/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4);
	__webpack_require__(264);
	module.exports = __webpack_require__(265);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	// 1. 管理布局
	// 2. 管理初始化
	// 3. 管理通信
	// 4. 管理切换
	__webpack_require__(5).polyfill();
	__webpack_require__(8);
	__webpack_require__(9);
	__webpack_require__(11);
	__webpack_require__(13);
	__webpack_require__(14);
	window._ = __webpack_require__(13);
	// var dd = require("./libs/sdk/ddsdk") // 为改钉钉上的问题
	var utils = __webpack_require__(16);
	var chat = __webpack_require__(135);
	var body_template = __webpack_require__(247);
	var main = __webpack_require__(248);
	var functionView = __webpack_require__(251);
	var commonConfig = __webpack_require__(177);
	var apiHelper = __webpack_require__(182);
	var _const = __webpack_require__(176);
	var profile = __webpack_require__(178);
	var handleConfig = commonConfig.handleConfig;
	var doWechatAuth = __webpack_require__(261);
	var getToHost = __webpack_require__(190);
	var eventListener = __webpack_require__(185);
	var fromUserClick = false;
	var Tab = __webpack_require__(262);
	var Apis = __webpack_require__(181);
	var loading = __webpack_require__(192);
	
	var ISIFRAME = false; // 网页插件为true
	var slideSwitch;
	var slideFoldedrState = true;
	var slideWidth;
	var slideSwitchAndMore;
	var iframeContent = [];
	var commonIssueEnable;
	var selfServiceEnable;
	var iframeEnable;
	var initIframeStateDate;
	var isChannelTag = false; //true表示关联设置
	var domData = {
		contact_agent: "Contact us",
		close: "Close",
		video_ended: "Video call ended",
		agent_is_typing: "Agent is typing...",
		current_queue_number: "Customers queuing: ",
		connecting: "Connecting...",
		video_connecting: "connecting",
		input_placeholder: "Type your message here",
		emoji: "Emoticon",
		picture: "Image",
		attachment: "File",
		ticket: "Note",
		video_invite: "Video call",
		evaluate_agent: "Satisfaction",
		transfer_to_kefu: "Agent",
		transfer_to_ticket: "Ticket",
		abandon_queue: "Abandon queue",
		press_save_img: "Press to save the picture",
		send_video: "SendVideo",
		out_of_line: "Exit the queue",
		exit_video: "Abandon the video call",
		unavailable: "The consultation channel is unavailable until the certification is passed.",
		risk_alert: "Risk reminder: This  is a test system, and no formal business has been opened yet. Please be cautious when dealing with payment and other transactions!",
		camera_permissions: "The program needs to access your gallery and use camera permissions. Do you want to allow it?",
		allow: "Allow",
		refuse: "Refuse",
		accept: "Accept",
		self_service: "Self service",
		min_window: "Minimize",
		close_sound: "Mute",
		screenShot: ""
	};
	
	screenShot();
	var selfServiceData; // 自助服务的数据
	var issueData; // 常见问题的数据
	var iframeData; // 新菜单页的数据
	
	var dingdingData;
	load_html();
	if (utils.isTop) {
		commonConfig.h5_mode_init();
		initCrossOriginIframe();
		widgetBoxShow();
	}
	else {
		main.chat_window_mode_init();
		getToHost.listen(function (msg) {
			var event = msg.event;
			var data = msg.data;
			switch (event) {
				// 用户点击联系客服时收到
				case _const.EVENTS.SHOW:
					fromUserClick = true;
					widgetBoxShow();
					break;
				case _const.EVENTS.CLOSE:
					widgetBoxHide();
					break;
				case _const.EVENTS.INIT_CONFIG:
					getToHost.to = data.parentId;
					commonConfig.setConfig(data);
					initCrossOriginIframe();
					ISIFRAME = true;
					break;
				default:
					break;
			}
		}, ["down2Im"]);
	}
	main.init(setUserInfo);
	
	// 监听点击咨询客服收到的通知
	eventListener.add(_const.SYSTEM_EVENT.CONSULT_AGENT, function () {
		$(".em-self-wrapper").addClass("hide");
		main.initChat();
		if (utils.isMobile) {
			$(".expand").addClass("hide");
			$(".em-service-title").addClass("hide");
	
		}
	});
	
	function widgetBoxShow() {
		if (utils.isMobile) {
			loading.show("mobile-uni");
		}
		utils.removeClass(document.querySelector(".em-widget-box"), "hide");
		if (!$("body").hasClass("window-demo")) {
			if (utils.isMobile) {
				$(".expand").addClass("hide");
				setTimeout(function () {
					loading.hide("mobile-uni");
				}, 1000);
			}
			return false;
		}
		if (!slideSwitch) {
			$(".em-self-wrapper").addClass("hide");
			if (!$("body").hasClass("window-demo") && !utils.isMobile) {
				$(".em-widget-box").css("width", "735px");
			}
			main.initChat();
			eventListener.trigger("swiper.update");
		}
	
		if (utils.isMobile && !slideSwitch) {
			$(".em-self-wrapper").addClass("hide");
			main.initChat();
			setTimeout(function () {
				loading.hide("mobile-uni");
			}, 1000);
			return false;
		}
		if ((selfServiceData.length == 0 || !selfServiceEnable) && (issueData.length == 0 || !commonIssueEnable) && (iframeContent.length == 0 || !iframeEnable)) {
			if (utils.isMobile && slideSwitch) {
				$(".em-self-wrapper").addClass("hide");
				main.initChat();
				$(".expand").addClass("hide");
				setTimeout(function () {
					loading.hide("mobile-uni");
				}, 1000);
				return false;
			}
			$(".em-self-wrapper").addClass("hide");
			$(".expand").addClass("hide");
			setTimeout(function () {
				// var chatWidth = $(".em-widget-content-box").width() - slideWidth;
				var closeWidth = 0;
				var closeChat = $(".em-widget-content-box").width() - closeWidth;
				$("#em-kefu-webim-self").css("width", closeWidth + "px");
				$("#em-kefu-webim-chat").css("width", closeChat + "px");
				$("#em-kefu-webim-self").css("display", "block");
				eventListener.trigger("swiper.update");
			}, 50);
		}
		else if (slideSwitch && !utils.isMobile) {
			if (!slideSwitchAndMore) {
				return false;
			}
			// 获取坐席端设置的宽度并设置，js集成网页的时候
			apiHelper.getSidebarWidth().then(function (res) {
				var sideWidth;
				if (!res.entity) {
					sideWidth = 360;
				}
				else {
					sideWidth = res.entity.value;
				}
				var chatWidth = $(".em-widget-content-box").width() - Number(sideWidth) - 20;
				$("#em-kefu-webim-chat").css("width", chatWidth + "px");
				$("#em-kefu-webim-self").css("width", sideWidth + "px");
				setTimeout(function () {
					$("#em-kefu-webim-self").css("display", "block");
				}, 500);
				eventListener.trigger("swiper.update");
			});
		}
	
		// 点击接受邀请的时候也需要滚动
		var listEle = $(".em-widget-left");
		var scroBox = $(".chat-wrapper")[0];
		var top = scroBox.scrollTop;
		var divEl = $(listEle[listEle.length - 1]).find(".em-widget-msg-wrapper");
		var elHeight = $(divEl).outerHeight() - 330;
		if ($(divEl).hasClass("msgtype-skillgroupMenu") || $(divEl).hasClass("msgtype-robotList")) {
			$(scroBox).scrollTop(top - elHeight);
		}
	
	}
	function widgetBoxHide() {
		utils.addClass(document.querySelector(".em-widget-box"), "hide");
	}
	function setUserInfo(targetUserInfo) {
		if (targetUserInfo) {
			// 游客
			if (targetUserInfo.userName) {
				return Promise.resolve("user");
			}
			// 访客带 token，sina patch
			else if (commonConfig.getConfig().user.token) {
				return Promise.resolve("userWithToken");
			}
			return new Promise(function (resolve) {
				apiHelper.getPassword().then(function (res) {
					commonConfig.setConfig({
						user: _.extend({}, commonConfig.getConfig().user, {
							password: res.password
						}),
						userNicknameFlg: res.nicename
					});
					resolve("userWithPassword");
				}, function (err) {
					console.error("username is not exist.");
					throw err;
				});
			});
		}
		else if (
			commonConfig.getConfig().user.username
			&& (
				commonConfig.getConfig().user.password
				|| commonConfig.getConfig().user.token
			)
		) {
			if (commonConfig.getConfig().user.token) {
				return Promise.resolve("userWithNameAndToken");
			}
			return Promise.resolve("userWidthNameAndPassword");
		}
		// 检测微信网页授权
		else if (commonConfig.getConfig().wechatAuth) {
			return new Promise(function (resolve) {
				doWechatAuth(function (entity) {
					commonConfig.setConfig({
						user: _.extend({}, commonConfig.getConfig().user, {
							username: entity.userId,
							password: entity.userPassword
						})
					});
					resolve("wechatAuth");
				}, function () {
					createVisitor().then(function () {
						resolve("noWechatAuth");
					});
				});
			});
		}
		else if (commonConfig.getConfig().user.username) {
			return new Promise(function (resolve) {
				apiHelper.getPassword().then(function (res) {
					commonConfig.setConfig({
						user: _.extend({}, commonConfig.getConfig().user, {
							password: res.password
						}),
						userNicknameFlg: res.nicename
					});
					resolve("widthPassword");
				}, function () {
					if (profile.grayList.autoCreateAppointedVisitor) {
						createVisitor(commonConfig.getConfig().user.username).then(function () {
							resolve("autoCreateAppointedVisitor");
						});
					}
					else {
						createVisitor().then(function () {
							resolve("noAutoCreateAppointedVisitor");
						});
					}
				});
			});
		}
		// if(true){
		var params = parseUrlSearch(window.location.href);
		if(params.originType && (params.originType == 'dingtalk')){
			return new Promise(function (resolve) {
				// 动态加载dd st
				var script = document.createElement("script");
				script.onload = function () {
					if (dd.env.platform!=="notInDingTalk") {
						dd.ready(function() {
							// dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
							var apiHelper = __webpack_require__(182);
							dd.runtime.permission.requestAuthCode({
								corpId: params.corpId,
								// corpId: "ding0eb82ac70e6295d0",
								onSuccess: function(result) {
									console.log("onSuccess",result)
								/*{
									code: 'hYLK98jkf0m' //string authCode
								}*/
									apiHelper.getDingdingVisitor({code: result.code, tenantId: commonConfig.getConfig().tenantId}).then(function(res){
										var visitor = commonConfig.getConfig().visitor;
										visitor.userNickname = res.userNickname;
										visitor.phone = res.phone;
										visitor.companyName = res.companyName;
										visitor.email = res.email;
										createVisitor(res.username).then(function () {
											resolve("")
										});
										commonConfig.setConfig({visitor: visitor})
									})
								},
								onFail : function(err) {
									console.log("onFail",err)
									createVisitor().then(function () {
										resolve("")
									});
								}
							});
						});
					} else {
						createVisitor().then(function () {
							resolve("")
						});
					}
					// 动态加载dd end
				};
				script.src = "./static/js/lib/ddsdk.min.js";
				document.getElementsByTagName("head")[0].appendChild(script);
			});
		} else {
			return createVisitor().then(function () {
				return Promise.resolve();
			});
		}
	}
	function createVisitor(username) {
		return apiHelper.createVisitor(username).then(function (entity) {
			commonConfig.setConfig({
				user: _.extend({}, commonConfig.getConfig().user, {
					username: entity.userId,
					password: entity.userPassword,
					userNickname: entity.nicename
				}),
				userNicknameFlg: entity.nicename
			});
			return Promise.resolve();
		});
	}
	
	function initConfig() {
		apiHelper.getConfig(commonConfig.getConfig().configId)
		.then(function (entity) {
			entity.configJson.tenantId = entity.tenantId;
			entity.configJson.configName = entity.configName;
			handleConfig(entity.configJson);
			handleSettingIframeSize();
			initRelevanceList(entity.tenantId);
			initInvite({ themeName: entity.configJson.ui.themeName });
			if (!ISIFRAME) {
				apiHelper.getQualificationStatus(entity.tenantId).then(function (res) {
					if (res) {
						widgetBoxHide();
						var str = "The consultation channel is unavailable until the certification is passed.";
						document.querySelector(".auth-box-PC >div span").innerHTML = str;
						utils.removeClass(document.querySelector(".auth-box-PC"), "hide");
					}
				});
			}
		});
	}
	
	function initInvite(opt) {
		apiHelper.getInviteInfo(commonConfig.getConfig().tenantId, commonConfig.getConfig().configId)
			.then(function (res) {
				if (res.status) {
					res.themeName = opt.themeName;
					getToHost.send({
						event: _const.EVENTS.INVITATION_INIT,
						data: res
					});
				}
			});
	}
	
	function initRelevanceList(tenantId) {
		apiHelper.getConfigOption(commonConfig.getConfig().configId)
			.then(function (value) {
				commonConfig.setConfig({
					configOption: _.extend({}, commonConfig.getConfig().configOption, value)
				});
				// 获取关联信息（targetChannel）
				var relevanceList;
				var tId = tenantId || utils.query("tenantId");
				if (!ISIFRAME) {
					apiHelper.getQualificationStatus(tId).then(function (res) {
						if (res) {
							widgetBoxHide();
							var str = "";
							if (res === 1) {
								str = "未进行认证，";
							}
							else if (res === 2) {
								str = "认证未通过，";
							}
							else if (res === 3) {
								str = "认证审核中，";
							}
							if (utils.isMobile) {
								document.querySelector(".auth-box-H5 >div span.is-auth").innerHTML = str;
								utils.removeClass(document.querySelector(".auth-box-H5"), "hide");
							}
							else {
								str += "认证未通过前，咨询通道暂不可用";
								document.querySelector(".auth-box-PC >div span").innerHTML = str;
								utils.removeClass(document.querySelector(".auth-box-PC"), "hide");
							}
						}
						getRelevanceList();
					});
				}
				else {
					getRelevanceList();
				}
	
	
				function getRelevanceList() {
					// TODO 接口替换为 配置文件
					if (commonConfig.getConfig().configOption && commonConfig.getConfig().configOption.option) {
						var slideOption = commonConfig.getConfig().configOption.option;
						// for(var i=0;i<slideOption.length;i++){
						// 	if(slideOption[i]  && slideOption[i].name === "sidebar-width"){
						// 		slideWidth = slideOption[i].value ? slideOption[i].value : 360;
						// 	}
						// 	else{
						// 		slideWidth = 360;
						// 	}
						// 	if( slideOption[i]  && slideOption[i].name === "sidebar"){
						// 		slideSwitch = slideOption[i].value ? slideOption[i].value : false;
						// 	}
						// 	else{
						// 		slideSwitch = false;
						// 	}
						// }
						for (var i = 0; i < slideOption.length; i++) {
							if (slideOption[i] && slideOption[i].name === "sidebar-width") {
								slideWidth = slideOption[i].value ? slideOption[i].value : 360;
							}
							else if (slideOption[i] && slideOption[i].name === "sidebar") {
								slideSwitch = slideOption[i].value ? slideOption[i].value : false;
							}
						}
						selfServiceData = commonConfig.getConfig().configOption["self-service"].content;
						issueData = commonConfig.getConfig().configOption.issue.content;
						iframeData = commonConfig.getConfig().configOption["webim-menu"].content;
						// slideWidth = commonConfig.getConfig().configOption.option.filter(item => item.name==="sidebar-width" );
						// slideSwitch = commonConfig.getConfig().configOption.option.filter(item => item.name==="sidebar" );
						if (slideSwitch === "true") {
							slideSwitch = true;
						}
						else {
							slideSwitch = false;
						}
					}
					else {
						slideWidth = 360;
						slideSwitch = false;
					}
	
					if (commonConfig.getConfig().configOption["self-service"] && commonConfig.getConfig().configOption["self-service"].content) {
						selfServiceData = commonConfig.getConfig().configOption["self-service"].content;
					}
					else {
						selfServiceData = [];
					}
	
					if (commonConfig.getConfig().configOption.issue && commonConfig.getConfig().configOption.issue.content) {
						issueData = commonConfig.getConfig().configOption.issue.content;
					}
					else {
						issueData = [];
					}
	
					if (commonConfig.getConfig().configOption["webim-menu"] && commonConfig.getConfig().configOption["webim-menu"].content) {
						iframeData = commonConfig.getConfig().configOption["webim-menu"].content;
					}
					else {
						iframeData = [];
					}
					apiHelper.getRelevanceList()
						.then(function (_relevanceList) {
							relevanceList = _relevanceList;
							return initFunctionStatus();
						}, function (err) {
							main.initRelevanceError(err);
						})
						.then(function (results) {
							handleCfgData(relevanceList, results);
						}, function () {
							handleCfgData(relevanceList || [], []);
						});
				}
			});
	}
	
	
	
	
	
	function initFunctionStatus() {
		if (commonConfig.getConfig().configId) {
			return arguments.callee.cache = arguments.callee.cache || Promise.all([
				apiHelper.getFaqOrSelfServiceStatus("issue"),
				apiHelper.getFaqOrSelfServiceStatus("self-service"),
				apiHelper.getIframeEnable(),
				apiHelper.getIframeSetting(),
			]);
		}
		return Promise.resolve([]);
	}
	
	function parseUrlSearch(url) {
		var result = {};
		var kv = url ? (url.split("?")[1] || "") : window.location.search;
		kv = $.trim(kv.replace("?", ""));
		if (kv) {
			kv = kv.split("&");
			var tmp;
			for (var i = 0; i < kv.length; i++) {
				tmp = kv[i].split("=");
				result[tmp[0]] = (tmp[1] ? decodeURIComponent(tmp[1]) : null);
			}
		}
		return result;
	}
	
	// todo: rename this function
	function handleCfgData(relevanceList, status) {
		var defaultStaticPath =  false ? "static" : "../static";
		// default value
	
		var targetItem;
		var appKey = commonConfig.getConfig().appKey;
		var splited = appKey.split("#");
		var orgName = splited[0];
		var appName = splited[1];
		var toUser = commonConfig.getConfig().toUser || commonConfig.getConfig().to;
	
		// toUser 转为字符串， todo: move it to handle config
		typeof toUser === "number" && (toUser = toUser.toString());
	
		if (appKey && toUser) {
			// appKey，imServiceNumber 都指定了
			targetItem = _.where(relevanceList, {
				orgName: orgName,
				appName: appName,
				imServiceNumber: toUser
			})[0];
		}
	
		// 未指定appKey, toUser时，或未找到符合条件的关联时，默认使用关联列表中的第一项
		if (!targetItem) {
			targetItem = targetItem || relevanceList[0];
			// 防止关联列表是空的情况js报错（海外环境）
			if (!targetItem) {
				targetItem = {
					imServiceNumber: ""
				};
			}
			console.log("mismatched channel, use default.");
		}else{
			isChannelTag = true
		}
		var params = parseUrlSearch(window.location.href);
		var initlanguage =  false ? "zh" : "en";
		commonConfig.setConfig({
			logo: commonConfig.getConfig().logo || { enabled: !!targetItem.tenantLogo, url: targetItem.tenantLogo },
			toUser: targetItem.imServiceNumber,
			orgName: targetItem.orgName,
			appName: targetItem.appName,
			channelId: targetItem.channelId,
			appKey: targetItem.orgName + "#" + targetItem.appName,
			restServer: commonConfig.getConfig().restServer || targetItem.restDomain,
			xmppServer: commonConfig.getConfig().xmppServer || targetItem.xmppServer,
			staticPath: commonConfig.getConfig().staticPath || defaultStaticPath,
			offDutyWord: commonConfig.getConfig().offDutyWord || "We are currently offline.",
			emgroup: commonConfig.getConfig().emgroup || "",
			timeScheduleId: commonConfig.getConfig().timeScheduleId || 0,
	
			user: commonConfig.getConfig().user || {},
			visitor: commonConfig.getConfig().visitor || {},
			routingRuleFlag: commonConfig.getConfig().routingRuleFlag || params.routingRuleFlag || "",
			initLanguage: commonConfig.getConfig().initLanguage || initlanguage,
			channel: commonConfig.getConfig().channel || {},
			ui: commonConfig.getConfig().ui || {
				H5Title: {}
			},
			toolbar: commonConfig.getConfig().toolbar || {
				sendAttachment: true,
				sendSmallVideo: !commonConfig.getConfig().configId,
			},
			chat: commonConfig.getConfig().chat || {},
			options: commonConfig.getConfig().options || {
				onlyCloseWindow: "true", // 访客离开下面的开关，默认不会传该值，默认为true 这样不影响之前的逻辑
				onlyCloseSession: "true", // 访客离开下面的开关，默认不会传该值，默认为true 这样不影响之前的逻辑
				showEnquiryButtonInAllTime: "false", // 是否在所有时间段显示主动评价按钮,默认不会传该值，默认值为"false"，即只在坐席接待时显示主动评价按钮
				closeSessionWhenCloseWindow: "false" // 是否在关闭聊窗的时候关闭会话，默认不会传该值，默认值为"false"
			},
			originType: params.originType || "",
			isChannelTag:isChannelTag
		});
	
		// fake patch: 老版本配置的字符串需要decode
		if (commonConfig.getConfig().offDutyWord) {
			try {
				commonConfig.setConfig({
					offDutyWord: decodeURIComponent(commonConfig.getConfig().offDutyWord)
				});
			}
			catch (e) { }
		}
	
		if (commonConfig.getConfig().emgroup) {
			try {
				commonConfig.setConfig({
					emgroup: decodeURIComponent(commonConfig.getConfig().emgroup)
				});
			}
			catch (e) { }
		}
	
		// 获取企业头像和名称
		// todo: rename to tenantName
		profile.tenantAvatar = utils.getAvatarsFullPath(targetItem.tenantAvatar, commonConfig.getConfig().domain);
		profile.defaultAgentName = targetItem.tenantName;
		profile.defaultAvatar = commonConfig.getConfig().staticPath + "/img/default_avatar.png";
	
		renderUI(status);
	}
	function renderUI(resultStatus) {
		// 添加移动端样式类
		if (utils.isMobile) {
			utils.addClass(document.body, "em-mobile");
		}
		else if (!utils.isTop) {
			utils.addClass(document.body, "window-demo");
		}
		else {
			utils.addClass(document.body, "window-pc");
		}
	
	
		// 用于预览模式
		if (commonConfig.getConfig().previewObj) {
			handleSettingIframeSize();
			allDisable();	// 相当于全关
		}
		// configId
		else if (commonConfig.getConfig().configId) {
			var slideState = commonConfig.getConfig().options.sidebar;
			commonIssueEnable = resultStatus[0];
			selfServiceEnable = resultStatus[1];
			iframeEnable = resultStatus[2];
			iframeContent = resultStatus[3];
			var serviceTitle = $(".em-service-title"); // issue self-servire
			selfServiceData = commonConfig.getConfig().configOption["self-service"].content;
			issueData = commonConfig.getConfig().configOption.issue.content;
			if (slideState == "true" && ((selfServiceData.length !== 0 && selfServiceEnable) || (issueData.length !== 0 && commonIssueEnable))) {
				serviceTitle.removeClass("hide");
			}
			else {
				serviceTitle.addClass("hide");
			}
	
			if ((commonIssueEnable || selfServiceEnable || iframeEnable) && slideState == "true") {
				slideSwitchAndMore = true;
			}
			// pc 端判断三个开关
			if (!utils.isMobile) {
				// 任意一个打开
				if ((commonIssueEnable || selfServiceEnable || iframeEnable) && slideState == "true") {
					utils.addClass(document.body, "big-window");
					// iframe 没有 url 时，初始化 tab 条件满足，但是没有内容！
					if (!pcAnyEnable()) {
						utils.removeClass(document.body, "big-window");
					}
					// 初始化成功 - 1 - im.html
					else if (utils.isTop) {
						utils.addClass(document.body, "big-window-h5");
					}
					// 初始化成功 - 2 - demo.html
					else {
						handleSettingIframeSize({
							// iframe 常见问题和自主服务，固定宽度 360px
							width: (Math.floor(commonConfig.getConfig().dialogWidth.slice(0, -2)) + Math.floor(360)) + "px"
						});
					}
				}
				// 全关
				else {
					utils.removeClass(document.body, "big-window");
					allDisable();
				}
			}
			// 移动端不判断 iframe 开关
			else {
				// 全关
				if (!commonIssueEnable && !selfServiceEnable) {
					allDisable();
				}
				// 任意一个打开（包括 iframeEnable）
				else {
					mobileAnyEnable();
				}
				// initSidePage
				var domTab = document.querySelector(".em-self-wrapper");
				setTimeout(function () {
					$(domTab).css("display", "block");
				}, 500);
			}
		}
		// tenantId
		else {
			allDisable();	// 相当于全关
			if (!fromUserClick) {
				main.close();
			}
		}
	
		apiHelper.getTheme().then(function (themeName) {
			var color;
			var className;
			if (themeName && themeName.indexOf("theme_custom") > -1) {
				var arr = themeName.split("theme_custom");
				color = arr[1];
				className = "theme_custom";
			}
			else {
				className = _const.themeMap[themeName];
			}
			className = className || "theme-1";
			className && utils.addClass(document.body, className);
	
			// 自定义主题色
			if (themeName && themeName.indexOf("theme_custom") > -1) {
				var fgColor = $(".theme_custom .fg-hover-color").css("color");
				$(".theme_custom .fg-color").css("cssText", "color: " + color + " !important");
				$(".theme_custom .selected .border-color").css("cssText", "border-color: " + color + " !important ; color: " + color + " !important");
				$(".theme_custom .bg-color").css("cssText", "background-color: " + color + " !important");
				$(".theme_custom .ui-cmp-tab .selected").css("cssText", "border-color: " + color + " !important ; color: " + color + " !important");
				if (!utils.isMobile) {
					$(".theme_custom .fg-hover-color").hover(function () {
						$(this).css("cssText", "color: " + color + " !important");
					}, function () {
						$(this).css("cssText", "color: " + fgColor + " !important");
					});
				}
			}
	
		});
	
		function allDisable() {
			// console.log("全关");
			$(".em-self-wrapper").addClass("hide");
			if (!$("body").hasClass("window-demo") && !utils.isMobile) {
				$(".em-widget-box").css("width", "735px");
			}
			main.initChat();
		}
		function mobileAnyEnable() {
			// console.log("移动任一");
			main.close();
			return initSidePage(resultStatus);
		}
		function pcAnyEnable() {
			// console.log("电脑任一");
			main.initChat();
			return initSidePage(resultStatus);
		}
		function initSidePage(resultStatus) {
			if (!slideSwitch) {
				return false;
			}
			// apiHelper.getSidebarWidth().then(function(res){
			// 	if(!res.entity){
			// 		slideWidth = 360;
			// 	}
			// 	else{
			// 		slideWidth = res.entity.value;
			// 	}
			// })
			var commonIssueEnable = resultStatus[0];
			var selfServiceEnable = resultStatus[1];
			var iframeEnable = resultStatus[2];
			var iframeSettings = resultStatus[3][0];	// 只取第一个
			if ((selfServiceData.length == 0 || !selfServiceEnable) && (issueData.length == 0 || !commonIssueEnable) && (iframeContent.length == 0 || !iframeEnable)) {
				return false;
			}
			var side_page = functionView.init({
				resultStatus: resultStatus
			});
			var tab = new Tab();
			if (commonIssueEnable || selfServiceEnable) {
				var faqInsArr = [];
				if (selfServiceEnable) {
					faqInsArr.push(side_page.ss);
					faqTxt = "Self service";
				}
				if (commonIssueEnable) {
					faqInsArr.push(side_page.faq);
					faqTxt = "FAQs";
				}
				if (selfServiceEnable && commonIssueEnable) {
					faqTxt = "Self service";
				}
				if (utils.isMobile) {
					faqInsArr.push(side_page.contact);
				}
				tab.addTab({
					sign: "faq",
					text: faqTxt,
					ins: faqInsArr,
				});
	
				if (commonIssueEnable && !selfServiceEnable) {
					tab.$el.find(".faq-list > p").hide();
				}
			}
			// iframe 开关开启并且信息完备时
			if (!utils.isMobile && iframeEnable && iframeSettings && iframeSettings.url) {
				for (var i = 0; i < resultStatus[3].length; i++) {
					tab.addTab({
						sign: "iframe" + i,
						text: resultStatus[3][i].name,
						ins: [side_page.iframeList[i]],
					});
				}
			}
			// 监听tab点击，在点击的时候发送postMessage，传递参数给iframe
			eventListener.add("ui.tab.click", function (e, sing) {
				if (sing && sing != "faq") {
					var iframeParent = $("div[sign='" + sing + "']")[0];
					setTimeout(function () {
						var msg = commonConfig.getConfig().visitorInfo;
						if (msg) {
							var obj = {
								phone: msg.phone,
								userId: msg.userId,
								username: msg.username
							};
						}
						if (iframeParent) {
							$(iframeParent).find("iframe")[0].contentWindow.postMessage(obj, "*");
						}
					}, 1000);
				}
			});
			// 第一个tab在页面渲染完成时候再触发事件
			if (tab.tabs != 0 && tab.tabs[0].sign != "faq") {
				setTimeout(function () {
					var iframeParent = $("div[sign='" + tab.tabs[0].sign + "']")[0];
					var msg = commonConfig.getConfig().visitorInfo;
					if (msg) {
						var obj = {
							phone: msg.phone,
							userId: msg.userId,
							username: msg.username
						};
					}
					$(iframeParent).find("iframe")[0].contentWindow.postMessage(obj, "*");
				}, 5000);
			}
			// 优先第一个
			if (tab.selectFirstTab()) {
				$("#em-kefu-webim-self").append(tab.$el);
				return true;
			}
			return false;
		}
		if (utils.isMobile && !slideSwitch) {
			$(".em-self-wrapper").addClass("hide");
			main.initChat();
			return false;
		}
		if ((selfServiceData.length == 0 || !selfServiceEnable) && (issueData.length == 0 || !commonIssueEnable) && (iframeContent.length == 0 || !iframeEnable)) {
			if (utils.isMobile && slideSwitch) {
				$(".em-self-wrapper").addClass("hide");
				main.initChat();
				$(".expand").addClass("hide");
				return false;
			}
			$(".em-self-wrapper").addClass("hide");
			$(".expand").addClass("hide");
			var chatWidth = $(".em-widget-content-box").width() - slideWidth;
			var closeWidth = 0;
			var closeChat = $(".em-widget-content-box").width() - closeWidth;
			$("#em-kefu-webim-self").css("width", closeWidth + "px");
			$("#em-kefu-webim-chat").css("width", closeChat + "px");
			setTimeout(function () {
				$("#em-kefu-webim-self").css("display", "block");
			}, 500);
			eventListener.trigger("swiper.update");
		}
		else if (slideSwitch && !utils.isMobile) {
			if (!slideSwitchAndMore) {
				return false;
			}
			// 获取坐席端设置的宽度并设置，js集成网页的时候
			apiHelper.getSidebarWidth().then(function (res) {
				var sideWidth;
				if (!res.entity) {
					sideWidth = 360;
				}
				else {
					sideWidth = res.entity.value;
				}
				var chatWidth = $(".em-widget-content-box").width() - Number(sideWidth) - 20;
				$("#em-kefu-webim-chat").css("width", chatWidth + "px");
				$("#em-kefu-webim-self").css("width", sideWidth + "px");
				setTimeout(function () {
					$("#em-kefu-webim-self").css("display", "block");
				}, 500);
				eventListener.trigger("swiper.update");
			});
		}
		// 监听页面状态
		listenPageState();
	}
	
	
	function handleSettingIframeSize(params) {
		// 把 iframe 里收到 _const.EVENTS.RESET_IFRAME 事件时设置 config 参数移到这里了
		if (params) {
			commonConfig.setConfig(params);
		}
		params = params || {};
		// 重新去设置iframe 的宽高
		getToHost.send({
			event: _const.EVENTS.RESET_IFRAME,
			data: {
				dialogHeight: commonConfig.getConfig().dialogHeight,
				dialogWidth: params.width || commonConfig.getConfig().dialogWidth,
				dialogPosition: commonConfig.getConfig().dialogPosition
			}
		});
	}
	
	function initCrossOriginIframe() {
		var iframe = document.getElementById("cross-origin-iframe");
		iframe.src = commonConfig.getConfig().domain + "/webim/transfer.html?v=tencent.0.2.213";
		utils.on(iframe, "load", function () {
			apiHelper.initApiTransfer();
	    var config = commonConfig.getConfig()
	    if(config.customer === "ysp") {
	      apiHelper.getYspVisitorInfo(config.key, config.visitor.visitorExt)
	      .then(function (data) {
	        var yspInfo = data.entity
	        var visitor = config.visitor
	        visitor.trueName = yspInfo.userName
	        visitor.phone = yspInfo.bindPhoneNumber
	        visitor.userNickname = yspInfo.loginName
	        visitor.userDefineColumn = JSON.stringify(yspInfo)
	        commonConfig.setConfig({ visitor: visitor })
	
	        // 有 configId 需要先去获取 config 信息
			    commonConfig.getConfig().configId ? initConfig() : initRelevanceList();
	      })
	    } else {
	      // 有 configId 需要先去获取 config 信息
	      commonConfig.getConfig().configId ? initConfig() : initRelevanceList();
	    }
		});
	}
	function screenShot() {
		var system = !!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
		if (system) $(".screenshot").addClass("hide");
		var agent = navigator.userAgent.toLowerCase();
		var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
		if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) tips = domData.screenShot = "Screenshot win + shift + s";
		if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) tips = domData.screenShot = "Screenshot win + shift + s";
		if (isMac) domData.screenShot = "Screenshot command + shift + 5";
	}
	// 监听页面的状态
	function listenPageState() {
		var hiddenProperty = "hidden" in document ? "hidden" :
			"webkitHidden" in document ? "webkitHidden" :
				"mozHidden" in document ? "mozHidden" :
					null;
		var visibilityChangeEvent = hiddenProperty.replace(/hidden/i, "visibilitychange");
		var onVisibilityChange = function () {
			if (!document[hiddenProperty]) {
				commonConfig.setConfig({
					pageState: true
				});
				// 每次页面激活时候需要调用已读消息接口
				var SessionId = profile.currentOfficialAccount.sessionId;
				Apis.readMessageLastRead(SessionId);
			}
			else {
				// console.log('页面非激活')
				commonConfig.setConfig({
					pageState: false
				});
			}
		};
		document.addEventListener(visibilityChangeEvent, onVisibilityChange);
	}
	
	
	
	
	
	// body.html 显示词语
	function load_html() {
		utils.appendHTMLToBody(_.template(body_template)(domData));
	
		chat.getDom();
	}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   4.1.1
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	var _isArray = undefined;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = undefined;
	var customSchedulerFn = undefined;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var r = require;
	    var vertx = __webpack_require__(7);
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = undefined;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var _arguments = arguments;
	
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	  if (_state) {
	    (function () {
	      var callback = _arguments[_state - 1];
	      asap(function () {
	        return invokeCallback(_state, child, callback, parent._result);
	      });
	    })();
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(16);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var GET_THEN_ERROR = new ErrorObject();
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    GET_THEN_ERROR.error = error;
	    return GET_THEN_ERROR;
	  }
	}
	
	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then$$1) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$1 === GET_THEN_ERROR) {
	      reject(promise, GET_THEN_ERROR.error);
	      GET_THEN_ERROR.error = null;
	    } else if (then$$1 === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$1)) {
	      handleForeignThenable(promise, maybeThenable, then$$1);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function resolve(promise, value) {
	  if (promise === value) {
	    reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = undefined,
	      callback = undefined,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function ErrorObject() {
	  this.error = null;
	}
	
	var TRY_CATCH_ERROR = new ErrorObject();
	
	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = undefined,
	      error = undefined,
	      succeeded = undefined,
	      failed = undefined;
	
	  if (hasCallback) {
	    value = tryCatch(callback, detail);
	
	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value.error = null;
	    } else {
	      succeeded = true;
	    }
	
	    if (promise === value) {
	      reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	      resolve(promise, value);
	    } else if (failed) {
	      reject(promise, error);
	    } else if (settled === FULFILLED) {
	      fulfill(promise, value);
	    } else if (settled === REJECTED) {
	      reject(promise, value);
	    }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      resolve(promise, value);
	    }, function rejectPromise(reason) {
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function Enumerator$1(Constructor, input) {
	  this._instanceConstructor = Constructor;
	  this.promise = new Constructor(noop);
	
	  if (!this.promise[PROMISE_ID]) {
	    makePromise(this.promise);
	  }
	
	  if (isArray(input)) {
	    this.length = input.length;
	    this._remaining = input.length;
	
	    this._result = new Array(this.length);
	
	    if (this.length === 0) {
	      fulfill(this.promise, this._result);
	    } else {
	      this.length = this.length || 0;
	      this._enumerate(input);
	      if (this._remaining === 0) {
	        fulfill(this.promise, this._result);
	      }
	    }
	  } else {
	    reject(this.promise, validationError());
	  }
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	}
	
	Enumerator$1.prototype._enumerate = function (input) {
	  for (var i = 0; this._state === PENDING && i < input.length; i++) {
	    this._eachEntry(input[i], i);
	  }
	};
	
	Enumerator$1.prototype._eachEntry = function (entry, i) {
	  var c = this._instanceConstructor;
	  var resolve$$1 = c.resolve;
	
	  if (resolve$$1 === resolve$1) {
	    var _then = getThen(entry);
	
	    if (_then === then && entry._state !== PENDING) {
	      this._settledAt(entry._state, i, entry._result);
	    } else if (typeof _then !== 'function') {
	      this._remaining--;
	      this._result[i] = entry;
	    } else if (c === Promise$2) {
	      var promise = new c(noop);
	      handleMaybeThenable(promise, entry, _then);
	      this._willSettleAt(promise, i);
	    } else {
	      this._willSettleAt(new c(function (resolve$$1) {
	        return resolve$$1(entry);
	      }), i);
	    }
	  } else {
	    this._willSettleAt(resolve$$1(entry), i);
	  }
	};
	
	Enumerator$1.prototype._settledAt = function (state, i, value) {
	  var promise = this.promise;
	
	  if (promise._state === PENDING) {
	    this._remaining--;
	
	    if (state === REJECTED) {
	      reject(promise, value);
	    } else {
	      this._result[i] = value;
	    }
	  }
	
	  if (this._remaining === 0) {
	    fulfill(promise, this._result);
	  }
	};
	
	Enumerator$1.prototype._willSettleAt = function (promise, i) {
	  var enumerator = this;
	
	  subscribe(promise, undefined, function (value) {
	    return enumerator._settledAt(FULFILLED, i, value);
	  }, function (reason) {
	    return enumerator._settledAt(REJECTED, i, reason);
	  });
	};
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all$1(entries) {
	  return new Enumerator$1(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race$1(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {function} resolver
	  Useful for tooling.
	  @constructor
	*/
	function Promise$2(resolver) {
	  this[PROMISE_ID] = nextId();
	  this._result = this._state = undefined;
	  this._subscribers = [];
	
	  if (noop !== resolver) {
	    typeof resolver !== 'function' && needsResolver();
	    this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
	  }
	}
	
	Promise$2.all = all$1;
	Promise$2.race = race$1;
	Promise$2.resolve = resolve$1;
	Promise$2.reject = reject$1;
	Promise$2._setScheduler = setScheduler;
	Promise$2._setAsap = setAsap;
	Promise$2._asap = asap;
	
	Promise$2.prototype = {
	  constructor: Promise$2,
	
	  /**
	    The primary way of interacting with a promise is through its `then` method,
	    which registers callbacks to receive either a promise's eventual value or the
	    reason why the promise cannot be fulfilled.
	  
	    ```js
	    findUser().then(function(user){
	      // user is available
	    }, function(reason){
	      // user is unavailable, and you are given the reason why
	    });
	    ```
	  
	    Chaining
	    --------
	  
	    The return value of `then` is itself a promise.  This second, 'downstream'
	    promise is resolved with the return value of the first promise's fulfillment
	    or rejection handler, or rejected if the handler throws an exception.
	  
	    ```js
	    findUser().then(function (user) {
	      return user.name;
	    }, function (reason) {
	      return 'default name';
	    }).then(function (userName) {
	      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	      // will be `'default name'`
	    });
	  
	    findUser().then(function (user) {
	      throw new Error('Found user, but still unhappy');
	    }, function (reason) {
	      throw new Error('`findUser` rejected and we're unhappy');
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	    });
	    ```
	    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	  
	    ```js
	    findUser().then(function (user) {
	      throw new PedagogicalException('Upstream error');
	    }).then(function (value) {
	      // never reached
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // The `PedgagocialException` is propagated all the way down to here
	    });
	    ```
	  
	    Assimilation
	    ------------
	  
	    Sometimes the value you want to propagate to a downstream promise can only be
	    retrieved asynchronously. This can be achieved by returning a promise in the
	    fulfillment or rejection handler. The downstream promise will then be pending
	    until the returned promise is settled. This is called *assimilation*.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // The user's comments are now available
	    });
	    ```
	  
	    If the assimliated promise rejects, then the downstream promise will also reject.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // If `findCommentsByAuthor` fulfills, we'll have the value here
	    }, function (reason) {
	      // If `findCommentsByAuthor` rejects, we'll have the reason here
	    });
	    ```
	  
	    Simple Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let result;
	  
	    try {
	      result = findResult();
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	    findResult(function(result, err){
	      if (err) {
	        // failure
	      } else {
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findResult().then(function(result){
	      // success
	    }, function(reason){
	      // failure
	    });
	    ```
	  
	    Advanced Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let author, books;
	  
	    try {
	      author = findAuthor();
	      books  = findBooksByAuthor(author);
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	  
	    function foundBooks(books) {
	  
	    }
	  
	    function failure(reason) {
	  
	    }
	  
	    findAuthor(function(author, err){
	      if (err) {
	        failure(err);
	        // failure
	      } else {
	        try {
	          findBoooksByAuthor(author, function(books, err) {
	            if (err) {
	              failure(err);
	            } else {
	              try {
	                foundBooks(books);
	              } catch(reason) {
	                failure(reason);
	              }
	            }
	          });
	        } catch(error) {
	          failure(err);
	        }
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findAuthor().
	      then(findBooksByAuthor).
	      then(function(books){
	        // found books
	    }).catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method then
	    @param {Function} onFulfilled
	    @param {Function} onRejected
	    Useful for tooling.
	    @return {Promise}
	  */
	  then: then,
	
	  /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	  
	    ```js
	    function findAuthor(){
	      throw new Error('couldn't find that author');
	    }
	  
	    // synchronous
	    try {
	      findAuthor();
	    } catch(reason) {
	      // something went wrong
	    }
	  
	    // async with promises
	    findAuthor().catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method catch
	    @param {Function} onRejection
	    Useful for tooling.
	    @return {Promise}
	  */
	  'catch': function _catch(onRejection) {
	    return this.then(null, onRejection);
	  }
	};
	
	/*global self*/
	function polyfill$1() {
	    var local = undefined;
	
	    if (typeof global !== 'undefined') {
	        local = global;
	    } else if (typeof self !== 'undefined') {
	        local = self;
	    } else {
	        try {
	            local = Function('return this')();
	        } catch (e) {
	            throw new Error('polyfill failed because global object is unavailable in this environment');
	        }
	    }
	
	    var P = local.Promise;
	
	    if (P) {
	        var promiseToString = null;
	        try {
	            promiseToString = Object.prototype.toString.call(P.resolve());
	        } catch (e) {
	            // silently ignored
	        }
	
	        if (promiseToString === '[object Promise]' && !P.cast) {
	            return;
	        }
	    }
	
	    local.Promise = Promise$2;
	}
	
	// Strange compat..
	Promise$2.polyfill = polyfill$1;
	Promise$2.Promise = Promise$2;
	
	return Promise$2;
	
	})));
	
	//# sourceMappingURL=es6-promise.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), (function() { return this; }())))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL;
	
	/* jshint ignore:start */
	
	/** PrivateFunction: Array.prototype.indexOf
	 *  Return the index of an object in an array.
	 *
	 *  This function is not supplied by some JavaScript implementations, so
	 *  we provide it if it is missing.  This code is from:
	 *  http://developer.mozilla.org/En/Core_JavaScript_1.5_Reference:Objects:Array:indexOf
	 *
	 *  Parameters:
	 *	(Object) elt - The object to look for.
	 *	(Integer) from - The index from which to start looking. (optional).
	 *
	 *  Returns:
	 *	The index of elt in the array or -1 if not found.
	 */
	if(!Array.prototype.indexOf){
		Array.prototype.indexOf = function(elt /* , from*/){
			var len = this.length;
	
			var from = Number(arguments[1]) || 0;
			from = (from < 0) ? Math.ceil(from) : Math.floor(from);
			if(from < 0){
				from += len;
			}
	
			for(; from < len; from++){
				if(from in this && this[from] === elt){
					return from;
				}
			}
	
			return -1;
		};
	}
	
	/* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim */
	if(!String.prototype.trim){
		String.prototype.trim = function(){
			return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
		};
	}
	
	// Production steps of ECMA-262, Edition 5, 15.4.4.18
	// Reference: http://es5.github.io/#x15.4.4.18
	if(!Array.prototype.forEach){
	
		Array.prototype.forEach = function(callback, thisArg){
	
			var T, k;
	
			if(this === null){
				throw new TypeError("this is null or not defined");
			}
	
			// 1. Let O be the result of calling toObject() passing the
			// |this| value as the argument.
			var O = Object(this);
	
			// 2. Let lenValue be the result of calling the Get() internal
			// method of O with the argument "length".
			// 3. Let len be toUint32(lenValue).
			var len = O.length >>> 0;
	
			// 4. If isCallable(callback) is false, throw a TypeError exception.
			// See: http://es5.github.com/#x9.11
			if(typeof callback !== "function"){
				throw new TypeError(callback + " is not a function");
			}
	
			// 5. If thisArg was supplied, let T be thisArg; else let
			// T be undefined.
			if(arguments.length > 1){
				T = thisArg;
			}
	
			// 6. Let k be 0
			k = 0;
	
			// 7. Repeat, while k < len
			while(k < len){
	
				var kValue;
	
				// a. Let Pk be ToString(k).
				//    This is implicit for LHS operands of the in operator
				// b. Let kPresent be the result of calling the HasProperty
				//    internal method of O with argument Pk.
				//    This step can be combined with c
				// c. If kPresent is true, then
				if(k in O){
	
					// i. Let kValue be the result of calling the Get internal
					// method of O with argument Pk.
					kValue = O[k];
	
					// ii. Call the Call internal method of callback with T as
					// the this value and argument list containing kValue, k, and O.
					callback.call(T, kValue, k, O);
				}
				// d. Increase k by 1.
				k++;
			}
			// 8. return undefined
		};
	}
	
	// reverted for backwards compatibility with ie8
	// Console-polyfill. MIT license.
	// https://github.com/paulmillr/console-polyfill
	// Make it safe to do console.log() always.
	(function(global){
	
		if(!global.console){
			global.console = {};
		}
		var con = global.console;
		var prop, method;
		var dummy = function(){};
		var properties = ["memory"];
		var methods = ("assert,clear,count,debug,dir,dirxml,error,exception,group," +
			"groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd," +
			"show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn").split(",");
		while(prop = properties.pop())if(!con[prop]) con[prop] = {};
		while(method = methods.pop())if(!con[method]) con[method] = dummy;
		// Using `this` for web workers & supports Browserify / Webpack.
	})(typeof window === "undefined" ? this : window);
	
	/* jshint ignore:end */


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Modernizr"] = __webpack_require__(10);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/*!
	 * modernizr v3.3.1
	 * Build https://modernizr.com/download?-inlinesvg-oninput-peerconnection-dontmin
	 *
	 * Copyright (c)
	 *  Faruk Ates
	 *  Paul Irish
	 *  Alex Sexton
	 *  Ryan Seddon
	 *  Patrick Kettner
	 *  Stu Cox
	 *  Richard Herrera
	
	 * MIT License
	 */
	
	/*
	 * Modernizr tests which native CSS3 and HTML5 features are available in the
	 * current UA and makes the results available to you in two ways: as properties on
	 * a global `Modernizr` object, and as classes on the `<html>` element. This
	 * information allows you to progressively enhance your pages with a granular level
	 * of control over the experience.
	*/
	
	// ;(function(window, document, undefined){
	  /**
	   * docElement is a convenience wrapper to grab the root element of the document
	   *
	   * @access private
	   * @returns {HTMLElement|SVGElement} The root element of the document
	   */
	
	  var docElement = document.documentElement;
	
	
	  var tests = [];
	
	
	  /**
	   *
	   * ModernizrProto is the constructor for Modernizr
	   *
	   * @class
	   * @access public
	   */
	
	  var ModernizrProto = {
	    // The current version, dummy
	    _version: '3.3.1',
	
	    // Any settings that don't work as separate modules
	    // can go in here as configuration.
	    _config: {
	      'classPrefix': '',
	      'enableClasses': true,
	      'enableJSClass': true,
	      'usePrefixes': true
	    },
	
	    // Queue of tests
	    _q: [],
	
	    // Stub these for people who are listening
	    on: function(test, cb) {
	      // I don't really think people should do this, but we can
	      // safe guard it a bit.
	      // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
	      // This is in case people listen to synchronous tests. I would leave it out,
	      // but the code to *disallow* sync tests in the real version of this
	      // function is actually larger than this.
	      var self = this;
	      setTimeout(function() {
	        cb(self[test]);
	      }, 0);
	    },
	
	    addTest: function(name, fn, options) {
	      tests.push({name: name, fn: fn, options: options});
	    },
	
	    addAsyncTest: function(fn) {
	      tests.push({name: null, fn: fn});
	    }
	  };
	
	
	
	  // Fake some of Object.create so we can force non test results to be non "own" properties.
	  var Modernizr = function() {};
	  Modernizr.prototype = ModernizrProto;
	
	  // Leak modernizr globally when you `require` it rather than force it here.
	  // Overwrite name so constructor name is nicer :D
	  Modernizr = new Modernizr();
	
	
	
	  var classes = [];
	
	
	  /**
	   * is returns a boolean if the typeof an obj is exactly type.
	   *
	   * @access private
	   * @function is
	   * @param {*} obj - A thing we want to check the type of
	   * @param {string} type - A string to compare the typeof against
	   * @returns {boolean}
	   */
	
	  function is(obj, type) {
	    return typeof obj === type;
	  }
	  ;
	
	  /**
	   * Run through all tests and detect their support in the current UA.
	   *
	   * @access private
	   */
	
	  function testRunner() {
	    var featureNames;
	    var feature;
	    var aliasIdx;
	    var result;
	    var nameIdx;
	    var featureName;
	    var featureNameSplit;
	
	    for (var featureIdx in tests) {
	      if (tests.hasOwnProperty(featureIdx)) {
	        featureNames = [];
	        feature = tests[featureIdx];
	        // run the test, throw the return value into the Modernizr,
	        // then based on that boolean, define an appropriate className
	        // and push it into an array of classes we'll join later.
	        //
	        // If there is no name, it's an 'async' test that is run,
	        // but not directly added to the object. That should
	        // be done with a post-run addTest call.
	        if (feature.name) {
	          featureNames.push(feature.name.toLowerCase());
	
	          if (feature.options && feature.options.aliases && feature.options.aliases.length) {
	            // Add all the aliases into the names list
	            for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
	              featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
	            }
	          }
	        }
	
	        // Run the test, or use the raw value if it's not a function
	        result = is(feature.fn, 'function') ? feature.fn() : feature.fn;
	
	
	        // Set each of the names on the Modernizr object
	        for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
	          featureName = featureNames[nameIdx];
	          // Support dot properties as sub tests. We don't do checking to make sure
	          // that the implied parent tests have been added. You must call them in
	          // order (either in the test, or make the parent test a dependency).
	          //
	          // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
	          // hashtag famous last words
	          featureNameSplit = featureName.split('.');
	
	          if (featureNameSplit.length === 1) {
	            Modernizr[featureNameSplit[0]] = result;
	          } else {
	            // cast to a Boolean, if not one already
	            /* jshint -W053 */
	            if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
	              Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
	            }
	
	            Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
	          }
	
	          classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
	        }
	      }
	    }
	  }
	  ;
	
	  /**
	   * A convenience helper to check if the document we are running in is an SVG document
	   *
	   * @access private
	   * @returns {boolean}
	   */
	
	  var isSVG = docElement.nodeName.toLowerCase() === 'svg';
	
	
	  /**
	   * createElement is a convenience wrapper around document.createElement. Since we
	   * use createElement all over the place, this allows for (slightly) smaller code
	   * as well as abstracting away issues with creating elements in contexts other than
	   * HTML documents (e.g. SVG documents).
	   *
	   * @access private
	   * @function createElement
	   * @returns {HTMLElement|SVGElement} An HTML or SVG element
	   */
	
	  function createElement() {
	    if (typeof document.createElement !== 'function') {
	      // This is the case in IE7, where the type of createElement is "object".
	      // For this reason, we cannot call apply() as Object is not a Function.
	      return document.createElement(arguments[0]);
	    } else if (isSVG) {
	      return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
	    } else {
	      return document.createElement.apply(document, arguments);
	    }
	  }
	
	  ;
	/*!
	{
	  "name": "Inline SVG",
	  "property": "inlinesvg",
	  "caniuse": "svg-html5",
	  "tags": ["svg"],
	  "notes": [{
	    "name": "Test page",
	    "href": "https://paulirish.com/demo/inline-svg"
	  }, {
	    "name": "Test page and results",
	    "href": "https://codepen.io/eltonmesquita/full/GgXbvo/"
	  }],
	  "polyfills": ["inline-svg-polyfill"],
	  "knownBugs": ["False negative on some Chromia browsers."]
	}
	!*/
	/* DOC
	Detects support for inline SVG in HTML (not within XHTML).
	*/
	
	  Modernizr.addTest('inlinesvg', function() {
	    var div = createElement('div');
	    div.innerHTML = '<svg/>';
	    return (typeof SVGRect != 'undefined' && div.firstChild && div.firstChild.namespaceURI) == 'http://www.w3.org/2000/svg';
	  });
	
	
	  /**
	   * Modernizr.hasEvent() detects support for a given event
	   *
	   * @memberof Modernizr
	   * @name Modernizr.hasEvent
	   * @optionName Modernizr.hasEvent()
	   * @optionProp hasEvent
	   * @access public
	   * @function hasEvent
	   * @param  {string|*} eventName - the name of an event to test for (e.g. "resize")
	   * @param  {Element|string} [element=HTMLDivElement] - is the element|document|window|tagName to test on
	   * @returns {boolean}
	   * @example
	   *  `Modernizr.hasEvent` lets you determine if the browser supports a supplied event.
	   *  By default, it does this detection on a div element
	   *
	   * ```js
	   *  hasEvent('blur') // true;
	   * ```
	   *
	   * However, you are able to give an object as a second argument to hasEvent to
	   * detect an event on something other than a div.
	   *
	   * ```js
	   *  hasEvent('devicelight', window) // true;
	   * ```
	   *
	   */
	
	  var hasEvent = (function() {
	
	    // Detect whether event support can be detected via `in`. Test on a DOM element
	    // using the "blur" event b/c it should always exist. bit.ly/event-detection
	    var needsFallback = !('onblur' in document.documentElement);
	
	    function inner(eventName, element) {
	
	      var isSupported;
	      if (!eventName) { return false; }
	      if (!element || typeof element === 'string') {
	        element = createElement(element || 'div');
	      }
	
	      // Testing via the `in` operator is sufficient for modern browsers and IE.
	      // When using `setAttribute`, IE skips "unload", WebKit skips "unload" and
	      // "resize", whereas `in` "catches" those.
	      eventName = 'on' + eventName;
	      isSupported = eventName in element;
	
	      // Fallback technique for old Firefox - bit.ly/event-detection
	      if (!isSupported && needsFallback) {
	        if (!element.setAttribute) {
	          // Switch to generic element if it lacks `setAttribute`.
	          // It could be the `document`, `window`, or something else.
	          element = createElement('div');
	        }
	
	        element.setAttribute(eventName, '');
	        isSupported = typeof element[eventName] === 'function';
	
	        if (element[eventName] !== undefined) {
	          // If property was created, "remove it" by setting value to `undefined`.
	          element[eventName] = undefined;
	        }
	        element.removeAttribute(eventName);
	      }
	
	      return isSupported;
	    }
	    return inner;
	  })();
	
	
	  ModernizrProto.hasEvent = hasEvent;
	
	
	  /**
	   * getBody returns the body of a document, or an element that can stand in for
	   * the body if a real body does not exist
	   *
	   * @access private
	   * @function getBody
	   * @returns {HTMLElement|SVGElement} Returns the real body of a document, or an
	   * artificially created element that stands in for the body
	   */
	
	  function getBody() {
	    // After page load injecting a fake body doesn't work so check if body exists
	    var body = document.body;
	
	    if (!body) {
	      // Can't use the real body create a fake one.
	      body = createElement(isSVG ? 'svg' : 'body');
	      body.fake = true;
	    }
	
	    return body;
	  }
	
	  ;
	
	  /**
	   * injectElementWithStyles injects an element with style element and some CSS rules
	   *
	   * @access private
	   * @function injectElementWithStyles
	   * @param {string} rule - String representing a css rule
	   * @param {function} callback - A function that is used to test the injected element
	   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
	   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
	   * @returns {boolean}
	   */
	
	  function injectElementWithStyles(rule, callback, nodes, testnames) {
	    var mod = 'modernizr';
	    var style;
	    var ret;
	    var node;
	    var docOverflow;
	    var div = createElement('div');
	    var body = getBody();
	
	    if (parseInt(nodes, 10)) {
	      // In order not to give false positives we create a node for each test
	      // This also allows the method to scale for unspecified uses
	      while (nodes--) {
	        node = createElement('div');
	        node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
	        div.appendChild(node);
	      }
	    }
	
	    style = createElement('style');
	    style.type = 'text/css';
	    style.id = 's' + mod;
	
	    // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
	    // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
	    (!body.fake ? div : body).appendChild(style);
	    body.appendChild(div);
	
	    if (style.styleSheet) {
	      style.styleSheet.cssText = rule;
	    } else {
	      style.appendChild(document.createTextNode(rule));
	    }
	    div.id = mod;
	
	    if (body.fake) {
	      //avoid crashing IE8, if background image is used
	      body.style.background = '';
	      //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
	      body.style.overflow = 'hidden';
	      docOverflow = docElement.style.overflow;
	      docElement.style.overflow = 'hidden';
	      docElement.appendChild(body);
	    }
	
	    ret = callback(div, rule);
	    // If this is done after page load we don't want to remove the body so check if body exists
	    if (body.fake) {
	      body.parentNode.removeChild(body);
	      docElement.style.overflow = docOverflow;
	      // Trigger layout so kinetic scrolling isn't disabled in iOS6+
	      docElement.offsetHeight;
	    } else {
	      div.parentNode.removeChild(div);
	    }
	
	    return !!ret;
	
	  }
	
	  ;
	
	  /**
	   * testStyles injects an element with style element and some CSS rules
	   *
	   * @memberof Modernizr
	   * @name Modernizr.testStyles
	   * @optionName Modernizr.testStyles()
	   * @optionProp testStyles
	   * @access public
	   * @function testStyles
	   * @param {string} rule - String representing a css rule
	   * @param {function} callback - A function that is used to test the injected element
	   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
	   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
	   * @returns {boolean}
	   * @example
	   *
	   * `Modernizr.testStyles` takes a CSS rule and injects it onto the current page
	   * along with (possibly multiple) DOM elements. This lets you check for features
	   * that can not be detected by simply checking the [IDL](https://developer.mozilla.org/en-US/docs/Mozilla/Developer_guide/Interface_development_guide/IDL_interface_rules).
	   *
	   * ```js
	   * Modernizr.testStyles('#modernizr { width: 9px; color: papayawhip; }', function(elem, rule) {
	   *   // elem is the first DOM node in the page (by default #modernizr)
	   *   // rule is the first argument you supplied - the CSS rule in string form
	   *
	   *   addTest('widthworks', elem.style.width === '9px')
	   * });
	   * ```
	   *
	   * If your test requires multiple nodes, you can include a third argument
	   * indicating how many additional div elements to include on the page. The
	   * additional nodes are injected as children of the `elem` that is returned as
	   * the first argument to the callback.
	   *
	   * ```js
	   * Modernizr.testStyles('#modernizr {width: 1px}; #modernizr2 {width: 2px}', function(elem) {
	   *   document.getElementById('modernizr').style.width === '1px'; // true
	   *   document.getElementById('modernizr2').style.width === '2px'; // true
	   *   elem.firstChild === document.getElementById('modernizr2'); // true
	   * }, 1);
	   * ```
	   *
	   * By default, all of the additional elements have an ID of `modernizr[n]`, where
	   * `n` is its index (e.g. the first additional, second overall is `#modernizr2`,
	   * the second additional is `#modernizr3`, etc.).
	   * If you want to have more meaningful IDs for your function, you can provide
	   * them as the fourth argument, as an array of strings
	   *
	   * ```js
	   * Modernizr.testStyles('#foo {width: 10px}; #bar {height: 20px}', function(elem) {
	   *   elem.firstChild === document.getElementById('foo'); // true
	   *   elem.lastChild === document.getElementById('bar'); // true
	   * }, 2, ['foo', 'bar']);
	   * ```
	   *
	   */
	
	  var testStyles = ModernizrProto.testStyles = injectElementWithStyles;
	
	/*!
	{
	  "name": "onInput Event",
	  "property": "oninput",
	  "notes": [{
	    "name": "MDN article",
	    "href": "https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers.oninput"
	  },{
	    "name": "WHATWG spec",
	    "href": "https://html.spec.whatwg.org/multipage/forms.html#common-input-element-attributes"
	  },{
	    "name": "Detecting onInput support",
	    "href": "http://danielfriesen.name/blog/2010/02/16/html5-browser-maze-oninput-support"
	  }],
	  "authors": ["Patrick Kettner"],
	  "tags": ["event"]
	}
	!*/
	/* DOC
	`oninput` tests if the browser is able to detect the input event
	*/
	
	
	  Modernizr.addTest('oninput', function() {
	    var input = createElement('input');
	    var supportsOnInput;
	    input.setAttribute('oninput', 'return');
	
	    if (hasEvent('oninput', docElement) || typeof input.oninput == 'function') {
	      return true;
	    }
	
	    // IE doesn't support onInput, so we wrap up the non IE APIs
	    // (createEvent, addEventListener) in a try catch, rather than test for
	    // their trident equivalent.
	    try {
	      // Older Firefox didn't map oninput attribute to oninput property
	      var testEvent  = document.createEvent('KeyboardEvent');
	      supportsOnInput = false;
	      var handler = function(e) {
	        supportsOnInput = true;
	        e.preventDefault();
	        e.stopPropagation();
	      };
	
	      testEvent.initKeyEvent('keypress', true, true, window, false, false, false, false, 0, 'e'.charCodeAt(0));
	      docElement.appendChild(input);
	      input.addEventListener('input', handler, false);
	      input.focus();
	      input.dispatchEvent(testEvent);
	      input.removeEventListener('input', handler, false);
	      docElement.removeChild(input);
	    } catch (e) {
	      supportsOnInput = false;
	    }
	      return supportsOnInput;
	  });
	
	
	  /**
	   * cssToDOM takes a kebab-case string and converts it to camelCase
	   * e.g. box-sizing -> boxSizing
	   *
	   * @access private
	   * @function cssToDOM
	   * @param {string} name - String name of kebab-case prop we want to convert
	   * @returns {string} The camelCase version of the supplied name
	   */
	
	  function cssToDOM(name) {
	    return name.replace(/([a-z])-([a-z])/g, function(str, m1, m2) {
	      return m1 + m2.toUpperCase();
	    }).replace(/^-/, '');
	  }
	  ;
	
	  /**
	   * If the browsers follow the spec, then they would expose vendor-specific style as:
	   *   elem.style.WebkitBorderRadius
	   * instead of something like the following, which would be technically incorrect:
	   *   elem.style.webkitBorderRadius
	
	   * Webkit ghosts their properties in lowercase but Opera & Moz do not.
	   * Microsoft uses a lowercase `ms` instead of the correct `Ms` in IE8+
	   *   erik.eae.net/archives/2008/03/10/21.48.10/
	
	   * More here: github.com/Modernizr/Modernizr/issues/issue/21
	   *
	   * @access private
	   * @returns {string} The string representing the vendor-specific style properties
	   */
	
	  var omPrefixes = 'Moz O ms Webkit';
	
	
	  var cssomPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.split(' ') : []);
	  ModernizrProto._cssomPrefixes = cssomPrefixes;
	
	
	  /**
	   * atRule returns a given CSS property at-rule (eg @keyframes), possibly in
	   * some prefixed form, or false, in the case of an unsupported rule
	   *
	   * @memberof Modernizr
	   * @name Modernizr.atRule
	   * @optionName Modernizr.atRule()
	   * @optionProp atRule
	   * @access public
	   * @function atRule
	   * @param {string} prop - String name of the @-rule to test for
	   * @returns {string|boolean} The string representing the (possibly prefixed)
	   * valid version of the @-rule, or `false` when it is unsupported.
	   * @example
	   * ```js
	   *  var keyframes = Modernizr.atRule('@keyframes');
	   *
	   *  if (keyframes) {
	   *    // keyframes are supported
	   *    // could be `@-webkit-keyframes` or `@keyframes`
	   *  } else {
	   *    // keyframes === `false`
	   *  }
	   * ```
	   *
	   */
	
	  var atRule = function(prop) {
	    var length = prefixes.length;
	    var cssrule = window.CSSRule;
	    var rule;
	
	    if (typeof cssrule === 'undefined') {
	      return undefined;
	    }
	
	    if (!prop) {
	      return false;
	    }
	
	    // remove literal @ from beginning of provided property
	    prop = prop.replace(/^@/, '');
	
	    // CSSRules use underscores instead of dashes
	    rule = prop.replace(/-/g, '_').toUpperCase() + '_RULE';
	
	    if (rule in cssrule) {
	      return '@' + prop;
	    }
	
	    for (var i = 0; i < length; i++) {
	      // prefixes gives us something like -o-, and we want O_
	      var prefix = prefixes[i];
	      var thisRule = prefix.toUpperCase() + '_' + rule;
	
	      if (thisRule in cssrule) {
	        return '@-' + prefix.toLowerCase() + '-' + prop;
	      }
	    }
	
	    return false;
	  };
	
	  ModernizrProto.atRule = atRule;
	
	
	
	  /**
	   * List of JavaScript DOM values used for tests
	   *
	   * @memberof Modernizr
	   * @name Modernizr._domPrefixes
	   * @optionName Modernizr._domPrefixes
	   * @optionProp domPrefixes
	   * @access public
	   * @example
	   *
	   * Modernizr._domPrefixes is exactly the same as [_prefixes](#modernizr-_prefixes), but rather
	   * than kebab-case properties, all properties are their Capitalized variant
	   *
	   * ```js
	   * Modernizr._domPrefixes === [ "Moz", "O", "ms", "Webkit" ];
	   * ```
	   */
	
	  var domPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(' ') : []);
	  ModernizrProto._domPrefixes = domPrefixes;
	
	
	
	  /**
	   * contains checks to see if a string contains another string
	   *
	   * @access private
	   * @function contains
	   * @param {string} str - The string we want to check for substrings
	   * @param {string} substr - The substring we want to search the first string for
	   * @returns {boolean}
	   */
	
	  function contains(str, substr) {
	    return !!~('' + str).indexOf(substr);
	  }
	
	  ;
	
	  /**
	   * fnBind is a super small [bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind) polyfill.
	   *
	   * @access private
	   * @function fnBind
	   * @param {function} fn - a function you want to change `this` reference to
	   * @param {object} that - the `this` you want to call the function with
	   * @returns {function} The wrapped version of the supplied function
	   */
	
	  function fnBind(fn, that) {
	    return function() {
	      return fn.apply(that, arguments);
	    };
	  }
	
	  ;
	
	  /**
	   * testDOMProps is a generic DOM property test; if a browser supports
	   *   a certain property, it won't return undefined for it.
	   *
	   * @access private
	   * @function testDOMProps
	   * @param {array.<string>} props - An array of properties to test for
	   * @param {object} obj - An object or Element you want to use to test the parameters again
	   * @param {boolean|object} elem - An Element to bind the property lookup again. Use `false` to prevent the check
	   */
	  function testDOMProps(props, obj, elem) {
	    var item;
	
	    for (var i in props) {
	      if (props[i] in obj) {
	
	        // return the property name as a string
	        if (elem === false) {
	          return props[i];
	        }
	
	        item = obj[props[i]];
	
	        // let's bind a function
	        if (is(item, 'function')) {
	          // bind to obj unless overriden
	          return fnBind(item, elem || obj);
	        }
	
	        // return the unbound function or obj or value
	        return item;
	      }
	    }
	    return false;
	  }
	
	  ;
	
	  /**
	   * Create our "modernizr" element that we do most feature tests on.
	   *
	   * @access private
	   */
	
	  var modElem = {
	    elem: createElement('modernizr')
	  };
	
	  // Clean up this element
	  Modernizr._q.push(function() {
	    delete modElem.elem;
	  });
	
	
	
	  var mStyle = {
	    style: modElem.elem.style
	  };
	
	  // kill ref for gc, must happen before mod.elem is removed, so we unshift on to
	  // the front of the queue.
	  Modernizr._q.unshift(function() {
	    delete mStyle.style;
	  });
	
	
	
	  /**
	   * domToCSS takes a camelCase string and converts it to kebab-case
	   * e.g. boxSizing -> box-sizing
	   *
	   * @access private
	   * @function domToCSS
	   * @param {string} name - String name of camelCase prop we want to convert
	   * @returns {string} The kebab-case version of the supplied name
	   */
	
	  function domToCSS(name) {
	    return name.replace(/([A-Z])/g, function(str, m1) {
	      return '-' + m1.toLowerCase();
	    }).replace(/^ms-/, '-ms-');
	  }
	  ;
	
	  /**
	   * nativeTestProps allows for us to use native feature detection functionality if available.
	   * some prefixed form, or false, in the case of an unsupported rule
	   *
	   * @access private
	   * @function nativeTestProps
	   * @param {array} props - An array of property names
	   * @param {string} value - A string representing the value we want to check via @supports
	   * @returns {boolean|undefined} A boolean when @supports exists, undefined otherwise
	   */
	
	  // Accepts a list of property names and a single value
	  // Returns `undefined` if native detection not available
	  function nativeTestProps(props, value) {
	    var i = props.length;
	    // Start with the JS API: http://www.w3.org/TR/css3-conditional/#the-css-interface
	    if ('CSS' in window && 'supports' in window.CSS) {
	      // Try every prefixed variant of the property
	      while (i--) {
	        if (window.CSS.supports(domToCSS(props[i]), value)) {
	          return true;
	        }
	      }
	      return false;
	    }
	    // Otherwise fall back to at-rule (for Opera 12.x)
	    else if ('CSSSupportsRule' in window) {
	      // Build a condition string for every prefixed variant
	      var conditionText = [];
	      while (i--) {
	        conditionText.push('(' + domToCSS(props[i]) + ':' + value + ')');
	      }
	      conditionText = conditionText.join(' or ');
	      return injectElementWithStyles('@supports (' + conditionText + ') { #modernizr { position: absolute; } }', function(node) {
	        return getComputedStyle(node, null).position == 'absolute';
	      });
	    }
	    return undefined;
	  }
	  ;
	
	  // testProps is a generic CSS / DOM property test.
	
	  // In testing support for a given CSS property, it's legit to test:
	  //    `elem.style[styleName] !== undefined`
	  // If the property is supported it will return an empty string,
	  // if unsupported it will return undefined.
	
	  // We'll take advantage of this quick test and skip setting a style
	  // on our modernizr element, but instead just testing undefined vs
	  // empty string.
	
	  // Property names can be provided in either camelCase or kebab-case.
	
	  function testProps(props, prefixed, value, skipValueTest) {
	    skipValueTest = is(skipValueTest, 'undefined') ? false : skipValueTest;
	
	    // Try native detect first
	    if (!is(value, 'undefined')) {
	      var result = nativeTestProps(props, value);
	      if (!is(result, 'undefined')) {
	        return result;
	      }
	    }
	
	    // Otherwise do it properly
	    var afterInit, i, propsLength, prop, before;
	
	    // If we don't have a style element, that means we're running async or after
	    // the core tests, so we'll need to create our own elements to use
	
	    // inside of an SVG element, in certain browsers, the `style` element is only
	    // defined for valid tags. Therefore, if `modernizr` does not have one, we
	    // fall back to a less used element and hope for the best.
	    // for strict XHTML browsers the hardly used samp element is used
	    var elems = ['modernizr', 'tspan', 'samp'];
	    while (!mStyle.style && elems.length) {
	      afterInit = true;
	      mStyle.modElem = createElement(elems.shift());
	      mStyle.style = mStyle.modElem.style;
	    }
	
	    // Delete the objects if we created them.
	    function cleanElems() {
	      if (afterInit) {
	        delete mStyle.style;
	        delete mStyle.modElem;
	      }
	    }
	
	    propsLength = props.length;
	    for (i = 0; i < propsLength; i++) {
	      prop = props[i];
	      before = mStyle.style[prop];
	
	      if (contains(prop, '-')) {
	        prop = cssToDOM(prop);
	      }
	
	      if (mStyle.style[prop] !== undefined) {
	
	        // If value to test has been passed in, do a set-and-check test.
	        // 0 (integer) is a valid property value, so check that `value` isn't
	        // undefined, rather than just checking it's truthy.
	        if (!skipValueTest && !is(value, 'undefined')) {
	
	          // Needs a try catch block because of old IE. This is slow, but will
	          // be avoided in most cases because `skipValueTest` will be used.
	          try {
	            mStyle.style[prop] = value;
	          } catch (e) {}
	
	          // If the property value has changed, we assume the value used is
	          // supported. If `value` is empty string, it'll fail here (because
	          // it hasn't changed), which matches how browsers have implemented
	          // CSS.supports()
	          if (mStyle.style[prop] != before) {
	            cleanElems();
	            return prefixed == 'pfx' ? prop : true;
	          }
	        }
	        // Otherwise just return true, or the property name if this is a
	        // `prefixed()` call
	        else {
	          cleanElems();
	          return prefixed == 'pfx' ? prop : true;
	        }
	      }
	    }
	    cleanElems();
	    return false;
	  }
	
	  ;
	
	  /**
	   * testPropsAll tests a list of DOM properties we want to check against.
	   * We specify literally ALL possible (known and/or likely) properties on
	   * the element including the non-vendor prefixed one, for forward-
	   * compatibility.
	   *
	   * @access private
	   * @function testPropsAll
	   * @param {string} prop - A string of the property to test for
	   * @param {string|object} [prefixed] - An object to check the prefixed properties on. Use a string to skip
	   * @param {HTMLElement|SVGElement} [elem] - An element used to test the property and value against
	   * @param {string} [value] - A string of a css value
	   * @param {boolean} [skipValueTest] - An boolean representing if you want to test if value sticks when set
	   */
	  function testPropsAll(prop, prefixed, elem, value, skipValueTest) {
	
	    var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
	    props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');
	
	    // did they call .prefixed('boxSizing') or are we just testing a prop?
	    if (is(prefixed, 'string') || is(prefixed, 'undefined')) {
	      return testProps(props, prefixed, value, skipValueTest);
	
	      // otherwise, they called .prefixed('requestAnimationFrame', window[, elem])
	    } else {
	      props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
	      return testDOMProps(props, prefixed, elem);
	    }
	  }
	
	  // Modernizr.testAllProps() investigates whether a given style property,
	  // or any of its vendor-prefixed variants, is recognized
	  //
	  // Note that the property names must be provided in the camelCase variant.
	  // Modernizr.testAllProps('boxSizing')
	  ModernizrProto.testAllProps = testPropsAll;
	
	
	
	  /**
	   * prefixed returns the prefixed or nonprefixed property name variant of your input
	   *
	   * @memberof Modernizr
	   * @name Modernizr.prefixed
	   * @optionName Modernizr.prefixed()
	   * @optionProp prefixed
	   * @access public
	   * @function prefixed
	   * @param {string} prop - String name of the property to test for
	   * @param {object} [obj] - An object to test for the prefixed properties on
	   * @param {HTMLElement} [elem] - An element used to test specific properties against
	   * @returns {string|false} The string representing the (possibly prefixed) valid
	   * version of the property, or `false` when it is unsupported.
	   * @example
	   *
	   * Modernizr.prefixed takes a string css value in the DOM style camelCase (as
	   * opposed to the css style kebab-case) form and returns the (possibly prefixed)
	   * version of that property that the browser actually supports.
	   *
	   * For example, in older Firefox...
	   * ```js
	   * prefixed('boxSizing')
	   * ```
	   * returns 'MozBoxSizing'
	   *
	   * In newer Firefox, as well as any other browser that support the unprefixed
	   * version would simply return `boxSizing`. Any browser that does not support
	   * the property at all, it will return `false`.
	   *
	   * By default, prefixed is checked against a DOM element. If you want to check
	   * for a property on another object, just pass it as a second argument
	   *
	   * ```js
	   * var rAF = prefixed('requestAnimationFrame', window);
	   *
	   * raf(function() {
	   *  renderFunction();
	   * })
	   * ```
	   *
	   * Note that this will return _the actual function_ - not the name of the function.
	   * If you need the actual name of the property, pass in `false` as a third argument
	   *
	   * ```js
	   * var rAFProp = prefixed('requestAnimationFrame', window, false);
	   *
	   * rafProp === 'WebkitRequestAnimationFrame' // in older webkit
	   * ```
	   *
	   * One common use case for prefixed is if you're trying to determine which transition
	   * end event to bind to, you might do something like...
	   * ```js
	   * var transEndEventNames = {
	   *     'WebkitTransition' : 'webkitTransitionEnd', * Saf 6, Android Browser
	   *     'MozTransition'    : 'transitionend',       * only for FF < 15
	   *     'transition'       : 'transitionend'        * IE10, Opera, Chrome, FF 15+, Saf 7+
	   * };
	   *
	   * var transEndEventName = transEndEventNames[ Modernizr.prefixed('transition') ];
	   * ```
	   *
	   * If you want a similar lookup, but in kebab-case, you can use [prefixedCSS](#modernizr-prefixedcss).
	   */
	
	  var prefixed = ModernizrProto.prefixed = function(prop, obj, elem) {
	    if (prop.indexOf('@') === 0) {
	      return atRule(prop);
	    }
	
	    if (prop.indexOf('-') != -1) {
	      // Convert kebab-case to camelCase
	      prop = cssToDOM(prop);
	    }
	    if (!obj) {
	      return testPropsAll(prop, 'pfx');
	    } else {
	      // Testing DOM property e.g. Modernizr.prefixed('requestAnimationFrame', window) // 'mozRequestAnimationFrame'
	      return testPropsAll(prop, obj, elem);
	    }
	  };
	
	
	/*!
	{
	  "name": "RTC Peer Connection",
	  "property": "peerconnection",
	  "tags": ["webrtc"],
	  "authors": ["Ankur Oberoi"],
	  "notes": [{
	    "name": "W3C Web RTC spec",
	    "href": "https://www.w3.org/TR/webrtc/"
	  }]
	}
	!*/
	
	  Modernizr.addTest('peerconnection', !!prefixed('RTCPeerConnection', window));
	
	
	  // Run each test
	  testRunner();
	
	  delete ModernizrProto.addTest;
	  delete ModernizrProto.addAsyncTest;
	
	  // Run the things that are supposed to run after the tests
	  for (var i = 0; i < Modernizr._q.length; i++) {
	    Modernizr._q[i]();
	  }
	
	  // Leak Modernizr namespace
	  // window.Modernizr = Modernizr;
	  module.exports = Modernizr;
	
	
	// ;
	
	// })(window, document);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["WebIM"] = __webpack_require__(12);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	/**
	 * git do not control webim.config.js
	 * everyone should copy webim.config.js.demo to webim.config.js
	 * and have their own configs.
	 * In this way , others won't be influenced by this config while git pull.
	 *
	 */
	var WebIM = {};
	
	WebIM.config = {
		/*
		 * XMPP server
		 */
		// xmppURL: 'im-api.easemob.com',
		/*
		 * Backend REST API URL
		 */
		// apiURL: (location.protocol === 'https:' ? 'https:' : 'http:') + '//a1.easemob.com',
		/*
		 * Application AppKey
		 */
		// appkey: 'easemob-demo#chatdemoui',
		/*
		 * Whether to use wss
		 * @parameter {Boolean} true or false
		 */
		// https: false,
		/*
		 * isMultiLoginSessions
		 * true: A visitor can sign in to multiple webpages and receive messages at all the webpages.
		 * false: A visitor can sign in to only one webpage and receive messages at the webpage.
		 */
		// isMultiLoginSessions: false,
		/*
		 * Set to auto sign-in
		 */
		isAutoLogin: true,
		/**
		 * Whether to use window.doQuery()
		 * @parameter {Boolean} true or false
		 */
		isWindowSDK: false,
		/**
		 * isSandBox=true:  xmppURL: 'im-api.sandbox.easemob.com',  apiURL: '//a1.sdb.easemob.com',
		 * isSandBox=false: xmppURL: 'im-api.easemob.com',          apiURL: '//a1.easemob.com',
		 * @parameter {Boolean} true or false
		 */
		isSandBox: false,
		/**
		 * Whether to console.log in strophe.log()
		 * @parameter {Boolean} true or false
		 */
		isDebug: false,
		/**
		 * will auto connect the xmpp server autoReconnectNumMax times in background when client is offline.
		 * won't auto connect if autoReconnectNumMax=0.
		 */
		autoReconnectNumMax: 2,
		/**
		 * the interval secons between each atuo reconnectting.
		 * works only if autoReconnectMaxNum >= 2.
		 */
		autoReconnectInterval: 2,
		/**
		 * webrtc supports WebKit and https only
		 */
		isWebRTC: /WebKit/.test(navigator.userAgent) && /^https:$/.test(window.location.protocol),
		/**
		 * while http access,use ip directly,instead of ServerName,avoiding DNS problem.
		 */
		isHttpDNS: false
	};
	
	module.exports = WebIM;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('underscore', factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
	    var current = global._;
	    var exports = global._ = factory();
	    exports.noConflict = function () { global._ = current; return exports; };
	  }()));
	}(this, (function () {
	  //     Underscore.js 1.13.1
	  //     https://underscorejs.org
	  //     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
	  //     Underscore may be freely distributed under the MIT license.
	
	  // Current version.
	  var VERSION = '1.13.1';
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = typeof self == 'object' && self.self === self && self ||
	            typeof global == 'object' && global.global === global && global ||
	            Function('return this')() ||
	            {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // Modern feature detection.
	  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
	      supportsDataView = typeof DataView !== 'undefined';
	
	  // All **ECMAScript 5+** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create,
	      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;
	
	  // Create references to these builtin functions because we override them.
	  var _isNaN = isNaN,
	      _isFinite = isFinite;
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  // The largest integer that can be represented exactly.
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  function restArguments(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  }
	
	  // Is a given variable an object?
	  function isObject(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  }
	
	  // Is a given value equal to null?
	  function isNull(obj) {
	    return obj === null;
	  }
	
	  // Is a given variable undefined?
	  function isUndefined(obj) {
	    return obj === void 0;
	  }
	
	  // Is a given value a boolean?
	  function isBoolean(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  }
	
	  // Is a given value a DOM element?
	  function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  }
	
	  // Internal function for creating a `toString`-based type tester.
	  function tagTester(name) {
	    var tag = '[object ' + name + ']';
	    return function(obj) {
	      return toString.call(obj) === tag;
	    };
	  }
	
	  var isString = tagTester('String');
	
	  var isNumber = tagTester('Number');
	
	  var isDate = tagTester('Date');
	
	  var isRegExp = tagTester('RegExp');
	
	  var isError = tagTester('Error');
	
	  var isSymbol = tagTester('Symbol');
	
	  var isArrayBuffer = tagTester('ArrayBuffer');
	
	  var isFunction = tagTester('Function');
	
	  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
	  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  var isFunction$1 = isFunction;
	
	  var hasObjectTag = tagTester('Object');
	
	  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
	  // In IE 11, the most common among them, this problem also applies to
	  // `Map`, `WeakMap` and `Set`.
	  var hasStringTagBug = (
	        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
	      ),
	      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));
	
	  var isDataView = tagTester('DataView');
	
	  // In IE 10 - Edge 13, we need a different heuristic
	  // to determine whether an object is a `DataView`.
	  function ie10IsDataView(obj) {
	    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
	  }
	
	  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native `Array.isArray`.
	  var isArray = nativeIsArray || tagTester('Array');
	
	  // Internal function to check whether `key` is an own property name of `obj`.
	  function has$1(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  }
	
	  var isArguments = tagTester('Arguments');
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  (function() {
	    if (!isArguments(arguments)) {
	      isArguments = function(obj) {
	        return has$1(obj, 'callee');
	      };
	    }
	  }());
	
	  var isArguments$1 = isArguments;
	
	  // Is a given object a finite number?
	  function isFinite$1(obj) {
	    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
	  }
	
	  // Is the given value `NaN`?
	  function isNaN$1(obj) {
	    return isNumber(obj) && _isNaN(obj);
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }
	
	  // Common internal logic for `isArrayLike` and `isBufferLike`.
	  function createSizePropertyCheck(getSizeProperty) {
	    return function(collection) {
	      var sizeProperty = getSizeProperty(collection);
	      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
	    }
	  }
	
	  // Internal helper to generate a function to obtain property `key` from `obj`.
	  function shallowProperty(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  }
	
	  // Internal helper to obtain the `byteLength` property of an object.
	  var getByteLength = shallowProperty('byteLength');
	
	  // Internal helper to determine whether we should spend extensive checks against
	  // `ArrayBuffer` et al.
	  var isBufferLike = createSizePropertyCheck(getByteLength);
	
	  // Is a given value a typed array?
	  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
	  function isTypedArray(obj) {
	    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
	    // Otherwise, fall back on the above regular expression.
	    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
	                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
	  }
	
	  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);
	
	  // Internal helper to obtain the `length` property of an object.
	  var getLength = shallowProperty('length');
	
	  // Internal helper to create a simple lookup structure.
	  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
	  // circular imports. `emulatedSet` is a one-off solution that only works for
	  // arrays of strings.
	  function emulatedSet(keys) {
	    var hash = {};
	    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
	    return {
	      contains: function(key) { return hash[key]; },
	      push: function(key) {
	        hash[key] = true;
	        return keys.push(key);
	      }
	    };
	  }
	
	  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
	  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
	  // needed.
	  function collectNonEnumProps(obj, keys) {
	    keys = emulatedSet(keys);
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = isFunction$1(constructor) && constructor.prototype || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  function keys(obj) {
	    if (!isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has$1(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  function isEmpty(obj) {
	    if (obj == null) return true;
	    // Skip the more expensive `toString`-based type checks if `obj` has no
	    // `.length`.
	    var length = getLength(obj);
	    if (typeof length == 'number' && (
	      isArray(obj) || isString(obj) || isArguments$1(obj)
	    )) return length === 0;
	    return getLength(keys(obj)) === 0;
	  }
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  function isMatch(object, attrs) {
	    var _keys = keys(attrs), length = _keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = _keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  }
	
	  // If Underscore is called as a function, it returns a wrapped object that can
	  // be used OO-style. This wrapper holds altered versions of all functions added
	  // through `_.mixin`. Wrapped objects may be chained.
	  function _$1(obj) {
	    if (obj instanceof _$1) return obj;
	    if (!(this instanceof _$1)) return new _$1(obj);
	    this._wrapped = obj;
	  }
	
	  _$1.VERSION = VERSION;
	
	  // Extracts the result from a wrapped and chained object.
	  _$1.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxies for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;
	
	  _$1.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // Internal function to wrap or shallow-copy an ArrayBuffer,
	  // typed array or DataView to a new view, reusing the buffer.
	  function toBufferView(bufferSource) {
	    return new Uint8Array(
	      bufferSource.buffer || bufferSource,
	      bufferSource.byteOffset || 0,
	      getByteLength(bufferSource)
	    );
	  }
	
	  // We use this string twice, so give it a name for minification.
	  var tagDataView = '[object DataView]';
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  }
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _$1) a = a._wrapped;
	    if (b instanceof _$1) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    // Work around a bug in IE 10 - Edge 13.
	    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
	      if (!isDataView$1(b)) return false;
	      className = tagDataView;
	    }
	    switch (className) {
	      // These types are compared by value.
	      case '[object RegExp]':
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	      case '[object ArrayBuffer]':
	      case tagDataView:
	        // Coerce to typed array so we can fall through.
	        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays && isTypedArray$1(a)) {
	        var byteLength = getByteLength(a);
	        if (byteLength !== getByteLength(b)) return false;
	        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
	        areArrays = true;
	    }
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
	                               isFunction$1(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var _keys = keys(a), key;
	      length = _keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = _keys[length];
	        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  }
	
	  // Perform a deep comparison to check if two objects are equal.
	  function isEqual(a, b) {
	    return eq(a, b);
	  }
	
	  // Retrieve all the enumerable property names of an object.
	  function allKeys(obj) {
	    if (!isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Since the regular `Object.prototype.toString` type tests don't work for
	  // some types in IE 11, we use a fingerprinting heuristic instead, based
	  // on the methods. It's not great, but it's the best we got.
	  // The fingerprint method lists are defined below.
	  function ie11fingerprint(methods) {
	    var length = getLength(methods);
	    return function(obj) {
	      if (obj == null) return false;
	      // `Map`, `WeakMap` and `Set` have no enumerable keys.
	      var keys = allKeys(obj);
	      if (getLength(keys)) return false;
	      for (var i = 0; i < length; i++) {
	        if (!isFunction$1(obj[methods[i]])) return false;
	      }
	      // If we are testing against `WeakMap`, we need to ensure that
	      // `obj` doesn't have a `forEach` method in order to distinguish
	      // it from a regular `Map`.
	      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
	    };
	  }
	
	  // In the interest of compact minification, we write
	  // each string in the fingerprints only once.
	  var forEachName = 'forEach',
	      hasName = 'has',
	      commonInit = ['clear', 'delete'],
	      mapTail = ['get', hasName, 'set'];
	
	  // `Map`, `WeakMap` and `Set` each have slightly different
	  // combinations of the above sublists.
	  var mapMethods = commonInit.concat(forEachName, mapTail),
	      weakMapMethods = commonInit.concat(mapTail),
	      setMethods = ['add'].concat(commonInit, forEachName, hasName);
	
	  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');
	
	  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');
	
	  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');
	
	  var isWeakSet = tagTester('WeakSet');
	
	  // Retrieve the values of an object's properties.
	  function values(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[_keys[i]];
	    }
	    return values;
	  }
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of `_.object` with one argument.
	  function pairs(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [_keys[i], obj[_keys[i]]];
	    }
	    return pairs;
	  }
	
	  // Invert the keys and values of an object. The values must be serializable.
	  function invert(obj) {
	    var result = {};
	    var _keys = keys(obj);
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      result[obj[_keys[i]]] = _keys[i];
	    }
	    return result;
	  }
	
	  // Return a sorted list of the function names available on the object.
	  function functions(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (isFunction$1(obj[key])) names.push(key);
	    }
	    return names.sort();
	  }
	
	  // An internal function for creating assigner functions.
	  function createAssigner(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  }
	
	  // Extend a given object with all the properties in passed-in object(s).
	  var extend = createAssigner(allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in
	  // object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var extendOwn = createAssigner(keys);
	
	  // Fill in a given object with default properties.
	  var defaults = createAssigner(allKeys, true);
	
	  // Create a naked function reference for surrogate-prototype-swapping.
	  function ctor() {
	    return function(){};
	  }
	
	  // An internal function for creating a new object that inherits from another.
	  function baseCreate(prototype) {
	    if (!isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    var Ctor = ctor();
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  }
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  function create(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) extendOwn(result, props);
	    return result;
	  }
	
	  // Create a (shallow-cloned) duplicate of an object.
	  function clone(obj) {
	    if (!isObject(obj)) return obj;
	    return isArray(obj) ? obj.slice() : extend({}, obj);
	  }
	
	  // Invokes `interceptor` with the `obj` and then returns `obj`.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  function tap(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  }
	
	  // Normalize a (deep) property `path` to array.
	  // Like `_.iteratee`, this function can be customized.
	  function toPath$1(path) {
	    return isArray(path) ? path : [path];
	  }
	  _$1.toPath = toPath$1;
	
	  // Internal wrapper for `_.toPath` to enable minification.
	  // Similar to `cb` for `_.iteratee`.
	  function toPath(path) {
	    return _$1.toPath(path);
	  }
	
	  // Internal function to obtain a nested property in `obj` along `path`.
	  function deepGet(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  }
	
	  // Get the value of the (deep) property on `path` from `object`.
	  // If any property in `path` does not exist or if the value is
	  // `undefined`, return `defaultValue` instead.
	  // The `path` is normalized through `_.toPath`.
	  function get(object, path, defaultValue) {
	    var value = deepGet(object, toPath(path));
	    return isUndefined(value) ? defaultValue : value;
	  }
	
	  // Shortcut function for checking if an object has a given property directly on
	  // itself (in other words, not on a prototype). Unlike the internal `has`
	  // function, this public version can also traverse nested properties.
	  function has(obj, path) {
	    path = toPath(path);
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (!has$1(obj, key)) return false;
	      obj = obj[key];
	    }
	    return !!length;
	  }
	
	  // Keep the identity function around for default iteratees.
	  function identity(value) {
	    return value;
	  }
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  function matcher(attrs) {
	    attrs = extendOwn({}, attrs);
	    return function(obj) {
	      return isMatch(obj, attrs);
	    };
	  }
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indices.
	  function property(path) {
	    path = toPath(path);
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  }
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  }
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `_.identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  function baseIteratee(value, context, argCount) {
	    if (value == null) return identity;
	    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
	    if (isObject(value) && !isArray(value)) return matcher(value);
	    return property(value);
	  }
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only `argCount` argument.
	  function iteratee(value, context) {
	    return baseIteratee(value, context, Infinity);
	  }
	  _$1.iteratee = iteratee;
	
	  // The function we call internally to generate a callback. It invokes
	  // `_.iteratee` if overridden, otherwise `baseIteratee`.
	  function cb(value, context, argCount) {
	    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
	    return baseIteratee(value, context, argCount);
	  }
	
	  // Returns the results of applying the `iteratee` to each element of `obj`.
	  // In contrast to `_.map` it returns an object.
	  function mapObject(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = keys(obj),
	        length = _keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function noop(){}
	
	  // Generates a function for a given object that returns a given property.
	  function propertyOf(obj) {
	    if (obj == null) return noop;
	    return function(path) {
	      return get(obj, path);
	    };
	  }
	
	  // Run a function **n** times.
	  function times(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  }
	
	  // Return a random integer between `min` and `max` (inclusive).
	  function random(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  }
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  var now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // Internal helper to generate functions for escaping and unescaping strings
	  // to/from HTML interpolation.
	  function createEscaper(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  }
	
	  // Internal list of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Function for escaping strings to HTML interpolation.
	  var _escape = createEscaper(escapeMap);
	
	  // Internal list of HTML entities for unescaping.
	  var unescapeMap = invert(escapeMap);
	
	  // Function for unescaping strings from HTML interpolation.
	  var _unescape = createEscaper(unescapeMap);
	
	  // By default, Underscore uses ERB-style template delimiters. Change the
	  // following template settings to use alternative delimiters.
	  var templateSettings = _$1.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `_.templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  function escapeChar(match) {
	    return '\\' + escapes[match];
	  }
	
	  // In order to prevent third-party code injection through
	  // `_.templateSettings.variable`, we test it against the following regular
	  // expression. It is intentionally a bit more liberal than just matching valid
	  // identifiers, but still prevents possible loopholes through defaults or
	  // destructuring assignment.
	  var bareIdentifier = /^\s*(\w|\$)+\s*$/;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  function template(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = defaults({}, settings, _$1.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    var argument = settings.variable;
	    if (argument) {
	      // Insure against third-party code injection. (CVE-2021-23358)
	      if (!bareIdentifier.test(argument)) throw new Error(
	        'variable is not a bare identifier: ' + argument
	      );
	    } else {
	      // If a variable is not specified, place data values in local scope.
	      source = 'with(obj||{}){\n' + source + '}\n';
	      argument = 'obj';
	    }
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(argument, '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _$1);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  }
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  function result(obj, path, fallback) {
	    path = toPath(path);
	    var length = path.length;
	    if (!length) {
	      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = isFunction$1(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  }
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  function uniqueId(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  }
	
	  // Start chaining a wrapped Underscore object.
	  function chain(obj) {
	    var instance = _$1(obj);
	    instance._chain = true;
	    return instance;
	  }
	
	  // Internal function to execute `sourceFunc` bound to `context` with optional
	  // `args`. Determines whether to execute a function as a constructor or as a
	  // normal function.
	  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (isObject(result)) return result;
	    return self;
	  }
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  var partial = restArguments(function(func, boundArgs) {
	    var placeholder = partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  partial.placeholder = _$1;
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally).
	  var bind = restArguments(function(func, context, args) {
	    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Internal helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var isArrayLike = createSizePropertyCheck(getLength);
	
	  // Internal implementation of a recursive `flatten` function.
	  function flatten$1(input, depth, strict, output) {
	    output = output || [];
	    if (!depth && depth !== 0) {
	      depth = Infinity;
	    } else if (depth <= 0) {
	      return output.concat(input);
	    }
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
	        // Flatten current level of array or arguments object.
	        if (depth > 1) {
	          flatten$1(value, depth - 1, strict, output);
	          idx = output.length;
	        } else {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  }
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  var bindAll = restArguments(function(obj, keys) {
	    keys = flatten$1(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = bind(obj[key], obj);
	    }
	    return obj;
	  });
	
	  // Memoize an expensive function by storing its results.
	  function memoize(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  }
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  var delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  var defer = partial(delay, _$1, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  function throttle(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var _now = now();
	      if (!previous && options.leading === false) previous = _now;
	      var remaining = wait - (_now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = _now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  }
	
	  // When a sequence of calls of the returned function ends, the argument
	  // function is triggered. The end of a sequence is defined by the `wait`
	  // parameter. If `immediate` is passed, the argument function will be
	  // triggered at the beginning of the sequence instead of at the end.
	  function debounce(func, wait, immediate) {
	    var timeout, previous, args, result, context;
	
	    var later = function() {
	      var passed = now() - previous;
	      if (wait > passed) {
	        timeout = setTimeout(later, wait - passed);
	      } else {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	        // This check is needed because `func` can recursively invoke `debounced`.
	        if (!timeout) args = context = null;
	      }
	    };
	
	    var debounced = restArguments(function(_args) {
	      context = this;
	      args = _args;
	      previous = now();
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	        if (immediate) result = func.apply(context, args);
	      }
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = args = context = null;
	    };
	
	    return debounced;
	  }
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  function wrap(func, wrapper) {
	    return partial(wrapper, func);
	  }
	
	  // Returns a negated version of the passed-in predicate.
	  function negate(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  }
	
	  // Returns a function that will only be executed on and after the Nth call.
	  function after(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  // Returns a function that will only be executed up to (but not including) the
	  // Nth call.
	  function before(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  }
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  var once = partial(before, 2);
	
	  // Returns the first key on an object that passes a truth test.
	  function findKey(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = keys(obj), key;
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      key = _keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  }
	
	  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a truth test.
	  var findIndex = createPredicateIndexFinder(1);
	
	  // Returns the last index on an array-like that passes a truth test.
	  var findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  function sortedIndex(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  }
	
	  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), isNaN$1);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  var indexOf = createIndexFinder(1, findIndex, sortedIndex);
	
	  // Return the position of the last occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  var lastIndexOf = createIndexFinder(-1, findLastIndex);
	
	  // Return the first value which passes a truth test.
	  function find(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  }
	
	  // Convenience version of a common use case of `_.find`: getting the first
	  // object containing specific `key:value` pairs.
	  function findWhere(obj, attrs) {
	    return find(obj, matcher(attrs));
	  }
	
	  // The cornerstone for collection functions, an `each`
	  // implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  function each(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var _keys = keys(obj);
	      for (i = 0, length = _keys.length; i < length; i++) {
	        iteratee(obj[_keys[i]], _keys[i], obj);
	      }
	    }
	    return obj;
	  }
	
	  // Return the results of applying the iteratee to each element.
	  function map(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Internal helper to create a reducing function, iterating left or right.
	  function createReduce(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var _keys = !isArrayLike(obj) && keys(obj),
	          length = (_keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[_keys ? _keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = _keys ? _keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  var reduce = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  var reduceRight = createReduce(-1);
	
	  // Return all the elements that pass a truth test.
	  function filter(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  }
	
	  // Return all the elements for which a truth test fails.
	  function reject(obj, predicate, context) {
	    return filter(obj, negate(cb(predicate)), context);
	  }
	
	  // Determine whether all of the elements pass a truth test.
	  function every(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  }
	
	  // Determine if at least one element in the object passes a truth test.
	  function some(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  }
	
	  // Determine if the array or object contains a given item (using `===`).
	  function contains(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return indexOf(obj, item, fromIndex) >= 0;
	  }
	
	  // Invoke a method (with arguments) on every item in a collection.
	  var invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (isFunction$1(path)) {
	      func = path;
	    } else {
	      path = toPath(path);
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `_.map`: fetching a property.
	  function pluck(obj, key) {
	    return map(obj, property(key));
	  }
	
	  // Convenience version of a common use case of `_.filter`: selecting only
	  // objects containing specific `key:value` pairs.
	  function where(obj, attrs) {
	    return filter(obj, matcher(attrs));
	  }
	
	  // Return the maximum element (or element-based computation).
	  function max(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Return the minimum element (or element-based computation).
	  function min(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `_.map`.
	  function sample(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = values(obj);
	      return obj[random(obj.length - 1)];
	    }
	    var sample = isArrayLike(obj) ? clone(obj) : values(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  }
	
	  // Shuffle a collection.
	  function shuffle(obj) {
	    return sample(obj, Infinity);
	  }
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  function sortBy(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return pluck(map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  }
	
	  // An internal function used for aggregate "group by" operations.
	  function group(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  }
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  var groupBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
	  // when you know that your index values will be unique.
	  var indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  var countBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Split a collection into two arrays: one whose elements all pass the given
	  // truth test, and one whose elements all do not pass the truth test.
	  var partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Safely create a real, live array from anything iterable.
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  function toArray(obj) {
	    if (!obj) return [];
	    if (isArray(obj)) return slice.call(obj);
	    if (isString(obj)) {
	      // Keep surrogate pair characters together.
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return map(obj, identity);
	    return values(obj);
	  }
	
	  // Return the number of elements in a collection.
	  function size(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : keys(obj).length;
	  }
	
	  // Internal `_.pick` helper function to determine whether `key` is an enumerable
	  // property name of `obj`.
	  function keyInObj(value, key, obj) {
	    return key in obj;
	  }
	
	  // Return a copy of the object only containing the allowed properties.
	  var pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (isFunction$1(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten$1(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the disallowed properties.
	  var omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (isFunction$1(iteratee)) {
	      iteratee = negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = map(flatten$1(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !contains(keys, key);
	      };
	    }
	    return pick(obj, iteratee, context);
	  });
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  function initial(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  }
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  function first(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return initial(array, array.length - n);
	  }
	
	  // Returns everything but the first entry of the `array`. Especially useful on
	  // the `arguments` object. Passing an **n** will return the rest N values in the
	  // `array`.
	  function rest(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  }
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  function last(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return rest(array, Math.max(0, array.length - n));
	  }
	
	  // Trim out all falsy values from an array.
	  function compact(array) {
	    return filter(array, Boolean);
	  }
	
	  // Flatten out an array, either recursively (by default), or up to `depth`.
	  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
	  function flatten(array, depth) {
	    return flatten$1(array, depth, false);
	  }
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  var difference = restArguments(function(array, rest) {
	    rest = flatten$1(rest, true, true);
	    return filter(array, function(value){
	      return !contains(rest, value);
	    });
	  });
	
	  // Return a version of the array that does not contain the specified value(s).
	  var without = restArguments(function(array, otherArrays) {
	    return difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  function uniq(array, isSorted, iteratee, context) {
	    if (!isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  var union = restArguments(function(arrays) {
	    return uniq(flatten$1(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  function intersection(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  }
	
	  // Complement of zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  function unzip(array) {
	    var length = array && max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = pluck(array, index);
	    }
	    return result;
	  }
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  var zip = restArguments(unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
	  function object(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  }
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](https://docs.python.org/library/functions.html#range).
	  function range(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  }
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  function chunk(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  }
	
	  // Helper function to continue chaining intermediate results.
	  function chainResult(instance, obj) {
	    return instance._chain ? _$1(obj).chain() : obj;
	  }
	
	  // Add your own custom functions to the Underscore object.
	  function mixin(obj) {
	    each(functions(obj), function(name) {
	      var func = _$1[name] = obj[name];
	      _$1.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_$1, args));
	      };
	    });
	    return _$1;
	  }
	
	  // Add all mutator `Array` functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) {
	        method.apply(obj, arguments);
	        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
	          delete obj[0];
	        }
	      }
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor `Array` functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) obj = method.apply(obj, arguments);
	      return chainResult(this, obj);
	    };
	  });
	
	  // Named Exports
	
	  var allExports = {
	    __proto__: null,
	    VERSION: VERSION,
	    restArguments: restArguments,
	    isObject: isObject,
	    isNull: isNull,
	    isUndefined: isUndefined,
	    isBoolean: isBoolean,
	    isElement: isElement,
	    isString: isString,
	    isNumber: isNumber,
	    isDate: isDate,
	    isRegExp: isRegExp,
	    isError: isError,
	    isSymbol: isSymbol,
	    isArrayBuffer: isArrayBuffer,
	    isDataView: isDataView$1,
	    isArray: isArray,
	    isFunction: isFunction$1,
	    isArguments: isArguments$1,
	    isFinite: isFinite$1,
	    isNaN: isNaN$1,
	    isTypedArray: isTypedArray$1,
	    isEmpty: isEmpty,
	    isMatch: isMatch,
	    isEqual: isEqual,
	    isMap: isMap,
	    isWeakMap: isWeakMap,
	    isSet: isSet,
	    isWeakSet: isWeakSet,
	    keys: keys,
	    allKeys: allKeys,
	    values: values,
	    pairs: pairs,
	    invert: invert,
	    functions: functions,
	    methods: functions,
	    extend: extend,
	    extendOwn: extendOwn,
	    assign: extendOwn,
	    defaults: defaults,
	    create: create,
	    clone: clone,
	    tap: tap,
	    get: get,
	    has: has,
	    mapObject: mapObject,
	    identity: identity,
	    constant: constant,
	    noop: noop,
	    toPath: toPath$1,
	    property: property,
	    propertyOf: propertyOf,
	    matcher: matcher,
	    matches: matcher,
	    times: times,
	    random: random,
	    now: now,
	    escape: _escape,
	    unescape: _unescape,
	    templateSettings: templateSettings,
	    template: template,
	    result: result,
	    uniqueId: uniqueId,
	    chain: chain,
	    iteratee: iteratee,
	    partial: partial,
	    bind: bind,
	    bindAll: bindAll,
	    memoize: memoize,
	    delay: delay,
	    defer: defer,
	    throttle: throttle,
	    debounce: debounce,
	    wrap: wrap,
	    negate: negate,
	    compose: compose,
	    after: after,
	    before: before,
	    once: once,
	    findKey: findKey,
	    findIndex: findIndex,
	    findLastIndex: findLastIndex,
	    sortedIndex: sortedIndex,
	    indexOf: indexOf,
	    lastIndexOf: lastIndexOf,
	    find: find,
	    detect: find,
	    findWhere: findWhere,
	    each: each,
	    forEach: each,
	    map: map,
	    collect: map,
	    reduce: reduce,
	    foldl: reduce,
	    inject: reduce,
	    reduceRight: reduceRight,
	    foldr: reduceRight,
	    filter: filter,
	    select: filter,
	    reject: reject,
	    every: every,
	    all: every,
	    some: some,
	    any: some,
	    contains: contains,
	    includes: contains,
	    include: contains,
	    invoke: invoke,
	    pluck: pluck,
	    where: where,
	    max: max,
	    min: min,
	    shuffle: shuffle,
	    sample: sample,
	    sortBy: sortBy,
	    groupBy: groupBy,
	    indexBy: indexBy,
	    countBy: countBy,
	    partition: partition,
	    toArray: toArray,
	    size: size,
	    pick: pick,
	    omit: omit,
	    first: first,
	    head: first,
	    take: first,
	    initial: initial,
	    last: last,
	    rest: rest,
	    tail: rest,
	    drop: rest,
	    compact: compact,
	    flatten: flatten,
	    without: without,
	    uniq: uniq,
	    unique: uniq,
	    union: union,
	    intersection: intersection,
	    difference: difference,
	    unzip: unzip,
	    transpose: unzip,
	    zip: zip,
	    object: object,
	    range: range,
	    chunk: chunk,
	    mixin: mixin,
	    'default': _$1
	  };
	
	  // Default Export
	
	  // Add all of the Underscore functions to the wrapper object.
	  var _ = mixin(allExports);
	  // Legacy Node.js API.
	  _._ = _;
	
	  return _;
	
	})));
	//# sourceMappingURL=underscore-umd.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["$"] = __webpack_require__(15);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v1.12.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:17Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var deletedIds = [];
	
	var document = window.document;
	
	var slice = deletedIds.slice;
	
	var concat = deletedIds.concat;
	
	var push = deletedIds.push;
	
	var indexOf = deletedIds.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "1.12.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1, IE<9
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: deletedIds.sort,
		splice: deletedIds.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var src, copyIsArray, copy, name, options, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		// See test/unit/core.js for details concerning isFunction.
		// Since version 1.3, DOM methods and functions like alert
		// aren't supported. They return false on IE (#2968).
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray || function( obj ) {
			return jQuery.type( obj ) === "array";
		},
	
		isWindow: function( obj ) {
			/* jshint eqeqeq: false */
			return obj != null && obj == obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Must be an Object.
			// Because of IE, we also have to check the presence of the constructor property.
			// Make sure that DOM nodes and window objects don't pass through, as well
			if ( !obj || jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			try {
	
				// Not own constructor property must be Object
				if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
					return false;
				}
			} catch ( e ) {
	
				// IE8,9 Will throw exceptions on certain host objects #9897
				return false;
			}
	
			// Support: IE<9
			// Handle iteration over inherited properties before own properties.
			if ( !support.ownFirst ) {
				for ( key in obj ) {
					return hasOwn.call( obj, key );
				}
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own.
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Workarounds based on findings by Jim Driscoll
		// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
		globalEval: function( data ) {
			if ( data && jQuery.trim( data ) ) {
	
				// We use execScript on Internet Explorer
				// We use an anonymous function so that context is window
				// rather than jQuery in Firefox
				( window.execScript || function( data ) {
					window[ "eval" ].call( window, data ); // jscs:ignore requireDotNotation
				} )( data );
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1, IE<9
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			var len;
	
			if ( arr ) {
				if ( indexOf ) {
					return indexOf.call( arr, elem, i );
				}
	
				len = arr.length;
				i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;
	
				for ( ; i < len; i++ ) {
	
					// Skip accessing in sparse arrays
					if ( i in arr && arr[ i ] === elem ) {
						return i;
					}
				}
			}
	
			return -1;
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			while ( j < len ) {
				first[ i++ ] = second[ j++ ];
			}
	
			// Support: IE<9
			// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
			if ( len !== len ) {
				while ( second[ j ] !== undefined ) {
					first[ i++ ] = second[ j++ ];
				}
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var args, proxy, tmp;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: function() {
			return +( new Date() );
		},
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = deletedIds[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( jQuery.inArray( elem, qualifier ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				ret = [],
				self = this,
				len = self.length;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// init accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector.charAt( 0 ) === "<" &&
					selector.charAt( selector.length - 1 ) === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document #6963
						if ( elem && elem.parentNode ) {
	
							// Handle the case where IE and Opera return items
							// by name instead of ID
							if ( elem.id !== match[ 2 ] ) {
								return rootjQuery.find( selector );
							}
	
							// Otherwise, we inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return typeof root.ready !== "undefined" ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var i,
				targets = jQuery( target, this ),
				len = targets.length;
	
			return this.filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within
		// the matched set of elements
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// index in selector
			if ( typeof elem === "string" ) {
				return jQuery.inArray( this[ 0 ], jQuery( elem ) );
			}
	
			// Locate the position of the desired element
			return jQuery.inArray(
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem, this );
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		do {
			cur = cur[ dir ];
		} while ( cur && cur.nodeType !== 1 );
	
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return jQuery.nodeName( elem, "iframe" ) ?
				elem.contentDocument || elem.contentWindow.document :
				jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var ret = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				ret = jQuery.filter( selector, ret );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					ret = jQuery.uniqueSort( ret );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					ret = ret.reverse();
				}
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = true;
					if ( !memory ) {
						self.disable();
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
	
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// if we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * Clean-up method for dom ready events
	 */
	function detach() {
		if ( document.addEventListener ) {
			document.removeEventListener( "DOMContentLoaded", completed );
			window.removeEventListener( "load", completed );
	
		} else {
			document.detachEvent( "onreadystatechange", completed );
			window.detachEvent( "onload", completed );
		}
	}
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
	
		// readyState === "complete" is good enough for us to call the dom ready in oldIE
		if ( document.addEventListener ||
			window.event.type === "load" ||
			document.readyState === "complete" ) {
	
			detach();
			jQuery.ready();
		}
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE6-10
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			// Standards-based browsers support DOMContentLoaded
			} else if ( document.addEventListener ) {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
	
			// If IE event model is used
			} else {
	
				// Ensure firing before onload, maybe late but safe also for iframes
				document.attachEvent( "onreadystatechange", completed );
	
				// A fallback to window.onload, that will always work
				window.attachEvent( "onload", completed );
	
				// If IE and not a frame
				// continually check to see if the document is ready
				var top = false;
	
				try {
					top = window.frameElement == null && document.documentElement;
				} catch ( e ) {}
	
				if ( top && top.doScroll ) {
					( function doScrollCheck() {
						if ( !jQuery.isReady ) {
	
							try {
	
								// Use the trick by Diego Perini
								// http://javascript.nwbox.com/IEContentLoaded/
								top.doScroll( "left" );
							} catch ( e ) {
								return window.setTimeout( doScrollCheck, 50 );
							}
	
							// detach all dom ready events
							detach();
	
							// and execute any waiting functions
							jQuery.ready();
						}
					} )();
				}
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Support: IE<9
	// Iteration over object's inherited properties before its own
	var i;
	for ( i in jQuery( support ) ) {
		break;
	}
	support.ownFirst = i === "0";
	
	// Note: most support tests are defined in their respective modules.
	// false until the test is run
	support.inlineBlockNeedsLayout = false;
	
	// Execute ASAP in case we need to set body.style.zoom
	jQuery( function() {
	
		// Minified: var a,b,c,d
		var val, div, body, container;
	
		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {
	
			// Return for frameset docs that don't have a body
			return;
		}
	
		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );
	
		if ( typeof div.style.zoom !== "undefined" ) {
	
			// Support: IE<8
			// Check if natively block-level elements act like inline-block
			// elements when setting their display to 'inline' and giving
			// them layout
			div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";
	
			support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
			if ( val ) {
	
				// Prevent IE 6 from affecting layout for positioned elements #11048
				// Prevent IE from shrinking the body in IE 7 mode #12869
				// Support: IE<8
				body.style.zoom = 1;
			}
		}
	
		body.removeChild( container );
	} );
	
	
	( function() {
		var div = document.createElement( "div" );
	
		// Support: IE<9
		support.deleteExpando = true;
		try {
			delete div.test;
		} catch ( e ) {
			support.deleteExpando = false;
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	} )();
	var acceptData = function( elem ) {
		var noData = jQuery.noData[ ( elem.nodeName + " " ).toLowerCase() ],
			nodeType = +elem.nodeType || 1;
	
		// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
		return nodeType !== 1 && nodeType !== 9 ?
			false :
	
			// Nodes accept data unless otherwise specified; rejection can be conditional
			!noData || noData !== true && elem.getAttribute( "classid" ) === noData;
	};
	
	
	
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /([A-Z])/g;
	
	function dataAttr( elem, key, data ) {
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
	
			var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
	
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				jQuery.data( elem, key, data );
	
			} else {
				data = undefined;
			}
		}
	
		return data;
	}
	
	// checks a cache object for emptiness
	function isEmptyDataObject( obj ) {
		var name;
		for ( name in obj ) {
	
			// if the public data object is empty, the private is still empty
			if ( name === "data" && jQuery.isEmptyObject( obj[ name ] ) ) {
				continue;
			}
			if ( name !== "toJSON" ) {
				return false;
			}
		}
	
		return true;
	}
	
	function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
		if ( !acceptData( elem ) ) {
			return;
		}
	
		var ret, thisCache,
			internalKey = jQuery.expando,
	
			// We have to handle DOM nodes and JS objects differently because IE6-7
			// can't GC object references properly across the DOM-JS boundary
			isNode = elem.nodeType,
	
			// Only DOM nodes need the global jQuery cache; JS object data is
			// attached directly to the object so GC can occur automatically
			cache = isNode ? jQuery.cache : elem,
	
			// Only defining an ID for JS objects if its cache already exists allows
			// the code to shortcut on the same path as a DOM node with no cache
			id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;
	
		// Avoid doing any more work than we need to when trying to get data on an
		// object that has no data at all
		if ( ( !id || !cache[ id ] || ( !pvt && !cache[ id ].data ) ) &&
			data === undefined && typeof name === "string" ) {
			return;
		}
	
		if ( !id ) {
	
			// Only DOM nodes need a new unique ID for each element since their data
			// ends up in the global cache
			if ( isNode ) {
				id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
			} else {
				id = internalKey;
			}
		}
	
		if ( !cache[ id ] ) {
	
			// Avoid exposing jQuery metadata on plain JS objects when the object
			// is serialized using JSON.stringify
			cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
		}
	
		// An object can be passed to jQuery.data instead of a key/value pair; this gets
		// shallow copied over onto the existing cache
		if ( typeof name === "object" || typeof name === "function" ) {
			if ( pvt ) {
				cache[ id ] = jQuery.extend( cache[ id ], name );
			} else {
				cache[ id ].data = jQuery.extend( cache[ id ].data, name );
			}
		}
	
		thisCache = cache[ id ];
	
		// jQuery data() is stored in a separate object inside the object's internal data
		// cache in order to avoid key collisions between internal data and user-defined
		// data.
		if ( !pvt ) {
			if ( !thisCache.data ) {
				thisCache.data = {};
			}
	
			thisCache = thisCache.data;
		}
	
		if ( data !== undefined ) {
			thisCache[ jQuery.camelCase( name ) ] = data;
		}
	
		// Check for both converted-to-camel and non-converted data property names
		// If a data property was specified
		if ( typeof name === "string" ) {
	
			// First Try to find as-is property data
			ret = thisCache[ name ];
	
			// Test for null|undefined property data
			if ( ret == null ) {
	
				// Try to find the camelCased property
				ret = thisCache[ jQuery.camelCase( name ) ];
			}
		} else {
			ret = thisCache;
		}
	
		return ret;
	}
	
	function internalRemoveData( elem, name, pvt ) {
		if ( !acceptData( elem ) ) {
			return;
		}
	
		var thisCache, i,
			isNode = elem.nodeType,
	
			// See jQuery.data for more information
			cache = isNode ? jQuery.cache : elem,
			id = isNode ? elem[ jQuery.expando ] : jQuery.expando;
	
		// If there is already no cache entry for this object, there is no
		// purpose in continuing
		if ( !cache[ id ] ) {
			return;
		}
	
		if ( name ) {
	
			thisCache = pvt ? cache[ id ] : cache[ id ].data;
	
			if ( thisCache ) {
	
				// Support array or space separated string names for data keys
				if ( !jQuery.isArray( name ) ) {
	
					// try the string as a key before any manipulation
					if ( name in thisCache ) {
						name = [ name ];
					} else {
	
						// split the camel cased version by spaces unless a key with the spaces exists
						name = jQuery.camelCase( name );
						if ( name in thisCache ) {
							name = [ name ];
						} else {
							name = name.split( " " );
						}
					}
				} else {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = name.concat( jQuery.map( name, jQuery.camelCase ) );
				}
	
				i = name.length;
				while ( i-- ) {
					delete thisCache[ name[ i ] ];
				}
	
				// If there is no data left in the cache, we want to continue
				// and let the cache object itself get destroyed
				if ( pvt ? !isEmptyDataObject( thisCache ) : !jQuery.isEmptyObject( thisCache ) ) {
					return;
				}
			}
		}
	
		// See jQuery.data for more information
		if ( !pvt ) {
			delete cache[ id ].data;
	
			// Don't destroy the parent cache unless the internal data object
			// had been the only thing left in it
			if ( !isEmptyDataObject( cache[ id ] ) ) {
				return;
			}
		}
	
		// Destroy the cache
		if ( isNode ) {
			jQuery.cleanData( [ elem ], true );
	
		// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
		/* jshint eqeqeq: false */
		} else if ( support.deleteExpando || cache != cache.window ) {
			/* jshint eqeqeq: true */
			delete cache[ id ];
	
		// When all else fails, undefined
		} else {
			cache[ id ] = undefined;
		}
	}
	
	jQuery.extend( {
		cache: {},
	
		// The following elements (space-suffixed to avoid Object.prototype collisions)
		// throw uncatchable exceptions if you attempt to set expando properties
		noData: {
			"applet ": true,
			"embed ": true,
	
			// ...but Flash objects (which have this classid) *can* handle expandos
			"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
		},
	
		hasData: function( elem ) {
			elem = elem.nodeType ? jQuery.cache[ elem[ jQuery.expando ] ] : elem[ jQuery.expando ];
			return !!elem && !isEmptyDataObject( elem );
		},
	
		data: function( elem, name, data ) {
			return internalData( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			return internalRemoveData( elem, name );
		},
	
		// For internal use only.
		_data: function( elem, name, data ) {
			return internalData( elem, name, data, true );
		},
	
		_removeData: function( elem, name ) {
			return internalRemoveData( elem, name, true );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Special expections of .data basically thwart jQuery.access,
			// so implement the relevant behavior ourselves
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = jQuery.data( elem );
	
					if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						jQuery._data( elem, "parsedAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					jQuery.data( this, key );
				} );
			}
	
			return arguments.length > 1 ?
	
				// Sets one value
				this.each( function() {
					jQuery.data( this, key, value );
				} ) :
	
				// Gets one value
				// Try to fetch any internally stored data first
				elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
		},
	
		removeData: function( key ) {
			return this.each( function() {
				jQuery.removeData( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = jQuery._data( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = jQuery._data( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// not intended for public consumption - generates a queueHooks object,
		// or returns the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return jQuery._data( elem, key ) || jQuery._data( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					jQuery._removeData( elem, type + "queue" );
					jQuery._removeData( elem, key );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = jQuery._data( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	
	
	( function() {
		var shrinkWrapBlocksVal;
	
		support.shrinkWrapBlocks = function() {
			if ( shrinkWrapBlocksVal != null ) {
				return shrinkWrapBlocksVal;
			}
	
			// Will be changed later if needed.
			shrinkWrapBlocksVal = false;
	
			// Minified: var b,c,d
			var div, body, container;
	
			body = document.getElementsByTagName( "body" )[ 0 ];
			if ( !body || !body.style ) {
	
				// Test fired too early or in an unsupported environment, exit.
				return;
			}
	
			// Setup
			div = document.createElement( "div" );
			container = document.createElement( "div" );
			container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
			body.appendChild( container ).appendChild( div );
	
			// Support: IE6
			// Check if elements with layout shrink-wrap their children
			if ( typeof div.style.zoom !== "undefined" ) {
	
				// Reset CSS: box-sizing; display; margin; border
				div.style.cssText =
	
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;" +
					"padding:1px;width:1px;zoom:1";
				div.appendChild( document.createElement( "div" ) ).style.width = "5px";
				shrinkWrapBlocksVal = div.offsetWidth !== 3;
			}
	
			body.removeChild( container );
	
			return shrinkWrapBlocksVal;
		};
	
	} )();
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			length = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < length; i++ ) {
					fn(
						elems[ i ],
						key,
						raw ? value : value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				length ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	var rleadingWhitespace = ( /^\s+/ );
	
	var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|" +
			"details|dialog|figcaption|figure|footer|header|hgroup|main|" +
			"mark|meter|nav|output|picture|progress|section|summary|template|time|video";
	
	
	
	function createSafeFragment( document ) {
		var list = nodeNames.split( "|" ),
			safeFrag = document.createDocumentFragment();
	
		if ( safeFrag.createElement ) {
			while ( list.length ) {
				safeFrag.createElement(
					list.pop()
				);
			}
		}
		return safeFrag;
	}
	
	
	( function() {
		var div = document.createElement( "div" ),
			fragment = document.createDocumentFragment(),
			input = document.createElement( "input" );
	
		// Setup
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	
		// IE strips leading whitespace when .innerHTML is used
		support.leadingWhitespace = div.firstChild.nodeType === 3;
	
		// Make sure that tbody elements aren't automatically inserted
		// IE will insert them into empty tables
		support.tbody = !div.getElementsByTagName( "tbody" ).length;
	
		// Make sure that link elements get serialized correctly by innerHTML
		// This requires a wrapper element in IE
		support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;
	
		// Makes sure cloning an html5 element does not cause problems
		// Where outerHTML is undefined, this still works
		support.html5Clone =
			document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";
	
		// Check if a disconnected checkbox will retain its checked
		// value of true after appended to the DOM (IE6/7)
		input.type = "checkbox";
		input.checked = true;
		fragment.appendChild( input );
		support.appendChecked = input.checked;
	
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		// Support: IE6-IE11+
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// #11217 - WebKit loses check when the name is after the checked attribute
		fragment.appendChild( div );
	
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input = document.createElement( "input" );
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
		// old WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<9
		// Cloned elements keep attachEvent handlers, we use addEventListener on IE9+
		support.noCloneEvent = !!div.addEventListener;
	
		// Support: IE<9
		// Since attributes and properties are the same in IE,
		// cleanData must set properties to undefined rather than use removeAttribute
		div[ jQuery.expando ] = 1;
		support.attributes = !div.getAttribute( jQuery.expando );
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
		legend: [ 1, "<fieldset>", "</fieldset>" ],
		area: [ 1, "<map>", "</map>" ],
	
		// Support: IE8
		param: [ 1, "<object>", "</object>" ],
		thead: [ 1, "<table>", "</table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
		// unless wrapped in a div with non-breaking characters in front of it.
		_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>" ]
	};
	
	// Support: IE8-IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
		var elems, elem,
			i = 0,
			found = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
					undefined;
	
		if ( !found ) {
			for ( found = [], elems = context.childNodes || context;
				( elem = elems[ i ] ) != null;
				i++
			) {
				if ( !tag || jQuery.nodeName( elem, tag ) ) {
					found.push( elem );
				} else {
					jQuery.merge( found, getAll( elem, tag ) );
				}
			}
		}
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], found ) :
			found;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var elem,
			i = 0;
		for ( ; ( elem = elems[ i ] ) != null; i++ ) {
			jQuery._data(
				elem,
				"globalEval",
				!refElements || jQuery._data( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/,
		rtbody = /<tbody/i;
	
	function fixDefaultChecked( elem ) {
		if ( rcheckableType.test( elem.type ) ) {
			elem.defaultChecked = elem.checked;
		}
	}
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var j, elem, contains,
			tmp, tag, tbody, wrap,
			l = elems.length,
	
			// Ensure a safe fragment
			safe = createSafeFragment( context ),
	
			nodes = [],
			i = 0;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || safe.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
	
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Manually add leading whitespace removed by IE
					if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
						nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[ 0 ] ) );
					}
	
					// Remove IE's autoinserted <tbody> from table fragments
					if ( !support.tbody ) {
	
						// String was a <table>, *may* have spurious <tbody>
						elem = tag === "table" && !rtbody.test( elem ) ?
							tmp.firstChild :
	
							// String was a bare <thead> or <tfoot>
							wrap[ 1 ] === "<table>" && !rtbody.test( elem ) ?
								tmp :
								0;
	
						j = elem && elem.childNodes.length;
						while ( j-- ) {
							if ( jQuery.nodeName( ( tbody = elem.childNodes[ j ] ), "tbody" ) &&
								!tbody.childNodes.length ) {
	
								elem.removeChild( tbody );
							}
						}
					}
	
					jQuery.merge( nodes, tmp.childNodes );
	
					// Fix #12392 for WebKit and IE > 9
					tmp.textContent = "";
	
					// Fix #12392 for oldIE
					while ( tmp.firstChild ) {
						tmp.removeChild( tmp.firstChild );
					}
	
					// Remember the top-level container for proper cleanup
					tmp = safe.lastChild;
				}
			}
		}
	
		// Fix #11356: Clear elements from fragment
		if ( tmp ) {
			safe.removeChild( tmp );
		}
	
		// Reset defaultChecked for any radios and checkboxes
		// about to be appended to the DOM in IE 6/7 (#8060)
		if ( !support.appendChecked ) {
			jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
		}
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
	
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( safe.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		tmp = null;
	
		return safe;
	}
	
	
	( function() {
		var i, eventName,
			div = document.createElement( "div" );
	
		// Support: IE<9 (lack submit/change bubble), Firefox (lack focus(in | out) events)
		for ( i in { submit: true, change: true, focusin: true } ) {
			eventName = "on" + i;
	
			if ( !( support[ i ] = eventName in window ) ) {
	
				// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
				div.setAttribute( eventName, "t" );
				support[ i ] = div.attributes[ eventName ].expando === false;
			}
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	} )();
	
	
	var rformElems = /^(?:input|select|textarea)$/i,
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
			var tmp, events, t, handleObjIn,
				special, eventHandle, handleObj,
				handlers, type, namespaces, origType,
				elemData = jQuery._data( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" &&
						( !e || jQuery.event.triggered !== e.type ) ?
						jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
						undefined;
				};
	
				// Add elem as a property of the handle fn to prevent a memory leak
				// with IE non-native events
				eventHandle.elem = elem;
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener/attachEvent if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						// Bind the global event handler to the element
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle, false );
	
						} else if ( elem.attachEvent ) {
							elem.attachEvent( "on" + type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
			// Nullify elem to prevent memory leaks in IE
			elem = null;
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
			var j, handleObj, tmp,
				origCount, t, events,
				special, handlers, type,
				namespaces, origType,
				elemData = jQuery.hasData( elem ) && jQuery._data( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				delete elemData.handle;
	
				// removeData also checks for emptiness and clears the expando if empty
				// so use it instead of delete
				jQuery._removeData( elem, "events" );
			}
		},
	
		trigger: function( event, data, elem, onlyHandlers ) {
			var handle, ontype, cur,
				bubbleType, special, tmp, i,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] &&
					jQuery._data( cur, "handle" );
	
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if (
					( !special._default ||
					 special._default.apply( eventPath.pop(), data ) === false
					) && acceptData( elem )
				) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Can't use an .isFunction() check here because IE6/7 fails that test.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						try {
							elem[ type ]();
						} catch ( e ) {
	
							// IE<9 dies on focus/blur to hidden element (#1486,#12518)
							// only reproducible on winXP IE8 native, not IE9 in IE8 mode
						}
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				/* jshint eqeqeq: false */
				for ( ; cur != this; cur = cur.parentNode || this ) {
					/* jshint eqeqeq: true */
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: IE<9
			// Fix target property (#1925)
			if ( !event.target ) {
				event.target = originalEvent.srcElement || document;
			}
	
			// Support: Safari 6-8+
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			// Support: IE<9
			// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
			event.metaKey = !!event.metaKey;
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY fromElement offsetX offsetY " +
				"pageX pageY screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var body, eventDoc, doc,
					button = original.button,
					fromElement = original.fromElement;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add relatedTarget, if necessary
				if ( !event.relatedTarget && fromElement ) {
					event.relatedTarget = fromElement === event.target ?
						original.toElement :
						fromElement;
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						try {
							this.focus();
							return false;
						} catch ( e ) {
	
							// Support: IE<9
							// If we error on focus to hidden element (#1486, #12518),
							// let .trigger() run the handlers
						}
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		},
	
		// Piggyback on a donor event to simulate a different one
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
	
					// Previously, `originalEvent: {}` was set here, so stopPropagation call
					// would not be triggered on donor event, since in our own
					// jQuery.event.stopPropagation function we had a check for existence of
					// originalEvent.stopPropagation method, so, consequently it would be a noop.
					//
					// Guard for simulated events was moved to jQuery.event.stopPropagation function
					// since `originalEvent` should point to the original event for the
					// constancy with other events and for more focused logic
				}
			);
	
			jQuery.event.trigger( e, null, elem );
	
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	};
	
	jQuery.removeEvent = document.removeEventListener ?
		function( elem, type, handle ) {
	
			// This "if" is needed for plain objects
			if ( elem.removeEventListener ) {
				elem.removeEventListener( type, handle );
			}
		} :
		function( elem, type, handle ) {
			var name = "on" + type;
	
			if ( elem.detachEvent ) {
	
				// #8545, #7054, preventing memory leaks for custom events in IE6-8
				// detachEvent needed property on element, by name of that event,
				// to properly expose it to GC
				if ( typeof elem[ name ] === "undefined" ) {
					elem[ name ] = null;
				}
	
				elem.detachEvent( name, handle );
			}
		};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: IE < 9, Android < 4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
			if ( !e ) {
				return;
			}
	
			// If preventDefault exists, run it on the original event
			if ( e.preventDefault ) {
				e.preventDefault();
	
			// Support: IE
			// Otherwise set the returnValue property of the original event to false
			} else {
				e.returnValue = false;
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( !e || this.isSimulated ) {
				return;
			}
	
			// If stopPropagation exists, run it on the original event
			if ( e.stopPropagation ) {
				e.stopPropagation();
			}
	
			// Support: IE
			// Set the cancelBubble property of the original event to true
			e.cancelBubble = true;
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && e.stopImmediatePropagation ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	// IE submit delegation
	if ( !support.submit ) {
	
		jQuery.event.special.submit = {
			setup: function() {
	
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Lazy-add a submit handler when a descendant form may potentially be submitted
				jQuery.event.add( this, "click._submit keypress._submit", function( e ) {
	
					// Node name check avoids a VML-related crash in IE (#9807)
					var elem = e.target,
						form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ?
	
							// Support: IE <=8
							// We use jQuery.prop instead of elem.form
							// to allow fixing the IE8 delegated submit issue (gh-2332)
							// by 3rd party polyfills/workarounds.
							jQuery.prop( elem, "form" ) :
							undefined;
	
					if ( form && !jQuery._data( form, "submit" ) ) {
						jQuery.event.add( form, "submit._submit", function( event ) {
							event._submitBubble = true;
						} );
						jQuery._data( form, "submit", true );
					}
				} );
	
				// return undefined since we don't need an event listener
			},
	
			postDispatch: function( event ) {
	
				// If form was submitted by the user, bubble the event up the tree
				if ( event._submitBubble ) {
					delete event._submitBubble;
					if ( this.parentNode && !event.isTrigger ) {
						jQuery.event.simulate( "submit", this.parentNode, event );
					}
				}
			},
	
			teardown: function() {
	
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
				jQuery.event.remove( this, "._submit" );
			}
		};
	}
	
	// IE change delegation and checkbox/radio fix
	if ( !support.change ) {
	
		jQuery.event.special.change = {
	
			setup: function() {
	
				if ( rformElems.test( this.nodeName ) ) {
	
					// IE doesn't fire change on a check/radio until blur; trigger it on click
					// after a propertychange. Eat the blur-change in special.change.handle.
					// This still fires onchange a second time for check/radio after blur.
					if ( this.type === "checkbox" || this.type === "radio" ) {
						jQuery.event.add( this, "propertychange._change", function( event ) {
							if ( event.originalEvent.propertyName === "checked" ) {
								this._justChanged = true;
							}
						} );
						jQuery.event.add( this, "click._change", function( event ) {
							if ( this._justChanged && !event.isTrigger ) {
								this._justChanged = false;
							}
	
							// Allow triggered, simulated change events (#11500)
							jQuery.event.simulate( "change", this, event );
						} );
					}
					return false;
				}
	
				// Delegated event; lazy-add a change handler on descendant inputs
				jQuery.event.add( this, "beforeactivate._change", function( e ) {
					var elem = e.target;
	
					if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "change" ) ) {
						jQuery.event.add( elem, "change._change", function( event ) {
							if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
								jQuery.event.simulate( "change", this.parentNode, event );
							}
						} );
						jQuery._data( elem, "change", true );
					}
				} );
			},
	
			handle: function( event ) {
				var elem = event.target;
	
				// Swallow native change events from checkbox/radio, we already triggered them above
				if ( this !== elem || event.isSimulated || event.isTrigger ||
					( elem.type !== "radio" && elem.type !== "checkbox" ) ) {
	
					return event.handleObj.handler.apply( this, arguments );
				}
			},
	
			teardown: function() {
				jQuery.event.remove( this, "._change" );
	
				return !rformElems.test( this.nodeName );
			}
		};
	}
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						jQuery._removeData( doc, fix );
					} else {
						jQuery._data( doc, fix, attaches );
					}
				}
			};
		} );
	}
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		},
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
		rnoshimcache = new RegExp( "<(?:" + nodeNames + ")[\\s/>]", "i" ),
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
		safeFragment = createSafeFragment( document ),
		fragmentDiv = safeFragment.appendChild( document.createElement( "div" ) );
	
	// Support: IE<8
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( jQuery.find.attr( elem, "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
			return;
		}
	
		var type, i, l,
			oldData = jQuery._data( src ),
			curData = jQuery._data( dest, oldData ),
			events = oldData.events;
	
		if ( events ) {
			delete curData.handle;
			curData.events = {};
	
			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	
		// make the cloned public data object a copy from the original
		if ( curData.data ) {
			curData.data = jQuery.extend( {}, curData.data );
		}
	}
	
	function fixCloneNodeIssues( src, dest ) {
		var nodeName, e, data;
	
		// We do not need to do anything for non-Elements
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		nodeName = dest.nodeName.toLowerCase();
	
		// IE6-8 copies events bound via attachEvent when using cloneNode.
		if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
			data = jQuery._data( dest );
	
			for ( e in data.events ) {
				jQuery.removeEvent( dest, e, data.handle );
			}
	
			// Event data gets referenced instead of copied if the expando gets copied too
			dest.removeAttribute( jQuery.expando );
		}
	
		// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
		if ( nodeName === "script" && dest.text !== src.text ) {
			disableScript( dest ).text = src.text;
			restoreScript( dest );
	
		// IE6-10 improperly clones children of object elements using classid.
		// IE10 throws NoModificationAllowedError if parent is null, #12132.
		} else if ( nodeName === "object" ) {
			if ( dest.parentNode ) {
				dest.outerHTML = src.outerHTML;
			}
	
			// This path appears unavoidable for IE9. When cloning an object
			// element in IE9, the outerHTML strategy above is not sufficient.
			// If the src has innerHTML and the destination does not,
			// copy the src.innerHTML into the dest.innerHTML. #10324
			if ( support.html5Clone && ( src.innerHTML && !jQuery.trim( dest.innerHTML ) ) ) {
				dest.innerHTML = src.innerHTML;
			}
	
		} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
	
			// IE6-8 fails to persist the checked state of a cloned checkbox
			// or radio button. Worse, IE6-7 fail to give the cloned element
			// a checked appearance if the defaultChecked value isn't also set
	
			dest.defaultChecked = dest.checked = src.checked;
	
			// IE6-7 get confused and end up setting the value of a cloned
			// checkbox/radio button to an empty string instead of "on"
			if ( dest.value !== src.value ) {
				dest.value = src.value;
			}
	
		// IE6-8 fails to return the selected option to the default selected
		// state when cloning options
		} else if ( nodeName === "option" ) {
			dest.defaultSelected = dest.selected = src.defaultSelected;
	
		// IE6-8 fails to set the defaultValue to the correct value when
		// cloning other types of input fields
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var first, node, hasScripts,
			scripts, doc, fragment,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!jQuery._data( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval(
									( node.text || node.textContent || node.innerHTML || "" )
										.replace( rcleanScript, "" )
								);
							}
						}
					}
				}
	
				// Fix #11809: Avoid leaking memory
				fragment = first = null;
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			elems = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = elems[ i ] ) != null; i++ ) {
	
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var destElements, node, clone, i, srcElements,
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			if ( support.html5Clone || jQuery.isXMLDoc( elem ) ||
				!rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {
	
				clone = elem.cloneNode( true );
	
			// IE<=8 does not properly clone detached, unknown element nodes
			} else {
				fragmentDiv.innerHTML = elem.outerHTML;
				fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
			}
	
			if ( ( !support.noCloneEvent || !support.noCloneChecked ) &&
					( elem.nodeType === 1 || elem.nodeType === 11 ) && !jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				// Fix all IE cloning issues
				for ( i = 0; ( node = srcElements[ i ] ) != null; ++i ) {
	
					// Ensure that the destination node is not null; Fixes #9587
					if ( destElements[ i ] ) {
						fixCloneNodeIssues( node, destElements[ i ] );
					}
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0; ( node = srcElements[ i ] ) != null; i++ ) {
						cloneCopyEvent( node, destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			destElements = srcElements = node = null;
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems, /* internal */ forceAcceptData ) {
			var elem, type, id, data,
				i = 0,
				internalKey = jQuery.expando,
				cache = jQuery.cache,
				attributes = support.attributes,
				special = jQuery.event.special;
	
			for ( ; ( elem = elems[ i ] ) != null; i++ ) {
				if ( forceAcceptData || acceptData( elem ) ) {
	
					id = elem[ internalKey ];
					data = id && cache[ id ];
	
					if ( data ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Remove cache only if it was not already removed by jQuery.event.remove
						if ( cache[ id ] ) {
	
							delete cache[ id ];
	
							// Support: IE<9
							// IE does not allow us to delete expando properties from nodes
							// IE creates expando attributes along with the property
							// IE does not have a removeAttribute function on Document nodes
							if ( !attributes && typeof elem.removeAttribute !== "undefined" ) {
								elem.removeAttribute( internalKey );
	
							// Webkit & Blink performance suffers when deleting properties
							// from DOM nodes, so set to undefined instead
							// https://code.google.com/p/chromium/issues/detail?id=378607
							} else {
								elem[ internalKey ] = undefined;
							}
	
							deletedIds.push( id );
						}
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().append(
						( this[ 0 ] && this[ 0 ].ownerDocument || document ).createTextNode( value )
					);
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
	
				// Remove element nodes and prevent memory leaks
				if ( elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem, false ) );
				}
	
				// Remove any remaining nodes
				while ( elem.firstChild ) {
					elem.removeChild( elem.firstChild );
				}
	
				// If this is a select, ensure that it displays empty (#12336)
				// Support: IE<9
				if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
					elem.options.length = 0;
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined ) {
					return elem.nodeType === 1 ?
						elem.innerHTML.replace( rinlinejQuery, "" ) :
						undefined;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
					( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
	
							// Remove element nodes and prevent memory leaks
							elem = this[ i ] || {};
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				i = 0,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, pixelMarginRightVal, boxSizingReliableVal,
			reliableHiddenOffsetsVal, reliableMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		div.style.cssText = "float:left;opacity:.5";
	
		// Support: IE<9
		// Make sure that element opacity exists (as opposed to filter)
		support.opacity = div.style.opacity === "0.5";
	
		// Verify style float existence
		// (IE uses styleFloat instead of cssFloat)
		support.cssFloat = !!div.style.cssFloat;
	
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container = document.createElement( "div" );
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		div.innerHTML = "";
		container.appendChild( div );
	
		// Support: Firefox<29, Android 2.3
		// Vendor-prefix box-sizing
		support.boxSizing = div.style.boxSizing === "" || div.style.MozBoxSizing === "" ||
			div.style.WebkitBoxSizing === "";
	
		jQuery.extend( support, {
			reliableHiddenOffsets: function() {
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableHiddenOffsetsVal;
			},
	
			boxSizingReliable: function() {
	
				// We're checking for pixelPositionVal here instead of boxSizingReliableVal
				// since that compresses better and they're computed together anyway.
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
	
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
	
			pixelPosition: function() {
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return pixelPositionVal;
			},
	
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableMarginRightVal;
			},
	
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			}
		} );
	
		function computeStyleTests() {
			var contents, divStyle,
				documentElement = document.documentElement;
	
			// Setup
			documentElement.appendChild( container );
	
			div.style.cssText =
	
				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
	
			// Support: IE<9
			// Assume reasonable values in the absence of getComputedStyle
			pixelPositionVal = boxSizingReliableVal = reliableMarginLeftVal = false;
			pixelMarginRightVal = reliableMarginRightVal = true;
	
			// Check for getComputedStyle so that this code is not run in IE<9.
			if ( window.getComputedStyle ) {
				divStyle = window.getComputedStyle( div );
				pixelPositionVal = ( divStyle || {} ).top !== "1%";
				reliableMarginLeftVal = ( divStyle || {} ).marginLeft === "2px";
				boxSizingReliableVal = ( divStyle || { width: "4px" } ).width === "4px";
	
				// Support: Android 4.0 - 4.3 only
				// Some styles come back with percentage values, even though they shouldn't
				div.style.marginRight = "50%";
				pixelMarginRightVal = ( divStyle || { marginRight: "4px" } ).marginRight === "4px";
	
				// Support: Android 2.3 only
				// Div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				contents = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				contents.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				contents.style.marginRight = contents.style.width = "0";
				div.style.width = "1px";
	
				reliableMarginRightVal =
					!parseFloat( ( window.getComputedStyle( contents ) || {} ).marginRight );
	
				div.removeChild( contents );
			}
	
			// Support: IE6-8
			// First check that getClientRects works as expected
			// Check if table cells still have offsetWidth/Height when they are set
			// to display:none and there are still other visible table cells in a
			// table row; if so, offsetWidth/Height are not reliable for use when
			// determining if an element has been hidden directly using
			// display:none (it is still safe to use offsets if a parent element is
			// hidden; don safety goggles and see bug #4512 for more information).
			div.style.display = "none";
			reliableHiddenOffsetsVal = div.getClientRects().length === 0;
			if ( reliableHiddenOffsetsVal ) {
				div.style.display = "";
				div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
				div.childNodes[ 0 ].style.borderCollapse = "separate";
				contents = div.getElementsByTagName( "td" );
				contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
				reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
				if ( reliableHiddenOffsetsVal ) {
					contents[ 0 ].style.display = "";
					contents[ 1 ].style.display = "none";
					reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
				}
			}
	
			// Teardown
			documentElement.removeChild( container );
		}
	
	} )();
	
	
	var getStyles, curCSS,
		rposition = /^(top|right|bottom|left)$/;
	
	if ( window.getComputedStyle ) {
		getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
		curCSS = function( elem, name, computed ) {
			var width, minWidth, maxWidth, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
	
			// getPropertyValue is only needed for .css('filter') in IE9, see #12537
			ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
			// Support: Opera 12.1x only
			// Fall back to style even without computed
			// computed is undefined for elems on document fragments
			if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			if ( computed ) {
	
				// A tribute to the "awesome hack by Dean Edwards"
				// Chrome < 17 and Safari 5.0 uses "computed value"
				// instead of "used value" for margin-right
				// Safari 5.1.7 (at least) returns percentage for a larger set of values,
				// but width seems to be reliably pixels
				// this is against the CSSOM draft spec:
				// http://dev.w3.org/csswg/cssom/#resolved-values
				if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
					// Remember the original values
					width = style.width;
					minWidth = style.minWidth;
					maxWidth = style.maxWidth;
	
					// Put in the new values to get a computed value out
					style.minWidth = style.maxWidth = style.width = ret;
					ret = computed.width;
	
					// Revert the changed values
					style.width = width;
					style.minWidth = minWidth;
					style.maxWidth = maxWidth;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "";
		};
	} else if ( documentElement.currentStyle ) {
		getStyles = function( elem ) {
			return elem.currentStyle;
		};
	
		curCSS = function( elem, name, computed ) {
			var left, rs, rsLeft, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
			ret = computed ? computed[ name ] : undefined;
	
			// Avoid setting ret to empty string here
			// so we don't default to auto
			if ( ret == null && style && style[ name ] ) {
				ret = style[ name ];
			}
	
			// From the awesome hack by Dean Edwards
			// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	
			// If we're not dealing with a regular pixel number
			// but a number that has a weird ending, we need to convert it to pixels
			// but not position css attributes, as those are
			// proportional to the parent element instead
			// and we can't measure the parent instead because it
			// might trigger a "stacking dolls" problem
			if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {
	
				// Remember the original values
				left = style.left;
				rs = elem.runtimeStyle;
				rsLeft = rs && rs.left;
	
				// Put in the new values to get a computed value out
				if ( rsLeft ) {
					rs.left = elem.currentStyle.left;
				}
				style.left = name === "fontSize" ? "1em" : ret;
				ret = style.pixelLeft + "px";
	
				// Revert the changed values
				style.left = left;
				if ( rsLeft ) {
					rs.left = rsLeft;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "" || "auto";
		};
	}
	
	
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
			ralpha = /alpha\([^)]*\)/i,
		ropacity = /opacity\s*=\s*([^)]*)/i,
	
		// swappable if display is none or starts with table except
		// "table", "table-cell", or "table-caption"
		// see here for display values:
		// https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	
	// return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// check for vendor prefixed names
		var capName = name.charAt( 0 ).toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = jQuery._data( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] =
						jQuery._data( elem, "olddisplay", defaultDisplay( elem.nodeName ) );
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display && display !== "none" || !hidden ) {
					jQuery._data(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
		var matches = rnumsplit.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// at this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// at this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// at this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = support.boxSizing &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// we need the check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
	
			// normalize float css property
			"float": support.cssFloat ? "cssFloat" : "styleFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set. See: #7116
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
				// but it would mean to define eight
				// (for every problematic property) identical functions
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					// Support: IE
					// Swallow errors from 'invalid' CSS values (#5509)
					try {
						style[ name ] = value;
					} catch ( e ) {}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var num, val, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			//convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Return, converting to number if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// certain elements can have dimension info if we invisibly show them
					// however, it must have a current display style that would benefit from this
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var styles = extra && getStyles( elem );
				return setPositiveNumber( elem, value, extra ?
					augmentWidthOrHeight(
						elem,
						name,
						extra,
						support.boxSizing &&
							jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					) : 0
				);
			}
		};
	} );
	
	if ( !support.opacity ) {
		jQuery.cssHooks.opacity = {
			get: function( elem, computed ) {
	
				// IE uses filters for opacity
				return ropacity.test( ( computed && elem.currentStyle ?
					elem.currentStyle.filter :
					elem.style.filter ) || "" ) ?
						( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
						computed ? "1" : "";
			},
	
			set: function( elem, value ) {
				var style = elem.style,
					currentStyle = elem.currentStyle,
					opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
					filter = currentStyle && currentStyle.filter || style.filter || "";
	
				// IE has trouble with opacity if it does not have layout
				// Force it by setting the zoom level
				style.zoom = 1;
	
				// if setting opacity to 1, and no other filters exist -
				// attempt to remove filter attribute #6652
				// if value === "", then remove inline opacity #12685
				if ( ( value >= 1 || value === "" ) &&
						jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
						style.removeAttribute ) {
	
					// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
					// if "filter:" is present at all, clearType is disabled, we want to avoid this
					// style.removeAttribute is IE Only, but so apparently is this code path...
					style.removeAttribute( "filter" );
	
					// if there is no filter style applied in a css rule
					// or unset inline opacity, we are done
					if ( value === "" || currentStyle && !currentStyle.filter ) {
						return;
					}
				}
	
				// otherwise, set new filter values
				style.filter = ralpha.test( filter ) ?
					filter.replace( ralpha, opacity ) :
					filter + " " + opacity;
			}
		};
	}
	
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return (
					parseFloat( curCSS( elem, "marginLeft" ) ) ||
	
					// Support: IE<=11+
					// Running getBoundingClientRect on a disconnected node in IE throws an error
					// Support: IE8 only
					// getClientRects() errors on disconnected elems
					( jQuery.contains( elem.ownerDocument, elem ) ?
						elem.getBoundingClientRect().left -
							swap( elem, { marginLeft: 0 }, function() {
								return elem.getBoundingClientRect().left;
							} ) :
						0
					)
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails
				// so, simple values such as "10px" are parsed to Float.
				// complex values such as "rotate(1rad)" are returned as is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// use step hook for back compat - use cssHook if its there - use .style if its
				// available and use plain properties where available
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9
	// Panic based approach to setting things on disconnected nodes
	
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			attrs = { height: type },
			i = 0;
	
		// if we include width, step value is 1 to do all cssExpand values,
		// if we don't include width, step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// we're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = jQuery._data( elem, "fxshow" );
	
		// handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// doing this makes sure that the complete handler will be called
				// before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE does not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				jQuery._data( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
	
				// inline-level elements accept inline-block;
				// block-level elements need to be inline with layout
				if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
					style.display = "inline-block";
				} else {
					style.zoom = 1;
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			if ( !support.shrinkWrapBlocks() ) {
				anim.always( function() {
					style.overflow = opts.overflow[ 0 ];
					style.overflowX = opts.overflow[ 1 ];
					style.overflowY = opts.overflow[ 2 ];
				} );
			}
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = jQuery._data( elem, "fxshow", {} );
			}
	
			// store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
				jQuery._removeData( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// not quite $.extend, this wont overwrite keys already present.
				// also - reusing 'index' from above because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// if we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// resolve when we played the last frame
					// otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || jQuery._data( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = jQuery._data( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// start the next in the queue if the last step wasn't forced
				// timers currently will call their complete callbacks, which will dequeue
				// but only if they were gotoEnd
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = jQuery._data( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// enable finishing flag on private data
				data.finish = true;
	
				// empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			timers = jQuery.timers,
			i = 0;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var a,
			input = document.createElement( "input" ),
			div = document.createElement( "div" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		// Setup
		div = document.createElement( "div" );
		div.setAttribute( "className", "t" );
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
		a = div.getElementsByTagName( "a" )[ 0 ];
	
		// Support: Windows Web Apps (WWA)
		// `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "checkbox" );
		div.appendChild( input );
	
		a = div.getElementsByTagName( "a" )[ 0 ];
	
		// First batch of tests.
		a.style.cssText = "top:1px";
	
		// Test setAttribute on camelCase class.
		// If it works, we need attrFixes when doing get/setAttribute (ie6/7)
		support.getSetAttribute = div.className !== "t";
	
		// Get the style information from getAttribute
		// (IE uses .cssText instead)
		support.style = /top/.test( a.getAttribute( "style" ) );
	
		// Make sure that URLs aren't manipulated
		// (IE normalizes it by default)
		support.hrefNormalized = a.getAttribute( "href" ) === "/a";
	
		// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
		support.checkOn = !!input.value;
	
		// Make sure that a selected-by-default option has a working selected property.
		// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
		support.optSelected = opt.selected;
	
		// Tests for enctype support on a form (#6743)
		support.enctype = !!document.createElement( "form" ).enctype;
	
		// Make sure that the options inside disabled selects aren't marked as disabled
		// (WebKit marks them as disabled)
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE8 only
		// Check if we can trust getAttribute("value")
		input = document.createElement( "input" );
		input.setAttribute( "value", "" );
		support.input = input.getAttribute( "value" ) === "";
	
		// Check if an input maintains its value after becoming a radio
		input.value = "t";
		input.setAttribute( "type", "radio" );
		support.radioValue = input.value === "t";
	} )();
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if (
						hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
				} else if ( typeof val === "number" ) {
					val += "";
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// oldIE doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled :
									option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1 ) {
	
							// Support: IE6
							// When new option element is added to select box we need to
							// force reflow of newly added node in order to workaround delay
							// of initialization properties
							try {
								option.selected = optionSet = true;
	
							} catch ( _ ) {
	
								// Will be executed only in IE6
								option.scrollHeight;
							}
	
						} else {
							option.selected = false;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
	
					return options;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	var nodeHook, boolHook,
		attrHandle = jQuery.expr.attrHandle,
		ruseDefault = /^(?:checked|selected)$/i,
		getSetAttribute = support.getSetAttribute,
		getSetInput = support.input;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
	
						// Setting the type on a radio button after the value resets the value in IE8-9
						// Reset value to default in case type is set after value during creation
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
							elem[ propName ] = false;
	
						// Support: IE<9
						// Also clear defaultChecked/defaultSelected (if appropriate)
						} else {
							elem[ jQuery.camelCase( "default-" + name ) ] =
								elem[ propName ] = false;
						}
	
					// See #9699 for explanation of this approach (setting first, then removal)
					} else {
						jQuery.attr( elem, name, "" );
					}
	
					elem.removeAttribute( getSetAttribute ? name : propName );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
	
				// IE<8 needs the *property* name
				elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );
	
			} else {
	
				// Support: IE<9
				// Use defaultChecked and defaultSelected for oldIE
				elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
			attrHandle[ name ] = function( elem, name, isXML ) {
				var ret, handle;
				if ( !isXML ) {
	
					// Avoid an infinite loop by temporarily removing this function from the getter
					handle = attrHandle[ name ];
					attrHandle[ name ] = ret;
					ret = getter( elem, name, isXML ) != null ?
						name.toLowerCase() :
						null;
					attrHandle[ name ] = handle;
				}
				return ret;
			};
		} else {
			attrHandle[ name ] = function( elem, name, isXML ) {
				if ( !isXML ) {
					return elem[ jQuery.camelCase( "default-" + name ) ] ?
						name.toLowerCase() :
						null;
				}
			};
		}
	} );
	
	// fix oldIE attroperties
	if ( !getSetInput || !getSetAttribute ) {
		jQuery.attrHooks.value = {
			set: function( elem, value, name ) {
				if ( jQuery.nodeName( elem, "input" ) ) {
	
					// Does not return so that setAttribute is also used
					elem.defaultValue = value;
				} else {
	
					// Use nodeHook if defined (#1954); otherwise setAttribute is fine
					return nodeHook && nodeHook.set( elem, value, name );
				}
			}
		};
	}
	
	// IE6/7 do not support getting/setting some attributes with get/setAttribute
	if ( !getSetAttribute ) {
	
		// Use this for any attribute in IE6/7
		// This fixes almost every IE6/7 issue
		nodeHook = {
			set: function( elem, value, name ) {
	
				// Set the existing or create a new attribute node
				var ret = elem.getAttributeNode( name );
				if ( !ret ) {
					elem.setAttributeNode(
						( ret = elem.ownerDocument.createAttribute( name ) )
					);
				}
	
				ret.value = value += "";
	
				// Break association with cloned elements by also using setAttribute (#9646)
				if ( name === "value" || value === elem.getAttribute( name ) ) {
					return value;
				}
			}
		};
	
		// Some attributes are constructed with empty-string values when not defined
		attrHandle.id = attrHandle.name = attrHandle.coords =
			function( elem, name, isXML ) {
				var ret;
				if ( !isXML ) {
					return ( ret = elem.getAttributeNode( name ) ) && ret.value !== "" ?
						ret.value :
						null;
				}
			};
	
		// Fixing value retrieval on a button requires this module
		jQuery.valHooks.button = {
			get: function( elem, name ) {
				var ret = elem.getAttributeNode( name );
				if ( ret && ret.specified ) {
					return ret.value;
				}
			},
			set: nodeHook.set
		};
	
		// Set contenteditable to false on removals(#10429)
		// Setting to empty string throws an error as an invalid value
		jQuery.attrHooks.contenteditable = {
			set: function( elem, value, name ) {
				nodeHook.set( elem, value === "" ? false : value, name );
			}
		};
	
		// Set width and height to auto instead of 0 on empty string( Bug #8150 )
		// This is for removals
		jQuery.each( [ "width", "height" ], function( i, name ) {
			jQuery.attrHooks[ name ] = {
				set: function( elem, value ) {
					if ( value === "" ) {
						elem.setAttribute( name, "auto" );
						return value;
					}
				}
			};
		} );
	}
	
	if ( !support.style ) {
		jQuery.attrHooks.style = {
			get: function( elem ) {
	
				// Return undefined in the case of empty string
				// Note: IE uppercases css property names, but if we were to .toLowerCase()
				// .cssText, that would destroy case sensitivity in URL's, like in "background"
				return elem.style.cssText || undefined;
			},
			set: function( elem, value ) {
				return ( elem.style.cssText = value + "" );
			}
		};
	}
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button|object)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			name = jQuery.propFix[ name ] || name;
			return this.each( function() {
	
				// try/catch handles cases where IE balks (such as removing a property on window)
				try {
					this[ name ] = undefined;
					delete this[ name ];
				} catch ( e ) {}
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Some attributes require a special call on IE
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !support.hrefNormalized ) {
	
		// href/src property should get the full normalized URL (#10299/#12915)
		jQuery.each( [ "href", "src" ], function( i, name ) {
			jQuery.propHooks[ name ] = {
				get: function( elem ) {
					return elem.getAttribute( name, 4 );
				}
			};
		} );
	}
	
	// Support: Safari, IE9+
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
	
				if ( parent ) {
					parent.selectedIndex;
	
					// Make sure that it also works with optgroups, see #5701
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	// IE6/7 call enctype encoding
	if ( !support.enctype ) {
		jQuery.propFix.enctype = "encoding";
	}
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return jQuery.attr( elem, "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							jQuery.attr( elem, "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							jQuery.attr( elem, "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// store className if set
						jQuery._data( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed "false",
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					jQuery.attr( this, "class",
						className || value === false ?
						"" :
						jQuery._data( this, "__className__" ) || ""
					);
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
	
	jQuery.parseJSON = function( data ) {
	
		// Attempt to parse using the native JSON parser first
		if ( window.JSON && window.JSON.parse ) {
	
			// Support: Android 2.3
			// Workaround failure to string-cast null input
			return window.JSON.parse( data + "" );
		}
	
		var requireNonComma,
			depth = null,
			str = jQuery.trim( data + "" );
	
		// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
		// after removing valid tokens
		return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {
	
			// Force termination if we see a misplaced comma
			if ( requireNonComma && comma ) {
				depth = 0;
			}
	
			// Perform no more replacements after returning to outermost depth
			if ( depth === 0 ) {
				return token;
			}
	
			// Commas must not follow "[", "{", or ","
			requireNonComma = open || comma;
	
			// Determine new depth
			// array/object open ("[" or "{"): depth += true - false (increment)
			// array/object close ("]" or "}"): depth += false - true (decrement)
			// other cases ("," or primitive): depth += true - true (numeric cast)
			depth += !close - !open;
	
			// Remove this token
			return "";
		} ) ) ?
			( Function( "return " + str ) )() :
			jQuery.error( "Invalid JSON: " + data );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, tmp;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		try {
			if ( window.DOMParser ) { // Standard
				tmp = new window.DOMParser();
				xml = tmp.parseFromString( data, "text/xml" );
			} else { // IE
				xml = new window.ActiveXObject( "Microsoft.XMLDOM" );
				xml.async = "false";
				xml.loadXML( data );
			}
		} catch ( e ) {
			xml = undefined;
		}
		if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
	
		// IE leaves an \r character at EOL
		rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
		rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Document location
		ajaxLocation = location.href,
	
		// Segment location into parts
		ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType.charAt( 0 ) === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var deep, key,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
		var firstDataType, ct, finalDataType, type,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s[ "throws" ] ) { // jscs:ignore requireDotNotation
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: ajaxLocation,
			type: "GET",
			isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var
	
				// Cross-domain detection vars
				parts,
	
				// Loop variable
				i,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers as string
				responseHeadersString,
	
				// timeout handle
				timeoutTimer,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				transport,
	
				// Response headers
				responseHeaders,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || ajaxLocation ) + "" )
				.replace( rhash, "" )
				.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when we have a protocol:host:port mismatch
			if ( s.crossDomain == null ) {
				parts = rurl.exec( s.url.toLowerCase() );
				s.crossDomain = !!( parts &&
					( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
						( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
							( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
				);
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// We extract error from statusText
					// then normalize statusText and status for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				var wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
						elem = elem.firstChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	function getDisplay( elem ) {
		return elem.style && elem.style.display || jQuery.css( elem, "display" );
	}
	
	function filterHidden( elem ) {
	
		// Disconnected elements are considered hidden
		if ( !jQuery.contains( elem.ownerDocument || document, elem ) ) {
			return true;
		}
		while ( elem && elem.nodeType === 1 ) {
			if ( getDisplay( elem ) === "none" || elem.type === "hidden" ) {
				return true;
			}
			elem = elem.parentNode;
		}
		return false;
	}
	
	jQuery.expr.filters.hidden = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		return support.reliableHiddenOffsets() ?
			( elem.offsetWidth <= 0 && elem.offsetHeight <= 0 &&
				!elem.getClientRects().length ) :
				filterHidden( elem );
	};
	
	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is(":disabled") so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	// Create the request object
	// (This is still attached to ajaxSettings for backward compatibility)
	jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?
	
		// Support: IE6-IE8
		function() {
	
			// XHR cannot access local files, always use ActiveX for that case
			if ( this.isLocal ) {
				return createActiveXHR();
			}
	
			// Support: IE 9-11
			// IE seems to error on cross-domain PATCH requests when ActiveX XHR
			// is used. In IE 9+ always use the native XHR.
			// Note: this condition won't catch Edge as it doesn't define
			// document.documentMode but it also doesn't support ActiveX so it won't
			// reach this code.
			if ( document.documentMode > 8 ) {
				return createStandardXHR();
			}
	
			// Support: IE<9
			// oldIE XHR does not support non-RFC2616 methods (#13240)
			// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
			// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
			// Although this check for six methods instead of eight
			// since IE also does not support "trace" and "connect"
			return /^(get|post|head|put|delete|options)$/i.test( this.type ) &&
				createStandardXHR() || createActiveXHR();
		} :
	
		// For all other browsers, use the standard XMLHttpRequest object
		createStandardXHR;
	
	var xhrId = 0,
		xhrCallbacks = {},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	// Support: IE<10
	// Open requests must be manually aborted on unload (#5280)
	// See https://support.microsoft.com/kb/2856746 for more info
	if ( window.attachEvent ) {
		window.attachEvent( "onunload", function() {
			for ( var key in xhrCallbacks ) {
				xhrCallbacks[ key ]( undefined, true );
			}
		} );
	}
	
	// Determine support properties
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	xhrSupported = support.ajax = !!xhrSupported;
	
	// Create transport if the browser can provide an xhr
	if ( xhrSupported ) {
	
		jQuery.ajaxTransport( function( options ) {
	
			// Cross domain only allowed if supported through XMLHttpRequest
			if ( !options.crossDomain || support.cors ) {
	
				var callback;
	
				return {
					send: function( headers, complete ) {
						var i,
							xhr = options.xhr(),
							id = ++xhrId;
	
						// Open the socket
						xhr.open(
							options.type,
							options.url,
							options.async,
							options.username,
							options.password
						);
	
						// Apply custom fields if provided
						if ( options.xhrFields ) {
							for ( i in options.xhrFields ) {
								xhr[ i ] = options.xhrFields[ i ];
							}
						}
	
						// Override mime type if needed
						if ( options.mimeType && xhr.overrideMimeType ) {
							xhr.overrideMimeType( options.mimeType );
						}
	
						// X-Requested-With header
						// For cross-domain requests, seeing as conditions for a preflight are
						// akin to a jigsaw puzzle, we simply never set it to be sure.
						// (it can always be set on a per-request basis or even using ajaxSetup)
						// For same-domain requests, won't change header if already provided.
						if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
							headers[ "X-Requested-With" ] = "XMLHttpRequest";
						}
	
						// Set headers
						for ( i in headers ) {
	
							// Support: IE<9
							// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
							// request header to a null-value.
							//
							// To keep consistent with other XHR implementations, cast the value
							// to string and ignore `undefined`.
							if ( headers[ i ] !== undefined ) {
								xhr.setRequestHeader( i, headers[ i ] + "" );
							}
						}
	
						// Do send the request
						// This may raise an exception which is actually
						// handled in jQuery.ajax (so no try/catch here)
						xhr.send( ( options.hasContent && options.data ) || null );
	
						// Listener
						callback = function( _, isAbort ) {
							var status, statusText, responses;
	
							// Was never called and is aborted or complete
							if ( callback && ( isAbort || xhr.readyState === 4 ) ) {
	
								// Clean up
								delete xhrCallbacks[ id ];
								callback = undefined;
								xhr.onreadystatechange = jQuery.noop;
	
								// Abort manually if needed
								if ( isAbort ) {
									if ( xhr.readyState !== 4 ) {
										xhr.abort();
									}
								} else {
									responses = {};
									status = xhr.status;
	
									// Support: IE<10
									// Accessing binary-data responseText throws an exception
									// (#11426)
									if ( typeof xhr.responseText === "string" ) {
										responses.text = xhr.responseText;
									}
	
									// Firefox throws an exception when accessing
									// statusText for faulty cross-domain requests
									try {
										statusText = xhr.statusText;
									} catch ( e ) {
	
										// We normalize with Webkit giving an empty statusText
										statusText = "";
									}
	
									// Filter status for non standard behaviors
	
									// If the request is local and we have data: assume a success
									// (success with no data won't get notified, that's the best we
									// can do given current implementations)
									if ( !status && options.isLocal && !options.crossDomain ) {
										status = responses.text ? 200 : 404;
	
									// IE - #1450: sometimes returns 1223 when it should be 204
									} else if ( status === 1223 ) {
										status = 204;
									}
								}
							}
	
							// Call complete if needed
							if ( responses ) {
								complete( status, statusText, responses, xhr.getAllResponseHeaders() );
							}
						};
	
						// Do send the request
						// `xhr.send` may raise an exception, but it will be
						// handled in jQuery.ajax (so no try/catch here)
						if ( !options.async ) {
	
							// If we're in sync mode we fire the callback
							callback();
						} else if ( xhr.readyState === 4 ) {
	
							// (IE6 & IE7) if it's in cache and has been
							// retrieved directly we need to fire the callback
							window.setTimeout( callback );
						} else {
	
							// Register the callback, but delay it in case `xhr.send` throws
							// Add to the list of active xhr callbacks
							xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
						}
					},
	
					abort: function() {
						if ( callback ) {
							callback( undefined, true );
						}
					}
				};
			}
		} );
	}
	
	// Functions to create xhrs
	function createStandardXHR() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	}
	
	function createActiveXHR() {
		try {
			return new window.ActiveXObject( "Microsoft.XMLHTTP" );
		} catch ( e ) {}
	}
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and global
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
			s.global = false;
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
	
			var script,
				head = document.head || jQuery( "head" )[ 0 ] || document.documentElement;
	
			return {
	
				send: function( _, callback ) {
	
					script = document.createElement( "script" );
	
					script.async = true;
	
					if ( s.scriptCharset ) {
						script.charset = s.scriptCharset;
					}
	
					script.src = s.url;
	
					// Attach handlers for all browsers
					script.onload = script.onreadystatechange = function( _, isAbort ) {
	
						if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {
	
							// Handle memory leak in IE
							script.onload = script.onreadystatechange = null;
	
							// Remove the script
							if ( script.parentNode ) {
								script.parentNode.removeChild( script );
							}
	
							// Dereference the script
							script = null;
	
							// Callback if not abort
							if ( !isAbort ) {
								callback( 200, "success" );
							}
						}
					};
	
					// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					head.insertBefore( script, head.firstChild );
				},
	
				abort: function() {
					if ( script ) {
						script.onload( undefined, true );
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// data: string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off, url.length ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ?
			elem :
			elem.nodeType === 9 ?
				elem.defaultView || elem.parentWindow :
				false;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				jQuery.inArray( "auto", [ curCSSTop, curCSSLeft ] ) > -1;
	
			// need to be able to calculate position if either top or left
			// is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				box = { top: 0, left: 0 },
				elem = this[ 0 ],
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			// If we don't have gBCR, just use 0,0 rather than error
			// BlackBerry 5, iOS 3 (original iPhone)
			if ( typeof elem.getBoundingClientRect !== "undefined" ) {
				box = elem.getBoundingClientRect();
			}
			win = getWindow( doc );
			return {
				top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
				left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				parentOffset = { top: 0, left: 0 },
				elem = this[ 0 ];
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// we assume that getBoundingClientRect is available when computed position is fixed
				offset = elem.getBoundingClientRect();
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			// note: when an element has margin: auto the offsetLeft and marginLeft
			// are the same in Safari causing offset.left to incorrectly be 0
			return {
				top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) ) {
					offsetParent = offsetParent.offsetParent;
				}
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = /Y/.test( prop );
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? ( prop in win ) ? win[ prop ] :
						win.document.documentElement[ method ] :
						elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : jQuery( win ).scrollLeft(),
						top ? val : jQuery( win ).scrollTop()
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length, null );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// getComputedStyle returns percent when specified for top/left/bottom/right
	// rather than make the css module depend on the offset module, we just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// if curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {
	
			// margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						// unfortunately, this causes bug #3838 in IE6/8 only,
						// but there is currently no good, small way to fix it.
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		return this.length;
	};
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in
	// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	
	var moment = __webpack_require__(17);
	var _isMobile = /mobile/i.test(navigator.userAgent) && !(/iPad/i.test(navigator.userAgent));
	// var _isIE8 = /Trident\/4\.0/.test(navigator.userAgent);
	var protocol = /(((ftp|https?):)?\/\/)?/;
	var auth = /([-._0-9a-zA-Z]+(:[-._0-9a-zA-Z]+)?@)?/;
	var host = /((\d+\.\d+\.\d+\.\d+)|(([-_0-9a-zA-Z_]+\.)+[a-zA-Z]+))/;
	var port = /(:\d+)?/;
	var path = /(\/[^ ?\n]*)*/;
	var query = /(\?([-+._%0-9a-zA-Z]+=[^ &#'"\n]*&)*([-+._%0-9a-zA-Z]+=[^ &#'"\n]*))?/;
	var hash = /(#[-+._%0-9a-zA-Z/]*)?/;
	var reg = new RegExp(getString(protocol) + getString(auth) + getString(host) + getString(port) + getString(path) + getString(query) + getString(hash), "gi");
	
	function getString(reg){
		return reg.toString().replace(/^\/(.*)\/$/, "$1");
	}
	
	function _isNodeList(nodes){
		var stringRepr = Object.prototype.toString.call(nodes);
	
		return typeof nodes === "object"
			&& /^\[object (HTMLCollection|NodeList|Object)\]$/.test(stringRepr)
			&& typeof nodes.length === "number"
			&& (nodes.length === 0 || (typeof nodes[0] === "object" && nodes[0].nodeType > 0));
	}
	
	function _addClass(elem, className){
		if(!_hasClass(elem, className)){
			elem.className += " " + className;
		}
	}
	
	function _removeClass(elem, className){
		if(_hasClass(elem, className)){
			elem.className = (
				(" " + elem.className + " ")
				.replace(new RegExp(" " + className + " ", "g"), " ")
			).trim();
		}
	}
	
	function _hasClass(elem, className){
		return !!~(" " + elem.className + " ").indexOf(" " + className + " ");
	}
	
	function _eachElement(elementOrNodeList, fn /* *arguments */){
		if(typeof fn !== "function") return;
	
		var nodeList = _isNodeList(elementOrNodeList) ? elementOrNodeList : [elementOrNodeList];
		var extraArgs = [];
		var i, l, tmpElem;
	
		// parse extra arguments
		for(i = 2, l = arguments.length; i < l; ++i){
			extraArgs.push(arguments[i]);
		}
	
		for(i = 0, l = nodeList.length; i < l; ++i){
			(tmpElem = nodeList[i])
			&& fn.apply(null, [tmpElem].concat(extraArgs));
		}
	}
	
	function _bind(elem, evt, handler, isCapture){
		if(elem.addEventListener){
			elem.addEventListener(evt, handler, isCapture);
		}
		else if(elem.attachEvent){
			// todo: add window.event to evt
			// todo: add srcElement
			// todo: remove this _event
			elem["_" + evt] = function(){
				handler.apply(elem, arguments);
			};
			elem.attachEvent("on" + evt, elem["_" + evt]);
		}
		else{}
	}
	
	function _unbind(elem, evt, handler){
		var keyName = "_" + evt;
		var eventName = "on" + evt;
	
		if(elem.removeEventListener && handler){
			elem.removeEventListener(evt, handler);
		}
		else if(elem.detachEvent){
			elem.detachEvent(eventName, elem[keyName]);
			delete elem[keyName];
		}
		else{}
	}
	
	function _appendHtmlToElement(element, html){
		if(!element) return;
	
		var tmpDiv = document.createElement("div");
		var documentFragment = document.createDocumentFragment();
		var children;
		var el;
	
		tmpDiv.innerHTML = html;
		children = tmpDiv.childNodes;
		el = children[0];
	
		while(children.length > 0){
			documentFragment.appendChild(children[0]);
		}
	
		element.appendChild(documentFragment);
		return el;
	}
	function _changeToRgb(color){
		if(!color){
			return "#42b8f4"
		}
		var reg  = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
		var sColor = color.toLowerCase();
		if (sColor && reg.test(sColor)) {
			if (sColor.length === 4) {
				var sColorNew = "#";
				for (var i = 1; i < 4; i += 1) {
					sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
				}
				sColor = sColorNew;
			}
			//处理六位的颜色值
			var sColorChange = [];
			for (var i = 1; i < 6; i += 2) {
				sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
			}
			//此处是返回的颜色 如需要透明度,0.3是指透明度30%&#xff0c;直接返回
			//"rgba(" + sColorChange.join(",") + "0.3)";
			return "rgba(" + sColorChange.join(",") + ",0.15)";
		} 
		else if(sColor.indexOf("rgb") != -1 && sColor.indexOf("rgba") === -1) {
			return "rgba" + sColor.split("rgb")[1].split(")")[0] + ",0.15)";
		}
		else {
			return sColor;
		}
	}
	
	module.exports = {
		changeToRgb:_changeToRgb,		
		isTop: window.top === window.self,
		isNodeList: _isNodeList,
		isAndroid: /android/i.test(navigator.userAgent),
		isQQBrowser: /MQQBrowser/i.test(navigator.userAgent),
		isIOS: /(iPad|iPhone|iPod)/i.test(navigator.userAgent),
		isSafari: /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent),
		isMobile: _isMobile,
		noop: function(){},
		click: _isMobile && ("ontouchstart" in window) ? "touchstart" : "click",
		isBrowserMinimized: function(){
			return document.visibilityState === "hidden" || document.hidden;
		},
		appendHTMLTo: _appendHtmlToElement,
		appendHTMLToBody: function(html){
			return _appendHtmlToElement(document.body, html);
		},
		createElementFromHTML: function(html){
			var tmpDiv = document.createElement("div");
			tmpDiv.innerHTML = html;
			return tmpDiv.childNodes[0];
		},
	
		createElementArticleFromHTML: function(html){
			var tmpDiv = document.createElement("div");
			tmpDiv.innerHTML = html;
			return tmpDiv;
		},
		getBrief: function(str, length){
			if(typeof str !== "string") return "";
			return str.length > length ? str.slice(0, length) + "..." : str;
		},
		formatDate: function(date){
			return moment(date || _.now()).format("MMM D HH:mm");
		},
		formatHHmm: function(date){
			return moment(date || _.now()).format("HH:mm");
		},
	
		formatProtocol: function(val){
			return val.replace(/(http:|https:)?(\/\/)?(.+)/, function(match, $1, $2, $3){
				return "//" + $3;
			});
		},
	
		filesizeFormat: function(filesize){
			var UNIT_ARRAY = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB"];
			var exponent;
			var result;
	
			if(filesize > 0){
				exponent = Math.floor(Math.log(filesize) / Math.log(1024));
				result = (filesize / Math.pow(1024, exponent)).toFixed(2) + " " + UNIT_ARRAY[exponent];
			}
			else if(filesize === 0){
				result = "0 B";
			}
			else{
				result = "";
			}
			return result;
		},
		uuid: function(){
			var s = [];
			var hexDigits = "0123456789abcdef";
			var i;
	
			for(i = 0; i < 36; i++){
				s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
			}
	
			s[14] = "4";
			s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
			s[8] = s[13] = s[18] = s[23] = "-";
	
			return s.join("");
		},
		convertFalse: function(obj){
			obj = typeof obj === "undefined" ? "" : obj;
			return obj === "false" ? false : obj;
		},
		removeDom: function(elem){
			if(!elem) return;
	
			if(elem.remove){
				elem.remove();
			}
			else if(elem.parentNode){
				elem.parentNode.removeChild(elem);
			}
			else{}
		},
		live: function(selector, ev, handler, wrapper){
			var me = this;
			var container = wrapper || document;
			me.on(container, ev, function(e){
				var evt = e || window.event;
				var target = evt.target || evt.srcElement;
				var parentOfTarget = target.parentNode;
				var targetList = container.querySelectorAll(selector);
				var i;
				var l;
				var currentElement;
	
				for(i = 0, l = targetList.length; i < l; ++i){
					currentElement = targetList[i];
					if(currentElement === target){
						handler.call(target, evt);
					}
					else if(currentElement === parentOfTarget){
						handler.call(parentOfTarget, evt);
					}
				}
			});
		},
		on: function(elementOrNodeList, event, handler, isCapture){
			event.split(" ").forEach(function(evt){
				evt && _eachElement(elementOrNodeList, _bind, evt, handler, isCapture);
			});
		},
		off: function(elementOrNodeList, event, handler){
			event.split(" ").forEach(function(evt){
				evt && _eachElement(elementOrNodeList, _unbind, evt, handler);
			});
		},
		one: function(element, ev, handler, isCapture){
			if(!element || !ev) return;
	
			var tempFn = function(){
				handler.apply(this, arguments);
				_unbind(element, ev, tempFn);
			};
			_bind(element, ev, tempFn, isCapture);
		},
		// 触发事件，对于ie8只支持原生事件，不支持自定义事件
		trigger: function(element, eventName){
			var ev;
			if(document.createEvent){
				ev = document.createEvent("HTMLEvents");
				ev.initEvent(eventName, true, false);
				element.dispatchEvent(ev);
			}
			else{
				element.fireEvent("on" + eventName);
			}
		},
		// todo： 去掉 使用 _.extend 替代
		extend: function(object, extend){
			var key;
			var type;
			var value;
			for(key in extend){
				if(Object.prototype.hasOwnProperty.call(extend, key)){
					value = extend[key];
					type = Object.prototype.toString.call(value);
					if(value === undefined){
						// patch ie8 will change undefined to {}
						object[key] = value;
					}
					else if(type === "[object Array]"){
						object[key] = [];
						this.extend(object[key], value);
					}
					else if(type === "[object Object]"){
						object[key] = {};
						this.extend(object[key], value);
					}
					else{
						object[key] = value;
					}
				}
			}
			return object;
		},
		addClass: function(elementOrNodeList, className){
			_eachElement(elementOrNodeList, _addClass, className);
			return elementOrNodeList;
		},
		removeClass: function(elementOrNodeList, className){
			_eachElement(elementOrNodeList, _removeClass, className);
			return elementOrNodeList;
		},
		hasClass: function(elem, className){
			if(!elem) return false;
			return _hasClass(elem, className);
		},
		toggleClass: function(element, className, stateValue){
			if(!element || !className) return;
	
			var ifNeedAddClass = typeof stateValue === "undefined"
				? !_hasClass(element, className)
				: stateValue;
	
			if(ifNeedAddClass){
				_addClass(element, className);
			}
			else{
				_removeClass(element, className);
			}
		},
		getDataByPath: getDataByPath,
		query: function(key){
			var reg = new RegExp("[?&]" + key + "=([^&]*)(?=&|$)");
			var matches = reg.exec(location.search);
			return matches ? matches[1] : "";
		},
		sameProtocol: function(url){
			url = url || "";
			// 全清理
			url = url.replace(/^http[s]?:/, "");
			url = url.replace(/^\/\//, "");
			if(!/^\//.test(url)){
				url = "//" + url;
			}
			return url;
		},
		setStore: function(key, value){
			try{
				localStorage.setItem(key, value);
			}
			catch(e){}
		},
		getStore: function(key){
			try{
				return localStorage.getItem(key);
			}
			catch(e){}
		},
		clearStore: function(key){
			try{
				localStorage.removeItem(key);
			}
			catch(e){}
		},
		clearAllStore: function(){
			try{
				localStorage.clear();
			}
			catch(e){}
		},
		set: function(key, value, expiration){
			var date = new Date();
			// 过期时间默认为30天
			var expiresTime = date.getTime() + (expiration || 30) * 24 * 3600 * 1000;
			date.setTime(expiresTime);
			document.cookie = encodeURIComponent(key) + "=" + encodeURIComponent(value) + ";path=/;expires=" + date.toGMTString();
		},
		get: function(key){
			var matches = document.cookie.match("(^|;) ?" + encodeURIComponent(key) + "=([^;]*)(;|$)");
			return matches ? decodeURIComponent(matches[2]) : "";
		},
		// case1: /v1/tenants/5323/mediafiles/08d3d9bf-5507-4115-a6e6-1b50b0585f99MTAzZWQ2ZjUxNjczZmM2MjY2YmE4MGMyNDNhMGI1OWMucG5n/cutout?arg=114_0_305_305_300_300
		getAvatarsFullPath: function(url, domain){
			// 阿里云的 oss 不支持 https，需要使用 ossimages 代理
			// 现在已经不使用这种逻辑了，但是为了兼容老数据所以没删除
			if(!url) return "";
			var hasProtocol = /^(https?:)?\/\//.test(url);
			var isKefuAvatar = ~url.indexOf("img-cn");
			var ossImg = ~url.indexOf("ossimages");
			url = url.replace(/^(https?:)?\/\/?/, "");
			if(isKefuAvatar && !ossImg){
				return domain + "/ossimages/" + url;
			}
			else if(!hasProtocol){
				return domain + "/" + url;
			}
			return "//" + url;
		},
		copy: function(obj){
			// todo：移到，easemob.js 里边
			return this.extend({}, obj);
		},
		encode: function(str){
			var s;
			if(!str) return "";
			s = str || "";
			if(str.length == 0) return "";
			s = s.replace(/[<]/g, "&lt;");
			s = s.replace(/[>]/g, "&gt;");
			s = s.replace(/[']/g, "&#39;");
			s = s.replace(/["]/g, "&quot;");
			s = s.replace(/\n/g, "<br>");
			return s;
		},
		decode: function(str){
			var s;
			if(!str) return "";
			s = str || "";
			if(str.length == 0) return "";
			s = s.replace(/&lt;/g, "<");
			s = s.replace(/&gt;/g, ">");
			s = s.replace(/&amp;/g, "&");
			return s;
		},
		parseUrl: parseUrl,
		stopPropagation: function(e){
			e = window.event || e;
			if(document.all){  // 只有ie识别
				e.cancelBubble = true;
			}
			else{
				e.stopPropagation();
			}
		}
	};
	
	function getDataByPath(obj, path){
		var propArray = path.split(".");
		var currentObj = obj;
	
		return seek();
	
		function seek(){
			var prop = propArray.shift();
	
			if(typeof prop !== "string"){
				// path 遍历完了，返回当前值
				return currentObj;
			}
			else if(typeof currentObj === "object" && currentObj !== null){
				// 正常遍历path，递归调用
				currentObj = currentObj[prop];
				return seek();
			}
	
			// 没有找到path，返回undefined
			return undefined;
		}
	}
	function addProtocol(url){
		if(!url.match(/^(https?)|(ftp):\/\//i)){
			url = "http://" + url;
		}
		return url;
	}
	function parseUrl(txt){
		txt = String(txt);
		// 可能有坑， 转义字符问题
		txt = txt.replace(/&amp;/g, "&");
		txt = txt.replace(/<br>/gi, "\n");
		txt = txt.replace(reg, function(match, a){
			// 判断是否为有效 url
			if(match){
				return "<a class=\"link\" href=\"" + addProtocol(match) + "\" target=\"_blank\">" + match + "</a>";
			}
			return match;
		});
		return txt.replace(/\n/g, "<br>");
	}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(19)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)(module)))

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 20,
		"./af.js": 20,
		"./ar": 21,
		"./ar-dz": 22,
		"./ar-dz.js": 22,
		"./ar-kw": 23,
		"./ar-kw.js": 23,
		"./ar-ly": 24,
		"./ar-ly.js": 24,
		"./ar-ma": 25,
		"./ar-ma.js": 25,
		"./ar-sa": 26,
		"./ar-sa.js": 26,
		"./ar-tn": 27,
		"./ar-tn.js": 27,
		"./ar.js": 21,
		"./az": 28,
		"./az.js": 28,
		"./be": 29,
		"./be.js": 29,
		"./bg": 30,
		"./bg.js": 30,
		"./bn": 31,
		"./bn.js": 31,
		"./bo": 32,
		"./bo.js": 32,
		"./br": 33,
		"./br.js": 33,
		"./bs": 34,
		"./bs.js": 34,
		"./ca": 35,
		"./ca.js": 35,
		"./cs": 36,
		"./cs.js": 36,
		"./cv": 37,
		"./cv.js": 37,
		"./cy": 38,
		"./cy.js": 38,
		"./da": 39,
		"./da.js": 39,
		"./de": 40,
		"./de-at": 41,
		"./de-at.js": 41,
		"./de-ch": 42,
		"./de-ch.js": 42,
		"./de.js": 40,
		"./dv": 43,
		"./dv.js": 43,
		"./el": 44,
		"./el.js": 44,
		"./en-au": 45,
		"./en-au.js": 45,
		"./en-ca": 46,
		"./en-ca.js": 46,
		"./en-gb": 47,
		"./en-gb.js": 47,
		"./en-ie": 48,
		"./en-ie.js": 48,
		"./en-nz": 49,
		"./en-nz.js": 49,
		"./eo": 50,
		"./eo.js": 50,
		"./es": 51,
		"./es-do": 52,
		"./es-do.js": 52,
		"./es.js": 51,
		"./et": 53,
		"./et.js": 53,
		"./eu": 54,
		"./eu.js": 54,
		"./fa": 55,
		"./fa.js": 55,
		"./fi": 56,
		"./fi.js": 56,
		"./fo": 57,
		"./fo.js": 57,
		"./fr": 58,
		"./fr-ca": 59,
		"./fr-ca.js": 59,
		"./fr-ch": 60,
		"./fr-ch.js": 60,
		"./fr.js": 58,
		"./fy": 61,
		"./fy.js": 61,
		"./gd": 62,
		"./gd.js": 62,
		"./gl": 63,
		"./gl.js": 63,
		"./gom-latn": 64,
		"./gom-latn.js": 64,
		"./he": 65,
		"./he.js": 65,
		"./hi": 66,
		"./hi.js": 66,
		"./hr": 67,
		"./hr.js": 67,
		"./hu": 68,
		"./hu.js": 68,
		"./hy-am": 69,
		"./hy-am.js": 69,
		"./id": 70,
		"./id.js": 70,
		"./is": 71,
		"./is.js": 71,
		"./it": 72,
		"./it.js": 72,
		"./ja": 73,
		"./ja.js": 73,
		"./jv": 74,
		"./jv.js": 74,
		"./ka": 75,
		"./ka.js": 75,
		"./kk": 76,
		"./kk.js": 76,
		"./km": 77,
		"./km.js": 77,
		"./kn": 78,
		"./kn.js": 78,
		"./ko": 79,
		"./ko.js": 79,
		"./ky": 80,
		"./ky.js": 80,
		"./lb": 81,
		"./lb.js": 81,
		"./lo": 82,
		"./lo.js": 82,
		"./lt": 83,
		"./lt.js": 83,
		"./lv": 84,
		"./lv.js": 84,
		"./me": 85,
		"./me.js": 85,
		"./mi": 86,
		"./mi.js": 86,
		"./mk": 87,
		"./mk.js": 87,
		"./ml": 88,
		"./ml.js": 88,
		"./mr": 89,
		"./mr.js": 89,
		"./ms": 90,
		"./ms-my": 91,
		"./ms-my.js": 91,
		"./ms.js": 90,
		"./my": 92,
		"./my.js": 92,
		"./nb": 93,
		"./nb.js": 93,
		"./ne": 94,
		"./ne.js": 94,
		"./nl": 95,
		"./nl-be": 96,
		"./nl-be.js": 96,
		"./nl.js": 95,
		"./nn": 97,
		"./nn.js": 97,
		"./pa-in": 98,
		"./pa-in.js": 98,
		"./pl": 99,
		"./pl.js": 99,
		"./pt": 100,
		"./pt-br": 101,
		"./pt-br.js": 101,
		"./pt.js": 100,
		"./ro": 102,
		"./ro.js": 102,
		"./ru": 103,
		"./ru.js": 103,
		"./sd": 104,
		"./sd.js": 104,
		"./se": 105,
		"./se.js": 105,
		"./si": 106,
		"./si.js": 106,
		"./sk": 107,
		"./sk.js": 107,
		"./sl": 108,
		"./sl.js": 108,
		"./sq": 109,
		"./sq.js": 109,
		"./sr": 110,
		"./sr-cyrl": 111,
		"./sr-cyrl.js": 111,
		"./sr.js": 110,
		"./ss": 112,
		"./ss.js": 112,
		"./sv": 113,
		"./sv.js": 113,
		"./sw": 114,
		"./sw.js": 114,
		"./ta": 115,
		"./ta.js": 115,
		"./te": 116,
		"./te.js": 116,
		"./tet": 117,
		"./tet.js": 117,
		"./th": 118,
		"./th.js": 118,
		"./tl-ph": 119,
		"./tl-ph.js": 119,
		"./tlh": 120,
		"./tlh.js": 120,
		"./tr": 121,
		"./tr.js": 121,
		"./tzl": 122,
		"./tzl.js": 122,
		"./tzm": 123,
		"./tzm-latn": 124,
		"./tzm-latn.js": 124,
		"./tzm.js": 123,
		"./uk": 125,
		"./uk.js": 125,
		"./ur": 126,
		"./ur.js": 126,
		"./uz": 127,
		"./uz-latn": 128,
		"./uz-latn.js": 128,
		"./uz.js": 127,
		"./vi": 129,
		"./vi.js": 129,
		"./x-pseudo": 130,
		"./x-pseudo.js": 130,
		"./yo": 131,
		"./yo.js": 131,
		"./zh-cn": 132,
		"./zh-cn.js": 132,
		"./zh-hk": 133,
		"./zh-hk.js": 133,
		"./zh-tw": 134,
		"./zh-tw.js": 134
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 19;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(17)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var WebIM = __webpack_require__(136);
	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	var commonConfig = __webpack_require__(177);
	var uikit = __webpack_require__(180);
	var apiHelper = __webpack_require__(181);
	var eventListener = __webpack_require__(185);
	var channel = __webpack_require__(186);
	var profile = __webpack_require__(178);
	var satisfaction = __webpack_require__(191);
	var customUrl = __webpack_require__(193);
	var imgView = __webpack_require__(194);
	var NoteIframe = __webpack_require__(197);
	var initPasteImage = __webpack_require__(198);
	var videoChat = __webpack_require__(199);
	// var videoChatAgora = require("./videoChatAgora");
	var videoChatAgora = __webpack_require__(208);
	var guessInfo = __webpack_require__(211);
	var Swiper = __webpack_require__(213);
	
	var TagSelector = __webpack_require__(214);
	var initAgentInputStatePoller = __webpack_require__(222);
	var initAgentStatusPoller = __webpack_require__(223);
	var initVisitorStatusPoller = __webpack_require__(224);
	var initQueuingNumberPoller = __webpack_require__(225);
	var initTransferToKefuButton = __webpack_require__(226);
	var initSessionList = __webpack_require__(227);
	var initGetGreetings = __webpack_require__(234);
	var initAgentNicknameUpdate = __webpack_require__(235);
	var initInputTopButton = __webpack_require__(236);
	var initInputH5Button = __webpack_require__(239);
	var emojiPanel = __webpack_require__(240);
	var extendMessageSender = __webpack_require__(242);
	var TenantInfo = __webpack_require__(243);
	var getToHost = __webpack_require__(190);
	var tenantInfo;
	var tagSelector = new TagSelector();
	
	var isMessageChannelReady;
	var config;
	var inputBoxPosition = "down";
	
	var topBar;
	var editorView;
	var doms;
	var noteIframe;
	var OnlyCloseSession;
	var OnlyCloseWindow;
	var welcomeListCount = 0;
	var restLength = 0;
	var noUploadDialog;
	var blackList = ["ASP", "EXE", "ASA", "VBS", "BAT", "PIF", "SCR"];
	
	var _reCreateImUser = _.once(function(){
		console.warn("user not found in current appKey, attempt to recreate user.");
		apiHelper.createVisitor().then(function(entity){
			var cacheKeyName = (config.configId || (config.to + config.tenantId + config.emgroup));
			commonConfig.setConfig({
				user: _.extend(
					{},
					commonConfig.getConfig().user,
					{ username: entity.userId, password: entity.userPassword }
				),
				userNicknameFlg: nicename
			});
			if(entity.userPassword === ""){
				profile.imRestDown = true;
			}
	
			_initSession();
	
			if(utils.isTop){
				utils.set("root" + (config.configId || (config.tenantId + config.emgroup)), entity.userId);
				// utils.set(entity.userId, entity.nicename);
			}
			else{
				getToHost.send({
					event: _const.EVENTS.CACHEUSER,
					data: {
						key: cacheKeyName,
						value: entity.userId,
					}
				});
			}
		});
	});
	
	module.exports = {
		init: _init,
		close: _close,
		show: _show,
		getDom: _getDom,
	};
	
	function _initSystemEventListener(){
		eventListener.add([
			_const.SYSTEM_EVENT.SESSION_OPENED,
			_const.SYSTEM_EVENT.SESSION_RESTORED,
		], function(officialAccount){
			var sessionId = officialAccount.sessionId;
			var isSessionOpen = officialAccount.isSessionOpen;
			if(isSessionOpen && sessionId){
				apiHelper.reportVisitorAttributes(sessionId);
			}
		});
		// 禁止所有容器中 robotList 消息可操作
		eventListener.add([
			_const.SYSTEM_EVENT.SESSION_CLOSED,
		], function(officialAccount){
			// 所有的 list 子类消息
			var allListBtn1 = document.querySelectorAll(".msgtype-robotList .em-btn-list button");
			var allListBtn2 = document.querySelectorAll(".msgtype-txt .em-btn-list button");
			var allListBtn3 = document.querySelectorAll(".msgtype-img .em-btn-list button");
			var all = _.toArray(allListBtn1)
				.concat(_.toArray(allListBtn2))
				.concat(_.toArray(allListBtn3));
			_.each(all, function(robotBtn){
				utils.addClass(robotBtn, "disabled");
			});
	
			// 会话关闭，隐藏，转人工按钮，留言按钮
			var toKefuBtn = document.querySelector(".em-widget-to-kefu");
			var toTicketBtn = document.querySelector(".em-widget-to-ticket");
			utils.addClass(toKefuBtn, "hide");
			utils.addClass(toTicketBtn, "hide");
		});
	}
	
	function _initUI(){
		((utils.isTop && !utils.isMobile) || !config.minimum) && utils.removeClass(doms.imChat, "hide");
	
		// 设置联系客服按钮文字
		document.querySelector(".em-widget-pop-bar").innerText = config.buttonText;
	
		// 判断灰度 关闭会话框按钮
		profile.grayList.visitorLeave
			&& !utils.isTop
			&& utils.removeClass(doms.closeBtn, "hide");
	
		// 最小化按钮
		config.minimum
			&& !utils.isTop
			&& utils.removeClass(doms.minifyBtn, "hide");
	
		// h5title设置
		if(config.ui.H5Title.enabled){
			document.title = config.ui.H5Title.content;
		}
	
		// 静音按钮
		window.HTMLAudioElement
			&& !utils.isMobile
			&& config.soundReminder
			&& utils.removeClass(doms.audioBtn, "hide");
	
		// 输入框位置开关
		utils.isMobile
			&& !config.hideKeyboard
			&& utils.removeClass(doms.switchKeyboardBtn, "hide");
	}
	
	function _initToolbar(){
		// 低版本浏览器不支持上传文件/图片
		if(WebIM.utils.isCanUploadFileAsync){
			utils.removeClass(doms.sendImgBtn, "hide");
			utils.removeClass(doms.sendVideoBtn, "hide");
		}
		// 小视频按钮
		if(config.sendSmallVideo){
			utils.removeClass(doms.sendVideoBtn, "hide");
		}
		else if(config.toolbar.sendSmallVideo){
			utils.removeClass(doms.sendVideoBtn, "hide");
		}
		else{
			utils.addClass(doms.sendVideoBtn, "hide");
		}
		// 上传图片按钮
		if(config.toolbar.sendImage){
			utils.removeClass(doms.sendImgBtn, "hide");
		}
		else{
			utils.addClass(doms.sendImgBtn, "hide");
		}
		// 上传附件按钮
		if(WebIM.utils.isCanUploadFileAsync && config.toolbar.sendAttachment){
			utils.removeClass(doms.sendFileBtn, "hide");
		}
	
		// 留言按钮
		config.ticket && utils.removeClass(doms.noteBtn, "hide");
	
		// 满意度评价按钮
		if(config.satisfaction && config.options.showEnquiryButtonInAllTime == "true"){
			utils.removeClass(doms.satisfaction, "hide");
		}
	}
	
	function _initSoundReminder(){
		if(!window.HTMLAudioElement || utils.isMobile || !config.soundReminder) return;
	
		var audioDom = document.createElement("audio");
		var slienceSwitch = document.querySelector(".em-widget-header .btn-audio");
		var isSlienceEnable = false;
		var play = _.throttle(function(){
			audioDom.play();
		}, 3000, { trailing: false });
	
		audioDom.src = config.staticPath + "/mp3/msg.m4a";
	
		// 音频按钮静音
		utils.on(slienceSwitch, "click", function(){
			isSlienceEnable = !isSlienceEnable;
			utils.toggleClass(slienceSwitch, "icon-slience", isSlienceEnable);
			utils.toggleClass(slienceSwitch, "icon-bell", !isSlienceEnable);
			if(isSlienceEnable){
				$(slienceSwitch).attr("title", "Close Mute");
			}
			else{
				$(slienceSwitch).attr("title", "Mute");
			}
		});
	
		eventListener.add(_const.SYSTEM_EVENT.MESSAGE_PROMPT, function(){
			!isSlienceEnable && play();
		});
	}
	
	function _setLogo(){
		if(!config.logo.enabled) return;
		if (config.logo.content && Array.isArray(config.logo.content) && config.logo.content.length) {
			var logoImgWapper = document.querySelector(".em-widget-tenant-logo");
			var swiperSlideObj = document.createDocumentFragment();
			config.logo.content.map(function(item) {
				var swiperSlide = $('<div class="swiper-slide"><a href="'+ (item.url || 'javascript:void(0)') +'" target="'+ (item.url && '_blank') +'"><img src="'+ item.thumail +'" /></a></div>');
				swiperSlideObj.appendChild(swiperSlide[0]);
			});
			logoImgWapper.getElementsByClassName('swiper-wrapper')[0].appendChild(swiperSlideObj);
			var swiperH5 = new Swiper('.em-widget-tenant-logo .mySwiper',{
				pagination: {
					el: '.em-widget-tenant-logo .swiper-pagination',
					clickable:true,
				},//这样写小圆点就有了
				resistanceRatio : 0,
				observer: true,//修改swiper自己或子元素时，自动初始化swiper
				observeParents: true,//修改swiper的父元素时，自动初始化swiper
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
			});
	
			utils.removeClass(logoImgWapper, "hide");
		}
	}
	
	function _setNotice(){
		var noticeContent = document.querySelector(".em-widget-tip .content");
		var noticeCloseBtn = document.querySelector(".em-widget-tip .tip-close");
		apiHelper.getNotice().then(function(notice){
			// test
			// notice.content = [
			// 	{
			// 		name: "自考介绍",
			// 		sub_button: [
			// 			{
			// 				type: "view",
			// 				name: "搜索2666",
			// 				url: "http://www.soso.com/"
			// 			}
			// 		]
			// 	},
			// 	{
			// 		type: "media_id",
			// 		name: "报考指南",
			// 		media_id: "75cffa4b-e462-40e8-a517-0ff807db29a6"
			// 	},
			// 	{
			// 		name: "课程试听",
			// 		sub_button: [
			// 			{
			// 				type: "media_id",
			// 				name: "111",
			// 				media_id: "75cffa4b-e462-40e8-a517-0ff807db29a6"
			// 			},
			// 			{
			// 				type: "media_id",
			// 				name: "香格里拉",
			// 				media_id: "4150c891-9917-4482-909c-ab7c9954110a"
			// 			}
			// 		]
			// 	}
			// ];
	
	
			var slogan = notice.content;
			if(!notice.enabled) return;
	
			// 显示信息栏
			utils.addClass(doms.imChat, "has-tip");
	
			// 新配置就走新 tenantInfo
			if(config.isWebChannelConfig){
				if(typeof slogan == "string"){
					renderSlogan();
				}
				else{
					tenantInfo = new TenantInfo();
				}
			}
			else{
				renderSlogan();
			}
	
			function renderSlogan(){
	
				if(!profile.grayList.poweredByEasemob){
					if(!utils.isMobile){
						if(!$("#em-kefu-webim-self").hasClass("hide")){
							$(".em-widget-send-wrapper").css("height", "140px !important");
							document.querySelector(".chat-wrapper").style.cssText = "top:65px;bottom\", \"140px !important;left:10px;background: #fff;padding-right:10px;";
						}
						else{
							// document.querySelector(".chat-wrapper").style.cssText='top:65px;bottom", "140px !important;background: #fff;';
						}
					}
				}
				else if(!utils.isMobile){
					if(!$("#em-kefu-webim-self").hasClass("hide")){
						document.querySelector(".chat-wrapper").style.cssText = "top:65px;left:10px;background: #fff;padding-right:10px;bottom:170px";
					}
					else{
						document.querySelector(".chat-wrapper").style.cssText = "top:45px;background: #fff;bottom:170px";
					}
				}
				// 设置信息栏内容
				noticeContent.innerHTML = WebIM.utils.parseLink(slogan);
				// 隐藏信息栏按钮
				utils.on(noticeCloseBtn, utils.click, function(){
					// 隐藏信息栏
					utils.removeClass(doms.imChat, "has-tip");
					if(!utils.isMobile && !$("#em-kefu-webim-self").hasClass("hide")){
						var bottomEl = $(".chat-wrapper").css("bottom");
						document.querySelector(".chat-wrapper").style.cssText = "top:10px;left: 10px;padding-right: 10px;bottom:" + bottomEl;
					}
					else if($("#em-kefu-webim-self").hasClass("hide") && !utils.isMobile){
						document.querySelector(".chat-wrapper").style.cssText = "top:0px;";
					}
				});
			}
		});
	}
	
	function _setOffline(){
		switch(config.offDutyType){
		case "none":
				// 下班禁止留言、禁止接入会话
			var modelDom = utils.createElementFromHTML("<div class=\"em-model\"></div>");
			var offDutyPromptDom = utils.createElementFromHTML([
				"<div class=\"em-dialog off-duty-prompt\">",
				"<div class=\"bg-color header\">" + "Tips" + "</div>",
				"<div class=\"body\">",
				"<p class=\"content\">" + config.offDutyWord + "</p>",
				"</div>",
				"</div>"
			].join(""));
			doms.imChat.appendChild(modelDom);
			doms.imChat.appendChild(offDutyPromptDom);
			doms.sendBtn.innerHTML = "Send";
			break;
		default:
				// 只允许留言此时无法关闭留言页面
			noteIframe.open({ hideCloseBtn: true, offDutyType: config.offDutyType });
				// utils.on($(".ticket .wrapper-title>.icon-close"), "click", function(){
				// 	window.close();
				// })
			break;
		}
	
		getToHost.send({ event: _const.EVENTS.ON_OFFDUTY });
	}
	
	function _scrollToBottom(){
		var scrollToBottom = utils.getDataByPath(profile, "currentOfficialAccount.messageView.scrollToBottom");
		// 有可能在 messageView 未初始化时调用
		// todo: remove this detect
		typeof scrollToBottom === "function" && scrollToBottom();
	}
	
	function _checkGradeType(){
		var riskWarning = document.querySelector(".em-widget-risk-warning");
		apiHelper.getGradeType().then(function(data){
			var entity = data.entity;
			var grade = entity.grade;
	
			var defaultAvatar = commonConfig.getConfig().staticPath + "/img/qiye.png";
			var avatar = entity.avatar;
			var topBar = document.querySelector(".em-widget-header");
			$agentFace = topBar.querySelector(".em-agent-face");
			if(avatar){
				$agentFace.src = avatar;
			}
			else{
				$agentFace.src = defaultAvatar;
			}
			utils.removeClass($agentFace, "hide");
	
			if(grade == "TRIAL"){
				riskWarning.style.display = "block";
				utils.addClass(doms.imChat, "has-risk-tip");
			}
			else{
				riskWarning.style.display = "none";
				utils.removeClass(doms.imChat, "has-risk-tip");
			}
		});
	}
	
	function _initAutoGrow(){
		var originHeight = doms.textInput.clientHeight || 34;
	
		// 键盘上下切换按钮
		utils.on(doms.switchKeyboardBtn, "click", function(){
			var status = utils.hasClass(this, "icon-keyboard-down");
			var height = doms.editorView.getBoundingClientRect().height;
			inputBoxPosition = status ? "down" : "up";
	
			utils.toggleClass(this, "icon-keyboard-up", status);
			utils.toggleClass(this, "icon-keyboard-down", !status);
			emojiPanel.move(inputBoxPosition, height);
	
			switch(inputBoxPosition){
			case "up":
				doms.editorView.style.bottom = "auto";
				doms.editorView.style.zIndex = "3";
				doms.editorView.style.top = "";
				doms.chatWrapper.style.bottom = "0";
				doms.queuingNumberStatus.style.top = height + "px";
				doms.editorView.style.paddingBottom = "0";
				break;
			case "down":
				doms.editorView.style.bottom = "0";
				doms.editorView.style.zIndex = "3";
				doms.editorView.style.top = "auto";
				doms.chatWrapper.style.bottom = height + "px";
					// doms.queuingNumberStatus.style.top = "-26px";
				doms.queuingNumberStatus.style.top = "-40px";
				doms.editorView.style.paddingBottom = "max(3px,env(safe-area-inset-bottom))";
				_scrollToBottom();
				break;
			default:
				throw new Error("unexpected inputBoxPosition.");
			}
		});
	
		utils.on(doms.textInput, "input change", update);
	
		// todo: 高度不改变时，不更新dom
		function update(){
			var height = this.value ? this.scrollHeight : originHeight;
			this.style.height = height + "px";
			this.scrollTop = 9999;
			callback();
		}
	
		function callback(){
			var height = doms.editorView.getBoundingClientRect().height || 76;
			if(inputBoxPosition === "up"){
				doms.queuingNumberStatus.style.top = height + "px";
			}
			else{
				doms.chatWrapper.style.bottom = height + "px";
			}
			emojiPanel.move(inputBoxPosition, height);
	
			_scrollToBottom();
		}
	}
	
	function _initOfficialAccount(){
		return new Promise(function(resolve, reject){
			apiHelper.getOfficalAccounts().then(function(officialAccountList){
				_.each(officialAccountList, channel.attemptToAppendOfficialAccount);
	
				if(!profile.ctaEnable){
					profile.currentOfficialAccount = profile.systemOfficialAccount;
					profile.systemOfficialAccount.messageView.show();
				}
	
				eventListener.excuteCallbacks(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_LIST_GOT, []);
	
				resolve();
			}, function(err){
				// 未创建会话时初始化默认服务号
				if(err === _const.ERROR_MSG.VISITOR_DOES_NOT_EXIST){
					// init default system message view
					channel.attemptToAppendOfficialAccount({
						type: "SYSTEM",
						official_account_id: "default",
						img: null
					});
	
					profile.currentOfficialAccount = profile.systemOfficialAccount;
					profile.systemOfficialAccount.messageView.show();
	
					eventListener.excuteCallbacks(_const.SYSTEM_EVENT.SESSION_NOT_CREATED, [profile.systemOfficialAccount]);
	
					resolve();
				}
				else{
					reject(err);
				}
			});
		});
	}
	
	function _bindEvents(){
		if(!utils.isTop){
			// 关闭会话框按钮
			utils.on(doms.closeBtn, "click", function(){
				// 调用关闭会话框接口记录访客离开
				var officialAccount = profile.currentOfficialAccount;
				var sessionId = officialAccount.sessionId;
				var currentState = officialAccount.sessionState;
	
				// 查询会话是否已经评价，评价了就不弹出评价邀请框了
				apiHelper.getSessionEnquires(sessionId)
				.then(function(res){
					if(!res.length){
							// 弹出评价邀请框
						if(typeof (config.options.onlyCloseSession) == "undefined"){
							config.options.onlyCloseSession = "true";
						}
						if(typeof (config.options.onlyCloseWindow) == "undefined"){
							config.options.onlyCloseWindow = "true";
						}
						if(config.options.closeSessionWhenCloseWindow == "true" && config.options.onlyCloseSession == "true" && (currentState == "Wait" || currentState == "Processing")){
							satisfaction.show(null, sessionId, "system");
						}
						else if(config.options.closeSessionWhenCloseWindow == "false" && config.options.onlyCloseWindow == "true" && (currentState == "Wait" || currentState == "Processing")){
							satisfaction.show(null, sessionId, "system");
						}
						else{
							eventListener.trigger(_const.SYSTEM_EVENT.CHAT_CLOSED);
							sessionId && apiHelper.closeChatDialog({ serviceSessionId: sessionId });
							getToHost.send({ event: _const.EVENTS.CLOSE });
							utils.setStore("isHaveCustomerMsg", false);
						}
					}
					else{
							// 取消轮询接口
						eventListener.trigger(_const.SYSTEM_EVENT.CHAT_CLOSED);
						sessionId && apiHelper.closeChatDialog({ serviceSessionId: sessionId });
						getToHost.send({ event: _const.EVENTS.CLOSE });
					}
				});
	
				// 关闭并且结束会话
				var agentType = officialAccount.agentType;
				var isRobotAgent = agentType === _const.AGENT_ROLE.ROBOT;
				// 仅机器人接待时关闭会话
				if(isRobotAgent && officialAccount.isSessionOpen && profile.grayList.visitorLeave && config.options.closeSessionWhenCloseWindow == "true"){
					sessionId && apiHelper.visitorCloseSession({ serviceSessionId: sessionId });
				}
	
			});
	
			// 最小化按钮
			utils.on(doms.minifyBtn, "click", function(){
				getToHost.send({ event: _const.EVENTS.CLOSE });
			});
	
			utils.on(document, "mouseover", function(){
				getToHost.send({ event: _const.EVENTS.RECOVERY });
			});
		}
	
		utils.on(doms.chatWrapper, "click", function(){
			doms.textInput.blur();
			// toolbar-mobile 隐藏
			if(utils.isMobile && !utils.hasClass(doms.toolBar, "hide")){
				utils.addClass(doms.toolBar, "hide");
				var height = doms.editorView.getBoundingClientRect().height;
				if(inputBoxPosition === "up"){
					doms.chatWrapper.style.bottom = "0";
					doms.queuingNumberStatus.style.top = height + "px";
				}
				else{
					doms.chatWrapper.style.bottom = height + "px";
	
				}
				emojiPanel.move(inputBoxPosition, height);
			}
		});
		utils.on(doms.chatWrapper, "touchmove", function(){
			// toolbar-mobile 隐藏
			if(utils.isMobile && !utils.hasClass(doms.toolBar, "hide")){
				utils.addClass(doms.toolBar, "hide");
				var height = doms.editorView.getBoundingClientRect().height;
				if(inputBoxPosition === "up"){
					doms.chatWrapper.style.bottom = "0";
					doms.queuingNumberStatus.style.top = height + "px";
				}
				else{
					doms.chatWrapper.style.bottom = height + "px";
				}
				emojiPanel.move(inputBoxPosition, height);
			}
		});
	
		utils.live("img.em-widget-imgview", "click", function(){
			var imgSrc = this.getAttribute("src");
			imgView.show(imgSrc);
		});
	
		if(config.dragenable && !utils.isTop && !utils.isMobile){
	
			doms.dragBar.style.cursor = "move";
	
			utils.on(doms.dragBar, "mousedown", function(ev){
				var e = window.event || ev;
				doms.textInput.blur(); // ie a  ie...
				getToHost.send({
					event: _const.EVENTS.DRAGREADY,
					data: {
						x: e.clientX,
						y: e.clientY
					}
				});
				return false;
			}, false);
		}
	
		if(utils.isMobile){
			// 全屏播放视频
			utils.live("div.icon-play-box", "click", function(){
				var url = this.previousSibling.dataset.url;
				utils.removeClass(doms.videoPlayContainer, "hide");
				var html = "<video controls autoplay x5-video-player-fullscreen='false' x5-video-player-type='h5' x5-playsinline='true' data-url=\"" + url + " \" src=\"" + url + " \">"
					+ "<source  src=\"" + url + " \" type=\"video/mp4\"></source>"
					+ "<source  src=\"" + url + " \" type=\"video/webm\"></source>"
					+ "<source  src=\"" + url + " \" type=\"video/ogg\"></source>"
					+ "</video>";
	
				doms.videoPlayBox.appendChild(utils.createElementFromHTML(html));
			});
			// 退出视频全屏
			utils.on(doms.videoBoxClose, "click", function(){
				utils.addClass(doms.videoPlayContainer, "hide");
				doms.videoPlayBox.innerHTML = "";
			});
		}
	
	
		// resend
		utils.live("div.em-widget-msg-status", "click", function(){
			var id = this.getAttribute("id").slice(0, -"_failed".length);
			var type = this.getAttribute("data-type");
	
			channel.reSend(type, id);
			utils.addClass(this, "hide");
			utils.removeClass(document.getElementById(id + "_loading"), "hide");
		});
		// 点击感叹号resend
		utils.live("div.em-widget-msg-status .icon-exclamation", "click", function(){
			var that = this.parentElement.parentElement;
			var id = that.getAttribute("id").slice(0, -"_failed".length);
			var type = that.getAttribute("data-type");
	
			channel.reSend(type, id);
			utils.addClass(that, "hide");
			utils.removeClass(document.getElementById(id + "_loading"), "hide");
		});
	
	
	
		utils.live("button.js_robotTransferBtn", "click", function(e){
			var id = this.getAttribute("data-id");
			var ssid = this.getAttribute("data-sessionid");
			var transferToHumanId = this.getAttribute("data-transferToHumanId");
			// 只能点击一次
			if(!this.clicked){
				this.clicked = true;
				if(!utils.hasClass(e.target, "disabled")){
					channel.sendTransferToKf(id, ssid, transferToHumanId);
				}
			}
		});
	
		utils.live("button.js-transfer-to-ticket", "click", function(){
			var officialAccount = profile.currentOfficialAccount;
			if(!officialAccount){
				return;
			}
			var isSessionOpen = officialAccount.isSessionOpen;
			var sessionId = officialAccount.sessionId;
			isSessionOpen && apiHelper.closeServiceSession(sessionId);
			var config = commonConfig.getConfig();
			if(config.toolbar.ticketUrlStatus){
				window.open(config.toolbar.ticketUrl);
			}
			else{
				noteIframe.open({
					preData: {
						name: config.visitor.trueName,
						phone: config.visitor.phone,
						mail: config.visitor.email,
					}
				});
			}
		});
	
		// 机器人列表
		utils.live("button.js_robotbtn", "click", function(e){
			if(!utils.hasClass(e.target, "disabled")){
	      // 这里为敦煌定制(格式很坑)
	      var dhCallback = e.target.dataset.callback
	      var dhNode = e.target.dataset.node
	      var text = dhCallback ? dhCallback : this.innerText
	      
				channel.sendText(text, {
					ext: {
						msgtype: {
							choice: {
								menuid: this.getAttribute("data-id")
							}
						},
	          dhRobot: {
	            node: dhNode
	          }
					}
				});
			}
		});
	
		// 机器人列表
		utils.live(".welcome-change", "click", function(e){
			var allDom = e.target.parentElement.parentElement.children;
			var buttonDomList = [];
	
			_.each(allDom, function(ele){
				if(ele != e.target.parentElement){
					buttonDomList.push(ele);
				}
			});
	
			if((welcomeListCount + 1) * 5 >= buttonDomList.length){
				welcomeListCount = 0;
			}
			else{
				welcomeListCount++;
			}
	
			_.each(buttonDomList, function(ele, index){
				if((index + 1) > welcomeListCount * 5 && (index + 1) <= (welcomeListCount * 5 + 5)){
					utils.removeClass(ele, "hide");
				}
				else{
					utils.addClass(ele, "hide");
				}
			});
		});
	
		// 机器人关联规则列表
		utils.live("button.js_robotRelateListbtn", "click", function(e){
			var menuData;
			if(!utils.hasClass(e.target, "disabled")){
				menuData = {
					ruleId: this.getAttribute("data-ruleId"),
					answerId: this.getAttribute("data-answerId"),
					relatedRuleId: this.getAttribute("data-relatedRuleId")
				};
				channel.sendText(this.innerText, {
					ext: {
						msgtype: {
							choice: {
								relatedRuleClickActionData: JSON.stringify(menuData)
							}
						}
					}
				});
			}
		});
	
		// 根据菜单项选择指定的技能组
		utils.live("button.js_skillgroupbtn", "click", function(){
			channel.sendText(this.innerText, {
				ext: {
					weichat: {
						queueName: this.getAttribute("data-queue-name") === "null" ? null : this.getAttribute("data-queue-name")
					}
				}
			});
		});
	
		// 转人工————根据询前引导菜单选择指定的一项
		utils.live("button.js_transferManualbtn", "click", function(){
			if(utils.hasClass(this, "disabled")){
				// 禁止发送
			}
			else if(this.getAttribute("data-queue-type") == "txt"){
				channel.sendText(this.innerText, {
					ext: {
						msgtype: {
							mode: "transferManualGuide",
							choice: {
								menuid: this.getAttribute("data-id"),
								queueId: this.getAttribute("data-queue-id"),
								queueType: "txt"
							}
						}
					}
				});
			}
			else if(this.getAttribute("data-queue-type") == "video" || this.getAttribute("data-queue-type") == 'independentVideo'){ // 独立视频先使用融合
				channel.sendText(this.innerText, {
					ext: {
						msgtype: {
							mode: "transferManualGuide",
							choice: {
								menuid: this.getAttribute("data-id"),
								queueId: this.getAttribute("data-queue-id"),
								queueType: "video"
							}
						}
					}
				});
			}
			else if(this.getAttribute("data-queue-type") == "transfer"){
				noteIframe.open();
			}
			else{
	
			}
	
	
		});
		// 入口指定————询前引导
		utils.live("button.js_transferManualEntrybtn", "click", function(){
			if(utils.hasClass(this, "disabled")){
				// 禁止发送
			}
			else if(this.getAttribute("data-queue-type") == "txt"){
				channel.sendText(this.innerText, {
					ext: {
						weichat: {
							queueName: this.getAttribute("data-queue-name") === "null" ? null : this.getAttribute("data-queue-name")
						}
					}
				});
			}
			else if(this.getAttribute("data-queue-type") == "video" || this.getAttribute("data-queue-type") == "independentVideo"){
				doms.videoInviteButton.click();
			}
			else if(this.getAttribute("data-queue-type") == "transfer"){
				noteIframe.open();
			}
			else{
	
			}
	
		});
	
	
		// 满意度评价
		utils.live("button.js_satisfybtn", "click", function(){
			var serviceSessionId = this.getAttribute("data-servicesessionid");
			var inviteId = this.getAttribute("data-inviteid");
			satisfaction.show(inviteId, serviceSessionId, "agent");
		});
	
		// 解决
		utils.live(".statisfyYes", "click", function(){
			var satisfactionCommentKey = this.getAttribute("data-satisfactionCommentInfo");
			var robotAgentId = this.getAttribute("data-agentId");
			apiHelper.getStatisfyYes(robotAgentId, satisfactionCommentKey).then(function(data){
				uikit.tip("谢谢");
			}, function(err){
				if(err.errorCode === "KEFU_ROBOT_INTEGRATION_0207"){
					uikit.tip("已评价");
				}
			});
			utils.setStore("isHaveCustomerMsg", false);
		});
	
		// 未解决
		utils.live(".statisfyNo", "click", function(){
			var satisfactionCommentKey = this.getAttribute("data-satisfactionCommentInfo");
			var robotAgentId = this.getAttribute("data-agentId");
	
			apiHelper.getSatisfactionCommentTags(robotAgentId, satisfactionCommentKey)
			.then(function(dat){
				if(dat.length > 0){
						// tagSelector = new TagSelector(dat, robotAgentId, satisfactionCommentKey);
					tagSelector.show(dat, robotAgentId, satisfactionCommentKey);
				}
				else{
					apiHelper.confirmSatisfaction(robotAgentId, satisfactionCommentKey)
					.then(function(){
						uikit.tip("谢谢");
					}, function(err){
						if(err.errorCode === "KEFU_ROBOT_INTEGRATION_0207"){
							uikit.tip("已评价");
						}
					});
					utils.setStore("isHaveCustomerMsg", false);
				}
			});
		});
	
		utils.live("#em-article-close .icon-back", "click", function(){
			var articleContainer = document.getElementById("em-article-container");
			var iframe = articleContainer.querySelector("iframe");
			iframe && utils.removeDom(iframe);
			articleContainer.style.display = "none";
			doms.editorView.style.display = "block";
			tenantInfo && tenantInfo.show();
		});
	
		// 交易风险提醒
		utils.live("#em-kefu-webim-chat .em-widget-risk-warning .icon-close", "click", function(){
			var riskWarning = document.querySelector(".em-widget-risk-warning");
			riskWarning.style.display = "none";
			utils.removeClass(doms.imChat, "has-risk-tip");
		});
		// 提示有新消息
		eventListener.add(_const.SYSTEM_EVENT.MESSAGE_APPENDED, function(oa, msg){
			utils.addClass(document.body.querySelector("#em-article-close .back-chat"), "hide");
			utils.removeClass(document.body.querySelector("#em-article-close .new-message"), "hide");
		});
		utils.live(".article-link", "click", function(e){
			var sendStatus = e.target.dataset.status;
			var curArticleDom = e.target.parentNode;
			var url = e.target.firstElementChild.innerText;
			url = utils.sameProtocol(url);
			window.open(url);
			// 根据sendStatus状态判断是否应该显示‘我正在看’状态
			if(sendStatus == "false"){
				// 发送一条图文
				channel.sendText("", {
					ext: {
						msgtype: {
							track: {
								// 消息标题
								title: "我正在看：",
								// 商品描述
								desc: curArticleDom.querySelector(".title").innerText,
								// 商品图片链接
								img_url: (
									curArticleDom.querySelector(".cover")
									|| curArticleDom.querySelector(".cover-img")
								).getAttribute("src"),
								// 商品页面链接
								item_url: url
							}
						}
					}
				});
			}
		});
	
		var messagePredict = _.throttle(function(msg){
			var officialAccount = profile.currentOfficialAccount || {};
			var sessionId = officialAccount.sessionId;
			var sessionState = officialAccount.sessionState;
			var agentType = officialAccount.agentType;
			var content = utils.getBrief(msg, _const.MESSAGE_PREDICT_MAX_LENGTH);
	
			if(
				sessionState === _const.SESSION_STATE.PROCESSING
				&& agentType !== _const.AGENT_ROLE.ROBOT
				&& sessionId
			){
				apiHelper.reportPredictMessage(sessionId, content);
			}
		}, 1000);
	
		function handleSendBtn(){
			var toKefuBtn = document.querySelector(".em-widget-to-kefu");
			var toTicketBtn = document.querySelector(".em-widget-to-ticket");
			// var toKefuBtn = document.querySelector(".em-widget-to-kefu-input-button");
			var isEmpty = !doms.textInput.value.trim();
	
			utils.toggleClass(
				doms.sendBtn,
				"disabled", !isMessageChannelReady || isEmpty
			);
			utils.toggleClass(
				doms.sendBtn,
				"bg-color", !isEmpty
			);
			// 自定义主题色
			var color = "";
			var themeClassName;
			var config = commonConfig.getConfig();
			var themeName = config.ui.themeName;
			if(themeName && themeName.indexOf("theme_custom") > -1){
				var arr = themeName.split("theme_custom");
				color = arr[1];
				themeClassName = "theme_custom";
			}
			else{
				themeClassName = _const.themeMap[config.themeName];
			}
			if(!isEmpty && color){
				$(".em-widget-send").css("cssText", "background-color: " + color + " !important");
			}
			else if(isEmpty && color){
				$(".em-widget-send").css("cssText", "background-color:#e4e6e9 !important");
			}
			profile.grayList.msgPredictEnable
				&& !isEmpty
				&& isMessageChannelReady
				&& messagePredict(doms.textInput.value);
	
			if(utils.isMobile){
				utils.removeClass(doms.emojiToggleButton, "hide");
				if(utils.hasClass(doms.sendBtn, "disabled")){
					utils.removeClass(doms.addBtn, "hide");
					if(utils.hasClass(toKefuBtn, "hide")){
						doms.textInput.style.maxWidth = "calc(100% - 45px)";
					}
					else{
						doms.textInput.style.maxWidth = "calc(100% - 90px)";
					}
					doms.emojiToggleButton.style.right = "40px";
	
				}
				else{
					utils.addClass(doms.addBtn, "hide");
					if(utils.hasClass(toKefuBtn, "hide")){
						doms.textInput.style.maxWidth = "calc(100% - 80px)";
					}
					else{
						doms.textInput.style.maxWidth = "calc(100% - 125px)";
					}
					doms.emojiToggleButton.style.right = "75px";
				}
			}
	
			eventListener.add(_const.eventMessageText.TICKET, function(){
				if(!utils.hasClass(toKefuBtn, "hide")){
					utils.addClass(toKefuBtn, "hide");
					utils.removeClass(toTicketBtn, "hide");
				}
			});
		}
	
		if(Modernizr.oninput){
			utils.on(doms.textInput, "input change", handleSendBtn);
		}
		else{
			utils.on(doms.textInput, "keyup change", handleSendBtn);
		}
	
		if(utils.isMobile){
			utils.on(doms.textInput, "focus touchstart", function(){
				doms.textInput.style.overflowY = "auto";
				_scrollToBottom();
			});
		}
	
		// 发送小视频
		utils.on(doms.videoInput, "change", function(){
			var fileInput = doms.videoInput;
			var filesize = utils.getDataByPath(fileInput, "files.0.size");
			var maxSize, tip;
			if(profile.grayList.uploadFileLimit){
				maxSize = 1024 * 1024 * 20;
				tip = "The file size cannot exceed 20 MB.";
			}
			else{
				maxSize = _const.UPLOAD_FILESIZE_LIMIT;
				tip = "The file size cannot exceed 10 MB.";
			}
			if(!fileInput.value){
			}
			else if(filesize > maxSize){
				uikit.tip(tip);  // ("文件大小不能超过10MB");
				fileInput.value = "";
			}
			else{
				var nameList = WebIM.utils.getFileUrl(fileInput) && WebIM.utils.getFileUrl(fileInput).filename.split(".");
				if(blackList.indexOf(nameList[nameList.length - 1].toLocaleUpperCase()) != -1){
					fileInput.value = "";
					noUploadTip();
					return;
				}
				channel.sendVideo(WebIM.utils.getFileUrl(fileInput)); // sendVideo 取自 channel.js
				fileInput.value = "";
			}
		});
	
		// 发送文件
		utils.on(doms.fileInput, "change", function(){
			var maxSize, tip;
			if(profile.grayList.uploadFileLimit){
				maxSize = 1024 * 1024 * 20;
				tip = "The file size cannot exceed 20 MB.";
			}
			else{
				maxSize = _const.UPLOAD_FILESIZE_LIMIT;
				tip = "The file size cannot exceed 10 MB.";
			}
			var fileInput = doms.fileInput;
			var filesize = utils.getDataByPath(fileInput, "files.0.size");
	
			if(!fileInput.value){
				// 未选择文件
			}
			else if(filesize > maxSize){
				uikit.tip(tip);
				fileInput.value = "";
			}
			else{
				var nameList = WebIM.utils.getFileUrl(fileInput) && WebIM.utils.getFileUrl(fileInput).filename.split(".");
				if(blackList.indexOf(nameList[nameList.length - 1].toLocaleUpperCase()) != -1){
					fileInput.value = "";
					noUploadTip();
					return;
				}
				channel.sendFile(WebIM.utils.getFileUrl(fileInput));
				fileInput.value = "";
			}
		});
	
		// qq web browser patch
		// qq浏览器有时无法选取图片
		if(utils.isQQBrowser && utils.isAndroid){
			doms.imgInput.setAttribute("accept", "image/*");
		}
		var maxSize, tip;
		if(profile.grayList.uploadFileLimit){
			maxSize = 1024 * 1024 * 20;
			tip = "The file size cannot exceed 20 MB.";
		}
		else{
			maxSize = _const.UPLOAD_FILESIZE_LIMIT;
			tip = "The file size cannot exceed 10 MB.";
		}
		// 发送图片
		utils.on(doms.imgInput, "change", function(){
			var fileInput = doms.imgInput;
			// ie8-9 do not support multifiles, so you can not get files
			var filesize = utils.getDataByPath(fileInput, "files.0.size");
	
			if(!fileInput.value){
				// 未选择文件
			}
			// 某些浏览器不能获取到正确的文件名，所以放弃文件类型检测
			// else if (!/\.(png|jpg|jpeg|gif)$/i.test(fileInput.value)) {
			// uikit.tip('unsupported picture format');
			// }
			// 某些浏览器无法获取文件大小, 忽略
			else if(filesize > maxSize){
				uikit.tip(tip);
				fileInput.value = "";
			}
			else{
				var nameList = WebIM.utils.getFileUrl(fileInput) && WebIM.utils.getFileUrl(fileInput).filename.split(".");
				if(blackList.indexOf(nameList[nameList.length - 1].toLocaleUpperCase()) != -1){
					fileInput.value = "";
					noUploadTip();
					return;
				}
				channel.sendImg(WebIM.utils.getFileUrl(fileInput));
				fileInput.value = "";
			}
		});
	
		// 弹出文件框(附件)
		utils.on(doms.sendFileBtn, "click", function(){
			if(utils.isMobile && config.toolbar.authConfirm && !utils.getStore("sendFileMobileModel")){
				utils.removeClass(doms.mobileModel, "hide");
				doms.mobileContent.innerText = "The program needs to access your file permission. Is it allowed?";
				utils.addClass(doms.mobileModel, "send_file");
			}
			else{
				doms.fileInput.click();
			}
		});
	
		// 弹出小视频框
		utils.on(doms.sendVideoBtn, "click", function(){
			if(utils.isMobile && config.toolbar.authConfirm && !utils.getStore("sendVideoMobileModel")){
				utils.removeClass(doms.mobileModel, "hide");
				doms.mobileContent.innerText = "The program needs access to your photos and albums. Is it allowed?";
				utils.addClass(doms.mobileModel, "send_video");
			}
			else{
				doms.videoInput.click();
			}
		});
	
		// 弹出图片框
		utils.on(doms.sendImgBtn, "click", function(){
			if(utils.isMobile && config.toolbar.authConfirm && !utils.getStore("sendImgMobileModel")){
				utils.removeClass(doms.mobileModel, "hide");
				doms.mobileContent.innerText = "The program needs to access your gallery and use camera permissions. Do you want to allow it?";
				utils.addClass(doms.mobileModel, "send_img");
			}
			else{
				doms.imgInput.click();
			}
		});
		// allow
		utils.on(doms.allowBtn, "click", function(){
			doms.imgInput.click();
			if(utils.hasClass(doms.mobileModel, "send_img")){
				utils.setStore("sendImgMobileModel", true);
				utils.removeClass(doms.mobileModel, "send_img");
			}
			else if(utils.hasClass(doms.mobileModel, "send_file")){
				utils.setStore("sendFileMobileModel", true);
				utils.removeClass(doms.mobileModel, "send_file");
			}
			else if(utils.hasClass(doms.mobileModel, "send_video")){
				utils.setStore("sendVideoMobileModel", true);
				utils.removeClass(doms.mobileModel, "send_video");
			}
			else{ }
			utils.addClass(doms.mobileModel, "hide");
		});
		// refuse
		utils.on(doms.refuseBtn, "click", function(){
			utils.removeClass(doms.mobileModel, "send_img");
			utils.removeClass(doms.mobileModel, "send_file");
			utils.removeClass(doms.mobileModel, "send_video");
			utils.addClass(doms.mobileModel, "hide");
		});
	
		// 消息中的留言
		utils.live(".msgTicketButton", "click", function(){
			// 是否使用第三方留言
			var config = commonConfig.getConfig();
			if(config.toolbar.ticketUrlStatus){
				if(config.visitor && config.visitor.userNickname){
					// 传递昵称
					config.toolbar.ticketUrl = config.toolbar.ticketUrl + "&visitor_nickname=" + config.visitor.userNickname;
				}
	
				if(config.visitorInfo && config.visitorInfo.userId){
					config.toolbar.ticketUrl = config.toolbar.ticketUrl + "&visitor_userId=" + config.visitorInfo.userId;
				}
	
				window.open(config.toolbar.ticketUrl);
				apiHelper.visitorCloseSession({ serviceSessionId: profile.currentOfficialAccount.sessionId });
			}
			else{
				noteIframe.open();
			}
	
			transferTicketsEvent();
		});
	
		// 输入框中的留言
		utils.live(".em-widget-to-ticket", "click", function(){
			// 是否使用第三方留言
			var config = commonConfig.getConfig();
			if(config.toolbar.ticketUrlStatus){
				if(config.visitor && config.visitor.userNickname){
					// 传递昵称
					config.toolbar.ticketUrl = config.toolbar.ticketUrl + "&visitor_nickname=" + config.visitor.userNickname;
				}
	
				if(config.visitorInfo && config.visitorInfo.userId){
					config.toolbar.ticketUrl = config.toolbar.ticketUrl + "&visitor_userId=" + config.visitorInfo.userId;
				}
	
				window.open(config.toolbar.ticketUrl);
				apiHelper.visitorCloseSession({ serviceSessionId: profile.currentOfficialAccount.sessionId });
			}
			else{
				noteIframe.open();
			}
	
			transferTicketsEvent();
		});
	
		// 点击留言，调用后端接口，统计是否转接应该是“是”
		function transferTicketsEvent(){
			apiHelper.getTransferTicketsEvent(profile.currentOfficialAccount.sessionId)
			.then(function(resp){
				
			});
		}
	
		// 显示留言页面
		utils.on(doms.noteBtn, "click", function(){
			// 是否使用第三方留言
			var config = commonConfig.getConfig();
			if(config.toolbar.ticketUrlStatus){
				if(config.visitor && config.visitor.userNickname){
					// 传递昵称
					config.toolbar.ticketUrl = config.toolbar.ticketUrl + "&visitor_nickname=" + config.visitor.userNickname;
				}
	
				if(config.visitorInfo && config.visitorInfo.userId){
					config.toolbar.ticketUrl = config.toolbar.ticketUrl + "&visitor_userId=" + config.visitorInfo.userId;
				}
	
				window.open(config.toolbar.ticketUrl);
				apiHelper.visitorCloseSession({ serviceSessionId: profile.currentOfficialAccount.sessionId });
			}
			else{
				noteIframe.open();
			}
	
			transferTicketsEvent();
		});
	
		// 满意度评价
		utils.on(doms.satisfaction, "click", function(){
			doms.textInput.blur();
			// 判断评价是否超时
			apiHelper.getEvaluateVerify(profile.currentOfficialAccount.sessionId)
			.then(function(resp){
				if(resp.status == "OK"){
						// 访客主动评价
					satisfaction.show(null, null, "visitor");
				}
				else if(resp.errorCode == "WEBIM_338"){
					uikit.tip("Visitor evaluate timeout");
				}
				else{
					uikit.tip("Other errors");
				}
			});
		});
	
		// ios patch: scroll page when keyboard is visible ones
		if(utils.isIOS){
			utils.on(doms.textInput, "focus", function(){
				if(utils.isTop){
					utils.removeClass(document.body, "em-mobile-translate");
				}
			});
			// CLOUD-15103 解决 ios 部分手机点击输入框失焦后输入框不能自动收回问题
			utils.on(doms.textInput, "blur", function(e){
				setTimeout(function(){
					// 曾经试过的方法
					// 1. 重新去设置iframe 的宽高
					// 2. document.body.scrollBottom = 0;		// 在 iframe 下会有问题
					// 3. document.body.scrollIntoView(false);	// 元素的底端将和其所在滚动区的可视区域的底端对齐 加载 iframe 的页面和 easemob.js 不在同一个域会出现问题。原因未知
					// 4. window.scrollTo(0, Math.max(document.body.clientHeight, document.documentElement.clientHeight));
					// 5. window.document.body.scrollTop = window.document.body.scrollHeight;
	
					if(utils.isTop){
						utils.addClass(document.body, "em-mobile-translate");
					}
					else{
						getToHost.send({
							event: _const.EVENTS.SCROLL_TO_BOTTOM,
						});
					}
	
				}, 100);
	
			});
		}
	
		// 回车发送消息
		utils.on(doms.textInput, "keydown", function(evt){
			if(
				evt.keyCode === 13
				&& !utils.isMobile
				&& !evt.ctrlKey
				&& !evt.shiftKey
			){
				// ie8 does not support preventDefault & stopPropagation
				if(evt.preventDefault){
					evt.preventDefault();
				}
				utils.trigger(doms.sendBtn, "click");
			}
		});
	
	
		utils.on(doms.sendBtn, "click", function(){
			var textMsg = doms.textInput.value;
	
			if(utils.hasClass(this, "disabled")){
				// 禁止发送
			}
			else if(textMsg.length > _const.MAX_TEXT_MESSAGE_LENGTH){
				uikit.tip("Message too long");
			}
			else{
				channel.sendText(textMsg);
				doms.textInput.value = "";
				utils.trigger(doms.textInput, "change");
				// 清除猜你想说 功能 并 重置样式(根据是否有灰度)
				if(profile.grayList.guessUSay){
					guessInfo.resetStyle();
	        guessInfo.clearCacheInput(); // 直接发送内容需要清楚猜你想问缓存的值 否则下次输入同样内容无法触发建议
				}
				utils.setStore("isHaveCustomerMsg", true);
			}
		});
	
		// 放弃排队
		utils.on(doms.abandonQueueBtn, "click", function(){
			var officialAccount = profile.currentOfficialAccount;
			var sessionId = officialAccount.sessionId;
			apiHelper.closeServiceSession(sessionId, true).then(function(){
				utils.addClass(doms.abandonQueueBtn, "hide");
				// 会话结束上屏
				channel.appendEventMsg("Conversation is closed", { ext: { weichat: { official_account: officialAccount } } });
			});
		});
	
		utils.on(doms.addBtn, "click", function(){
			utils.toggleClass(doms.toolBar, "hide");
			var height = doms.editorView.getBoundingClientRect().height;
			if(inputBoxPosition === "up"){
				doms.chatWrapper.style.bottom = "0";
				doms.queuingNumberStatus.style.top = height + "px";
	
			}
			else{
				doms.chatWrapper.style.bottom = height + "px";
			}
			emojiPanel.move(inputBoxPosition, height);
			_scrollToBottom();
			// 由于移动端时候轮播图的元素没有家在无法获取到 所以需要在加载完成以后改变主题色
			if(utils.isMobile){
				// 获取主题色
				var color = "";
				var themeClassName;
				var config = commonConfig.getConfig();
				var themeName = config.ui.themeName;
				if(themeName && themeName.indexOf("theme_custom") > -1){
					var arr = themeName.split("theme_custom");
					color = arr[1];
					themeClassName = "theme_custom";
				}
				else{
					themeClassName = _const.themeMap[config.themeName];
				}
				var hoverColor = $("body." + themeClassName + " .border-color").css("borderColor");
				// 设置主题色
				setTimeout(function(){
					var el = document.querySelector(".swiper-pagination-bullet-active");
					if(color){
						$(el).css("backgroundColor", color);
					}
					else{
						$(el).css("backgroundColor", hoverColor);
					}
				}, 300);
			}
		});
		utils.on($(".ui-cmp-tab>.ul-left"), "click", function(){
			onLeft();
		});
		utils.on($(".ui-cmp-tab>.ul-right"), "click", function(){
			onRight();
		});
	
		function onLeft(){
			if($(".ui-cmp-tab > ul li").length < 2 || restLength == 0){
				$(".ul-left").removeClass("hover");
				return false;
			}
			restLength--;
			var slideW = Math.floor($(".ui-cmp-tab > ul").width() / 2);
	
			$(".ui-cmp-tab > ul").animate({
				left: -slideW * restLength + "px"
			});
			if($(".ui-cmp-tab > ul li").length < 2 || restLength == 0){
				$(".ul-left").removeClass("hover");
			}
			else{
				$(".ul-left").addClass("hover");
			}
			$(".ul-right").addClass("hover");
		}
		function onRight(){
			if($(".ui-cmp-tab > ul li").length < 2 || $(".ui-cmp-tab > ul li").length - 2 == restLength){
				$(".ul-right").removeClass("hover");
				return false;
			}
			restLength++;
			var slideW = Math.floor($(".ui-cmp-tab > ul").width() / 2);
	
			$(".ui-cmp-tab > ul").animate({
				left: -slideW * restLength + "px"
			});
			if($(".ui-cmp-tab > ul li").length < 2 || $(".ui-cmp-tab > ul li").length - 2 == restLength){
				$(".ul-right").removeClass("hover");
			}
			else{
				$(".ul-right").addClass("hover");
			}
			$(".ul-left").addClass("hover");
		}
		function noUploadTip(){
			var content = "Type not supported:" + blackList.join("、");
			if(noUploadDialog){
				noUploadDialog.show();
				return;
			}
			noUploadDialog = uikit.createDialog({
				contentDom: [
					"<div class=\"wrapper\">",
					"<p class=\"prompt\">" + "This file format does not support sending, please select again" + "</p>",
					"<p class=\"no-tip\">" + content + "</p>",
					"</div>"
				].join(""),
				className: "no-upload refresh-dialog",
			}).addButton({
				confirm: function(){
					noUploadDialog.hide();
				}, hideCancel: true,
			});
			noUploadDialog.show();
		}
	}
	
	function _close(){
		profile.isChatWindowOpen = false;
	
		if(config && !config.hide){
			utils.addClass(doms.imChat, "hide");
			!profile.isHideBtn && utils.removeClass(doms.imBtn, "hide");
		}
	
		eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CHAT_WINDOW_CLOSED, []);
	}
	
	function _show(){
		profile.isChatWindowOpen = true;
		utils.addClass(doms.imBtn, "hide");
		utils.removeClass(doms.imChat, "hide");
		_scrollToBottom();
		if(
			profile.isInOfficeHours
			&& !utils.isMobile
			// IE 8 will throw an error when focus an invisible element
			&& doms.textInput.offsetHeight > 0
		){
			doms.textInput.focus();
		}
		getToHost.send({ event: _const.EVENTS.REOPEN }); // 不管是否ready，都send
		getToHost.send({ event: _const.EVENTS.RECOVERY });
	
		eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CHAT_WINDOW_OPENED, []);
	}
	
	function _onReady(){
		// sessionStorage.setItem("tabIdSession",new Date().getTime());
		commonConfig.setConfig({
			tabIdSession: new Date().getTime(),
		});
		if(isMessageChannelReady) return;
	
		isMessageChannelReady = true;
	
		doms.sendBtn.innerHTML = "Send";
		utils.trigger(doms.textInput, "change");
	
		// todo: discard this
		// bug fix:
		// minimum = fales 时, 或者 访客回呼模式 调用easemobim.bind时显示问题
		if(config.minimum === false || config.eventCollector === true){
			getToHost.send({ event: _const.EVENTS.SHOW });
		}
	
		eventListener.trigger(_const.SYSTEM_EVENT.MESSAGE_CHANNEL_READY);
	
		// onready 回调
		getToHost.send({ event: _const.EVENTS.ONREADY });
		var chartIsShow = window.sessionStorage && sessionStorage.getItem("chartIsShow");
		if(chartIsShow){
			setTimeout(function(){
				getToHost.send({ event: _const.EVENTS.SHOW });
			}, 1000);
			window.sessionStorage && sessionStorage.removeItem("chartIsShow");
		}
	  if(typeof window._sendFaqMessage === "function"){
	    window._sendFaqMessage();
	    window._sendFaqMessage = undefined;
	  }
	}
	
	function _initSDK(){
		return new Promise(function(resolve){
			channel.initConnection(resolve);
		});
	}
	// 获取dom
	function _getDom(){
		topBar = document.querySelector(".em-widget-header");
		editorView = document.querySelector(".em-widget-send-wrapper");
		var inputBox = editorView.querySelector(".input-box");
	
		var toolBar = utils.isMobile ? editorView.querySelector(".toolbar-mobile") : editorView.querySelector(".toolbar-pc");
		// 将猜你想说 dom 插入的指定元素之前
		toolBar.parentNode.insertBefore(guessInfo.loadHtml().dom, toolBar);
	
		doms = {
			imBtn: document.getElementById("em-widgetPopBar"),
			imChat: document.getElementById("em-kefu-webim-chat"),
			agentStatusText: topBar.querySelector(".em-header-status-text"),
			dragBar: topBar.querySelector(".drag-bar"),
			closeBtn: topBar.querySelector(".btn-close"),
			minifyBtn: topBar.querySelector(".btn-min"),
			audioBtn: topBar.querySelector(".btn-audio"),
			switchKeyboardBtn: topBar.querySelector(".btn-keyboard"),
	
			emojiToggleButton: utils.isMobile ? inputBox.querySelector(".em-bar-emoji") : toolBar.querySelector(".em-bar-emoji"),
			// 获取文件上传，图片，小视频按钮dom
			sendImgBtn: toolBar.querySelector(".em-widget-img"),
			sendFileBtn: toolBar.querySelector(".em-widget-file"),
			sendVideoBtn: toolBar.querySelector(".em-widget-video"),
			sendBtn: editorView.querySelector(".em-widget-send"),
			satisfaction: toolBar.querySelector(".em-widget-satisfaction"),
			textInput: editorView.querySelector(".em-widget-textarea"),
			noteBtn: toolBar.querySelector(".em-widget-note"),
			videoInviteButton: toolBar.querySelector(".em-video-invite"),
			queuingNumberStatus: editorView.querySelector(".queuing-number-status"),
			//  图片小视频文件 file框
			videoInput: document.querySelector(".upload-video-container"),
			imgInput: document.querySelector(".upload-img-container"),
			fileInput: document.querySelector(".upload-file-container"),
			chatWrapper: document.querySelector(".chat-wrapper"),
			addBtn: editorView.querySelector(".em-widget-add"),
	
			videoPlayContainer: document.querySelector(".em-video-container"),
			videoPlayBox: document.querySelector(".full-video-box"),
			videoBoxClose: document.querySelector(".video-container-close"),
	
			mobileModel: document.querySelector(".mobile-model"),
			mobileContent: document.querySelector(".mobile-model-content"),
			allowBtn: document.querySelector("span[allow]"),
			refuseBtn: document.querySelector("span[refuse]"),
	
			// 放弃排队
			abandonQueueBtn: editorView.querySelector(".em-widget-abandon-queue"),
	
			toolBar: toolBar,
			topBar: topBar,
			editorView: editorView,
			// inputTopButton:document.querySelector(".em-widget-send-wrapper-top>.input-top-btn"),
		};
	}
	
	function _init(){
		apiHelper.getOnlyCloseSession().then(function(res){
			OnlyCloseSession = res;
		});
		apiHelper.getOnlyCloseWindow().then(function(res){
			OnlyCloseWindow = res;
		});
		utils.setStore("isHaveCustomerMsg", false);
		// 根据灰度设置 是否添加猜你想问功能
		if(profile.grayList.guessUSay){
			guessInfo.addEvents();
		}
		config = commonConfig.getConfig();
		channel.init();
		profile.isChatWindowOpen = true;
		_initSoundReminder();
		_initUI();
		// 初始化留言
		_initNote();
		_bindEvents();
		initSessionList();
		_initSession();
		// 查询是否开启询前引导开关
		if(profile.grayList.transfermanualmenuguide){
			apiHelper.getOptForManualMenuGuide().then(function(yes){
				profile.isManualMenuGuide = yes;
			});
		}
		// 查询是否开启申请相机的权限开关
		// apiHelper.getSendImgTips().then(function (yes) {
		// 	profile.sendImgTips = yes.entity;
		// });
	
		var url;
		if(profile.grayList.poweredByEasemob){
			// utils.addClass(el, "paddingTo48");
			// utils.addClass(noMoreMsg, "top34");
			url = "http://www.easemob.com/product/cs?utm_source=csw&tenantid=" + commonConfig.getConfig().tenantId;
			if(!utils.isMobile){
				utils.appendHTMLTo(editorView, "<div class=\"easemob-copyright\"><a target=\"_blank\" href=" + url + "><span><i class=\"icon-easemob\"></i>" + "powered by easemob" + "</a></div>");
				utils.addClass(editorView, "height-170");
				utils.addClass($(editorView).find(".em-widget-send"), "bottom-30");
				utils.addClass(document.querySelector(".chat-wrapper"), "chat-padding-40");
				$(".em-widget-send-wrapper").css("height", "170px");
				$(".chat-wrapper").css("bottom", "170px");
			}
		}
		else if(!utils.isMobile){
			$(".em-widget-send-wrapper").css("height", "140px !important");
			$(".chat-wrapper").css("bottom", "140px !important");
		}
	
	}
	
	function _initSatisfactionButton(){
		eventListener.add(_const.SYSTEM_EVENT.SESSION_OPENED, _displayOrHideSatisfactionBtn);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERING, _displayOrHideSatisfactionBtn);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERED, _displayOrHideSatisfactionBtn);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_RESTORED, _displayOrHideSatisfactionBtn);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_NOT_CREATED, _displayOrHideSatisfactionBtn);
		eventListener.add(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_SWITCHED, _displayOrHideSatisfactionBtn);
	}
	
	function _displayOrHideSatisfactionBtn(officialAccount){
		// 忽略非当前服务号的事件
		if(profile.currentOfficialAccount !== officialAccount) return;
	
		var state = officialAccount.sessionState;
		var agentType = officialAccount.agentType;
		var type = officialAccount.type;
		var isRobotAgent = agentType === _const.AGENT_ROLE.ROBOT;
	
		if(state === _const.SESSION_STATE.PROCESSING){
			utils.toggleClass(doms.satisfaction, "hide", isRobotAgent);
		}
		else if(state === _const.SESSION_STATE.WAIT){
			// 待接入状态 隐藏按钮
			utils.addClass(doms.satisfaction, "hide");
		}
		else if(profile.isAgentStateOnline){
			utils.removeClass(doms.satisfaction, "hide");
		}
	}
	
	function _initNote(){
		var data;
		var closeNoteBtn = document.querySelector(".em-kefu-webim-note .note-top");
		noteIframe = new NoteIframe(config);
		if(window.addEventListener){
			window.addEventListener("message", function(e){
				closeNoteIframe(e);
				closeChat(e);
			}, false);
		}
		else if(window.attachEvent){
			window.attachEvent("onmessage", function(e){
				closeNoteIframe(e);
				closeChat(e);
			});
		}
	
		utils.on(closeNoteBtn, "click", function(){
			noteIframe.close();
		});
	
		function closeNoteIframe(e){
			try{
				data = e.data;
				if(typeof data === "string" && data != "undefined"){
					data = JSON.parse(data);
				}
				data.closeNote && noteIframe.close();
			}
			catch(e){ }
		}
		function closeChat(e){
			try{
				data = e.data;
				if(typeof data === "string" && data != "undefined"){
					data = JSON.parse(data);
				}
				data.closeChat && getToHost.send({ event: _const.EVENTS.CLOSE });
	
			}
			catch(e){ }
		}
	}
	
	function _initSession(){
		Promise.all([
			apiHelper.getDutyStatus(),
			apiHelper.getToken(),
		]).then(function(result){
			var dutyStatus = result[0];
			// 当配置为下班进会话时执行与上班相同的逻辑
			profile.isInOfficeHours = dutyStatus || config.offDutyType === "chat";
			if(profile.isInOfficeHours){
				emojiPanel.init({
					container: doms.imChat,
					toggleButton: doms.emojiToggleButton,
					textInput: doms.textInput,
				});
	
		//   config.toolbar.videoSwitch = true; //YU test
	
	      const videoSwitch = config.toolbar.videoSwitch
	
		  
	    //   profile.grayList.agoraVideo = true //YU test 因为得权限的接口，本地401了，线上是好的，不知道为神马？
	
	
	      if(profile.grayList.agoraVideo){
	        videoChatAgora.init({
	          videoSwitch: videoSwitch,
	          triggerButton: doms.videoInviteButton,
	          parentContainer: doms.imChat,
	        });
	      }
	      else{
	        videoChat.init({
	          videoSwitch: videoSwitch,
	          triggerButton: doms.videoInviteButton,
	          parentContainer: doms.imChat,
	        });
	      }
				extendMessageSender.init();
	
				Promise.all([
					// 查询是否开启机器人
					apiHelper.getRobertIsOpen().then(function(isRobotEnable){
						profile.hasRobotAgentOnline = isRobotEnable;
					}),
					// 获取坐席昵称设置
					apiHelper.getNickNameOption().then(function(displayNickname){
						profile.isAgentNicknameEnable = displayNickname;
					}),
					// 获取是否显示 track msg
					apiHelper.getOptForShowTrackMsg().then(function(yes){
						profile.isShowTrackMsg = yes;
					}),
					// 获取是否显示 客服状态
					apiHelper.getOnlineCustomerStatus().then(function(yes){
						profile.isHideCustomerStatus = yes;
					}),
					apiHelper.getIsNoLink().then(function(yes){
						profile.isNoLink = yes;
					}),
				])
				.then(function(){
					return Promise.all([
						_initOfficialAccount(),
						_initSDK()
					]);
				})
				.then(_onReady);
	
	
	
				_initSystemEventListener();
				satisfaction.init();
				customUrl.init();
				initAgentInputStatePoller();
				initAgentStatusPoller();
				initVisitorStatusPoller();
				initQueuingNumberPoller();
				initTransferToKefuButton();
				if(config.satisfaction && config.options.showEnquiryButtonInAllTime == "false"){
					_initSatisfactionButton();
					_InitH5AndInputTop(true);
				}
				else{
					_InitH5AndInputTop(false);
				}
	
				initAgentNicknameUpdate();
				initGetGreetings();
	
				// 第二通道收消息初始化
				channel.initSecondChannle();
				// todo: move to handle ready
				initPasteImage();
				// 显示广告条
				_setLogo();
				// 设置信息栏
				_setNotice();
				_initToolbar();
				// 检测租户版本是否是试用期
				_checkGradeType();
				// 移动端输入框自动增长
				utils.isMobile && _initAutoGrow();
			}
			else{
				// 设置下班时间展示的页面
				_setOffline();
			}
		}, function(err){
			if(
				err.error_description === "user not found"
				&& config.isUsernameFromCookie
			){
				_reCreateImUser();
			}
			else{
				throw err;
			}
		});
	}
	function _InitH5AndInputTop(isShowSatis){
		apiHelper.getInputTopStatus().then(function(res){
			var isOpen = res.entity;
			apiHelper.getInputTopButton().then(function(res){
				initInputTopButton(res.entities, isOpen);
			});
		});
	
		if(utils.isMobile){
	
			// document.querySelector(".em-widget-send-wrapper-top").style.bottom = "60" + "px";
			// $(".em-widget-send-wrapper-top").addClass("hide");
			apiHelper.getInputH5Status().then(function(res){
				// 如果开关打开渲染输入框上边的快捷操作按钮
				if(res.entity){
					apiHelper.getInputH5Button().then(function(res){
						if(res.entities.length != 0){
							initInputH5Button(res.entities, isShowSatis);
						}
					});
				}
				else{
					// $(".em-widget-send-wrapper-top").addClass("hide");
				}
	
			});
		}
		else{
	
		}
	}


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(137)


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var _version = '1.4.13';
	var _code = __webpack_require__(138).code; 
	var _utils = __webpack_require__(139).utils; 
	var _msg = __webpack_require__(140);
	var _message = _msg._msg;
	var _msgHash = {};
	var Queue = __webpack_require__(175).Queue;
	var CryptoJS = __webpack_require__(141);
	var _ = __webpack_require__(13);
	
	var Strophe = window.Strophe
	var isStropheLog;
	var stropheConn = null
	var abc = "";
	
	window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL;
	
	var logMessage = function (message) {
	}
	
	if (window.XDomainRequest) {
	    // not support ie8 send is not a function , canot 
	    // case send is object, doesn't has a attr of call
	    // XDomainRequest.prototype.oldsend = XDomainRequest.prototype.send;
	    // XDomainRequest.prototype.send = function () {
	    //     XDomainRequest.prototype.oldsend.call(this, arguments);
	    //     this.readyState = 2;
	    // };
	}
	
	Strophe.Request.prototype._newXHR = function () {
	    var xhr = _utils.xmlrequest(true);
	    if (xhr.overrideMimeType) {
	        xhr.overrideMimeType('text/xml');
	    }
	    // use Function.bind() to prepend ourselves as an argument
	    xhr.onreadystatechange = this.func.bind(null, this);
	    return xhr;
	};
	
	Strophe.Websocket.prototype._closeSocket = function () {
	    if (this.socket) {
	        var me = this;
	        setTimeout(function () {
	            try {
	                me.socket.close();
	            } catch (e) {
	            }
	        }, 0);
	    } else {
	        this.socket = null;
	    }
	};
	
	/** Function: log
	 *  User overrideable logging function.
	 *
	 *  This function is called whenever the Strophe library calls any
	 *  of the logging functions.  The default implementation of this
	 *  function does nothing.  If client code wishes to handle the logging
	 *  messages, it should override this with
	 *  > Strophe.log = function (level, msg) {
	     *  >   (user code here)
	     *  > };
	 *
	 *  Please note that data sent and received over the wire is logged
	 *  via Strophe.Connection.rawInput() and Strophe.Connection.rawOutput().
	 *
	 *  The different levels and their meanings are
	 *
	 *    DEBUG - Messages useful for debugging purposes.
	 *    INFO - Informational messages.  This is mostly information like
	 *      'disconnect was called' or 'SASL auth succeeded'.
	 *    WARN - Warnings about potential problems.  This is mostly used
	 *      to report transient connection errors like request timeouts.
	 *    ERROR - Some error occurred.
	 *    FATAL - A non-recoverable fatal error occurred.
	 *
	 *  Parameters:
	 *    (Integer) level - The log level of the log message.  This will
	 *      be one of the values in Strophe.LogLevel.
	 *    (String) msg - The log message.
	 */
	/* jshint ignore:start */
	Strophe.log =  function (level, msg) {
	    if(!isStropheLog){
	        return
	    }
	    switch(level){
	        case this.LogLevel.DEBUG:
	            console.debug(msg)
	            break;
	        case this.LogLevel.INFO:
	            console.info(msg);
	            break;
	        case this.LogLevel.WARN:
	            console.warn(msg);
	            break;
	        case this.LogLevel.ERROR:
	        case this.LogLevel.FATAL:
	            console.error(msg);
	            break;
	        default:
	            console.log(msg);
	    }
	    return;
	}
	
	/**
	 *
	 * Strophe.Websocket has a bug while logout:
	 * 1.send: <presence xmlns='jabber:client' type='unavailable'/> is ok;
	 * 2.send: <close xmlns='urn:ietf:params:xml:ns:xmpp-framing'/> will cause a problem,log as follows:
	 * WebSocket connection to 'ws://im-api.easemob.com/ws/' failed: Data frame received after close_connect @ strophe.js:5292connect @ strophe.js:2491_login @ websdk-1.1.2.js:278suc @ websdk-1.1.2.js:636xhr.onreadystatechange @ websdk-1.1.2.js:2582
	 * 3 "Websocket error [object Event]"
	 * _changeConnectStatus
	 * onError Object {type: 7, msg: "The WebSocket connection could not be established or was disconnected.", reconnect: true}
	 *
	 * this will trigger socket.onError, therefore _doDisconnect again.
	 * Fix it by overide  _onMessage
	 */
	Strophe.Websocket.prototype._onMessage = function (message) {
	    logMessage(message)
	    // 获取Resource
	    var data = message.data;
	    if (data.indexOf('<jid>') > 0) {
	        var start = data.indexOf('<jid>'),
	            end = data.indexOf('</jid>'),
	            data = data.substring(start + 5, end);
	        stropheConn.setJid(data);
	    }
	    var elem, data;
	    // check for closing stream
	    // var close = '<close xmlns="urn:ietf:params:xml:ns:xmpp-framing" />';
	    // if (message.data === close) {
	    //     this._conn.rawInput(close);
	    //     this._conn.xmlInput(message);
	    //     if (!this._conn.disconnecting) {
	    //         this._conn._doDisconnect();
	    //     }
	    //     return;
	    //
	    // send and receive close xml: <close xmlns='urn:ietf:params:xml:ns:xmpp-framing'/>
	    // so we can't judge whether message.data equals close by === simply.
	    if (message.data.indexOf("<close ") === 0) {
	        elem = new DOMParser().parseFromString(message.data, "text/xml").documentElement;
	        var see_uri = elem.getAttribute("see-other-uri");
	        if (see_uri) {
	            this._conn._changeConnectStatus(Strophe.Status.REDIRECT, "Received see-other-uri, resetting connection");
	            this._conn.reset();
	            this._conn.service = see_uri;
	            this._connect();
	        } else {
	            // if (!this._conn.disconnecting) {
	            this._conn._doDisconnect("receive <close> from server");
	            // }
	        }
	        return;
	    } else if (message.data.search("<open ") === 0) {
	        // This handles stream restarts
	        elem = new DOMParser().parseFromString(message.data, "text/xml").documentElement;
	        if (!this._handleStreamStart(elem)) {
	            return;
	        }
	    } else {
	        data = this._streamWrap(message.data);
	        elem = new DOMParser().parseFromString(data, "text/xml").documentElement;
	    }
	
	    if (this._check_streamerror(elem, Strophe.Status.ERROR)) {
	        if(elem.textContent == "Replaced by new connection"){
	            abc.onError({
	                type: "Replaced by new connection",
	            })
	        }
	        return;
	    }
	
	    //handle unavailable presence stanza before disconnecting
	    if (this._conn.disconnecting &&
	        elem.firstChild.nodeName === "presence" &&
	        elem.firstChild.getAttribute("type") === "unavailable") {
	        this._conn.xmlInput(elem);
	        this._conn.rawInput(Strophe.serialize(elem));
	        // if we are already disconnecting we will ignore the unavailable stanza and
	        // wait for the </stream:stream> tag before we close the connection
	        return;
	    }
	    this._conn._dataRecv(elem, message.data);
	};
	
	
	var _listenNetwork = function (onlineCallback, offlineCallback) {
	
	    if (window.addEventListener) {
	        window.addEventListener('online', onlineCallback);
	        window.addEventListener('offline', offlineCallback);
	
	    } else if (window.attachEvent) {
	        if (document.body) {
	            document.body.attachEvent('ononline', onlineCallback);
	            document.body.attachEvent('onoffline', offlineCallback);
	        } else {
	            window.attachEvent('load', function () {
	                document.body.attachEvent('ononline', onlineCallback);
	                document.body.attachEvent('onoffline', offlineCallback);
	            });
	        }
	    } else {
	        /*var onlineTmp = window.ononline;
	         var offlineTmp = window.onoffline;
	
	         window.attachEvent('ononline', function () {
	         try {
	         typeof onlineTmp === 'function' && onlineTmp();
	         } catch ( e ) {}
	         onlineCallback();
	         });
	         window.attachEvent('onoffline', function () {
	         try {
	         typeof offlineTmp === 'function' && offlineTmp();
	         } catch ( e ) {}
	         offlineCallback();
	         });*/
	    }
	};
	
	var _parseRoom = function (result) {
	    var rooms = [];
	    var items = result.getElementsByTagName('item');
	    if (items) {
	        for (var i = 0; i < items.length; i++) {
	            var item = items[i];
	            var roomJid = item.getAttribute('jid');
	            var tmp = roomJid.split('@')[0];
	            var room = {
	                jid: roomJid,
	                name: item.getAttribute('name'),
	                roomId: tmp.split('_')[1]
	            };
	            rooms.push(room);
	        }
	    }
	    return rooms;
	};
	
	var _parseRoomOccupants = function (result) {
	    var occupants = [];
	    var items = result.getElementsByTagName('item');
	    if (items) {
	        for (var i = 0; i < items.length; i++) {
	            var item = items[i];
	            var room = {
	                jid: item.getAttribute('jid'),
	                name: item.getAttribute('name')
	            };
	            occupants.push(room);
	        }
	    }
	    return occupants;
	};
	
	var _parseResponseMessage = function (msginfo) {
	    var parseMsgData = {errorMsg: true, data: []};
	
	    var msgBodies = msginfo.getElementsByTagName('body');
	    if (msgBodies) {
	        for (var i = 0; i < msgBodies.length; i++) {
	            var msgBody = msgBodies[i];
	            var childNodes = msgBody.childNodes;
	            if (childNodes && childNodes.length > 0) {
	                var childNode = msgBody.childNodes[0];
	                if (childNode.nodeType == Strophe.ElementType.TEXT) {
	                    var jsondata = childNode.wholeText || childNode.nodeValue;
	                    jsondata = jsondata.replace('\n', '<br>');
	                    try {
	                        var data = eval('(' + jsondata + ')');
	                        parseMsgData.errorMsg = false;
	                        parseMsgData.data = [data];
	                    } catch (e) {
	                    }
	                }
	            }
	        }
	
	        var delayTags = msginfo.getElementsByTagName('delay');
	        if (delayTags && delayTags.length > 0) {
	            var delayTag = delayTags[0];
	            var delayMsgTime = delayTag.getAttribute('stamp');
	            if (delayMsgTime) {
	                parseMsgData.delayTimeStamp = delayMsgTime;
	            }
	        }
	    } else {
	        var childrens = msginfo.childNodes;
	        if (childrens && childrens.length > 0) {
	            var child = msginfo.childNodes[0];
	            if (child.nodeType == Strophe.ElementType.TEXT) {
	                try {
	                    var data = eval('(' + child.nodeValue + ')');
	                    parseMsgData.errorMsg = false;
	                    parseMsgData.data = [data];
	                } catch (e) {
	                }
	            }
	        }
	    }
	    return parseMsgData;
	};
	
	var _parseNameFromJidFn = function (jid, domain) {
	    domain = domain || '';
	    var tempstr = jid;
	    var findex = tempstr.indexOf('_');
	
	    if (findex !== -1) {
	        tempstr = tempstr.substring(findex + 1);
	    }
	    var atindex = tempstr.indexOf('@' + domain);
	    if (atindex !== -1) {
	        tempstr = tempstr.substring(0, atindex);
	    }
	    return tempstr;
	};
	
	var _parseFriend = function (queryTag, conn, from) {
	    var rouster = [];
	    var items = queryTag.getElementsByTagName('item');
	    if (items) {
	        for (var i = 0; i < items.length; i++) {
	            var item = items[i];
	            var jid = item.getAttribute('jid');
	            if (!jid) {
	                continue;
	            }
	            var subscription = item.getAttribute('subscription');
	            var friend = {
	                subscription: subscription,
	                jid: jid
	            };
	            var ask = item.getAttribute('ask');
	            if (ask) {
	                friend.ask = ask;
	            }
	            var name = item.getAttribute('name');
	            if (name) {
	                friend.name = name;
	            } else {
	                var n = _parseNameFromJidFn(jid);
	                friend.name = n;
	            }
	            var groups = [];
	            Strophe.forEachChild(item, 'group', function (group) {
	                groups.push(Strophe.getText(group));
	            });
	            friend.groups = groups;
	            rouster.push(friend);
	            // B同意之后 -> B订阅A
	            // fix: 含有ask标示的好友代表已经发送过反向订阅消息，不需要再次发送。
	            if (conn && (subscription == 'from') && !ask) {
	                conn.subscribe({
	                    toJid: jid,
	                    message: "[resp:true]"
	                });
	            }
	
	            if (conn && (subscription == 'to')) {
	                conn.subscribed({
	                    toJid: jid
	                });
	            }
	        }
	    }
	    return rouster;
	};
	
	var _login = function (options, conn) {
	    if(!options){
	        return;
	    }
	    var accessToken = options.access_token || '';
	    if (accessToken == '') {
	        var loginfo = _utils.stringify(options);
	        conn.onError({
	            type: _code.WEBIM_CONNCTION_OPEN_USERGRID_ERROR,
	            data: options
	        });
	        return;
	    }
	    conn.context.accessToken = options.access_token;
	    conn.context.accessTokenExpires = options.expires_in;
	    if (conn.isOpening() && conn.context.stropheConn) {
	        stropheConn = conn.getStrophe();
	    } else if (conn.isOpened() && conn.context.stropheConn) {
	        // return;
	        stropheConn = conn.getStrophe();
	    } else {
	        stropheConn = conn.getStrophe();
	    }
	    var callback = function (status, msg) {
	        _loginCallback(status, msg, conn);
	    };
	
	    conn.context.stropheConn = stropheConn;
	    if (conn.route) {
	        stropheConn.connect(conn.context.jid, '$t$' + accessToken, callback, conn.wait, conn.hold, conn.route);
	    } else {
	        stropheConn.connect(conn.context.jid, '$t$' + accessToken, callback, conn.wait, conn.hold);
	    }
	};
	
	var _parseMessageType = function (msginfo) {
	    var receiveinfo = msginfo.getElementsByTagName('received'),
	        inviteinfo = msginfo.getElementsByTagName('invite'),
	        deliveryinfo = msginfo.getElementsByTagName('delivery'),
	        acked = msginfo.getElementsByTagName('acked'),
	        error = msginfo.getElementsByTagName('error'),
	        msgtype = 'normal';
	    if (receiveinfo && receiveinfo.length > 0
	        &&
	        receiveinfo[0].namespaceURI === 'urn:xmpp:receipts') {
	
	        msgtype = 'received';
	
	    } else if (inviteinfo && inviteinfo.length > 0) {
	
	        msgtype = 'invite';
	
	    } else if (deliveryinfo && deliveryinfo.length > 0) {
	
	        msgtype = 'delivery';           // 消息送达
	
	    } else if (acked && acked.length) {
	
	        msgtype = 'acked';              // 消息已读
	
	    } else if (error && error.length) {
	
	        var errorItem = error[0],
	            userMuted = errorItem.getElementsByTagName('user-muted');
	
	        if (userMuted && userMuted.length) {
	
	            msgtype = 'userMuted';
	
	        }
	
	    }
	    return msgtype;
	};
	
	var _handleMessageQueue = function (conn) {
	    for (var i in _msgHash) {
	        if (_msgHash.hasOwnProperty(i)) {
	            _msgHash[i].send(conn);
	        }
	    }
	};
	
	var _loginCallback = function (status, msg, conn) {
	    var conflict, error;
	
	    if (msg === 'conflict') {
	        conflict = true;
	        conn.close();
	    }
	
	    if (status == Strophe.Status.CONNFAIL) {
	        //client offline, ping/pong timeout, server quit, server offline
	        error = {
	            type: _code.WEBIM_CONNCTION_SERVER_CLOSE_ERROR,
	            msg: msg,
	            reconnect: true
	        };
	
	        conflict && (error.conflict = true);
	        conn.onError(error);
	    } else if (status == Strophe.Status.ATTACHED || status == Strophe.Status.CONNECTED) {
	        // client should limit the speed of sending ack messages  up to 5/s  (后修改为10/s途虎重复收到离线消息)
	        conn.autoReconnectNumTotal = 0;
	        conn.intervalId = setInterval(function () {
	            conn.handelSendQueue();
	        }, 100);
	        var handleMessage = function (msginfo) {
	            var delivery = msginfo.getElementsByTagName('delivery');
	            var acked = msginfo.getElementsByTagName('acked');
	            if (delivery.length) {
	                conn.handleDeliveredMessage(msginfo);
	                return true;
	            }
	            if (acked.length) {
	                conn.handleAckedMessage(msginfo);
	                return true;
	            }
	            var type = _parseMessageType(msginfo);
	            switch (type) {
	                case "received":
	                    conn.handleReceivedMessage(msginfo);
	                    return true;
	                case "invite":
	                    conn.handleInviteMessage(msginfo);
	                    return true;
	                case "delivery":
	                    conn.handleDeliveredMessage(msginfo);
	                    return true;
	                case "acked":
	                    conn.handleAckedMessage(msginfo);
	                    return true;
	                case "userMuted":
	                    conn.handleMutedMessage(msginfo);
	                    return true;
	                default:
	                    conn.handleMessage(msginfo);
	                    return true;
	            }
	        };
	        var handlePresence = function (msginfo) {
	            conn.handlePresence(msginfo);
	            return true;
	        };
	        var handlePing = function (msginfo) {
	            conn.handlePing(msginfo);
	            return true;
	        };
	        var handleIqRoster = function (msginfo) {
	            conn.handleIqRoster(msginfo);
	            return true;
	        };
	        var handleIqPrivacy = function (msginfo) {
	            conn.handleIqPrivacy(msginfo);
	            return true;
	        };
	        var handleIq = function (msginfo) {
	            conn.handleIq(msginfo);
	            return true;
	        };
	
	        conn.addHandler(handleMessage, null, 'message', null, null, null);
	        conn.addHandler(handlePresence, null, 'presence', null, null, null);
	        conn.addHandler(handlePing, 'urn:xmpp:ping', 'iq', 'get', null, null);
	        conn.addHandler(handleIqRoster, 'jabber:iq:roster', 'iq', 'set', null, null);
	        conn.addHandler(handleIqPrivacy, 'jabber:iq:privacy', 'iq', 'set', null, null);
	        conn.addHandler(handleIq, null, 'iq', null, null, null);
	
	        conn.registerConfrIQHandler && (conn.registerConfrIQHandler());
	
	        conn.context.status = _code.STATUS_OPENED;
	
	        var supportRecMessage = [
	            _code.WEBIM_MESSAGE_REC_TEXT,
	            _code.WEBIM_MESSAGE_REC_EMOJI];
	
	        if (_utils.isCanDownLoadFile) {
	            supportRecMessage.push(_code.WEBIM_MESSAGE_REC_PHOTO);
	            supportRecMessage.push(_code.WEBIM_MESSAGE_REC_AUDIO_FILE);
	        }
	        var supportSedMessage = [_code.WEBIM_MESSAGE_SED_TEXT];
	        if (_utils.isCanUploadFile) {
	            supportSedMessage.push(_code.WEBIM_MESSAGE_REC_PHOTO);
	            supportSedMessage.push(_code.WEBIM_MESSAGE_REC_AUDIO_FILE);
	        }
	        conn.notifyVersion();
	        conn.retry && _handleMessageQueue(conn);
	        conn.heartBeat();
	        conn.isAutoLogin && conn.setPresence();
	        // console.log("conn",conn);
	
	        try {
	            if (conn.unSendMsgArr.length > 0) {
	                console.log("unSendMesArr",conn.unSendMsgArr);
	                for (var i in conn.unSendMsgArr) {
	                    var dom = conn.unSendMsgArr[i];
	                    conn.sendCommand(dom);
	                    delete conn.unSendMsgArr[i];
	                }
	            }
	        } catch (e) {
	            console.error(e.message);
	        }
	        conn.offLineSendConnecting = false;
	        conn.logOut = false;
	        conn.onOpened({
	            canReceive: supportRecMessage,
	            canSend: supportSedMessage,
	            accessToken: conn.context.accessToken
	        });
	    } else if (status == Strophe.Status.DISCONNECTING) {
	        if (conn.isOpened()) {
	            conn.stopHeartBeat();
	            conn.context.status = _code.STATUS_CLOSING;
	
	            error = {
	                type: _code.WEBIM_CONNCTION_SERVER_CLOSE_ERROR,
	                msg: msg,
	                reconnect: true
	            };
	
	            conflict && (error.conflict = true);
	            conn.onError(error);
	        }
	    } else if (status == Strophe.Status.DISCONNECTED) {
	        if (!conn.isClosing() || conn.isOpened()) {
	            if (conn.autoReconnectNumTotal < conn.autoReconnectNumMax) {
	                conn.reconnect(!conn.isClosing());
	                return;
	            } else {
	                error = {
	                    type: _code.WEBIM_CONNCTION_DISCONNECTED
	                };
	                conn.onError(error);
	            }
	        }
	        conn.context.status = _code.STATUS_CLOSED;
	        conn.clear();
	        conn.onClosed();
	    } else if (status == Strophe.Status.AUTHFAIL) {
	        error = {
	            type: _code.WEBIM_CONNCTION_AUTH_ERROR
	        };
	
	        conflict && (error.conflict = true);
	        conn.onError(error);
	        conn.clear();
	    } else if (status == Strophe.Status.ERROR) {
	        conn.context.status = _code.STATUS_ERROR;
	        error = {
	            type: _code.WEBIM_CONNCTION_SERVER_ERROR,
	            msg: msg,
	        };
	
	        conflict && (error.conflict = true);
	        conn.onError(error);
	    }
	    conn.context.status_now = status;
	};
	
	var _getJid = function (options, conn) {
	    var jid = options.toJid || '';
	
	    if (jid === '') {
	        var appKey = conn.context.appKey || '';
	        var toJid = appKey + '_' + options.to + '@' + conn.domain;
	
	        if (options.resource) {
	            toJid = toJid + '/' + options.resource;
	        }
	        jid = toJid;
	    }
	    return jid;
	};
	
	var _getJidByName = function (name, conn) {
	    var options = {
	        to: name
	    };
	    return _getJid(options, conn);
	};
	
	var _validCheck = function (options, conn) {
	    options = options || {};
	
	    if (options.user == '') {
	        conn.onError({
	            type: _code.WEBIM_CONNCTION_USER_NOT_ASSIGN_ERROR
	        });
	        return false;
	    }
	
	    var user = (options.user + '') || '';
	    var appKey = options.appKey || '';
	    var devInfos = appKey.split('#');
	
	    if (devInfos.length !== 2) {
	        conn.onError({
	            type: _code.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR
	        });
	        return false;
	    }
	    var orgName = devInfos[0];
	    var appName = devInfos[1];
	
	    if (!orgName) {
	        conn.onError({
	            type: _code.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR
	        });
	        return false;
	    }
	    if (!appName) {
	        conn.onError({
	            type: _code.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR
	        });
	        return false;
	    }
	
	    var jid = appKey + '_' + user.toLowerCase() + '@' + conn.domain,
	        resource = options.resource || 'webim';
	
	    if (conn.isMultiLoginSessions) {
	        resource += user + new Date().getTime() + Math.floor(Math.random().toFixed(6) * 1000000);
	    }
	    conn.context.jid = jid + '/' + resource;
	    /*jid: {appkey}_{username}@domain/resource*/
	    conn.context.userId = user;
	    conn.context.appKey = appKey;
	    conn.context.appName = appName;
	    conn.context.orgName = orgName;
	
	    return true;
	};
	
	var _getXmppUrl = function (baseUrl, https) {
	    if (/^(ws|http)s?:\/\/?/.test(baseUrl)) {
	        return baseUrl;
	    }
	
	    var url = {
	        prefix: 'http',
	        base: '://' + baseUrl,
	        suffix: '/http-bind/'
	    };
	
	    if (https && _utils.isSupportWss) {
	        url.prefix = 'wss';
	        url.suffix = '/ws/';
	    } else {
	        if (https) {
	            url.prefix = 'https';
	        } else if (window.WebSocket) {
	            url.prefix = 'ws';
	            url.suffix = '/ws/';
	        }
	    }
	
	    return url.prefix + url.base + url.suffix;
	};
	
	
	/**
	 * The connection class.
	 * @constructor
	 * @param {Object} options - 创建连接的初始化参数
	 * @param {String} options.url - xmpp服务器的URL
	 * @param {String} options.apiUrl - API服务器的URL
	 * @param {Boolean} options.isHttpDNS - 防止域名劫持
	 * @param {Boolean} options.isMultiLoginSessions - 为true时同一账户可以同时在多个Web页面登录（多标签登录，默认不开启，如有需要请联系商务），为false时同一账号只能在一个Web页面登录
	 * @param {Boolean} options.https - 是否启用wss.
	 * @param {Number} options.heartBeatWait - 发送心跳包的时间间隔（毫秒）
	 * @param {Boolean} options.isAutoLogin - 登录成功后是否自动出席
	 * @param {Number} options.autoReconnectNumMax - 掉线后重连的最大次数
	 * @param {Number} options.autoReconnectInterval -  掉线后重连的间隔时间（毫秒）
	 * @param {Boolean} options.isWindowSDK - 是否运行在WindowsSDK上
	 * @param {Boolean} options.encrypt - 是否加密文本消息
	 * @param {Boolean} options.delivery - 是否发送delivered ack
	 * @returns {Class}  连接实例
	 */
	
	
	//class
	var connection = function (options) {
	    if (!this instanceof connection) {
	        return new connection(options);
	    }
	
	    var options = options || {};
	
	    this.isHttpDNS = options.isHttpDNS || false;
	    this.isMultiLoginSessions = options.isMultiLoginSessions || false;
	    this.wait = options.wait || 30;
	    this.retry = options.retry || false;
	    this.https = options.https && location.protocol === 'https:';
	    this.url = _getXmppUrl(options.url, this.https);
	    this.hold = options.hold || 1;
	    this.route = options.route || null;
	    this.domain = options.domain || 'easemob.com';
	    this.inactivity = options.inactivity || 30;
	    this.heartBeatWait = options.heartBeatWait || 4500;
	    this.maxRetries = options.maxRetries || 5;
	    this.isAutoLogin = options.isAutoLogin === false ? false : true;
	    this.pollingTime = options.pollingTime || 800;
	    this.stropheConn = false;
	    this.autoReconnectNumMax = options.autoReconnectNumMax || 0;
	    this.autoReconnectNumTotal = 0;
	    this.autoReconnectInterval = options.autoReconnectInterval || 0;
	    this.context = {status: _code.STATUS_INIT};
	    this.sendQueue = new Queue();  //instead of sending message immediately,cache them in this queue
	    this.intervalId = null;   //clearInterval return value
	    this.apiUrl = options.apiUrl || '';
	    this.isWindowSDK = options.isWindowSDK || false;
	    this.encrypt = options.encrypt || {encrypt: {type: 'none'}};
	    this.delivery = options.delivery || false;
	    this.user = '';
	    this.orgName = '';
	    this.appName = '';
	    this.token = '';
	    this.unSendMsgArr = [];
	
	    this.dnsArr = ['https://rs.easemob.com', 'https://rsbak.easemob.com', 'http://182.92.174.78', 'http://112.126.66.111']; //http dns server hosts
	    this.dnsIndex = 0;   //the dns ip used in dnsArr currently
	    this.dnsTotal = this.dnsArr.length;  //max number of getting dns retries
	    this.restHosts = null; //rest server ips
	    this.restIndex = 0;    //the rest ip used in restHosts currently
	    this.restTotal = 0;    //max number of getting rest token retries
	    this.xmppHosts = null; //xmpp server ips
	    this.xmppIndex = 0;    //the xmpp ip used in xmppHosts currently
	    this.xmppTotal = 0;    //max number of creating xmpp server connection(ws/bosh) retries
	
	    this.groupOption = {};
	    
	    // global params
	    isStropheLog = options.isStropheLog || false;
	
	    abc = this;
	};
	
	/**
	 * 注册新用户
	 * @param {Object} options - 
	 * @param {String} options.username - 用户名，即用户ID
	 * @param {String} options.password - 密码
	 * @param {String} options.nickname - 用户昵称
	 * @param {Function} options.success - 成功之后的回调，默认为空
	 * @param {Function} options.error - 失败之后的回调，默认为空
	 */
	
	connection.prototype.registerUser = function (options) {
	    if (location.protocol != 'https:' && this.isHttpDNS) {
	        this.dnsIndex = 0;
	        this.getHttpDNS(options, 'signup');
	    } else {
	        this.signup(options);
	    }
	}
	
	/**
	 * 处理发送队列
	 * @private
	 */
	
	connection.prototype.handelSendQueue = function () {
	    var options = this.sendQueue.pop();
	    if (options !== null) {
	        this.sendReceiptsMessage(options);
	    }
	};
	
	/**
	 * 注册监听函数
	 * @param {Object} options - 回调函数集合
	 * @param {connection~onOpened} options.onOpened - 处理登录的回调
	 * @param {connection~onTextMessage} options.onTextMessage - 处理文本消息的回调
	 * @param {connection~onEmojiMessage} options.onEmojiMessage - 处理表情消息的回调
	 * @param {connection~onPictureMessage} options.onPictureMessage - 处理图片消息的回调
	 * @param {connection~onAudioMessage} options.onAudioMessage - 处理音频消息的回调
	 * @param {connection~onVideoMessage} options.onVideoMessage - 处理视频消息的回调
	 * @param {connection~onFileMessage} options.onFileMessage - 处理文件消息的回调
	 * @param {connection~onLocationMessage} options.onLocationMessage - 处理位置消息的回调
	 * @param {connection~onCmdMessage} options.onCmdMessage - 处理命令消息的回调
	 * @param {connection~onPresence} options.onPresence - 处理Presence消息的回调
	 * @param {connection~onError} options.onError - 处理错误消息的回调
	 * @param {connection~onReceivedMessage} options.onReceivedMessage - 处理Received消息的回调
	 * @param {connection~onInviteMessage} options.onInviteMessage - 处理邀请消息的回调
	 * @param {connection~onDeliverdMessage} options.onDeliverdMessage - 处理Delivered ACK消息的回调
	 * @param {connection~onReadMessage} options.onReadMessage - 处理Read ACK消息的回调
	 * @param {connection~onMutedMessage} options.onMutedMessage - 处理禁言消息的回调
	 * @param {connection~onOffline} options.onOffline - 处理断网的回调
	 * @param {connection~onOnline} options.onOnline - 处理联网的回调
	 * @param {connection~onCreateGroup} options.onCreateGroup - 处理创建群组的回调
	 */
	connection.prototype.listen = function (options) {
	    /**
	     * 登录成功后调用
	     * @callback connection~onOpened
	     */
	    /**
	     * 收到文本消息
	     * @callback connection~onTextMessage
	     */
	    /**
	     * 收到表情消息
	     * @callback connection~onEmojiMessage
	     */
	    /**
	     * 收到图片消息
	     * @callback connection~onPictureMessage
	     */
	    /**
	     * 收到音频消息
	     * @callback connection~onAudioMessage
	     */
	    /**
	     * 收到视频消息
	     * @callback connection~onVideoMessage
	     */
	    /**
	     * 收到文件消息
	     * @callback connection~onFileMessage
	     */
	    /**
	     * 收到位置消息
	     * @callback connection~onLocationMessage
	     */
	    /**
	     * 收到命令消息
	     * @callback connection~onCmdMessage
	     */
	    /**
	     * 收到错误消息
	     * @callback connection~onError
	     */
	    /**
	     * 收到Presence消息
	     * @callback connection~onPresence
	     */
	    /**
	     * 收到Received消息
	     * @callback connection~onReceivedMessage
	     */
	    /**
	     * 被邀请进群
	     * @callback connection~onInviteMessage
	     */
	    /**
	     * 收到已送达回执
	     * @callback connection~onDeliverdMessage
	     */
	    /**
	     * 收到已读回执
	     * @callback connection~onReadMessage
	     */
	    /**
	     * 被群管理员禁言
	     * @callback connection~onMutedMessage
	     */
	    /**
	     * 浏览器被断网时调用
	     * @callback connection~onOffline
	     */
	    /**
	     * 浏览器联网时调用
	     * @callback connection~onOnline
	     */
	    /**
	     * 建群成功后调用
	     * @callback connection~onCreateGroup
	     */
	    this.onOpened = options.onOpened || _utils.emptyfn;
	    this.onClosed = options.onClosed || _utils.emptyfn;
	    this.onTextMessage = options.onTextMessage || _utils.emptyfn;
	    this.onEmojiMessage = options.onEmojiMessage || _utils.emptyfn;
	    this.onPictureMessage = options.onPictureMessage || _utils.emptyfn;
	    this.onAudioMessage = options.onAudioMessage || _utils.emptyfn;
	    this.onVideoMessage = options.onVideoMessage || _utils.emptyfn;
	    this.onFileMessage = options.onFileMessage || _utils.emptyfn;
	    this.onLocationMessage = options.onLocationMessage || _utils.emptyfn;
	    this.onCmdMessage = options.onCmdMessage || _utils.emptyfn;
	    this.onPresence = options.onPresence || _utils.emptyfn;
	    this.onRoster = options.onRoster || _utils.emptyfn;
	    this.onError = options.onError || _utils.emptyfn;
	    this.onReceivedMessage = options.onReceivedMessage || _utils.emptyfn;
	    this.onInviteMessage = options.onInviteMessage || _utils.emptyfn;
	    this.onDeliverdMessage = options.onDeliveredMessage || _utils.emptyfn;
	    this.onReadMessage = options.onReadMessage || _utils.emptyfn;
	    this.onMutedMessage = options.onMutedMessage || _utils.emptyfn;
	    this.onOffline = options.onOffline || _utils.emptyfn;
	    this.onOnline = options.onOnline || _utils.emptyfn;
	    this.onConfirmPop = options.onConfirmPop || _utils.emptyfn;
	    this.onCreateGroup = options.onCreateGroup || _utils.emptyfn;
	    //for WindowSDK start
	    this.onUpdateMyGroupList = options.onUpdateMyGroupList || _utils.emptyfn;
	    this.onUpdateMyRoster = options.onUpdateMyRoster || _utils.emptyfn;
	    //for WindowSDK end
	    this.onBlacklistUpdate = options.onBlacklistUpdate || _utils.emptyfn;
	
	    _listenNetwork(this.onOnline, this.onOffline);
	};
	
	/**
	 * 发送心跳
	 * webrtc需要强制心跳，加个默认为false的参数 向下兼容
	 * @param {Boolean} forcing - 是否强制发送
	 * @private
	 */
	connection.prototype.heartBeat = function (forcing) {
	    if (forcing !== true) {
	        forcing = false;
	    }
	    var me = this;
	    //IE8: strophe auto switch from ws to BOSH, need heartbeat
	    var isNeed = !/^ws|wss/.test(me.url) || /mobile/.test(navigator.userAgent);
	
	    if (this.heartBeatID || (!forcing && !isNeed)) {
	        return;
	    }
	
	    var options = {
	        toJid: this.domain,
	        type: 'normal'
	    };
	    this.heartBeatID = setInterval(function () {
	        // fix: do heartbeat only when websocket 
	        _utils.isSupportWss && me.ping(options);
	    }, this.heartBeatWait);
	};
	
	/**
	 * @private
	 */
	
	connection.prototype.stopHeartBeat = function () {
	    if (typeof this.heartBeatID == "number") {
	        this.heartBeatID = clearInterval(this.heartBeatID);
	    }
	};
	
	/**
	 * 发送接收消息回执
	 * @param {Object} options -
	 * @param {String} options.id - 消息id
	 * @private
	 */
	connection.prototype.sendReceiptsMessage = function (options) {
	    var dom = $msg({
	        from: this.context.jid || '',
	        to: this.domain,
	        id: options.id || ''
	    }).c('received', {
	        xmlns: 'urn:xmpp:receipts',
	        id: options.id || ''
	    });
	    this.sendCommand(dom.tree());
	};
	
	/**
	 * @private
	 */
	
	connection.prototype.cacheReceiptsMessage = function (options) {
	    this.sendQueue.push(options);
	};
	
	/**
	 * @private
	 */
	
	connection.prototype.getStrophe = function () {
	    if (location.protocol != 'https:' && this.isHttpDNS) {
	        //TODO: try this.xmppTotal times on fail
	        var url = '';
	        var host = this.xmppHosts[this.xmppIndex];
	        var domain = _utils.getXmlFirstChild(host, 'domain');
	        var ip = _utils.getXmlFirstChild(host, 'ip');
	        if (ip) {
	            url = ip.textContent;
	            var port = _utils.getXmlFirstChild(host, 'port');
	            if (port.textContent != '80') {
	                url += ':' + port.textContent;
	            }
	        } else {
	            url = domain.textContent;
	        }
	
	        if (url != '') {
	            var parter = /(.+\/\/).+(\/.+)/;
	            this.url = this.url.replace(parter, "$1" + url + "$2");
	        }
	    }
	
	    var stropheConn = new Strophe.Connection(this.url, {
	        inactivity: this.inactivity,
	        maxRetries: this.maxRetries,
	        pollingTime: this.pollingTime
	    });
	    return stropheConn;
	};
	
	/**
	 *
	 * @param data
	 * @param tagName
	 * @private
	 */
	connection.prototype.getHostsByTag = function (data, tagName) {
	    var tag = _utils.getXmlFirstChild(data, tagName);
	    if (!tag) {
	        console.log(tagName + ' hosts error');
	        return null;
	    }
	    var hosts = tag.getElementsByTagName('hosts');
	    if (hosts.length == 0) {
	        console.log(tagName + ' hosts error2');
	        return null;
	    }
	    return hosts[0].getElementsByTagName('host');
	
	};
	
	/**
	 * @private
	 */
	connection.prototype.getRestFromHttpDNS = function (options, type) {
	    if (this.restIndex > this.restTotal) {
	        console.log('rest hosts all tried,quit');
	        return;
	    }
	    var url = '';
	    var host = this.restHosts[this.restIndex];
	    var domain = _utils.getXmlFirstChild(host, 'domain');
	    var ip = _utils.getXmlFirstChild(host, 'ip');
	    if (ip) {
	        var port = _utils.getXmlFirstChild(host, 'port');
	        url = (location.protocol === 'https:' ? 'https:' : 'http:') + '//' + ip.textContent + ':' + port.textContent;
	    } else {
	        url = (location.protocol === 'https:' ? 'https:' : 'http:') + '//' + domain.textContent;
	    }
	
	    if (url != '') {
	        this.apiUrl = url;
	        options.apiUrl = url;
	    }
	
	    if (type == 'login') {
	        this.login(options);
	    } else {
	        this.signup(options);
	    }
	};
	
	/**
	 * @private
	 */
	
	connection.prototype.getHttpDNS = function (options, type) {
	    // if (this.restHosts) {
	    //     this.getRestFromHttpDNS(options, type);
	    //     return;
	    // }
	    var self = this;
	    var suc = function (data, xhr) {
	        data = new DOMParser().parseFromString(data, "text/xml").documentElement;
	        //get rest ips
	        var restHosts = self.getHostsByTag(data, 'rest');
	        if (!restHosts) {
	            console.log('rest hosts error3');
	            return;
	        }
	        self.restHosts = restHosts;
	        self.restTotal = restHosts.length;
	
	        //get xmpp ips
	        var makeArray = function(obj){    //伪数组转为数组
	          return Array.prototype.slice.call(obj,0); 
	        } 
	        try{ 
	            Array.prototype.slice.call(document.documentElement.childNodes, 0)[0].nodeType; 
	        }catch(e){ 
	            makeArray = function(obj){ 
	                var res = []; 
	                for(var i=0,len=obj.length; i<len; i++){
	                   res.push(obj[i]); 
	                } 
	              return res; 
	          } 
	        } 
	        var xmppHosts = makeArray(self.getHostsByTag(data, 'xmpp'));
	        if (!xmppHosts) {
	            console.log('xmpp hosts error3');
	            return;
	        }
	        for(var i = 0; i< xmppHosts.length; i++){
	            var httpType = self.https ? 'https' : 'http';
	            if(_utils.getXmlFirstChild(xmppHosts[i], 'protocol').textContent === httpType ){
	                var currentPost = xmppHosts[i];
	                xmppHosts.splice(i,1);
	                xmppHosts.unshift(currentPost);
	            }
	        }
	        self.xmppHosts = xmppHosts;
	        self.xmppTotal = xmppHosts.length;
	
	        self.getRestFromHttpDNS(options, type);
	    };
	    var error = function (res, xhr, msg) {
	
	        console.log('getHttpDNS error', res, msg);
	        self.dnsIndex++;
	        if (self.dnsIndex < self.dnsTotal) {
	            self.getHttpDNS(options, type);
	        }
	
	    };
	    var options2 = {
	        url: this.dnsArr[this.dnsIndex] + '/easemob/server.xml',
	        dataType: 'text',
	        type: 'GET',
	
	        // url: 'http://www.easemob.com/easemob/server.xml',
	        // dataType: 'xml',
	        data: {app_key: encodeURIComponent(options.appKey)},
	        success: suc || _utils.emptyfn,
	        error: error || _utils.emptyfn
	    };
	    _utils.ajax(options2);
	};
	
	/**
	 * @private
	 */
	
	connection.prototype.signup = function (options) {
	    var self = this;
	    var orgName = options.orgName || '';
	    var appName = options.appName || '';
	    var appKey = options.appKey || '';
	    var suc = options.success || EMPTYFN;
	    var err = options.error || EMPTYFN;
	
	    if (!orgName && !appName && appKey) {
	        var devInfos = appKey.split('#');
	        if (devInfos.length === 2) {
	            orgName = devInfos[0];
	            appName = devInfos[1];
	        }
	    }
	    if (!orgName && !appName) {
	        err({
	            type: _code.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR
	        });
	        return;
	    }
	
	    var error = function (res, xhr, msg) {
	        if (location.protocol != 'https:' && self.isHttpDNS) {
	            if ((self.restIndex + 1) < self.restTotal) {
	                self.restIndex++;
	                self.getRestFromHttpDNS(options, 'signup');
	                return;
	            }
	        }
	        self.clear();
	        err(res);
	    };
	    var https = options.https || https;
	    var apiUrl = options.apiUrl;
	    var restUrl = apiUrl + '/' + orgName + '/' + appName + '/users';
	
	    var userjson = {
	        username: options.username,
	        password: options.password,
	        nickname: options.nickname || ''
	    };
	
	    var userinfo = _utils.stringify(userjson);
	    var options2 = {
	        url: restUrl,
	        dataType: 'json',
	        data: userinfo,
	        success: suc,
	        error: error
	    };
	    _utils.ajax(options2);
	};
	
	/**
	 * 登录
	 * @param {Object} options - 用户信息
	 * @param {String} options.user - 用户名
	 * @param {String} options.pwd - 用户密码，跟token二选一
	 * @param {String} options.accessToken - token，跟密码二选一
	 * @param {String} options.appKey - Appkey
	 * @param {String} options.apiUrl - Rest 服务地址,非必须。可在项目的WebIMConfig配置
	 * @param {String} options.xmppURL - Xmpp 服务地址,非必须。可在项目的WebIMConfig配置
	 * @param {Function} options.success - 成功之后的回调，默认为空，token登录没有该回调
	 * @param {Function} options.error - 失败之后的回调，默认为空，token登录没有该回调
	 */
	
	connection.prototype.open = function (options) {
	    // console.log(8888888);
	    
	    var appkey = options.appKey,
	        orgName = appkey.split('#')[0],
	        appName = appkey.split('#')[1];
	    this.orgName = orgName;
	    this.appName = appName;
	    if (options.accessToken) {
	        this.token = options.accessToken;
	    }
	    if (options.xmppURL) {
	        this.url = _getXmppUrl(options.xmppURL, this.https);
	    }
	    if (location.protocol != 'https:' && this.isHttpDNS) {
	        this.dnsIndex = 0;
	        this.getHttpDNS(options, 'login');
	    } else {
	        this.login(options);
	    }
	};
	
	/**
	 *
	 * @param options
	 * @private
	 */
	
	connection.prototype.login = function (options) {
	    this.user = options.user;
	    var pass = _validCheck(options, this);
	
	    if (!pass) {
	        return;
	    }
	
	    var conn = this;
	
	    if (conn.isOpened()) {
	        return;
	    }
	
	    if (options.accessToken) {
	        options.access_token = options.accessToken;
	        conn.context.restTokenData = options;
	        _login(options, conn);
	    } else {
	        var apiUrl = options.apiUrl;
	        var userId = this.context.userId;
	        var pwd = options.pwd || '';
	        var appName = this.context.appName;
	        var orgName = this.context.orgName;
	
	        var suc = function (data, xhr) {
	            conn.context.status = _code.STATUS_DOLOGIN_IM;
	            conn.context.restTokenData = data;
	            if (options.success)
	                options.success(data);
	            conn.token = data.access_token;
	            _login(data, conn);
	        };
	        var error = function (res, xhr, msg) {
	            if (options.error)
	                options.error();
	            if (location.protocol != 'https:' && conn.isHttpDNS) {
	                if ((conn.restIndex + 1) < conn.restTotal) {
	                    conn.restIndex++;
	                    conn.getRestFromHttpDNS(options, 'login');
	                    return;
	                }
	            }
	            conn.clear();
	            if (res.error && res.error_description) {
	                conn.onError({
	                    type: _code.WEBIM_CONNCTION_OPEN_USERGRID_ERROR,
	                    data: res,
	                    xhr: xhr
	                });
	            } else {
	                conn.onError({
	                    type: _code.WEBIM_CONNCTION_OPEN_ERROR,
	                    data: res,
	                    xhr: xhr
	                });
	            }
	        };
	
	        this.context.status = _code.STATUS_DOLOGIN_USERGRID;
	
	        var loginJson = {
	            grant_type: 'password',
	            username: userId,
	            password: pwd,
	            timestamp: +new Date()
	        };
	        var loginfo = _utils.stringify(loginJson);
	
	        var options2 = {
	            url: apiUrl + '/' + orgName + '/' + appName + '/token',
	            dataType: 'json',
	            data: loginfo,
	            success: suc || _utils.emptyfn,
	            error: error || _utils.emptyfn
	        };
	        _utils.ajax(options2);
	    }
	};
	
	/**
	 * attach to xmpp server for BOSH
	 * @private
	 */
	connection.prototype.attach = function (options) {
	    var pass = _validCheck(options, this);
	
	    if (!pass) {
	        return;
	    }
	
	    options = options || {};
	
	    var accessToken = options.accessToken || '';
	    if (accessToken == '') {
	        this.onError({
	            type: _code.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR
	        });
	        return;
	    }
	
	    var sid = options.sid || '';
	    if (sid === '') {
	        this.onError({
	            type: _code.WEBIM_CONNCTION_SESSIONID_NOT_ASSIGN_ERROR
	        });
	        return;
	    }
	
	    var rid = options.rid || '';
	    if (rid === '') {
	        this.onError({
	            type: _code.WEBIM_CONNCTION_RID_NOT_ASSIGN_ERROR
	        });
	        return;
	    }
	
	    var stropheConn = this.getStrophe();
	
	    this.context.accessToken = accessToken;
	    this.context.stropheConn = stropheConn;
	    this.context.status = _code.STATUS_DOLOGIN_IM;
	
	    var conn = this;
	    var callback = function (status, msg) {
	        _loginCallback(status, msg, conn);
	    };
	
	    var jid = this.context.jid;
	    var wait = this.wait;
	    var hold = this.hold;
	    var wind = this.wind || 5;
	    stropheConn.attach(jid, sid, rid, callback, wait, hold, wind);
	};
	
	/**
	 * 断开连接，同时心跳停止
	 * @param {String} reason - 断开原因
	 */
	
	connection.prototype.close = function (reason) {
	    this.logOut = true;
	    this.stopHeartBeat();
	
	    var status = this.context.status;
	    if (status == _code.STATUS_INIT) {
	        return;
	    }
	
	    if (this.isClosed() || this.isClosing()) {
	        return;
	    }
	
	    this.context.status = _code.STATUS_CLOSING;
	    this.context.stropheConn.disconnect(reason);
	};
	
	/**
	 * strophe 的方法
	 * @private
	 */
	
	connection.prototype.addHandler = function (handler, ns, name, type, id, from, options) {
	    this.context.stropheConn.addHandler(handler, ns, name, type, id, from, options);
	};
	
	/**
	 * strophe sendIQ
	 * @private
	 */
	connection.prototype.notifyVersion = function (suc, fail) {
	    var jid = _getJid({}, this);
	    var dom = $iq({
	        from: this.context.jid || ''
	        , to: this.domain
	        , type: 'result'
	    })
	        .c('query', {xmlns: 'jabber:iq:version'})
	        .c('name')
	        .t('easemob')
	        .up()
	        .c('version')
	        .t(_version)
	        .up()
	        .c('os')
	        .t('webim');
	
	    var suc = suc || _utils.emptyfn;
	    var error = fail || this.onError;
	    var failFn = function (ele) {
	        error({
	            type: _code.WEBIM_CONNCTION_NOTIFYVERSION_ERROR
	            , data: ele
	        });
	    };
	    this.context.stropheConn.sendIQ(dom.tree(), suc, failFn);
	    return;
	};
	
	/**
	 * handle all types of presence message
	 * @private
	 */
	connection.prototype.handlePresence = function (msginfo) {
	    if (this.isClosed()) {
	        return;
	    }
	    var from = msginfo.getAttribute('from') || '';
	    var to = msginfo.getAttribute('to') || '';
	    var type = msginfo.getAttribute('type') || '';
	    var presence_type = msginfo.getAttribute('presence_type') || '';
	    var fromUser = _parseNameFromJidFn(from);
	    var toUser = _parseNameFromJidFn(to);
	    var isCreate = false;
	    var isMemberJoin = false;
	    var isDecline = false;
	    var isApply = false;
	    var info = {
	        from: fromUser,
	        to: toUser,
	        fromJid: from,
	        toJid: to,
	        type: type,
	        chatroom: msginfo.getElementsByTagName('roomtype').length ? true : false
	    };
	
	    var showTags = msginfo.getElementsByTagName('show');
	    if (showTags && showTags.length > 0) {
	        var showTag = showTags[0];
	        info.show = Strophe.getText(showTag);
	    }
	    var statusTags = msginfo.getElementsByTagName('status');
	    if (statusTags && statusTags.length > 0) {
	        var statusTag = statusTags[0];
	        info.status = Strophe.getText(statusTag);
	        info.code = statusTag.getAttribute('code');
	    }
	
	    var priorityTags = msginfo.getElementsByTagName('priority');
	    if (priorityTags && priorityTags.length > 0) {
	        var priorityTag = priorityTags[0];
	        info.priority = Strophe.getText(priorityTag);
	    }
	
	    var error = msginfo.getElementsByTagName('error');
	    if (error && error.length > 0) {
	        var error = error[0];
	        info.error = {
	            code: error.getAttribute('code')
	        };
	    }
	
	    var destroy = msginfo.getElementsByTagName('destroy');
	    if (destroy && destroy.length > 0) {
	        var destroy = destroy[0];
	        info.destroy = true;
	
	        var reason = destroy.getElementsByTagName('reason');
	        if (reason && reason.length > 0) {
	            info.reason = Strophe.getText(reason[0]);
	        }
	    }
	
	    var members = msginfo.getElementsByTagName('item');
	    if (members && members.length > 0) {
	        var member = members[0];
	        var role = member.getAttribute('role');
	        var jid = member.getAttribute('jid');
	        var affiliation = member.getAttribute('affiliation');
	        // dismissed by group
	        if (role == 'none' && jid) {
	            var kickedMember = _parseNameFromJidFn(jid);
	            var actor = member.getElementsByTagName('actor')[0];
	            var actorNick = actor.getAttribute('nick');
	            info.actor = actorNick;
	            info.kicked = kickedMember;
	        }
	        // Service Acknowledges Room Creation `createGroupACK`
	        if (role == 'moderator' && info.code == '201') {
	            if (affiliation === 'owner') {
	                info.type = 'createGroupACK';
	                isCreate = true;
	            }
	            // else
	            //     info.type = 'joinPublicGroupSuccess';
	        }
	    }
	
	    var x = msginfo.getElementsByTagName('x');
	    if (x && x.length > 0) {
	        // 加群申请
	        var apply = x[0].getElementsByTagName('apply');
	        // 加群成功
	        var accept = x[0].getElementsByTagName('accept');
	        // 同意加群后用户进群通知
	        var item = x[0].getElementsByTagName('item');
	        // 加群被拒绝
	        var decline = x[0].getElementsByTagName('decline');
	        // 被设为管理员
	        var addAdmin = x[0].getElementsByTagName('add_admin');
	        // 被取消管理员
	        var removeAdmin = x[0].getElementsByTagName('remove_admin');
	        // 被禁言
	        var addMute = x[0].getElementsByTagName('add_mute');
	        // 取消禁言
	        var removeMute = x[0].getElementsByTagName('remove_mute');
	
	        if (apply && apply.length > 0) {
	            isApply = true;
	            info.toNick = apply[0].getAttribute('toNick');
	            info.type = 'joinGroupNotifications';
	            var groupJid = apply[0].getAttribute('to');
	            var gid = groupJid.split('@')[0].split('_');
	            gid = gid[gid.length - 1];
	            info.gid = gid;
	        } else if (accept && accept.length > 0) {
	            info.type = 'joinPublicGroupSuccess';
	        } else if (item && item.length > 0) {
	            var affiliation = item[0].getAttribute('affiliation'),
	                role = item[0].getAttribute('role');
	            if (affiliation == 'member'
	                ||
	                role == 'participant') {
	                isMemberJoin = true;
	                info.mid = info.fromJid.split('/');
	                info.mid = info.mid[info.mid.length - 1];
	                info.type = 'memberJoinPublicGroupSuccess';
	                var roomtype = msginfo.getElementsByTagName('roomtype');
	                if (roomtype && roomtype.length > 0) {
	                    var type = roomtype[0].getAttribute('type');
	                    if (type == 'chatroom') {
	                        info.type = 'memberJoinChatRoomSuccess';
	                    }
	                }
	            }
	        } else if (decline && decline.length) {
	            isDecline = true;
	            var gid = decline[0].getAttribute("fromNick");
	            var owner = _parseNameFromJidFn(decline[0].getAttribute("from"));
	            info.type = "joinPublicGroupDeclined";
	            info.owner = owner;
	            info.gid = gid;
	        } else if (addAdmin && addAdmin.length > 0) {
	            var gid = _parseNameFromJidFn(addAdmin[0].getAttribute('mucjid'));
	            var owner = _parseNameFromJidFn(addAdmin[0].getAttribute('from'));
	            info.owner = owner;
	            info.gid = gid;
	            info.type = "addAdmin";
	        } else if (removeAdmin && removeAdmin.length > 0) {
	            var gid = _parseNameFromJidFn(removeAdmin[0].getAttribute('mucjid'));
	            var owner = _parseNameFromJidFn(removeAdmin[0].getAttribute('from'));
	            info.owner = owner;
	            info.gid = gid;
	            info.type = "removeAdmin";
	        } else if (addMute && addMute.length > 0) {
	            var gid = _parseNameFromJidFn(addMute[0].getAttribute('mucjid'));
	            var owner = _parseNameFromJidFn(addMute[0].getAttribute('from'));
	            info.owner = owner;
	            info.gid = gid;
	            info.type = "addMute";
	        } else if (removeMute && removeMute.length > 0) {
	            var gid = _parseNameFromJidFn(removeMute[0].getAttribute('mucjid'));
	            var owner = _parseNameFromJidFn(removeMute[0].getAttribute('from'));
	            info.owner = owner;
	            info.gid = gid;
	            info.type = "removeMute";
	        }
	    }
	
	
	    if (info.chatroom) {
	        // diff the
	        info.presence_type = presence_type;
	        info.original_type = info.type;
	        var reflectUser = from.slice(from.lastIndexOf('/') + 1);
	
	        if (reflectUser === this.context.userId) {
	            if (info.type === '' && !info.code) {
	                info.type = 'joinChatRoomSuccess';
	            } else if (presence_type === 'unavailable' || info.type === 'unavailable') {
	                if (!info.status) {// logout successfully.
	                    info.type = 'leaveChatRoom';
	                } else if (info.code == 110) {// logout or dismissied by admin.
	                    info.type = 'leaveChatRoom';
	                } else if (info.error && info.error.code == 406) {// The chat room is full.
	                    info.type = 'reachChatRoomCapacity';
	                }
	            }
	        }
	    } else {
	        info.presence_type = presence_type;
	        info.original_type = type;
	
	        if (/subscribe/.test(info.type)) {
	            //subscribe | subscribed | unsubscribe | unsubscribed
	        } else if (type == ""
	            &&
	            !info.status
	            &&
	            !info.error
	            &&
	            !isCreate
	            &&
	            !isApply
	            &&
	            !isMemberJoin
	            &&
	            !isDecline
	        ) {
	            // console.log(2222222, msginfo, info, isApply);
	            // info.type = 'joinPublicGroupSuccess';
	        } else if (presence_type === 'unavailable' || type === 'unavailable') {// There is no roomtype when a chat room is deleted.
	            if (info.destroy) {// Group or Chat room Deleted.
	                info.type = 'deleteGroupChat';
	            } else if (info.code == 307 || info.code == 321) {// Dismissed by group.
	                var nick = msginfo.getAttribute('nick');
	                if (!nick)
	                    info.type = 'leaveGroup';
	                else
	                    info.type = 'removedFromGroup';
	            }
	        }
	    }
	    this.onPresence(info, msginfo);
	};
	
	/**
	 * @private
	 */
	
	connection.prototype.handlePing = function (e) {
	    if (this.isClosed()) {
	        return;
	    }
	    var id = e.getAttribute('id');
	    var from = e.getAttribute('from');
	    var to = e.getAttribute('to');
	    var dom = $iq({
	        from: to
	        , to: from
	        , id: id
	        , type: 'result'
	    });
	    this.sendCommand(dom.tree());
	};
	
	/**
	 * @private
	 */
	
	connection.prototype.handleIq = function (iq) {
	    return true;
	};
	
	/**
	 * @private
	 */
	connection.prototype.handleIqPrivacy = function (msginfo) {
	    var list = msginfo.getElementsByTagName('list');
	    if (list.length == 0) {
	        return;
	    }
	    this.getBlacklist();
	};
	
	/**
	 * @private
	 */
	connection.prototype.handleIqRoster = function (e) {
	    var id = e.getAttribute('id');
	    var from = e.getAttribute('from') || '';
	    var name = _parseNameFromJidFn(from);
	    var curJid = this.context.jid;
	    var curUser = this.context.userId;
	
	    var iqresult = $iq({type: 'result', id: id, from: curJid});
	    this.sendCommand(iqresult.tree());
	
	    var msgBodies = e.getElementsByTagName('query');
	    if (msgBodies && msgBodies.length > 0) {
	        var queryTag = msgBodies[0];
	        var rouster = _parseFriend(queryTag, this, from);
	        this.onRoster(rouster);
	    }
	    return true;
	};
	
	/**
	 * @private
	 */
	connection.prototype.handleMessage = function (msginfo) {
	    var self = this;
	    if (this.isClosed()) {
	        return;
	    }
	
	    var id = msginfo.getAttribute('id') || '';
	
	
	    // cache ack into sendQueue first , handelSendQueue will do the send thing with the speed of  5/s
	    this.cacheReceiptsMessage({
	        id: id
	    });
	    var parseMsgData = _parseResponseMessage(msginfo);
	    if (parseMsgData.errorMsg) {
	        this.handlePresence(msginfo);
	        return;
	    }
	    // send error
	    var error = msginfo.getElementsByTagName('error');
	    var errorCode = '';
	    var errorText = '';
	    var errorBool = false;
	    if (error.length > 0) {
	        errorBool = true;
	        errorCode = error[0].getAttribute('code');
	        var textDOM = error[0].getElementsByTagName('text');
	        errorText = textDOM[0].textContent || textDOM[0].text;
	    }
	
	    var msgDatas = parseMsgData.data;
	    for (var i in msgDatas) {
	        if (!msgDatas.hasOwnProperty(i)) {
	            continue;
	        }
	        var msg = msgDatas[i];
	        if (!msg.from || !msg.to) {
	            continue;
	        }
	
	        var from = (msg.from + '').toLowerCase();
	        var too = (msg.to + '').toLowerCase();
	        var extmsg = msg.ext || {};
	        var chattype = '';
	        var typeEl = msginfo.getElementsByTagName('roomtype');
	        if (typeEl.length) {
	            chattype = typeEl[0].getAttribute('type') || 'chat';
	        } else {
	            chattype = msginfo.getAttribute('type') || 'chat';
	        }
	
	        var msgBodies = msg.bodies;
	        if (!msgBodies || msgBodies.length == 0) {
	            continue;
	        }
	        var msgBody = msg.bodies[0];
	        var type = msgBody.type;
	        var isCmdMsg = false;
	
	        try {
	            switch (type) {
	                case 'txt':
	                    var receiveMsg = msgBody.msg;
	                    if (self.encrypt.type === 'base64') {
	                        receiveMsg = atob(receiveMsg);
	                    } else if (self.encrypt.type === 'aes') {
	                        var key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
	                        var iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
	                        var mode = self.encrypt.mode.toLowerCase();
	                        var option = {};
	                        if (mode === 'cbc') {
	                            option = {
	                                iv: iv,
	                                mode: CryptoJS.mode.CBC,
	                                padding: CryptoJS.pad.Pkcs7
	                            };
	                        } else if (mode === 'ebc') {
	                            option = {
	                                mode: CryptoJS.mode.ECB,
	                                padding: CryptoJS.pad.Pkcs7
	                            }
	                        }
	                        var encryptedBase64Str = receiveMsg;
	                        var decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, option);
	                        var decryptedStr = decryptedData.toString(CryptoJS.enc.Utf8);
	                        receiveMsg = decryptedStr;
	                    }
	                    var emojibody = _utils.parseTextMessage(receiveMsg, WebIM.Emoji);
	                    if (emojibody.isemoji) {
	                        var msg = {
	                            id: id
	                            , type: chattype
	                            , from: from
	                            , to: too
	                            , delay: parseMsgData.delayTimeStamp
	                            , data: emojibody.body
	                            , ext: extmsg
	                        };
	                        !msg.delay && delete msg.delay;
	                        msg.error = errorBool;
	                        msg.errorText = errorText;
	                        msg.errorCode = errorCode;
	                        this.onEmojiMessage(msg);
	                    } else {
	                        var msg = {
	                            id: id
	                            , type: chattype
	                            , from: from
	                            , to: too
	                            , delay: parseMsgData.delayTimeStamp
	                            , data: receiveMsg
	                            , ext: extmsg
	                        };
	                        !msg.delay && delete msg.delay;
	                        msg.error = errorBool;
	                        msg.errorText = errorText;
	                        msg.errorCode = errorCode;
	                        this.onTextMessage(msg);
	                    }
	                    break;
	                case 'img':
	                    var rwidth = 0;
	                    var rheight = 0;
	                    if (msgBody.size) {
	                        rwidth = msgBody.size.width;
	                        rheight = msgBody.size.height;
	                    }
	                    var msg = {
	                        id: id
	                        , type: chattype
	                        , from: from
	                        , to: too
	                        ,
	                        url: (location.protocol != 'https:' && self.isHttpDNS) ? (self.apiUrl + msgBody.url.substr(msgBody.url.indexOf("/", 9))) : msgBody.url
	                        , secret: msgBody.secret
	                        , filename: msgBody.filename
	                        , thumb: msgBody.thumb
	                        , thumb_secret: msgBody.thumb_secret
	                        , file_length: msgBody.file_length || ''
	                        , width: rwidth
	                        , height: rheight
	                        , filetype: msgBody.filetype || ''
	                        , accessToken: this.context.accessToken || ''
	                        , ext: extmsg
	                        , delay: parseMsgData.delayTimeStamp
	                    };
	                    !msg.delay && delete msg.delay;
	                    msg.error = errorBool;
	                    msg.errorText = errorText;
	                    msg.errorCode = errorCode;
	                    this.onPictureMessage(msg);
	                    break;
	                case 'audio':
	                    var msg = {
	                        id: id
	                        , type: chattype
	                        , from: from
	                        , to: too
	                        ,
	                        url: (location.protocol != 'https:' && self.isHttpDNS) ? (self.apiUrl + msgBody.url.substr(msgBody.url.indexOf("/", 9))) : msgBody.url
	                        , secret: msgBody.secret
	                        , filename: msgBody.filename
	                        , length: msgBody.length || ''
	                        , file_length: msgBody.file_length || ''
	                        , filetype: msgBody.filetype || ''
	                        , accessToken: this.context.accessToken || ''
	                        , ext: extmsg
	                        , delay: parseMsgData.delayTimeStamp
	                    };
	                    !msg.delay && delete msg.delay;
	                    msg.error = errorBool;
	                    msg.errorText = errorText;
	                    msg.errorCode = errorCode;
	                    this.onAudioMessage(msg);
	                    break;
	                case 'file':
	                    var msg = {
	                        id: id
	                        , type: chattype
	                        , from: from
	                        , to: too
	                        ,
	                        url: (location.protocol != 'https:' && self.isHttpDNS) ? (self.apiUrl + msgBody.url.substr(msgBody.url.indexOf("/", 9))) : msgBody.url
	                        , secret: msgBody.secret
	                        , filename: msgBody.filename
	                        , file_length: msgBody.file_length
	                        , accessToken: this.context.accessToken || ''
	                        , ext: extmsg
	                        , delay: parseMsgData.delayTimeStamp
	                    };
	                    !msg.delay && delete msg.delay;
	                    msg.error = errorBool;
	                    msg.errorText = errorText;
	                    msg.errorCode = errorCode;
	                    this.onFileMessage(msg);
	                    break;
	                case 'loc':
	                    var msg = {
	                        id: id
	                        , type: chattype
	                        , from: from
	                        , to: too
	                        , addr: msgBody.addr
	                        , lat: msgBody.lat
	                        , lng: msgBody.lng
	                        , ext: extmsg
	                        , delay: parseMsgData.delayTimeStamp
	                    };
	                    !msg.delay && delete msg.delay;
	                    msg.error = errorBool;
	                    msg.errorText = errorText;
	                    msg.errorCode = errorCode;
	                    this.onLocationMessage(msg);
	                    break;
	                case 'video':
	                    var msg = {
	                        id: id
	                        , type: chattype
	                        , from: from
	                        , to: too
	                        ,
	                        url: (location.protocol != 'https:' && self.isHttpDNS) ? (self.apiUrl + msgBody.url.substr(msgBody.url.indexOf("/", 9))) : msgBody.url
	                        , secret: msgBody.secret
	                        , filename: msgBody.filename
	                        , file_length: msgBody.file_length
	                        , accessToken: this.context.accessToken || ''
	                        , ext: extmsg
	                        , delay: parseMsgData.delayTimeStamp
	                    };
	                    !msg.delay && delete msg.delay;
	                    msg.error = errorBool;
	                    msg.errorText = errorText;
	                    msg.errorCode = errorCode;
	                    this.onVideoMessage(msg);
	                    break;
	                case 'cmd':
	                    var msg = {
	                        id: id
	                        , from: from
	                        , to: too
	                        , action: msgBody.action
	                        , ext: extmsg
	                        , delay: parseMsgData.delayTimeStamp
	                    };
	                    !msg.delay && delete msg.delay;
	                    msg.error = errorBool;
	                    msg.errorText = errorText;
	                    msg.errorCode = errorCode;
	                    if(msgBody.action === 'em_retrieve_dns'){
	                        isCmdMsg = true;
	                    }
	                    // if(msgBody.action.indexOf("em_") !== 0){
	                        self.onCmdMessage(msg);
	                    // }
	                    // else{
	                    //     var ackMessage = new WebIM.message("read", self.getUniqueId())
	                    //     ackMessage.set({ id: msg.id, to: msg.from, ext: { logo: "easemob" } })
	                    //     self.send(ackMessage.body)
	                    //     self.handelSendQueue();        
	                    // }
	                    break;
	            }
	            ;
	            if (self.delivery) {
	                var msgId = self.getUniqueId();
	                var bodyId = msg.id;
	                var deliverMessage = new WebIM.message('delivery', msgId);
	                deliverMessage.set({
	                    id: bodyId
	                    , to: msg.from
	                });
	                self.send(deliverMessage.body);
	            }
	            isCmdMsg && this.close();       //action==em_retrieve_dns 的cmd消息用于迁集群，退出重新登录以获取config信息
	        } catch (e) {
	            this.onError({
	                type: _code.WEBIM_CONNCTION_CALLBACK_INNER_ERROR
	                , data: e
	            });
	        }
	    }
	};
	
	/**
	 * @private
	 */
	connection.prototype.handleDeliveredMessage = function (message) {
	    var id = message.id;
	    var body = message.getElementsByTagName('body');
	    var mid = 0;
	    mid = body[0].innerHTML;
	    var msg = {
	        mid: mid
	    };
	    this.onDeliverdMessage(msg);
	    this.sendReceiptsMessage({
	        id: id
	    });
	};
	
	/**
	 * @private
	 */
	connection.prototype.handleAckedMessage = function (message) {
	    var id = message.id;
	    var body = message.getElementsByTagName('body');
	    var mid = 0;
	    mid = body[0].innerHTML;
	    var msg = {
	        mid: mid
	    };
	    this.onReadMessage(msg);
	    this.sendReceiptsMessage({
	        id: id
	    });
	};
	
	/**
	 * @private
	 */
	connection.prototype.handleReceivedMessage = function (message) {
	    try {
	        var received = message.getElementsByTagName("received");
	        var mid = received[0].getAttribute('mid');
	        var body = message.getElementsByTagName("body");
	        var id = body[0].innerHTML;
	        var msg = {
	            mid: mid,
	            id: id
	        };
	        this.onReceivedMessage(msg);
	    } catch (e) {
	        this.onError({
	            type: _code.WEBIM_CONNCTION_CALLBACK_INNER_ERROR
	            , data: e
	        });
	    }
	
	    var rcv = message.getElementsByTagName('received'),
	        id,
	        mid;
	
	    if (rcv.length > 0) {
	        if (rcv[0].childNodes && rcv[0].childNodes.length > 0) {
	            id = rcv[0].childNodes[0].nodeValue;
	        } else {
	            id = rcv[0].innerHTML || rcv[0].innerText;
	        }
	        mid = rcv[0].getAttribute('mid');
	    }
	
	    if (_msgHash[id]) {
	        try {
	            _msgHash[id].msg.success instanceof Function && _msgHash[id].msg.success(id, mid);
	        } catch (e) {
	            this.onError({
	                type: _code.WEBIM_CONNCTION_CALLBACK_INNER_ERROR
	                , data: e
	            });
	        }
	        delete _msgHash[id];
	    }
	};
	
	/**
	 * @private
	 */
	connection.prototype.handleInviteMessage = function (message) {
	    var form = null;
	    var invitemsg = message.getElementsByTagName('invite');
	    var reasonDom = message.getElementsByTagName('reason')[0];
	    var reasonMsg = reasonDom.textContent;
	    var id = message.getAttribute('id') || '';
	    this.sendReceiptsMessage({
	        id: id
	    });
	
	    if (invitemsg && invitemsg.length > 0) {
	        var fromJid = invitemsg[0].getAttribute('from');
	        form = _parseNameFromJidFn(fromJid);
	    }
	    var xmsg = message.getElementsByTagName('x');
	    var roomid = null;
	    if (xmsg && xmsg.length > 0) {
	        for (var i = 0; i < xmsg.length; i++) {
	            if ('jabber:x:conference' === xmsg[i].namespaceURI) {
	                var roomjid = xmsg[i].getAttribute('jid');
	                roomid = _parseNameFromJidFn(roomjid);
	            }
	        }
	    }
	    this.onInviteMessage({
	        type: 'invite',
	        from: form,
	        roomid: roomid,
	        reason: reasonMsg
	    });
	};
	
	/**
	 * @private
	 */
	connection.prototype.handleMutedMessage = function (message) {
	    var id = message.id;
	    this.onMutedMessage({
	        mid: id
	    });
	};
	
	/**
	 * @private
	 */
	connection.prototype.sendCommand = function (dom, id) {
	    if (this.isOpened()) {
	        this.context.stropheConn.send(dom);
	    } else {
	        this.unSendMsgArr.push(dom);
	        if(!this.offLineSendConnecting && !this.logOut){
	            this.offLineSendConnecting = true;
	            this.reconnect();
	        }
	        this.onError({
	            type: _code.WEBIM_CONNCTION_DISCONNECTED,
	            reconnect: true
	        });
	    }
	};
	
	/**
	 * 随机生成一个id用于消息id
	 * @param {String} prefix - 前缀，默认为"WEBIM_"
	 */
	connection.prototype.getUniqueId = function (prefix) {
	    // fix: too frequently msg sending will make same id
	    if (this.autoIncrement) {
	        this.autoIncrement++
	    } else {
	        this.autoIncrement = 1
	    }
	    var cdate = new Date();
	    var offdate = new Date(2010, 1, 1);
	    var offset = cdate.getTime() - offdate.getTime();
	    var hexd = parseFloat(offset).toString(16) + this.autoIncrement;
	
	    if (typeof prefix === 'string' || typeof prefix === 'number') {
	        return prefix + '_' + hexd;
	    } else {
	        return 'WEBIM_' + hexd;
	    }
	};
	
	/**
	 * 发送消息
	 * @param {Object} messageSource - 由 Class Message 生成
	 * @example
	 *let deliverMessage = new WebIM.message('delivery', msgId);
	 *deliverMessage.set({
	 *  id: msgId, 
	 *  to: msg.from
	 *});
	 *conn.send(deliverMessage.body);
	 */
	
	connection.prototype.send = function (messageSource) {
	    var self = this;
	    var message = messageSource;
	    if (message.type === 'txt') {
	        if (this.encrypt.type === 'base64') {
	            message = _.clone(messageSource);
	            message.msg = btoa(message.msg);
	        } else if (this.encrypt.type === 'aes') {
	            message = _.clone(messageSource);
	            var key = CryptoJS.enc.Utf8.parse(this.encrypt.key);
	            var iv = CryptoJS.enc.Utf8.parse(this.encrypt.iv);
	            var mode = this.encrypt.mode.toLowerCase();
	            var option = {};
	            if (mode === 'cbc') {
	                option = {
	                    iv: iv,
	                    mode: CryptoJS.mode.CBC,
	                    padding: CryptoJS.pad.Pkcs7
	                };
	            } else if (mode === 'ebc') {
	                option = {
	                    mode: CryptoJS.mode.ECB,
	                    padding: CryptoJS.pad.Pkcs7
	                }
	            }
	            var encryptedData = CryptoJS.AES.encrypt(message.msg, key, option);
	
	            message.msg = encryptedData.toString();
	        }
	    }
	    if (this.isWindowSDK) {
	        WebIM.doQuery('{"type":"sendMessage","to":"' + message.to + '","message_type":"' + message.type + '","msg":"' + encodeURI(message.msg) + '","chatType":"' + message.chatType + '"}',
	            function (response) {
	            },
	            function (code, msg) {
	                var message = {
	                    data: {
	                        data: "send"
	                    },
	                    type: _code.WEBIM_MESSAGE_SED_ERROR
	                };
	                self.onError(message);
	            });
	    } else {
	        if (Object.prototype.toString.call(message) === '[object Object]') {
	            var appKey = this.context.appKey || '';
	            var toJid = appKey + '_' + message.to + '@' + this.domain;
	
	            if (message.group) {
	                toJid = appKey + '_' + message.to + '@conference.' + this.domain;
	            }
	            if (message.resource) {
	                toJid = toJid + '/' + message.resource;
	            }
	
	            message.toJid = toJid;
	            message.id = message.id || this.getUniqueId();
	            _msgHash[message.id] = new _message(message);
	            _msgHash[message.id].send(this);
	        } else if (typeof message === 'string') {
	            _msgHash[message] && _msgHash[message].send(this);
	        }
	    }
	};
	
	/**
	 * 添加联系人(已废弃)
	 * @param {Object} options
	 * @deprecated
	 */
	
	connection.prototype.addRoster = function (options) {
	    var jid = _getJid(options, this);
	    var name = options.name || '';
	    var groups = options.groups || '';
	
	    var iq = $iq({type: 'set'});
	    iq.c('query', {xmlns: 'jabber:iq:roster'});
	    iq.c('item', {jid: jid, name: name});
	
	    if (groups) {
	        for (var i = 0; i < groups.length; i++) {
	            iq.c('group').t(groups[i]).up();
	        }
	    }
	    var suc = options.success || _utils.emptyfn;
	    var error = options.error || _utils.emptyfn;
	    this.context.stropheConn.sendIQ(iq.tree(), suc, error);
	};
	
	/**
	 * 删除联系人
	 *
	 * @param {Object} options -
	 * @param {String} options.to - 联系人ID
	 * @param {String} options.resource - 用于生成jid，默认"webim"
	 * @param {Function} options.success - 成功之后的回调，在回调里调用connection.unsubscribed才能真正删除联系人
	 * @param {Function} options.error - 失败之后的回调，默认为空
	 * @example
	 * connection.removeRoster({
	 *   to: id,
	 *   success: function() {
	 *      connection.unsubscribed({
	 *          to: id
	 *      })
	 *   },
	 *   error: function() {
	 *
	 *   }
	 * })
	 * @fires connection#unsubscribed
	 */
	
	connection.prototype.removeRoster = function (options) {
	    var jid = _getJid(options, this);
	    var iq = $iq({type: 'set'}).c('query', {xmlns: 'jabber:iq:roster'}).c('item', {
	        jid: jid,
	        subscription: 'remove'
	    });
	
	    var suc = options.success || _utils.emptyfn;
	    var error = options.error || _utils.emptyfn;
	    this.context.stropheConn.sendIQ(iq, suc, error);
	};
	
	/**
	 * 获取联系人
	 * @param {Object} options - 
	 * @param {Function} options.success - 成功之后的回调，默认为空
	 * @param {Function} options.error - 失败之后的回调，默认为空
	 */
	connection.prototype.getRoster = function (options) {
	    var conn = this;
	    var dom = $iq({
	        type: 'get'
	    }).c('query', {xmlns: 'jabber:iq:roster'});
	
	    var options = options || {};
	    var suc = options.success || this.onRoster;
	    var completeFn = function (ele) {
	        var rouster = [];
	        var msgBodies = ele.getElementsByTagName('query');
	        if (msgBodies && msgBodies.length > 0) {
	            var queryTag = msgBodies[0];
	            rouster = _parseFriend(queryTag);
	        }
	        suc(rouster, ele);
	    };
	    var error = options.error || this.onError;
	    var failFn = function (ele) {
	        error({
	            type: _code.WEBIM_CONNCTION_GETROSTER_ERROR
	            , data: ele
	        });
	    };
	    if (this.isOpened()) {
	        this.context.stropheConn.sendIQ(dom.tree(), completeFn, failFn);
	    } else {
	        error({
	            type: _code.WEBIM_CONNCTION_DISCONNECTED
	        });
	    }
	};
	
	/**
	 * 订阅和反向订阅
	 * @example
	 *
	 * A订阅B（A添加B为好友）
	 * A执行：
	 *  conn.subscribe({
	        to: 'B',
	        message: 'Hello~'
	    });
	 B的监听函数onPresence参数message.type == subscribe监听到有人订阅他
	 B执行：
	 conn.subscribed({
	    to: 'A',
	    message: '[resp:true]'
	 });
	 同意A的订阅请求
	 B继续执行：
	 conn.subscribe({
	    to: 'A',
	    message: '[resp:true]'
	 });
	 反向订阅A，这样才算双方添加好友成功。
	 若B拒绝A的订阅请求，只需执行：
	 conn.unsubscribed({
	    to: 'A',
	    message: 'I don't want to be subscribed'
	 });
	 另外，在监听函数onPresence参数message.type == "subscribe"这个case中，加一句
	 if (message && message.status === '[resp:true]') {
	    return;
	 }
	 否则会进入死循环
	 *
	 * @param {Object} options - 
	 * @param {String} options.to - 想要订阅的联系人
	 * @param {String} options.nick - 想要订阅的联系人昵称 （非必须）
	 * @param {String} options.message - 发送给想要订阅的联系人的验证消息（非必须）
	 */
	connection.prototype.subscribe = function (options) {
	    var jid = _getJid(options, this);
	    var pres = $pres({to: jid, type: 'subscribe'});
	    if (options.message) {
	        pres.c('status').t(options.message).up();
	    }
	    if (options.nick) {
	        pres.c('nick', {'xmlns': 'http://jabber.org/protocol/nick'}).t(options.nick);
	    }
	    this.sendCommand(pres.tree());
	};
	
	/**
	 * 被订阅后确认同意被订阅
	 * @param {Object} options - 
	 * @param {String} options.to - 订阅人的ID
	 * @param {String} options.message  - 默认为[resp:true]，后续将去掉该参数
	 */
	connection.prototype.subscribed = function (options) {
	    var jid = _getJid(options, this);
	    var pres = $pres({to: jid, type: 'subscribed'});
	
	    if (options.message) {
	        pres.c('status').t(options.message).up();
	    }
	    this.sendCommand(pres.tree());
	};
	
	/**
	 * 取消订阅成功(已废弃)
	 * @param {Object} options
	 * @deprecated
	 */
	connection.prototype.unsubscribe = function (options) {
	    var jid = _getJid(options, this);
	    var pres = $pres({to: jid, type: 'unsubscribe'});
	
	    if (options.message) {
	        pres.c('status').t(options.message);
	    }
	    this.sendCommand(pres.tree());
	};
	
	/**
	 * 拒绝对方的订阅请求
	 * @function connection#event:unsubscribed
	 * @param {Object} options -
	 * @param {String} options.to - 订阅人的ID
	 * @param {String} options.message - 发送给拒绝订阅的联系人的验证消息（非必须）
	 */
	connection.prototype.unsubscribed = function (options) {
	    var jid = _getJid(options, this);
	    var pres = $pres({to: jid, type: 'unsubscribed'});
	
	    if (options.message) {
	        pres.c('status').t(options.message).up();
	    }
	    this.sendCommand(pres.tree());
	};
	
	/**
	 * 加入公开群组(已废弃)
	 * @param {Object} options
	 * @deprecated
	 */
	connection.prototype.joinPublicGroup = function (options) {
	    var roomJid = this.context.appKey + '_' + options.roomId + '@conference.' + this.domain;
	    var room_nick = roomJid + '/' + this.context.userId;
	    var suc = options.success || _utils.emptyfn;
	    var err = options.error || _utils.emptyfn;
	    var errorFn = function (ele) {
	        err({
	            type: _code.WEBIM_CONNCTION_JOINROOM_ERROR,
	            data: ele
	        });
	    };
	    var iq = $pres({
	        from: this.context.jid,
	        to: room_nick
	    })
	        .c('x', {xmlns: Strophe.NS.MUC});
	
	    this.context.stropheConn.sendIQ(iq.tree(), suc, errorFn);
	};
	
	/**
	 * 获取聊天室列表(已废弃)
	 * @param {Object} options
	 * @deprecated
	 */
	connection.prototype.listRooms = function (options) {
	    var iq = $iq({
	        to: options.server || 'conference.' + this.domain,
	        from: this.context.jid,
	        type: 'get'
	    })
	        .c('query', {xmlns: Strophe.NS.DISCO_ITEMS});
	
	    var suc = options.success || _utils.emptyfn;
	    var error = options.error || this.onError;
	    var completeFn = function (result) {
	        var rooms = [];
	        rooms = _parseRoom(result);
	        try {
	            suc(rooms);
	        } catch (e) {
	            error({
	                type: _code.WEBIM_CONNCTION_GETROOM_ERROR,
	                data: e
	            });
	        }
	    };
	    var err = options.error || _utils.emptyfn;
	    var errorFn = function (ele) {
	        err({
	            type: _code.WEBIM_CONNCTION_GETROOM_ERROR
	            , data: ele
	        });
	    };
	    this.context.stropheConn.sendIQ(iq.tree(), completeFn, errorFn);
	};
	
	/**
	 * 获取群组成员列表(已废弃)
	 * @param {Object} options
	 * @deprecated
	 */
	connection.prototype.queryRoomMember = function (options) {
	    var domain = this.domain;
	    var members = [];
	    var iq = $iq({
	        to: this.context.appKey + '_' + options.roomId + '@conference.' + this.domain
	        , type: 'get'
	    })
	        .c('query', {xmlns: Strophe.NS.MUC + '#admin'})
	        .c('item', {affiliation: 'member'});
	
	    var suc = options.success || _utils.emptyfn;
	    var completeFn = function (result) {
	        var items = result.getElementsByTagName('item');
	
	        if (items) {
	            for (var i = 0; i < items.length; i++) {
	                var item = items[i];
	                var mem = {
	                    jid: item.getAttribute('jid')
	                    , affiliation: 'member'
	                };
	                members.push(mem);
	            }
	        }
	        suc(members);
	    };
	    var err = options.error || _utils.emptyfn;
	    var errorFn = function (ele) {
	        err({
	            type: _code.WEBIM_CONNCTION_GETROOMMEMBER_ERROR
	            , data: ele
	        });
	    };
	    this.context.stropheConn.sendIQ(iq.tree(), completeFn, errorFn);
	};
	
	/**
	 * 获取群组信息(已废弃)
	 * @param {Object} options
	 * @deprecated
	 */
	connection.prototype.queryRoomInfo = function (options) {
	    var domain = this.domain;
	    var iq = $iq({
	        to: this.context.appKey + '_' + options.roomId + '@conference.' + domain,
	        type: 'get'
	    }).c('query', {xmlns: Strophe.NS.DISCO_INFO});
	
	    var suc = options.success || _utils.emptyfn;
	    var members = [];
	
	    var completeFn = function (result) {
	        var settings = '';
	        var features = result.getElementsByTagName('feature');
	        if (features) {
	            settings = features[1].getAttribute('var') + '|' + features[3].getAttribute('var') + '|' + features[4].getAttribute('var');
	        }
	        switch (settings) {
	            case 'muc_public|muc_membersonly|muc_notallowinvites':
	                settings = 'PUBLIC_JOIN_APPROVAL';
	                break;
	            case 'muc_public|muc_open|muc_notallowinvites':
	                settings = 'PUBLIC_JOIN_OPEN';
	                break;
	            case 'muc_hidden|muc_membersonly|muc_allowinvites':
	                settings = 'PRIVATE_MEMBER_INVITE';
	                break;
	            case 'muc_hidden|muc_membersonly|muc_notallowinvites':
	                settings = 'PRIVATE_OWNER_INVITE';
	                break;
	        }
	        var owner = '';
	        var fields = result.getElementsByTagName('field');
	        var fieldValues = {};
	        if (fields) {
	            for (var i = 0; i < fields.length; i++) {
	                var field = fields[i];
	                var fieldVar = field.getAttribute('var');
	                var fieldSimplify = fieldVar.split('_')[1];
	                switch (fieldVar) {
	                    case 'muc#roominfo_occupants':
	                    case 'muc#roominfo_maxusers':
	                    case 'muc#roominfo_affiliations':
	                    case 'muc#roominfo_description':
	                        fieldValues[fieldSimplify] = (field.textContent || field.text || '');
	                        break;
	                    case 'muc#roominfo_owner':
	                        var mem = {
	                            jid: (field.textContent || field.text) + '@' + domain
	                            , affiliation: 'owner'
	                        };
	                        members.push(mem);
	                        fieldValues[fieldSimplify] = (field.textContent || field.text);
	                        break;
	                }
	
	                // if (field.getAttribute('label') === 'owner') {
	                //     var mem = {
	                //         jid: (field.textContent || field.text) + '@' + domain
	                //         , affiliation: 'owner'
	                //     };
	                //     members.push(mem);
	                //     break;
	                // }
	            }
	            fieldValues['name'] = (result.getElementsByTagName('identity')[0]).getAttribute('name');
	        }
	        suc(settings, members, fieldValues);
	    };
	    var err = options.error || _utils.emptyfn;
	    var errorFn = function (ele) {
	        err({
	            type: _code.WEBIM_CONNCTION_GETROOMINFO_ERROR
	            , data: ele
	        });
	    };
	    this.context.stropheConn.sendIQ(iq.tree(), completeFn, errorFn);
	};
	
	/**
	 * 获取聊天室管理员(已废弃)
	 * @param {Object} options
	 * @deprecated
	 */
	connection.prototype.queryRoomOccupants = function (options) {
	    var suc = options.success || _utils.emptyfn;
	    var completeFn = function (result) {
	        var occupants = [];
	        occupants = _parseRoomOccupants(result);
	        suc(occupants);
	    }
	    var err = options.error || _utils.emptyfn;
	    var errorFn = function (ele) {
	        err({
	            type: _code.WEBIM_CONNCTION_GETROOMOCCUPANTS_ERROR
	            , data: ele
	        });
	    };
	    var attrs = {
	        xmlns: Strophe.NS.DISCO_ITEMS
	    };
	    var info = $iq({
	        from: this.context.jid
	        , to: this.context.appKey + '_' + options.roomId + '@conference.' + this.domain
	        , type: 'get'
	    }).c('query', attrs);
	    this.context.stropheConn.sendIQ(info.tree(), completeFn, errorFn);
	};
	
	/**
	 *
	 * @deprecated
	 * @private
	 */
	connection.prototype.setUserSig = function (desc) {
	    var dom = $pres({xmlns: 'jabber:client'});
	    desc = desc || '';
	    dom.c('status').t(desc);
	    this.sendCommand(dom.tree());
	};
	
	/**
	 *
	 * @private
	 */
	connection.prototype.setPresence = function (type, status) {
	    var dom = $pres({xmlns: 'jabber:client'});
	    if (type) {
	        if (status) {
	            dom.c('show').t(type);
	            dom.up().c('status').t(status);
	        } else {
	            dom.c('show').t(type);
	        }
	    }
	    this.sendCommand(dom.tree());
	};
	
	/**
	 * @private
	 *
	 */
	connection.prototype.getPresence = function () {
	    var dom = $pres({xmlns: 'jabber:client'});
	    var conn = this;
	    this.sendCommand(dom.tree());
	};
	
	/**
	 * @private
	 *
	 */
	connection.prototype.ping = function (options) {
	    var options = options || {};
	    var jid = _getJid(options, this);
	
	    var dom = $iq({
	        from: this.context.jid || ''
	        , to: jid
	        , type: 'get'
	    }).c('ping', {xmlns: 'urn:xmpp:ping'});
	
	    var suc = options.success || _utils.emptyfn;
	    var error = options.error || this.onError;
	    var failFn = function (ele) {
	        error({
	            type: _code.WEBIM_CONNCTION_PING_ERROR
	            , data: ele
	        });
	    };
	    if (this.isOpened()) {
	        this.context.stropheConn.sendIQ(dom.tree(), suc, failFn);
	    } else {
	        error({
	            type: _code.WEBIM_CONNCTION_DISCONNECTED
	        });
	    }
	    return;
	};
	
	/**
	 * @private
	 *
	 */
	connection.prototype.isOpened = function () {
	    return this.context.status == _code.STATUS_OPENED;
	};
	
	/**
	 * @private
	 *
	 */
	connection.prototype.isOpening = function () {
	    var status = this.context.status;
	    return status == _code.STATUS_DOLOGIN_USERGRID || status == _code.STATUS_DOLOGIN_IM;
	};
	
	/**
	 * @private
	 *
	 */
	connection.prototype.isClosing = function () {
	    return this.context.status == _code.STATUS_CLOSING;
	};
	
	/**
	 * @private
	 *
	 */
	connection.prototype.isClosed = function () {
	    return this.context.status == _code.STATUS_CLOSED;
	};
	
	/**
	 * @private
	 *
	 */
	connection.prototype.clear = function () {
	    var key = this.context.appKey;
	    if (this.errorType != _code.WEBIM_CONNCTION_DISCONNECTED) {
	        // this.context = {
	        //     status: _code.STATUS_INIT,
	        //     appKey: key
	        // };
	        if (this.logOut) {
	            this.unSendMsgArr = [];
	            this.offLineSendConnecting = false;
	            this.context = {
	                status: _code.STATUS_INIT,
	                appKey: key
	            };
	        }
	    }
	    if (this.intervalId) {
	        clearInterval(this.intervalId);
	    }
	    this.restIndex = 0;
	    this.xmppIndex = 0;
	
	    if (this.errorType == _code.WEBIM_CONNCTION_CLIENT_LOGOUT || this.errorType == -1) {
	        var message = {
	            data: {
	                data: "logout"
	            },
	            type: _code.WEBIM_CONNCTION_CLIENT_LOGOUT
	        };
	        this.onError(message);
	    }
	};
	
	/**
	 * 获取聊天室列表（分页）
	 * @param {Object} options -
	 * @param {String} options.apiUrl - rest的接口地址
	 * @param {Number} options.pagenum - 页码，默认1
	 * @param {Number} options.pagesize - 每页数量，默认20
	 * @param {Function} options.success - 成功之后的回调，默认为空
	 */
	connection.prototype.getChatRooms = function (options) {
	
	    if (!_utils.isCanSetRequestHeader) {
	        conn.onError({
	            type: _code.WEBIM_CONNCTION_NOT_SUPPORT_CHATROOM_ERROR
	        });
	        return;
	    }
	
	    var conn = this,
	        token = options.accessToken || this.context.accessToken;
	
	    if (token) {
	        var apiUrl = options.apiUrl;
	        var appName = this.context.appName;
	        var orgName = this.context.orgName;
	
	        if (!appName || !orgName) {
	            conn.onError({
	                type: _code.WEBIM_CONNCTION_AUTH_ERROR
	            });
	            return;
	        }
	
	        var suc = function (data, xhr) {
	            typeof options.success === 'function' && options.success(data);
	        };
	
	        var error = function (res, xhr, msg) {
	            if (res.error && res.error_description) {
	                conn.onError({
	                    type: _code.WEBIM_CONNCTION_LOAD_CHATROOM_ERROR,
	                    msg: res.error_description,
	                    data: res,
	                    xhr: xhr
	                });
	            }
	        };
	
	        var pageInfo = {
	            pagenum: parseInt(options.pagenum) || 1,
	            pagesize: parseInt(options.pagesize) || 20
	        };
	
	        var opts = {
	            url: apiUrl + '/' + orgName + '/' + appName + '/chatrooms',
	            dataType: 'json',
	            type: 'GET',
	            headers: {'Authorization': 'Bearer ' + token},
	            data: pageInfo,
	            success: suc || _utils.emptyfn,
	            error: error || _utils.emptyfn
	        };
	        _utils.ajax(opts);
	    } else {
	        conn.onError({
	            type: _code.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR
	        });
	    }
	
	};
	
	/**
	 * 加入聊天室
	 * @param {Object} options - 
	 * @param {String} options.roomId - 聊天室的ID
	 * @param {Function} options.success - 成功之后的回调，默认为空
	 * @param {Function} options.error - 失败之后的回调，默认为空
	 */
	connection.prototype.joinChatRoom = function (options) {
	    var roomJid = this.context.appKey + '_' + options.roomId + '@conference.' + this.domain;
	    var room_nick = roomJid + '/' + this.context.userId;
	    var suc = options.success || _utils.emptyfn;
	    var err = options.error || _utils.emptyfn;
	    var errorFn = function (ele) {
	        err({
	            type: _code.WEBIM_CONNCTION_JOINCHATROOM_ERROR
	            , data: ele
	        });
	    };
	
	    var iq = $pres({
	        from: this.context.jid,
	        to: room_nick
	    })
	        .c('x', {xmlns: Strophe.NS.MUC + '#user'})
	        .c('item', {affiliation: 'member', role: 'participant'})
	        .up().up()
	        .c('roomtype', {xmlns: 'easemob:x:roomtype', type: 'chatroom'});
	
	    this.context.stropheConn.sendIQ(iq.tree(), suc, errorFn);
	};
	
	/**
	 * 退出聊天室
	 * @param {Object} options -
	 * @param {String} options.roomId - 聊天室的ID
	 * @param {Function} options.success - 成功之后的回调，默认为空
	 * @param {Function} options.error - 失败之后的回调，默认为空
	 */
	connection.prototype.quitChatRoom = function (options) {
	    var roomJid = this.context.appKey + '_' + options.roomId + '@conference.' + this.domain;
	    var room_nick = roomJid + '/' + this.context.userId;
	    var suc = options.success || _utils.emptyfn;
	    var err = options.error || _utils.emptyfn;
	    var errorFn = function (ele) {
	        err({
	            type: _code.WEBIM_CONNCTION_QUITCHATROOM_ERROR
	            , data: ele
	        });
	    };
	    var iq = $pres({
	        from: this.context.jid,
	        to: room_nick,
	        type: 'unavailable'
	    })
	        .c('x', {xmlns: Strophe.NS.MUC + '#user'})
	        .c('item', {affiliation: 'none', role: 'none'})
	        .up().up()
	        .c('roomtype', {xmlns: 'easemob:x:roomtype', type: 'chatroom'});
	
	    this.context.stropheConn.sendIQ(iq.tree(), suc, errorFn);
	};
	
	/**
	 * for windowSDK
	 * @private
	 *
	 */
	connection.prototype._onReceiveInviteFromGroup = function (info) {
	    info = eval('(' + info + ')');
	    var self = this;
	    var options = {
	        title: "Group invitation",
	        msg: info.user + " invites you to join into group:" + info.group_id,
	        agree: function agree() {
	            WebIM.doQuery('{"type":"acceptInvitationFromGroup","id":"' + info.group_id + '","user":"' + info.user + '"}', function (response) {
	            }, function (code, msg) {
	                var message = {
	                    data: {
	                        data: "acceptInvitationFromGroup error:" + msg
	                    },
	                    type: _code.WEBIM_CONNECTION_ACCEPT_INVITATION_FROM_GROUP
	                };
	                self.onError(message);
	            });
	        },
	        reject: function reject() {
	            WebIM.doQuery('{"type":"declineInvitationFromGroup","id":"' + info.group_id + '","user":"' + info.user + '"}', function (response) {
	            }, function (code, msg) {
	                var message = {
	                    data: {
	                        data: "declineInvitationFromGroup error:" + msg
	                    },
	                    type: _code.WEBIM_CONNECTION_DECLINE_INVITATION_FROM_GROUP
	                };
	                self.onError(message);
	            });
	        }
	    };
	
	    this.onConfirmPop(options);
	};
	
	/**
	 * for windowSDK
	 * @private
	 *
	 */
	connection.prototype._onReceiveInviteAcceptionFromGroup = function (info) {
	    info = eval('(' + info + ')');
	    var options = {
	        title: "Group invitation response",
	        msg: info.user + " agreed to join into group:" + info.group_id,
	        agree: function agree() {
	        }
	    };
	    this.onConfirmPop(options);
	};
	
	/**
	 * for windowSDK
	 * @private
	 *
	 */
	connection.prototype._onReceiveInviteDeclineFromGroup = function (info) {
	    info = eval('(' + info + ')');
	    var options = {
	        title: "Group invitation response",
	        msg: info.user + " rejected to join into group:" + info.group_id,
	        agree: function agree() {
	        }
	    };
	    this.onConfirmPop(options);
	};
	
	/**
	 * for windowSDK
	 * @private
	 *
	 */
	connection.prototype._onAutoAcceptInvitationFromGroup = function (info) {
	    info = eval('(' + info + ')');
	    var options = {
	        title: "Group invitation",
	        msg: "You had joined into the group:" + info.group_name + " automatically.Inviter:" + info.user,
	        agree: function agree() {
	        }
	    };
	    this.onConfirmPop(options);
	};
	
	/**
	 * for windowSDK
	 * @private
	 *
	 */
	connection.prototype._onLeaveGroup = function (info) {
	    info = eval('(' + info + ')');
	    var options = {
	        title: "Group notification",
	        msg: "You have been out of the group:" + info.group_id + ".Reason:" + info.msg,
	        agree: function agree() {
	        }
	    };
	    this.onConfirmPop(options);
	};
	
	/**
	 * for windowSDK
	 * @private
	 *
	 */
	connection.prototype._onReceiveJoinGroupApplication = function (info) {
	    info = eval('(' + info + ')');
	    var self = this;
	    var options = {
	        title: "Group join application",
	        msg: info.user + " applys to join into group:" + info.group_id,
	        agree: function agree() {
	            WebIM.doQuery('{"type":"acceptJoinGroupApplication","id":"' + info.group_id + '","user":"' + info.user + '"}', function (response) {
	            }, function (code, msg) {
	                var message = {
	                    data: {
	                        data: "acceptJoinGroupApplication error:" + msg
	                    },
	                    type: _code.WEBIM_CONNECTION_ACCEPT_JOIN_GROUP
	                };
	                self.onError(message);
	            });
	        },
	        reject: function reject() {
	            WebIM.doQuery('{"type":"declineJoinGroupApplication","id":"' + info.group_id + '","user":"' + info.user + '"}', function (response) {
	            }, function (code, msg) {
	                var message = {
	                    data: {
	                        data: "declineJoinGroupApplication error:" + msg
	                    },
	                    type: _code.WEBIM_CONNECTION_DECLINE_JOIN_GROUP
	                };
	                self.onError(message);
	            });
	        }
	    };
	    this.onConfirmPop(options);
	};
	
	/**
	 * for windowSDK
	 * @private
	 *
	 */
	connection.prototype._onReceiveAcceptionFromGroup = function (info) {
	    info = eval('(' + info + ')');
	    var options = {
	        title: "Group notification",
	        msg: "You had joined into the group:" + info.group_name + ".",
	        agree: function agree() {
	        }
	    };
	    this.onConfirmPop(options);
	};
	
	/**
	 * for windowSDK
	 * @private
	 *
	 */
	connection.prototype._onReceiveRejectionFromGroup = function () {
	    info = eval('(' + info + ')');
	    var options = {
	        title: "Group notification",
	        msg: "You have been rejected to join into the group:" + info.group_name + ".",
	        agree: function agree() {
	        }
	    };
	    this.onConfirmPop(options);
	};
	
	/**
	 * for windowSDK
	 * @private
	 *
	 */
	connection.prototype._onUpdateMyGroupList = function (options) {
	    this.onUpdateMyGroupList(options);
	};
	
	/**
	 * for windowSDK
	 * @private
	 *
	 */
	connection.prototype._onUpdateMyRoster = function (options) {
	    this.onUpdateMyRoster(options);
	};
	
	/**
	 * @private
	 *
	 */
	connection.prototype.reconnect = function (v) {
	    var that = this;
	    v && that.xmppIndex++;       //重连时改变ip地址
	    setTimeout(function () {
	        _login(that.context.restTokenData, that);
	    }, (this.autoReconnectNumTotal == 0 ? 0 : this.autoReconnectInterval) * 1000);
	    this.autoReconnectNumTotal++;
	};
	
	/**
	 *
	 * @private
	 * @deprecated
	 */
	connection.prototype.closed = function () {
	    var message = {
	        data: {
	            data: "Closed error"
	        },
	        type: _code.WEBIM_CONNECTION_CLOSED
	    };
	    this.onError(message);
	};
	
	connection.prototype.textContentError = function(error){
	    return error
	}
	
	/**
	 * used for blacklist
	 * @private
	 *
	 */
	function _parsePrivacy(iq) {
	    var list = {};
	    var items = iq.getElementsByTagName('item');
	
	    if (items) {
	        for (var i = 0; i < items.length; i++) {
	            var item = items[i];
	            var jid = item.getAttribute('value');
	            var order = item.getAttribute('order');
	            var type = item.getAttribute('type');
	            if (!jid) {
	                continue;
	            }
	            var n = _parseNameFromJidFn(jid);
	            list[n] = {
	                type: type,
	                order: order,
	                jid: jid,
	                name: n
	            };
	        }
	    }
	    return list;
	};
	
	/**
	 * 获取好友黑名单
	 * @param {Object} options - 
	 * @param {Function} options.success - 成功之后的回调，默认为空
	 * @param {Function} options.error - 失败之后的回调，默认为空
	 */
	connection.prototype.getBlacklist = function (options) {
	    options = (options || {});
	    var iq = $iq({type: 'get'});
	    var sucFn = options.success || _utils.emptyfn;
	    var errFn = options.error || _utils.emptyfn;
	    var me = this;
	
	    iq.c('query', {xmlns: 'jabber:iq:privacy'})
	        .c('list', {name: 'special'});
	
	    this.context.stropheConn.sendIQ(iq.tree(), function (iq) {
	        me.onBlacklistUpdate(_parsePrivacy(iq));
	        sucFn();
	    }, function () {
	        me.onBlacklistUpdate([]);
	        errFn();
	    });
	};
	
	/**
	 * 将好友加入到黑名单
	 * @param {Object} options -
	 * @param {Object[]} options.list - json数组，调用这个函数后黑名单的所有名单列表（已经存在的黑名单加上这次新加黑名单），json的key值为好友的ID，value为之前获取的整个好友对象即可
	 * @param {Object} options.type - 要加到黑名单的好友对象的type，默认是"jid"
	 * @param {Number} options.list[].order - 要加到黑名单的好友对象的order，所有order不重复,可不填
	 * @param {string} options.list[].jid - 要加到黑名单的好友的jid
	 * @param {string} options.list[].name - 要加到黑名单的好友的ID
	 * @param {Function} options.success - 成功之后的回调，默认为空
	 * @param {Function} options.error - 失败之后的回调，默认为空
	 */
	connection.prototype.addToBlackList = function (options) {
	    var iq = $iq({type: 'set'});
	    var blacklist = options.list || {};
	    var type = options.type || 'jid';
	    var sucFn = options.success || _utils.emptyfn;
	    var errFn = options.error || _utils.emptyfn;
	    var piece = iq.c('query', {xmlns: 'jabber:iq:privacy'})
	        .c('list', {name: 'special'});
	
	    var keys = Object.keys(blacklist);
	    var len = keys.length;
	    var order = 2;
	
	    for (var i = 0; i < len; i++) {
	        var item = blacklist[keys[i]];
	        var type = item.type || 'jid';
	        var jid = item.jid;
	
	        piece = piece.c('item', {action: 'deny', order: order++, type: type, value: jid})
	            .c('message');
	        if (i !== len - 1) {
	            piece = piece.up().up();
	        }
	    }
	
	    // console.log('addToBlackList', blacklist, piece.tree());
	    this.context.stropheConn.sendIQ(piece.tree(), sucFn, errFn);
	};
	
	/**
	 * 将好友从黑名单移除
	 * @param {Object} options -
	 * @param {Object[]} options.list - json数组，调用这个函数后黑名单的所有名单列表，json的key值为好友的ID，value为之前获取的整个好友对象即可
	 * @param {Object} options.type - 要加到黑名单的好友对象的type，默认是"jid"
	 * @param {Number} options.list[].order - 要加到黑名单的好友对象的order，所有order不重复
	 * @param {string} options.list[].jid - 要加到黑名单的好友的jid
	 * @param {string} options.list[].name - 要加到黑名单的好友的ID
	 * @param {Function} options.success - 成功之后的回调，默认为空
	 * @param {Function} options.error - 失败之后的回调，默认为空
	 */
	connection.prototype.removeFromBlackList = function (options) {
	
	    var iq = $iq({type: 'set'});
	    var blacklist = options.list || {};
	    var sucFn = options.success || _utils.emptyfn;
	    var errFn = options.error || _utils.emptyfn;
	    var piece = iq.c('query', {xmlns: 'jabber:iq:privacy'})
	        .c('list', {name: 'special'});
	
	    var keys = Object.keys(blacklist);
	    var len = keys.length;
	
	    for (var i = 0; i < len; i++) {
	        var item = blacklist[keys[i]];
	        var type = item.type || 'jid';
	        var jid = item.jid;
	        var order = item.order;
	
	        piece = piece.c('item', {action: 'deny', order: order, type: type, value: jid})
	            .c('message');
	        if (i !== len - 1) {
	            piece = piece.up().up();
	        }
	    }
	
	    // console.log('removeFromBlackList', blacklist, piece.tree());
	    this.context.stropheConn.sendIQ(piece.tree(), sucFn, errFn);
	};
	
	/**
	 *
	 * @private
	 */
	connection.prototype._getGroupJid = function (to) {
	    var appKey = this.context.appKey || '';
	    return appKey + '_' + to + '@conference.' + this.domain;
	};
	
	/**
	 * 加入群组黑名单(已废弃)
	 * @param {Object} options
	 * @deprecated
	 */
	connection.prototype.addToGroupBlackList = function (options) {
	    var sucFn = options.success || _utils.emptyfn;
	    var errFn = options.error || _utils.emptyfn;
	    var jid = _getJid(options, this);
	    var affiliation = 'admin';//options.affiliation || 'admin';
	    var to = this._getGroupJid(options.roomId);
	    var iq = $iq({type: 'set', to: to});
	
	    iq.c('query', {xmlns: 'http://jabber.org/protocol/muc#' + affiliation})
	        .c('item', {
	            affiliation: 'outcast',
	            jid: jid
	        });
	
	    this.context.stropheConn.sendIQ(iq.tree(), sucFn, errFn);
	};
	
	/**
	 *
	 * @private
	 */
	function _parseGroupBlacklist(iq) {
	    var list = {};
	    var items = iq.getElementsByTagName('item');
	
	    if (items) {
	        for (var i = 0; i < items.length; i++) {
	            var item = items[i];
	            var jid = item.getAttribute('jid');
	            var affiliation = item.getAttribute('affiliation');
	            var nick = item.getAttribute('nick');
	            if (!jid) {
	                continue;
	            }
	            var n = _parseNameFromJidFn(jid);
	            list[n] = {
	                jid: jid,
	                affiliation: affiliation,
	                nick: nick,
	                name: n
	            };
	        }
	    }
	    return list;
	}
	
	/**
	 * 获取群组黑名单(已废弃)
	 * @param {Object} options
	 * @deprecated
	 */
	connection.prototype.getGroupBlacklist = function (options) {
	    var sucFn = options.success || _utils.emptyfn;
	    var errFn = options.error || _utils.emptyfn;
	
	    // var jid = _getJid(options, this);
	    var affiliation = 'admin';//options.affiliation || 'admin';
	    var to = this._getGroupJid(options.roomId);
	    var iq = $iq({type: 'get', to: to});
	
	    iq.c('query', {xmlns: 'http://jabber.org/protocol/muc#' + affiliation})
	        .c('item', {
	            affiliation: 'outcast',
	        });
	
	    this.context.stropheConn.sendIQ(iq.tree(), function (msginfo) {
	        sucFn(_parseGroupBlacklist(msginfo));
	    }, function () {
	        errFn();
	    });
	};
	
	/**
	 * 从群组黑名单删除(已废弃)
	 * @param {Object} options
	 * @deprecated
	 */
	connection.prototype.removeGroupMemberFromBlacklist = function (options) {
	    var sucFn = options.success || _utils.emptyfn;
	    var errFn = options.error || _utils.emptyfn;
	
	    var jid = _getJid(options, this);
	    var affiliation = 'admin';//options.affiliation || 'admin';
	    var to = this._getGroupJid(options.roomId);
	    var iq = $iq({type: 'set', to: to});
	
	    iq.c('query', {xmlns: 'http://jabber.org/protocol/muc#' + affiliation})
	        .c('item', {
	            affiliation: 'none',
	            jid: jid
	        });
	
	    this.context.stropheConn.sendIQ(iq.tree(), function (msginfo) {
	        sucFn();
	    }, function () {
	        errFn();
	    });
	};
	
	/**
	 * 修改群名称(已废弃)
	 *
	 * @param options
	 * @deprecated
	 */
	// <iq to='easemob-demo#chatdemoui_roomid@conference.easemob.com' type='set' id='3940489311' xmlns='jabber:client'>
	//     <query xmlns='http://jabber.org/protocol/muc#owner'>
	//         <x type='submit' xmlns='jabber:x:data'>
	//             <field var='FORM_TYPE'><value>http://jabber.org/protocol/muc#roomconfig</value></field>
	//             <field var='muc#roomconfig_roomname'><value>Room Name</value></field>
	//         </x>
	//     </query>
	// </iq>
	
	connection.prototype.changeGroupSubject = function (options) {
	    var sucFn = options.success || _utils.emptyfn;
	    var errFn = options.error || _utils.emptyfn;
	
	    // must be `owner`
	    var affiliation = 'owner';
	    var to = this._getGroupJid(options.roomId);
	    var iq = $iq({type: 'set', to: to});
	
	    iq.c('query', {xmlns: 'http://jabber.org/protocol/muc#' + affiliation})
	        .c('x', {type: 'submit', xmlns: 'jabber:x:data'})
	        .c('field', {'var': 'FORM_TYPE'})
	        .c('value')
	        .t('http://jabber.org/protocol/muc#roomconfig')
	        .up().up()
	        .c('field', {'var': 'muc#roomconfig_roomname'})
	        .c('value')
	        .t(options.subject)
	        .up().up()
	        .c('field', {'var': 'muc#roomconfig_roomdesc'})
	        .c('value')
	        .t(options.description);
	
	
	    this.context.stropheConn.sendIQ(iq.tree(), function (msginfo) {
	        sucFn();
	    }, function () {
	        errFn();
	    });
	};
	
	/**
	 * 删除群组(已废弃)
	 *
	 * @param {Object} options -
	 * @example
	 <iq id="9BEF5D20-841A-4048-B33A-F3F871120E58" to="easemob-demo#chatdemoui_1477462231499@conference.easemob.com" type="set">
	 <query xmlns="http://jabber.org/protocol/muc#owner">
	 <destroy>
	 <reason>xxx destory group yyy</reason>
	 </destroy>
	 </query>
	 </iq>
	 * @deprecated
	 */
	connection.prototype.destroyGroup = function (options) {
	    var sucFn = options.success || _utils.emptyfn;
	    var errFn = options.error || _utils.emptyfn;
	
	    // must be `owner`
	    var affiliation = 'owner';
	    var to = this._getGroupJid(options.roomId);
	    var iq = $iq({type: 'set', to: to});
	
	    iq.c('query', {xmlns: 'http://jabber.org/protocol/muc#' + affiliation})
	        .c('destroy')
	        .c('reason').t(options.reason || '');
	
	    this.context.stropheConn.sendIQ(iq.tree(), function (msginfo) {
	        sucFn();
	    }, function () {
	        errFn();
	    });
	};
	
	/**
	 * 主动离开群组(已废弃)
	 *
	 * @param {Object} options -
	 * @example
	 <iq id="5CD33172-7B62-41B7-98BC-CE6EF840C4F6_easemob_occupants_change_affiliation" to="easemob-demo#chatdemoui_1477481609392@conference.easemob.com" type="set">
	 <query xmlns="http://jabber.org/protocol/muc#admin">
	 <item affiliation="none" jid="easemob-demo#chatdemoui_lwz2@easemob.com"/>
	 </query>
	 </iq>
	 <presence to="easemob-demo#chatdemoui_1479811172349@conference.easemob.com/mt002" type="unavailable"/>
	 * @deprecated
	 */
	connection.prototype.leaveGroupBySelf = function (options) {
	    var self = this;
	    var sucFn = options.success || _utils.emptyfn;
	    var errFn = options.error || _utils.emptyfn;
	
	    // must be `owner`
	    var jid = _getJid(options, this);
	    var affiliation = 'admin';
	    var to = this._getGroupJid(options.roomId);
	    var iq = $iq({type: 'set', to: to});
	
	    iq.c('query', {xmlns: 'http://jabber.org/protocol/muc#' + affiliation})
	        .c('item', {
	            affiliation: 'none',
	            jid: jid
	        });
	
	    this.context.stropheConn.sendIQ(iq.tree(), function (msgInfo) {
	        sucFn(msgInfo);
	        var pres = $pres({type: 'unavailable', to: to + '/' + self.context.userId});
	        self.sendCommand(pres.tree());
	    }, function (errInfo) {
	        errFn(errInfo);
	    });
	};
	
	/**
	 * 群主从群组中踢人(已废弃)
	 *
	 * @param {Object} options -
	 * @param {string[]} options.list - 需要从群组移除的好友ID组成的数组
	 * @param {string} options.roomId - 群组ID
	 * @deprecated
	 * @example
	 <iq id="9fb25cf4-1183-43c9-961e-9df70e300de4:sendIQ" to="easemob-demo#chatdemoui_1477481597120@conference.easemob.com" type="set" xmlns="jabber:client">
	 <query xmlns="http://jabber.org/protocol/muc#admin">
	 <item affiliation="none" jid="easemob-demo#chatdemoui_lwz4@easemob.com"/>
	 <item jid="easemob-demo#chatdemoui_lwz4@easemob.com" role="none"/>
	 <item affiliation="none" jid="easemob-demo#chatdemoui_lwz2@easemob.com"/>
	 <item jid="easemob-demo#chatdemoui_lwz2@easemob.com" role="none"/>
	 </query>
	 </iq>
	 */
	connection.prototype.leaveGroup = function (options) {
	    var sucFn = options.success || _utils.emptyfn;
	    var errFn = options.error || _utils.emptyfn;
	    var list = options.list || [];
	    var affiliation = 'admin';
	    var to = this._getGroupJid(options.roomId);
	    var iq = $iq({type: 'set', to: to});
	    var piece = iq.c('query', {xmlns: 'http://jabber.org/protocol/muc#' + affiliation});
	    var keys = Object.keys(list);
	    var len = keys.length;
	
	    for (var i = 0; i < len; i++) {
	        var name = list[keys[i]];
	        var jid = _getJidByName(name, this);
	
	        piece = piece.c('item', {
	            affiliation: 'none',
	            jid: jid
	        }).up().c('item', {
	            role: 'none',
	            jid: jid,
	        }).up();
	    }
	
	    this.context.stropheConn.sendIQ(iq.tree(), function (msgInfo) {
	        sucFn(msgInfo);
	    }, function (errInfo) {
	        errFn(errInfo);
	    });
	};
	
	/**
	 * 添加群组成员(已废弃)
	 *
	 * @param {Object} options -
	 * @param {Object} options.list - 字符串数组，成员列表。[id1,id2,id3]
	 * @param {Object} options.roomId - 群组id
	 * @param {Function} options.success - 成功回调
	 * @param {Function} options.error - 失败回调
	 * @deprecated
	 * @example
	 Attention the sequence: message first (每个成员单独发一条message), iq second (多个成员可以合成一条iq发)
	 <!-- 添加成员通知：send -->
	 <message to='easemob-demo#chatdemoui_1477482739698@conference.easemob.com'>
	 <x xmlns='http://jabber.org/protocol/muc#user'>
	 <invite to='easemob-demo#chatdemoui_lwz2@easemob.com'>
	 <reason>liuwz invite you to join group '谢谢'</reason>
	 </invite>
	 </x>
	 </message>
	 <!-- 添加成员：send -->
	 <iq id='09DFB1E5-C939-4C43-B5A7-8000DA0E3B73_easemob_occupants_change_affiliation' to='easemob-demo#chatdemoui_1477482739698@conference.easemob.com' type='set'>
	 <query xmlns='http://jabber.org/protocol/muc#admin'>
	 <item affiliation='member' jid='easemob-demo#chatdemoui_lwz2@easemob.com'/>
	 </query>
	 </iq>
	 */
	connection.prototype.addGroupMembers = function (options) {
	    var sucFn = options.success || _utils.emptyfn;
	    var errFn = options.error || _utils.emptyfn;
	    var list = options.list || [];
	    var affiliation = 'admin';
	    var to = this._getGroupJid(options.roomId);
	    var iq = $iq({type: 'set', to: to});
	    var piece = iq.c('query', {xmlns: 'http://jabber.org/protocol/muc#' + affiliation});
	    var len = list.length;
	
	    for (var i = 0; i < len; i++) {
	
	        var name = list[i];
	        var jid = _getJidByName(name, this);
	
	        piece = piece.c('item', {
	            affiliation: 'member',
	            jid: jid
	        }).up();
	
	        var dom = $msg({
	            to: to
	        }).c('x', {
	            xmlns: 'http://jabber.org/protocol/muc#user'
	        }).c('invite', {
	            to: jid
	        }).c('reason').t(options.reason || '');
	
	        this.sendCommand(dom.tree());
	
	    }
	
	    this.context.stropheConn.sendIQ(iq.tree(), function (msgInfo) {
	        sucFn(msgInfo);
	    }, function (errInfo) {
	        errFn(errInfo);
	    });
	};
	
	/**
	 * 接受加入申请(已废弃)
	 *
	 * @param {Object} options - 
	 * @param {Array} options.list - 列表，默认[]
	 * @param {String} options.roomId - 聊天室id
	 * @param {String} options.reason - 原因
	 * @param {Function} options.success - 成功之后的回调，默认为空
	 * @param {Function} options.error - 失败之后的回调，默认为空
	 * @deprecated
	 */
	connection.prototype.acceptInviteFromGroup = function (options) {
	    options.success = function () {
	        // then send sendAcceptInviteMessage
	        // connection.prototype.sendAcceptInviteMessage(optoins);
	    };
	    this.addGroupMembers(options);
	};
	
	/**
	 * 拒绝入群申请(已废弃)
	 * @param {Object} options -
	 * @example
	 throw request for now 暂时不处理，直接丢弃
	
	 <message to='easemob-demo#chatdemoui_mt002@easemob.com' from='easmeob-demo#chatdemoui_mt001@easemob.com' id='B83B7210-BCFF-4DEE-AB28-B9FE5579C1E2'>
	 <x xmlns='http://jabber.org/protocol/muc#user'>
	 <apply to='easemob-demo#chatdemoui_groupid1@conference.easemob.com' from='easmeob-demo#chatdemoui_mt001@easemob.com' toNick='llllll'>
	 <reason>reject</reason>
	 </apply>
	 </x>
	 </message>
	 * @deprecated
	 */
	connection.prototype.rejectInviteFromGroup = function (options) {
	    // var from = _getJidByName(options.from, this);
	    // var dom = $msg({
	    //     from: from,
	    //     to: _getJidByName(options.to, this)
	    // }).c('x', {
	    //     xmlns: 'http://jabber.org/protocol/muc#user'
	    // }).c('apply', {
	    //     from: from,
	    //     to: this._getGroupJid(options.groupId),
	    //     toNick: options.groupName
	    // }).c('reason').t(options.reason || '');
	    //
	    // this.sendCommand(dom.tree());
	};
	
	/**
	 * 创建群组-异步(已废弃)
	 * @param {Object} p -
	 * @deprecated
	 */
	connection.prototype.createGroupAsync = function (p) {
	    var roomId = p.from
	    var me = this;
	    var toRoom = this._getGroupJid(roomId);
	    var to = toRoom + '/' + this.context.userId;
	    var options = this.groupOption;
	    var suc = p.success || _utils.emptyfn;
	
	    // Creating a Reserved Room
	    var iq = $iq({type: 'get', to: toRoom})
	        .c('query', {xmlns: 'http://jabber.org/protocol/muc#owner'});
	
	    // Strophe.info('step 1 ----------');
	    // Strophe.info(options);
	    me.context.stropheConn.sendIQ(iq.tree(), function (msgInfo) {
	        // console.log(msgInfo);
	
	        // for ie hack
	        if ('setAttribute' in msgInfo) {
	            // Strophe.info('step 3 ----------');
	            var x = msgInfo.getElementsByTagName('x')[0];
	            x.setAttribute('type', 'submit');
	        } else {
	            // Strophe.info('step 4 ----------');
	            Strophe.forEachChild(msgInfo, 'x', function (field) {
	                field.setAttribute('type', 'submit');
	            });
	        }
	
	        Strophe.info('step 5 ----------');
	        Strophe.forEachChild(x, 'field', function (field) {
	            var fieldVar = field.getAttribute('var');
	            var valueDom = field.getElementsByTagName('value')[0];
	            Strophe.info(fieldVar);
	            switch (fieldVar) {
	                case 'muc#roomconfig_maxusers':
	                    _setText(valueDom, options.optionsMaxUsers || 200);
	                    break;
	                case 'muc#roomconfig_roomname':
	                    _setText(valueDom, options.subject || '');
	                    break;
	                case 'muc#roomconfig_roomdesc':
	                    _setText(valueDom, options.description || '');
	                    break;
	                case 'muc#roomconfig_publicroom': // public 1
	                    _setText(valueDom, +options.optionsPublic);
	                    break;
	                case 'muc#roomconfig_membersonly':
	                    _setText(valueDom, +options.optionsMembersOnly);
	                    break;
	                case 'muc#roomconfig_moderatedroom':
	                    _setText(valueDom, +options.optionsModerate);
	                    break;
	                case 'muc#roomconfig_persistentroom':
	                    _setText(valueDom, 1);
	                    break;
	                case 'muc#roomconfig_allowinvites':
	                    _setText(valueDom, +options.optionsAllowInvites);
	                    break;
	                case 'muc#roomconfig_allowvisitornickchange':
	                    _setText(valueDom, 0);
	                    break;
	                case 'muc#roomconfig_allowvisitorstatus':
	                    _setText(valueDom, 0);
	                    break;
	                case 'allow_private_messages':
	                    _setText(valueDom, 0);
	                    break;
	                case 'allow_private_messages_from_visitors':
	                    _setText(valueDom, 'nobody');
	                    break;
	                default:
	                    break;
	            }
	        });
	
	        var iq = $iq({to: toRoom, type: 'set'})
	            .c('query', {xmlns: 'http://jabber.org/protocol/muc#owner'})
	            .cnode(x);
	
	        me.context.stropheConn.sendIQ(iq.tree(), function (msgInfo) {
	            me.addGroupMembers({
	                list: options.members,
	                roomId: roomId
	            });
	
	            suc(options);
	        }, function (errInfo) {
	            // errFn(errInfo);
	        });
	        // sucFn(msgInfo);
	    }, function (errInfo) {
	        // errFn(errInfo);
	    });
	};
	
	/**
	 * 创建群组(已废弃)
	 * @param {Object} options -
	 * @deprecated
	 * @example
	 * 1. 创建申请 -> 得到房主身份
	 * 2. 获取房主信息 -> 得到房间form
	 * 3. 完善房间form -> 创建成功
	 * 4. 添加房间成员
	 * 5. 消息通知成员
	 */
	connection.prototype.createGroup = function (options) {
	    this.groupOption = options;
	    var roomId = +new Date();
	    var toRoom = this._getGroupJid(roomId);
	    var to = toRoom + '/' + this.context.userId;
	
	    var pres = $pres({to: to})
	        .c('x', {xmlns: 'http://jabber.org/protocol/muc'}).up()
	        .c('create', {xmlns: 'http://jabber.org/protocol/muc'}).up();
	
	    // createGroupACK
	    this.sendCommand(pres.tree());
	};
	/**
	 * 通过RestFul API接口创建群组
	 * @param opt {Object} - 
	 * @param opt.data {Object} - 群组信息
	 * @param opt.data.groupname {string} - 群组名
	 * @param opt.data.desc {string} - 群组描述
	 * @param opt.data.members {string[]} - 好友id数组，群好友列表
	 * @param opt.data.public {Boolean} - true: 公开群，false: 私有群
	 * @param opt.data.approval {Boolean} - 前提：opt.data.public=true, true: 加群需要审批，false: 加群无需审批
	 * @param opt.data.allowinvites {Boolean} - 前提：opt.data.public=false, true: 允许成员邀请入群，false: 不允许成员邀请入群
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 * @since 1.4.11
	 */
	connection.prototype.createGroupNew = function (opt) {
	    opt.data.owner = this.user;
	    opt.data.invite_need_confirm = false;
	    var options = {
	        url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/chatgroups',
	        dataType: 'json',
	        type: 'POST',
	        data: JSON.stringify(opt.data),
	        headers: {
	            'Authorization': 'Bearer ' + this.token,
	            'Content-Type': 'application/json'
	        }
	    };
	    options.success = function (respData) {
	        opt.success(respData);
	        this.onCreateGroup(respData);
	    }.bind(this);
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API屏蔽群组，只对移动端有效
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 需要屏蔽的群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 * @since 1.4.11
	 */
	connection.prototype.blockGroup = function (opt) {
	    var groupId = opt.groupId;
	    groupId = 'notification_ignore_' + groupId;
	    var data = {
	        entities: []
	    };
	    data.entities[0] = {};
	    data.entities[0][groupId] = true;
	    var options = {
	        type: 'PUT',
	        url: this.apiUrl + '/' + this.orgName + '/'
	        + this.appName + '/' + 'users' + '/' + this.user,
	        data: JSON.stringify(data),
	        headers: {
	            'Authorization': 'Bearer ' + this.token,
	            'Content-Type': 'application/json'
	        }
	    };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	/**
	 * 通过RestFul API发出入群申请
	 * @param {Object} opt -
	 * @param {String} opt.groupId - 加入群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 * @since 1.4.11
	 */
	connection.prototype.joinGroup = function (opt) {
	    var options = {
	        url: this.apiUrl + '/' + this.orgName + '/'
	        + this.appName + '/' + 'chatgroups' + '/' + opt.groupId + '/' + 'apply',
	        type: 'POST',
	        dataType: 'json',
	        data: JSON.stringify({ message: 'join group' }),    // 后端参数变更，申请入群需要填写入群消息
	        headers: {
	            'Authorization': 'Bearer ' + this.token,
	            'Content-Type': 'application/json'
	        }
	    };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	/**
	 * 通过RestFul API分页获取群组列表
	 * @param {Object} opt -
	 * @param {Number} opt.limit - 每一页群组的最大数目
	 * @param {string} opt.cursor=null - 游标，如果数据还有下一页，API 返回值会包含此字段，传递此字段可获取下一页的数据，为null时获取第一页数据
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 * @since 1.4.11
	 */
	connection.prototype.listGroups = function (opt) {
	    var requestData = [];
	    requestData['limit'] = opt.limit;
	    requestData['cursor'] = opt.cursor;
	    if (!requestData['cursor'])
	        delete requestData['cursor'];
	    if (isNaN(opt.limit)) {
	        throw 'The parameter \"limit\" should be a number';
	        return;
	    }
	    var options = {
	        url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/publicchatgroups',
	        type: 'GET',
	        dataType: 'json',
	        data: requestData,
	        headers: {
	            'Authorization': 'Bearer ' + this.token,
	            'Content-Type': 'application/json'
	        }
	    };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API根据groupId获取群组详情
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 * @since 1.4.11
	 */
	connection.prototype.getGroupInfo = function (opt) {
	    var options = {
	        url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/chatgroups/' + opt.groupId,
	        type: 'GET',
	        dataType: 'json',
	        headers: {
	            'Authorization': 'Bearer ' + this.token,
	            'Content-Type': 'application/json'
	        }
	    };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API列出某用户所加入的所有群组
	 * @param {Object} opt - 
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 * @since 1.4.11
	 */
	connection.prototype.getGroup = function (opt) {
	    var options = {
	        url: this.apiUrl + '/' + this.orgName +
	        '/' + this.appName + '/' + 'users' + '/' +
	        this.user + '/' + 'joined_chatgroups',
	        dataType: 'json',
	        type: 'GET',
	        headers: {
	            'Authorization': 'Bearer ' + this.token,
	            'Content-Type': 'application/json'
	        }
	    };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API分页列出群组的所有成员
	 * @param {Object} opt -
	 * @param {Number} opt.pageNum - 页码，默认1
	 * @param {Number} opt.pageSize - 每一页的最大群成员数目,最大值1000
	 * @param {string} opt.groupId - 群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.listGroupMember = function (opt) {
	    if (isNaN(opt.pageNum) || opt.pageNum <= 0) {
	        throw 'The parameter \"pageNum\" should be a positive number';
	        return;
	    } else if (isNaN(opt.pageSize) || opt.pageSize <= 0) {
	        throw 'The parameter \"pageSize\" should be a positive number';
	        return;
	    } else if (opt.groupId === null && typeof opt.groupId === 'undefined') {
	        throw 'The parameter \"groupId\" should be added';
	        return;
	    }
	    var requestData = [],
	        groupId = opt.groupId;
	    requestData['pagenum'] = opt.pageNum;
	    requestData['pagesize'] = opt.pageSize;
	    var options = {
	        url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/chatgroups'
	        + '/' + groupId + '/users',
	        dataType: 'json',
	        type: 'GET',
	        data: requestData,
	        headers: {
	            'Authorization': 'Bearer ' + this.token,
	            'Content-Type': 'application/json'
	        }
	    };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API禁止群用户发言
	 * @param {Object} opt -
	 * @param {string} opt.username - 被禁言的群成员的ID
	 * @param {Number} opt.muteDuration - 被禁言的时长，单位ms
	 * @param {string} opt.groupId - 群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 * @since 1.4.11
	 */
	connection.prototype.mute = function (opt) {
	    var groupId = opt.groupId,
	        requestData = {
	            "usernames": [opt.username],
	            "mute_duration": opt.muteDuration
	        },
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups'
	            + '/' + groupId + '/' + 'mute',
	            dataType: 'json',
	            type: 'POST',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            },
	            data: JSON.stringify(requestData)
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API取消对用户禁言
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {string} opt.username - 被取消禁言的群用户ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 * @since 1.4.11
	 */
	connection.prototype.removeMute = function (opt) {
	    var groupId = opt.groupId,
	        username = opt.username;
	    var options = {
	        url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups'
	        + '/' + groupId + '/' + 'mute' + '/' + username,
	        dataType: 'json',
	        type: 'DELETE',
	        headers: {
	            'Authorization': 'Bearer ' + this.token,
	            'Content-Type': 'application/json'
	        }
	    };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API获取群组下所有管理员
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 * @since 1.4.11
	 */
	connection.prototype.getGroupAdmin = function (opt) {
	    var groupId = opt.groupId;
	    var options = {
	        url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/chatgroups'
	        + '/' + groupId + '/admin',
	        dataType: 'json',
	        type: 'GET',
	        headers: {
	            'Authorization': 'Bearer ' + this.token,
	            'Content-Type': 'application/json'
	        }
	    };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API获取群组下所有被禁言成员
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.getMuted = function (opt) {
	    var groupId = opt.groupId;
	    var options = {
	        url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/chatgroups'
	        + '/' + groupId + '/mute',
	        dataType: 'json',
	        type: 'GET',
	        headers: {
	            'Authorization': 'Bearer ' + this.token,
	            'Content-Type': 'application/json'
	        }
	    };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API设置群管理员
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {string} opt.username - 用户ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.setAdmin = function (opt) {
	    var groupId = opt.groupId,
	        requestData = {
	            newadmin: opt.username
	        },
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups'
	            + '/' + groupId + '/' + 'admin',
	            type: "POST",
	            dataType: 'json',
	            data: JSON.stringify(requestData),
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API取消群管理员
	 * @param {Object} opt -
	 * @param {string} opt.gorupId - 群组ID
	 * @param {string} opt.username - 用户ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.removeAdmin = function (opt) {
	    var groupId = opt.groupId,
	        username = opt.username,
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups'
	            + '/' + groupId + '/' + 'admin' + '/' + username,
	            type: 'DELETE',
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API同意用户加入群
	 * @param {Object} opt -
	 * @param {string} opt.applicant - 申请加群的用户ID
	 * @param {Object} opt.groupId - 群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.agreeJoinGroup = function (opt) {
	    var groupId = opt.groupId,
	        requestData = {
	            "applicant": opt.applicant,
	            "verifyResult": true,
	            "reason": "no clue"
	        },
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '/' + 'apply_verify',
	            type: 'POST',
	            dataType: "json",
	            data: JSON.stringify(requestData),
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API拒绝用户加入群
	 * @param {Object} opt -
	 * @param {string} opt.applicant - 申请加群的用户ID
	 * @param {Object} opt.groupId - 群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.rejectJoinGroup = function (opt) {
	    var groupId = opt.groupId,
	        requestData = {
	            "applicant": opt.applicant,
	            "verifyResult": false,
	            "reason": "no clue"
	        },
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '/' + 'apply_verify',
	            type: 'POST',
	            dataType: "json",
	            data: JSON.stringify(requestData),
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API添加用户至群组黑名单(单个)
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {stirng} opt.username - 用户ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.groupBlockSingle = function (opt) {
	    var groupId = opt.groupId,
	        username = opt.username,
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '/' + 'blocks' + '/'
	            + 'users' + '/' + username,
	            type: 'POST',
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API添加用户至群组黑名单(批量)
	 * @param {Object} opt -
	 * @param {string[]} opt.username - 用户ID数组
	 * @param {string} opt.groupId - 群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.groupBlockMulti = function (opt) {
	    var groupId = opt.groupId,
	        usernames = opt.usernames,
	        requestData = {
	            usernames: usernames
	        },
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '/' + 'blocks' + '/'
	            + 'users',
	            data: JSON.stringify(requestData),
	            type: 'POST',
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API将用户从群黑名单移除（单个）
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {string} opt.username - 用户ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.removeGroupBlockSingle = function (opt) {
	    var groupId = opt.groupId,
	        username = opt.username,
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '/' + 'blocks' + '/'
	            + 'users' + '/' + username,
	            type: 'DELETE',
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API将用户从群黑名单移除（批量）
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {string[]} opt.username - 用户ID数组
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.removeGroupBlockMulti = function (opt) {
	    var groupId = opt.groupId,
	        username = opt.username.join(','),
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '/' + 'blocks' + '/'
	            + 'users' + '/' + username,
	            type: 'DELETE',
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API解散群组
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.dissolveGroup = function (opt) {
	    var groupId = opt.groupId,
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '?version=v3',
	            type: 'DELETE',
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API获取群组黑名单
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.getGroupBlacklistNew = function (opt) {
	    var groupId = opt.groupId,
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '/' + 'blocks' + '/' + 'users',
	            type: 'GET',
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API离开群组
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.quitGroup = function (opt) {
	    var groupId = opt.groupId,
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '/' + 'quit',
	            type: 'DELETE',
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API修改群信息
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {string} opt.groupName - 群组名
	 * @param {string} opt.description - 群组简介
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.modifyGroup = function (opt) {
	    var groupId = opt.groupId,
	        requestData = {
	            groupname: opt.groupName,
	            description: opt.description
	        },
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId,
	            type: 'PUT',
	            data: JSON.stringify(requestData),
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API删除单个群成员
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {string} opt.username - 用户ID
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.removeSingleGroupMember = function (opt) {
	    var groupId = opt.groupId,
	        username = opt.username,
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '/' + 'users' + '/'
	            + username,
	            type: 'DELETE',
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API删除多个群成员
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组ID
	 * @param {string[]} opt.users - 用户ID数组
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.removeMultiGroupMember = function (opt) {
	    var groupId = opt.groupId,
	        users = opt.users.join(','),
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '/' + 'users' + '/'
	            + users,
	            type: 'DELETE',
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	/**
	 * 通过RestFul API邀请群成员
	 * @param {Object} opt -
	 * @param {string} opt.groupId - 群组名
	 * @param {string[]} opt.users - 用户ID数组
	 * @param {Function} opt.success - 成功之后的回调，默认为空
	 * @param {Function} opt.error - 失败之后的回调，默认为空
	 */
	connection.prototype.inviteToGroup = function (opt) {
	    var groupId = opt.groupId,
	        users = opt.users,
	        requestData = {
	            usernames: users
	        },
	        options = {
	            url: this.apiUrl + '/' + this.orgName + '/' + this.appName
	            + '/' + 'chatgroups' + '/' + groupId + '/' + 'invite',
	            type: 'POST',
	            data: JSON.stringify(requestData),
	            dataType: 'json',
	            headers: {
	                'Authorization': 'Bearer ' + this.token,
	                'Content-Type': 'application/json'
	            }
	        };
	    options.success = opt.success || _utils.emptyfn;
	    options.error = opt.error || _utils.emptyfn;
	    WebIM.utils.ajax(options);
	};
	
	function _setText(valueDom, v) {
	    if ('textContent' in valueDom) {
	        valueDom.textContent = v;
	    } else if ('text' in valueDom) {
	        valueDom.text = v;
	    } else {
	        // Strophe.info('_setText 4 ----------');
	        // valueDom.innerHTML = v;
	    }
	}
	
	
	var WebIM = window.WebIM || {};
	WebIM.connection = connection;
	WebIM.utils = _utils;
	WebIM.statusCode = _code;
	WebIM.message = _msg.message;
	WebIM.doQuery = function (str, suc, fail) {
	    if (typeof window.cefQuery === 'undefined') {
	        return;
	    }
	    window.cefQuery({
	            request: str,
	            persistent: false,
	            onSuccess: suc,
	            onFailure: fail
	        }
	    );
	};
	
	/**************************** debug ****************************/
	WebIM.debug = function (bool) {
	
	    logMessage = function (message) {
	        bool && console.log(WebIM.utils.ts() + '[recv] ', message.data);
	    }
	
	    Strophe.Connection.prototype.rawOutput = function (data) {
	        bool && console.log('%c ' + WebIM.utils.ts() + '[send] ' + data, "background-color: #e2f7da");
	    }
	
	}
	
	module.exports = WebIM;
	
	if (false) {
	    module.hot.accept();
	}


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	;
	(function () {
	    //管理各种错误信息
	    exports.code = {
	        WEBIM_CONNCTION_USER_NOT_ASSIGN_ERROR: 0,
	        WEBIM_CONNCTION_OPEN_ERROR: 1,
	        WEBIM_CONNCTION_AUTH_ERROR: 2,
	        WEBIM_CONNCTION_OPEN_USERGRID_ERROR: 3,
	        WEBIM_CONNCTION_ATTACH_ERROR: 4,
	        WEBIM_CONNCTION_ATTACH_USERGRID_ERROR: 5,
	        WEBIM_CONNCTION_REOPEN_ERROR: 6,
	        WEBIM_CONNCTION_SERVER_CLOSE_ERROR: 7,  //7: client-side network offline (net::ERR_INTERNET_DISCONNECTED)
	        WEBIM_CONNCTION_SERVER_ERROR: 8,        //8: offline by multi login
	        WEBIM_CONNCTION_IQ_ERROR: 9,
	
	        WEBIM_CONNCTION_PING_ERROR: 10,
	        WEBIM_CONNCTION_NOTIFYVERSION_ERROR: 11,
	        WEBIM_CONNCTION_GETROSTER_ERROR: 12,
	        WEBIM_CONNCTION_CROSSDOMAIN_ERROR: 13,
	        WEBIM_CONNCTION_LISTENING_OUTOF_MAXRETRIES: 14,
	        WEBIM_CONNCTION_RECEIVEMSG_CONTENTERROR: 15,
	        WEBIM_CONNCTION_DISCONNECTED: 16,    //16: server-side close the websocket connection
	        WEBIM_CONNCTION_AJAX_ERROR: 17,
	        WEBIM_CONNCTION_JOINROOM_ERROR: 18,
	        WEBIM_CONNCTION_GETROOM_ERROR: 19,
	
	        WEBIM_CONNCTION_GETROOMINFO_ERROR: 20,
	        WEBIM_CONNCTION_GETROOMMEMBER_ERROR: 21,
	        WEBIM_CONNCTION_GETROOMOCCUPANTS_ERROR: 22,
	        WEBIM_CONNCTION_LOAD_CHATROOM_ERROR: 23,
	        WEBIM_CONNCTION_NOT_SUPPORT_CHATROOM_ERROR: 24,
	        WEBIM_CONNCTION_JOINCHATROOM_ERROR: 25,
	        WEBIM_CONNCTION_QUITCHATROOM_ERROR: 26,
	        WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR: 27,
	        WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR: 28,
	        WEBIM_CONNCTION_SESSIONID_NOT_ASSIGN_ERROR: 29,
	
	        WEBIM_CONNCTION_RID_NOT_ASSIGN_ERROR: 30,
	        WEBIM_CONNCTION_CALLBACK_INNER_ERROR: 31,  //31: 处理下行消息出错 try/catch抛出异常
	        WEBIM_CONNCTION_CLIENT_OFFLINE: 32,        //32: client offline
	        WEBIM_CONNCTION_CLIENT_LOGOUT: 33,        //33: client logout
	        WEBIM_CONNCTION_CLIENT_TOO_MUCH_ERROR: 34, // 34: Over amount of the tabs a user opened in the same browser
	        WEBIM_CONNECTION_ACCEPT_INVITATION_FROM_GROUP: 35,
	        WEBIM_CONNECTION_DECLINE_INVITATION_FROM_GROUP: 36,
	        WEBIM_CONNECTION_ACCEPT_JOIN_GROUP: 37,
	        WEBIM_CONNECTION_DECLINE_JOIN_GROUP: 38,
	        WEBIM_CONNECTION_CLOSED: 39,
	
	
	        WEBIM_UPLOADFILE_BROWSER_ERROR: 100,
	        WEBIM_UPLOADFILE_ERROR: 101,
	        WEBIM_UPLOADFILE_NO_LOGIN: 102,
	        WEBIM_UPLOADFILE_NO_FILE: 103,
	
	
	        WEBIM_DOWNLOADFILE_ERROR: 200,
	        WEBIM_DOWNLOADFILE_NO_LOGIN: 201,
	        WEBIM_DOWNLOADFILE_BROWSER_ERROR: 202,
	
	
	        WEBIM_MESSAGE_REC_TEXT: 300,
	        WEBIM_MESSAGE_REC_TEXT_ERROR: 301,
	        WEBIM_MESSAGE_REC_EMOTION: 302,
	        WEBIM_MESSAGE_REC_PHOTO: 303,
	        WEBIM_MESSAGE_REC_AUDIO: 304,
	        WEBIM_MESSAGE_REC_AUDIO_FILE: 305,
	        WEBIM_MESSAGE_REC_VEDIO: 306,
	        WEBIM_MESSAGE_REC_VEDIO_FILE: 307,
	        WEBIM_MESSAGE_REC_FILE: 308,
	        WEBIM_MESSAGE_SED_TEXT: 309,
	        WEBIM_MESSAGE_SED_EMOTION: 310,
	        WEBIM_MESSAGE_SED_PHOTO: 311,
	        WEBIM_MESSAGE_SED_AUDIO: 312,
	        WEBIM_MESSAGE_SED_AUDIO_FILE: 313,
	        WEBIM_MESSAGE_SED_VEDIO: 314,
	        WEBIM_MESSAGE_SED_VEDIO_FILE: 315,
	        WEBIM_MESSAGE_SED_FILE: 316,
	        WEBIM_MESSAGE_SED_ERROR: 317,
	
	
	        STATUS_INIT: 400,
	        STATUS_DOLOGIN_USERGRID: 401,
	        STATUS_DOLOGIN_IM: 402,
	        STATUS_OPENED: 403,
	        STATUS_CLOSING: 404,
	        STATUS_CLOSED: 405,
	        STATUS_ERROR: 406
	    };
	}());


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	;
	(function () {
	
	    var EMPTYFN = function () {
	    };
	    var _code = __webpack_require__(138).code;
	    var WEBIM_FILESIZE_LIMIT = 20971520;
	
	    var _createStandardXHR = function () {
	        try {
	            return new window.XMLHttpRequest();
	        } catch (e) {
	            return false;
	        }
	    };
	
	    var _createActiveXHR = function () {
	        try {
	            return new window.ActiveXObject('Microsoft.XMLHTTP');
	        } catch (e) {
	            return false;
	        }
	    };
	
	    var _xmlrequest = function (crossDomain) {
	        crossDomain = crossDomain || true;
	        var temp = _createStandardXHR() || _createActiveXHR();
	
	        if ('withCredentials' in temp) {
	            return temp;
	        }
	        if (!crossDomain) {
	            return temp;
	        }
	        if (typeof window.XDomainRequest === 'undefined') {
	            return temp;
	        }
	        var xhr = new XDomainRequest();
	        xhr.readyState = 0;
	        xhr.status = 100;
	        xhr.onreadystatechange = EMPTYFN;
	        xhr.onload = function () {
	            xhr.readyState = 4;
	            xhr.status = 200;
	
	            var xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
	            xmlDoc.async = 'false';
	            xmlDoc.loadXML(xhr.responseText);
	            xhr.responseXML = xmlDoc;
	            xhr.response = xhr.responseText;
	            xhr.onreadystatechange();
	        };
	        xhr.ontimeout = xhr.onerror = function () {
	            xhr.readyState = 4;
	            xhr.status = 500;
	            xhr.onreadystatechange();
	        };
	        return xhr;
	    };
	
	    var _hasFlash = (function () {
	        if ('ActiveXObject' in window) {
	            try {
	                return new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	            } catch (ex) {
	                return 0;
	            }
	        } else {
	            if (navigator.plugins && navigator.plugins.length > 0) {
	                return navigator.plugins['Shockwave Flash'];
	            }
	        }
	        return 0;
	    }());
	
	    var _tmpUtilXHR = _xmlrequest(),
	        _hasFormData = typeof FormData !== 'undefined',
	        _hasBlob = typeof Blob !== 'undefined',
	        _isCanSetRequestHeader = _tmpUtilXHR.setRequestHeader || false,
	        _hasOverrideMimeType = _tmpUtilXHR.overrideMimeType || false,
	        _isCanUploadFileAsync = _isCanSetRequestHeader && _hasFormData,
	        _isCanUploadFile = _isCanUploadFileAsync || _hasFlash,
	        _isCanDownLoadFile = _isCanSetRequestHeader && (_hasBlob || _hasOverrideMimeType);
	
	    if (!Object.keys) {
	        Object.keys = (function () {
	            'use strict';
	            var hasOwnProperty = Object.prototype.hasOwnProperty,
	                hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
	                dontEnums = [
	                    'toString',
	                    'toLocaleString',
	                    'valueOf',
	                    'hasOwnProperty',
	                    'isPrototypeOf',
	                    'propertyIsEnumerable',
	                    'constructor'
	                ],
	                dontEnumsLength = dontEnums.length;
	
	            return function (obj) {
	                if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
	                    throw new TypeError('Object.keys called on non-object');
	                }
	
	                var result = [], prop, i;
	
	                for (prop in obj) {
	                    if (hasOwnProperty.call(obj, prop)) {
	                        result.push(prop);
	                    }
	                }
	
	                if (hasDontEnumBug) {
	                    for (i = 0; i < dontEnumsLength; i++) {
	                        if (hasOwnProperty.call(obj, dontEnums[i])) {
	                            result.push(dontEnums[i]);
	                        }
	                    }
	                }
	                return result;
	            };
	        }());
	    }
	
	    var utils = {
	        hasFormData: _hasFormData,
	
	        hasBlob: _hasBlob,
	
	        emptyfn: EMPTYFN,
	
	        isCanSetRequestHeader: _isCanSetRequestHeader,
	
	        hasOverrideMimeType: _hasOverrideMimeType,
	
	        isCanUploadFileAsync: _isCanUploadFileAsync,
	
	        isCanUploadFile: _isCanUploadFile,
	
	        isCanDownLoadFile: _isCanDownLoadFile,
	
	        isSupportWss: (function () {
	            var notSupportList = [
	                //1: QQ browser X5 core
	                /MQQBrowser[\/]5([.]\d+)?\sTBS/
	
	                //2: etc.
	                //...
	            ];
	
	            if (!window.WebSocket) {
	                return false;
	            }
	
	            var ua = window.navigator.userAgent;
	            for (var i = 0, l = notSupportList.length; i < l; i++) {
	                if (notSupportList[i].test(ua)) {
	                    return false;
	                }
	            }
	            return true;
	        }()),
	
	        getIEVersion: (function () {
	            var ua = navigator.userAgent, matches, tridentMap = {'4': 8, '5': 9, '6': 10, '7': 11};
	
	            matches = ua.match(/MSIE (\d+)/i);
	
	            if (matches && matches[1]) {
	                return +matches[1];
	            }
	            matches = ua.match(/Trident\/(\d+)/i);
	            if (matches && matches[1]) {
	                return tridentMap[matches[1]] || null;
	            }
	            return null;
	        }()),
	
	
	        stringify: function (json) {
	            if (typeof JSON !== 'undefined' && JSON.stringify) {
	                return JSON.stringify(json);
	            } else {
	                var s = '',
	                    arr = [];
	
	                var iterate = function (json) {
	                    var isArr = false;
	
	                    if (Object.prototype.toString.call(json) === '[object Array]') {
	                        arr.push(']', '[');
	                        isArr = true;
	                    } else if (Object.prototype.toString.call(json) === '[object Object]') {
	                        arr.push('}', '{');
	                    }
	
	                    for (var o in json) {
	                        if (Object.prototype.toString.call(json[o]) === '[object Null]') {
	                            json[o] = 'null';
	                        } else if (Object.prototype.toString.call(json[o]) === '[object Undefined]') {
	                            json[o] = 'undefined';
	                        }
	
	                        if (json[o] && typeof json[o] === 'object') {
	                            s += ',' + (isArr ? '' : '"' + o + '":' + (isArr ? '"' : '')) + iterate(json[o]) + '';
	                        } else {
	                            s += ',"' + (isArr ? '' : o + '":"') + json[o] + '"';
	                        }
	                    }
	
	                    if (s != '') {
	                        s = s.slice(1);
	                    }
	
	                    return arr.pop() + s + arr.pop();
	                };
	                return iterate(json);
	            }
	        },
	        login: function (options) {
	            var options = options || {};
	            var suc = options.success || EMPTYFN;
	            var err = options.error || EMPTYFN;
	
	            var appKey = options.appKey || '';
	            var devInfos = appKey.split('#');
	            if (devInfos.length !== 2) {
	                err({
	                    type: _code.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR
	                });
	                return false;
	            }
	
	            var orgName = devInfos[0];
	            var appName = devInfos[1];
	            var https = https || options.https;
	            var user = options.user || '';
	            var pwd = options.pwd || '';
	
	            var apiUrl = options.apiUrl;
	
	            var loginJson = {
	                grant_type: 'password',
	                username: user,
	                password: pwd,
	                timestamp: +new Date()
	            };
	            var loginfo = utils.stringify(loginJson);
	
	            var options = {
	                url: apiUrl + '/' + orgName + '/' + appName + '/token',
	                dataType: 'json',
	                data: loginfo,
	                success: suc,
	                error: err
	            };
	            return utils.ajax(options);
	        },
	
	        getFileUrl: function (fileInputId) {
	            var uri = {
	                url: '',
	                filename: '',
	                filetype: '',
	                data: ''
	            };
	
	            var fileObj = typeof fileInputId === 'string' ? document.getElementById(fileInputId) : fileInputId;
	
	            if (!utils.isCanUploadFileAsync || !fileObj) {
	                return uri;
	            }
	            try {
	                if (window.URL.createObjectURL) {
	                    var fileItems = fileObj.files;
	                    if (fileItems.length > 0) {
	                        var u = fileItems.item(0);
	                        uri.data = u;
	                        uri.url = window.URL.createObjectURL(u);
	                        uri.filename = u.name || '';
	                    }
	                } else { // IE
	                    var u = document.getElementById(fileInputId).value;
	                    uri.url = u;
	                    var pos1 = u.lastIndexOf('/');
	                    var pos2 = u.lastIndexOf('\\');
	                    var pos = Math.max(pos1, pos2);
	                    if (pos < 0)
	                        uri.filename = u;
	                    else
	                        uri.filename = u.substring(pos + 1);
	                }
	                var index = uri.filename.lastIndexOf('.');
	                if (index != -1) {
	                    uri.filetype = uri.filename.substring(index + 1).toLowerCase();
	                }
	                return uri;
	
	            } catch (e) {
	                throw e;
	            }
	        },
	
	        getFileSize: function (file) {
	            var fileSize = this.getFileLength(file);
	            if (fileSize > 10000000) {
	                return false;
	            }
	            var kb = Math.round(fileSize / 1000);
	            if (kb < 1000) {
	                fileSize = kb + ' KB';
	            } else if (kb >= 1000) {
	                var mb = kb / 1000;
	                if (mb < 1000) {
	                    fileSize = mb.toFixed(1) + ' MB';
	                } else {
	                    var gb = mb / 1000;
	                    fileSize = gb.toFixed(1) + ' GB';
	                }
	            }
	            return fileSize;
	        },
	
	        getFileLength: function (file) {
	            var fileLength = 0;
	            if (file) {
	                if (file.files) {
	                    if (file.files.length > 0) {
	                        fileLength = file.files[0].size;
	                    }
	                } else if (file.select && 'ActiveXObject' in window) {
	                    file.select();
	                    var fileobject = new ActiveXObject('Scripting.FileSystemObject');
	                    var file = fileobject.GetFile(file.value);
	                    fileLength = file.Size;
	                }
	            }
	            return fileLength;
	        },
	
	        hasFlash: _hasFlash,
	
	        trim: function (str) {
	
	            str = typeof str === 'string' ? str : '';
	
	            return str.trim
	                ? str.trim()
	                : str.replace(/^\s|\s$/g, '');
	        },
	
	        parseEmoji: function (msg) {
	            if (typeof WebIM.Emoji === 'undefined' || typeof WebIM.Emoji.map === 'undefined') {
	                return msg;
	            } else {
	                var emoji = WebIM.Emoji,
	                    reg = null;
	
	                for (var face in emoji.map) {
	                    if (emoji.map.hasOwnProperty(face)) {
	                        while (msg.indexOf(face) > -1) {
	                            msg = msg.replace(face, '<img class="emoji" src="' + emoji.path + emoji.map[face] + '" />');
	                        }
	                    }
	                }
	                return msg;
	            }
	        },
	
	        parseLink: function (msg) {
	
	            var reg = /(https?\:\/\/|www\.)([a-zA-Z0-9-]+(\.[a-zA-Z0-9]+)+)(\:[0-9]{2,4})?\/?((\.[:_0-9a-zA-Z-]+)|[:_0-9a-zA-Z-]*\/?)*\??[:_#@*&%0-9a-zA-Z-/=]*/gm;
	
	            msg = msg.replace(reg, function (v) {
	
	                var prefix = /^https?/gm.test(v);
	
	                return "<a href='"
	                    + (prefix ? v : '//' + v)
	                    + "' target='_blank'>"
	                    + v
	                    + "</a>";
	
	            });
	
	            return msg;
	
	        },
	
	        parseJSON: function (data) {
	
	            if (window.JSON && window.JSON.parse) {
	                return window.JSON.parse(data + '');
	            }
	
	            var requireNonComma,
	                depth = null,
	                str = utils.trim(data + '');
	
	            return str && !utils.trim(
	                str.replace(/(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g
	                    , function (token, comma, open, close) {
	
	                        if (requireNonComma && comma) {
	                            depth = 0;
	                        }
	
	                        if (depth === 0) {
	                            return token;
	                        }
	
	                        requireNonComma = open || comma;
	                        depth += !close - !open;
	                        return '';
	                    })
	            )
	                ? (Function('return ' + str))()
	                : (Function('Invalid JSON: ' + data))();
	        },
	
	        parseUploadResponse: function (response) {
	            return response.indexOf('callback') > -1 ? //lte ie9
	                response.slice(9, -1) : response;
	        },
	
	        parseDownloadResponse: function (response) {
	            return ((response && response.type && response.type === 'application/json')
	            || 0 > Object.prototype.toString.call(response).indexOf('Blob'))
	                ? this.url + '?token=' : window.URL.createObjectURL(response);
	        },
	
	        uploadFile: function (options) {
	            var options = options || {};
	            options.onFileUploadProgress = options.onFileUploadProgress || EMPTYFN;
	            options.onFileUploadComplete = options.onFileUploadComplete || EMPTYFN;
	            options.onFileUploadError = options.onFileUploadError || EMPTYFN;
	            options.onFileUploadCanceled = options.onFileUploadCanceled || EMPTYFN;
	
	            var acc = options.accessToken || this.context.accessToken;
	            if (!acc) {
	                options.onFileUploadError({
	                    type: _code.WEBIM_UPLOADFILE_NO_LOGIN
	                    , id: options.id
	                });
	                return;
	            }
	
	            var orgName, appName, devInfos;
	            var appKey = options.appKey || this.context.appKey || '';
	
	            if (appKey) {
	                devInfos = appKey.split('#');
	                orgName = devInfos[0];
	                appName = devInfos[1];
	            }
	
	            if (!orgName && !appName) {
	                options.onFileUploadError({
	                    type: _code.WEBIM_UPLOADFILE_ERROR
	                    , id: options.id
	                });
	                return;
	            }
	
	            var apiUrl = options.apiUrl;
	            var uploadUrl = apiUrl + '/' + orgName + '/' + appName + '/chatfiles';
	
	            if (!utils.isCanUploadFileAsync) {
	                if (utils.hasFlash && typeof options.flashUpload === 'function') {
	                    options.flashUpload && options.flashUpload(uploadUrl, options);
	                } else {
	                    options.onFileUploadError({
	                        type: _code.WEBIM_UPLOADFILE_BROWSER_ERROR
	                        , id: options.id
	                    });
	                }
	                return;
	            }
	
	            var fileSize = options.file.data ? options.file.data.size : undefined;
	            if (fileSize > WEBIM_FILESIZE_LIMIT) {
	                options.onFileUploadError({
	                    type: _code.WEBIM_UPLOADFILE_ERROR
	                    , id: options.id
	                });
	                return;
	            } else if (fileSize <= 0) {
	                options.onFileUploadError({
	                    type: _code.WEBIM_UPLOADFILE_ERROR
	                    , id: options.id
	                });
	                return;
	            }
	
	            var xhr = utils.xmlrequest();
	            var onError = function (e) {
	                options.onFileUploadError({
	                    type: _code.WEBIM_UPLOADFILE_ERROR,
	                    id: options.id,
	                    xhr: xhr
	                });
	            };
	            if (xhr.upload) {
	                xhr.upload.addEventListener('progress', options.onFileUploadProgress, false);
	            }
	            if (xhr.addEventListener) {
	                xhr.addEventListener('abort', options.onFileUploadCanceled, false);
	                xhr.addEventListener('load', function (e) {
	                    try {
	                        var json = utils.parseJSON(xhr.responseText);
	                        try {
	                            options.onFileUploadComplete(json);
	                        } catch (e) {
	                            options.onFileUploadError({
	                                type: _code.WEBIM_CONNCTION_CALLBACK_INNER_ERROR
	                                , data: e
	                            });
	                        }
	                    } catch (e) {
	                        options.onFileUploadError({
	                            type: _code.WEBIM_UPLOADFILE_ERROR,
	                            data: xhr.responseText,
	                            id: options.id,
	                            xhr: xhr
	                        });
	                    }
	                }, false);
	                xhr.addEventListener('error', onError, false);
	            } else if (xhr.onreadystatechange) {
	                xhr.onreadystatechange = function () {
	                    if (xhr.readyState === 4) {
	                        if (ajax.status === 200) {
	                            try {
	                                var json = utils.parseJSON(xhr.responseText);
	                                options.onFileUploadComplete(json);
	                            } catch (e) {
	                                options.onFileUploadError({
	                                    type: _code.WEBIM_UPLOADFILE_ERROR,
	                                    data: xhr.responseText,
	                                    id: options.id,
	                                    xhr: xhr
	                                });
	                            }
	                        } else {
	                            options.onFileUploadError({
	                                type: _code.WEBIM_UPLOADFILE_ERROR,
	                                data: xhr.responseText,
	                                id: options.id,
	                                xhr: xhr
	                            });
	                        }
	                    } else {
	                        xhr.abort();
	                        options.onFileUploadCanceled();
	                    }
	                }
	            }
	
	            xhr.open('POST', uploadUrl);
	
	            xhr.setRequestHeader('restrict-access', 'true');
	            xhr.setRequestHeader('Accept', '*/*');// Android QQ browser has some problem with this attribute.
	            xhr.setRequestHeader('Authorization', 'Bearer ' + acc);
	
	            var formData = new FormData();
	            formData.append('file', options.file.data);
	            // fix: ie8 status error
	            window.XDomainRequest && (xhr.readyState = 2)
	            xhr.send(formData);
	        },
	
	
	        download: function (options) {
	            options.onFileDownloadComplete = options.onFileDownloadComplete || EMPTYFN;
	            options.onFileDownloadError = options.onFileDownloadError || EMPTYFN;
	
	            var accessToken = options.accessToken || this.context.accessToken;
	            if (!accessToken) {
	                options.onFileDownloadError({
	                    type: _code.WEBIM_DOWNLOADFILE_NO_LOGIN,
	                    id: options.id
	                });
	                return;
	            }
	
	            var onError = function (e) {
	                options.onFileDownloadError({
	                    type: _code.WEBIM_DOWNLOADFILE_ERROR,
	                    id: options.id,
	                    xhr: xhr
	                });
	            };
	
	            if (!utils.isCanDownLoadFile) {
	                options.onFileDownloadComplete();
	                return;
	            }
	            var xhr = utils.xmlrequest();
	            if ('addEventListener' in xhr) {
	                xhr.addEventListener('load', function (e) {
	                    options.onFileDownloadComplete(xhr.response, xhr);
	                }, false);
	                xhr.addEventListener('error', onError, false);
	            } else if ('onreadystatechange' in xhr) {
	                xhr.onreadystatechange = function () {
	                    if (xhr.readyState === 4) {
	                        if (ajax.status === 200) {
	                            options.onFileDownloadComplete(xhr.response, xhr);
	                        } else {
	                            options.onFileDownloadError({
	                                type: _code.WEBIM_DOWNLOADFILE_ERROR,
	                                id: options.id,
	                                xhr: xhr
	                            });
	                        }
	                    } else {
	                        xhr.abort();
	                        options.onFileDownloadError({
	                            type: _code.WEBIM_DOWNLOADFILE_ERROR,
	                            id: options.id,
	                            xhr: xhr
	                        });
	                    }
	                }
	            }
	
	            var method = options.method || 'GET';
	            var resType = options.responseType || 'blob';
	            var mimeType = options.mimeType || 'text/plain; charset=x-user-defined';
	            xhr.open(method, options.url);
	            if (typeof Blob !== 'undefined') {
	                xhr.responseType = resType;
	            } else {
	                xhr.overrideMimeType(mimeType);
	            }
	
	            var innerHeaer = {
	                'X-Requested-With': 'XMLHttpRequest',
	                'Accept': 'application/octet-stream',
	                'share-secret': options.secret,
	                'Authorization': 'Bearer ' + accessToken
	            };
	            var headers = options.headers || {};
	            for (var key in headers) {
	                innerHeaer[key] = headers[key];
	            }
	            for (var key in innerHeaer) {
	                if (innerHeaer[key]) {
	                    xhr.setRequestHeader(key, innerHeaer[key]);
	                }
	            }
	            // fix: ie8 status error
	            window.XDomainRequest && (xhr.readyState = 2)
	            xhr.send(null);
	        },
	
	        parseTextMessage: function (message, faces) {
	            if (typeof message !== 'string') {
	                return;
	            }
	
	            if (Object.prototype.toString.call(faces) !== '[object Object]') {
	                return {
	                    isemoji: false,
	                    body: [
	                        {
	                            type: 'txt',
	                            data: message
	                        }
	                    ]
	                };
	            }
	
	            var receiveMsg = message;
	            var emessage = [];
	            var expr = /\[[^[\]]{2,3}\]/mg;
	            var emoji = receiveMsg.match(expr);
	
	            if (!emoji || emoji.length < 1) {
	                return {
	                    isemoji: false,
	                    body: [
	                        {
	                            type: 'txt',
	                            data: message
	                        }
	                    ]
	                };
	            }
	            var isemoji = false;
	            for (var i = 0; i < emoji.length; i++) {
	                var tmsg = receiveMsg.substring(0, receiveMsg.indexOf(emoji[i])),
	                    existEmoji = WebIM.Emoji.map[emoji[i]];
	
	                if (tmsg) {
	                    emessage.push({
	                        type: 'txt',
	                        data: tmsg
	                    });
	                }
	                if (!existEmoji) {
	                    emessage.push({
	                        type: 'txt',
	                        data: emoji[i]
	                    });
	                    continue;
	                }
	                var emojiStr = WebIM.Emoji.map ? WebIM.Emoji.path + existEmoji : null;
	
	                if (emojiStr) {
	                    isemoji = true;
	                    emessage.push({
	                        type: 'emoji',
	                        data: emojiStr
	                    });
	                } else {
	                    emessage.push({
	                        type: 'txt',
	                        data: emoji[i]
	                    });
	                }
	                var restMsgIndex = receiveMsg.indexOf(emoji[i]) + emoji[i].length;
	                receiveMsg = receiveMsg.substring(restMsgIndex);
	            }
	            if (receiveMsg) {
	                emessage.push({
	                    type: 'txt',
	                    data: receiveMsg
	                });
	            }
	            if (isemoji) {
	                return {
	                    isemoji: isemoji,
	                    body: emessage
	                };
	            }
	            return {
	                isemoji: false,
	                body: [
	                    {
	                        type: 'txt',
	                        data: message
	                    }
	                ]
	            };
	        },
	
	        parseUri: function () {
	            var pattern = /([^\?|&])\w+=([^&]+)/g;
	            var uri = {};
	            if (window.location.search) {
	                var args = window.location.search.match(pattern);
	                for (var i in args) {
	                    var str = args[i];
	                    var eq = str.indexOf('=');
	                    var key = str.substr(0, eq);
	                    var value = str.substr(eq + 1);
	                    uri[key] = value;
	                }
	            }
	            return uri;
	        },
	
	        parseHrefHash: function () {
	            var pattern = /([^\#|&])\w+=([^&]+)/g;
	            var uri = {};
	            if (window.location.hash) {
	                var args = window.location.hash.match(pattern);
	                for (var i in args) {
	                    var str = args[i];
	                    var eq = str.indexOf('=');
	                    var key = str.substr(0, eq);
	                    var value = str.substr(eq + 1);
	                    uri[key] = value;
	                }
	            }
	            return uri;
	        },
	
	        xmlrequest: _xmlrequest,
	
	
	        getXmlFirstChild: function (data, tagName) {
	            var children = data.getElementsByTagName(tagName);
	            if (children.length == 0) {
	                return null;
	            } else {
	                return children[0];
	            }
	        },
	        ajax: function (options) {
	            var dataType = options.dataType || 'text';
	            var suc = options.success || EMPTYFN;
	            var error = options.error || EMPTYFN;
	            var xhr = utils.xmlrequest();
	
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    var status = xhr.status || 0;
	                    if (status === 200) {
	                        try {
	                            switch (dataType) {
	                                case 'text':
	                                    suc(xhr.responseText);
	                                    return;
	                                case 'json':
	                                    var json = utils.parseJSON(xhr.responseText);
	                                    suc(json, xhr);
	                                    return;
	                                case 'xml':
	                                    if (xhr.responseXML && xhr.responseXML.documentElement) {
	                                        suc(xhr.responseXML.documentElement, xhr);
	                                    } else {
	                                        error({
	                                            type: _code.WEBIM_CONNCTION_AJAX_ERROR,
	                                            data: xhr.responseText
	                                        });
	                                    }
	                                    return;
	                            }
	                            suc(xhr.response || xhr.responseText, xhr);
	                        } catch (e) {
	                            error({
	                                type: _code.WEBIM_CONNCTION_AJAX_ERROR,
	                                data: e
	                            });
	                        }
	                        return;
	                    } else {
	                        error({
	                            type: _code.WEBIM_CONNCTION_AJAX_ERROR,
	                            data: xhr.responseText
	                        });
	                        return;
	                    }
	                }
	                if (xhr.readyState === 0) {
	                    error({
	                        type: _code.WEBIM_CONNCTION_AJAX_ERROR,
	                        data: xhr.responseText
	                    });
	                }
	            };
	
	            if (options.responseType) {
	                if (xhr.responseType) {
	                    xhr.responseType = options.responseType;
	                }
	            }
	            if (options.mimeType) {
	                if (utils.hasOverrideMimeType) {
	                    xhr.overrideMimeType(options.mimeType);
	                }
	            }
	
	            var type = options.type || 'POST',
	                data = options.data || null,
	                tempData = '';
	
	            if (type.toLowerCase() === 'get' && data) {
	                for (var o in data) {
	                    if (data.hasOwnProperty(o)) {
	                        tempData += o + '=' + data[o] + '&';
	                    }
	                }
	                tempData = tempData ? tempData.slice(0, -1) : tempData;
	                options.url += (options.url.indexOf('?') > 0 ? '&' : '?') + (tempData ? tempData + '&' : tempData) + '_v=' + new Date().getTime();
	                data = null;
	                tempData = null;
	            }
	            xhr.open(type, options.url, utils.isCanSetRequestHeader);
	
	            if (utils.isCanSetRequestHeader) {
	                var headers = options.headers || {};
	                for (var key in headers) {
	                    if (headers.hasOwnProperty(key)) {
	                        xhr.setRequestHeader(key, headers[key]);
	                    }
	                }
	            }
	            // fix: ie8 status error
	            window.XDomainRequest && (xhr.readyState = 2)
	            xhr.send(data);
	            return xhr;
	        },
	        ts: function () {
	            var d = new Date();
	            var Hours = d.getHours(); //获取当前小时数(0-23)
	            var Minutes = d.getMinutes(); //获取当前分钟数(0-59)
	            var Seconds = d.getSeconds(); //获取当前秒数(0-59)
	            var Milliseconds = d.getMilliseconds(); //获取当前毫秒
	            return (Hours < 10 ? "0" + Hours : Hours) + ':' + (Minutes < 10 ? "0" + Minutes : Minutes) + ':' + (Seconds < 10 ? "0" + Seconds : Seconds) + ':' + Milliseconds + ' ';
	        },
	
	        getObjectKey: function (obj, val) {
	            for (var key in obj) {
	                if (obj[key] == val) {
	                    return key;
	                }
	            }
	            return '';
	        },
	
	        sprintf: function () {
	            var arg = arguments,
	                str = arg[0] || '',
	                i, len;
	            for (i = 1, len = arg.length; i < len; i++) {
	                str = str.replace(/%s/, arg[i]);
	            }
	            return str;
	        },
	
	        setCookie: function (name, value, days) {
	            var cookie = name + '=' + encodeURIComponent(value);
	            if (typeof days == 'number') {
	                cookie += '; max-age: ' + (days * 60 * 60 * 24);
	            }
	            document.cookie = cookie;
	        },
	
	        getCookie: function () {
	            var allCookie = {};
	            var all = document.cookie;
	            if (all === "") {
	                return allCookie;
	            }
	            var list = all.split("; ");
	            for (var i = 0; i < list.length; i++) {
	                var cookie = list[i];
	                var p = cookie.indexOf('=');
	                var name = cookie.substring(0, p);
	                var value = cookie.substring(p + 1);
	                value = decodeURIComponent(value);
	                allCookie[name] = value;
	            }
	            return allCookie;
	        }
	    };
	
	
	    exports.utils = utils;
	}());

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var CryptoJS = __webpack_require__(141);
	;(function () {
	    'use strict';
	
	    var _utils = __webpack_require__(139).utils;
	    var Message = function (type, id) {
	        if (!this instanceof Message) {
	            return new Message(type);
	        }
	
	        this._msg = {};
	
	        if (typeof Message[type] === 'function') {
	            Message[type].prototype.setGroup = this.setGroup;
	            this._msg = new Message[type](id);
	        }
	        return this._msg;
	    }
	    Message.prototype.setGroup = function (group) {
	        this.body.group = group;
	    }
	
	    /*
	     * Read Message
	     */
	    Message.read = function (id) {
	        this.id = id;
	        this.type = 'read';
	    };
	
	    Message.read.prototype.set = function (opt) {
	        this.body = {
	            ackId: opt.id
	            , to: opt.to
	        }
	    };
	
	    /*
	     * deliver message
	     */
	    Message.delivery = function (id) {
	        this.id = id;
	        this.type = 'delivery';
	    };
	
	    Message.delivery.prototype.set = function (opt) {
	        this.body = {
	            bodyId: opt.id
	            , to: opt.to
	        };
	    };
	
	    /*
	     * text message
	     */
	    Message.txt = function (id) {
	        this.id = id;
	        this.type = 'txt';
	        this.body = {};
	    };
	    Message.txt.prototype.set = function (opt) {
	        this.value = opt.msg;
	        this.body = {
	            id: this.id
	            , to: opt.to
	            , msg: this.value
	            , type: this.type
	            , roomType: opt.roomType
	            , ext: opt.ext || {}
	            , success: opt.success
	            , fail: opt.fail
	        };
	
	        !opt.roomType && delete this.body.roomType;
	
	    };
	
	    /*
	     * cmd message
	     */
	    Message.cmd = function (id) {
	        this.id = id;
	        this.type = 'cmd';
	        this.body = {};
	    };
	    Message.cmd.prototype.set = function (opt) {
	        this.value = '';
	
	        this.body = {
	            to: opt.to
	            , action: opt.action
	            , msg: this.value
	            , type: this.type
	            , roomType: opt.roomType
	            , ext: opt.ext || {}
	            , success: opt.success
	        };
	        !opt.roomType && delete this.body.roomType;
	    };
	
	    /*
	     * loc message
	     */
	    Message.location = function (id) {
	        this.id = id;
	        this.type = 'loc';
	        this.body = {};
	    };
	    Message.location.prototype.set = function (opt) {
	        this.body = {
	            to: opt.to
	            , type: this.type
	            , roomType: opt.roomType
	            , addr: opt.addr
	            , lat: opt.lat
	            , lng: opt.lng
	            , ext: opt.ext || {}
	        };
	    };
	
	    /*
	     * img message
	     */
	    Message.img = function (id) {
	        this.id = id;
	        this.type = 'img';
	        this.body = {};
	    };
	    Message.img.prototype.set = function (opt) {
	        opt.file = opt.file || _utils.getFileUrl(opt.fileInputId);
	
	        this.value = opt.file;
	
	        this.body = {
	            id: this.id,
	            file: this.value,
	            apiUrl: opt.apiUrl,
	            to: opt.to,
	            type: this.type,
	            ext: opt.ext || {},
	            roomType: opt.roomType,
	            onFileUploadError: opt.onFileUploadError,
	            onFileUploadComplete: opt.onFileUploadComplete,
	            success: opt.success,
	            fail: opt.fail,
	            flashUpload: opt.flashUpload,
	            width: opt.width,
	            height: opt.height,
	            body: opt.body,
	            uploadError: opt.uploadError,
	            uploadComplete: opt.uploadComplete
	        };
	
	        !opt.roomType && delete this.body.roomType;
	    };
	
	    /*
	     * audio message
	     */
	    Message.audio = function (id) {
	        this.id = id;
	        this.type = 'audio';
	        this.body = {};
	    };
	    Message.audio.prototype.set = function (opt) {
	        opt.file = opt.file || _utils.getFileUrl(opt.fileInputId);
	
	        this.value = opt.file;
	        this.filename = opt.filename || this.value.filename;
	
	        this.body = {
	            id: this.id
	            , file: this.value
	            , filename: this.filename
	            , apiUrl: opt.apiUrl
	            , to: opt.to
	            , type: this.type
	            , ext: opt.ext || {}
	            , length: opt.length || 0
	            , roomType: opt.roomType
	            , file_length: opt.file_length
	            , onFileUploadError: opt.onFileUploadError
	            , onFileUploadComplete: opt.onFileUploadComplete
	            , success: opt.success
	            , fail: opt.fail
	            , flashUpload: opt.flashUpload
	            , body: opt.body
	        };
	        !opt.roomType && delete this.body.roomType;
	    };
	
	    /*
	     * file message
	     */
	    Message.file = function (id) {
	        this.id = id;
	        this.type = 'file';
	        this.body = {};
	    };
	    Message.file.prototype.set = function (opt) {
	        opt.file = opt.file || _utils.getFileUrl(opt.fileInputId);
	
	        this.value = opt.file;
	        this.filename = opt.filename || this.value.filename;
	
	        this.body = {
	            id: this.id
	            , file: this.value
	            , filename: this.filename
	            , apiUrl: opt.apiUrl
	            , to: opt.to
	            , type: this.type
	            , ext: opt.ext || {}
	            , roomType: opt.roomType
	            , onFileUploadError: opt.onFileUploadError
	            , onFileUploadComplete: opt.onFileUploadComplete
	            , success: opt.success
	            , fail: opt.fail
	            , flashUpload: opt.flashUpload
	            , body: opt.body
	        };
	        !opt.roomType && delete this.body.roomType;
	    };
	
	    /*
	     * video message
	     */
	    Message.video = function (id) {
	
	    };
	    Message.video.prototype.set = function (opt) {
	
	    };
	
	    var _Message = function (message) {
	
	        if (!this instanceof _Message) {
	            return new _Message(message, conn);
	        }
	
	        this.msg = message;
	    };
	
	    _Message.prototype.send = function (conn) {
	        var me = this;
	
	        var _send = function (message) {
	
	            message.ext = message.ext || {};
	            message.ext.weichat = message.ext.weichat || {};
	            message.ext.weichat.originType = message.ext.weichat.originType || 'webim';
	
	            var dom;
	            var json = {
	                from: conn.context.userId || ''
	                , to: message.to
	                , bodies: [message.body]
	                , ext: message.ext || {}
	            };
	            var jsonstr = _utils.stringify(json);
	            dom = $msg({
	                type: message.group || 'chat'
	                , to: message.toJid
	                , id: message.id
	                , xmlns: 'jabber:client'
	            }).c('body').t(jsonstr);
	
	            if (message.roomType) {
	                dom.up().c('roomtype', {xmlns: 'easemob:x:roomtype', type: 'chatroom'});
	            }
	            if (message.bodyId) {
	                dom = $msg({
	                    from: conn.context.jid || ''
	                    , to: message.toJid
	                    , id: message.id
	                    , xmlns: 'jabber:client'
	                }).c('body').t(message.bodyId);
	                var delivery = {
	                    xmlns: 'urn:xmpp:receipts'
	                    , id: message.bodyId
	                };
	                dom.up().c('delivery', delivery);
	            }
	            if (message.ackId) {
	
	                if (conn.context.jid.indexOf(message.toJid) >= 0) {
	                    return;
	                }
	                dom = $msg({
	                    from: conn.context.jid || ''
	                    , to: message.toJid
	                    , id: message.id
	                    , xmlns: 'jabber:client'
	                }).c('body').t(message.ackId);
	                var read = {
	                    xmlns: 'urn:xmpp:receipts'
	                    , id: message.ackId
	                };
	                dom.up().c('acked', read);
	            }
	
	            setTimeout(function () {
	                if (typeof _msgHash !== 'undefined' && _msgHash[message.id]) {
	                    _msgHash[message.id].msg.fail instanceof Function
	                    && _msgHash[message.id].msg.fail(message.id);
	                }
	            }, 60000);
	            conn.sendCommand(dom.tree(), message.id);
	        };
	
	
	        if (me.msg.file) {
	            if (me.msg.body && me.msg.body.url) {// Only send msg
	                _send(me.msg);
	                return;
	            }
	            var _tmpComplete = me.msg.onFileUploadComplete;
	            var _complete = function (data) {
	                if (data.entities[0]['file-metadata']) {
	                    var file_len = data.entities[0]['file-metadata']['content-length'];
	                    // me.msg.file_length = file_len;
	                    me.msg.filetype = data.entities[0]['file-metadata']['content-type'];
	                    if (file_len > 204800) {
	                        me.msg.thumbnail = true;
	                    }
	                }
	
	                me.msg.body = {
	                    type: me.msg.type || 'file'
	                    ,
	                    url: ((location.protocol != 'https:' && conn.isHttpDNS) ? (conn.apiUrl + data.uri.substr(data.uri.indexOf("/", 9))) : data.uri) + '/' + data.entities[0]['uuid']
	                    , secret: data.entities[0]['share-secret']
	                    , filename: me.msg.file.filename || me.msg.filename
	                    , size: {
	                        width: me.msg.width || 0
	                        , height: me.msg.height || 0
	                    }
	                    , length: me.msg.length || 0
	                    , file_length: me.msg.ext.file_length || 0
	                    , filetype: me.msg.filetype
	                }
	                _send(me.msg);
	                _tmpComplete instanceof Function && _tmpComplete(data, me.msg.id);
	            };
	
	            me.msg.onFileUploadComplete = _complete;
	            _utils.uploadFile.call(conn, me.msg);
	        } else {
	            me.msg.body = {
	                type: me.msg.type === 'chat' ? 'txt' : me.msg.type
	                , msg: me.msg.msg
	            };
	            if (me.msg.type === 'cmd') {
	                me.msg.body.action = me.msg.action;
	            } else if (me.msg.type === 'loc') {
	                me.msg.body.addr = me.msg.addr;
	                me.msg.body.lat = me.msg.lat;
	                me.msg.body.lng = me.msg.lng;
	            }
	
	            _send(me.msg);
	        }
	    };
	
	    exports._msg = _Message;
	    exports.message = Message;
	}());


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(143), __webpack_require__(144), __webpack_require__(145), __webpack_require__(146), __webpack_require__(147), __webpack_require__(148), __webpack_require__(149), __webpack_require__(150), __webpack_require__(151), __webpack_require__(152), __webpack_require__(153), __webpack_require__(154), __webpack_require__(155), __webpack_require__(156), __webpack_require__(157), __webpack_require__(158), __webpack_require__(159), __webpack_require__(160), __webpack_require__(161), __webpack_require__(162), __webpack_require__(163), __webpack_require__(164), __webpack_require__(165), __webpack_require__(166), __webpack_require__(167), __webpack_require__(168), __webpack_require__(169), __webpack_require__(170), __webpack_require__(171), __webpack_require__(172), __webpack_require__(173), __webpack_require__(174));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		return CryptoJS;
	
	}));

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var X32WordArray = C_lib.WordArray;
	
		    /**
		     * x64 namespace.
		     */
		    var C_x64 = C.x64 = {};
	
		    /**
		     * A 64-bit word.
		     */
		    var X64Word = C_x64.Word = Base.extend({
		        /**
		         * Initializes a newly created 64-bit word.
		         *
		         * @param {number} high The high 32 bits.
		         * @param {number} low The low 32 bits.
		         *
		         * @example
		         *
		         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
		         */
		        init: function (high, low) {
		            this.high = high;
		            this.low = low;
		        }
	
		        /**
		         * Bitwise NOTs this word.
		         *
		         * @return {X64Word} A new x64-Word object after negating.
		         *
		         * @example
		         *
		         *     var negated = x64Word.not();
		         */
		        // not: function () {
		            // var high = ~this.high;
		            // var low = ~this.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ANDs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to AND with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ANDing.
		         *
		         * @example
		         *
		         *     var anded = x64Word.and(anotherX64Word);
		         */
		        // and: function (word) {
		            // var high = this.high & word.high;
		            // var low = this.low & word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to OR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ORing.
		         *
		         * @example
		         *
		         *     var ored = x64Word.or(anotherX64Word);
		         */
		        // or: function (word) {
		            // var high = this.high | word.high;
		            // var low = this.low | word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise XORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to XOR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after XORing.
		         *
		         * @example
		         *
		         *     var xored = x64Word.xor(anotherX64Word);
		         */
		        // xor: function (word) {
		            // var high = this.high ^ word.high;
		            // var low = this.low ^ word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the left.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftL(25);
		         */
		        // shiftL: function (n) {
		            // if (n < 32) {
		                // var high = (this.high << n) | (this.low >>> (32 - n));
		                // var low = this.low << n;
		            // } else {
		                // var high = this.low << (n - 32);
		                // var low = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the right.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftR(7);
		         */
		        // shiftR: function (n) {
		            // if (n < 32) {
		                // var low = (this.low >>> n) | (this.high << (32 - n));
		                // var high = this.high >>> n;
		            // } else {
		                // var low = this.high >>> (n - 32);
		                // var high = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Rotates this word n bits to the left.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotL(25);
		         */
		        // rotL: function (n) {
		            // return this.shiftL(n).or(this.shiftR(64 - n));
		        // },
	
		        /**
		         * Rotates this word n bits to the right.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotR(7);
		         */
		        // rotR: function (n) {
		            // return this.shiftR(n).or(this.shiftL(64 - n));
		        // },
	
		        /**
		         * Adds this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to add with this word.
		         *
		         * @return {X64Word} A new x64-Word object after adding.
		         *
		         * @example
		         *
		         *     var added = x64Word.add(anotherX64Word);
		         */
		        // add: function (word) {
		            // var low = (this.low + word.low) | 0;
		            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
		            // var high = (this.high + word.high + carry) | 0;
	
		            // return X64Word.create(high, low);
		        // }
		    });
	
		    /**
		     * An array of 64-bit words.
		     *
		     * @property {Array} words The array of CryptoJS.x64.Word objects.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var X64WordArray = C_x64.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create();
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ]);
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ], 10);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 8;
		            }
		        },
	
		        /**
		         * Converts this 64-bit word array to a 32-bit word array.
		         *
		         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
		         *
		         * @example
		         *
		         *     var x32WordArray = x64WordArray.toX32();
		         */
		        toX32: function () {
		            // Shortcuts
		            var x64Words = this.words;
		            var x64WordsLength = x64Words.length;
	
		            // Convert
		            var x32Words = [];
		            for (var i = 0; i < x64WordsLength; i++) {
		                var x64Word = x64Words[i];
		                x32Words.push(x64Word.high);
		                x32Words.push(x64Word.low);
		            }
	
		            return X32WordArray.create(x32Words, this.sigBytes);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {X64WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = x64WordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
	
		            // Clone "words" array
		            var words = clone.words = this.words.slice(0);
	
		            // Clone each X64Word object
		            var wordsLength = words.length;
		            for (var i = 0; i < wordsLength; i++) {
		                words[i] = words[i].clone();
		            }
	
		            return clone;
		        }
		    });
		}());
	
	
		return CryptoJS;
	
	}));

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Check if typed arrays are supported
		    if (typeof ArrayBuffer != 'function') {
		        return;
		    }
	
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
	
		    // Reference original init
		    var superInit = WordArray.init;
	
		    // Augment WordArray.init to handle typed arrays
		    var subInit = WordArray.init = function (typedArray) {
		        // Convert buffers to uint8
		        if (typedArray instanceof ArrayBuffer) {
		            typedArray = new Uint8Array(typedArray);
		        }
	
		        // Convert other array views to uint8
		        if (
		            typedArray instanceof Int8Array ||
		            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
		            typedArray instanceof Int16Array ||
		            typedArray instanceof Uint16Array ||
		            typedArray instanceof Int32Array ||
		            typedArray instanceof Uint32Array ||
		            typedArray instanceof Float32Array ||
		            typedArray instanceof Float64Array
		        ) {
		            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
		        }
	
		        // Handle Uint8Array
		        if (typedArray instanceof Uint8Array) {
		            // Shortcut
		            var typedArrayByteLength = typedArray.byteLength;
	
		            // Extract bytes
		            var words = [];
		            for (var i = 0; i < typedArrayByteLength; i++) {
		                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
		            }
	
		            // Initialize this word array
		            superInit.call(this, words, typedArrayByteLength);
		        } else {
		            // Else call normal init
		            superInit.apply(this, arguments);
		        }
		    };
	
		    subInit.prototype = WordArray;
		}());
	
	
		return CryptoJS.lib.WordArray;
	
	}));

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * UTF-16 BE encoding strategy.
		     */
		    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
		        /**
		         * Converts a word array to a UTF-16 BE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 BE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 BE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 BE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    /**
		     * UTF-16 LE encoding strategy.
		     */
		    C_enc.Utf16LE = {
		        /**
		         * Converts a word array to a UTF-16 LE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 LE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 LE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 LE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    function swapEndian(word) {
		        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
		    }
		}());
	
	
		return CryptoJS.enc.Utf16;
	
	}));

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * Base64 encoding strategy.
		     */
		    var Base64 = C_enc.Base64 = {
		        /**
		         * Converts a word array to a Base64 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Base64 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
		            var map = this._map;
	
		            // Clamp excess bits
		            wordArray.clamp();
	
		            // Convert
		            var base64Chars = [];
		            for (var i = 0; i < sigBytes; i += 3) {
		                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
		                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
		                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;
	
		                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;
	
		                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
		                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
		                }
		            }
	
		            // Add padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                while (base64Chars.length % 4) {
		                    base64Chars.push(paddingChar);
		                }
		            }
	
		            return base64Chars.join('');
		        },
	
		        /**
		         * Converts a Base64 string to a word array.
		         *
		         * @param {string} base64Str The Base64 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
		         */
		        parse: function (base64Str) {
		            // Shortcuts
		            var base64StrLength = base64Str.length;
		            var map = this._map;
		            var reverseMap = this._reverseMap;
	
		            if (!reverseMap) {
		                    reverseMap = this._reverseMap = [];
		                    for (var j = 0; j < map.length; j++) {
		                        reverseMap[map.charCodeAt(j)] = j;
		                    }
		            }
	
		            // Ignore padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                var paddingIndex = base64Str.indexOf(paddingChar);
		                if (paddingIndex !== -1) {
		                    base64StrLength = paddingIndex;
		                }
		            }
	
		            // Convert
		            return parseLoop(base64Str, base64StrLength, reverseMap);
	
		        },
	
		        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
		    };
	
		    function parseLoop(base64Str, base64StrLength, reverseMap) {
		      var words = [];
		      var nBytes = 0;
		      for (var i = 0; i < base64StrLength; i++) {
		          if (i % 4) {
		              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
		              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
		              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
		              nBytes++;
		          }
		      }
		      return WordArray.create(words, nBytes);
		    }
		}());
	
	
		return CryptoJS.enc.Base64;
	
	}));

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var T = [];
	
		    // Compute constants
		    (function () {
		        for (var i = 0; i < 64; i++) {
		            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
		        }
		    }());
	
		    /**
		     * MD5 hash algorithm.
		     */
		    var MD5 = C_algo.MD5 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
	
		            // Shortcuts
		            var H = this._hash.words;
	
		            var M_offset_0  = M[offset + 0];
		            var M_offset_1  = M[offset + 1];
		            var M_offset_2  = M[offset + 2];
		            var M_offset_3  = M[offset + 3];
		            var M_offset_4  = M[offset + 4];
		            var M_offset_5  = M[offset + 5];
		            var M_offset_6  = M[offset + 6];
		            var M_offset_7  = M[offset + 7];
		            var M_offset_8  = M[offset + 8];
		            var M_offset_9  = M[offset + 9];
		            var M_offset_10 = M[offset + 10];
		            var M_offset_11 = M[offset + 11];
		            var M_offset_12 = M[offset + 12];
		            var M_offset_13 = M[offset + 13];
		            var M_offset_14 = M[offset + 14];
		            var M_offset_15 = M[offset + 15];
	
		            // Working varialbes
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
	
		            // Computation
		            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
		            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
		            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
		            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
		            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
		            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
		            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
		            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
		            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
		            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
		            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
		            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
		            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
		            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
		            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
		            b = FF(b, c, d, a, M_offset_15, 22, T[15]);
	
		            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
		            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
		            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
		            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
		            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
		            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
		            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
		            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
		            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
		            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
		            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
		            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
		            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
		            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
		            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
		            b = GG(b, c, d, a, M_offset_12, 20, T[31]);
	
		            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
		            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
		            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
		            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
		            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
		            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
		            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
		            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
		            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
		            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
		            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
		            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
		            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
		            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
		            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
		            b = HH(b, c, d, a, M_offset_2,  23, T[47]);
	
		            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
		            d = II(d, a, b, c, M_offset_7,  10, T[49]);
		            c = II(c, d, a, b, M_offset_14, 15, T[50]);
		            b = II(b, c, d, a, M_offset_5,  21, T[51]);
		            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
		            d = II(d, a, b, c, M_offset_3,  10, T[53]);
		            c = II(c, d, a, b, M_offset_10, 15, T[54]);
		            b = II(b, c, d, a, M_offset_1,  21, T[55]);
		            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
		            d = II(d, a, b, c, M_offset_15, 10, T[57]);
		            c = II(c, d, a, b, M_offset_6,  15, T[58]);
		            b = II(b, c, d, a, M_offset_13, 21, T[59]);
		            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
		            d = II(d, a, b, c, M_offset_11, 10, T[61]);
		            c = II(c, d, a, b, M_offset_2,  15, T[62]);
		            b = II(b, c, d, a, M_offset_9,  21, T[63]);
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	
		            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
		            var nBitsTotalL = nBitsTotal;
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
		                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
		            );
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
		            );
	
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    function FF(a, b, c, d, x, s, t) {
		        var n = a + ((b & c) | (~b & d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function GG(a, b, c, d, x, s, t) {
		        var n = a + ((b & d) | (c & ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function HH(a, b, c, d, x, s, t) {
		        var n = a + (b ^ c ^ d) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function II(a, b, c, d, x, s, t) {
		        var n = a + (c ^ (b | ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.MD5('message');
		     *     var hash = CryptoJS.MD5(wordArray);
		     */
		    C.MD5 = Hasher._createHelper(MD5);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacMD5(message, key);
		     */
		    C.HmacMD5 = Hasher._createHmacHelper(MD5);
		}(Math));
	
	
		return CryptoJS.MD5;
	
	}));

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-1 hash algorithm.
		     */
		    var SHA1 = C_algo.SHA1 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476,
		                0xc3d2e1f0
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
	
		            // Computation
		            for (var i = 0; i < 80; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
		                    W[i] = (n << 1) | (n >>> 31);
		                }
	
		                var t = ((a << 5) | (a >>> 27)) + e + W[i];
		                if (i < 20) {
		                    t += ((b & c) | (~b & d)) + 0x5a827999;
		                } else if (i < 40) {
		                    t += (b ^ c ^ d) + 0x6ed9eba1;
		                } else if (i < 60) {
		                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
		                } else /* if (i < 80) */ {
		                    t += (b ^ c ^ d) - 0x359d3e2a;
		                }
	
		                e = d;
		                d = c;
		                c = (b << 30) | (b >>> 2);
		                b = a;
		                a = t;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA1('message');
		     *     var hash = CryptoJS.SHA1(wordArray);
		     */
		    C.SHA1 = Hasher._createHelper(SHA1);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA1(message, key);
		     */
		    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
		}());
	
	
		return CryptoJS.SHA1;
	
	}));

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Initialization and round constants tables
		    var H = [];
		    var K = [];
	
		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }
	
		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
		                nPrime++;
		            }
	
		            n++;
		        }
		    }());
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];
	
		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);
	
		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);
	
		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }
	
		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);
	
		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));
	
		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;
	
		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));
	
	
		return CryptoJS.SHA256;
	
	}));

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(149));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha256"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA256 = C_algo.SHA256;
	
		    /**
		     * SHA-224 hash algorithm.
		     */
		    var SHA224 = C_algo.SHA224 = SHA256.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
		                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA256._doFinalize.call(this);
	
		            hash.sigBytes -= 4;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA224('message');
		     *     var hash = CryptoJS.SHA224(wordArray);
		     */
		    C.SHA224 = SHA256._createHelper(SHA224);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA224(message, key);
		     */
		    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
		}());
	
	
		return CryptoJS.SHA224;
	
	}));

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(143));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
	
		    function X64Word_create() {
		        return X64Word.create.apply(X64Word, arguments);
		    }
	
		    // Constants
		    var K = [
		        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
		        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
		        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
		        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
		        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
		        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
		        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
		        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
		        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
		        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
		        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
		        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
		        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
		        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
		        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
		        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
		        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
		        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
		        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
		        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
		        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
		        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
		        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
		        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
		        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
		        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
		        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
		        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
		        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
		        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
		        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
		        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
		        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
		        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
		        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
		        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
		        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
		        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
		        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
		        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
		    ];
	
		    // Reusable objects
		    var W = [];
		    (function () {
		        for (var i = 0; i < 80; i++) {
		            W[i] = X64Word_create();
		        }
		    }());
	
		    /**
		     * SHA-512 hash algorithm.
		     */
		    var SHA512 = C_algo.SHA512 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
		                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
		                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
		                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var H = this._hash.words;
	
		            var H0 = H[0];
		            var H1 = H[1];
		            var H2 = H[2];
		            var H3 = H[3];
		            var H4 = H[4];
		            var H5 = H[5];
		            var H6 = H[6];
		            var H7 = H[7];
	
		            var H0h = H0.high;
		            var H0l = H0.low;
		            var H1h = H1.high;
		            var H1l = H1.low;
		            var H2h = H2.high;
		            var H2l = H2.low;
		            var H3h = H3.high;
		            var H3l = H3.low;
		            var H4h = H4.high;
		            var H4l = H4.low;
		            var H5h = H5.high;
		            var H5l = H5.low;
		            var H6h = H6.high;
		            var H6l = H6.low;
		            var H7h = H7.high;
		            var H7l = H7.low;
	
		            // Working variables
		            var ah = H0h;
		            var al = H0l;
		            var bh = H1h;
		            var bl = H1l;
		            var ch = H2h;
		            var cl = H2l;
		            var dh = H3h;
		            var dl = H3l;
		            var eh = H4h;
		            var el = H4l;
		            var fh = H5h;
		            var fl = H5l;
		            var gh = H6h;
		            var gl = H6l;
		            var hh = H7h;
		            var hl = H7l;
	
		            // Rounds
		            for (var i = 0; i < 80; i++) {
		                // Shortcut
		                var Wi = W[i];
	
		                // Extend message
		                if (i < 16) {
		                    var Wih = Wi.high = M[offset + i * 2]     | 0;
		                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
		                } else {
		                    // Gamma0
		                    var gamma0x  = W[i - 15];
		                    var gamma0xh = gamma0x.high;
		                    var gamma0xl = gamma0x.low;
		                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
		                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));
	
		                    // Gamma1
		                    var gamma1x  = W[i - 2];
		                    var gamma1xh = gamma1x.high;
		                    var gamma1xl = gamma1x.low;
		                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
		                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));
	
		                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
		                    var Wi7  = W[i - 7];
		                    var Wi7h = Wi7.high;
		                    var Wi7l = Wi7.low;
	
		                    var Wi16  = W[i - 16];
		                    var Wi16h = Wi16.high;
		                    var Wi16l = Wi16.low;
	
		                    var Wil = gamma0l + Wi7l;
		                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
		                    var Wil = Wil + gamma1l;
		                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
		                    var Wil = Wil + Wi16l;
		                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);
	
		                    Wi.high = Wih;
		                    Wi.low  = Wil;
		                }
	
		                var chh  = (eh & fh) ^ (~eh & gh);
		                var chl  = (el & fl) ^ (~el & gl);
		                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
		                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);
	
		                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
		                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
		                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
		                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));
	
		                // t1 = h + sigma1 + ch + K[i] + W[i]
		                var Ki  = K[i];
		                var Kih = Ki.high;
		                var Kil = Ki.low;
	
		                var t1l = hl + sigma1l;
		                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
		                var t1l = t1l + chl;
		                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
		                var t1l = t1l + Kil;
		                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
		                var t1l = t1l + Wil;
		                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);
	
		                // t2 = sigma0 + maj
		                var t2l = sigma0l + majl;
		                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);
	
		                // Update working variables
		                hh = gh;
		                hl = gl;
		                gh = fh;
		                gl = fl;
		                fh = eh;
		                fl = el;
		                el = (dl + t1l) | 0;
		                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
		                dh = ch;
		                dl = cl;
		                ch = bh;
		                cl = bl;
		                bh = ah;
		                bl = al;
		                al = (t1l + t2l) | 0;
		                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
		            }
	
		            // Intermediate hash value
		            H0l = H0.low  = (H0l + al);
		            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
		            H1l = H1.low  = (H1l + bl);
		            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
		            H2l = H2.low  = (H2l + cl);
		            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
		            H3l = H3.low  = (H3l + dl);
		            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
		            H4l = H4.low  = (H4l + el);
		            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
		            H5l = H5.low  = (H5l + fl);
		            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
		            H6l = H6.low  = (H6l + gl);
		            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
		            H7l = H7.low  = (H7l + hl);
		            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Convert hash to 32-bit word array before returning
		            var hash = this._hash.toX32();
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        },
	
		        blockSize: 1024/32
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA512('message');
		     *     var hash = CryptoJS.SHA512(wordArray);
		     */
		    C.SHA512 = Hasher._createHelper(SHA512);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA512(message, key);
		     */
		    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
		}());
	
	
		return CryptoJS.SHA512;
	
	}));

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(143), __webpack_require__(151));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./sha512"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
		    var SHA512 = C_algo.SHA512;
	
		    /**
		     * SHA-384 hash algorithm.
		     */
		    var SHA384 = C_algo.SHA384 = SHA512.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
		                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
		                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
		                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA512._doFinalize.call(this);
	
		            hash.sigBytes -= 16;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA384('message');
		     *     var hash = CryptoJS.SHA384(wordArray);
		     */
		    C.SHA384 = SHA512._createHelper(SHA384);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA384(message, key);
		     */
		    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
		}());
	
	
		return CryptoJS.SHA384;
	
	}));

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(143));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var C_algo = C.algo;
	
		    // Constants tables
		    var RHO_OFFSETS = [];
		    var PI_INDEXES  = [];
		    var ROUND_CONSTANTS = [];
	
		    // Compute Constants
		    (function () {
		        // Compute rho offset constants
		        var x = 1, y = 0;
		        for (var t = 0; t < 24; t++) {
		            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;
	
		            var newX = y % 5;
		            var newY = (2 * x + 3 * y) % 5;
		            x = newX;
		            y = newY;
		        }
	
		        // Compute pi index constants
		        for (var x = 0; x < 5; x++) {
		            for (var y = 0; y < 5; y++) {
		                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
		            }
		        }
	
		        // Compute round constants
		        var LFSR = 0x01;
		        for (var i = 0; i < 24; i++) {
		            var roundConstantMsw = 0;
		            var roundConstantLsw = 0;
	
		            for (var j = 0; j < 7; j++) {
		                if (LFSR & 0x01) {
		                    var bitPosition = (1 << j) - 1;
		                    if (bitPosition < 32) {
		                        roundConstantLsw ^= 1 << bitPosition;
		                    } else /* if (bitPosition >= 32) */ {
		                        roundConstantMsw ^= 1 << (bitPosition - 32);
		                    }
		                }
	
		                // Compute next LFSR
		                if (LFSR & 0x80) {
		                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
		                    LFSR = (LFSR << 1) ^ 0x71;
		                } else {
		                    LFSR <<= 1;
		                }
		            }
	
		            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
		        }
		    }());
	
		    // Reusable objects for temporary values
		    var T = [];
		    (function () {
		        for (var i = 0; i < 25; i++) {
		            T[i] = X64Word.create();
		        }
		    }());
	
		    /**
		     * SHA-3 hash algorithm.
		     */
		    var SHA3 = C_algo.SHA3 = Hasher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} outputLength
		         *   The desired number of bits in the output hash.
		         *   Only values permitted are: 224, 256, 384, 512.
		         *   Default: 512
		         */
		        cfg: Hasher.cfg.extend({
		            outputLength: 512
		        }),
	
		        _doReset: function () {
		            var state = this._state = []
		            for (var i = 0; i < 25; i++) {
		                state[i] = new X64Word.init();
		            }
	
		            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var state = this._state;
		            var nBlockSizeLanes = this.blockSize / 2;
	
		            // Absorb
		            for (var i = 0; i < nBlockSizeLanes; i++) {
		                // Shortcuts
		                var M2i  = M[offset + 2 * i];
		                var M2i1 = M[offset + 2 * i + 1];
	
		                // Swap endian
		                M2i = (
		                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
		                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
		                );
		                M2i1 = (
		                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
		                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
		                );
	
		                // Absorb message into state
		                var lane = state[i];
		                lane.high ^= M2i1;
		                lane.low  ^= M2i;
		            }
	
		            // Rounds
		            for (var round = 0; round < 24; round++) {
		                // Theta
		                for (var x = 0; x < 5; x++) {
		                    // Mix column lanes
		                    var tMsw = 0, tLsw = 0;
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        tMsw ^= lane.high;
		                        tLsw ^= lane.low;
		                    }
	
		                    // Temporary values
		                    var Tx = T[x];
		                    Tx.high = tMsw;
		                    Tx.low  = tLsw;
		                }
		                for (var x = 0; x < 5; x++) {
		                    // Shortcuts
		                    var Tx4 = T[(x + 4) % 5];
		                    var Tx1 = T[(x + 1) % 5];
		                    var Tx1Msw = Tx1.high;
		                    var Tx1Lsw = Tx1.low;
	
		                    // Mix surrounding columns
		                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
		                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        lane.high ^= tMsw;
		                        lane.low  ^= tLsw;
		                    }
		                }
	
		                // Rho Pi
		                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
		                    // Shortcuts
		                    var lane = state[laneIndex];
		                    var laneMsw = lane.high;
		                    var laneLsw = lane.low;
		                    var rhoOffset = RHO_OFFSETS[laneIndex];
	
		                    // Rotate lanes
		                    if (rhoOffset < 32) {
		                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
		                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
		                    } else /* if (rhoOffset >= 32) */ {
		                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
		                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
		                    }
	
		                    // Transpose lanes
		                    var TPiLane = T[PI_INDEXES[laneIndex]];
		                    TPiLane.high = tMsw;
		                    TPiLane.low  = tLsw;
		                }
	
		                // Rho pi at x = y = 0
		                var T0 = T[0];
		                var state0 = state[0];
		                T0.high = state0.high;
		                T0.low  = state0.low;
	
		                // Chi
		                for (var x = 0; x < 5; x++) {
		                    for (var y = 0; y < 5; y++) {
		                        // Shortcuts
		                        var laneIndex = x + 5 * y;
		                        var lane = state[laneIndex];
		                        var TLane = T[laneIndex];
		                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
		                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];
	
		                        // Mix rows
		                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
		                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
		                    }
		                }
	
		                // Iota
		                var lane = state[0];
		                var roundConstant = ROUND_CONSTANTS[round];
		                lane.high ^= roundConstant.high;
		                lane.low  ^= roundConstant.low;;
		            }
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
		            var blockSizeBits = this.blockSize * 32;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
		            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var state = this._state;
		            var outputLengthBytes = this.cfg.outputLength / 8;
		            var outputLengthLanes = outputLengthBytes / 8;
	
		            // Squeeze
		            var hashWords = [];
		            for (var i = 0; i < outputLengthLanes; i++) {
		                // Shortcuts
		                var lane = state[i];
		                var laneMsw = lane.high;
		                var laneLsw = lane.low;
	
		                // Swap endian
		                laneMsw = (
		                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
		                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
		                );
		                laneLsw = (
		                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
		                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
		                );
	
		                // Squeeze state to retrieve hash
		                hashWords.push(laneLsw);
		                hashWords.push(laneMsw);
		            }
	
		            // Return final computed hash
		            return new WordArray.init(hashWords, outputLengthBytes);
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
	
		            var state = clone._state = this._state.slice(0);
		            for (var i = 0; i < 25; i++) {
		                state[i] = state[i].clone();
		            }
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA3('message');
		     *     var hash = CryptoJS.SHA3(wordArray);
		     */
		    C.SHA3 = Hasher._createHelper(SHA3);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA3(message, key);
		     */
		    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
		}(Math));
	
	
		return CryptoJS.SHA3;
	
	}));

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		(c) 2012 by Cédric Mesnil. All rights reserved.
	
		Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
		    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
		    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
		THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var _zl = WordArray.create([
		        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
		        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
		        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
		        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
		        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
		    var _zr = WordArray.create([
		        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
		        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
		        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
		        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
		        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
		    var _sl = WordArray.create([
		         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
		        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
		        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
		          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
		        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
		    var _sr = WordArray.create([
		        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
		        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
		        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
		        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
		        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);
	
		    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
		    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
	
		    /**
		     * RIPEMD160 hash algorithm.
		     */
		    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
		        _doReset: function () {
		            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
		        },
	
		        _doProcessBlock: function (M, offset) {
	
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                // Swap
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
		            // Shortcut
		            var H  = this._hash.words;
		            var hl = _hl.words;
		            var hr = _hr.words;
		            var zl = _zl.words;
		            var zr = _zr.words;
		            var sl = _sl.words;
		            var sr = _sr.words;
	
		            // Working variables
		            var al, bl, cl, dl, el;
		            var ar, br, cr, dr, er;
	
		            ar = al = H[0];
		            br = bl = H[1];
		            cr = cl = H[2];
		            dr = dl = H[3];
		            er = el = H[4];
		            // Computation
		            var t;
		            for (var i = 0; i < 80; i += 1) {
		                t = (al +  M[offset+zl[i]])|0;
		                if (i<16){
			            t +=  f1(bl,cl,dl) + hl[0];
		                } else if (i<32) {
			            t +=  f2(bl,cl,dl) + hl[1];
		                } else if (i<48) {
			            t +=  f3(bl,cl,dl) + hl[2];
		                } else if (i<64) {
			            t +=  f4(bl,cl,dl) + hl[3];
		                } else {// if (i<80) {
			            t +=  f5(bl,cl,dl) + hl[4];
		                }
		                t = t|0;
		                t =  rotl(t,sl[i]);
		                t = (t+el)|0;
		                al = el;
		                el = dl;
		                dl = rotl(cl, 10);
		                cl = bl;
		                bl = t;
	
		                t = (ar + M[offset+zr[i]])|0;
		                if (i<16){
			            t +=  f5(br,cr,dr) + hr[0];
		                } else if (i<32) {
			            t +=  f4(br,cr,dr) + hr[1];
		                } else if (i<48) {
			            t +=  f3(br,cr,dr) + hr[2];
		                } else if (i<64) {
			            t +=  f2(br,cr,dr) + hr[3];
		                } else {// if (i<80) {
			            t +=  f1(br,cr,dr) + hr[4];
		                }
		                t = t|0;
		                t =  rotl(t,sr[i]) ;
		                t = (t+er)|0;
		                ar = er;
		                er = dr;
		                dr = rotl(cr, 10);
		                cr = br;
		                br = t;
		            }
		            // Intermediate hash value
		            t    = (H[1] + cl + dr)|0;
		            H[1] = (H[2] + dl + er)|0;
		            H[2] = (H[3] + el + ar)|0;
		            H[3] = (H[4] + al + br)|0;
		            H[4] = (H[0] + bl + cr)|0;
		            H[0] =  t;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
		            );
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 5; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                // Swap
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
	
		    function f1(x, y, z) {
		        return ((x) ^ (y) ^ (z));
	
		    }
	
		    function f2(x, y, z) {
		        return (((x)&(y)) | ((~x)&(z)));
		    }
	
		    function f3(x, y, z) {
		        return (((x) | (~(y))) ^ (z));
		    }
	
		    function f4(x, y, z) {
		        return (((x) & (z)) | ((y)&(~(z))));
		    }
	
		    function f5(x, y, z) {
		        return ((x) ^ ((y) |(~(z))));
	
		    }
	
		    function rotl(x,n) {
		        return (x<<n) | (x>>>(32-n));
		    }
	
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.RIPEMD160('message');
		     *     var hash = CryptoJS.RIPEMD160(wordArray);
		     */
		    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
		     */
		    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
		}(Math));
	
	
		return CryptoJS.RIPEMD160;
	
	}));

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var C_algo = C.algo;
	
		    /**
		     * HMAC algorithm.
		     */
		    var HMAC = C_algo.HMAC = Base.extend({
		        /**
		         * Initializes a newly created HMAC.
		         *
		         * @param {Hasher} hasher The hash algorithm to use.
		         * @param {WordArray|string} key The secret key.
		         *
		         * @example
		         *
		         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
		         */
		        init: function (hasher, key) {
		            // Init hasher
		            hasher = this._hasher = new hasher.init();
	
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof key == 'string') {
		                key = Utf8.parse(key);
		            }
	
		            // Shortcuts
		            var hasherBlockSize = hasher.blockSize;
		            var hasherBlockSizeBytes = hasherBlockSize * 4;
	
		            // Allow arbitrary length keys
		            if (key.sigBytes > hasherBlockSizeBytes) {
		                key = hasher.finalize(key);
		            }
	
		            // Clamp excess bits
		            key.clamp();
	
		            // Clone key for inner and outer pads
		            var oKey = this._oKey = key.clone();
		            var iKey = this._iKey = key.clone();
	
		            // Shortcuts
		            var oKeyWords = oKey.words;
		            var iKeyWords = iKey.words;
	
		            // XOR keys with pad constants
		            for (var i = 0; i < hasherBlockSize; i++) {
		                oKeyWords[i] ^= 0x5c5c5c5c;
		                iKeyWords[i] ^= 0x36363636;
		            }
		            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this HMAC to its initial state.
		         *
		         * @example
		         *
		         *     hmacHasher.reset();
		         */
		        reset: function () {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Reset
		            hasher.reset();
		            hasher.update(this._iKey);
		        },
	
		        /**
		         * Updates this HMAC with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {HMAC} This HMAC instance.
		         *
		         * @example
		         *
		         *     hmacHasher.update('message');
		         *     hmacHasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            this._hasher.update(messageUpdate);
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the HMAC computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The HMAC.
		         *
		         * @example
		         *
		         *     var hmac = hmacHasher.finalize();
		         *     var hmac = hmacHasher.finalize('message');
		         *     var hmac = hmacHasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Compute HMAC
		            var innerHash = hasher.finalize(messageUpdate);
		            hasher.reset();
		            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	
		            return hmac;
		        }
		    });
		}());
	
	
	}));

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(148), __webpack_require__(155));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA1 = C_algo.SHA1;
		    var HMAC = C_algo.HMAC;
	
		    /**
		     * Password-Based Key Derivation Function 2 algorithm.
		     */
		    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hasher to use. Default: SHA1
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: SHA1,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.PBKDF2.create();
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Computes the Password-Based Key Derivation Function 2.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init HMAC
		            var hmac = HMAC.create(cfg.hasher, password);
	
		            // Initial values
		            var derivedKey = WordArray.create();
		            var blockIndex = WordArray.create([0x00000001]);
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var blockIndexWords = blockIndex.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                var block = hmac.update(salt).finalize(blockIndex);
		                hmac.reset();
	
		                // Shortcuts
		                var blockWords = block.words;
		                var blockWordsLength = blockWords.length;
	
		                // Iterations
		                var intermediate = block;
		                for (var i = 1; i < iterations; i++) {
		                    intermediate = hmac.finalize(intermediate);
		                    hmac.reset();
	
		                    // Shortcut
		                    var intermediateWords = intermediate.words;
	
		                    // XOR intermediate with block
		                    for (var j = 0; j < blockWordsLength; j++) {
		                        blockWords[j] ^= intermediateWords[j];
		                    }
		                }
	
		                derivedKey.concat(block);
		                blockIndexWords[0]++;
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Computes the Password-Based Key Derivation Function 2.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.PBKDF2(password, salt);
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.PBKDF2 = function (password, salt, cfg) {
		        return PBKDF2.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.PBKDF2;
	
	}));

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(148), __webpack_require__(155));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var MD5 = C_algo.MD5;
	
		    /**
		     * This key derivation function is meant to conform with EVP_BytesToKey.
		     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
		     */
		    var EvpKDF = C_algo.EvpKDF = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: MD5,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.EvpKDF.create();
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Derives a key from a password.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init hasher
		            var hasher = cfg.hasher.create();
	
		            // Initial values
		            var derivedKey = WordArray.create();
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                if (block) {
		                    hasher.update(block);
		                }
		                var block = hasher.update(password).finalize(salt);
		                hasher.reset();
	
		                // Iterations
		                for (var i = 1; i < iterations; i++) {
		                    block = hasher.finalize(block);
		                    hasher.reset();
		                }
	
		                derivedKey.concat(block);
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Derives a key from a password.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.EvpKDF(password, salt);
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.EvpKDF = function (password, salt, cfg) {
		        return EvpKDF.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.EvpKDF;
	
	}));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(157));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./evpkdf"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher core components.
		 */
		CryptoJS.lib.Cipher || (function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var Base64 = C_enc.Base64;
		    var C_algo = C.algo;
		    var EvpKDF = C_algo.EvpKDF;
	
		    /**
		     * Abstract base cipher template.
		     *
		     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
		     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
		     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
		     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
		     */
		    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {WordArray} iv The IV to use for this operation.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Creates this cipher in encryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createEncryptor: function (key, cfg) {
		            return this.create(this._ENC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Creates this cipher in decryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createDecryptor: function (key, cfg) {
		            return this.create(this._DEC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Initializes a newly created cipher.
		         *
		         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
		         */
		        init: function (xformMode, key, cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Store transform mode and key
		            this._xformMode = xformMode;
		            this._key = key;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this cipher to its initial state.
		         *
		         * @example
		         *
		         *     cipher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-cipher logic
		            this._doReset();
		        },
	
		        /**
		         * Adds data to be encrypted or decrypted.
		         *
		         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.process('data');
		         *     var encrypted = cipher.process(wordArray);
		         */
		        process: function (dataUpdate) {
		            // Append
		            this._append(dataUpdate);
	
		            // Process available blocks
		            return this._process();
		        },
	
		        /**
		         * Finalizes the encryption or decryption process.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after final processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.finalize();
		         *     var encrypted = cipher.finalize('data');
		         *     var encrypted = cipher.finalize(wordArray);
		         */
		        finalize: function (dataUpdate) {
		            // Final data update
		            if (dataUpdate) {
		                this._append(dataUpdate);
		            }
	
		            // Perform concrete-cipher logic
		            var finalProcessedData = this._doFinalize();
	
		            return finalProcessedData;
		        },
	
		        keySize: 128/32,
	
		        ivSize: 128/32,
	
		        _ENC_XFORM_MODE: 1,
	
		        _DEC_XFORM_MODE: 2,
	
		        /**
		         * Creates shortcut functions to a cipher's object interface.
		         *
		         * @param {Cipher} cipher The cipher to create a helper for.
		         *
		         * @return {Object} An object with encrypt and decrypt shortcut functions.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
		         */
		        _createHelper: (function () {
		            function selectCipherStrategy(key) {
		                if (typeof key == 'string') {
		                    return PasswordBasedCipher;
		                } else {
		                    return SerializableCipher;
		                }
		            }
	
		            return function (cipher) {
		                return {
		                    encrypt: function (message, key, cfg) {
		                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
		                    },
	
		                    decrypt: function (ciphertext, key, cfg) {
		                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
		                    }
		                };
		            };
		        }())
		    });
	
		    /**
		     * Abstract base stream cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
		     */
		    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
		        _doFinalize: function () {
		            // Process partial blocks
		            var finalProcessedBlocks = this._process(!!'flush');
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 1
		    });
	
		    /**
		     * Mode namespace.
		     */
		    var C_mode = C.mode = {};
	
		    /**
		     * Abstract base block cipher mode template.
		     */
		    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
		        /**
		         * Creates this mode for encryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
		         */
		        createEncryptor: function (cipher, iv) {
		            return this.Encryptor.create(cipher, iv);
		        },
	
		        /**
		         * Creates this mode for decryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
		         */
		        createDecryptor: function (cipher, iv) {
		            return this.Decryptor.create(cipher, iv);
		        },
	
		        /**
		         * Initializes a newly created mode.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
		         */
		        init: function (cipher, iv) {
		            this._cipher = cipher;
		            this._iv = iv;
		        }
		    });
	
		    /**
		     * Cipher Block Chaining mode.
		     */
		    var CBC = C_mode.CBC = (function () {
		        /**
		         * Abstract base CBC mode.
		         */
		        var CBC = BlockCipherMode.extend();
	
		        /**
		         * CBC encryptor.
		         */
		        CBC.Encryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // XOR and encrypt
		                xorBlock.call(this, words, offset, blockSize);
		                cipher.encryptBlock(words, offset);
	
		                // Remember this block to use with next block
		                this._prevBlock = words.slice(offset, offset + blockSize);
		            }
		        });
	
		        /**
		         * CBC decryptor.
		         */
		        CBC.Decryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // Remember this block to use with next block
		                var thisBlock = words.slice(offset, offset + blockSize);
	
		                // Decrypt and XOR
		                cipher.decryptBlock(words, offset);
		                xorBlock.call(this, words, offset, blockSize);
	
		                // This block becomes the previous block
		                this._prevBlock = thisBlock;
		            }
		        });
	
		        function xorBlock(words, offset, blockSize) {
		            // Shortcut
		            var iv = this._iv;
	
		            // Choose mixing block
		            if (iv) {
		                var block = iv;
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            } else {
		                var block = this._prevBlock;
		            }
	
		            // XOR blocks
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= block[i];
		            }
		        }
	
		        return CBC;
		    }());
	
		    /**
		     * Padding namespace.
		     */
		    var C_pad = C.pad = {};
	
		    /**
		     * PKCS #5/7 padding strategy.
		     */
		    var Pkcs7 = C_pad.Pkcs7 = {
		        /**
		         * Pads data using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to pad.
		         * @param {number} blockSize The multiple that the data should be padded to.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
		         */
		        pad: function (data, blockSize) {
		            // Shortcut
		            var blockSizeBytes = blockSize * 4;
	
		            // Count padding bytes
		            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		            // Create padding word
		            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;
	
		            // Create padding
		            var paddingWords = [];
		            for (var i = 0; i < nPaddingBytes; i += 4) {
		                paddingWords.push(paddingWord);
		            }
		            var padding = WordArray.create(paddingWords, nPaddingBytes);
	
		            // Add padding
		            data.concat(padding);
		        },
	
		        /**
		         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to unpad.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
		         */
		        unpad: function (data) {
		            // Get number of padding bytes from last byte
		            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		            // Remove padding
		            data.sigBytes -= nPaddingBytes;
		        }
		    };
	
		    /**
		     * Abstract base block cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
		     */
		    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Mode} mode The block mode to use. Default: CBC
		         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
		         */
		        cfg: Cipher.cfg.extend({
		            mode: CBC,
		            padding: Pkcs7
		        }),
	
		        reset: function () {
		            // Reset cipher
		            Cipher.reset.call(this);
	
		            // Shortcuts
		            var cfg = this.cfg;
		            var iv = cfg.iv;
		            var mode = cfg.mode;
	
		            // Reset block mode
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                var modeCreator = mode.createEncryptor;
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                var modeCreator = mode.createDecryptor;
		                // Keep at least one block in the buffer for unpadding
		                this._minBufferSize = 1;
		            }
	
		            if (this._mode && this._mode.__creator == modeCreator) {
		                this._mode.init(this, iv && iv.words);
		            } else {
		                this._mode = modeCreator.call(mode, this, iv && iv.words);
		                this._mode.__creator = modeCreator;
		            }
		        },
	
		        _doProcessBlock: function (words, offset) {
		            this._mode.processBlock(words, offset);
		        },
	
		        _doFinalize: function () {
		            // Shortcut
		            var padding = this.cfg.padding;
	
		            // Finalize
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                // Pad data
		                padding.pad(this._data, this.blockSize);
	
		                // Process final blocks
		                var finalProcessedBlocks = this._process(!!'flush');
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                // Process final blocks
		                var finalProcessedBlocks = this._process(!!'flush');
	
		                // Unpad data
		                padding.unpad(finalProcessedBlocks);
		            }
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 128/32
		    });
	
		    /**
		     * A collection of cipher parameters.
		     *
		     * @property {WordArray} ciphertext The raw ciphertext.
		     * @property {WordArray} key The key to this ciphertext.
		     * @property {WordArray} iv The IV used in the ciphering operation.
		     * @property {WordArray} salt The salt used with a key derivation function.
		     * @property {Cipher} algorithm The cipher algorithm.
		     * @property {Mode} mode The block mode used in the ciphering operation.
		     * @property {Padding} padding The padding scheme used in the ciphering operation.
		     * @property {number} blockSize The block size of the cipher.
		     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
		     */
		    var CipherParams = C_lib.CipherParams = Base.extend({
		        /**
		         * Initializes a newly created cipher params object.
		         *
		         * @param {Object} cipherParams An object with any of the possible cipher parameters.
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.lib.CipherParams.create({
		         *         ciphertext: ciphertextWordArray,
		         *         key: keyWordArray,
		         *         iv: ivWordArray,
		         *         salt: saltWordArray,
		         *         algorithm: CryptoJS.algo.AES,
		         *         mode: CryptoJS.mode.CBC,
		         *         padding: CryptoJS.pad.PKCS7,
		         *         blockSize: 4,
		         *         formatter: CryptoJS.format.OpenSSL
		         *     });
		         */
		        init: function (cipherParams) {
		            this.mixIn(cipherParams);
		        },
	
		        /**
		         * Converts this cipher params object to a string.
		         *
		         * @param {Format} formatter (Optional) The formatting strategy to use.
		         *
		         * @return {string} The stringified cipher params.
		         *
		         * @throws Error If neither the formatter nor the default formatter is set.
		         *
		         * @example
		         *
		         *     var string = cipherParams + '';
		         *     var string = cipherParams.toString();
		         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
		         */
		        toString: function (formatter) {
		            return (formatter || this.formatter).stringify(this);
		        }
		    });
	
		    /**
		     * Format namespace.
		     */
		    var C_format = C.format = {};
	
		    /**
		     * OpenSSL formatting strategy.
		     */
		    var OpenSSLFormatter = C_format.OpenSSL = {
		        /**
		         * Converts a cipher params object to an OpenSSL-compatible string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The OpenSSL-compatible string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            // Shortcuts
		            var ciphertext = cipherParams.ciphertext;
		            var salt = cipherParams.salt;
	
		            // Format
		            if (salt) {
		                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
		            } else {
		                var wordArray = ciphertext;
		            }
	
		            return wordArray.toString(Base64);
		        },
	
		        /**
		         * Converts an OpenSSL-compatible string to a cipher params object.
		         *
		         * @param {string} openSSLStr The OpenSSL-compatible string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
		         */
		        parse: function (openSSLStr) {
		            // Parse base64
		            var ciphertext = Base64.parse(openSSLStr);
	
		            // Shortcut
		            var ciphertextWords = ciphertext.words;
	
		            // Test for salt
		            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
		                // Extract salt
		                var salt = WordArray.create(ciphertextWords.slice(2, 4));
	
		                // Remove salt from ciphertext
		                ciphertextWords.splice(0, 4);
		                ciphertext.sigBytes -= 16;
		            }
	
		            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
		        }
		    };
	
		    /**
		     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
		     */
		    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
		         */
		        cfg: Base.extend({
		            format: OpenSSLFormatter
		        }),
	
		        /**
		         * Encrypts a message.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Encrypt
		            var encryptor = cipher.createEncryptor(key, cfg);
		            var ciphertext = encryptor.finalize(message);
	
		            // Shortcut
		            var cipherCfg = encryptor.cfg;
	
		            // Create and return serializable cipher params
		            return CipherParams.create({
		                ciphertext: ciphertext,
		                key: key,
		                iv: cipherCfg.iv,
		                algorithm: cipher,
		                mode: cipherCfg.mode,
		                padding: cipherCfg.padding,
		                blockSize: cipher.blockSize,
		                formatter: cfg.format
		            });
		        },
	
		        /**
		         * Decrypts serialized ciphertext.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Decrypt
		            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
	
		            return plaintext;
		        },
	
		        /**
		         * Converts serialized ciphertext to CipherParams,
		         * else assumed CipherParams already and returns ciphertext unchanged.
		         *
		         * @param {CipherParams|string} ciphertext The ciphertext.
		         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
		         *
		         * @return {CipherParams} The unserialized ciphertext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
		         */
		        _parse: function (ciphertext, format) {
		            if (typeof ciphertext == 'string') {
		                return format.parse(ciphertext, this);
		            } else {
		                return ciphertext;
		            }
		        }
		    });
	
		    /**
		     * Key derivation function namespace.
		     */
		    var C_kdf = C.kdf = {};
	
		    /**
		     * OpenSSL key derivation function.
		     */
		    var OpenSSLKdf = C_kdf.OpenSSL = {
		        /**
		         * Derives a key and IV from a password.
		         *
		         * @param {string} password The password to derive from.
		         * @param {number} keySize The size in words of the key to generate.
		         * @param {number} ivSize The size in words of the IV to generate.
		         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
		         *
		         * @return {CipherParams} A cipher params object with the key, IV, and salt.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
		         */
		        execute: function (password, keySize, ivSize, salt) {
		            // Generate random salt
		            if (!salt) {
		                salt = WordArray.random(64/8);
		            }
	
		            // Derive key and IV
		            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);
	
		            // Separate key and IV
		            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
		            key.sigBytes = keySize * 4;
	
		            // Return params
		            return CipherParams.create({ key: key, iv: iv, salt: salt });
		        }
		    };
	
		    /**
		     * A serializable cipher wrapper that derives the key from a password,
		     * and returns ciphertext as a serializable cipher params object.
		     */
		    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
		         */
		        cfg: SerializableCipher.cfg.extend({
		            kdf: OpenSSLKdf
		        }),
	
		        /**
		         * Encrypts a message using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Encrypt
		            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
	
		            // Mix in derived params
		            ciphertext.mixIn(derivedParams);
	
		            return ciphertext;
		        },
	
		        /**
		         * Decrypts serialized ciphertext using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Decrypt
		            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
	
		            return plaintext;
		        }
		    });
		}());
	
	
	}));

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher Feedback block mode.
		 */
		CryptoJS.mode.CFB = (function () {
		    var CFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    CFB.Encryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // Remember this block to use with next block
		            this._prevBlock = words.slice(offset, offset + blockSize);
		        }
		    });
	
		    CFB.Decryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            // Remember this block to use with next block
		            var thisBlock = words.slice(offset, offset + blockSize);
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // This block becomes the previous block
		            this._prevBlock = thisBlock;
		        }
		    });
	
		    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
		        // Shortcut
		        var iv = this._iv;
	
		        // Generate keystream
		        if (iv) {
		            var keystream = iv.slice(0);
	
		            // Remove IV for subsequent blocks
		            this._iv = undefined;
		        } else {
		            var keystream = this._prevBlock;
		        }
		        cipher.encryptBlock(keystream, 0);
	
		        // Encrypt
		        for (var i = 0; i < blockSize; i++) {
		            words[offset + i] ^= keystream[i];
		        }
		    }
	
		    return CFB;
		}());
	
	
		return CryptoJS.mode.CFB;
	
	}));

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Counter block mode.
		 */
		CryptoJS.mode.CTR = (function () {
		    var CTR = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = CTR.Encryptor = CTR.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Increment counter
		            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTR.Decryptor = Encryptor;
	
		    return CTR;
		}());
	
	
		return CryptoJS.mode.CTR;
	
	}));

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
		 * derived from CryptoJS.mode.CTR
		 * Jan Hruby jhruby.web@gmail.com
		 */
		CryptoJS.mode.CTRGladman = (function () {
		    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
	
			function incWord(word)
			{
				if (((word >> 24) & 0xff) === 0xff) { //overflow
				var b1 = (word >> 16)&0xff;
				var b2 = (word >> 8)&0xff;
				var b3 = word & 0xff;
	
				if (b1 === 0xff) // overflow b1
				{
				b1 = 0;
				if (b2 === 0xff)
				{
					b2 = 0;
					if (b3 === 0xff)
					{
						b3 = 0;
					}
					else
					{
						++b3;
					}
				}
				else
				{
					++b2;
				}
				}
				else
				{
				++b1;
				}
	
				word = 0;
				word += (b1 << 16);
				word += (b2 << 8);
				word += b3;
				}
				else
				{
				word += (0x01 << 24);
				}
				return word;
			}
	
			function incCounter(counter)
			{
				if ((counter[0] = incWord(counter[0])) === 0)
				{
					// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
					counter[1] = incWord(counter[1]);
				}
				return counter;
			}
	
		    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
	
					incCounter(counter);
	
					var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTRGladman.Decryptor = Encryptor;
	
		    return CTRGladman;
		}());
	
	
	
	
		return CryptoJS.mode.CTRGladman;
	
	}));

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Output Feedback block mode.
		 */
		CryptoJS.mode.OFB = (function () {
		    var OFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = OFB.Encryptor = OFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var keystream = this._keystream;
	
		            // Generate keystream
		            if (iv) {
		                keystream = this._keystream = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    OFB.Decryptor = Encryptor;
	
		    return OFB;
		}());
	
	
		return CryptoJS.mode.OFB;
	
	}));

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Electronic Codebook block mode.
		 */
		CryptoJS.mode.ECB = (function () {
		    var ECB = CryptoJS.lib.BlockCipherMode.extend();
	
		    ECB.Encryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.encryptBlock(words, offset);
		        }
		    });
	
		    ECB.Decryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.decryptBlock(words, offset);
		        }
		    });
	
		    return ECB;
		}());
	
	
		return CryptoJS.mode.ECB;
	
	}));

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ANSI X.923 padding strategy.
		 */
		CryptoJS.pad.AnsiX923 = {
		    pad: function (data, blockSize) {
		        // Shortcuts
		        var dataSigBytes = data.sigBytes;
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
	
		        // Compute last byte position
		        var lastBytePos = dataSigBytes + nPaddingBytes - 1;
	
		        // Pad
		        data.clamp();
		        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
		        data.sigBytes += nPaddingBytes;
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Ansix923;
	
	}));

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO 10126 padding strategy.
		 */
		CryptoJS.pad.Iso10126 = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		        // Pad
		        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
		             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Iso10126;
	
	}));

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO/IEC 9797-1 Padding Method 2.
		 */
		CryptoJS.pad.Iso97971 = {
		    pad: function (data, blockSize) {
		        // Add 0x80 byte
		        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));
	
		        // Zero pad the rest
		        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
		    },
	
		    unpad: function (data) {
		        // Remove zero padding
		        CryptoJS.pad.ZeroPadding.unpad(data);
	
		        // Remove one more byte -- the 0x80 byte
		        data.sigBytes--;
		    }
		};
	
	
		return CryptoJS.pad.Iso97971;
	
	}));

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Zero padding strategy.
		 */
		CryptoJS.pad.ZeroPadding = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Pad
		        data.clamp();
		        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
		    },
	
		    unpad: function (data) {
		        // Shortcut
		        var dataWords = data.words;
	
		        // Unpad
		        var i = data.sigBytes - 1;
		        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
		            i--;
		        }
		        data.sigBytes = i + 1;
		    }
		};
	
	
		return CryptoJS.pad.ZeroPadding;
	
	}));

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * A noop padding strategy.
		 */
		CryptoJS.pad.NoPadding = {
		    pad: function () {
		    },
	
		    unpad: function () {
		    }
		};
	
	
		return CryptoJS.pad.NoPadding;
	
	}));

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var CipherParams = C_lib.CipherParams;
		    var C_enc = C.enc;
		    var Hex = C_enc.Hex;
		    var C_format = C.format;
	
		    var HexFormatter = C_format.Hex = {
		        /**
		         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The hexadecimally encoded string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            return cipherParams.ciphertext.toString(Hex);
		        },
	
		        /**
		         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
		         *
		         * @param {string} input The hexadecimally encoded string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
		         */
		        parse: function (input) {
		            var ciphertext = Hex.parse(input);
		            return CipherParams.create({ ciphertext: ciphertext });
		        }
		    };
		}());
	
	
		return CryptoJS.format.Hex;
	
	}));

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(146), __webpack_require__(147), __webpack_require__(157), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Lookup tables
		    var SBOX = [];
		    var INV_SBOX = [];
		    var SUB_MIX_0 = [];
		    var SUB_MIX_1 = [];
		    var SUB_MIX_2 = [];
		    var SUB_MIX_3 = [];
		    var INV_SUB_MIX_0 = [];
		    var INV_SUB_MIX_1 = [];
		    var INV_SUB_MIX_2 = [];
		    var INV_SUB_MIX_3 = [];
	
		    // Compute lookup tables
		    (function () {
		        // Compute double table
		        var d = [];
		        for (var i = 0; i < 256; i++) {
		            if (i < 128) {
		                d[i] = i << 1;
		            } else {
		                d[i] = (i << 1) ^ 0x11b;
		            }
		        }
	
		        // Walk GF(2^8)
		        var x = 0;
		        var xi = 0;
		        for (var i = 0; i < 256; i++) {
		            // Compute sbox
		            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
		            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
		            SBOX[x] = sx;
		            INV_SBOX[sx] = x;
	
		            // Compute multiplication
		            var x2 = d[x];
		            var x4 = d[x2];
		            var x8 = d[x4];
	
		            // Compute sub bytes, mix columns tables
		            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
		            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
		            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
		            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
		            SUB_MIX_3[x] = t;
	
		            // Compute inv sub bytes, inv mix columns tables
		            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
		            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
		            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
		            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
		            INV_SUB_MIX_3[sx] = t;
	
		            // Compute next counter
		            if (!x) {
		                x = xi = 1;
		            } else {
		                x = x2 ^ d[d[d[x8 ^ x2]]];
		                xi ^= d[d[xi]];
		            }
		        }
		    }());
	
		    // Precomputed Rcon lookup
		    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	
		    /**
		     * AES block cipher algorithm.
		     */
		    var AES = C_algo.AES = BlockCipher.extend({
		        _doReset: function () {
		            // Skip reset of nRounds has been set before and key did not change
		            if (this._nRounds && this._keyPriorReset === this._key) {
		                return;
		            }
	
		            // Shortcuts
		            var key = this._keyPriorReset = this._key;
		            var keyWords = key.words;
		            var keySize = key.sigBytes / 4;
	
		            // Compute number of rounds
		            var nRounds = this._nRounds = keySize + 6;
	
		            // Compute number of key schedule rows
		            var ksRows = (nRounds + 1) * 4;
	
		            // Compute key schedule
		            var keySchedule = this._keySchedule = [];
		            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
		                if (ksRow < keySize) {
		                    keySchedule[ksRow] = keyWords[ksRow];
		                } else {
		                    var t = keySchedule[ksRow - 1];
	
		                    if (!(ksRow % keySize)) {
		                        // Rot word
		                        t = (t << 8) | (t >>> 24);
	
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	
		                        // Mix Rcon
		                        t ^= RCON[(ksRow / keySize) | 0] << 24;
		                    } else if (keySize > 6 && ksRow % keySize == 4) {
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
		                    }
	
		                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
		                }
		            }
	
		            // Compute inv key schedule
		            var invKeySchedule = this._invKeySchedule = [];
		            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
		                var ksRow = ksRows - invKsRow;
	
		                if (invKsRow % 4) {
		                    var t = keySchedule[ksRow];
		                } else {
		                    var t = keySchedule[ksRow - 4];
		                }
	
		                if (invKsRow < 4 || ksRow <= 4) {
		                    invKeySchedule[invKsRow] = t;
		                } else {
		                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
		                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
		                }
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
		        },
	
		        decryptBlock: function (M, offset) {
		            // Swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
	
		            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
	
		            // Inv swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
		        },
	
		        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
		            // Shortcut
		            var nRounds = this._nRounds;
	
		            // Get input, add round key
		            var s0 = M[offset]     ^ keySchedule[0];
		            var s1 = M[offset + 1] ^ keySchedule[1];
		            var s2 = M[offset + 2] ^ keySchedule[2];
		            var s3 = M[offset + 3] ^ keySchedule[3];
	
		            // Key schedule row counter
		            var ksRow = 4;
	
		            // Rounds
		            for (var round = 1; round < nRounds; round++) {
		                // Shift rows, sub bytes, mix columns, add round key
		                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
		                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
		                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
		                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
	
		                // Update state
		                s0 = t0;
		                s1 = t1;
		                s2 = t2;
		                s3 = t3;
		            }
	
		            // Shift rows, sub bytes, add round key
		            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
		            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
		            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
		            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	
		            // Set output
		            M[offset]     = t0;
		            M[offset + 1] = t1;
		            M[offset + 2] = t2;
		            M[offset + 3] = t3;
		        },
	
		        keySize: 256/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
		     */
		    C.AES = BlockCipher._createHelper(AES);
		}());
	
	
		return CryptoJS.AES;
	
	}));

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(146), __webpack_require__(147), __webpack_require__(157), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Permuted Choice 1 constants
		    var PC1 = [
		        57, 49, 41, 33, 25, 17, 9,  1,
		        58, 50, 42, 34, 26, 18, 10, 2,
		        59, 51, 43, 35, 27, 19, 11, 3,
		        60, 52, 44, 36, 63, 55, 47, 39,
		        31, 23, 15, 7,  62, 54, 46, 38,
		        30, 22, 14, 6,  61, 53, 45, 37,
		        29, 21, 13, 5,  28, 20, 12, 4
		    ];
	
		    // Permuted Choice 2 constants
		    var PC2 = [
		        14, 17, 11, 24, 1,  5,
		        3,  28, 15, 6,  21, 10,
		        23, 19, 12, 4,  26, 8,
		        16, 7,  27, 20, 13, 2,
		        41, 52, 31, 37, 47, 55,
		        30, 40, 51, 45, 33, 48,
		        44, 49, 39, 56, 34, 53,
		        46, 42, 50, 36, 29, 32
		    ];
	
		    // Cumulative bit shift constants
		    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];
	
		    // SBOXes and round permutation constants
		    var SBOX_P = [
		        {
		            0x0: 0x808200,
		            0x10000000: 0x8000,
		            0x20000000: 0x808002,
		            0x30000000: 0x2,
		            0x40000000: 0x200,
		            0x50000000: 0x808202,
		            0x60000000: 0x800202,
		            0x70000000: 0x800000,
		            0x80000000: 0x202,
		            0x90000000: 0x800200,
		            0xa0000000: 0x8200,
		            0xb0000000: 0x808000,
		            0xc0000000: 0x8002,
		            0xd0000000: 0x800002,
		            0xe0000000: 0x0,
		            0xf0000000: 0x8202,
		            0x8000000: 0x0,
		            0x18000000: 0x808202,
		            0x28000000: 0x8202,
		            0x38000000: 0x8000,
		            0x48000000: 0x808200,
		            0x58000000: 0x200,
		            0x68000000: 0x808002,
		            0x78000000: 0x2,
		            0x88000000: 0x800200,
		            0x98000000: 0x8200,
		            0xa8000000: 0x808000,
		            0xb8000000: 0x800202,
		            0xc8000000: 0x800002,
		            0xd8000000: 0x8002,
		            0xe8000000: 0x202,
		            0xf8000000: 0x800000,
		            0x1: 0x8000,
		            0x10000001: 0x2,
		            0x20000001: 0x808200,
		            0x30000001: 0x800000,
		            0x40000001: 0x808002,
		            0x50000001: 0x8200,
		            0x60000001: 0x200,
		            0x70000001: 0x800202,
		            0x80000001: 0x808202,
		            0x90000001: 0x808000,
		            0xa0000001: 0x800002,
		            0xb0000001: 0x8202,
		            0xc0000001: 0x202,
		            0xd0000001: 0x800200,
		            0xe0000001: 0x8002,
		            0xf0000001: 0x0,
		            0x8000001: 0x808202,
		            0x18000001: 0x808000,
		            0x28000001: 0x800000,
		            0x38000001: 0x200,
		            0x48000001: 0x8000,
		            0x58000001: 0x800002,
		            0x68000001: 0x2,
		            0x78000001: 0x8202,
		            0x88000001: 0x8002,
		            0x98000001: 0x800202,
		            0xa8000001: 0x202,
		            0xb8000001: 0x808200,
		            0xc8000001: 0x800200,
		            0xd8000001: 0x0,
		            0xe8000001: 0x8200,
		            0xf8000001: 0x808002
		        },
		        {
		            0x0: 0x40084010,
		            0x1000000: 0x4000,
		            0x2000000: 0x80000,
		            0x3000000: 0x40080010,
		            0x4000000: 0x40000010,
		            0x5000000: 0x40084000,
		            0x6000000: 0x40004000,
		            0x7000000: 0x10,
		            0x8000000: 0x84000,
		            0x9000000: 0x40004010,
		            0xa000000: 0x40000000,
		            0xb000000: 0x84010,
		            0xc000000: 0x80010,
		            0xd000000: 0x0,
		            0xe000000: 0x4010,
		            0xf000000: 0x40080000,
		            0x800000: 0x40004000,
		            0x1800000: 0x84010,
		            0x2800000: 0x10,
		            0x3800000: 0x40004010,
		            0x4800000: 0x40084010,
		            0x5800000: 0x40000000,
		            0x6800000: 0x80000,
		            0x7800000: 0x40080010,
		            0x8800000: 0x80010,
		            0x9800000: 0x0,
		            0xa800000: 0x4000,
		            0xb800000: 0x40080000,
		            0xc800000: 0x40000010,
		            0xd800000: 0x84000,
		            0xe800000: 0x40084000,
		            0xf800000: 0x4010,
		            0x10000000: 0x0,
		            0x11000000: 0x40080010,
		            0x12000000: 0x40004010,
		            0x13000000: 0x40084000,
		            0x14000000: 0x40080000,
		            0x15000000: 0x10,
		            0x16000000: 0x84010,
		            0x17000000: 0x4000,
		            0x18000000: 0x4010,
		            0x19000000: 0x80000,
		            0x1a000000: 0x80010,
		            0x1b000000: 0x40000010,
		            0x1c000000: 0x84000,
		            0x1d000000: 0x40004000,
		            0x1e000000: 0x40000000,
		            0x1f000000: 0x40084010,
		            0x10800000: 0x84010,
		            0x11800000: 0x80000,
		            0x12800000: 0x40080000,
		            0x13800000: 0x4000,
		            0x14800000: 0x40004000,
		            0x15800000: 0x40084010,
		            0x16800000: 0x10,
		            0x17800000: 0x40000000,
		            0x18800000: 0x40084000,
		            0x19800000: 0x40000010,
		            0x1a800000: 0x40004010,
		            0x1b800000: 0x80010,
		            0x1c800000: 0x0,
		            0x1d800000: 0x4010,
		            0x1e800000: 0x40080010,
		            0x1f800000: 0x84000
		        },
		        {
		            0x0: 0x104,
		            0x100000: 0x0,
		            0x200000: 0x4000100,
		            0x300000: 0x10104,
		            0x400000: 0x10004,
		            0x500000: 0x4000004,
		            0x600000: 0x4010104,
		            0x700000: 0x4010000,
		            0x800000: 0x4000000,
		            0x900000: 0x4010100,
		            0xa00000: 0x10100,
		            0xb00000: 0x4010004,
		            0xc00000: 0x4000104,
		            0xd00000: 0x10000,
		            0xe00000: 0x4,
		            0xf00000: 0x100,
		            0x80000: 0x4010100,
		            0x180000: 0x4010004,
		            0x280000: 0x0,
		            0x380000: 0x4000100,
		            0x480000: 0x4000004,
		            0x580000: 0x10000,
		            0x680000: 0x10004,
		            0x780000: 0x104,
		            0x880000: 0x4,
		            0x980000: 0x100,
		            0xa80000: 0x4010000,
		            0xb80000: 0x10104,
		            0xc80000: 0x10100,
		            0xd80000: 0x4000104,
		            0xe80000: 0x4010104,
		            0xf80000: 0x4000000,
		            0x1000000: 0x4010100,
		            0x1100000: 0x10004,
		            0x1200000: 0x10000,
		            0x1300000: 0x4000100,
		            0x1400000: 0x100,
		            0x1500000: 0x4010104,
		            0x1600000: 0x4000004,
		            0x1700000: 0x0,
		            0x1800000: 0x4000104,
		            0x1900000: 0x4000000,
		            0x1a00000: 0x4,
		            0x1b00000: 0x10100,
		            0x1c00000: 0x4010000,
		            0x1d00000: 0x104,
		            0x1e00000: 0x10104,
		            0x1f00000: 0x4010004,
		            0x1080000: 0x4000000,
		            0x1180000: 0x104,
		            0x1280000: 0x4010100,
		            0x1380000: 0x0,
		            0x1480000: 0x10004,
		            0x1580000: 0x4000100,
		            0x1680000: 0x100,
		            0x1780000: 0x4010004,
		            0x1880000: 0x10000,
		            0x1980000: 0x4010104,
		            0x1a80000: 0x10104,
		            0x1b80000: 0x4000004,
		            0x1c80000: 0x4000104,
		            0x1d80000: 0x4010000,
		            0x1e80000: 0x4,
		            0x1f80000: 0x10100
		        },
		        {
		            0x0: 0x80401000,
		            0x10000: 0x80001040,
		            0x20000: 0x401040,
		            0x30000: 0x80400000,
		            0x40000: 0x0,
		            0x50000: 0x401000,
		            0x60000: 0x80000040,
		            0x70000: 0x400040,
		            0x80000: 0x80000000,
		            0x90000: 0x400000,
		            0xa0000: 0x40,
		            0xb0000: 0x80001000,
		            0xc0000: 0x80400040,
		            0xd0000: 0x1040,
		            0xe0000: 0x1000,
		            0xf0000: 0x80401040,
		            0x8000: 0x80001040,
		            0x18000: 0x40,
		            0x28000: 0x80400040,
		            0x38000: 0x80001000,
		            0x48000: 0x401000,
		            0x58000: 0x80401040,
		            0x68000: 0x0,
		            0x78000: 0x80400000,
		            0x88000: 0x1000,
		            0x98000: 0x80401000,
		            0xa8000: 0x400000,
		            0xb8000: 0x1040,
		            0xc8000: 0x80000000,
		            0xd8000: 0x400040,
		            0xe8000: 0x401040,
		            0xf8000: 0x80000040,
		            0x100000: 0x400040,
		            0x110000: 0x401000,
		            0x120000: 0x80000040,
		            0x130000: 0x0,
		            0x140000: 0x1040,
		            0x150000: 0x80400040,
		            0x160000: 0x80401000,
		            0x170000: 0x80001040,
		            0x180000: 0x80401040,
		            0x190000: 0x80000000,
		            0x1a0000: 0x80400000,
		            0x1b0000: 0x401040,
		            0x1c0000: 0x80001000,
		            0x1d0000: 0x400000,
		            0x1e0000: 0x40,
		            0x1f0000: 0x1000,
		            0x108000: 0x80400000,
		            0x118000: 0x80401040,
		            0x128000: 0x0,
		            0x138000: 0x401000,
		            0x148000: 0x400040,
		            0x158000: 0x80000000,
		            0x168000: 0x80001040,
		            0x178000: 0x40,
		            0x188000: 0x80000040,
		            0x198000: 0x1000,
		            0x1a8000: 0x80001000,
		            0x1b8000: 0x80400040,
		            0x1c8000: 0x1040,
		            0x1d8000: 0x80401000,
		            0x1e8000: 0x400000,
		            0x1f8000: 0x401040
		        },
		        {
		            0x0: 0x80,
		            0x1000: 0x1040000,
		            0x2000: 0x40000,
		            0x3000: 0x20000000,
		            0x4000: 0x20040080,
		            0x5000: 0x1000080,
		            0x6000: 0x21000080,
		            0x7000: 0x40080,
		            0x8000: 0x1000000,
		            0x9000: 0x20040000,
		            0xa000: 0x20000080,
		            0xb000: 0x21040080,
		            0xc000: 0x21040000,
		            0xd000: 0x0,
		            0xe000: 0x1040080,
		            0xf000: 0x21000000,
		            0x800: 0x1040080,
		            0x1800: 0x21000080,
		            0x2800: 0x80,
		            0x3800: 0x1040000,
		            0x4800: 0x40000,
		            0x5800: 0x20040080,
		            0x6800: 0x21040000,
		            0x7800: 0x20000000,
		            0x8800: 0x20040000,
		            0x9800: 0x0,
		            0xa800: 0x21040080,
		            0xb800: 0x1000080,
		            0xc800: 0x20000080,
		            0xd800: 0x21000000,
		            0xe800: 0x1000000,
		            0xf800: 0x40080,
		            0x10000: 0x40000,
		            0x11000: 0x80,
		            0x12000: 0x20000000,
		            0x13000: 0x21000080,
		            0x14000: 0x1000080,
		            0x15000: 0x21040000,
		            0x16000: 0x20040080,
		            0x17000: 0x1000000,
		            0x18000: 0x21040080,
		            0x19000: 0x21000000,
		            0x1a000: 0x1040000,
		            0x1b000: 0x20040000,
		            0x1c000: 0x40080,
		            0x1d000: 0x20000080,
		            0x1e000: 0x0,
		            0x1f000: 0x1040080,
		            0x10800: 0x21000080,
		            0x11800: 0x1000000,
		            0x12800: 0x1040000,
		            0x13800: 0x20040080,
		            0x14800: 0x20000000,
		            0x15800: 0x1040080,
		            0x16800: 0x80,
		            0x17800: 0x21040000,
		            0x18800: 0x40080,
		            0x19800: 0x21040080,
		            0x1a800: 0x0,
		            0x1b800: 0x21000000,
		            0x1c800: 0x1000080,
		            0x1d800: 0x40000,
		            0x1e800: 0x20040000,
		            0x1f800: 0x20000080
		        },
		        {
		            0x0: 0x10000008,
		            0x100: 0x2000,
		            0x200: 0x10200000,
		            0x300: 0x10202008,
		            0x400: 0x10002000,
		            0x500: 0x200000,
		            0x600: 0x200008,
		            0x700: 0x10000000,
		            0x800: 0x0,
		            0x900: 0x10002008,
		            0xa00: 0x202000,
		            0xb00: 0x8,
		            0xc00: 0x10200008,
		            0xd00: 0x202008,
		            0xe00: 0x2008,
		            0xf00: 0x10202000,
		            0x80: 0x10200000,
		            0x180: 0x10202008,
		            0x280: 0x8,
		            0x380: 0x200000,
		            0x480: 0x202008,
		            0x580: 0x10000008,
		            0x680: 0x10002000,
		            0x780: 0x2008,
		            0x880: 0x200008,
		            0x980: 0x2000,
		            0xa80: 0x10002008,
		            0xb80: 0x10200008,
		            0xc80: 0x0,
		            0xd80: 0x10202000,
		            0xe80: 0x202000,
		            0xf80: 0x10000000,
		            0x1000: 0x10002000,
		            0x1100: 0x10200008,
		            0x1200: 0x10202008,
		            0x1300: 0x2008,
		            0x1400: 0x200000,
		            0x1500: 0x10000000,
		            0x1600: 0x10000008,
		            0x1700: 0x202000,
		            0x1800: 0x202008,
		            0x1900: 0x0,
		            0x1a00: 0x8,
		            0x1b00: 0x10200000,
		            0x1c00: 0x2000,
		            0x1d00: 0x10002008,
		            0x1e00: 0x10202000,
		            0x1f00: 0x200008,
		            0x1080: 0x8,
		            0x1180: 0x202000,
		            0x1280: 0x200000,
		            0x1380: 0x10000008,
		            0x1480: 0x10002000,
		            0x1580: 0x2008,
		            0x1680: 0x10202008,
		            0x1780: 0x10200000,
		            0x1880: 0x10202000,
		            0x1980: 0x10200008,
		            0x1a80: 0x2000,
		            0x1b80: 0x202008,
		            0x1c80: 0x200008,
		            0x1d80: 0x0,
		            0x1e80: 0x10000000,
		            0x1f80: 0x10002008
		        },
		        {
		            0x0: 0x100000,
		            0x10: 0x2000401,
		            0x20: 0x400,
		            0x30: 0x100401,
		            0x40: 0x2100401,
		            0x50: 0x0,
		            0x60: 0x1,
		            0x70: 0x2100001,
		            0x80: 0x2000400,
		            0x90: 0x100001,
		            0xa0: 0x2000001,
		            0xb0: 0x2100400,
		            0xc0: 0x2100000,
		            0xd0: 0x401,
		            0xe0: 0x100400,
		            0xf0: 0x2000000,
		            0x8: 0x2100001,
		            0x18: 0x0,
		            0x28: 0x2000401,
		            0x38: 0x2100400,
		            0x48: 0x100000,
		            0x58: 0x2000001,
		            0x68: 0x2000000,
		            0x78: 0x401,
		            0x88: 0x100401,
		            0x98: 0x2000400,
		            0xa8: 0x2100000,
		            0xb8: 0x100001,
		            0xc8: 0x400,
		            0xd8: 0x2100401,
		            0xe8: 0x1,
		            0xf8: 0x100400,
		            0x100: 0x2000000,
		            0x110: 0x100000,
		            0x120: 0x2000401,
		            0x130: 0x2100001,
		            0x140: 0x100001,
		            0x150: 0x2000400,
		            0x160: 0x2100400,
		            0x170: 0x100401,
		            0x180: 0x401,
		            0x190: 0x2100401,
		            0x1a0: 0x100400,
		            0x1b0: 0x1,
		            0x1c0: 0x0,
		            0x1d0: 0x2100000,
		            0x1e0: 0x2000001,
		            0x1f0: 0x400,
		            0x108: 0x100400,
		            0x118: 0x2000401,
		            0x128: 0x2100001,
		            0x138: 0x1,
		            0x148: 0x2000000,
		            0x158: 0x100000,
		            0x168: 0x401,
		            0x178: 0x2100400,
		            0x188: 0x2000001,
		            0x198: 0x2100000,
		            0x1a8: 0x0,
		            0x1b8: 0x2100401,
		            0x1c8: 0x100401,
		            0x1d8: 0x400,
		            0x1e8: 0x2000400,
		            0x1f8: 0x100001
		        },
		        {
		            0x0: 0x8000820,
		            0x1: 0x20000,
		            0x2: 0x8000000,
		            0x3: 0x20,
		            0x4: 0x20020,
		            0x5: 0x8020820,
		            0x6: 0x8020800,
		            0x7: 0x800,
		            0x8: 0x8020000,
		            0x9: 0x8000800,
		            0xa: 0x20800,
		            0xb: 0x8020020,
		            0xc: 0x820,
		            0xd: 0x0,
		            0xe: 0x8000020,
		            0xf: 0x20820,
		            0x80000000: 0x800,
		            0x80000001: 0x8020820,
		            0x80000002: 0x8000820,
		            0x80000003: 0x8000000,
		            0x80000004: 0x8020000,
		            0x80000005: 0x20800,
		            0x80000006: 0x20820,
		            0x80000007: 0x20,
		            0x80000008: 0x8000020,
		            0x80000009: 0x820,
		            0x8000000a: 0x20020,
		            0x8000000b: 0x8020800,
		            0x8000000c: 0x0,
		            0x8000000d: 0x8020020,
		            0x8000000e: 0x8000800,
		            0x8000000f: 0x20000,
		            0x10: 0x20820,
		            0x11: 0x8020800,
		            0x12: 0x20,
		            0x13: 0x800,
		            0x14: 0x8000800,
		            0x15: 0x8000020,
		            0x16: 0x8020020,
		            0x17: 0x20000,
		            0x18: 0x0,
		            0x19: 0x20020,
		            0x1a: 0x8020000,
		            0x1b: 0x8000820,
		            0x1c: 0x8020820,
		            0x1d: 0x20800,
		            0x1e: 0x820,
		            0x1f: 0x8000000,
		            0x80000010: 0x20000,
		            0x80000011: 0x800,
		            0x80000012: 0x8020020,
		            0x80000013: 0x20820,
		            0x80000014: 0x20,
		            0x80000015: 0x8020000,
		            0x80000016: 0x8000000,
		            0x80000017: 0x8000820,
		            0x80000018: 0x8020820,
		            0x80000019: 0x8000020,
		            0x8000001a: 0x8000800,
		            0x8000001b: 0x0,
		            0x8000001c: 0x20800,
		            0x8000001d: 0x820,
		            0x8000001e: 0x20020,
		            0x8000001f: 0x8020800
		        }
		    ];
	
		    // Masks that select the SBOX input
		    var SBOX_MASK = [
		        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
		        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
		    ];
	
		    /**
		     * DES block cipher algorithm.
		     */
		    var DES = C_algo.DES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
	
		            // Select 56 bits according to PC1
		            var keyBits = [];
		            for (var i = 0; i < 56; i++) {
		                var keyBitPos = PC1[i] - 1;
		                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
		            }
	
		            // Assemble 16 subkeys
		            var subKeys = this._subKeys = [];
		            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
		                // Create subkey
		                var subKey = subKeys[nSubKey] = [];
	
		                // Shortcut
		                var bitShift = BIT_SHIFTS[nSubKey];
	
		                // Select 48 bits according to PC2
		                for (var i = 0; i < 24; i++) {
		                    // Select from the left 28 key bits
		                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);
	
		                    // Select from the right 28 key bits
		                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
		                }
	
		                // Since each subkey is applied to an expanded 32-bit input,
		                // the subkey can be broken into 8 values scaled to 32-bits,
		                // which allows the key to be used without expansion
		                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
		                for (var i = 1; i < 7; i++) {
		                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
		                }
		                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
		            }
	
		            // Compute inverse subkeys
		            var invSubKeys = this._invSubKeys = [];
		            for (var i = 0; i < 16; i++) {
		                invSubKeys[i] = subKeys[15 - i];
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._subKeys);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._invSubKeys);
		        },
	
		        _doCryptBlock: function (M, offset, subKeys) {
		            // Get input
		            this._lBlock = M[offset];
		            this._rBlock = M[offset + 1];
	
		            // Initial permutation
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeLR.call(this, 1,  0x55555555);
	
		            // Rounds
		            for (var round = 0; round < 16; round++) {
		                // Shortcuts
		                var subKey = subKeys[round];
		                var lBlock = this._lBlock;
		                var rBlock = this._rBlock;
	
		                // Feistel function
		                var f = 0;
		                for (var i = 0; i < 8; i++) {
		                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
		                }
		                this._lBlock = rBlock;
		                this._rBlock = lBlock ^ f;
		            }
	
		            // Undo swap from last round
		            var t = this._lBlock;
		            this._lBlock = this._rBlock;
		            this._rBlock = t;
	
		            // Final permutation
		            exchangeLR.call(this, 1,  0x55555555);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
	
		            // Set output
		            M[offset] = this._lBlock;
		            M[offset + 1] = this._rBlock;
		        },
	
		        keySize: 64/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    // Swap bits across the left and right words
		    function exchangeLR(offset, mask) {
		        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
		        this._rBlock ^= t;
		        this._lBlock ^= t << offset;
		    }
	
		    function exchangeRL(offset, mask) {
		        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
		        this._lBlock ^= t;
		        this._rBlock ^= t << offset;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
		     */
		    C.DES = BlockCipher._createHelper(DES);
	
		    /**
		     * Triple-DES block cipher algorithm.
		     */
		    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
	
		            // Create DES instances
		            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
		            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
		            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
		        },
	
		        encryptBlock: function (M, offset) {
		            this._des1.encryptBlock(M, offset);
		            this._des2.decryptBlock(M, offset);
		            this._des3.encryptBlock(M, offset);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._des3.decryptBlock(M, offset);
		            this._des2.encryptBlock(M, offset);
		            this._des1.decryptBlock(M, offset);
		        },
	
		        keySize: 192/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
		     */
		    C.TripleDES = BlockCipher._createHelper(TripleDES);
		}());
	
	
		return CryptoJS.TripleDES;
	
	}));

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(146), __webpack_require__(147), __webpack_require__(157), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    /**
		     * RC4 stream cipher algorithm.
		     */
		    var RC4 = C_algo.RC4 = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
		            var keySigBytes = key.sigBytes;
	
		            // Init sbox
		            var S = this._S = [];
		            for (var i = 0; i < 256; i++) {
		                S[i] = i;
		            }
	
		            // Key setup
		            for (var i = 0, j = 0; i < 256; i++) {
		                var keyByteIndex = i % keySigBytes;
		                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;
	
		                j = (j + S[i] + keyByte) % 256;
	
		                // Swap
		                var t = S[i];
		                S[i] = S[j];
		                S[j] = t;
		            }
	
		            // Counters
		            this._i = this._j = 0;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            M[offset] ^= generateKeystreamWord.call(this);
		        },
	
		        keySize: 256/32,
	
		        ivSize: 0
		    });
	
		    function generateKeystreamWord() {
		        // Shortcuts
		        var S = this._S;
		        var i = this._i;
		        var j = this._j;
	
		        // Generate keystream word
		        var keystreamWord = 0;
		        for (var n = 0; n < 4; n++) {
		            i = (i + 1) % 256;
		            j = (j + S[i]) % 256;
	
		            // Swap
		            var t = S[i];
		            S[i] = S[j];
		            S[j] = t;
	
		            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
		        }
	
		        // Update counters
		        this._i = i;
		        this._j = j;
	
		        return keystreamWord;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4 = StreamCipher._createHelper(RC4);
	
		    /**
		     * Modified RC4 stream cipher algorithm.
		     */
		    var RC4Drop = C_algo.RC4Drop = RC4.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} drop The number of keystream words to drop. Default 192
		         */
		        cfg: RC4.cfg.extend({
		            drop: 192
		        }),
	
		        _doReset: function () {
		            RC4._doReset.call(this);
	
		            // Drop
		            for (var i = this.cfg.drop; i > 0; i--) {
		                generateKeystreamWord.call(this);
		            }
		        }
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
		}());
	
	
		return CryptoJS.RC4;
	
	}));

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(146), __webpack_require__(147), __webpack_require__(157), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm
		     */
		    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
		                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
		            }
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
		     */
		    C.Rabbit = StreamCipher._createHelper(Rabbit);
		}());
	
	
		return CryptoJS.Rabbit;
	
	}));

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(142), __webpack_require__(146), __webpack_require__(147), __webpack_require__(157), __webpack_require__(158));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm.
		     *
		     * This is a legacy version that neglected to convert the key to little-endian.
		     * This error doesn't affect the cipher's security,
		     * but it does affect its compatibility with other implementations.
		     */
		    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
		     */
		    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
		}());
	
	
		return CryptoJS.RabbitLegacy;
	
	}));

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	;(function () {
	    function Array_h(length) {
	        this.array = length === undefined ? [] : new Array(length);
	    }
	
	    Array_h.prototype = {
	        /**
	         * 返回数组长度
	         *
	         * @return {Number} length [数组长度]
	         */
	        length: function () {
	            return this.array.length;
	        },
	
	        at: function (index) {
	            return this.array[index];
	        },
	
	        set: function (index, obj) {
	            this.array[index] = obj;
	        },
	
	        /**
	         * 向数组的末尾添加一个或多个元素，并返回新的长度。
	         *
	         * @param  {*} obj [description]
	         * @return {Number} length [新数组的长度]
	         */
	        push: function (obj) {
	            return this.array.push(obj);
	        },
	
	        /**
	         * 返回数组中选定的元素
	         *
	         * @param  {Number} start [开始索引值]
	         * @param  {Number} end [结束索引值]
	         * @return {Array} newArray  [新的数组]
	         */
	        slice: function (start, end) {
	            return this.array = this.array.slice(start, end);
	        },
	
	        concat: function (array) {
	            this.array = this.array.concat(array);
	        },
	
	        remove: function (index, count) {
	            count = count === undefined ? 1 : count;
	            this.array.splice(index, count);
	        },
	
	        join: function (separator) {
	            return this.array.join(separator);
	        },
	
	        clear: function () {
	            this.array.length = 0;
	        }
	    };
	
	    /**
	     * 先进先出队列 (First Input First Output)
	     *
	     * 一种先进先出的数据缓存器
	     */
	    var Queue = function () {
	        this._array_h = new Array_h();
	    };
	
	    Queue.prototype = {
	        _index: 0,
	
	        /**
	         * 排队
	         *
	         * @param  {Object} obj [description]
	         * @return {[type]}     [description]
	         */
	        push: function (obj) {
	            this._array_h.push(obj);
	        },
	
	        /**
	         * 出队
	         *
	         * @return {Object} [description]
	         */
	        pop: function () {
	            var ret = null;
	            if (this._array_h.length()) {
	                ret = this._array_h.at(this._index);
	                if (++this._index * 2 >= this._array_h.length()) {
	                    this._array_h.slice(this._index);
	                    this._index = 0;
	                }
	            }
	            return ret;
	        },
	
	        /**
	         * 返回队列中头部(即最新添加的)的动态对象
	         *
	         * @return {Object} [description]
	         */
	        head: function () {
	            var ret = null, len = this._array_h.length();
	            if (len) {
	                ret = this._array_h.at(len - 1);
	            }
	            return ret;
	        },
	
	        /**
	         * 返回队列中尾部(即最早添加的)的动态对象
	         *
	         * @return {Object} [description]
	         */
	        tail: function () {
	            var ret = null, len = this._array_h.length();
	            if (len) {
	                ret = this._array_h.at(this._index);
	            }
	            return ret;
	        },
	
	        /**
	         * 返回数据队列长度
	         *
	         * @return {Number} [description]
	         */
	        length: function () {
	            return this._array_h.length() - this._index;
	        },
	
	        /**
	         * 队列是否为空
	         *
	         * @return {Boolean} [description]
	         */
	        empty: function () {
	            return (this._array_h.length() === 0);
	        },
	
	        clear: function () {
	            this._array_h.clear();
	        }
	    };
	    exports.Queue = Queue;
	}());


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
		loadingSvg: [
			"<div class=\"em-widget-loading\">",
			"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70 70\">",
			"<circle opacity=\".3\" fill=\"none\" stroke=\"#000\" stroke-width=\"4\" stroke-miterlimit=\"10\" cx=\"35\" cy=\"35\" r=\"11\"/>",
			"<path fill=\"none\" stroke=\"#E5E5E5\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" d=\"M24 35c0-6.1 4.9-11 11-11 2.8 0 5.3 1 7.3 2.8\"/>",
			"</svg>",
			"</div>"
		].join(""),
	
		agentStatusText: {
			Online: "(Online)",
			Busy: "(Busy)",
			Leave: "(Away)",
			Hidden: "(Invisible)",
			Idle: "(Offline)",
			Offline: "(Offline)",
			Logout: "(Offline)",
			Other: "",
		},
	
		eventMessageText: {
			NOTE: "Agent is offline. Please leave your contact info.",
			TICKET: "ticket",
		},
	
		SYSTEM_EVENT_MSG_TEXT: {
			ServiceSessionCreatedEvent: "Conversation is created",
			ServiceSessionOpenedEvent: "Conversation is opened",
			ServiceSessionTransferedToAgentQueueEvent: "Transferring. Please wait...",
			ServiceSessionTransferedEvent: "Conversation is transferred",
			ServiceSessionClosedEvent: "Conversation is closed",
		},
	
		SYSTEM_EVENT: {
			SESSION_CREATED: "ServiceSessionCreatedEvent",
			SESSION_OPENED: "ServiceSessionOpenedEvent",
			SESSION_CLOSED: "ServiceSessionClosedEvent",
			SESSION_ABORTED: "ServiceSessionAbortedEvent",
			SESSION_TRANSFERED: "ServiceSessionTransferedEvent",
			SESSION_TRANSFERING: "ServiceSessionTransferedToAgentQueueEvent",
	
			CUSTOMURL_DIALOG_SHOW: "customUrl.dialog.show",
	
			SESSION_RESTORED: "session.restored",
			SESSION_NOT_CREATED: "session.not.created",
			SESSION_ALREADY_CREATED: "session.already.created",
			CLEAR_TIMEOUT: "clear.answersGroup.timeout",
			STOP_TIMEOUT: "stop.answersGroup.timeout",
	
			SEND_MESSAGE: "send.message",
	
			AGENT_INFO_UPDATE: "agent.info.update",
			OFFICIAL_ACCOUNT_SWITCHED: "official.account.switched",
			NEW_OFFICIAL_ACCOUNT_FOUND: "new.official.account.found",
			SYSTEM_OFFICIAL_ACCOUNT_UPDATED: "system.official.account.updated",
			OFFICIAL_ACCOUNT_LIST_GOT: "official.account.list.got",
	
			MARKETING_MESSAGE_RECEIVED: "marketing.message.received",
			SATISFACTION_EVALUATION_MESSAGE_RECEIVED: "satisfaction.evaluation.message.received",
			MESSAGE_PROMPT: "message.prompt",
	
			CHAT_WINDOW_OPENED: "chat.window.opened",
			CHAT_WINDOW_CLOSED: "chat.window.closed",
	
			IM_CONNECTION_OPENED: "im.connection.opened",
	
			MESSAGE_SENT: "message.sent",
			MESSAGE_APPENDED: "message.appended",
	
			VIDEO_TICKET_RECEIVED: "video.ticket.received",
			VIDEO_ARGO_END: "video.argo.end", // 声网音视频结束的通知
			WHITE_BOARD_RECEIVED: "board.received", // 电子白板的通知
			MESSAGE_CHANNEL_READY: "message.channel.ready",
	
			CONSULT_AGENT: "consult.agent",
			ACCEPT_INVITATION: "accept_invitation",
	
			// 关闭 会话聊天框
			CHAT_CLOSED: "chat.closed",
	
			// 清除agentState定时器
			CLEAR_AGENTSTATE: "clear.agentstate",
			// 清除agentState定时器
			CLEAR_AGENTINPUTSTATE: "clear.agentinputstate",
			// 判断是否调用历史消息
			IS_PULL_HISTORY: "is.pull.history"
	
		},
	
		themeMap: {
			theme_sky: "theme-1",
			theme_tree: "theme-2",
			theme_house: "theme-3",
			theme_orange: "theme-4",
			theme_grass: "theme-5",
			theme_sea: "theme-6",
			theme_mountion: "theme-7",
			theme_moon: "theme-8",
			theme_lake: "theme-9",
			theme_business: "theme-10",
			theme_cherry: "theme-11",
			theme_science: "theme-12",
			theme_custom: "theme_custom",
			天空之城: "theme-1",
			丛林物语: "theme-2",
			红瓦洋房: "theme-3",
			鲜美橙汁: "theme-4",
			青草田间: "theme-5",
			湖光山色: "theme-6",
			冷峻山峰: "theme-7",
			月色池塘: "theme-8",
			天籁湖光: "theme-9",
			商务风格: "theme-10",
			烂漫樱花: "theme-11",
			蔚蓝科技: "theme-12",
			自定义主题: "theme_custom",
			Sky: "theme-1",
			Tree: "theme-2",
			House: "theme-3",
			Orange: "theme-4",
			Grass: "theme-5",
			Sea: "theme-6",
			Mountain: "theme-7",
			Moon: "theme-8",
			Lake: "theme-9",
			Business: "theme-10",
			Cherry: "theme-11",
			Science: "theme-12",
			Custom: "theme_custom",
		},
	
		IM: {
			WEBIM_CONNCTION_OPEN_ERROR: 1,
			WEBIM_CONNCTION_AUTH_ERROR: 2,
			WEBIM_CONNCTION_AJAX_ERROR: 17,
			WEBIM_CONNCTION_CALLBACK_INNER_ERROR: 31
		},
	
		// todo: 分离这部分代码
		EVENTS: {
			NOTIFY: "notify",
			RECOVERY: "recoveryTitle",
			SHOW: "showChat",
			CLOSE: "closeChat",
			CACHEUSER: "setUser",
			DRAGREADY: "dragReady",
			DRAGEND: "dragEnd",
			SLIDE: "titleSlide",
			ONMESSAGE: "onMessage",
			ONSESSIONCLOSED: "onSessionClosed",
			ONSESSIONCREAT: "ONSESSIONCREAT",
			ONBAOZICALLBACK: "ONBAOZICALLBACK",
			EXT: "ext",
			TEXTMSG: "textmsg",
			ONREADY: "onready",
			ON_OFFDUTY: "onOffDuty",
			SET_ITEM: "setItem",
			UPDATE_URL: "updateURL",
			REQUIRE_URL: "requireURL",
			INIT_CONFIG: "initConfig",
			SHOW_IMG: "showIMG",
			RESIZE_IFRAME: "resizeIframe",
			ADD_PROMPT: "add.prompt",
			REMOVE_PROMPT: "remove.prompt",
			SCROLL_TO_BOTTOM: "scroll.to.bottom",
			INVITATION_INIT: "invitation_init",
			REOPEN: "reopen",
			HIDE_DEFAULT_BTN: "hideDefaultBtn",
			EVALUATIONSUBMIT: "evaluation_submit"
		},
	
		ERROR_MSG: {
			VISITOR_DOES_NOT_EXIST: "visitor does not exist.",
			SESSION_DOES_NOT_EXIST: "session does not exist.",
		},
	
		SESSION_STATE: {
			WAIT: "Wait",
			PROCESSING: "Processing",
			TERMINAL: "Terminal",
			ABORT: "Abort",
			RESOLVED: "Resolved",
			PREPARE: "Prepare"
		},
	
		AGENT_ROLE: {
			AGENT: 1,
			ROBOT: 6,
		},
	
		STREAM_TYPE: {
			NORMAL: 0,
			NO_AUDIO: 1,
		},
	
		// 上传文件大小限制
		UPLOAD_FILESIZE_LIMIT: 1024 * 1024 * 10,
	
		// 超时未收到 kefu-ack 启用第二通道发消息
		FIRST_CHANNEL_MESSAGE_TIMEOUT: 2000,
	
		// 发送图片时 超时未收到 kefu-ack 启用第二通道发消息
		FIRST_CHANNEL_IMG_MESSAGE_TIMEOUT: 15000,
	
		// 发送消息第二通道失败后，最多再试1次
		SECOND_MESSAGE_CHANNEL_MAX_RETRY_COUNT: 1,
	
		// 如果im连接超时后启用第二通道
		FIRST_CHANNEL_CONNECTION_TIMEOUT: 20000,
	
		// IM心跳时间间隔
		HEART_BEAT_INTERVAL: 60000,
	
		// 第二通道收消息轮询时间间隔
		SECOND_CHANNEL_MESSAGE_RECEIVE_INTERVAL: 20000,
	
		// 消息预知功能截断长度
		MESSAGE_PREDICT_MAX_LENGTH: 100,
	
		// 最大文本消息长度
		MAX_TEXT_MESSAGE_LENGTH: 1500,
	
		// 每次拉取历史消息条数
		GET_HISTORY_MESSAGE_COUNT_EACH_TIME: 10,
	
		// 轮询坐席输入状态间隔
		AGENT_INPUT_STATE_INTERVAL: 1000,
	
		// 消息时间戳最小间隔
		MESSAGE_TIME_SPAN_INTERVAL: 300000,
	
		E_MEDIA_SDK_ERROR_CODE_MAP: {
			0: "Normal exit.",
			1: "No response.",
			2: "The other side refused.",
			3: "The other side is busy.",
			4: "Server refused.",
			5: "Unsupported.",
			10: "Log in on other devices.",
			11: "The conference is closed.",
		},
	
		EMOJI_PATH:  false ? "static/img/faces/" : "../static/img/faces/",
	
		EMOJI_MAP: {
			"[):]": "ee_1.png",
			"[:D]": "ee_2.png",
			"[;)]": "ee_3.png",
			"[:-o]": "ee_4.png",
			"[:p]": "ee_5.png",
			"[(H)]": "ee_6.png",
			"[:@]": "ee_7.png",
			"[:s]": "ee_8.png",
			"[:$]": "ee_9.png",
			"[:(]": "ee_10.png",
			"[:'(]": "ee_11.png",
			"[:|]": "ee_12.png",
			"[(a)]": "ee_13.png",
			// "[8o|]": "ee_14.png",
			"[8-|]": "ee_15.png",
			// "[+o(]": "ee_16.png",
			"[<o)]": "ee_17.png",
			"[|-)]": "ee_18.png",
			"[*-)]": "ee_19.png",
			"[:-#]": "ee_20.png",
			"[:-*]": "ee_21.png",
			// "[^o)]": "ee_22.png",
			"[8-)]": "ee_23.png",
			"[(|)]": "ee_24.png",
			"[(u)]": "ee_25.png",
			"[(S)]": "ee_26.png",
			"[(*)]": "ee_27.png",
			"[(#)]": "ee_28.png",
			"[(R)]": "ee_29.png",
			"[({)]": "ee_30.png",
			"[(})]": "ee_31.png",
			"[(k)]": "ee_32.png",
			"[(F)]": "ee_33.png",
			"[(W)]": "ee_34.png",
			"[(D)]": "ee_35.png",
		},
	
		SELFSERVICE_PATH:  false ? "static/img/selfServiceIcon/" : "../static/img/selfServiceIcon/",
	
	};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var config = {};
	
	function h5_mode_init(){
		config = {};
		config.tenantId = utils.query("tenantId");
		config.configId = utils.query("configId");
		config.offDutyType = utils.query("offDutyType");
		config.grUserId = utils.query("grUserId");
		config.domain = utils.query("domain") ? "//" + utils.query("domain") : "";
	
		// H5 方式集成时不支持eventCollector配置
		config.to = utils.convertFalse(utils.query("to"));
		config.xmppServer = utils.convertFalse(utils.query("xmppServer"));
		config.restServer = utils.convertFalse(utils.query("restServer"));
		config.agentName = utils.convertFalse(utils.query("agentName"));
		config.resources = utils.convertFalse(utils.query("resources"));
		config.hideStatus = utils.convertFalse(utils.query("hideStatus"));
		config.satisfaction = utils.convertFalse(utils.query("sat"));
		config.wechatAuth = utils.convertFalse(utils.query("wechatAuth"));
		config.hideKeyboard = utils.convertFalse(utils.query("hideKeyboard"));
	
		config.appKey = utils.convertFalse(decodeURIComponent(utils.query("appKey")));
		config.domain = config.domain || "//" + location.host;
		config.offDutyWord = decodeURIComponent(utils.query("offDutyWord"));
		config.ticket = utils.query("ticket") === "" ? true : utils.convertFalse(utils.query("ticket")); // true default
		config.emgroup = decodeURIComponent(utils.query("emgroup"));
	
		config.user = {};
		config.configOption = {};
		var usernameFromUrl = utils.query("user");
	
		var usernameFromCookie = utils.get("root" + (config.configId || (config.tenantId + config.emgroup)));
		// var userNickname = utils.get(usernameFromCookie);
	
		if(usernameFromUrl){
			config.user.username = usernameFromUrl;
		}
		else if(usernameFromCookie){
			config.user.username = usernameFromCookie;
			// config.user.userNickname = userNickname;
			config.isUsernameFromCookie = true;
		}
		else{}
	
		// fake transfer
		window.transfer = {
			send: function(){}
		};
	}
	
	
	function handleConfig(configJson){
		if(!configJson.options){
			configJson.options = {};
		}
		config.tenantId = configJson.tenantId;
		window.sessionStorage && sessionStorage.setItem("white_tenantId", config.tenantId);
		// todo: 把配置转换为新的
		// 用于config标记是否是来自于坐席端网页配置
		config.isWebChannelConfig = true;
	
		config.configName = configJson.configName;
		config.channel = configJson.channel;
		config.ui = configJson.ui;
		config.toolbar = configJson.toolbar;
		config.chat = configJson.chat;
	
		config.appKey = configJson.channel.appKey;
		config.to = configJson.channel.to;
		// config.agentName = configJson.channel.agentName;
		config.emgroup = config.emgroup || configJson.channel.emgroup;
	
		// config.buttonText = configJson.ui.buttonText;
		// config.dialogHeight = configJson.ui.dialogHeight;
		// config.dialogWidth = configJson.ui.dialogWidth;
		// config.dialogPosition = configJson.ui.dialogPosition;
		config.dragenable = configJson.ui.dragenable;
		config.hide = configJson.ui.hide;
		config.logo = configJson.ui.logo;
		config.notice = configJson.ui.notice;
		config.themeName = configJson.ui.themeName;
	
		if(config.themeName && config.themeName.indexOf("theme_custom") > -1){
			var arr = config.themeName.split("theme_custom"); 
			var color = arr[1];
			config.themeCustomColor = color;
		}
		else{
			config.themeCustomColor = "";
		}
	
		config.autoConnect = configJson.toolbar.autoConnect;
		// config.hideKeyboard = configJson.toolbar.hideKeyboard;
		config.minimum = configJson.toolbar.minimum;
		config.offDutyWord = configJson.toolbar.offDutyWord;
		config.offDutyType = configJson.toolbar.offDutyType;
		config.popupOnInitialized = configJson.toolbar.popupOnInitialized;
		config.satisfaction = configJson.toolbar.satisfaction;
		config.soundReminder = configJson.toolbar.soundReminder;
		config.sendSmallVideo = configJson.toolbar.sendSmallVideo;
		config.ticket = configJson.toolbar.ticket;
	
		config.resources = configJson.chat.resources;
		config.hideStatus = configJson.chat.hideStatus;
		config.timeScheduleId = configJson.chat.timeScheduleId || 0;
		config.options = configJson.options;
		config.videoH5Status = "";
		config.pageState = true;
	
	}
	
	function setConfig(extendConfig){
		config = _.extend({}, config, extendConfig);
	}
	
	function getConfig(){
		return JSON.parse(JSON.stringify(config));
	}
	
	module.exports = {
		getConfig: getConfig,
		h5_mode_init: h5_mode_init,
		handleConfig: handleConfig,
		setConfig: setConfig,
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var Dict = __webpack_require__(179);
	
	var profile = {
		imToken: null,
		imRestDown: false,
		ctaEnable: false,
		systemAgentAvatar: null,
		isChatWindowOpen: null,
		isAgentNicknameEnable: null,
		currentBrowsingURL: null,
		isInOfficeHours: false,
		// 用来缓存图片的file对象，用于全屏查看图片
		imgFileList: new Dict(),
		hasHumanAgentOnline: false,
		hasRobotAgentOnline: false,
		officialAccountList: [],
		tenantAvatar: null,
		defaultAvatar: null,
		currentOfficialAccount: {},
		systemOfficialAccount: {},
		isNoLink:null,
		isHideBtn:false,
		// systemOfficialAccount 相关方法
		shouldMsgActivated: function(curSSID){
			if(typeof curSSID !== "string"){
				return true;
			}
			var isCurSSOpen = this.systemOfficialAccount.isSessionOpen;
			var isSameSSID = this.systemOfficialAccount.sessionId === curSSID;
			return isCurSSOpen && isSameSSID;
		},
	};
	
	module.exports = profile;


/***/ }),
/* 179 */
/***/ (function(module, exports) {

	var Dict;
	
	module.exports = Dict = function(){
		this.map = {};
	};
	
	Dict.prototype.set = function(key, value){
		// todo: new value overwrite old value
		!this.has(key) && (this.map[key] = value);
	};
	
	Dict.prototype.has = function(key){
		return Object.prototype.hasOwnProperty.call(this.map, key);
	};
	
	Dict.prototype.get = function(key){
		return this.has(key)
			? this.map[key]
			: undefined;
	};
	
	Dict.prototype.remove = function(key){
		this.has(key) && delete this.map[key];
	};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	// prompt 不会消失
	// tip 2秒后自动消失
	
	// todo: 拆分这个文件，把 dialog 拆出去
	var utils = __webpack_require__(16);
	
	var EMPTY_FUNCTION = function(){};
	var promptDom;
	var promptTextSpanDom;
	
	var _initPrompt = _.once(function(){
		promptDom = document.querySelector(".em-widget-error-prompt");
		promptTextSpanDom = promptDom.querySelector("span");
	});
	
	module.exports = {
		prompt: _showPrompt,
		tip: tip,
		createDialog: _createDialog,
		showSuccess: showSuccess
	};
	
	function _showPrompt(msg){
		_initPrompt();
		promptTextSpanDom.innerText = msg;
		utils.removeClass(promptDom, "hide");
	}
	
	function _hidePrompt(){
		utils.addClass(promptDom, "hide");
	}
	
	function tip(msg){
		_initPrompt();
		_showPrompt(msg);
		setTimeout(_hidePrompt, 2000);
	}
	
	function _createDialog(options){
		var opt = options || {};
		var className = opt.className;
		var contentDom = opt.contentDom;
		var isFullSreen = opt.isFullSreen || false;
		var el = utils.createElementFromHTML("<div class=\"em-dialog hide\"></div>");
		var cancelBtn;
		var confirmBtn;
		var cancel;
		var confirm;
		// 增加适配全屏的dialog
		if(isFullSreen){
			var widgetWrapper = document.querySelector("body");
		}
		else{
			var widgetWrapper = document.querySelector(".em-widget-wrapper");
		}
	
		className && utils.addClass(el, className);
		if(typeof contentDom === "string"){
			contentDom = utils.createElementFromHTML(contentDom);
		}
	
		contentDom && el.appendChild(contentDom);
		widgetWrapper && widgetWrapper.appendChild(el);
	
		function _hide(){
			utils.addClass(el, "hide");
		}
		function _show(){
			utils.removeClass(el, "hide");
		}
		function _toggle(){
			utils.toggle(el, "hide");
		}
		function _cancelCb(){
			cancel();
			_hide();
		}
		function _confirmCb(){
			confirm() !== false && _hide();
		}
	
		return {
			addButton: function(opt){
				opt = opt || {};
				var hideCancel = opt.hideCancel;
				var confirmText = opt.confirmText || "Confirm";
				var cancelText = opt.cancelText || "Cancel";
				cancel = opt.cancel || EMPTY_FUNCTION;
				confirm = opt.confirm || EMPTY_FUNCTION;
				var footer = utils.createElementFromHTML([
					"<div class=\"footer\">",
					"<button class=\"cancel-btn\"></button>",
					"<button class=\"confirm-btn bg-color\"></button>",
					"</div>"
				].join(""));
	
				cancelBtn = footer.querySelector(".cancel-btn");
				cancelBtn.innerText = cancelText;
				confirmBtn = footer.querySelector(".confirm-btn");
				confirmBtn.innerText = confirmText;
				hideCancel && utils.addClass(cancelBtn, "hide");
				el.appendChild(footer);
				utils.on(cancelBtn, "click", _cancelCb);
				utils.on(confirmBtn, "click", _confirmCb);
				return this;
			},
			show: function(){
				_show();
				return this;
			},
			hide: function(){
				_hide();
				return this;
			},
			toggle: function(){
				_toggle();
				return this;
			},
			destroy: function(){
				utils.off(cancelBtn, "click", _cancelCb);
				utils.off(confirmBtn, "click", _confirmCb);
				utils.removeDom(el);
			},
			el: el
		};
	}
	
	function showSuccess(msg){
		var contentDom = utils.createElementFromHTML([
			"<div>",
			"<i class=\"icon-circle\"><i class=\"icon-good\"></i></i>",
			"<p></p>",
			"</div>"
		].join(""));
		contentDom.querySelector("p").innerText = msg;
		var dialog = _createDialog({
			contentDom: contentDom,
			className: "mini em-success-prompt"
		}).show();
	
		setTimeout(dialog.destroy, 2000);
	}


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var apiHelper = __webpack_require__(182);
	var _const = __webpack_require__(176);
	var emajax = __webpack_require__(184);
	var profile = __webpack_require__(178);
	var commonConfig = __webpack_require__(177);
	
	// 以下调用会缓存参数
	// getVisitorId
	// getProjectId
	// getToken
	var config;
	var cache = {
		appraiseTags: {}
	};
	var api = apiHelper.api;
	
	function getGrayList(tenantId){
		return new Promise(function(resolve/* , reject */){
			api("grayScale", {
				tenantId: tenantId,
			}, function(msg){
				var grayScaleDescription = utils.getDataByPath(msg, "data.entities") || [];
				var grayScaleList = _.chain(grayScaleDescription)
					.map(function(item){
						var keyName = item.grayName;
						var status = item.status;
						var enable = status !== "Disable";
	
						return [keyName, enable];
					})
					.object()
					.value();
	
				resolve(grayScaleList);
			}, function(err){
				console.error("unable to get gray list: ", err);
				// 获取失败返回空对象
				resolve({});
			});
		});
	}
	
	function getToken(){
		return new Promise(function(resolve, reject){
			var token = profile.imToken;
	
			// 超时降级
			setTimeout(function(){
				if(profile.imToken === null){
					profile.imToken = "";
					resolve("");
				}
			}, 5000);
			if(token !== null || profile.imRestDown){
				resolve(token);
				return;
			}
			emajax({
				url: location.protocol + "//" + config.restServer + "/" + config.orgName +
					"/" + config.appName + "/token",
				useXDomainRequestInIE: true,
				dataType: "json",
				data: {
					grant_type: "password",
					username: config.user.username,
					password: config.user.password
				},
				type: "POST",
				success: function(resp){
					var token = resp.access_token;
	
					// cache token
					profile.imToken = token;
					resolve(token);
				},
				error: function(err){
					if(err.error_description === "user not found"){
						reject(err);
					}
					else{
						// 未知错误降级走第二通道
						profile.imToken = "";
						resolve("");
					}
				}
			});
		});
	}
	function getNotice(){
		return new Promise(function(resolve, reject){
			if(config.isWebChannelConfig){
				resolve(config.notice);
			}
			else{
				api("getSlogan", {
					tenantId: config.tenantId
				}, function(msg){
					var content = utils.getDataByPath(msg, "data.0.optionValue");
					var notice = {
						enabled: !!content,
						content: content
					};
					resolve(notice);
				}, function(err){
					reject(err);
				});
			}
		});
	}
	
	
	function getProjectId(){
		return new Promise(function(resolve, reject){
			if(cache.projectId){
				resolve(cache.projectId);
			}
			else{
				getToken().then(function(token){
					api("getProject", {
						tenantId: config.tenantId,
						"easemob-target-username": config.toUser,
						"easemob-appkey": config.appKey.replace("#", "%23"),
						"easemob-username": config.user.username,
						headers: { Authorization: "Easemob IM " + token }
					}, function(msg){
						var projectId = utils.getDataByPath(msg, "data.entities.0.id");
						if(projectId){
							// cache projectId
							cache.projectId = projectId;
							resolve(projectId);
						}
						else{
							reject(new Error("no project id exist."));
						}
					}, function(err){
						reject(err);
					});
				});
			}
		});
	}
	
	function getNoteCategories(){
		return new Promise(function(resolve, reject){
			Promise.all([
				getToken(),
				getProjectId()
			]).then(function(result){
				var token = result[0];
				var projectId = result[1];
	
				api("getNoteCategories", {
					tenantId: config.tenantId,
					"easemob-target-username": config.toUser,
					"easemob-appkey": config.appKey.replace("#", "%23"),
					"easemob-username": config.user.username,
					headers: { Authorization: "Easemob IM " + token },
					projectId: projectId,
				}, function(msg){
					var list = utils.getDataByPath(msg, "data.entities");
					resolve(list);
	
				}, function(err){
					reject(err);
				});
			});
		});
	}
	
	function createTicket(opt){
		return new Promise(function(resolve, reject){
			api("createTicket", {
				tenantId: config.tenantId,
				"easemob-target-username": config.toUser,
				"easemob-appkey": config.appKey.replace("#", "%23"),
				"easemob-username": config.user.username,
				config_id: config.configId,
				config_name: config.configName,
				origin_type: "webim",
				headers: { Authorization: "Easemob IM " + opt.token },
				projectId: opt.projectId,
				subject: "",
				content: opt.content,
				status_id: "",
				priority_id: "",
				category_id: opt.category_id,
				session_id: opt.session_id,
				creator: {
					name: opt.name,
					avatar: "",
					email: opt.mail,
					phone: opt.phone,
					qq: "",
					company: "",
					description: ""
				},
				attachments: null
			}, function(msg){
				if(utils.getDataByPath(msg, "data.id")){
					resolve();
				}
				else{
					reject(new Error("unknown error."));
				}
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getVisitorId(){
		return new Promise(function(resolve, reject){
			if(cache.visitorId){
				resolve(cache.visitorId);
			}
			else{
				getToken().then(function(token){
					api("getVisitorInfo", {
						tenantId: config.tenantId,
						orgName: config.orgName,
						appName: config.appName,
						userName: config.user.username,
						imServiceNumber: config.toUser,
						token: token
					}, function(msg){
						// console.log(msg,"访客信息")
						// 存储访客信息
						commonConfig.setConfig({
							visitorInfo: msg.data.entity
						});
						var visitorId = utils.getDataByPath(msg, "data.entity.userId");
						if(visitorId){
							// cache visitor id
							cache.visitorId = visitorId;
							resolve(visitorId);
						}
						else{
							reject(_const.ERROR_MSG.VISITOR_DOES_NOT_EXIST);
						}
					}, function(err){
						reject(err);
					});
				});
			}
		});
	}
	
	function getOfficalAccounts(){
		return new Promise(function(resolve, reject){
			Promise.all([
				getVisitorId(),
				getToken()
			]).then(function(result){
				var visitorId = result[0];
				var token = result[1];
	
				api("getOfficalAccounts", {
					tenantId: config.tenantId,
					orgName: config.orgName,
					appName: config.appName,
					userName: config.user.username,
					visitorId: visitorId,
					token: token
				}, function(msg){
					var list = utils.getDataByPath(msg, "data.entities");
					if(_.isArray(list)){
						resolve(list);
					}
					else{
						resolve([]);
						console.error("unexpect data format: ", list);
					}
				}, function(err){
					reject(err);
				});
			})
			// 未创建会话时 visitor不存在，此时 getVisitorId 会reject 特定error，需要捕获此错误
			["catch"](function(err){
				reject(err);
			});
		});
	}
	
	function getOfficalAccountMessage(officialAccountId, startId){
		return new Promise(function(resolve, reject){
			Promise.all([
				getVisitorId(),
				getToken()
			]).then(function(result){
				var visitorId = result[0];
				var token = result[1];
	
				api("getOfficalAccountMessage", {
					tenantId: config.tenantId,
					orgName: config.orgName,
					appName: config.appName,
					userName: config.user.username,
					token: token,
					visitorId: visitorId,
					officialAccountId: officialAccountId,
					direction: "before",
					size: _const.GET_HISTORY_MESSAGE_COUNT_EACH_TIME,
					startId: startId
				}, function(msg){
					var list = utils.getDataByPath(msg, "data.entities");
					if(_.isArray(list)){
						resolve(list);
					}
					else{
						reject(new Error("unexpect data format."));
					}
				}, function(err){
					reject(err);
				});
			})
			["catch"](function(err){
				reject(err);
			});
		});
	}
	
	// 获取上下班状态，false 代表上班，true 代表下班
	function getDutyStatus(){
		return new Promise(function(resolve/* , reject */){
			api("getDutyStatus_2", {
				channelType: "easemob",
				originType: "webim",
				channelId: config.channelId,
				tenantId: config.tenantId,
				queueName: encodeURIComponent(config.emgroup),
				agentUsername: config.agentName,
				timeScheduleId: config.timeScheduleId,
			}, function(msg){
				resolve(!utils.getDataByPath(msg, "data.entity"));
			}, function(err){
				console.error("unable to get duty state: ", err);
				// 获取状态失败则置为上班状态
				resolve(true);
			});
		});
	}
	
	function getRobertGreeting(){
		var referer = parseReferer(config.referer);
		// !!! 2020年7月之后，百度将word、wd等推广词封了，目前此方式取不到了
		var keyword1 = referer.word || referer.wd; // 百度
		var keyword2 = referer.q; // 360/神马
		var keyword3 = referer.query || referer.keyword; // 搜狗
		var keyword = keyword1 || keyword2 || keyword3;
		return new Promise(function(resolve, reject){
			api("getRobertGreeting_2", {
				channelType: "easemob",
				originType: "webim",
				channelId: config.channelId,
				tenantId: config.tenantId,
				agentUsername: config.agentName,
				queueName: encodeURIComponent(config.emgroup),
				visitorUserName: config.user.username,
				keyword: keyword || ""
			}, function(msg){
				resolve(msg.data.entity || {});
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getRobertIsOpen(){
		return new Promise(function(resolve, reject){
			if(typeof cache.isRobotOpen === "boolean"){
				resolve(cache.isRobotOpen);
			}
			else{
				api("getRobertIsOpen", {
					channelType: "easemob",
					originType: "webim",
					channelId: config.channelId,
					tenantId: config.tenantId,
					agentUsername: config.agentName,
					queueName: encodeURIComponent(config.emgroup)
				}, function(msg){
					var entity = msg.data.entity;
	
					cache.isRobotOpen = entity;
					resolve(entity);
				}, function(err){
					reject(err);
				});
			}
		});
	}
	
	function getMsgNumberOption(){
		return new Promise(function(resolve, reject){
			api("getMsgNumberOption", {
				tenantId: config.tenantId,
			}, function(msg){
				resolve(msg.data.entities);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getSystemGreeting(visitorUserName){
		return new Promise(function(resolve, reject){
			api("getSystemGreeting", {
				tenantId: config.tenantId,
				visitorUserName: config.user.username,
				orgName: config.orgName,
				appName: config.appName,
				easeMobIMNumber: config.to,
			}, function(msg){
				resolve(msg.data);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getTransferManualMenu(){
		return new Promise(function(resolve, reject){
			api("getTransferManualMenu", {
				tenantId: config.tenantId,
				channelId: config.channelId,
				channelType: "easemob" 
			}, function(msg){
				var entity = utils.getDataByPath(msg, "data.entity");
				if(entity){
					resolve(entity);
				}
				else{
					reject(new Error("unexpected data format."));
				}
			}, function(err){
				reject(err);
			});
		});
	}
	
	
	function getExSession(){
		return new Promise(function(resolve, reject){
			Promise.all([getNoEmptyAgentEnable(), getNoEmptyAgentMessage()]).then(function(datas){
				var enableData = datas[0];
				var messageData = datas[1];
	
				api("getExSession_2", {
					username: config.user.username,
					orgName: config.orgName,
					appName: config.appName,
					imServiceNumber: config.toUser,
					channelType: "easemob",
					originType: "webim",
					channelId: config.channelId,
					queueName: encodeURIComponent(config.emgroup),
					agentUsername: config.agentName,
					tenantId: config.tenantId
				}, function(msg){
					var entity = utils.getDataByPath(msg, "data.entity");
					if(entity){
						// undefined展示默认，其他按照开关展示 tip_content:undefined 就是关
						if(enableData.length == 0 || enableData[0].optionValue == "true"){
							// 没设置，默认开
							entity.tip_content = messageData.length ? messageData[0].optionValue : _const.eventMessageText.NOTE;
						}
	
						resolve(entity);
					}
					else{
						reject(new Error("unexpected data format."));
					}
				}, function(err){
					reject(err);
				});
			})["catch"](function(err){
				reject(err);
			});
		});
	}
	
	function getAgentStatus(agentUserId){
		return new Promise(function(resolve, reject){
			// todo: discard this
			// 没有token 不发送请求 也不报错
			if(!profile.imToken){
				resolve();
				return;
			}
	
			api("getAgentStatus", {
				tenantId: config.tenantId,
				orgName: config.orgName,
				appName: config.appName,
				agentUserId: agentUserId,
				userName: config.user.username,
				token: profile.imToken,
				imServiceNumber: config.toUser
			}, function(msg){
				resolve(utils.getDataByPath(msg, "data.state"));
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getLastSession(officialAccountId){
		return new Promise(function(resolve, reject){
			Promise.all([
				getVisitorId(),
				getToken()
			]).then(function(result){
				var visitorId = result[0];
				var token = result[1];
	
				api("getLastSession", {
					tenantId: config.tenantId,
					orgName: config.orgName,
					appName: config.appName,
					imServiceNumber: config.toUser,
					officialAccountId: officialAccountId,
					userName: config.user.username,
					visitorId: visitorId,
					token: token
				}, function(msg){
					var entity = utils.getDataByPath(msg, "data.entity");
					if(entity){
						resolve(entity);
					}
					else{
						reject(_const.ERROR_MSG.SESSION_DOES_NOT_EXIST);
					}
				}, function(err){
					reject(err);
				});
			})
			// 未创建会话时 visitor不存在，此时 getVisitorId 会reject 特定error，需要捕获此错误
			["catch"](function(err){
				reject(err);
			});
		});
	}
	
	function getSkillgroupMenu(){
		return new Promise(function(resolve, reject){
			api("getSkillgroupMenu", {
				tenantId: config.tenantId,
				visitorUserName: config.user.username,
				orgName: config.orgName,
				appName: config.appName,
				easeMobIMNumber: config.to
			}, function(msg){
				resolve(utils.getDataByPath(msg, "data.entities.0"));
			}, function(err){
				reject(err);
			});
		});
	}
	
	function reportVisitorAttributes(sessionId){
		return new Promise(function(resolve, reject){
			getToken().then(function(token){
				api("reportVisitorAttributes", {
					tenantId: config.tenantId,
					orgName: config.orgName,
					appName: config.appName,
					imServiceNumber: config.toUser,
					sessionId: sessionId,
					userName: config.user.username,
					referer: document.referrer,
					token: token,
					fromUrl: config.fromUrl,
					docReferer: config.referer
				}, function(){
					resolve();
				}, function(err){
					reject(err);
				});
			});
		});
	}
	
	function reportPredictMessage(sessionId, content){
		return new Promise(function(resolve, reject){
			Promise.all([
				getVisitorId(), // 获取访客信息
				getToken()
			]).then(function(result){
				var visitorId = result[0];
				var token = result[1];
	
				api("messagePredict_2", {
					sessionId: sessionId,
					visitor_user_id: visitorId,
					content: content,
					timestamp: _.now(),
					orgName: config.orgName,
					appName: config.appName,
					userName: config.user.username,
					imServiceNumber: config.toUser,
					token: token
				}, function(){
					resolve();
				}, function(err){
					reject(err);
				});
			});
		});
	}
	
	function getAgentInputState(sessionId){
		return new Promise(function(resolve, reject){
			getToken().then(function(token){
				api("getAgentInputState", {
					username: config.user.username,
					orgName: config.orgName,
					appName: config.appName,
					tenantId: config.tenantId,
					serviceSessionId: sessionId,
					token: token,
				}, function(msg){
					resolve(msg.data.entity);
				}, function(err){
					reject(err);
				});
			});
		});
	}
	
	function getWaitListNumber(sessionId, queueId){
		return new Promise(function(resolve, reject){
			api("getWaitListNumber", {
				tenantId: config.tenantId,
				queueId: queueId,
				serviceSessionId: sessionId
			}, function(msg){
				resolve(msg.data.entity);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getNickNameOption(){
		return new Promise(function(resolve, reject){
			api("getNickNameOption", {
				tenantId: config.tenantId
			}, function(msg){
				var optionValue = utils.getDataByPath(msg, "data.0.optionValue");
				resolve(optionValue === "true");
			}, function(err){
				reject(err);
			});
		});
	}
	
	function closeServiceSession(sessionId, visitorActive){
		return new Promise(function(resolve, reject){
			getToken().then(function(token){
				api("closeServiceSession", {
					tenantId: config.tenantId,
					orgName: config.orgName,
					appName: config.appName,
					userName: config.user.username,
					token: token,
					serviceSessionId: sessionId,
					visitorActive: visitorActive || false
				}, function(){
					resolve();
				}, function(err){
					reject(err);
				});
			});
		});
	}
	
	function deleteEvent(gid){
		return new Promise(function(resolve, reject){
			api("deleteEvent", {
				userId: gid
			}, function(){
				resolve();
			}, function(err){
				reject(err);
			});
		});
	}
	
	function receiveMsgChannel(tabId){
		return new Promise(function(resolve, reject){
			api("receiveMsgChannel", {
				orgName: config.orgName,
				appName: config.appName,
				easemobId: config.toUser,
				tenantId: config.tenantId,
				visitorEasemobId: config.user.username,
				tabId: tabId
			}, function(msg){
				var status = utils.getDataByPath(msg, "data.status");
				var entities = utils.getDataByPath(msg, "data.entities");
	
				if(status === "OK"){
					resolve(entities);
				}
				else{
					reject(new Error("unexpected response data."));
				}
			}, function(err){
				reject(err);
			});
		});
	}
	
	function sendMsgChannel(body, ext){
		return new Promise(function(resolve, reject){
			api("sendMsgChannel", {
				from: config.user.username,
				to: config.toUser,
				tenantId: config.tenantId,
				bodies: [body],
				ext: ext,
				orgName: config.orgName,
				appName: config.appName,
				originType: "webim"
			}, function(msg){
				resolve(msg.data);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function uploadImgMsgChannel(file){
		return new Promise(function(resolve, reject){
			getToken().then(function(token){
				api("uploadImgMsgChannel", {
					userName: config.user.username,
					tenantId: config.tenantId,
					file: file,
					auth: "Bearer " + token,
					orgName: config.orgName,
					appName: config.appName,
				}, function(msg){
					resolve(msg.data);
				}, function(err){
					reject(err);
				});
			});
		});
	}
	
	function reportMarketingTaskDelivered(marketingTaskId){
		return new Promise(function(resolve, reject){
			Promise.all([
				getVisitorId(),
				getToken()
			]).then(function(result){
				var visitorId = result[0];
				var token = result[1];
	
				api("reportMarketingTaskDelivered", {
					marketingTaskId: marketingTaskId,
					tenantId: config.tenantId,
					orgName: config.orgName,
					appName: config.appName,
					userName: config.user.username,
					token: token,
					visitor_id: visitorId,
				}, function(msg){
					var status = utils.getDataByPath(msg, "data.status");
	
					if(status === "OK"){
						resolve();
					}
					else{
						reject(new Error("unexpected reaponse status."));
					}
					resolve(msg.data);
				}, function(err){
					reject(err);
				});
			});
		});
	}
	
	function reportMarketingTaskOpened(marketingTaskId){
		return new Promise(function(resolve, reject){
			Promise.all([
				getVisitorId(),
				getToken()
			]).then(function(result){
				var visitorId = result[0];
				var token = result[1];
	
				api("reportMarketingTaskOpened", {
					marketingTaskId: marketingTaskId,
					tenantId: config.tenantId,
					orgName: config.orgName,
					appName: config.appName,
					userName: config.user.username,
					token: token,
					visitor_id: visitorId,
				}, function(msg){
					var status = utils.getDataByPath(msg, "data.status");
	
					if(status === "OK"){
						resolve();
					}
					else{
						reject(new Error("unexpected reaponse status."));
					}
					resolve(msg.data);
				}, function(err){
					reject(err);
				});
			});
		});
	}
	
	function reportMarketingTaskReplied(marketingTaskId){
		return new Promise(function(resolve, reject){
			Promise.all([
				getVisitorId(),
				getToken()
			]).then(function(result){
				var visitorId = result[0];
				var token = result[1];
	
				api("reportMarketingTaskReplied", {
					marketingTaskId: marketingTaskId,
					tenantId: config.tenantId,
					orgName: config.orgName,
					appName: config.appName,
					userName: config.user.username,
					token: token,
					visitor_id: visitorId,
				}, function(msg){
					var status = utils.getDataByPath(msg, "data.status");
	
					if(status === "OK"){
						resolve();
					}
					else{
						reject(new Error("unexpected reaponse status."));
					}
					resolve(msg.data);
				}, function(err){
					reject(err);
				});
			});
		});
	}
	
	function getLatestMarketingTask(officialAccountId){
		return new Promise(function(resolve, reject){
			getToken().then(function(token){
				api("getLatestMarketingTask", {
					tenantId: config.tenantId,
					orgName: config.orgName,
					appName: config.appName,
					officialAccountId: officialAccountId,
					userName: config.user.username,
					token: token
				}, function(msg){
					var entity = utils.getDataByPath(msg, "data.entity");
					resolve(entity);
				}, function(err){
					reject(err);
				});
			});
		});
	}
	
	function getEvaluationDegrees(){
		var officialAccount = profile.currentOfficialAccount;
		return new Promise(function(resolve, reject){
			if(cache.evaluationDegrees){
				resolve(cache.evaluationDegrees);
			}
			else{
				getToken().then(function(token){
					api("getEvaluationDegrees", {
						tenantId: config.tenantId,
						orgName: config.orgName,
						appName: config.appName,
						userName: config.user.username,
						serviceSessionId: officialAccount.sessionId,
						token: token,
						isChannelTag:config.isChannelTag,
						channelType:"easemob",
						channelId:config.channelId
					}, function(msg){
						var entities = utils.getDataByPath(msg, "data.entities");
						if(_.isArray(entities)){
							cache.evaluationDegrees = entities;
							resolve(entities);
						}
						else{
							reject(new Error("unexpected reaponse value."));
						}
					}, function(err){
						reject(err);
					});
				});
			}
		});
	}
	
	function getAppraiseTags(evaluateId){
		var officialAccount = profile.currentOfficialAccount;
		return new Promise(function(resolve, reject){
			if(cache.appraiseTags[evaluateId]){
				resolve(cache.appraiseTags[evaluateId]);
			}
			else{
				getToken().then(function(token){
					api("getAppraiseTags", {
						tenantId: config.tenantId,
						orgName: config.orgName,
						appName: config.appName,
						userName: config.user.username,
						token: token,
						serviceSessionId: officialAccount.sessionId,
						evaluateId: evaluateId
					}, function(msg){
						var entities = utils.getDataByPath(msg, "data.entities");
						if(entities){
							cache.appraiseTags[evaluateId] = entities;
							resolve(entities);
						}
						else{
							reject(new Error("unexpected reaponse value."));
						}
					}, function(err){
						reject(err);
					});
				});
			}
		});
	}
	
	function getCustomEmojiPackages(){
		return new Promise(function(resolve, reject){
			api("getCustomEmojiPackages", { tenantId: config.tenantId }, function(msg){
				var entities = utils.getDataByPath(msg, "data.entities");
	
				if(_.isArray(entities)){
					resolve(entities);
				}
				else{
					reject(new Error("unexpected emoji package list."));
				}
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getCustomEmojiFiles(){
		return new Promise(function(resolve, reject){
			api("getCustomEmojiFiles", { tenantId: config.tenantId }, function(msg){
				var entities = utils.getDataByPath(msg, "data.entities");
	
				if(_.isArray(entities)){
					resolve(entities);
				}
				else{
					reject(new Error("unexpected emoji package list."));
				}
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getSatisfactionTipWord(){
		var officialAccount = profile.currentOfficialAccount;
		return new Promise(function(resolve, reject){
			api("getSatisfactionTipWord", {
				tenantId: config.tenantId,
				serviceSessionId: officialAccount.sessionId
			}, function(msg){
				var tipWord = utils.getDataByPath(msg, "data.entities.0.optionValue") || "Rate my service";
				resolve(tipWord);
			}, function(){
				// 异常时，满意度提示语为默认提示语，无reject
				var tipWord = "Rate my service";
				resolve(tipWord);
			});
		});
	}
	
	function getEvaluteSolveWord(){
		var officialAccount = profile.currentOfficialAccount;
		return new Promise(function(resolve, reject){
			api("getEvaluteSolveWord", {
				tenantId: config.tenantId,
				serviceSessionId: officialAccount.sessionId
			}, function(msg){
				var tipWord = utils.getDataByPath(msg, "data.entities.0.optionValue") || "Has your problem been resolved?";
				resolve(tipWord);
			}, function(){
				// 异常时，问题解决评价引导语为默认提示语，无reject
				var tipWord = "Has your problem been resolved?";
				resolve(tipWord);
			});
		});
	}
	
	function getServiceSessionResolved(){
		return new Promise(function(resolve, reject){
			var webim = false;
			api("getServiceSessionResolved", { tenantId: config.tenantId }, function(res){
				var val = utils.getDataByPath(res, "data.entities.0.optionValue");
				if(typeof val === "string"){
					val = val.replace(/&quot;/g, "\"");
					val = JSON.parse(val);
					if(val.webim){
						webim = true;
					}
				}
				resolve(webim);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getResolutionparams(){
		return new Promise(function(resolve, reject){
			api("getResolutionparams", { 
				tenantId: config.tenantId,
				orgName: config.orgName,
				appName: config.appName,
				userName: config.user.username,
				token: config.user.token,
				channelType:"easemob",
				channelId:config.channelId
			 }, function(res){
				var entities = utils.getDataByPath(res, "data.entities");
				if(_.isArray(entities)){
					resolve(entities);
				}else{
					reject(new Error("unexpected emoji package list."));
				}
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getDefaultFiveStarEnable(){
		return new Promise(function(resolve, reject){
			var webim = false;
			api("getDefaultFiveStarEnable", { tenantId: config.tenantId }, function(res){
				var val = utils.getDataByPath(res, "data.entities.0.optionValue");
				if(typeof val === "string"){
					if(val == "true"){
						webim = true;
					}
				}
				resolve(webim);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getEvaluatePrescription(){
		return new Promise(function(resolve, reject){
			api("getEvaluatePrescription", { tenantId: config.tenantId }, function(res){
				var val = utils.getDataByPath(res, "data.entities.0.optionValue");
				resolve(val);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function updateCustomerInfo(data){
		return new Promise(function(resolve, reject){
			Promise.all([
				getVisitorId(),
				getToken()
			]).then(function(result){
				var visitorId = result[0];
				var token = result[1];
				data.visitorId = visitorId;
				data.tenantId = config.tenantId;
				data.orgName = config.orgName;
				data.appName = config.appName;
				data.userName = config.user.username;
				data.token = token;
				api("updateCustomerInfo", data, function(msg){
					// resolve(msg.data);
				}, function(err){
					// reject(err);
				});
			});
		});
	}
	
	function getArticleJson(data){
		return new Promise(function(resolve, reject){
			api("getArticleJson", {
				media_id: data.media_id,
				tenantId: config.tenantId,
				userId: config.user.userName,
				orgName: config.orgName,
				appName: config.appName,
				token: 0,
			}, function(ret){
				var articles = utils.getDataByPath(ret, "data.entity.articles");
				resolve(articles);
			});
		});
	}
	// 猜你想说 接口列表
	function getGuessList(data){
		var officialAccount = profile.currentOfficialAccount;
		if(!officialAccount) return;
		return new Promise(function(resolve, reject){
			api("getGuessList", {
				tenantId: config.tenantId,
				sessionId: officialAccount.sessionId,
				robotId: officialAccount.agentId,
				inputValue: data
			}, function(msg){
				resolve(msg);
			});
		});
	}
	
	function getStatisfyYes(robotAgentId, satisfactionCommentKey){
		return new Promise(function(resolve, reject){
			emajax({
				url: "/v1/webimplugin/tenants/" + config.tenantId + "/robot-agents/" + robotAgentId + "/satisfaction-comment",
				data: {
					satisfactionCommentKey: satisfactionCommentKey,
					type: 1
				},
				type: "POST",
				success: function(resp){
					var parsed;
	
					try{
						parsed = JSON.parse(resp);
					}
					catch(e){ }
	
					if((parsed && parsed.status) === "OK"){
						resolve(parsed.entity);
					}
					else{
						reject(parsed);
					}
				},
				error: function(e){
					reject(e);
				}
			});
		});
	}
	function getStatisfyNo(robotAgentId, satisfactionCommentKey){
		return new Promise(function(resolve, reject){
			emajax({
				url: "/v1/webimplugin/tenants/" + config.tenantId + "/robot-agents/" + robotAgentId + "/satisfaction-comment",
				data: {
					satisfactionCommentKey: satisfactionCommentKey,
					type: 2
				},
				type: "POST",
				success: function(resp){
					var parsed;
	
					try{
						parsed = JSON.parse(resp);
					}
					catch(e){ }
	
					if((parsed && parsed.status) === "OK"){
						resolve(parsed.entity);
					}
					else{
						reject(parsed);
					}
				},
				error: function(e){
					reject(e);
				}
			});
		});
	}
	
	function getSatisfactionCommentTags(robotAgentId){
		return new Promise(function(resolve, reject){
			api("getSatisfactionCommentTags", {
				tenantId: config.tenantId,
				robotAgentId: robotAgentId
			}, function(msg){
				var status = utils.getDataByPath(msg, "data.status");
				var entities = utils.getDataByPath(msg, "data.entities");
				if(status === "OK"){
					resolve(entities);
				}
				else{
					reject(msg.data);
				}
			}, function(error){
				reject(error);
			});
		});
	}
	function confirmSatisfaction(robotAgentId, satisfactionCommentKey, selected){
		var data = {
			satisfactionCommentKey: satisfactionCommentKey,
			type: 2,
		};
		selected && (data.reasonTag = selected);
	
		return new Promise(function(resolve, reject){
			emajax({
				url: "/v1/webimplugin/tenants/" + config.tenantId + "/robot-agents/" + robotAgentId + "/satisfaction-comment",
				data: data,
				type: "POST",
				success: function(resp){
					var parsed;
	
					try{
						parsed = JSON.parse(resp);
					}
					catch(e){ }
	
					if((parsed && parsed.status) === "OK"){
						resolve(parsed.entity);
					}
					else{
						reject(parsed);
					}
				},
				error: function(e){
					reject(e);
				}
			});
		});
	}
	
	function getGradeType(){
		return new Promise(function(resolve, reject){
			api("getInfo", {
				tenantId: config.tenantId,
			}, function(resp){
				if(resp){
					resolve(resp.data);
				}
				else{
					reject(new Error("unexpected response value."));
				}
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getOptForShowTrackMsg(){
		return new Promise(function(resolve, reject){
			api("getOptForShowTrackMsg", {
				tenantId: config.tenantId,
			}, function(res){
				var val = utils.getDataByPath(res, "data.entities.0.optionValue");
				if(typeof val === "string"){
					if(val == (false + "")){
						val = false;
					}
					else if(val == (true + "")){
						val = true;
					}
				}
				resolve(val);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getOptForManualMenuGuide(){
		return new Promise(function(resolve, reject){
			api("getOptForManualMenuGuide", {
				tenantId: config.tenantId,
			}, function(res){
				var val = utils.getDataByPath(res, "data.entities.0.optionValue");
				if(typeof val === "string"){
					if(val == (false + "")){
						val = false;
					}
					else if(val == (true + "")){
						val = true;
					}
				}
				resolve(val);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getlaiyeHtml(url){
		return emajax({
			url: url,
			type: "GET",
			async: false
		});
	}
	function getArticleHtml(articleUrl){
		var url = "/v1/robot/integration/tenants/material/news/article/html?url=" + articleUrl;
		return emajax({
			url: url,
			type: "GET",
			async: false
		});
	}
	
	function parseReferer(ref){
		var i;
		var len;
		var idx;
		var tmp = [];
		var referer = {};
		var arr;
		var elementA;
		if(!ref){
			return {};
		}
		ref = utils.decode(ref);
		elementA = document.createElement("a");
		elementA.href = ref;
		idx = ref.indexOf("?");
		referer.domain = elementA.origin;
		arr = ref.slice(idx + 1).split("&");
		for(i = 0, len = arr.length; i < len; i++){
			tmp = arr[i].split("=");
			referer[tmp[0]] = tmp.length > 1 ? tmp[1] : "";
		}
		return referer;
	}
	
	function startKeep(data){
		return new Promise(function(resolve, reject){
			Promise.all([
				getVisitorId(),
			]).then(function(result){
				var visitorId = result[0];
				data.visitorId = visitorId;
				data.tenantId = config.tenantId;
				api("startKeep", data, function(msg){
					// resolve(msg.data);
				}, function(err){
					// reject(err);
				});
			});
		});
	}
	
	function closeChatDialog(data){
		return new Promise(function(resolve, reject){
			Promise.all([
				getVisitorId(),
			]).then(function(result){
				var visitorId = result[0];
				data.visitorId = visitorId;
				data.tenantId = config.tenantId;
				api("closeChatDialog", data, function(msg){
					// resolve(msg.data);
				}, function(err){
					// reject(err);
				});
			});
		});
	}
	
	function getSessionEnquires(serviceSessionId){
		return new Promise(function(resolve, reject){
			api("getSessionEnquires", {
				tenantId: config.tenantId,
				serviceSessionId: serviceSessionId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data.entities");
				resolve(result);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getRobotNotReachableENEnable(){
		return emajax({
			url: "/v1/webimplugin/tenants/"
				+ config.tenantId
				+ "/options/robotNotReachableENEnable",
			type: "GET",
			async: false,
		});
	}
	
	function getNoEmptyAgentEnable(){
		return new Promise(function(resolve, reject){
			emajax({
				url: "/v1/webimplugin/tenants/"
					+ config.tenantId
					+ "/options/noEmptyAgentTipEnable",
				type: "GET",
				async: false,
				success: function(data){
					data = JSON.parse(data);
					if(data.status && data.status == "OK" && data.entities){
						resolve(data.entities);
					}
					else{
						reject("");
					}
				},
				error: function(err){
					reject(err);
				}
			});
		});
	}
	
	function getNoEmptyAgentMessage(){
		return new Promise(function(resolve, reject){
			emajax({
				url: "/v1/webimplugin/tenants/"
					+ config.tenantId
					+ "/options/noEmptyAgentTipMessage?visitorUserName=" + config.user.username,
				type: "GET",
				async: false,
				success: function(data){
					data = JSON.parse(data);
					if(data.status && data.status == "OK" && data.entities && data.entities){
						resolve(data.entities);
					}
					else{
						reject("");
					}
				},
				error: function(err){
					reject(err);
				},
			});
		});
	}
	
	function getOnlineCustomerStatus(){
		return new Promise(function(resolve, reject){
			api("getOnlineCustomerStatus", {
				tenantId: config.tenantId,
			}, function(res){
				var val = utils.getDataByPath(res, "data.entities.0.optionValue");
				if(typeof val === "string"){
					if(val == (false + "")){
						val = false;
					}
					else if(val == (true + "")){
						val = true;
					}
				}
				resolve(val);
			}, function(err){
				reject(err);
			});
		});
	}
	function getIsNoLink(){
		return new Promise(function(resolve, reject){
			api("getIsNoLink", {
				tenantId: config.tenantId,
			}, function(res){
				var val = utils.getDataByPath(res, "data.entities.0.optionValue");
				if(typeof val === "string"){
					if(val == (false + "")){
						val = false;
					}
					else if(val == (true + "")){
						val = true;
					}
				}
				resolve(val);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function deleteVideoInvitation(serviceSessionId){
		return new Promise(function(resolve, reject){
			api("deleteVideoInvitation", {
				serviceSessionId: serviceSessionId,
			}, function(){
				resolve();
			}, function(err){
				reject(err);
			});
		});
	}
	
	function visitorCloseSession(data){
		return new Promise(function(resolve, reject){
			Promise.all([
				getVisitorId(),
			]).then(function(result){
				var visitorId = result[0];
				data.visitorId = visitorId;
				data.tenantId = config.tenantId;
				api("visitorCloseSession", data, function(msg){
					// resolve(msg.data);
				}, function(err){
					// reject(err);
				});
			});
		});
	}
	
	function getEvaluateVerify(serviceSessionId){
		return new Promise(function(resolve, reject){
			api("getEvaluateVerify", {
				tenantId: config.tenantId,
				serviceSessionId: serviceSessionId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getTransferTicketsEvent(serviceSessionId){
		return new Promise(function(resolve, reject){
			api("getTransferTicketsEvent", {
				tenantId: config.tenantId,
				serviceSessionId: serviceSessionId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getInputTopButton(){
		return new Promise(function(resolve, reject){
			api("getInputTopButton", {
				tenantId: config.tenantId,
				configId: config.configId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				// reject(err);
				resolve(err);
			});
		});
	}
	function getInputTopStatus(){
		return new Promise(function(resolve, reject){
			api("getInputTopStatus", {
				tenantId: config.tenantId,
				configId: config.configId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				// reject(err);
				resolve(err);
			});
		});
	}
	function getInputH5Button(){
		return new Promise(function(resolve, reject){
			api("getInputH5Button", {
				tenantId: config.tenantId,
				configId: config.configId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				// reject(err);
				resolve(err);
			});
		});
	}
	function getInputH5Status(){
		return new Promise(function(resolve, reject){
			api("getInputH5Status", {
				tenantId: config.tenantId,
				configId: config.configId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				// reject(err);
				resolve(err);
			});
		});
	}
	function getVideoH5Status(){
		return new Promise(function(resolve, reject){
			api("getVideoH5Status", {
				tenantId: config.tenantId,
				configId: config.configId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				resolve(err);
			});
		});
	}
	
	function getSendImgTips(){
		return new Promise(function(resolve, reject){
			api("getSendImgTips", {
				tenantId: config.tenantId,
				configId: config.configId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				// reject(err);
				resolve(err);
			});
		});
	}
	function getOnlyCloseWindow(){
		return new Promise(function(resolve, reject){
			var webim = false;
			api("getOnlyCloseWindow", { tenantId: config.tenantId }, function(res){
				var val = utils.getDataByPath(res, "data.entities.0.optionValue");
				if(typeof val === "string"){
					if(val == "true"){
						webim = true;
					}
				}
				resolve(webim);
			}, function(err){
				reject(err);
			});
		});
	}
	function getOnlyCloseSession(){
		return new Promise(function(resolve, reject){
			var webim = false;
			api("getOnlyCloseSession", { tenantId: config.tenantId }, function(res){
				var val = utils.getDataByPath(res, "data.entities.0.optionValue");
				if(typeof val === "string"){
					if(val == "true"){
						webim = true;
					}
				}
				resolve(webim);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function readMessageLastRead(serviceSessionId){
		return new Promise(function(resolve, reject){
			api("readMessageLastRead", {
				tenantId: config.tenantId,
				serviceSessionId: serviceSessionId,
			}, function(res){
				resolve(res);
			}, function(err){
				reject(err);
			});
		});
	}
	function initLanguage(language, visitorUserName){
		return new Promise(function(resolve, reject){
			api("initLanguage", {
				tenantId: config.tenantId,
				language: language,
				visitorUserName: visitorUserName,
			}, function(res){
				resolve(res);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getSessionClosedDialog(){
		return new Promise(function(resolve, reject){
			api("getSessionClosedDialog", {
				tenantId: config.tenantId,
			}, function(res){
				resolve(res);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getSessionClosedDialogUrl(){
		return new Promise(function(resolve, reject){
			api("getSessionClosedDialogUrl", {
				tenantId: config.tenantId,
			}, function(res){
				resolve(res);
			}, function(err){
				reject(err);
			});
		});
	}
	
	
	module.exports = {
		getGrayList: getGrayList,
		getToken: getToken,
		getNotice: getNotice,
		getProjectId: getProjectId,
		createTicket: createTicket,
		getVisitorId: getVisitorId,
		getOfficalAccounts: getOfficalAccounts,
		getOfficalAccountMessage: getOfficalAccountMessage,
		getDutyStatus: getDutyStatus,
		getRobertGreeting: getRobertGreeting,
		getRobertIsOpen: getRobertIsOpen,
		getMsgNumberOption: getMsgNumberOption,
		getSystemGreeting: getSystemGreeting,
		getExSession: getExSession,
		getAgentStatus: getAgentStatus,
		getLastSession: getLastSession,
		getSkillgroupMenu: getSkillgroupMenu,
		getNoteCategories: getNoteCategories,
		reportVisitorAttributes: reportVisitorAttributes,
		reportPredictMessage: reportPredictMessage,
		getAgentInputState: getAgentInputState,
		getWaitListNumber: getWaitListNumber,
		getNickNameOption: getNickNameOption,
		closeServiceSession: closeServiceSession,
		deleteEvent: deleteEvent,
		receiveMsgChannel: receiveMsgChannel,
		sendMsgChannel: sendMsgChannel,
		uploadImgMsgChannel: uploadImgMsgChannel,
		reportMarketingTaskDelivered: reportMarketingTaskDelivered,
		reportMarketingTaskOpened: reportMarketingTaskOpened,
		reportMarketingTaskReplied: reportMarketingTaskReplied,
		getLatestMarketingTask: getLatestMarketingTask,
		getEvaluationDegrees: getEvaluationDegrees,
		getAppraiseTags: getAppraiseTags,
		getCustomEmojiPackages: getCustomEmojiPackages,
		getCustomEmojiFiles: getCustomEmojiFiles,
		getSatisfactionTipWord: getSatisfactionTipWord,
		updateCustomerInfo: updateCustomerInfo,
		getArticleJson: getArticleJson,
		getGuessList: getGuessList,
	
		getStatisfyYes: getStatisfyYes,
		getStatisfyNo: getStatisfyNo,
		getSatisfactionCommentTags: getSatisfactionCommentTags,
		confirmSatisfaction: confirmSatisfaction,
		getGradeType: getGradeType,
		getTransferManualMenu: getTransferManualMenu,
	
		// opts
		getOptForShowTrackMsg: getOptForShowTrackMsg,
		getOptForManualMenuGuide: getOptForManualMenuGuide,
		getlaiyeHtml: getlaiyeHtml,
		getArticleHtml: getArticleHtml,
		getEvaluteSolveWord: getEvaluteSolveWord,
		getServiceSessionResolved: getServiceSessionResolved,
		getResolutionparams: getResolutionparams,
		startKeep: startKeep,
		closeChatDialog: closeChatDialog,
		visitorCloseSession: visitorCloseSession,
		getSessionEnquires: getSessionEnquires,
	
		getRobotNotReachableENEnable: getRobotNotReachableENEnable, // 获取机器人英文开关状态
		getDefaultFiveStarEnable: getDefaultFiveStarEnable,  // 获取默认五星评价的开关
		getEvaluatePrescription: getEvaluatePrescription,   // 满意度评价时效开关
		getNoEmptyAgentEnable: getNoEmptyAgentEnable, // 无空闲坐席提示文案自定义开关
		getNoEmptyAgentMessage: getNoEmptyAgentMessage, // 无空闲坐席提示文案自定义回复
	
		getIsNoLink: getIsNoLink, // 获取是否开启不解析html的开关
		// opt获取是否隐藏状态
		getOnlineCustomerStatus: getOnlineCustomerStatus,
		deleteVideoInvitation: deleteVideoInvitation, // 取消视频邀请
		getEvaluateVerify: getEvaluateVerify,
		getTransferTicketsEvent: getTransferTicketsEvent,
		getInputTopButton: getInputTopButton,
		getInputTopStatus: getInputTopStatus,
		getInputTopButton: getInputTopButton,
		getInputH5Button: getInputH5Button,
		getInputH5Status: getInputH5Status,
		getSendImgTips: getSendImgTips,
		getOnlyCloseSession: getOnlyCloseSession,
		getOnlyCloseWindow: getOnlyCloseWindow,
		getVideoH5Status: getVideoH5Status,
		readMessageLastRead: readMessageLastRead,
		initLanguage: initLanguage,
		getSessionClosedDialog: getSessionClosedDialog,
		getSessionClosedDialogUrl: getSessionClosedDialogUrl,
		update: function(cfg){
			config = cfg;
		}
	
	};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var Transfer = __webpack_require__(183);
	var profile = __webpack_require__(178);
	var commonConfig = __webpack_require__(177);
	var emajax = __webpack_require__(184);
	
	// 以下调用会缓存参数
	// getVisitorId
	// getProjectId
	// getToken
	var config;
	var cachedApiCallbackTable = {};
	var toProxy;
	
	function initApiTransfer(){
	
		toProxy = new Transfer("cross-origin-iframe", "data", true);
	
		toProxy.listen(function(msg){
			var apiName = msg.call;
			var timestamp = msg.timespan;
			var isSuccess = msg.status === 0;
			var callbacks;
			var successCallback;
			var errorCallback;
	
			if(cachedApiCallbackTable[apiName] && cachedApiCallbackTable[apiName][timestamp]){
	
				callbacks = cachedApiCallbackTable[apiName][timestamp];
				delete cachedApiCallbackTable[apiName][timestamp];
	
				successCallback = callbacks.success;
				errorCallback = callbacks.error;
	
				if(isSuccess){
					typeof successCallback === "function" && successCallback(msg);
				}
				else{
					typeof errorCallback === "function" && errorCallback(msg);
				}
			}
		}, ["api"]);
	}
	
	function api(apiName, data, success, error){
		var uuid = utils.uuid();
		// cache
		cachedApiCallbackTable[apiName] = cachedApiCallbackTable[apiName] || {};
		cachedApiCallbackTable[apiName][uuid] = {
			success: success,
			error: error
		};
		toProxy.send({
			api: apiName,
			data: data,
			timespan: uuid,
			// 标记postMessage使用object，47.9 增加
			useObject: true
		});
	}
	
	function getConfig(configId){
		return new Promise(function(resolve, reject){
			api("getConfig", {
				configId: configId
			}, function(msg){
				var entity = utils.getDataByPath(msg, "data.entity");
				resolve(entity);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getConfigOption(configId){
		var cfg = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getConfigOption", {
				tenantId: cfg.tenantId,
				configId: configId
			}, function(msg){
				var entity = utils.getDataByPath(msg, "data.entity");
				resolve(entity);
			}, function(err){
				// reject(err);
				console.log(err );
				resolve(err);// 由于访客集成方式不一样，所以configId获取不到，做特殊处理
			});
		});
	}
	function getWechatComponentId(){
		return new Promise(function(resolve, reject){
			emajax({
				url: "/v1/weixin/admin/appid",
				type: "GET",
				success: function(id){
					if(id){
						resolve(id);
					}
					else{
						reject(new Error("unexpected response value."));
					}
				},
				error: function(err){
					reject(err);
				}
			});
		});
	}
	
	function getWechatProfile(tenantId, appId, code){
		return new Promise(function(resolve, reject){
			emajax({
				url: "/v1/weixin/sns/userinfo/" + appId + "/" + code + "?tenantId=" + tenantId,
				type: "GET",
				success: function(resp){
					var parsed;
	
					try{
						parsed = JSON.parse(resp);
					}
					catch(e){}
	
					if(parsed){
						resolve(parsed);
					}
					else{
						reject(new Error("unexpected response value."));
					}
				},
				error: function(err){
					reject(err);
				}
			});
		});
	}
	
	// 以下几个接口是 config 还没初始化完时调用的，需要从 config 中获取值
	
	function getTheme(){
		var cfg = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			if(cfg.isWebChannelConfig){
				resolve(cfg.themeName);
			}
			else{
				api("getTheme", {
					tenantId: cfg.tenantId
				}, function(msg){
					var themeName = utils.getDataByPath(msg, "data.0.optionValue");
					resolve(themeName);
				}, function(err){
					reject(err);
				});
			}
		});
	}
	
	function getPassword(){
		var cfg = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getPassword2", {
				userId: cfg.user.username,
				orgName: cfg.orgName,
				appName: cfg.appName,
				tenantId: cfg.tenantId,
				imServiceNumber: cfg.toUser,
			}, function(msg){
				var status = utils.getDataByPath(msg, "data.status");
				var password = utils.getDataByPath(msg, "data.entity.userPassword");
	
				var nicename = utils.getDataByPath(msg, "data.entity.nicename");
				if(status === "OK"){
					resolve({password:password,nicename:nicename});
				}
				else{
					reject(new Error("unable to get password."));
				}
			}, function(err){
				var status = utils.getDataByPath(err, "data.status");
				var errorDescription = utils.getDataByPath(err, "data.errorDescription");
	
				if(status === "FAIL"){
					if(errorDescription === "IM user create fail."){
						profile.imRestDown = true;
						resolve("");
						return;
					}
					else if(errorDescription === "IM user not found."){
						reject(new Error("im user not found"));
						return;
					}
				}
				reject(new Error("unknown error when get password"));
			});
		});
	}
	
	function getRelevanceList(){
		var cfg = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getRelevanceList", {
				tenantId: cfg.tenantId
			}, function(msg){
				var relevanceList = msg.data;
	
				if(_.isArray(relevanceList) && !_.isEmpty(relevanceList)){
					resolve(relevanceList);
				}
				else{
					reject(new Error("There is no channel account."));
				}
			}, function(err){
				reject(err);
			});
		});
	}
	
	function reportEvent(url, userType, userId){
		var config = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("reportEvent", {
				type: "VISIT_URL",
				tenantId: config.tenantId,
				url: url,
				designatedAgent: config.agentName || "",
				userId: {
					type: userType,
					id: userId
				}
			}, function(msg){
				var resp = msg.data;
	
				if(resp){
					resolve(resp);
				}
				else{
					reject(new Error("unexpected resopnse data."));
				}
			}, function(err){
				reject(err);
			});
		});
	}
	
	
	function getCurrentServiceSession(){
		var config = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getCurrentServiceSession", {
				tenantId: config.tenantId,
				orgName: config.orgName,
				appName: config.appName,
				imServiceNumber: config.toUser,
				id: config.user.username
			}, function(msg){
				resolve(msg.data);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getFaqOrSelfServiceStatus(type){
		var cfg = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getFaqOrSelfServiceStatus", {
				tenantId: cfg.tenantId,
				configId: cfg.configId,
				type: type
			}, function(msg){
				var status = utils.getDataByPath(msg, "data.status");
				var entity = utils.getDataByPath(msg, "data.entity");
				if(status === "OK"){
					resolve(entity);
				}
				else{
					reject(msg.data);
				}
			}, function(error){
				reject(error);
			});
		});
	}
	function getIframeEnable(){
		var cfg = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getIframeEnable", {
				tenantId: cfg.tenantId,
				configId: cfg.configId
			}, function(dat){
				resolve(dat.data.entity);
			}, function(err){
				reject(err);
			});
		});
	}
	function getIframeSetting(){
		var cfg = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getIframeSetting", {
				tenantId: cfg.tenantId,
				configId: cfg.configId
			}, function(dat){
				resolve(dat.data.entities);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function createVisitor(specifiedUserName){
		var cfg = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("createVisitor", {
				orgName: cfg.orgName,
				appName: cfg.appName,
				imServiceNumber: cfg.toUser,
				tenantId: cfg.tenantId,
				specifiedUserName: specifiedUserName || ""
			}, function(msg){
				var entity = msg.data;
	
				if(entity){
					resolve(msg.data);
				}
				else{
					reject(new Error("error when attempt to create webim visitor"));
				}
			}, function(err){
				reject(err);
			});
		});
	}
	
	function createWechatImUser(openId){
		var config = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			emajax({
				url: "/v1/webimplugin/visitors/wechat/"
					+ [
					config.tenantId,
					config.orgName,
					config.appName,
					config.toUser,
					openId,
				].join("_")
					+ "?tenantId=" + config.tenantId,
				data: {
					orgName: config.orgName,
					appName: config.appName,
					imServiceNumber: config.toUser
				},
				type: "POST",
				success: function(resp){
					var parsed;
	
					try{
						parsed = JSON.parse(resp);
					}
					catch(e){}
	
					if((parsed && parsed.status) === "OK"){
						resolve(parsed.entity);
					}
					else{
						reject();
					}
				},
				error: function(err){
					reject(err);
				}
			});
		});
	}
	
	function getInviteInfo(){
		var cfg = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getInviteInfo", {
				tenantId: cfg.tenantId,
				configId: cfg.configId
			}, function(msg){
				var entity = utils.getDataByPath(msg, "data.entity");
				resolve(entity);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getQualificationStatus(tenantId) {
		return new Promise(function(resolve, reject){
			var isAuth = false;
			api("getQualificationStatus", { tenantId: tenantId }, function(res){
				var obj = res.data.entity;
				if(obj.isQualification == true){
					resolve("");
					return false
				}
				if(obj.isQualification !== null) {
					// 未提交申请
					if(obj.verifyStatus === null) {
						isAuth = 1;
					} 
					// 审核失败
					else if(obj.verifyStatus === 2) {
						isAuth = 2;
					}
					// 审核中
					else if(obj.verifyStatus === 0){
						isAuth = 3;
					}
				}else{
					// 老用户
				}
				
				resolve(isAuth);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getSlidebarSwitch(){
		var config = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getSlidebarSwitch", {
				tenantId: config.tenantId,
				configId: config.configId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				// reject(err);
				resolve(err);// 由于访客集成方式不一样，所以configId获取不到，做特殊处理
			});
		});
	}
	function getSidebarWidth(){
		var config = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getSidebarWidth", {
				tenantId: config.tenantId,
				configId: config.configId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				// reject(err);
				resolve(err);
			});
		});
	}
	function getSidebarFoldedrSwitch(){
		var config = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getSidebarFoldedrSwitch", {
				tenantId: config.tenantId,
				configId: config.configId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				// reject(err);
				resolve(err);
			});
		});
	}
	function putSidebarFoldedrSwitch(val){
		var config = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("putSidebarFoldedrSwitch", {
				tenantId: config.tenantId,
				configId: config.configId,
				val:val
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getDingdingVisitor(val){
		var config = commonConfig.getConfig();
		return new Promise(function(resolve, reject){
			api("getDingdingVisitor", {
				code: val.code,
				configId: config.configId,
				tenantId: val.tenantId
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				reject(err);
			});
		});
	}
	
	function getYspVisitorInfo(secret, visitorExt){
		return new Promise(function(resolve, reject){
			api("getYspVisitorInfo", {
	      customer: "ysp",
				secret: secret,
				visitorExt: visitorExt
			}, function(msg){
				var result = utils.getDataByPath(msg, "data");
				resolve(result);
			}, function(err){
				reject(err);
			});
		});
	}
	
	module.exports = {
		getTheme: getTheme,
		getPassword: getPassword,
		getRelevanceList: getRelevanceList,
		initApiTransfer: initApiTransfer,
		api: api,
		getConfig: getConfig,
		getConfigOption: getConfigOption,
		getFaqOrSelfServiceStatus: getFaqOrSelfServiceStatus,
		createVisitor: createVisitor,
		getCurrentServiceSession: getCurrentServiceSession,
		reportEvent: reportEvent,
		getWechatComponentId: getWechatComponentId,
		getWechatProfile: getWechatProfile,
		createWechatImUser: createWechatImUser,
		getInviteInfo: getInviteInfo,
		getIframeEnable: getIframeEnable,
		getIframeSetting: getIframeSetting,
		getQualificationStatus: getQualificationStatus,
		getSlidebarSwitch:getSlidebarSwitch,//获取侧边栏开关状态
		getSidebarFoldedrSwitch:getSidebarFoldedrSwitch,//获取侧边栏展开折叠状态
		putSidebarFoldedrSwitch:putSidebarFoldedrSwitch,//修改侧边栏展开折叠状态
		getSidebarWidth:getSidebarWidth,//获取侧边栏宽度
		getDingdingVisitor: getDingdingVisitor, // 获取钉钉访客信息
	  getYspVisitorInfo: getYspVisitorInfo, // 获取央视频访客信息
		update: function(cfg){
			config = cfg;
		}
	};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	// [HOST]
	// [IM]
	// [PROXY] [NOTE]
	
	// [HOST] -down2Im-> [IM] <-up2Im- [TRANS]
	// [HOST] <-toHost- [IM] -toProxy-> [TRANS]
	
	var isPostMessageSupportObj = (function(){
		var supportObject = true;
		try{
			window.postMessage({
				toString: function(){
					supportObject = false;
				}
			}, "*");
		}
		catch(e){}
		return supportObject;
	})();
	
	function handleMsg(e, callback, accept){
		// 兼容旧版的标志
		var flag = false;
		var data = e.data;
		var msg;
		var i;
		var l;
	
		// 47.9 及以后的版本 postMessage 会传 object （如果浏览器支持的话）
		if(typeof data === "object"){
			msg = data;
		}
		// 47.9 以前的版本或者浏览器不支持时 postMessage 会传 JSON.stringigy 后得到的字符串，需要解析
		else if(typeof data === "string"){
			try{
				msg = JSON.parse(data);
			}
			catch(err){}
	
			if(typeof msg !== "object"){
				return;
			}
		}
	
		if(accept && accept.length){
			for(i = 0, l = accept.length; i < l; i++){
				if(msg.key === accept[i]){
					flag = true;
					typeof callback === "function" && callback(msg);
				}
			}
		}
		else{
			typeof callback === "function" && callback(msg);
		}
	
		if(!flag && accept){
			for(i = 0, l = accept.length; i < l; i++){
				if(accept[i] === "data"){
					typeof callback === "function" && callback(msg);
					break;
				}
			}
		}
	}
	
	var Transfer = function(iframeId, key, useObject){
		if(!(this instanceof Transfer)){
			return new Transfer(iframeId);
		}
		this.key = key;
		this.iframe = document.getElementById(iframeId);
		this.origin = location.protocol + "//" + location.host;
		this.useObject = useObject;
	};
	
	Transfer.prototype.send = function(msg, to){
	
		msg.origin = this.origin;
	
		msg.key = this.key;
	
		if(this.to){
			msg.to = this.to;
		}
		else if(to){
			msg.to = to;
		}
	
		// this.useObject 在实例化时指定
		// msg.useObject 在调用 send 时指定
		// 这两种情况都有效，之所以这样设计是为了兼容老版本
		// 因为 em-transfer.js 总是最新版的，main.js 可能是老版本的
		// 所以需要在通信的 msg 中增加 useObject，用来指示使用哪种方式
		if(!(isPostMessageSupportObj && (this.useObject || msg.useObject))){
			msg = JSON.stringify(msg);
		}
	
		if(this.iframe){
			this.iframe.contentWindow.postMessage(msg, "*");
		}
		else{
			window.parent.postMessage(msg, "*");
		}
		return this;
	};
	
	Transfer.prototype.listen = function(callback, accept){
		var me = this;
	
		if(window.addEventListener){
			window.addEventListener("message", function(e){
				handleMsg.call(me, e, callback, accept);
			}, false);
		}
		else if(window.attachEvent){
			window.attachEvent("onmessage", function(e){
				handleMsg.call(me, e, callback, accept);
			});
		}
		return this;
	};
	
	module.exports = Transfer;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	var EMPTYFN = function(){};
	var _createStandardXHR = function(){
		try{
			return new window.XMLHttpRequest();
		}
		catch(e){
			return false;
		}
	};
	var _createActiveXHR = function(){
		try{
			return new window.ActiveXObject("Microsoft.XMLHTTP");
		}
		catch(e){
			return false;
		}
	};
	
	module.exports = function(options){
		var dataType = options.dataType || "text";
		var suc = options.success || EMPTYFN;
		var error = options.error || EMPTYFN;
		var useXDomainRequestInIE = options.useXDomainRequestInIE;
		var xhr = _createStandardXHR() || _createActiveXHR();
		var type = options.type || "GET";
		var data = options.data || {};
		var async = options.async;
		var tempData = "";
		var headers = options.headers || {};
		var isFileUpload = options.isFileUpload;
		var disableTimeStampInGet = options.disableTimeStampInGet;
		var key;
		var fileForm;
		var o;
	
		if(useXDomainRequestInIE && window.XDomainRequest){
			xhr = new XDomainRequest();
			xhr.onload = function(){
				var parsedJSON = {};
				try{
					parsedJSON = JSON.parse(xhr.responseText);
				}
				catch(e){}
				suc(parsedJSON, xhr);
			};
			xhr.ontimeout = function(){
				error(xhr.responseText, xhr, "XDomainRequest timeout.");
			};
			xhr.onerror = function(){
				error(xhr.responseText, xhr, "XDomainRequest error.");
			};
			xhr.open("POST", options.url);
			xhr.send(JSON.stringify(data));
			return xhr;
		}
	
		xhr.onreadystatechange = _onReadyStateChange;
		if(type.toLowerCase() === "get"){
			for(o in data){
				if(Object.prototype.hasOwnProperty.call(data, o)){
					tempData += o + "=" + data[o] + "&";
				}
			}
			// todo: use Array.prototype.join
			tempData = tempData ? tempData.slice(0, -1) : tempData;
			options.url += (~options.url.indexOf("?") ? "&" : "?")
				+ (tempData ? tempData + "&" : tempData)
				// 在需要读取缓存资源时不加时间戳
				+ (disableTimeStampInGet ? "" : "_v=" + new Date().getTime());
		}
		else if(isFileUpload){
			fileForm = new FormData();
			fileForm.append("file", data.file);
	
			xhr.open("POST", options.url);
			xhr.setRequestHeader("Authorization", data.auth);
			xhr.send(fileForm);
			return xhr;
		}
		else{
			data = JSON.stringify(data);
		}
		
		xhr.open(type, options.url, async);
		if(xhr.setRequestHeader){
			headers["Content-Type"] = headers["Content-Type"] || "application/json";
	
			for(key in headers){
				if(Object.prototype.hasOwnProperty.call(headers, key)){
					xhr.setRequestHeader(key, headers[key]);
				}
			}
		}
	
		xhr.send(data);
		return xhr;
	
		function _onReadyStateChange(){
			var json;
	
			if(xhr.readyState === 4){
				if(xhr.status === 200){
					if(dataType === "text"){
						suc(xhr.responseText, xhr);
						return;
					}
					if(dataType === "json"){
						try{
							json = JSON.parse(xhr.responseText);
							suc(json, xhr);
						}
						catch(e){}
						return;
					}
					suc(xhr.response || xhr.responseText, xhr);
					return;
				}
	
				if(dataType == "json"){
					try{
						json = JSON.parse(xhr.responseText);
						error(json, xhr, "error response.");
					}
					catch(e){
						error(xhr.responseText, xhr, "JSON parse error.");
					}
					return;
				}
				error(xhr.responseText, xhr, "error response.");
			}
			else if(xhr.readyState === 0){
				error(xhr.responseText, xhr, "unexpected server error.");
			}
		}
	};


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	
	var eventCallbackTable = {};
	
	module.exports = {
		add: add,
		excuteCallbacks: excuteCallbacks,
		trigger: trigger,
	};
	
	function add(eventOrArray, callback){
		if(typeof eventOrArray === "string"){
			_add(eventOrArray, callback);
		}
		else if(_.isArray(eventOrArray)){
			_.each(eventOrArray, function(event){
				_add(event, callback);
			});
		}
		else{
			throw new Error("unexpected type of event:", typeof eventOrArray);
		}
	}
	function _add(event, callback){
		if(typeof event !== "string") throw new Error("unexpected type of event.");
		if(!eventCallbackTable[event]) eventCallbackTable[event] = [];
		eventCallbackTable[event].push(callback);
	}
	
	function excuteCallbacks(event, argumentList){
		argumentList.push(event);
	
		_.each(eventCallbackTable[event], function(callback){
			try{
				callback.apply(null, argumentList);
			}
			catch(error){
				console.warn("error occurred when run event callbacks.", event, argumentList, error);
			}
		});
	}
	
	function trigger(){
		var event = arguments[0];
		var argumentList = arguments;
	
		_.each(eventCallbackTable[event], function(callback){
			try{
				callback.apply(null, argumentList);
			}
			catch(error){
				console.warn("error occurred when run event callbacks.", argumentList, error);
			}
		});
	}


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(13);
	window._ = __webpack_require__(13);
	var WebIM = __webpack_require__(136);
	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	var Dict = __webpack_require__(179);
	var List = __webpack_require__(187);
	var profile = __webpack_require__(178);
	var tools = __webpack_require__(188);
	var eventListener = __webpack_require__(185);
	var textParser = __webpack_require__(189);
	var apiHelper = __webpack_require__(181);
	var moment = __webpack_require__(17);
	var commonConfig = __webpack_require__(177);
	var getToHost = __webpack_require__(190);
	var uikit = __webpack_require__(180);
	
	var isNoAgentOnlineTipShowed;
	var receiveMsgTimer;
	var config;
	var conn;
	var evaluateTime;
	var evaluateFlag = false;
	// var isPullHistory = false;
	var activeAnswerTimeout;
	
	// 监听ack的timer, 每条消息启动一个
	var ackTimerDict = new Dict();
	
	// 发消息队列
	var sendMsgDict = new Dict();
	
	// 收消息队列
	var receiveMsgDict = new Dict();
	
	var _open = tools.retryThrottle(function(){
		var op = {
			user: config.user.username,
			appKey: config.appKey,
			apiUrl: location.protocol + "//" + config.restServer
		};
	
		if(profile.imToken !== null){
			op.accessToken = profile.imToken;
		}
		else{
			op.pwd = config.user.password;
		}
	
		conn.open(op);
	}, {
		resetTime: 10 * 60 * 1000,
		waitTime: 2000,
		retryLimit: 100 // 重连次数改为100次
	});
	
	window.sendText = _sendText;
	
	module.exports = {
		// todo: discard this
		init: function(){
			config = commonConfig.getConfig();
		},
		initConnection: _initConnection,
		reSend: _reSend,
		sendCmdExitVideo: _sendCmdExitVideo,
		sendTransferToKf: _sendTransferToKf,
		sendText: _sendText,
		sendImg: _sendImg,
		sendFile: _sendFile,
		sendVideo: _sendVideo, // 新增小视频发送类型
		attemptToAppendOfficialAccount: _attemptToAppendOfficialAccount,
		appendEventMsg: _appendEventMsg,
	
		// todo: move this to message view
		handleHistoryMsg: function(element){
			var textMessage = utils.getDataByPath(element, "body.bodies.0.msg");
			var titleMessage = utils.getDataByPath(element, "body.ext.msgtype.choice.title");
			// 后端历史消息转义2次，需要处理
			if(typeof textMessage === "string"){
				element.body.bodies[0].msg = textParser.unescape(textParser.unescape(textMessage));
			}
			if(typeof titleMessage === "string"){
				element.body.ext.msgtype.choice.title = textParser.unescape(textParser.unescape(titleMessage));
			}
			_handleMessage(_transformMessageFormat(element), { isHistory: true });
		},
		initSecondChannle: _initSecondChannle,
		handleMessage: _handleMessage
	};
	// 把初始化第二通道的方法提取出来，供外部方法调用
	function _initSecondChannle(){
		receiveMsgTimer = clearInterval(receiveMsgTimer);
		receiveMsgTimer = setInterval(function(){
			// var tab = sessionStorage.getItem("tabIdSession")
			var tab = null;
			tab = commonConfig.getConfig().tabIdSession;
			apiHelper.receiveMsgChannel(tab).then(function(msgList){
				_.each(msgList, function(elem){
					_handleMessage(_transformMessageFormat({ body: elem }), { isHistory: false });
				});
			});
		}, _const.SECOND_CHANNEL_MESSAGE_RECEIVE_INTERVAL);
	}
	
	function _initConnection(onReadyCallback){
		// xmpp连接超时则改为可发送消息状态
		// todo: 自动切换通道状态
		var firstTS = setTimeout(function(){
			onReadyCallback();
		}, _const.FIRST_CHANNEL_CONNECTION_TIMEOUT);
	
		// init connection
		conn = new WebIM.connection({
			url: config.xmppServer,
			retry: true,
			isMultiLoginSessions: true,
			heartBeatWait: _const.HEART_BEAT_INTERVAL,
			https: true
		});
	
		if(profile.imRestDown){
			onReadyCallback();
		}
	
		conn.listen({
			onOpened: function(info){
				// discard this
				if(info && info.accessToken && (profile.imToken === null)){
					profile.imToken = info.accessToken;
				}
				// 连接未超时，清除timer，暂不开启api通道发送消息
				clearTimeout(firstTS);
	
				conn.setPresence();
	
				onReadyCallback(info);
			},
			onTextMessage: function(message){
				_handleMessage(message, { type: "txt", notFromSystem: true });
			},
			onPictureMessage: function(message){
				_handleMessage(message, { type: "img" });
			},
			onFileMessage: function(message){
				_handleMessage(message, { type: "file" });
			},
			onVideoMessage: function(message){
				_handleMessage(message, { type: "video" });
			}, // 新增小视频类型
			onCmdMessage: function(message){
				_handleMessage(message, { type: "cmd" });
			},
			onOnline: function(){
				utils.isMobile && _open();
			},
			onOffline: function(){
				utils.isMobile && conn.close();
	
				eventListener.excuteCallbacks(_const.SYSTEM_EVENT.OFFLINE, []);
			},
			onError: function(e){
				console.log(e);
				if(e.reconnect){
					// _open();
					// 在移动端会触发多次重连，导致自己多次登录，影响多端登录的判断
					!utils.isMobile && _open();
				}
				else if(e.type === _const.IM.WEBIM_CONNCTION_AUTH_ERROR){
					_open();
				}
				// im sdk 会捕获回调中的异常，需要把出错信息打出来
				else if(e.type === _const.IM.WEBIM_CONNCTION_CALLBACK_INNER_ERROR){
					console.error(e.data);
				}
				else{
					console.error(e);
				}
				// 当多端登录挤掉上一个ws链接的时候给出提示
				if(e.type == "Replaced by new connection"){
					if(config.tenantId == "66639"){
						return false;
					}
					_refreshDialog();
					// 在收到多端登录信息时候，第二通道轮询暂且不清除。
					// TODO: 等查清楚重新连接以后第二通通道轮询没开启的原因再把这行注释解开
					// clearInterval(receiveMsgTimer);
					eventListener.trigger(_const.SYSTEM_EVENT.CHAT_CLOSED);
					eventListener.trigger(_const.SYSTEM_EVENT.CLEAR_AGENTSTATE);
					eventListener.trigger(_const.SYSTEM_EVENT.CLEAR_AGENTINPUTSTATE);
					eventListener.trigger(_const.SYSTEM_EVENT.IS_PULL_HISTORY);
					return false;
				}
			}
		});
	
	
	
		// open connection
		_open();
		// 在刚开始执行的时候获取满意度时效的值
		apiHelper.getEvaluatePrescription().then(function(res){
			if(res){
				evaluateTime = res;
			}
			else{
				evaluateTime = 8 * 3600;
			}
		});
		// 添加一个监听事件判断是否调用历史消息
		eventListener.add(_const.SYSTEM_EVENT.IS_PULL_HISTORY, function(){
			receiveMsgDict = new Dict();
		});
	}
	function _refreshDialog(){
		var modelDom = utils.createElementFromHTML("<div class=\"em-model\"></div>");
		var chat = document.getElementById("em-kefu-webim-chat");
		chat.append(modelDom);
		var dialog = uikit.createDialog({
			contentDom: [
				"<p class=\"prompt\">",
				"You have initiated a consultation on other pages, and the current consultation is invalid. You can initiate a consultation again",
				"</p>"
			].join(""),
			className: "refresh-dialog"
		}).addButton({
			hideCancel: true,
			confirmText: "Reconnecting",
			confirm: function(){
				var el = document.getElementsByTagName("body");
				getToHost.send({ event: _const.EVENTS.CLOSE });
				if($(el).hasClass("window-demo")){
					// 小窗口集成的页面也刷新防止ws接收错误信息
					window.location.reload();
					window.sessionStorage && sessionStorage.setItem("chartIsShow", true);
				}
				else{
					window.location.reload();
				}
			}
		});
		dialog.show();
	}
	function _reSend(type, id){
		if(!id) return;
	
		switch(type){
		case "txt":
				// 重试只发一次
			_sendMsgChannle(id, 0);
			break;
		default:
				// todo: 解决图片文件无法重发问题
			conn.send(id);
			break;
		}
	}
	
	function _sendText(message, ext){
		var id = utils.uuid();
		var msg = new WebIM.message.txt(id);
		msg.set({
			msg: message,
			to: config.toUser,
			// 此回调用于确认im server收到消息, 有别于kefu ack
			success: function(/* id */){ },
			fail: function(/* id */){ }
		});
		if(ext){
			_.extend(msg.body, ext);
		}
		_setExt(msg);
		_appendAck(msg, id);
		conn.send(msg.body);
		sendMsgDict.set(id, msg);
		_detectSendTextMsgByApi(id);
	
		_promptNoAgentOnlineIfNeeded({
			hasTransferedToKefu: !!~"Chat with agent".slice("|").indexOf(message)
		});
	
		_handleMessage(
			_transfromImMessage(msg),
			{ isReceived: false, isHistory: false, type: "txt", notFromSystem: true }
		);
	
		eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CLEAR_TIMEOUT, []);
		clearActiveAnswerTimeout();
		_clearNiceName();
	}
	
	// 这个临时使用，下个版本会去掉
	function _transfromImMessage(msg){
		return {
			data: utils.getDataByPath(msg, "body.body.msg") || "",
			ext: utils.getDataByPath(msg, "body.ext") || "",
			type: utils.getDataByPath(msg, "body.type"),
		};
	}
	
	function _sendTransferToKf(tid, sessionId, transferToHumanId){
		var id = utils.uuid();
		var msg = new WebIM.message.cmd(id);
		var msgAction = transferToHumanId ? transferToHumanId : "TransferToKf";
		msg.set({
			to: config.toUser,
			action: msgAction,
			ext: {
				weichat: {
					ctrlArgs: {
						id: tid,
						serviceSessionId: sessionId
					}
				}
			}
		});
		_setExt(msg);
		_appendAck(msg, id);
		conn.send(msg.body);
		sendMsgDict.set(id, msg);
		_detectSendTextMsgByApi(id);
	
		_promptNoAgentOnlineIfNeeded({ hasTransferedToKefu: true });
		eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CLEAR_TIMEOUT, []);
		clearActiveAnswerTimeout();
		_clearNiceName();
	}
	function _sendCmdExitVideo(callId, ext){
		var id = utils.uuid();
		var msg = new WebIM.message.cmd(id);
		var msgAction = "Agorartcmedia";
		msg.set({
			to: config.toUser,
			action: msgAction,
		});
		if(ext){
			_.extend(msg.body, ext);
		}
		_setExt(msg);
		_appendAck(msg, id);
		conn.send(msg.body);
		sendMsgDict.set(id, msg);
		_detectSendTextMsgByApi(id);
	
		_promptNoAgentOnlineIfNeeded({ hasTransferedToKefu: true });
		eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CLEAR_TIMEOUT, []);
		clearActiveAnswerTimeout();
	}
	
	function _sendImg(fileMsg){
		var id = utils.uuid();
		var msg = new WebIM.message.img(id);
	
		msg.set({
			apiUrl: location.protocol + "//" + config.restServer,
			file: fileMsg,
			accessToken: profile.imToken,
			to: config.toUser,
			success: function(id){
				// todo: 验证这里是否执行，验证此处id是im msg id 还是 kefu-ack-id
				_hideFailedAndLoading(id);
			},
			fail: function(id){
				_showFailed(id);
			},
		});
		_setExt(msg);
		_appendAck(msg, id);
		_appendMsg({
			id: id,
			type: "img",
			url: fileMsg.url
		}, {
			isReceived: false,
			isHistory: false,
		});
		conn.send(msg.body);
		sendMsgDict.set(id, msg);
		_detectUploadImgMsgByApi(id, fileMsg.data, "img");
	
		// 自己发出去的图片要缓存File对象，用于全屏显示图片
		profile.imgFileList.set(fileMsg.url, fileMsg.data);
		eventListener.excuteCallbacks(_const.SYSTEM_EVENT.MESSAGE_SENT, []);
		eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CLEAR_TIMEOUT, []);
		clearActiveAnswerTimeout();
		_clearNiceName();
	}
	
	function _sendFile(fileMsg){
		var id = utils.uuid();
		var msg = new WebIM.message.file(id);
	
		msg.set({
			apiUrl: location.protocol + "//" + config.restServer,
			file: fileMsg,
			to: config.toUser,
			success: function(id){
				// todo: 验证这里是否执行，验证此处id是im msg id 还是 kefu-ack-id
				_hideFailedAndLoading(id);
			},
			fail: function(id){
				_showFailed(id);
			},
		});
		msg.fileLength = fileMsg.data.size;
		_setExt(msg);
		_appendMsg({
			id: id,
			type: "file",
			url: fileMsg.url,
			filename: fileMsg.filename,
			fileLength: fileMsg.data.size,
		}, {
			isReceived: false,
			isHistory: false,
		});
		_appendAck(msg, id);
		conn.send(msg.body);
		sendMsgDict.set(id, msg);
		_detectUploadImgMsgByApi(id, fileMsg.data, "file");
		eventListener.excuteCallbacks(_const.SYSTEM_EVENT.MESSAGE_SENT, []);
		eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CLEAR_TIMEOUT, []);
		clearActiveAnswerTimeout();
		_clearNiceName();
	}
	
	// 小视频发送
	function _sendVideo(fileMsg){
		var id = utils.uuid();
		var msg = new Message.video(id); //   new Message.video => 339行  message 格式的转换
	
		msg.set({
			apiUrl: location.protocol + "//" + config.restServer,
			file: fileMsg,
			to: config.toUser,
			success: function(id){
				// todo: 验证这里是否执行，验证此处id是im msg id 还是 kefu-ack-id
				_hideFailedAndLoading(id);
			},
			fail: function(id){
				_showFailed(id);
			},
		});
		_setExt(msg);
		_appendMsg({
			id: id,
			type: "video",
			url: fileMsg.url,
			filename: fileMsg.filename,
			fileLength: fileMsg.data.size,
		}, {
			isReceived: false,
			isHistory: false,
		});
		_appendAck(msg, id);
		conn.send(msg.body);
		sendMsgDict.set(id, msg);
		_detectUploadImgMsgByApi(id, fileMsg.data, "video");
		eventListener.excuteCallbacks(_const.SYSTEM_EVENT.MESSAGE_SENT, []);
		eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CLEAR_TIMEOUT, []);
		clearActiveAnswerTimeout();
		_clearNiceName();
	}
	function _clearNiceName(){
		// 发完消息清除nicename
		commonConfig.setConfig({
			userNicknameFlg: null
		});
	}
	
	// 新增 视频格式发送
	var Message = function(type, id){
		if(!(this instanceof Message)){
			return new Message(type);
		}
	
		this._msg = {};
	
		if(typeof Message[type] === "function"){
			Message[type].prototype.setGroup = this.setGroup;
			this._msg = new Message[type](id);
		}
		return this._msg;
	};
	
	Message.video = function(id){
		this.id = id;
		this.type = "video";
		this.body = {};
	};
	Message.video.prototype.set = function(opt){
		opt.file = opt.file;
	
		this.value = opt.file;
		this.filename = opt.filename || this.value.filename;
	
		this.body = {
			id: this.id
			, file: this.value
			, filename: this.filename
			, apiUrl: opt.apiUrl
			, to: opt.to
			, type: this.type
			, ext: opt.ext || {}
			, roomType: opt.roomType
			, onFileUploadError: opt.onFileUploadError
			, onFileUploadComplete: opt.onFileUploadComplete
			, success: opt.success
			, fail: opt.fail
			, flashUpload: opt.flashUpload
			, body: opt.body
		};
		!opt.roomType && delete this.body.roomType;
	};
	
	
	function _handleMessage(msg, options){
		var opt = options || {};
		var type = opt.type || (msg && msg.type);
		var noPrompt = opt.noPrompt;
		var isHistory = opt.isHistory;
		var eventName = utils.getDataByPath(msg, "ext.weichat.event.eventName");
		var eventObj = utils.getDataByPath(msg, "ext.weichat.event.eventObj");
		var laiye = opt.laiye || utils.getDataByPath(msg, "ext.weichat.extRobot.laiye");
		var msgId = utils.getDataByPath(msg, "ext.weichat.msgId")
			// 这是自己发出去的消息的 msgId，此为临时修改，在完成 messageBuilder 之后应该就可以去掉了
			|| utils.getDataByPath(msg, "ext.weichat.msg_id_for_ack");
		var isReceived = typeof opt.isReceived === "boolean"
			? opt.isReceived
			// from 不存在默认认为是收到的消息
			: (!msg.from || (msg.from.toLowerCase() !== config.user.username.toLowerCase()));
		var officialAccount = utils.getDataByPath(msg, "ext.weichat.official_account");
		var marketingTaskId = utils.getDataByPath(msg, "ext.weichat.marketing.marketing_task_id");
		var satisfactionCommentInvitation = utils.getDataByPath(msg, "ext.weichat.extRobot.satisfactionCommentInvitation");
		var satisfactionCommentInfo = utils.getDataByPath(msg, "ext.weichat.extRobot.satisfactionCommentInfo");
		var agentId = utils.getDataByPath(msg, "ext.weichat.agent.userId");
		var officialAccountId = officialAccount && officialAccount.official_account_id;
		var videoTicket = utils.getDataByPath(msg, "ext.msgtype.sendVisitorTicket.ticket");
		var videoExtend = utils.getDataByPath(msg, "ext.msgtype.sendVisitorTicket.extend");
		var whiteBoardTicket = utils.getDataByPath(msg, "ext.msgtype.roomData");
		var videoEndArgo = utils.getDataByPath(msg, "ext.msgtype.videoPlayback");
		var customMagicEmoji = utils.getDataByPath(msg, "ext.msgtype.customMagicEmoji");
		var activeAnswerBundle = utils.getDataByPath(msg, "ext.activeAnswerBundle");
		var targetOfficialAccount;
		var message;
		var inviteId;
		var serviceSessionId;
		msg.fileLength = msg.fileLength || msg.file_length || (msg.ext && msg.ext.file_length) || "";
	
		// 重复消息不处理
		if(receiveMsgDict.get(msgId)){
			return;
		}
		// 消息加入去重列表
		else if(msgId){
			receiveMsgDict.set(msgId, msg);
		}
		// 没有 msgId 忽略，继续处理（KEFU-ACK 消息没有 msgId）
		else{
		}
		// 绑定访客的情况有可能会收到多关联的消息，不是自己的不收
		if(!isHistory && msg.from && msg.from.toLowerCase() != config.toUser.toLowerCase() && !noPrompt){
			return;
		}
		// 撤回的消息不处理
		if(utils.getDataByPath(msg, "ext.weichat.recall_flag") === 1){
			return;
		}
		// 尝试
		if(officialAccount){
			_attemptToAppendOfficialAccount(officialAccount);
		}
		targetOfficialAccount = _getOfficialAccountById(officialAccountId);
	
		if(targetOfficialAccount.agentState == "Online"){
			profile.isAgentStateOnline = true;
		}
		// ===========
		// 消息类型判断
		// ===========
		// 满意度评价
		if(utils.getDataByPath(msg, "ext.weichat.ctrlType") === "inviteEnquiry"){
			type = "satisfactionEvaluation";
		}
		// 机器人自定义菜单
		// 需要判断：收到的 choice 显示为菜单，发出的 choice 渲染为文本消息
		else if(
			isReceived
			&& utils.getDataByPath(msg, "ext.msgtype.choice.title")
			&& utils.getDataByPath(msg, "ext.msgtype.choice.items")
			&& !utils.getDataByPath(msg, "ext.msgtype.choice.mode")
	    && type !== "tianrunRobotWelcomeList"
		){
			type = "robotList";
		}
		// 待接入超时转留言
		else if(
			eventName === "ServiceSessionWillScheduleTimeoutEvent"
			&& eventObj
			&& eventObj.ticketEnable === "true"
		){
			type = "transferToTicket";
		}
		else if(utils.getDataByPath(msg, "ext.msgtype.articles")){
			type = "article";
		}
		// track 消息在访客端不与处理
		else if(utils.getDataByPath(msg, "ext.msgtype.track")){
			type = "track";
		}
		// order 消息在访客端不与处理
		else if(utils.getDataByPath(msg, "ext.msgtype.order")){
			type = "order";
		}
		else if(utils.getDataByPath(msg, "ext.type") === "html/form"){
			type = "html-form";
		}
		// 视频 ticket
		else if(videoTicket){
			type = "rtcVideoTicket";
		}
		else if(videoEndArgo){
			type = "videoEndArgo";
		}
		else if(whiteBoardTicket){
			type = "whiteBoardTicket";
		}
		else if(customMagicEmoji){
			type = "customMagicEmoji";
		}
		else if(
			isReceived
			&& utils.getDataByPath(msg, "ext.msgtype.choice.mode") == "transferManualGuide"
		){
			type = "transferManualGuide";
		}
		else{
	
		}
	
		var myconfig = commonConfig.getConfig();
		var themeCustomColor = myconfig.themeCustomColor;
	
	
		// ===========
		// 消息结构构造
		// ===========
		switch(type){
		case "txt":
			message = msg;
			message.type = type;
			message.data = (msg && msg.data) || "";
			message.brief = textParser.getTextMessageBrief(message.data, isReceived);
			break;
		case "img":
			message = msg;
			message.type = type;
			message.brief = "[Image]";
			break;
		case "file":
			message = msg;
			message.type = type;
			message.brief = "[File]";
			break;
		case "video":
			message = msg;
			message.type = type;
			message.brief = "[Video]";	// 页面接收提示视频
			break;
		case "article":
		case "track":
		case "order":
			message = msg;
			message.type = type;
			break;
		case "customMagicEmoji":
			message = customMagicEmoji;
			message.type = type;
			message.brief = "[Emoticon]";
			break;
		case "html-form":
			message = msg;
			message.type = type;
			message.brief = "[Unknown]";
			break;
		case "cmd":
			var action = msg.action;
			if(action === "KF-ACK"){
					// 清除 ack 对应的 site item
				_clearTS(msg.ext.weichat.ack_for_msg_id);
				return;
			}
			else if(action === "KEFU_MESSAGE_RECALL"){
					// 撤回消息命令
				var recallMsgId = msg.ext.weichat.recall_msg_id;
				var dom = document.getElementById(recallMsgId);
				utils.addClass(dom, "hide");
			}
			break;
		case "rtcVideoTicket":
			!isHistory && eventListener.excuteCallbacks(_const.SYSTEM_EVENT.VIDEO_TICKET_RECEIVED, [videoTicket, videoExtend]);
			break;
		case "satisfactionEvaluation":
			if(!evaluateTime){
				evaluateTime = 8 * 3600;
			}
			var time;
			var closeArrDate = JSON.parse(utils.getStore("closDate"));
			serviceSessionId = msg.ext.weichat.ctrlArgs.serviceSessionId;
			var closid = [];
				// 处理历史消息
			if(closeArrDate){
				if(closeArrDate.length != 0){
					for(var i = 0; i < closeArrDate.length; i++){
						if(serviceSessionId === closeArrDate[i].id){
							time = closeArrDate[i].timp;
						}
						closid.push(closeArrDate[i].id);
					}
				}
				else{
					time = new Date().getTime();
				}
			}
			else{
				time = new Date().getTime();
			}
	
				// 过来的即时消息不计算过期时间，在结束时候计算
			if(closid.indexOf(serviceSessionId) < 0){
				time = new Date().getTime();
			}
			var SessionId = profile.currentOfficialAccount.sessionId;
				// evaluateFlag是个标志位，处理会话结束后发来的邀请评价
			if((closid.indexOf(serviceSessionId) < 0) && !evaluateFlag && serviceSessionId != SessionId){
					// 此处的时间：历史消息获取是10条一组，会话结束的事件跟评价可能不在同一组，这里无法取到，取当前消息的时间
				time = msg.timestamp;
			}
	
			var isInvalid = new Date().getTime() - time;
			if(evaluateTime * 1000 > isInvalid){
				inviteId = msg.ext.weichat.ctrlArgs.inviteId;
					// serviceSessionId = msg.ext.weichat.ctrlArgs.serviceSessionId;
				message = msg;
				message.type = "list";
				message.subtype = type;
				message.data = "Please rate my service";
				message.list = [
					"<div class=\"em-btn-list\">"
						+ "<button class=\" js_satisfybtn fg-color\" data-inviteid=\""
						+ inviteId
						+ "\" data-servicesessionid=\""
						+ serviceSessionId
						+ "\">" + "Rate" + "</button></div>"
				];
				message.brief = "[Menu]";
				!isHistory && config.ui.enquiryShowMode === "popup" && eventListener.excuteCallbacks(
						_const.SYSTEM_EVENT.SATISFACTION_EVALUATION_MESSAGE_RECEIVED,
						[targetOfficialAccount, inviteId, serviceSessionId]
					);
					// isInvalid 本轮会话结束时间距离这条消息刚创建的时间（是否超过设置的评价失效时间）
					// evaluateTime 客服系统设置的评价超时的时间
					// 判断是否是过来的即时评价消息，是的话不失效，在结束会话时候处理（即时评价消息有主动邀请和结束会话两种）
				if(!(closid.indexOf(serviceSessionId) < 0) || evaluateFlag){
					setTimeout(function(){
						var btn = $(".em-btn-list>button[data-servicesessionid=" + serviceSessionId + "]");
						btn.removeClass("bg-hover-color");
						btn.removeClass("js_satisfybtn");
						btn.text("Invalid");
						btn.addClass("invalid-btn");
						btn.addClass("disabled");
						evaluateFlag = false;
					}, evaluateTime * 1000 - isInvalid);
				}
			}
			else{
				inviteId = msg.ext.weichat.ctrlArgs.inviteId;
				serviceSessionId = msg.ext.weichat.ctrlArgs.serviceSessionId;
				message = msg;
				message.type = "list";
				message.subtype = type;
				message.data = "Please rate my service";
				message.list = [
					"<div class=\"em-btn-list\">"
						+ "<button class=\"invalid-btn\" data-inviteid=\""
						+ inviteId
						+ "\" data-servicesessionid=\""
						+ serviceSessionId
						+ "\">" + "Invalid" + "</button></div>"
				];
				message.brief = "[Menu]";
				!isHistory && config.ui.enquiryShowMode === "popup" && eventListener.excuteCallbacks(
						_const.SYSTEM_EVENT.SATISFACTION_EVALUATION_MESSAGE_RECEIVED,
						[targetOfficialAccount, inviteId, serviceSessionId]
					);
			}
			break;
	  // 暂时针对天润欢迎语菜单设定
	  case "tianrunRobotWelcomeList":
	    message = msg;
			message.type = "tianrunRobotWelcomeListMessageType";
			// message.subtype = type;
	    // message.list = "<div class=\"em-btn-list\">";
			// _.each(msg.ext.msgtype.choice.items, function(item, index){
	    //   var className = "";
			// 	var color = "";
	    //   className = themeCustomColor ? "" : "fg-color";
	    //   color = themeCustomColor;
	
	    //   var callback = item.callback || "";
	    //   var node = item.node || "";
			// 	if(options.answerSource == "WELCOME"){
			// 		if(index < 5){
			// 			message.list += "<li  data-index=" + index + "><button "
			// 					+ "class=\"js_robotbtn " + className + "\" "
			// 					+ "style=\"color: " + color + " \""
			// 					+ "data-callback=\"" + callback + "\" " + "data-node=\"" + node + "\" " + "data-id=\"" + item.id + "\" "
			// 					+ ">" + item.name + "</button> <i class='icon-arrow-right'></i> </li>";
			// 		}
			// 		else{
			// 			message.list += "<li class='hide'  data-index=" + index + "><button "
			// 					+ "class=\"js_robotbtn " + className + "\" "
			// 					+ "style=\"color: " + color + " \""
			// 					+ "data-callback=\"" + callback + "\" " + "data-node=\"" + node + "\" " + "data-id=\"" + item.id + "\" "
			// 					+ ">" + item.name + "</button> <i class='icon-arrow-right'></i> </li>";
			// 		}
			// 	}
			// });
	
			// if(options.answerSource == "WELCOME" && msg.ext.msgtype.choice.items.length > 5){
			// 	message.list += "<span class='welcome-change'><i class='icon-change-copy'></i> <span>换一换</span></span>";
			// }
	
			// message.list += "</div>";
			// message.data = msg.ext.msgtype.choice.title;
			message.brief = "[Menu]";
	    break;
	  // 常规的通用富文本展示
	  case "commonRichText":
	    message = msg;
	    message.type = "commonRichText";
	    message.data = textParser.unescape(msg.data);
	    break;
		case "robotList":
				// 如果取不到，就默认 true 打开菜单
				// 这个 service_session 对象，对于欢迎语类的消息，是没有的
			serviceSessionId = utils.getDataByPath(msg, "ext.weichat.service_session.serviceSessionId");
			message = msg;
			message.type = "list";
			message.subtype = type;
			message.list = "<div class=\"em-btn-list\">";
			_.each(msg.ext.msgtype.choice.items, function(item, index){
	      var className = "";
				var color = "";
				if(profile.shouldMsgActivated(serviceSessionId)){
					className = themeCustomColor ? "" : "fg-color";
					color = themeCustomColor;
				}
				else{
					className = "disabled";
					color = "";
				}
	
	      var callback = item.callback || "";
	      var node = item.node || "";
				if(options.answerSource == "WELCOME"){
					if(index < 5){
						message.list += "<li  data-index=" + index + "><button "
								+ "class=\"js_robotbtn " + className + "\" "
								+ "style=\"color: " + color + " \""
								+ "data-callback=\"" + callback + "\" " + "data-node=\"" + node + "\" " + "data-id=\"" + item.id + "\" "
								+ ">" + item.name + "</button> <i class='icon-arrow-right'></i> </li>";
					}
					else{
						message.list += "<li class='hide'  data-index=" + index + "><button "
								+ "class=\"js_robotbtn " + className + "\" "
								+ "style=\"color: " + color + " \""
								+ "data-callback=\"" + callback + "\" " + "data-node=\"" + node + "\" " + "data-id=\"" + item.id + "\" "
								+ ">" + item.name + "</button> <i class='icon-arrow-right'></i> </li>";
					}
				}
				else{
					message.list += "<li  data-index=" + index + "><button "
							+ "class=\"js_robotbtn " + className + "\" "
							+ "style=\"color: " + color + " \""
							+ "data-callback=\"" + callback + "\" " + "data-node=\"" + node + "\" " + "data-id=\"" + item.id + "\" "
							+ ">" + item.name + "</button> <i class='icon-arrow-right'></i> </li>";
				}
	
			});
			if(options.answerSource == "WELCOME" && msg.ext.msgtype.choice.items.length > 5){
				message.list += "<span class='welcome-change'><i class='icon-change-copy'></i> <span>换一换</span></span>";
			}
			message.list += "</div>";
			message.data = msg.ext.msgtype.choice.title;
			message.brief = "[Menu]";
			break;
		case "transferManualGuide":
			serviceSessionId = utils.getDataByPath(msg, "ext.weichat.service_session.serviceSessionId");
			message = msg;
			message.type = "list";
			message.subtype = type;
			message.list = "<div class=\"em-btn-list\">"
					+ _.map(msg.ext.msgtype.choice.items, function(item){
						if(item.queueType == "video"){
							if(
								window.location.protocol !== "https:"
								|| !Modernizr.peerconnection
								|| !profile.grayList.audioVideo
							){
								return "";
							}
						}
						if(item.id == "hasTransferNote"){
							item.queueType = "transfer";
						}
	
						var className = "";
						var color = "";
						if(profile.shouldMsgActivated(serviceSessionId)){
							className = themeCustomColor ? "" : "fg-color";
							color = themeCustomColor;
						}
						else{
							className = "disabled";
							color = "";
						}
	
						return "<button "
							+ "class=\"js_transferManualbtn " + className + "\" "
							+ "style=\"color: " + color + " \""
							+ "data-id=\"" + item.id + "\" "
							+ "data-queue-id=\"" + item.queueId + "\" "
							+ "data-queue-type=\"" + item.queueType + "\" "
							+ ">" + item.name + "</button>";
					}).join("") || ""
					+ "</div>";
			message.data = msg.ext.msgtype.choice.title;
			message.brief = "[Menu]";
			break;
		case "skillgroupMenu":
			message = msg;
			message.type = "list";
			message.subtype = type;
			message.list = "<div class=\"em-btn-list\">"
					+ _.map(msg.data.children, function(item){
						var queueName = item.queueName;
						var label = item.menuName;
						var className = themeCustomColor ? "js_skillgroupbtn" : "js_skillgroupbtn fg-color";
	
						return "<li><button "
							+ " class=\"" + className + "\""
							+ "style=\"color: " + themeCustomColor + " \""
							+ "data-queue-name=\"" + queueName + "\">"
							+ label + "</button><i class='icon-arrow-right'></i></li>";
					}).join("") || ""
					+ "</div>";
			message.data = msg.data.menuName;
			message.brief = "[Menu]";
			break;
			// 入口指定
		case "transferManualMenu":
			message = msg;
			message.type = "list";
			message.subtype = type;
			var array = msg.data.children;
			if(msg.data.hasTransferNote){
				var transferChild = {
					queueName: "hasTransferNote",
					itemName: "转留言",
					queueType: "transfer"
				};
				array.push(transferChild);
			}
				// 判断没有视频功能时，隐藏type为video的item
	
			message.list = "<div class=\"em-btn-list\">"
					+ _.map(array, function(item){
						var queueName = item.queueName;
						var label = item.itemName;
						var queueType = item.queueType;
						var className = "js_transferManualEntrybtn fg-color";
						if(item.queueType == "video"){
							if(
								window.location.protocol !== "https:"
								|| !Modernizr.peerconnection
								|| !profile.grayList.audioVideo
							){
								return "";
							}
						}
	
						return "<button class=\"" + className + "\" data-queue-name=\"" + queueName + "\" data-queue-type=\"" + queueType + "\">" + label + "</button>";
					}).join("") || ""
					+ "</div>";
			message.data = msg.data.itemName;
			message.brief = "[Menu]";
			break;
		case "robotTransfer":
			var ctrlArgs = msg.ext.weichat.ctrlArgs;
			message = msg;
			message.type = "list";
			message.subtype = type;
			message.data = message.data || utils.getDataByPath(msg, "ext.weichat.ctrlArgs.label");
				// msg.ext.weichat.ctrlArgs.label 未知是否有用，暂且保留
				// 此处修改为了修复取出历史消息时，转人工评价标题改变的 bug
				// 还有待测试其他带有转人工的情况
			message.list = [
				"<div class=\"em-btn-list\">",
				"<button class=\"white fg-color js_robotTransferBtn\" ",
				"data-sessionid=\"" + ctrlArgs.serviceSessionId + "\" ",
				"data-id=\"" + ctrlArgs.id + "\">" + ctrlArgs.label + "</button>",
				"</div>"
			].join("");
			message.brief = "[Menu]";
			break;
		case "transferToTicket":
			message = msg;
			message.type = "list";
			message.subtype = type;
			message.list = [
				"<div class=\"em-btn-list\">",
				"<button class=\"white fg-color js-transfer-to-ticket\">",
				"Note",
				"</button>",
				"</div>"
			].join("");
			message.brief = "[Menu]";
			break;
		case "videoEndArgo":
			message = msg;
			message.type = "txt";
			message.data = (msg && msg.data) || "";
			message.brief = textParser.getTextMessageBrief(message.data, isReceived);
			!isHistory && eventListener.excuteCallbacks(_const.SYSTEM_EVENT.VIDEO_ARGO_END, [videoEndArgo]);
			break;
		case "whiteBoardTicket":
			message = msg;
			message.type = "txt";
			message.data = (msg && msg.data) || "";
			message.brief = textParser.getTextMessageBrief(message.data, isReceived);
			!isHistory && eventListener.excuteCallbacks(_const.SYSTEM_EVENT.WHITE_BOARD_RECEIVED, [whiteBoardTicket]);
			break;
		default:
			console.error("unexpected msg type");
			break;
		}
	
		if(!isHistory){
			// 实时消息需要处理系统事件
			marketingTaskId
				&& type === "txt"
				&& eventListener.excuteCallbacks(
					_const.SYSTEM_EVENT.MARKETING_MESSAGE_RECEIVED,
					[
						targetOfficialAccount,
						marketingTaskId,
						msg
					]
				);
	
			if(eventName){
				_handleSystemEvent(eventName, eventObj, msg);
			}
			else{
				var agentInfo = utils.getDataByPath(msg, "ext.weichat.agent");
				var isThirdAgent = utils.getDataByPath(msg, "ext.msgtype.sendVisitorTicket.ticket.isThirdAgent");
				if(agentInfo && !isThirdAgent){
					targetOfficialAccount.agentNickname = agentInfo.userNickname;
					targetOfficialAccount.agentAvatar = agentInfo.avatar;
					eventListener.excuteCallbacks(_const.SYSTEM_EVENT.AGENT_INFO_UPDATE, [targetOfficialAccount]);
				}
			}
		}
	
		// ===========
		// 消息类型上屏
		// ===========
		if(
			!message
			// 空文本消息不上屏
			|| (type === "txt" && !message.data)
			// 空文章不上屏
			|| (type === "article" && _.isEmpty(utils.getDataByPath(msg, "ext.msgtype.articles")))
			// 视频邀请不上屏
			|| (type === "rtcVideoTicket")
			// 白板消息不上屏
			|| (type === "whiteBoardTicket")
			// 订单轨迹按条件上屏
			|| ((type === "track" || type === "order") && !profile.isShowTrackMsg)
		){
			return;
		}
	
		// 给收到的消息加 id，用于撤回消息
		message.id = msgId;
	
		// 消息上屏
	
		message.laiye = laiye;
		var dat = message.data;
		// 来也机器人多条消息逐条展示
		if(laiye && !isJsonString(dat)){
			dat = dat.replace(/&amp;amp;quot;|&amp;quot;/g, "\"");
		}
		if(profile.grayList.multipleMsgOneByOne && laiye && isJsonString(dat)){
			dat = JSON.parse(dat);
			dat.forEach(function(item, index){
				var arr = [item];
				message.data = JSON.stringify(arr);
				if(item.type == "text"){
					message.type = "txt";
				}
				else if(item.type == "image"){
					message.type = "img";
					message.url = item.content;
				}
				else if(item.type == "richtext"){
					var articleDom = apiHelper.getlaiyeHtml(item.content);
					message.data = articleDom.response;
					message.type = "txt";
				}
				else{
					message.type = item.type;
				}
				message.multipleMsgOneByOne = true;
				_appendMsg(message, {
					isReceived: isReceived,
					isHistory: isHistory,
					officialAccount: targetOfficialAccount,
					timestamp: msg.timestamp,
					noPrompt: noPrompt,
				});
			});
		}
		else{
			_appendMsg(message, {
				isReceived: isReceived,
				isHistory: isHistory,
				officialAccount: targetOfficialAccount,
				timestamp: msg.timestamp,
				noPrompt: noPrompt,
				notFromSystem: opt.notFromSystem
			});
		}
	
		// 挽回
		if(!isHistory && activeAnswerBundle && activeAnswerBundle.activeAnswers && activeAnswerBundle.activeAnswers.length > 0){
			activeAnswerMessage(activeAnswerBundle, 0);
		}
	
		// 是否发送解决未解决 msg.ext.extRobot.satisfactionCommentInvitation
		// if(satisfactionCommentInvitation && !isHistory){
		// 	_appendMsg({
		// 		data: "<p>此次服务是否已解决您的问题：</p><a class='statisfyYes' data-satisfactionCommentInfo='" + satisfactionCommentInfo + "' data-agentId='" + agentId + "'>解决</a>/<a class='statisfyNo' data-satisfactionCommentInfo='" + satisfactionCommentInfo + "' data-agentId='" + agentId + "'>未解决</a>",
		// 		type: "txtLink",
		// 	}, {
		// 		isReceived: true,
		// 		isHistory: false
		// 	});
		// }
	
		if(!isHistory){
			!noPrompt && _messagePrompt(message, targetOfficialAccount);
			// 兼容旧的消息格式
			message.value = message.data;
			// 收消息回调
			isReceived && getToHost.send({
				event: _const.EVENTS.ONMESSAGE,
				data: {
					from: msg.from,
					to: msg.to,
					message: message
				}
			});
		}
		serviceSessionId = utils.getDataByPath(msg, "ext.weichat.service_session.serviceSessionId");
		if(isReceived && !isHistory && commonConfig.getConfig().pageState && serviceSessionId){
			// TODO 调用已读消息接口
			apiHelper.readMessageLastRead(serviceSessionId);
		}
	}
	
	function activeAnswerMessage(activeAnswerBundle, index){
		var activeAnswerMsg;
		var activeAnswerTime = Math.floor((parseInt(Math.random() * 10) + 25) * 1000);
		// var activeAnswerTime = 1000;
	
		if(index < activeAnswerBundle.activeAnswers.length){
			activeAnswerMsg = {
				type: "txt",
				data: activeAnswerBundle.activeAnswers[index]
			};
	
			activeAnswerTimeout = setTimeout(function(){
				// _handleMessage(activeAnswerMsg);
				_appendMsg(activeAnswerMsg, {
					isReceived: true,
					isHistory: false,
				});
				activeAnswerMessage(activeAnswerBundle, ++index);
				console.log("挽回时间：", new Date());
				eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CLEAR_TIMEOUT, []);
			}, activeAnswerTime);
		}
		else{
			clearActiveAnswerTimeout();
		}
	}
	function clearActiveAnswerTimeout(){
		clearTimeout(activeAnswerTimeout);
	}
	function isJsonString(str){
		try{
			if(typeof JSON.parse(str) == "object"){
				return true;
			}
		}
		catch(e){
		}
		return false;
	}
	function _transformMessageFormat(element){
		var msgBody = element.body || {};
		var msg = utils.getDataByPath(msgBody, "bodies.0") || {};
		var url = msg.url;
		var timestamp = moment(element.created_at, "YYYY-MM-DDTHH:mm:ss.SSSZZ").valueOf();
		var fileLength;
		var thumb;
		// // 只有坐席发出的消息里边的file_length是准确的
		// if(msgBody.from !== config.user.username){
		// 	fileLength = msg.file_length;
		// }
		// 去掉之前的判断逻辑，双方发送的file_length 都需要展示
		fileLength = msg.file_length;
	
	
		// 给图片消息或附件消息的 url 拼上 hostname
		if(url && !/^https?/.test(url)){
			url = config.domain + url;
		}
		// 消息处理时候添加缩略图属性
		if(msg.type == "video"){
			thumb = msg.thumb;
		}
		else{
			thumb = "";
		}
		return {
			data: msg.msg || "",
			url: url,
			filename: msg.filename,
			action: msg.action,
			type: msg.type,
			msgId: element.msg_id,
			fromUser: element.from_user,
			timestamp: timestamp,
			fileLength: fileLength,
			ext: msgBody.ext,
			to: msgBody.to,
			from: msgBody.from,
			thumb: thumb
		};
	}
	
	function _showFailed(msgId){
		if(_.isObject(msgId)){
			utils.addClass(document.getElementById(msgId.id + "_loading"), "hide");
			utils.removeClass(document.getElementById(msgId.id + "_failed"), "hide");
		}
		else{
			utils.addClass(document.getElementById(msgId + "_loading"), "hide");
			utils.removeClass(document.getElementById(msgId + "_failed"), "hide");
		}
	
	}
	
	function _hideFailedAndLoading(msgId){
		utils.addClass(document.getElementById(msgId + "_loading"), "hide");
		utils.addClass(document.getElementById(msgId + "_failed"), "hide");
	}
	
	// todo: merge setExt & appendAck
	function _appendAck(msg, id){
		msg.body.ext.weichat.msg_id_for_ack = id;
	}
	
	function _setExt(msg){
		var officialAccount = profile.currentOfficialAccount || profile.systemOfficialAccount;
		var officialAccountId = officialAccount.official_account_id;
		var bindAgentUsername = officialAccount.bindAgentUsername;
		var bindSkillGroupName = officialAccount.bindSkillGroupName;
		var language = "en-US";
		var customExtendMessage = commonConfig.getConfig().customExtendMessage;
		var rulaiExtendMessage = commonConfig.getConfig().rulaiExtendMessage;
	
		msg.body.ext = msg.body.ext || {};
		msg.body.ext.weichat = msg.body.ext.weichat || {};
		msg.body.ext.file_length = msg.fileLength;
	
		msg.body.ext.weichat.language = language;
	
		// 对接百度机器人，增加消息扩展
		if(typeof customExtendMessage === "object"){
			_.assign(msg.body.ext, customExtendMessage);
		}
	
		// 对接敦煌网(如来机器人)，增加消息扩展
		if(typeof rulaiExtendMessage === "object"){
			_.assign(msg.body.ext, rulaiExtendMessage);
		}
	
		// bind skill group im服务号or自动消息(已下架)
		if(bindSkillGroupName){
			msg.body.ext.weichat.queueName = bindSkillGroupName;
		}
		else if(config.emgroup){
			msg.body.ext.weichat.queueName = msg.body.ext.weichat.queueName || config.emgroup;
		}
	
		// bind visitor
		// 访客将nicename放在第一条消息的扩展字段中
		var imId = utils.get("root" + (config.configId || (config.tenantId + config.emgroup)));
		if(!_.isEmpty(config.visitor)){
			msg.body.ext.weichat.visitor = config.visitor;
			if(config.visitor && !config.visitor.userNickname){
				msg.body.ext.weichat.visitor.userNickname = commonConfig.getConfig().userNicknameFlg;
			}
		}
		else{
			msg.body.ext.weichat.visitor = {
				userNickname: commonConfig.getConfig().userNicknameFlg
			};
		}
	
		// bind agent username
		if(bindAgentUsername){
			msg.body.ext.weichat.agentUsername = bindAgentUsername;
		}
		else if(config.agentName){
			msg.body.ext.weichat.agentUsername = config.agentName;
		}
	
		// set growingio id
		if(config.grUserId){
			msg.body.ext.weichat.visitor = msg.body.ext.weichat.visitor || {};
			msg.body.ext.weichat.visitor.gr_user_id = config.grUserId;
		}
	
		// 初始化时系统服务号的ID为defaut，此时不用传
		if(officialAccountId !== "default"){
			msg.body.ext.weichat.official_account = {
				official_account_id: officialAccountId
			};
		}
		if(!!config.routingRuleFlag){
			msg.body.ext.weichat.routingRuleFlag = config.routingRuleFlag;
		}
		if(commonConfig.getConfig().originType && commonConfig.getConfig().originType == "dingtalk"){
			msg.body.ext.weichat.originType = "dingtalk"
		}
	}
	
	function _promptNoAgentOnlineIfNeeded(opt){
		var hasTransferedToKefu = opt && opt.hasTransferedToKefu;
		var officialAccountId = opt && opt.officialAccountId;
		var officialAccount = _getOfficialAccountById(officialAccountId);
		var sessionState = officialAccount.sessionState;
		// 只去查询一次有无坐席在线
		if(isNoAgentOnlineTipShowed) return;
		// 待接入中的会话 不做查询
		if(sessionState === _const.SESSION_STATE.WAIT) return;
		// 开启机器人接待时 不转人工不查询
		if(profile.hasRobotAgentOnline && !hasTransferedToKefu) return;
		// 获取在线坐席数
		apiHelper.getExSession().then(function(data){
			profile.hasHumanAgentOnline = data.onlineHumanAgentCount > 0;
			profile.hasRobotAgentOnline = data.onlineRobotAgentCount > 0;
	
			isNoAgentOnlineTipShowed = true;
			// 显示无坐席在线(只显示一次)
			if(
				!profile.hasHumanAgentOnline && data.tip_content !== undefined
			){
				_appendEventMsg(data.tip_content, { ext: { weichat: { official_account: officialAccount } } });
			}
		});
	}
	
	function _handleSystemEvent(event, eventObj, msg){
		var eventMessageText = _const.SYSTEM_EVENT_MSG_TEXT[event];
		var officialAccountId = utils.getDataByPath(msg, "ext.weichat.official_account.official_account_id");
		var officialAccount = _getOfficialAccountById(officialAccountId);
		var agentType = utils.getDataByPath(msg, "ext.weichat.event.eventObj.agentType");
	
		// 系统消息上屏
		if(eventMessageText){
			_appendEventMsg(eventMessageText, msg);
		}
	
	
		switch(event){
		case _const.SYSTEM_EVENT.SESSION_TRANSFERED:
			officialAccount.agentId = eventObj.userId;
			officialAccount.agentType = eventObj.agentType;
			officialAccount.agentAvatar = eventObj.avatar;
			officialAccount.agentNickname = eventObj.agentUserNiceName;
			officialAccount.sessionState = _const.SESSION_STATE.PROCESSING;
			officialAccount.isSessionOpen = true;
			profile.latestNiceName = null;
			eventListener.excuteCallbacks(_const.SYSTEM_EVENT.STOP_TIMEOUT, [officialAccount]);
			break;
		case _const.SYSTEM_EVENT.SESSION_TRANSFERING:
			officialAccount.sessionState = _const.SESSION_STATE.WAIT;
			officialAccount.isSessionOpen = true;
			officialAccount.skillGroupId = null;
			eventListener.excuteCallbacks(_const.SYSTEM_EVENT.STOP_TIMEOUT, [officialAccount]);
			profile.latestNiceName = null;  // 转接时把最近一次名称置空
			break;
		case _const.SYSTEM_EVENT.SESSION_CLOSED:
				// 如果在会话结束前已经发起了满意度评价，在结束时开始计算失效时间
			evaluateFlag = true;
			var serviceId = msg.ext.weichat.service_session.serviceSessionId;
			var btnInvalid = $(".em-btn-list>button[data-servicesessionid=" + serviceId + "]");
			if(btnInvalid){
				apiHelper.getEvaluatePrescription().then(function(res){
					if(!res){
						res = 8 * 3600;
					}
					setTimeout(function(){
						btnInvalid.removeClass("bg-hover-color");
						btnInvalid.removeClass("js_satisfybtn");
						btnInvalid.text("Invalid");
						btnInvalid.addClass("invalid-btn");
					}, res * 1000);
				});
			}
			officialAccount.sessionState = _const.SESSION_STATE.ABORT;
			officialAccount.agentId = null;
				// 发起满意度评价需要回传sessionId，所以不能清空
				// officialAccount.sessionId = null;
			officialAccount.skillGroupId = null;
			officialAccount.isSessionOpen = false;
			officialAccount.hasReportedAttributes = false;
			profile.latestNiceName = null;  // 结束会话把最近一次名称置空
				// to topLayer
			getToHost.send({ event: _const.EVENTS.ONSESSIONCLOSED });
			break;
		case _const.SYSTEM_EVENT.SESSION_OPENED:
			officialAccount.sessionState = _const.SESSION_STATE.PROCESSING;
			officialAccount.agentType = eventObj.agentType;
			officialAccount.agentId = eventObj.userId;
			officialAccount.sessionId = eventObj.sessionId;
			officialAccount.agentAvatar = eventObj.avatar;
			officialAccount.agentNickname = eventObj.agentUserNiceName;
			officialAccount.isSessionOpen = true;
			break;
		case _const.SYSTEM_EVENT.SESSION_CREATED:
			officialAccount.sessionState = _const.SESSION_STATE.WAIT;
			officialAccount.sessionId = eventObj.sessionId;
			officialAccount.isSessionOpen = true;
			getToHost.send({ event: _const.EVENTS.ONSESSIONCREAT });
			break;
		default:
			break;
		}
		eventListener.excuteCallbacks(event, [officialAccount]);
		_promptNoAgentOnlineIfNeeded({ officialAccountId: officialAccountId });
	}
	
	// 系统事件消息上屏
	function _appendEventMsg(text, msg){
		// 如果设置了 hideStatus, 不显示此类提示
		if(config.hideStatus){
			return;
		}
		var officialAccountId = utils.getDataByPath(msg, "ext.weichat.official_account.official_account_id");
		var targetOfficialAccount = _getOfficialAccountById(officialAccountId);
		targetOfficialAccount.messageView.appendEventMsg(text);
	}
	
	function _getOfficialAccountById(id){
		// 默认返回系统服务号
		if(!id){
			return profile.systemOfficialAccount;
		}
		return _.findWhere(profile.officialAccountList, { official_account_id: id });
	}
	
	function _appendMsg(msg, options){
		// 灰度打开时，访客收到菜单消息后，如果访客又发送了新消息，则菜单置灰不可再点选
		var msgType = utils.getDataByPath(msg, "ext.weichat.official_account.type");
	  // 天润欢迎语菜单不置灰
		if(profile.grayList.menuNoClicked && msgType !== "SYSTEM"){
			// 所有的 list 子类消息
			var allListBtn1 = document.querySelectorAll(".msgtype-robotList .em-btn-list button");
			var all = _.toArray(allListBtn1);
			_.each(all, function(robotBtn){
				utils.addClass(robotBtn, "disabled");
			});
			// 对应的箭头也置灰
			var allListBtn2 = document.querySelectorAll(".msgtype-robotList .em-btn-list i");
			var allI = _.toArray(allListBtn2);
			_.each(allI, function(i){
				utils.addClass(i, "disabled");
			});
		}
	
		var opt = options || {};
		var isReceived = opt.isReceived;
		var isHistory = opt.isHistory;
		var noPrompt = opt.noPrompt;
		var officialAccount = opt.officialAccount || profile.currentOfficialAccount || profile.systemOfficialAccount;
	
		officialAccount.messageView.appendMsg(msg, opt);
	
		if(isReceived && !isHistory && !noPrompt){
			eventListener.excuteCallbacks(
				_const.SYSTEM_EVENT.MESSAGE_APPENDED,
				[officialAccount, msg]
			);
		}
		// 设置list主题色
		var themeCustomColor = config.themeCustomColor;
		if(themeCustomColor){
			var bgColor = $(".theme_custom .bg-hover-color").css("background");
			$(".theme_custom .bg-hover-color").hover(function(){
				$(this).css("cssText", "background-color: " + themeCustomColor + " !important");
			}, function(){
				$(this).css("cssText", "background-color: " + bgColor + " !important");
			});
			// 留言文字颜色
			$(".js-transfer-to-ticket").css("cssText", "color: " + themeCustomColor + " !important");
			// 换一换语文字颜色
			$(".welcome-change").css("cssText", "color: " + themeCustomColor + " !important");
			// 转人工按钮
			$(".js_robotTransferBtn").css("cssText", "color: " + themeCustomColor + " !important");
		}
		else{
			// 换一换语文字颜色
			$(".welcome-change").addClass("fg-color");
		}
	}
	
	function _attemptToAppendOfficialAccount(officialAccountInfo){
		var id = officialAccountInfo.official_account_id;
		var targetOfficialAccount = _.findWhere(profile.officialAccountList, { official_account_id: id });
	
		// 如果相应messageView已存在，则不处理
		if(targetOfficialAccount) return;
	
		var type = officialAccountInfo.type;
		var img = officialAccountInfo.img;
		var name = officialAccountInfo.name;
		// copy object
		var officialAccount = {
			official_account_id: id,
			type: type,
			img: img,
			name: name
		};
	
		if(type === "SYSTEM"){
			if(_.isEmpty(profile.systemOfficialAccount)){
				profile.systemOfficialAccount = officialAccount;
				profile.officialAccountList.push(officialAccount);
				officialAccount.unopenedMarketingTaskIdList = new List();
				officialAccount.unrepliedMarketingTaskIdList = new List();
				officialAccount.unreadMessageIdList = new List();
				eventListener.excuteCallbacks(
					_const.SYSTEM_EVENT.NEW_OFFICIAL_ACCOUNT_FOUND,
					[officialAccount]
				);
			}
			else if(profile.systemOfficialAccount.official_account_id !== id){
				// 如果id不为null则更新 systemOfficialAccount
				profile.systemOfficialAccount.official_account_id = id;
				profile.systemOfficialAccount.img = img;
				profile.systemOfficialAccount.name = name;
				eventListener.excuteCallbacks(_const.SYSTEM_EVENT.SYSTEM_OFFICIAL_ACCOUNT_UPDATED, []);
			}
		}
		// 没有使用（无用户）
		else if(type === "CUSTOM"){
			profile.ctaEnable = true;
			profile.officialAccountList.push(officialAccount);
			officialAccount.unopenedMarketingTaskIdList = new List();
			officialAccount.unrepliedMarketingTaskIdList = new List();
			officialAccount.unreadMessageIdList = new List();
			eventListener.excuteCallbacks(
				_const.SYSTEM_EVENT.NEW_OFFICIAL_ACCOUNT_FOUND,
				[officialAccount]
			);
		}
		else{
			throw new Error("unexpected official_account type.");
		}
	}
	
	// 第二通道发消息
	function _sendMsgChannle(id, retryCount){
		var msg = sendMsgDict.get(id);
		var body = utils.getDataByPath(msg, "body.body");
		var ext = utils.getDataByPath(msg, "body.ext");
		var count = typeof retryCount === "number"
			? retryCount
			: _const.SECOND_MESSAGE_CHANNEL_MAX_RETRY_COUNT;
	
		apiHelper.sendMsgChannel(body, ext).then(function(){
			// 发送成功清除
			_clearTS(id);
		}, function(){
			// 失败继续重试
			if(count > 0){
				_sendMsgChannle(id, --count);
			}
			else{
				_showFailed(id);
			}
		});
	}
	
	// 第二通道上传图片消息
	function _uploadImgMsgChannle(type, id, file, retryCount){
		var msg = sendMsgDict.get(id);
		var count = typeof retryCount === "number"
			? retryCount
			: _const.SECOND_MESSAGE_CHANNEL_MAX_RETRY_COUNT;
	
	
		apiHelper.uploadImgMsgChannel(file).then(function(resp){
			if(type == "img"){
				msg.body.body = {
					filename: resp.fileName,
					type: "img",
					url: resp.url
				};
			}
			else if(type == "video"){
				msg.body.body = {
					filename: resp.fileName,
					type: "video",
					url: resp.url
				};
			}
			else{
				msg.body.body = {
					filename: resp.fileName,
					type: "file",
					fileLength: file.size,
					file_length: file.size,
					url: resp.url
				};
			}
			_sendMsgChannle(id, 0);
		}, function(){
			if(count > 0){
				_uploadImgMsgChannle(type, msg, file, --count);
			}
			else{
				_showFailed(id);
			}
		});
	}
	
	// 消息发送成功，清除timer
	function _clearTS(id){
		clearTimeout(ackTimerDict.get(id));
		ackTimerDict.remove(id);
	
		_hideFailedAndLoading(id);
		sendMsgDict.remove(id);
	}
	
	// 监听ack，超时则开启api通道, 发文本消息时调用
	function _detectSendTextMsgByApi(id){
		ackTimerDict.set(
			id,
			setTimeout(function(){
				_sendMsgChannle(id);
			}, _const.FIRST_CHANNEL_MESSAGE_TIMEOUT)
		);
	}
	
	// 监听ack，超时则开启api通道, 上传图片消息时调用
	function _detectUploadImgMsgByApi(id, file, type){
		ackTimerDict.set(
			id,
			setTimeout(function(){
				_uploadImgMsgChannle(type, id, file);
			}, _const.FIRST_CHANNEL_IMG_MESSAGE_TIMEOUT)
		);
	}
	
	function _messagePrompt(message, officialAccount){
		var officialAccountType = officialAccount.type;
		var brief = message.brief;
		var avatar = officialAccountType === "CUSTOM"
			? officialAccount.img
			: profile.systemAgentAvatar || profile.tenantAvatar || profile.defaultAvatar;
	
		if(utils.isBrowserMinimized() || !profile.isChatWindowOpen){
			eventListener.excuteCallbacks(_const.SYSTEM_EVENT.MESSAGE_PROMPT, []);
	
			getToHost.send({ event: _const.EVENTS.SLIDE });
			getToHost.send({
				event: _const.EVENTS.NOTIFY,
				data: {
					avatar: avatar,
					title: "New message",
					brief: brief
				}
			});
		}
	}


/***/ }),
/* 187 */
/***/ (function(module, exports) {

	var List = function(content){
		this.list = _.isArray(content) ? content : [];
	};
	
	List.prototype.has = function(value){
		return !!~this.list.indexOf(value);
	};
	
	List.prototype.add = function(value){
		if(!this.has(value)){
			this.list.push(value);
		}
	};
	
	List.prototype.remove = function(value){
		var index = this.list.indexOf(value);
		if(index >= 0){
			this.list.splice(index, 1);
		}
	};
	
	List.prototype.getAll = function(){
		return this.list;
	};
	
	List.prototype.getLength = function(){
		return this.list.length;
	};
	
	// todo: rename to clear
	List.prototype.removeAll = function(){
		this.list.length = 0;
	};
	
	module.exports = List;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var emajax = __webpack_require__(184);
	
	module.exports = window.tools = {
		retryThrottle: retryThrottle,
		DOMEval: DOMEval,
		loadScript: loadScript,
		resolvePromiseSequentially: resolvePromiseSequentially,
	};
	
	// todo: implemnet this
	function resolvePromiseSequentially(list){
	
	}
	
	function loadScript(path){
		return new Promise(function(resolve, reject){
			emajax({
				url: path,
				success: resolve,
				error: reject,
				disableTimeStampInGet: true,
			});
		})
		.then(DOMEval);
	}
	
	function DOMEval(code){
		var script = document.createElement("script");
	
		script.text = code;
		document.head.appendChild(script).parentNode.removeChild(script);
	}
	
	// 限制一段时间内的重试次数，以及每次调用的时间间隔
	function retryThrottle(fn, options){
		var opt = options || {};
		var lastResetTimestamp = _.now();
		var retryLimit = opt.retryLimit || 3;
		var resetTime = opt.resetTime || 60 * 10 * 1000;
		var waitTime = opt.waitTime || 3 * 1000;
		var retryCount = 0;
		var throttledFn = _.throttle(fn, waitTime);
	
		return function(){
			if(_.now() - lastResetTimestamp < resetTime){
				if(retryCount < retryLimit){
					retryCount++;
					throttledFn();
				}
				else{
					// 达到重试次数，忽略
				}
			}
			else{
				lastResetTimestamp = _.now();
				retryCount = 1;
				throttledFn();
			}
	
		};
	}


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	
	var EMOJI_PATH = _const.EMOJI_PATH;
	var EMOJI_MAP = _const.EMOJI_MAP;
	
	var protocol = /(((ftp|https?):)?\/\/)/;
	var auth = /([-._0-9a-zA-Z]+(:[-._0-9a-zA-Z]+)?@)?/;
	var host = /((\d+\.\d+\.\d+\.\d+)|(([-_0-9a-zA-Z_]+\.)+[a-zA-Z]+))/;
	var port = /(:\d+)?/;
	var path = /(\/[^ ?<">\n]*)*/;
	var query = /(\?([-+._%0-9a-zA-Z]+=[^ &#'"\n]*&)*([-+._%0-9a-zA-Z]+=[^ &#'"\n]*))?/;
	var hash = /(#[-+._%0-9a-zA-Z/]*)?/;
	var commonConfig = __webpack_require__(177);
	var profile = __webpack_require__(178);
	
	var URL_RE = new RegExp(
		[protocol, auth, host, port, path, query, hash]
		.map(function(regExp){
			return regExp.source;
		})
		.join(""), "i");
	// var URL_RE = /(https?:\/\/|www\.)([a-zA-Z0-9-]+(\.[a-zA-Z0-9]+)+)(:[0-9]{2,4})?\/?((\.[:_0-9a-zA-Z-]+)|[:_0-9a-zA-Z-]*\/?)*\??[:_#@*&%0-9a-zA-Z-/=]*/i;
	
	module.exports = {
		parse: parse,
	  replaceEmojis: replaceEmojis,
		unescape: _unescape,
		getTextMessageBrief: getTextMessageBrief,
	};
	
	// 从消息通道来的消息需要 _unescape
	function _unescape(str){
		if(typeof str !== "string") return "";
	
		return str
		.replace(/&#39;/g, "'")
		.replace(/&quot;/g, "\"")
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		// &amp; 要最后处理
		.replace(/&amp;/g, "&");
	}
	
	function getTextMessageBrief(text, isReceived){
		var textMap = parse(text, null, isReceived);
		return _.map(textMap, function(fragment){
			var value = fragment.value;
			var type = fragment.type;
	
			switch(type){
			case "ENCODED_TEXT":
				return value
				.replace(/&lt;/g, "<")
				.replace(/&gt;/g, ">")
				.replace(/\n/mg, " ");
			case "LINK":
			case "CUSTOM_LINK":
				return "[Link]";
			case "EMOJI":
				return "[Emoticon]";
			default:
				console.error("unexpect fragment type: " + type);
				return "";
			}
		}).join("");
	}
	
	function parse(text, opt, isReceived){
		opt = opt || {};
		var isNoLink = profile.isNoLink;
		if(typeof text !== "string") return "";
		var list;
		// 开了不解析访客端链接的开关情况
		if(!!isNoLink && typeof (isReceived) != "undefined" && !isReceived){
			list = [
				_emojiParser,
				_encodeParser
			];
		}
		else{
			list = [
				_emojiParser,
				_customLinkParser,
				_linkParser,
				_encodeParser
			];
			if(opt["default"]){
				list = [
					_emojiParser,
					_linkParser,
					_encodeParser
				];
			}
		}
	
		return _.reduce(list, function(result, parser){
			return _parseMap(result, parser);
		}, [{
			type: "UNPARSED",
			value: text,
			baseIndex: 0,
		}]);
	}
	
	function _encodeParser(text){
		var newStr = text
		// 此处 & 要先处理
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;");
	
		return {
			type: "ENCODED_TEXT",
			index: 0,
			oldStr: text,
			newStr: newStr,
		};
	}
	
	function _linkParser(text){
		var result = text.match(URL_RE);
		var targetLink;
		var hasProtocol;
		var taggedLink;
		var index;
	
		if(!result) return null;
	
		targetLink = result[0];
		index = result.index;
		hasProtocol = /^https?/i.test(targetLink);
		var color = "";
		var themeClassName;
		var config = commonConfig.getConfig();
		var themeName = config.ui.themeName;
		if(themeName && themeName.indexOf("theme_custom") > -1){
			var arr = themeName.split("theme_custom");
			color = arr[1];
			themeClassName = "theme_custom";
		}
		else{
			themeClassName = _const.themeMap[config.themeName];
		}
		var hoverColor = $("body." + themeClassName + " .border-color").css("borderColor");
		if(!color){
			color = hoverColor;
		}
		taggedLink = "<a  style=\"color:" + color + ";\" href=\""
			+ (hasProtocol ? targetLink : "//" + targetLink)
			+ "\" target=\"_blank\">"
			+ targetLink
			+ "</a>";
	
		return {
			index: index,
			oldStr: targetLink,
			newStr: taggedLink,
			type: "LINK",
		};
	}
	
	function _customLinkParser(text){
		var re = /<a[^>]+>[^<>]+<\/a>/i;
		var matchResult = text.match(re);
		var divDom;
		var matchedText;
		var index;
		var aDom;
		var href;
		var cloneADom;
	
		if(!matchResult) return null;
	
		matchedText = matchResult[0];
		index = matchResult.index;
	
		divDom = document.createElement("div");
		divDom.innerHTML = matchedText;
		aDom = divDom.childNodes[0];
	
		if(
			aDom
			&& aDom.tagName === "A"
			&& URL_RE.test(href = aDom.href)
		){
			cloneADom = document.createElement("a");
			cloneADom.href = href;
			cloneADom.target = "_blank";
			cloneADom.innerText = aDom.innerText;
	
			return {
				index: index,
				oldStr: matchedText,
				newStr: cloneADom.outerHTML,
				type: "CUSTOM_LINK",
			};
		}
	
		return null;
	}
	
	function replaceEmojis(str) {
		for (var emoji in EMOJI_MAP) {
		  if (Object.prototype.hasOwnProperty.call(EMOJI_MAP, emoji)) {
			var value = EMOJI_MAP[emoji];
			str = str.split(emoji).join("<img class=\"emoji\" src=\"" + EMOJI_PATH + value + "\">");
		  }
		}
		return str;
	  }
	
	function _emojiParser(text){
		var key;
		var value;
		var index;
	
		for(key in EMOJI_MAP){
			if(Object.prototype.hasOwnProperty.call(EMOJI_MAP, key)){
				value = EMOJI_MAP[key];
				index = text.indexOf(key);
				if(~index){
					return {
						index: index,
						oldStr: key,
						newStr: "<img class=\"emoji\" src=\"" + EMOJI_PATH + value + "\">",
						type: "EMOJI",
					};
				}
			}
		}
	
		return null;
	}
	
	function _parseMap(map, parser){
		return _.chain(map)
		.each(function(fragment, fragmentIndex, array){
			var baseIndex = fragment.baseIndex;
			var text = fragment.value;
			var wholeLength = text.length;
			var result = [];
			var parsed;
			var oldStr;
			var newStr;
			var beginIndex;
			var endIndex;
			var type;
	
			if(fragment.type !== "UNPARSED") return;
	
			parsed = parser(text);
	
			if(parsed === null) return;
	
			newStr = parsed.newStr;
			oldStr = parsed.oldStr;
			type = parsed.type;
			beginIndex = parsed.index;
			endIndex = beginIndex + oldStr.length;
	
	
			// 将前边的内容加入结果集
			if(beginIndex !== 0){
				result.push({
					baseIndex: baseIndex,
					type: "UNPARSED",
					value: text.substring(0, beginIndex),
				});
			}
	
			result.push({
				baseIndex: baseIndex + beginIndex,
				type: type,
				value: newStr,
			});
	
			// 将匹配内容后面的加入结果集
			if(endIndex !== wholeLength){
				result.push({
					baseIndex: baseIndex + endIndex,
					type: "UNPARSED",
					value: text.substring(endIndex, wholeLength),
				});
			}
	
			_parseMap(result, parser);
	
			array.splice(fragmentIndex, 1, result);
		})
		.flatten()
		.sortBy("baseIndex")
		.value();
	}


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var Transfer = __webpack_require__(183);
	
	module.exports = new Transfer(null, "toHost", true);


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	var uikit = __webpack_require__(180);
	var apiHelper = __webpack_require__(181);
	var channel = __webpack_require__(186);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var loading = __webpack_require__(192);
	var getToHost = __webpack_require__(190);
	var commonConfig = __webpack_require__(177);
	
	var dom;
	var starsUl;
	var resolvedBtn;
	var commentDom;
	var tagContainer;
	var dialog;
	
	var starList;
	
	var session;
	var invite;
	var score;
	var evaluationDegreeId;
	var isSingleTag;
	var resolvedDom;
	var resolveTip;
	var resolvedId = 1;
	var _initOnce = _.once(_init);
	var evaluateType; // 评价方式
	var sessionResolved;// 问题解决评价
	var fiveStarState;//默认五星评价
	var defaultScore;
	var defaultEvaluationDegreeId;
	var color;
	var bgColor;
	var tipNameArr;
	var resolveTxt = "Resolved"
	var unresolvedTxt = "Unsolved"
	
	module.exports = {
		init: init,
		show: show,
	};
	
	function _init(){
		// 自定义主题色
		var config = commonConfig.getConfig();
		var themeName = config.ui.themeName;
		var themeClassName;
		if(themeName && themeName.indexOf("theme_custom") > -1){
			var arr = themeName.split("theme_custom");
			color = arr[1];
		}
		else{
			themeClassName = _const.themeMap[config.themeName || 'theme_sky']; // 默认为theme_sky
		}
		color = !color? $("body." + themeClassName + " .border-color").css("borderColor") : color;
		bgColor = $("body." + themeClassName + " .border-color").css("borderColor") ? $("body." + themeClassName + " .border-color").css("borderColor") : color;
		color = utils.changeToRgb(color);
		// 如果存在url弹窗，不loading，否则会闪
		if(!$(document.querySelector(".session-closed-dialog"))){
			loading.show("satisfaction");
		}
		
		//默认五星评价的开关
		apiHelper.getDefaultFiveStarEnable()
		.then(function(resp){
			fiveStarState = resp;
		});
		apiHelper.getResolutionparams().then(function(resp){
			resp.map(function (item) {
				if (item.score == 1) {
					resolveTxt = item.name;
				} else if (item.score == 2) {
					unresolvedTxt = item.name;
				} else {
					resolveTxt = "Resolved";
					unresolvedTxt = "Unsolved";
				}
			});
	
			apiHelper.getSatisfactionTipWord().then(function(tipWord){
				dom = sessionResolved ? utils.createElementFromHTML([
					"<div class=\"wrapper\">",
					"<div class=\"wrapper-title\">" + "Service evaluation" + "<i class=\"icon-close\"></i></div>",
					"<div class=\"resolveCon\"><span class=\"title\">" + resolveTip + "</span>",
					"<div><span class=\"resolve-btn selected bg-color resolved\" data-num = \"1\"><i class=\"icon-resolved\"></i><span>" + resolveTxt + "</span></span>",
					"<span class=\"resolve-btn unresolved\" data-num = \"2\"><i class=\"icon-unresolved\"></i><span>" + unresolvedTxt + "</span></span></div></div>",
					"<span class=\"title\">" + tipWord + "</span>",
					"<ul></ul>",
					"<div class=\"tip hide\"></div>",
					"<div class=\"tag-container\"></div>",
					"<textarea spellcheck=\"false\" placeholder=\"" + "Review" + "\"></textarea>",
					"<div class=\"cancel hidden\">" + "No evaluation" + "</div>",
					"<div class=\"confirm bg-color\">"+  "Submit evaluation"  +"</div>",
					"</div>"
				].join(""))
					:
					utils.createElementFromHTML([
						"<div class=\"wrapper\">",
						"<div class=\"wrapper-title\">" + "Service evaluation" + "<i class=\"icon-close\"></i></div>",
						"<span class=\"title\">" + tipWord + "</span>",
						"<ul></ul>",
						"<div class=\"tip hide\"></div>",
						"<div class=\"tag-container\"></div>",
						"<textarea spellcheck=\"false\" placeholder=\"" + "Review" + "\"></textarea>",
						"<div class=\"cancel hidden\">" + "No evaluation" + "</div>",
						"<div class=\"confirm bg-color\">"+  "Submit evaluation"  +"</div>",
						"</div>"
					].join(""));
				if(utils.isMobile || ($("body").hasClass("window-demo") && $("#em-kefu-webim-self").hasClass("hide"))){
					dom = sessionResolved ? utils.createElementFromHTML([
						"<div id=\"satisfaction-mobile\" class=\"wrapper\">",
						"<div class=\"wrapper-title bg-color\">" + "Service evaluation" + " <i class=\"icon-back-new\"></i></div>",
						"<div class=\"resolveCon\"><span class=\"title\">" + resolveTip + "</span>",
						"<div><span class=\"resolve-btn selected bg-color resolved\" data-num = \"1\"><i class=\"icon-resolved\"></i><span>" + resolveTxt + "</span></span>",
						"<span class=\"resolve-btn unresolved\" data-num = \"2\"><i class=\"icon-unresolved\"></i><span>" + unresolvedTxt + "</span></span></div></div>",
						"<span class=\"title\">" + tipWord + "</span>",
						"<ul></ul>",
						"<div class=\"tip hide\"></div>",
						"<div class=\"tag-container\"></div>",
						"<textarea spellcheck=\"false\" placeholder=\"" + "Review" + "\"></textarea>",
						"<div class=\"cancel hidden\">" + "No evaluation" + "</div>",
						"<div class=\"confirm bg-color\">"+  "Submit evaluation"  +"</div>",
						"</div>"
					].join(""))
						:
						utils.createElementFromHTML([
							"<div id=\"satisfaction-mobile\" class=\"wrapper\">",
							"<div class=\"wrapper-title bg-color\">" + "Service evaluation" + " <i class=\"icon-back-new\"></i></div>",
							"<span class=\"title\">" + tipWord + "</span>",
							"<ul></ul>",
							"<div class=\"tip hide\"></div>",
							"<div class=\"tag-container\"></div>",
							"<textarea spellcheck=\"false\" placeholder=\"" + "Review" + "\"></textarea>",
							"<div class=\"cancel hidden\">" + "No evaluation" + "</div>",
							"<div class=\"confirm bg-color\">"+  "Submit evaluation"  +"</div>",
							"</div>"
						].join(""));
				}
				starsUl = dom.querySelector("ul");
				commentDom = dom.querySelector("textarea");
				tagContainer = dom.querySelector(".tag-container");
				resolvedBtn = dom.querySelectorAll(".resolve-btn");
				resolvedDom = dom.querySelector(".resolved");
	
				utils.live(".resolve-btn", "click", function(){
					utils.removeClass(resolvedBtn, "selected bg-color");
					$(".resolve-btn").css("cssText","background-color:#f7f7f7 !important");
					$(".resolve-btn i").css("cssText","color:##595959 !important"); 
					$(".resolve-btn span").css("cssText","color:##595959 !important");  
					utils.addClass(this, "selected bg-color");
					if(color){
						$(".resolveCon .selected").css("cssText","background-color:"+  color +"!important"); 
						$(".resolveCon .selected i").css("cssText","color:"+  bgColor +"!important"); 
						$(".resolveCon .selected span").css("cssText","color:"+  bgColor +"!important"); 
					}
					resolvedId = this.dataset.num;
					if(fiveStarState){
						if(resolvedId == 1){
							utils.addClass(starList, "sel");
							score = defaultScore;
							evaluationDegreeId = defaultEvaluationDegreeId;
						}
						else{
							utils.removeClass(starList, "sel");
							score = false;
						}
					}
				});
	
				utils.live("li", "click", function(){
					var level = +this.getAttribute("data-level");
	
					evaluationDegreeId = this.getAttribute("data-evaluate-id");
					score = this.getAttribute("data-score");
					isSingleTag = this.getAttribute("data-isSingleTag");
					level && _.each(starList, function(elem, i){
						utils.toggleClass(elem, "sel", i < level);
					});
					var tipBox = $(".satisfaction .tip")
					// var tipText = ["Very dissatisfied","Dissatisfied","Satisfied","Good","Very satisfied"]
					var tipText = tipNameArr || [];
					tipBox.removeClass("hide");
					tipBox.text(tipText[level - 1]);
	
					evaluationDegreeId && _createLabel(evaluationDegreeId);
				}, starsUl);
	
				utils.live("span.tag", "click", function(){
					var selectedTagNodeList = tagContainer.querySelectorAll(".selected");
					if(isSingleTag == "true"){
						utils.removeClass(selectedTagNodeList, "selected");
						utils.toggleClass(this, "selected");
					}
					else{
						utils.toggleClass(this, "selected");
					}
	
				}, tagContainer);
				utils.live(".confirm","click",_confirm);
				utils.live(".cancel","click",function(){
					// dialog && dialog.hide();
					dialog && dialog.el.remove();
					// 关闭满意度，弹出url配置弹窗。
					// eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CUSTOMURL_DIALOG_SHOW,[])
				});
				utils.live(".icon-back-new","click",function(){
					// dialog && dialog.hide();
					dialog && dialog.el.remove();
					// 关闭满意度，弹出url配置弹窗。
					// eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CUSTOMURL_DIALOG_SHOW,[])
				});
				utils.live(".wrapper-title .icon-close","click",function(){
					// dialog && dialog.hide();
					dialog && dialog.el.remove();
					// 关闭满意度，弹出url配置弹窗。
					// eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CUSTOMURL_DIALOG_SHOW,[])
				});
	
				if(utils.isMobile || ($("body").hasClass("window-demo") && $("#em-kefu-webim-self").hasClass("hide"))){
					dialog = uikit.createDialog({
						isFullSreen: true,
						contentDom: dom,
						className: "satisfaction"
					});
				}
				else{
					dialog = uikit.createDialog({
						isFullSreen: false,
						contentDom: dom,
						className: "satisfaction"
					});
				}
				// dialog = uikit.createDialog({
				// 	contentDom: dom,
				// 	className: "satisfaction"
				// }).addButton({
				// 	confirmText: "Submit",
				// 	confirm: _confirm,
				// });
				if(!$(document.querySelector(".session-closed-dialog"))){
					loading.hide("satisfaction");
				}
				dialog.show();
	
				if(!$(document.querySelector(".em-self-wrapper")).hasClass("hide")){
					dialog.el.style.cssText='left:10px;top:10px;';
					if(!utils.isMobile && $("body").hasClass("window-demo")){
						dom.querySelector(".icon-close").style.cssText='margin-right:20px;';
					}
				}
				else{
					dialog.el.style.cssText='left:0;top:0;';
				}
				// 火狐浏览器 _setSatisfaction时找不到starsUl，所以必须先执行完init
				_setSatisfaction();
	
				// 自定义主题色
				// color && $(".theme_custom").find(".bg-color").css("cssText","background-color: " + color + " !important");
				bgColor && $(".theme_custom").find(".bg-color").css("cssText","background-color: " + bgColor + " !important");
				if($("body").hasClass("window-demo")){
					// $(".wrapper > .cancel").addClass("hidden");
				}
				else{
					// $(".wrapper > .cancel").removeClass("hidden");
					if(!utils.isMobile){
						$(".satisfaction >.wrapper").addClass("wrapperTpo");
					}
				}
				if(color){
					$(".resolveCon .selected").css("cssText","background-color:"+  color +"!important"); 
					$(".resolveCon .selected i").css("cssText","color:"+  bgColor +"!important"); 
					$(".resolveCon .selected span").css("cssText","color:"+  bgColor +"!important"); 
				}
			});
		})
	}
	
	function _clear(){
		commentDom.blur();
		commentDom.value = "";
		score = null;
		// clear stars
		utils.removeClass(starList, "sel");
		// clear label
		tagContainer.innerHTML = "";
		// clear resolvedBtn
		utils.removeClass(resolvedBtn, "selected bg-color");
		utils.addClass(resolvedDom, "selected bg-color");
	
		resolvedId = 1;
	
	}
	
	function _sendSatisfaction(score, content, session, invite, appraiseTags, resolutionParam, evaluationDegreeId){
		var data = {
			ext: {
				weichat: {
					ctrlType: "enquiry",
					ctrlArgs: {
						// 后端类型要求，inviteId必须传数字
						inviteId: invite || 0,
						serviceSessionId: session || profile.currentOfficialAccount.sessionId || "",
						detail: content,
						summary: score,
						appraiseTags: appraiseTags,
						resolutionParam: resolutionParam,
						evaluationDegreeId: evaluationDegreeId,
						// 评价方式，由前端传入：visitor - 访客主动评价; agent - 坐席邀请; system - 强制邀请,访客点击关闭窗口或会话结束
						evaluateWay: evaluateType
					}
				}
			}
		};
		if(!sessionResolved){
			delete data.ext.weichat.ctrlArgs.resolutionParam;
		}
		channel.sendText("", data);
	}
	
	function _setSatisfaction(){
		tipNameArr = [];
		apiHelper.getEvaluationDegrees().then(function(entities){
			var labelID;
			var lastScore;
			var lastEvaluationDegreeId;
			for(var i=0;i<entities.length;i++){
				tipNameArr.push(entities[i].name);
			}
			tipNameArr = tipNameArr.reverse();
			starsUl.innerHTML = _.chain(entities)
			.sortBy("level")
			.map(function(elem, index){
				// stat level 1-based
				var level = index + 1;
				var name = elem.name;
				var id = elem.id;
				var score = elem.score;
				var isSingleTag = elem.isSingleTag;
				labelID = id;
				lastScore = score;
				lastEvaluationDegreeId = id;
				 
				return "<li  data-level=\"" + level
					+ "\" title=\"" + name
					+ "\" data-evaluate-id=\"" + id
					+ "\" data-score=\"" + score
					+ "\" data-isSingleTag=\"" + isSingleTag
					+ "\" class=\"" + "icon-start"
					+ "\"></li>";
			})
			.value()
			.join("");
	
			starList = starsUl.querySelectorAll("li");
			defaultScore = lastScore;
			defaultEvaluationDegreeId = lastEvaluationDegreeId;
			if(fiveStarState){
				if(resolvedId == 1){
					utils.addClass(starList, "sel");
					//创建评价标签
					_createLabel(labelID);
					score = defaultScore;
					evaluationDegreeId = defaultEvaluationDegreeId;
				}
				else{
					utils.removeClass(starList, "sel");
					score = false;
				}
			}
			
		});
	}
	
	function _createLabel(evaluateId){
		apiHelper.getAppraiseTags(evaluateId).then(function(entities){
			tagContainer.innerHTML = _.map(entities, function(elem){
				var name = elem.name;
				var id = elem.id;
	
				return "<span data-label-id = \"" + id + "\"  class=\"tag\">" + name + "</span>";
			}).join("");
			utils.removeClass(tagContainer, "hide");
		});
	}
	
	function _confirm(){
		var selectedTagNodeList = tagContainer.querySelectorAll(".selected");
		var tagNodeList = tagContainer.querySelectorAll(".tag");
		var content = commentDom.value;
		var appraiseTags = _.map(selectedTagNodeList, function(elem){
			return {
				id: elem.getAttribute("data-label-id"),
				name: elem.innerText
			};
		});
		var resolutionParam = [{
			id: resolvedId,
			name: resolvedId == 1 ? resolveTxt : unresolvedTxt,
			score: resolvedId,
			resolutionParamTags: []
		}];
	
		// 必须选择星级
		if(!score){
			uikit.tip("Select a star");
			// 防止对话框关闭
			return false;
		}
		// 若有标签则至少选择一个
		else if(tagNodeList.length > 0 && selectedTagNodeList.length === 0){
			uikit.tip("Select a label");
			// 防止对话框关闭
			return false;
		}
		//yu 只传个id , 是因为靠通信，把信息传给后台了，这里只是告知后台一下，提交评价了
		// 判断评价是否超时
		apiHelper.getEvaluateVerify(session || profile.currentOfficialAccount.sessionId || "")
		.then(function(resp){
			if(resp.status == "OK"){
				_sendSatisfaction(score, content, session, invite, appraiseTags, resolutionParam, evaluationDegreeId);
				uikit.showSuccess("Submit successfully");
				getToHost.send({ event: _const.EVENTS.EVALUATIONSUBMIT });
				// 强制评价点击确定关闭会话框
				setTimeout(function(){
					// 关闭会话
					if(evaluateType === "system" && profile.grayList.visitorLeave){
						// 取消轮询接口
						eventListener.trigger(_const.SYSTEM_EVENT.CHAT_CLOSED);
						if(session){
							apiHelper.closeChatDialog({ serviceSessionId: session });
						}
						else{
							profile.currentOfficialAccount.sessionId && apiHelper.closeChatDialog({ serviceSessionId: profile.currentOfficialAccount.sessionId });
						}
						getToHost.send({ event: _const.EVENTS.CLOSE });
					}
				}, 2000);
				_clear();
				// dialog && dialog.hide();
				dialog && dialog.el.remove();
				// 关闭满意度，弹出url配置弹窗。
				eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CUSTOMURL_DIALOG_SHOW,[])
			}
			else{	
				if(resp.errorCode == "WEBIM_338"){
					uikit.tip("Visitor evaluate timeout");
				}else{
					uikit.tip("Other errors");
				}
				// dialog && dialog.hide();
				dialog && dialog.el.remove();
				// 关闭满意度，弹出url配置弹窗。
				eventListener.excuteCallbacks(_const.SYSTEM_EVENT.CUSTOMURL_DIALOG_SHOW,[])
			}
		});
	
		
	}
	
	function show(inviteId, serviceSessionId, evaluateWay){
		$(".resolve-btn i").css("cssText","color:#595959!important"); 
		$(".resolve-btn span").css("cssText","color:#595959!important");  
		if(color){
			$(".resolveCon .selected").css("cssText","background-color:"+  color +"!important"); 
			$(".resolveCon .selected i").css("cssText","color:"+  bgColor +"!important"); 
			$(".resolveCon .selected span").css("cssText","color:"+  bgColor +"!important"); 
		}
		$(".satisfaction .tip").addClass("hide");
		apiHelper.getEvaluteSolveWord().then(function(tip){
			resolveTip = tip;
		});
		apiHelper.getServiceSessionResolved()
		.then(function(resp){
			sessionResolved = resp;
			_init();
			// _initOnce();
		});
		
		session = serviceSessionId;
		invite = inviteId;
		evaluateType = evaluateWay;
		_setDefaultScore();
		var mask = utils.createElementFromHTML([
			"<div class=\"mask\"></div>"
		].join(""))
		$(".em-widget-content-box").append(mask)
		if(evaluateType === "system"){
			$(".cancel").removeClass("hidden");
		}
		else{
			$(".cancel").addClass("hidden");
		}
		dialog && dialog.show();
	
	}
	
	function _setDefaultScore(){ 
		if(!starsUl){
			return false;
		} 
		_setSatisfaction();
	}
	
	
	function init(){
		eventListener.add(
			_const.SYSTEM_EVENT.SATISFACTION_EVALUATION_MESSAGE_RECEIVED,
			function(officialAccount, inviteId, serviceSessionId){
				if(officialAccount !== profile.currentOfficialAccount) return;
				show(inviteId, serviceSessionId, "system");
			}
		);
	}


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var uikit = __webpack_require__(180);
	var _const = __webpack_require__(176);
	
	var LOADING = Modernizr.inlinesvg ? _const.loadingSvg : "<img src=\"//kefu.easemob.com/webim/static/img/loading.gif\" width=\"20\" style=\"margin-top:10px;\"/>";
	
	var dialog;
	var showLoadingObj = {};
	
	var _init = _.once(function(){
		var dom = utils.createElementFromHTML("<div class=\"wrapper\">" + LOADING + "</div>");
		dialog = uikit.createDialog({
			contentDom: dom,
			className: "loading"
		});
	});
	
	function _show(secret){
		_init();
		showLoadingObj[secret] = true;
		dialog.show();
	}
	
	function _hide(secret){
		delete showLoadingObj[secret];
		if(_.isEmpty(showLoadingObj)){
			dialog.hide();
		}
	}
	
	module.exports = {
		show: _show,
		hide: _hide,
	};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	var uikit = __webpack_require__(180);
	var apiHelper = __webpack_require__(181);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var commonConfig = __webpack_require__(177);
	var dom;
	var dialog;
	var dialogShow = false;
	
	module.exports = {
		init: init,
		show: show,
	};
	
	function _init(){
		apiHelper.getSessionClosedDialog().then(function(res){
			if(res.data && res.data.entities.length >0 && res.data.entities[0].optionValue == "true"){
				apiHelper.getSessionClosedDialogUrl().then(function(res){
					dom = utils.createElementFromHTML([
						"<div class=\"wrapper\">",
						"<div class=\"custom-url-title\"><i class=\"icon-close\"></i></div>",
						"<iframe  src=\""+ res.data.entities[0].optionValue +"\" frameborder=\"0\"></iframe>",
						"</div>"
					].join(""))
				
		
		utils.live(".custom-url-title .icon-close","click",function(){
			// dialog && dialog.hide();
			dialog && dialog.el.remove();
			dialogShow = false;
		});
	
		if(utils.isMobile){
			dialog = uikit.createDialog({
				isFullSreen: true,
				contentDom: dom,
				className: "session-closed-dialog"
			});
		}
		else{
			dialog = uikit.createDialog({
				isFullSreen: false,
				contentDom: dom,
				className: "session-closed-dialog"
			});
		}
		
		dialog.show();
	
		if(!$(document.querySelector(".em-self-wrapper")).hasClass("hide")){
			dialog.el.style.cssText='left:10px;top:10px;';
			if(!utils.isMobile && $("body").hasClass("window-demo")){
				dom.querySelector(".icon-close").style.cssText='margin-right:20px;';
			}
		}
		else{
			dialog.el.style.cssText='left:0;top:0;';
		}
			})
		}
	})
	}
	
	function show(){
		if(!dialogShow){//_init只执行一次，避免出现发送多次结束会话消息的情况。
			_init();
			dialogShow = true;
		}
		// _init = function(){};
	}
	
	function init(){
		eventListener.add(
			_const.SYSTEM_EVENT.SESSION_CLOSED,
			function(){
				// 满意度评价邀请为主动弹出邀请的情况时，先弹满意度。
				// config = commonConfig.getConfig();
				// if(config.ui.enquiryShowMode === "popup"){
				// 	eventListener.add(
				// 		_const.SYSTEM_EVENT.CUSTOMURL_DIALOG_SHOW,
				// 		function(){
				// 			show();
				// 		}
				// 	);
				// }
				// else{
				// 	show();
				// }
	
				show();
			}
		);
		eventListener.add(
			_const.SYSTEM_EVENT.SESSION_ABORTED,
			function(){
				show();
			}
		);
	}


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	var profile = __webpack_require__(178);
	var getToHost = __webpack_require__(190);
	__webpack_require__(195);
	var AlloyFinger = 	__webpack_require__(196);
	
	var img;
	var imgWrapper;
	var iosLoadTip;
	var androidLoadTip;
	var imgSrc;
	var af;
	var initScale = 1;
	var _init = _.once(function(){
		imgWrapper = document.querySelector("div.img-view");
		var coverHtml = "<div class=\"cover-floor\"></div>"
		$(".img-view").append(coverHtml)
		img = imgWrapper.querySelector("img");
		iosLoadTip = imgWrapper.querySelector("span.ios-load");
		androidLoadTip = imgWrapper.querySelector("a.android-load");
		utils.isAndroid && utils.removeClass(androidLoadTip, "hide");
		utils.isIOS && utils.removeClass(iosLoadTip, "hide");
		
		startAf();
	
		utils.on(imgWrapper, "click", function(){
			utils.addClass(imgWrapper, "hide");
		}, false);
	
		// 解决ios端打开图片还能滑动屏幕的bug
		utils.on(imgWrapper, "touchmove", function(event){
			event.preventDefault();
		});
		utils.off(imgWrapper, "touchmove", function(event){
			event.preventDefault();
		});
		("download" in document.createElement("a")) && utils.on(androidLoadTip, "click", function(){
			window.location = imgSrc;
			return false;
		});
		function preventDefaultFn(event){
			event.preventDefault();
		}
	
	});
	
	function startAf(){
		if(utils.isMobile){
			var el = img;
			Transform(el);
	        af = new AlloyFinger(el, {
				pinch: function (evt) {
	                el.scaleX = el.scaleY = initScale * evt.zoom;
				},
				pressMove: function (evt) {
	                el.translateX += evt.deltaX;
	                el.translateY += evt.deltaY;
	                evt.preventDefault();
				},
	
			})
		}
	}
	
	module.exports = {
		show: function(url){
			if(url.indexOf("blob:") == 0){
				url = url
			}
			else {
	      if (url.indexOf("?") > -1) {
	        url = url + "&origin-file=true";
	      } else {
	        url = url + '?origin-file=true';
	      }
			}
			imgSrc = url;
			_init();
			if(utils.isTop || utils.isMobile){
				img.src = url;
				// 恢复
				initScale = 1;
				img.scaleX = 1;
				img.scaleY = 1;
				img.translateX = 0;
				img.translateY = 0;
	
				// androidLoadTip.href = url;
				utils.removeClass(imgWrapper, "hide");
			}
			else{
				getToHost.send({
					event: _const.EVENTS.SHOW_IMG,
					data: {
						imgSrc: url,
						imgFile: profile.imgFileList.get(url)
					}
				});
			}
		}
	};


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	/* transformjs
	 * By dntzhang
	 */
	;(function () {
	
	    var Matrix3D = function (n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
	        this.elements =window.Float32Array ? new Float32Array(16) : [];
	        var te = this.elements;
	        te[0] = (n11 !== undefined) ? n11 : 1; te[4] = n12 || 0; te[8] = n13 || 0; te[12] = n14 || 0;
	        te[1] = n21 || 0; te[5] = (n22 !== undefined) ? n22 : 1; te[9] = n23 || 0; te[13] = n24 || 0;
	        te[2] = n31 || 0; te[6] = n32 || 0; te[10] = (n33 !== undefined) ? n33 : 1; te[14] = n34 || 0;
	        te[3] = n41 || 0; te[7] = n42 || 0; te[11] = n43 || 0; te[15] = (n44 !== undefined) ? n44 : 1;
	    };
	
	    Matrix3D.DEG_TO_RAD = Math.PI / 180;
	
	    Matrix3D.prototype = {
	        set: function (n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
	            var te = this.elements;
	            te[0] = n11; te[4] = n12; te[8] = n13; te[12] = n14;
	            te[1] = n21; te[5] = n22; te[9] = n23; te[13] = n24;
	            te[2] = n31; te[6] = n32; te[10] = n33; te[14] = n34;
	            te[3] = n41; te[7] = n42; te[11] = n43; te[15] = n44;
	            return this;
	        },
	        identity: function () {
	            this.set(
	                1, 0, 0, 0,
	                0, 1, 0, 0,
	                0, 0, 1, 0,
	                0, 0, 0, 1
	            );
	            return this;
	        },
	        multiplyMatrices: function (a, be) {
	
	            var ae = a.elements;
	            var te = this.elements;
	            var a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
	            var a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
	            var a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
	            var a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
	
	            var b11 = be[0], b12 = be[1], b13 = be[2], b14 = be[3];
	            var b21 = be[4], b22 = be[5], b23 = be[6], b24 = be[7];
	            var b31 = be[8], b32 = be[9], b33 = be[10], b34 = be[11];
	            var b41 = be[12], b42 = be[13], b43 = be[14], b44 = be[15];
	
	            te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
	            te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
	            te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
	            te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
	
	            te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
	            te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
	            te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
	            te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
	
	            te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
	            te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
	            te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
	            te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
	
	            te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
	            te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
	            te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
	            te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
	
	            return this;
	
	        },
	        // 解决角度为90的整数倍导致Math.cos得到极小的数，其实是0。导致不渲染
	        _rounded: function(value,i){
	            i= Math.pow(10, i || 15);
	            // default
	            return Math.round(value*i)/i;
	        },
	        appendTransform: function (x, y, z, scaleX, scaleY, scaleZ, rotateX, rotateY, rotateZ,skewX,skewY, originX, originY, originZ) {
	
	            var rx = rotateX * Matrix3D.DEG_TO_RAD;
	            var cosx =this._rounded( Math.cos(rx));
	            var sinx = this._rounded(Math.sin(rx));
	            var ry = rotateY * Matrix3D.DEG_TO_RAD;
	            var cosy =this._rounded( Math.cos(ry));
	            var siny = this._rounded(Math.sin(ry));
	            var rz = rotateZ * Matrix3D.DEG_TO_RAD;
	            var cosz =this._rounded( Math.cos(rz * -1));
	            var sinz =this._rounded( Math.sin(rz * -1));
	
	            this.multiplyMatrices(this, [
	                1, 0, 0, x,
	                0, cosx, sinx, y,
	                0, -sinx, cosx, z,
	                0, 0, 0, 1
	            ]);
	
	            this.multiplyMatrices(this, [
	                cosy, 0, siny, 0,
	                0, 1, 0, 0,
	                -siny, 0, cosy, 0,
	                0, 0, 0, 1
	            ]);
	
	            this.multiplyMatrices(this,[
	                cosz * scaleX, sinz * scaleY, 0, 0,
	                -sinz * scaleX, cosz * scaleY, 0, 0,
	                0, 0, 1 * scaleZ, 0,
	                0, 0, 0, 1
	            ]);
	
	            if(skewX||skewY){
	                this.multiplyMatrices(this,[
	                    this._rounded(Math.cos(skewX* Matrix3D.DEG_TO_RAD)), this._rounded( Math.sin(skewX* Matrix3D.DEG_TO_RAD)), 0, 0,
	                    -1*this._rounded(Math.sin(skewY* Matrix3D.DEG_TO_RAD)), this._rounded( Math.cos(skewY* Matrix3D.DEG_TO_RAD)), 0, 0,
	                    0, 0, 1, 0,
	                    0, 0, 0, 1
	                ]);
	            }
	
	            if (originX || originY || originZ) {
	                this.elements[12] -= originX * this.elements[0] + originY * this.elements[4] + originZ * this.elements[8];
	                this.elements[13] -= originX * this.elements[1] + originY * this.elements[5] + originZ * this.elements[9];
	                this.elements[14] -= originX * this.elements[2] + originY * this.elements[6] + originZ * this.elements[10];
	            }
	            return this;
	        }
	    };
	
	    function observe(target, props, callback) {
	        for (var i = 0, len = props.length; i < len; i++) {
	            var prop = props[i];
	            watch(target, prop, callback);
	        }
	    }
	
	    function watch(target, prop, callback) {
	        Object.defineProperty(target, prop, {
	            get: function () {
	                return this["__" + prop];
	            },
	            set: function (value) {
	                if (value !== this["__" + prop]) {
	                    this["__" + prop] = value;
	                    callback();
	                }
	
	            }
	        });
	    }
	
	    window.Transform = function (element) {
	
	        observe(
	            element,
	            ["translateX", "translateY", "translateZ", "scaleX", "scaleY", "scaleZ" , "rotateX", "rotateY", "rotateZ","skewX","skewY", "originX", "originY", "originZ"],
	            function () {
	                var mtx = element.matrix3D.identity().appendTransform( element.translateX, element.translateY, element.translateZ, element.scaleX, element.scaleY, element.scaleZ, element.rotateX, element.rotateY, element.rotateZ,element.skewX,element.skewY, element.originX, element.originY, element.originZ);
	                element.style.transform = element.style.msTransform = element.style.OTransform = element.style.MozTransform = element.style.webkitTransform = "perspective("+element.perspective+"px) matrix3d(" + Array.prototype.slice.call(mtx.elements).join(",") + ")";
	            });
	
	        observe(
	            element,
	            [ "perspective"],
	            function () {
	                element.style.transform = element.style.msTransform = element.style.OTransform = element.style.MozTransform = element.style.webkitTransform = "perspective("+element.perspective+"px) matrix3d(" + Array.prototype.slice.call(element.matrix3D.elements).join(",") + ")";
	            });
	
	        element.matrix3D = new Matrix3D();
	        element.perspective = 500;
	        element.scaleX = element.scaleY = element.scaleZ = 1;
	        //由于image自带了x\y\z，所有加上translate前缀
	        element.translateX = element.translateY = element.translateZ = element.rotateX = element.rotateY = element.rotateZ =element.skewX=element.skewY= element.originX = element.originY = element.originZ = 0;
	    }
	})();

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	/* AlloyFinger v0.1.15
	 * By dntzhang
	 * Github: https://github.com/AlloyTeam/AlloyFinger
	 */
	; (function () {
	    function getLen(v) {
	        return Math.sqrt(v.x * v.x + v.y * v.y);
	    }
	
	    function dot(v1, v2) {
	        return v1.x * v2.x + v1.y * v2.y;
	    }
	
	    function getAngle(v1, v2) {
	        var mr = getLen(v1) * getLen(v2);
	        if (mr === 0) return 0;
	        var r = dot(v1, v2) / mr;
	        if (r > 1) r = 1;
	        return Math.acos(r);
	    }
	
	    function cross(v1, v2) {
	        return v1.x * v2.y - v2.x * v1.y;
	    }
	
	    function getRotateAngle(v1, v2) {
	        var angle = getAngle(v1, v2);
	        if (cross(v1, v2) > 0) {
	            angle *= -1;
	        }
	
	        return angle * 180 / Math.PI;
	    }
	
	    var HandlerAdmin = function(el) {
	        this.handlers = [];
	        this.el = el;
	    };
	
	    HandlerAdmin.prototype.add = function(handler) {
	        this.handlers.push(handler);
	    }
	
	    HandlerAdmin.prototype.del = function(handler) {
	        if(!handler) this.handlers = [];
	
	        for(var i=this.handlers.length; i>=0; i--) {
	            if(this.handlers[i] === handler) {
	                this.handlers.splice(i, 1);
	            }
	        }
	    }
	
	    HandlerAdmin.prototype.dispatch = function() {
	        for(var i=0,len=this.handlers.length; i<len; i++) {
	            var handler = this.handlers[i];
	            if(typeof handler === 'function') handler.apply(this.el, arguments);
	        }
	    }
	
	    function wrapFunc(el, handler) {
	        var handlerAdmin = new HandlerAdmin(el);
	        handlerAdmin.add(handler);
	
	        return handlerAdmin;
	    }
	
	    var AlloyFinger = function (el, option) {
	
	        this.element = typeof el == 'string' ? document.querySelector(el) : el;
	
	        this.start = this.start.bind(this);
	        this.move = this.move.bind(this);
	        this.end = this.end.bind(this);
	        this.cancel = this.cancel.bind(this);
	        this.element.addEventListener("touchstart", this.start, false);
	        this.element.addEventListener("touchmove", this.move, false);
	        this.element.addEventListener("touchend", this.end, false);
	        this.element.addEventListener("touchcancel", this.cancel, false);
	
	        this.preV = { x: null, y: null };
	        this.pinchStartLen = null;
	        this.zoom = 1;
	        this.isDoubleTap = false;
	
	        var noop = function () { };
	
	        this.rotate = wrapFunc(this.element, option.rotate || noop);
	        this.touchStart = wrapFunc(this.element, option.touchStart || noop);
	        this.multipointStart = wrapFunc(this.element, option.multipointStart || noop);
	        this.multipointEnd = wrapFunc(this.element, option.multipointEnd || noop);
	        this.pinch = wrapFunc(this.element, option.pinch || noop);
	        this.swipe = wrapFunc(this.element, option.swipe || noop);
	        this.tap = wrapFunc(this.element, option.tap || noop);
	        this.doubleTap = wrapFunc(this.element, option.doubleTap || noop);
	        this.longTap = wrapFunc(this.element, option.longTap || noop);
	        this.singleTap = wrapFunc(this.element, option.singleTap || noop);
	        this.pressMove = wrapFunc(this.element, option.pressMove || noop);
	        this.twoFingerPressMove = wrapFunc(this.element, option.twoFingerPressMove || noop);
	        this.touchMove = wrapFunc(this.element, option.touchMove || noop);
	        this.touchEnd = wrapFunc(this.element, option.touchEnd || noop);
	        this.touchCancel = wrapFunc(this.element, option.touchCancel || noop);
	
	        this._cancelAllHandler = this.cancelAll.bind(this);
	
	        window.addEventListener('scroll', this._cancelAllHandler);
	
	        this.delta = null;
	        this.last = null;
	        this.now = null;
	        this.tapTimeout = null;
	        this.singleTapTimeout = null;
	        this.longTapTimeout = null;
	        this.swipeTimeout = null;
	        this.x1 = this.x2 = this.y1 = this.y2 = null;
	        this.preTapPosition = { x: null, y: null };
	    };
	
	    AlloyFinger.prototype = {
	        start: function (evt) {
	            if (!evt.touches) return;
	            this.now = Date.now();
	            this.x1 = evt.touches[0].pageX;
	            this.y1 = evt.touches[0].pageY;
	            this.delta = this.now - (this.last || this.now);
	            this.touchStart.dispatch(evt, this.element);
	            if (this.preTapPosition.x !== null) {
	                this.isDoubleTap = (this.delta > 0 && this.delta <= 250 && Math.abs(this.preTapPosition.x - this.x1) < 30 && Math.abs(this.preTapPosition.y - this.y1) < 30);
	                if (this.isDoubleTap) clearTimeout(this.singleTapTimeout);
	            }
	            this.preTapPosition.x = this.x1;
	            this.preTapPosition.y = this.y1;
	            this.last = this.now;
	            var preV = this.preV,
	                len = evt.touches.length;
	            if (len > 1) {
	                this._cancelLongTap();
	                this._cancelSingleTap();
	                var v = { x: evt.touches[1].pageX - this.x1, y: evt.touches[1].pageY - this.y1 };
	                preV.x = v.x;
	                preV.y = v.y;
	                this.pinchStartLen = getLen(preV);
	                this.multipointStart.dispatch(evt, this.element);
	            }
	            this._preventTap = false;
	            this.longTapTimeout = setTimeout(function () {
	                this.longTap.dispatch(evt, this.element);
	                this._preventTap = true;
	            }.bind(this), 750);
	        },
	        move: function (evt) {
	            if (!evt.touches) return;
	            var preV = this.preV,
	                len = evt.touches.length,
	                currentX = evt.touches[0].pageX,
	                currentY = evt.touches[0].pageY;
	            this.isDoubleTap = false;
	            if (len > 1) {
	                var sCurrentX = evt.touches[1].pageX,
	                    sCurrentY = evt.touches[1].pageY
	                var v = { x: evt.touches[1].pageX - currentX, y: evt.touches[1].pageY - currentY };
	
	                if (preV.x !== null) {
	                    if (this.pinchStartLen > 0) {
	                        evt.zoom = getLen(v) / this.pinchStartLen;
	                        this.pinch.dispatch(evt, this.element);
	                    }
	
	                    evt.angle = getRotateAngle(v, preV);
	                    this.rotate.dispatch(evt, this.element);
	                }
	                preV.x = v.x;
	                preV.y = v.y;
	
	                if (this.x2 !== null && this.sx2 !== null) {
	                    evt.deltaX = (currentX - this.x2 + sCurrentX - this.sx2) / 2;
	                    evt.deltaY = (currentY - this.y2 + sCurrentY - this.sy2) / 2;
	                } else {
	                    evt.deltaX = 0;
	                    evt.deltaY = 0;
	                }
	                this.twoFingerPressMove.dispatch(evt, this.element);
	
	                this.sx2 = sCurrentX;
	                this.sy2 = sCurrentY;
	            } else {
	                if (this.x2 !== null) {
	                    evt.deltaX = currentX - this.x2;
	                    evt.deltaY = currentY - this.y2;
	
	                    //move事件中添加对当前触摸点到初始触摸点的判断，
	                    //如果曾经大于过某个距离(比如10),就认为是移动到某个地方又移回来，应该不再触发tap事件才对。
	                    var movedX = Math.abs(this.x1 - this.x2),
	                        movedY = Math.abs(this.y1 - this.y2);
	
	                    if(movedX > 10 || movedY > 10){
	                        this._preventTap = true;
	                    }
	
	                } else {
	                    evt.deltaX = 0;
	                    evt.deltaY = 0;
	                }
	                
	                
	                this.pressMove.dispatch(evt, this.element);
	            }
	
	            this.touchMove.dispatch(evt, this.element);
	
	            this._cancelLongTap();
	            this.x2 = currentX;
	            this.y2 = currentY;
	            
	            if (len > 1) {
	                evt.preventDefault();
	            }
	        },
	        end: function (evt) {
	            if (!evt.changedTouches) return;
	            this._cancelLongTap();
	            var self = this;
	            if (evt.touches.length < 2) {
	                this.multipointEnd.dispatch(evt, this.element);
	                this.sx2 = this.sy2 = null;
	            }
	
	            //swipe
	            if ((this.x2 && Math.abs(this.x1 - this.x2) > 30) ||
	                (this.y2 && Math.abs(this.y1 - this.y2) > 30)) {
	                evt.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2);
	                this.swipeTimeout = setTimeout(function () {
	                    self.swipe.dispatch(evt, self.element);
	
	                }, 0)
	            } else {
	                this.tapTimeout = setTimeout(function () {
	                    if(!self._preventTap){
	                        self.tap.dispatch(evt, self.element);
	                    }
	                    // trigger double tap immediately
	                    if (self.isDoubleTap) {
	                        self.doubleTap.dispatch(evt, self.element);
	                        self.isDoubleTap = false;
	                    }
	                }, 0)
	
	                if (!self.isDoubleTap) {
	                    self.singleTapTimeout = setTimeout(function () {
	                        self.singleTap.dispatch(evt, self.element);
	                    }, 250);
	                }
	            }
	
	            this.touchEnd.dispatch(evt, this.element);
	
	            this.preV.x = 0;
	            this.preV.y = 0;
	            this.zoom = 1;
	            this.pinchStartLen = null;
	            this.x1 = this.x2 = this.y1 = this.y2 = null;
	        },
	        cancelAll: function () {
	            this._preventTap = true
	            clearTimeout(this.singleTapTimeout);
	            clearTimeout(this.tapTimeout);
	            clearTimeout(this.longTapTimeout);
	            clearTimeout(this.swipeTimeout);
	        },
	        cancel: function (evt) {
	            this.cancelAll()
	            this.touchCancel.dispatch(evt, this.element);
	        },
	        _cancelLongTap: function () {
	            clearTimeout(this.longTapTimeout);
	        },
	        _cancelSingleTap: function () {
	            clearTimeout(this.singleTapTimeout);
	        },
	        _swipeDirection: function (x1, x2, y1, y2) {
	            return Math.abs(x1 - x2) >= Math.abs(y1 - y2) ? (x1 - x2 > 0 ? 'Left' : 'Right') : (y1 - y2 > 0 ? 'Up' : 'Down')
	        },
	
	        on: function(evt, handler) {
	            if(this[evt]) {
	                this[evt].add(handler);
	            }
	        },
	
	        off: function(evt, handler) {
	            if(this[evt]) {
	                this[evt].del(handler);
	            }
	        },
	
	        destroy: function() {
	            if(this.singleTapTimeout) clearTimeout(this.singleTapTimeout);
	            if(this.tapTimeout) clearTimeout(this.tapTimeout);
	            if(this.longTapTimeout) clearTimeout(this.longTapTimeout);
	            if(this.swipeTimeout) clearTimeout(this.swipeTimeout);
	
	            this.element.removeEventListener("touchstart", this.start);
	            this.element.removeEventListener("touchmove", this.move);
	            this.element.removeEventListener("touchend", this.end);
	            this.element.removeEventListener("touchcancel", this.cancel);
	
	            this.rotate.del();
	            this.touchStart.del();
	            this.multipointStart.del();
	            this.multipointEnd.del();
	            this.pinch.del();
	            this.swipe.del();
	            this.tap.del();
	            this.doubleTap.del();
	            this.longTap.del();
	            this.singleTap.del();
	            this.pressMove.del();
	            this.twoFingerPressMove.del()
	            this.touchMove.del();
	            this.touchEnd.del();
	            this.touchCancel.del();
	
	            this.preV = this.pinchStartLen = this.zoom = this.isDoubleTap = this.delta = this.last = this.now = this.tapTimeout = this.singleTapTimeout = this.longTapTimeout = this.swipeTimeout = this.x1 = this.x2 = this.y1 = this.y2 = this.preTapPosition = this.rotate = this.touchStart = this.multipointStart = this.multipointEnd = this.pinch = this.swipe = this.tap = this.doubleTap = this.longTap = this.singleTap = this.pressMove = this.touchMove = this.touchEnd = this.touchCancel = this.twoFingerPressMove = null;
	
	            window.removeEventListener('scroll', this._cancelAllHandler);
	            return null;
	        }
	    };
	
	    if (true) {
	        module.exports = AlloyFinger;
	    } else {
	        window.AlloyFinger = AlloyFinger;
	    }
	})();


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	var profile = __webpack_require__(178);
	var commonConfig = __webpack_require__(177);
	
	var NOTE_HTML_PATH =  false ? "/note.html" : "/en-US/note.html";
	
	function Iframe(config){
		// 自定义主题色
		var color = "";
		var themeClassName;
		var config = commonConfig.getConfig();
		var themeName = config.ui.themeName;
		if(themeName && themeName.indexOf("theme_custom") > -1){
			var arr = themeName.split("theme_custom");
			color = arr[1];
			themeClassName = "theme_custom";
		}
		else{
			themeClassName = _const.themeMap[config.themeName];
		}
	
		var id = "easemob-iframe-note";
		var className = "easemobim-note-panel";
		var iframe = document.createElement("iframe");
		this.globalConfig = config;
	
		// 留言页面需要用到的数据，不能全部传过去，url 有长度限制
		this.noteConfig = {
			tenantId: config.tenantId,
			configId: config.configId,
			configName: config.configName,
			restServer: config.restServer,
			orgName: config.orgName,
			appName: config.appName,
			user: config.user,
			toUser: config.toUser,
			appKey: config.appKey,
			grayNoteCategory: false,
			sessionId: "",
			hideCloseBtn: false,
			themeClassName: themeClassName,
			showBody: $("body").hasClass("window-demo"),// 获取元素判断留言页面样式，不能在ifram里直接获取外边元素会造成
			showSelf: $("#em-kefu-webim-self").hasClass("hide"),
			themeColor: color
		};
		
		iframe.frameBorder = 0;
		iframe.allowTransparency = "true";
		iframe.id = id;
		iframe.className = className;
		iframe.allow = "microphone; camera";
		if(utils.isMobile){
			this.noteWrapper = document.querySelector(".em-kefu-webim-note-mobile");
		}
		else{
			if($("body").hasClass("window-demo") && $("#em-kefu-webim-self").hasClass("hide")){
				this.noteWrapper = document.querySelector(".em-kefu-webim-note-mobile");
			}
			else{
				this.noteWrapper = document.querySelector(".em-kefu-webim-note");
			}
		}
		this.noteWrapper.appendChild(iframe);
	
		this.iframe = iframe;
	
		this.show = false;
		Iframe.iframe = this;
	
		return this;
	}
	
	
	Iframe.prototype.open = function(config){
		var me = this;
		var base64;
		var iframeSrc = "";
		if(this.show) return this;
		this.show = true;
		this.noteConfig = _.extend({}, this.noteConfig, {
			grayNoteCategory: utils.getDataByPath(profile, "grayList.noteCategory"),
			sessionId: utils.getDataByPath(profile, "currentOfficialAccount.sessionId")
		});
		config = _.extend({}, this.noteConfig, config);
		if(config.hideCloseBtn || !this.globalConfig.noteSrc){
			me.iframe.style.height = "100%";
			utils.addClass(this.noteWrapper.querySelector(".note-top"), "hide");
		}
		
		utils.on(this.iframe, "load", function(){
			utils.removeClass(me.noteWrapper, "hide");
		});
		base64 = encodeURIComponent(JSON.stringify(config));
		base64 = window.btoa
			? window.btoa(base64)
			: base64;
		
		if(this.globalConfig.noteSrc){
			if(this.globalConfig.noteSrc.indexOf("?") > -1){
				iframeSrc = this.globalConfig.noteSrc + "&config=" + base64;
			}
			else{
				iframeSrc = this.globalConfig.noteSrc + "?config=" + base64;
			}
		}
		else{
			iframeSrc = this.globalConfig.domain + "/webim" + NOTE_HTML_PATH + "?config=" + base64;
		}
		this.iframe.src = iframeSrc;
		return this;
	};
	
	Iframe.prototype.close = function(){
		if(this.show === false) return this;
		this.show = false;
	
		utils.addClass(this.noteWrapper, "hide");
	
		return this;
	};
	
	
	
	module.exports = Iframe;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var uikit = __webpack_require__(180);
	var channel = __webpack_require__(186);
	
	var blob;
	var dataURL;
	var imgDom;
	var dialog;
	
	function _init(){
		imgDom = document.createElement("img");
		dialog = uikit.createDialog({
			contentDom: imgDom,
			className: "mini paste-image"
		}).addButton({
			confirmText: "Send",
			confirm: function(){
				channel.sendImg({ data: blob, url: dataURL });
			}
		});
	
		// bind events
		utils.on(
			document.querySelector(".em-widget-send-wrapper .em-widget-textarea"),
			"paste",
			_handler
		);
	}
	
	function _handler(ev){
		if(/^image\/\w+$/.test(utils.getDataByPath(ev, "clipboardData.items.0.type"))){
			blob = ev.clipboardData.items[0].getAsFile();
			dataURL = window.URL.createObjectURL(blob);
			imgDom.src = dataURL;
			dialog.show();
		}
	}
	module.exports = _init;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		视频流程
		1.
			a. 访客发起邀请
			b. 坐席发起邀请
		2. 访客收到ticket
		3. 初始化sdk，回调
		4. 访客加入会议
		5. 振铃
		6. 访客接起
		7. 访客推流
	*/
	
	var _const = __webpack_require__(176);
	var uikit = __webpack_require__(180);
	var channel = __webpack_require__(186);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var utils = __webpack_require__(16);
	var tools = __webpack_require__(188);
	var Dispatcher = __webpack_require__(200);
	var commonConfig = __webpack_require__(177);
	
	var statusBar = __webpack_require__(201);
	var videoPanel = __webpack_require__(203);
	var videoChatTemplate = __webpack_require__(206);
	var apiHelper = __webpack_require__(181);
	var TimerLabel = __webpack_require__(202);
	var videoChatAgora = __webpack_require__(207);
	var videoInviteButton = false;
	var _initOnce = _.once(_init);
	var parentContainer;
	var videoWidget;
	var dispatcher;
	
	var config;
	var dialog, agentInviteDialog, visitorDialog;
	var timerBarDom, timerLabel;
	var service;
	var inviteByVisitor = false; //访客邀请的
	
	var STATIC_PATH =  false ? "static" : "../static";
	
	module.exports = {
		init: init,
	};
	
	function _init(){
		if(videoWidget) return;
		// init dom
		videoWidget = utils.createElementFromHTML(_.template(videoChatTemplate)());
	
		parentContainer.appendChild(videoWidget);
	
		config = commonConfig.getConfig();
	
		if(config.videoH5Status == ""){
			apiHelper.getVideoH5Status().then(function(res){
				if(res.entity){
					config.videoH5Status = res.entity
				}
			})
		}
	
		// init emedia config
		// window.emedia.config({ autoSub: false });
	
		// disable emedia log
		window.emedia.LOG_LEVEL = 5;
	
		dispatcher = new Dispatcher();
	
		service = new window.emedia.Service({
			// 这个目前没有定义，前段可写 web
			resource: "web",
			// 这个人的昵称，可以不写。比如 jid 中的name
			nickName: config.user.username,
	
			// 以下监听，this object == me == service.current
			listeners: {
				// 退出，服务端强制退出，进入会议失败，sdk重连失败等 均会调用到此处
				onMeExit: function(errorCode){
					// var errorMessage = _const.E_MEDIA_SDK_ERROR_CODE_MAP[errorCode] || "unknown error code.";
	
					statusBar.showClosing();
					videoPanel.hide();
					videoInviteButton = false;
	
					// if(errorCode !== 0) throw new Error(errorMessage);
				},
				// 某人进入会议
				onAddMember: function(member){
					console.info({
						type: "memberEnter",
						memberId: member.id,
						memberNickname: member.nickName,
					});
				},
				// 某人退出会议
				onRemoveMember: function(member){
					console.info({
						type: "memberExit",
						memberId: member.id,
						memberNickname: member.nickName,
					});
				},
				// 某人 发布 一个流 （音视频流，共享桌面等）（包含本地流）
				onAddStream: videoPanel.addOrUpdateStream,
				// 某人 取消 一个流 （音视频流，共享桌面等）（包含本地流）
				onRemoveStream: videoPanel.removeStream,
				// 更新 一个流 （音视频流，共享桌面等）。
				// 可能是 断网后，重新获取到远端媒体流，或者对方静音或关闭摄像头
				onUpdateStream: videoPanel.addOrUpdateStream,
				// 这个事件比较多，以后业务拓展时，根据需要再给开放一些回调，目前忽略
				onNotifyEvent: function(evt){
					// 接听 打开本地摄像头 并成功推流
					if(evt instanceof window.emedia.event.PushSuccess){}
					// 接听 打开本地摄像头 推流失败
					else if(evt instanceof window.emedia.event.PushFail){
						uikit.tip("reconnected");
						service.exit();
						inviteByVisitor = false;
						videoInviteButton = false;
					}
					// 接听 打开摄像头失败
					else if(evt instanceof window.emedia.event.OpenMediaError){
						uikit.tip("open camera fail");
						service.exit();
						inviteByVisitor = false;
						videoInviteButton = false;
					}
					else{}
				},
			}
		});
	
		dialog = uikit.createDialog({
			contentDom: [
				"<p class=\"prompt\">",
				"Invite the agent to a video call? Send the invite and wait for the agent to join the video call.",
				"</p>"
			].join(""),
			className: "rtc-video-confirm",
		}).addButton({ confirm: _onConfirm });
	
		var $agentNickname = document.querySelector(".em-widget-header-nickname").innerText;
		var $agentFace = document.querySelector(".em-agent-face").src;
		agentInviteDialog = uikit.createDialog({
			contentDom: [
				"<div>",
				"<p class=\"title\">"+ "Video call" +"</p>",
				"<p class=\"time\"><p>",
				"<p> <img src=\""+ $agentFace +"\" class=\"\"/> </p>",
				"<p class=\"nickname\">"+ $agentNickname +"</p>",
				"<p class=\"title\">"+ "The agent invite you to enter the video call"+"</p>",
				// "<p class=\"title\">客服邀请您进入视频通话</p>",
				// "<div class=\"foot\"> <svg class=\"icon svg-icon\" aria-hidden=\"true\"><use xlink:href=\"#newim-a-anwser1x\"></use> </svg></div>",
				"<div class=\"foot\"> <div class=\"button answer\"><i class=\"icon-answer\"></i> <span>接听</span></div> <div class=\"button huang\"><i class=\"icon-huang\"></i> <span>"+ "Refuse"+"</span></div> </div>",
				"</div>"
			].join(""),
			className: "agent-invite-video-confirm",
		})
		// .addButton({ confirmText: "Accept", cancelText: "Refuse", confirm: _onAgentInviteConfirm, cancel: _onAgentInviteCancel });
	
		utils.live(".icon-answer","click",_onAgentInviteConfirm);
		utils.live(".icon-huang","click",_onAgentInviteCancel);
	
		// agentInviteDialog = uikit.createDialog({
		// 	contentDom: [
		// 		"<div>",
		// 		"<p class=\"time\"><p>",
		// 		"<i class=\"icon-answer\"></i><span class=\"prompt\">",
		// 		"The agent invite you to enter the video call",
		// 		"</span>",
		// 		"</div>"
		// 	].join(""),
		// 	className: "agent-invite-video-confirm",
		// }).addButton({ confirmText: "Accept", cancelText: "Refuse", confirm: _onAgentInviteConfirm, cancel: _onAgentInviteCancel });
	
		timerBarDom = agentInviteDialog.el.querySelector(".time");
		timerLabel = new TimerLabel(timerBarDom);
	
		statusBar.init({
			wrapperDom: videoWidget.querySelector(".status-bar"),
			acceptCallback: function(){
				service.join(function(/* _memId */){
					videoPanel.show();
					statusBar.hideAcceptButton();
					statusBar.startTimer();
					statusBar.setStatusText("connecting");
					_pushStream();
					visitorDialog && visitorDialog.hide();
				}, function(evt){
					service.exit();
					throw new Error("failed to join conference: " + evt.message());
				});
			},
			endCallback: function(){
				service && service.exit();
				inviteByVisitor = false;
			},
		});
	
		videoPanel.init({
			wrapperDom: videoWidget.querySelector(".video-panel"),
			service: service,
			dispatcher: dispatcher,
		});
	}
	
	function startTimer(){
		timerLabel.start();
	}
	
	function init(option){
		var opt;
		var triggerButton;
		var adapterPath;
		var eMediaSdkPath;
	
		if(
			window.location.protocol !== "https:"
			|| !Modernizr.peerconnection // UC 和 夸克 该方法返回false，不支持webRtc
			|| !profile.grayList.audioVideo
		) return;
	
		opt = option || {};
		triggerButton = opt.triggerButton;
		parentContainer = opt.parentContainer;
	  var videoSwitch = opt.videoSwitch;
	
		adapterPath = STATIC_PATH + "/js/lib/adapter.min.js?v=unknown-000";
		eMediaSdkPath = STATIC_PATH + "/js/lib/EMedia_sdk.min.js?v=1.1.2";
	
		// todo: resolve promise sequentially
		tools.loadScript(adapterPath)
		.then(function(){
			return tools.loadScript(eMediaSdkPath);
		})
		.then(function(){
			eventListener.add(_const.SYSTEM_EVENT.VIDEO_TICKET_RECEIVED, _reveiveTicket);
	
	    // 当关闭视频按钮开关时，不触发视频邀请按钮逻辑
	    if(!videoSwitch) return
	    
			// 显示视频邀请按钮，并绑定事件
			utils.removeClass(triggerButton, "hide");
			utils.on(triggerButton, "click", function(){
				if(videoInviteButton) return;
				_initOnce();
				// dialog.show();
				_onConfirm();
				videoInviteButton = true;
			});
		});
		
	}
	
	function _pushStream(){
		var myStream = new service.AVPubstream({ voff: 0, aoff: 0, name: "video" });
	
		service.openUserMedia(myStream).then(function(){
			service.push(myStream);
		});
	}
	
	function _reveiveTicket(ticketInfo, ticketExtend){
		// 有可能收到客服的主动邀请，此时需要初始化
		_initOnce();
	
		// 加入会议
		service.setup(ticketInfo, {
			identity: "visitor",
			nickname: config.visitor.trueName || config.user.username,
			avatarUrl: "",
			extend: ticketExtend
		});
		statusBar.reset();
	
		// 访客邀请的，不显示，直接打开视频, 
		// 开启“视频通话允许访客二次确认”，需要确认
		var wrapperDom = videoWidget.querySelector(".status-bar"); 
		var acceptButtonDom = wrapperDom.querySelector(".accept-button");
		if(inviteByVisitor && config.videoH5Status == false){
			acceptButtonDom.click();
			utils.addClass(acceptButtonDom, "hide");
			inviteByVisitor = false;
			statusBar.show();
		}
		else{
			utils.removeClass(acceptButtonDom, "hide");
			// 访客二次确认
			if(inviteByVisitor && config.videoH5Status){
				statusBar.show();
				$(".visitor-invite-video-confirm").addClass("hide")
			}
			else{
				// 弹 “客服邀请” 窗
				agentInviteDialog.show();
				videoInviteButton = true;
				startTimer();
			}
		}
		
	}
	
	function _onConfirm(){
		inviteByVisitor = true;
		eventListener.trigger("video.conform");
		channel.sendText("Invite the agent to a video call", {
			ext: {
				type: "rtcmedia/video",
				msgtype: {
					liveStreamInvitation: {
						msg: "Invite the agent to a video call",
						orgName: config.orgName,
						appName: config.appName,
						userName: config.user.username,
						imServiceNumber: config.toUser,
						restServer: config.restServer,
						xmppServer: config.xmppServer,
						resource: "webim",
						isNewInvitation: true,
						userAgent: navigator.userAgent,
					},
				},
			},
		});
		// 开启视频通话添加取消按钮
		// var el = utils.createElementFromHTML("<span class=\"em-widget-exit-video\">取消视频通话</span>");
		// var editor = document.querySelector(".toolbar");
		// editor.appendChild(el);
		// var el = utils.createElementFromHTML("<div class=\"swiper-slide em-widget-exit-video\">取消视频通话</div>");
	
		var $agentNickname = document.querySelector(".em-widget-header-nickname").innerText;
		var $agentFace = document.querySelector(".em-agent-face").src;
		visitorDialog = uikit.createDialog({
			contentDom: [
				"<div>",
				"<p class=\"title\">"+ "Video call" +"</p>",
				"<p class=\"time\"><p>",
				"<p> <img src=\""+ $agentFace +"\" class=\"\"/> </p>",
				"<p class=\"nickname\">"+ $agentNickname +"</p>",
				"<p class=\"title\">"+ "You are inviting customer service for a video call"+"</p>",
				// "<div class=\"foot\"> <svg class=\"icon svg-icon\" aria-hidden=\"true\"><use xlink:href=\"#newim-a-anwser1x\"></use> </svg></div>",
				"<div class=\"foot\">  <div class=\"button\"><i class=\"icon-huang\"></i> <span>"+ "Hang up"+"</span></div> </div>",
				"</div>"
			].join(""),
			className: "visitor-invite-video-confirm",
		})
		visitorDialog.show();
		$(".visitor-invite-video-confirm .icon-huang").on("click",_onConfirmExitvideo);
	}
	
	function _onAgentInviteConfirm(){
		timerLabel.stop();
		statusBar.show();
		statusBar.accept();
		agentInviteDialog.hide();
	}
	
	function _onAgentInviteCancel(){
		timerLabel.stop();
		statusBar.end();
		agentInviteDialog.hide();
		videoInviteButton = false;
		inviteByVisitor = false;
	}
	
	function _onConfirmExitvideo(){
		eventListener.trigger("video.cancel");
		var serviceSessionId = profile.currentOfficialAccount.sessionId;
		apiHelper.deleteVideoInvitation(serviceSessionId)
		.then(function(res){
				channel.sendText("The visitor abandoned the video call", {
				// channel.sendText("访客取消实时视频", {
					ext: {
						type: "rtcmedia/video",
						msgtype: {
							visitorCancelInvitation: {
								msg: "The visitor abandoned the video call",
								// msg: "访客取消实时视频",
								orgName: config.orgName,
								appName: config.appName,
								userName: config.user.username,
								imServiceNumber: config.toUser,
								restServer: config.restServer,
								xmppServer: config.xmppServer,
								resource: "webim",
								// isNewInvitation: true,
								userAgent: navigator.userAgent,
							},
						},
					},
				});
				visitorDialog.hide();
				videoInviteButton = false;
				inviteByVisitor = false;
				// // 取消通话移除按钮
				// var editor = document.querySelector(".toolbar");
				// var ele = document.querySelector(".em-widget-exit-video");
				// editor.removeChild(ele)
		});
		// return false;
	
	
	
	}


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var Dict = __webpack_require__(179);
	var List = __webpack_require__(187);
	
	var Dispatecher = module.exports = function(){
		this.eventCallbackDict = new Dict();
	};
	
	Dispatecher.prototype.addEventListener = function(event, callback){
		if(this.eventCallbackDict.has(event)){
			this.eventCallbackDict.get(event).add(callback);
		}
		else{
			this.eventCallbackDict.set(event, new List([callback]));
		}
	};
	
	Dispatecher.prototype.removeEventListener = function(event, callback){
		var callbackList = this.eventCallbackDict.get(event);
	
		callbackList && callbackList.remove(callback);
	};
	
	Dispatecher.prototype.trigger = function(event){
		var callbackList = this.eventCallbackDict.get(event).getAll();
		var argumentList = [];
		var i;
		var l;
	
		// event 取后面的参数列表
		for(i = 1, l = arguments.length; i < l; ++i){
			argumentList.push(arguments[i]);
		}
	
		_.each(callbackList, function(callback){
			try{
				callback.apply({ type: event }, argumentList);
			}
			catch(error){
				console.error("uncaught exception inside eventDispatcher callback.", error);
			}
		});
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var TimerLabel = __webpack_require__(202);
	
	var wrapperDom;
	var timerBarDom;
	var statusTextDom;
	var acceptButtonDom;
	var endButtonDom;
	var collapseToggleButton;
	
	var timerLabel;
	var showClosingTimerHandler;
	
	var acceptCallback;
	var endCallback;
	
	var nopFunction = function(){};
	
	module.exports = {
		init: init,
		startTimer: startTimer,
		show: show,
		hide: hide,
		toggleCollapse: toggleCollapse,
		showClosing: showClosing,
		reset: reset,
		hideAcceptButton: hideAcceptButton,
		setStatusText: setStatusText,
		accept: accept,
		end: end,
	
	};
	
	function init(option){
		var opt = option || {};
	
		if(wrapperDom) throw new Error("statusBar has been already initialized.");
	
		wrapperDom = opt.wrapperDom;
		acceptCallback = opt.acceptCallback || nopFunction;
		endCallback = opt.endCallback || nopFunction;
	
		timerBarDom = wrapperDom.querySelector(".time-escape");
		statusTextDom = wrapperDom.querySelector(".status-text");
		acceptButtonDom = wrapperDom.querySelector(".accept-button");
		endButtonDom = wrapperDom.querySelector(".end-button");
		collapseToggleButton = wrapperDom.querySelector(".collapse-toggle-button");
	
		timerLabel = new TimerLabel(timerBarDom);
	
		utils.on(acceptButtonDom, "click", acceptCallback);
		utils.on(endButtonDom, "click", endCallback);
		utils.on(collapseToggleButton, "click", function(){
			toggleCollapse();
		});
	}
	
	function setStatusText(text){
		statusTextDom.innerText = text;
	}
	
	function toggleCollapse(state){
		utils.toggleClass(wrapperDom, "collapsed", state);
	}
	
	function startTimer(){
		timerLabel.start();
	}
	
	function show(){
		utils.removeClass(wrapperDom, "hide");
		startTimer();
	}
	
	function hide(){
		utils.addClass(wrapperDom, "hide");
	}
	
	function showClosing(){
		toggleCollapse(true);
		utils.addClass(wrapperDom, "terminated");
		setStatusText("Video call ended");
	
		timerLabel.stop();
	
		clearTimeout(showClosingTimerHandler);
		showClosingTimerHandler = setTimeout(function(){
			hide();
			reset();
		}, 3000);
	}
	
	function reset(){
		toggleCollapse(false);
		utils.removeClass(wrapperDom, "terminated");
		// utils.removeClass(acceptButtonDom, "hide");
		showClosingTimerHandler = clearTimeout(showClosingTimerHandler);
		timerLabel.stop();
		setStatusText("Waiting");
		// 移除取消通话按钮
		var editor = document.querySelector(".toolbar");
		var ele = document.querySelector(".visitor-invite-video-confirms");
		if(ele){
			$(ele).addClass("hide");
		}
	}
	
	function hideAcceptButton(){
		utils.addClass(acceptButtonDom, "hide");
	}
	
	function accept(){
		acceptButtonDom.click()
	}
	
	function end(){
		endButtonDom.click()
	}
	


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(17);
	
	var TimerLabel = function(dom){
		this.displayDom = dom;
		this.timerHandler = null;
		this.count = 0;
	};
	
	TimerLabel.prototype.start = function(){
		var me = this;
	
		// 若已存在则清除
		if(this.timerHandler) this.stop();
	
		setTimeout(_trigger, 0);
		this.timerHandler = setInterval(_trigger, 1000);
	
		function _trigger(){
			var escapedTime = me.count++;
			me.displayDom.innerHTML = moment(escapedTime * 1000).format("mm:ss");
		}
	};
	
	TimerLabel.prototype.stop = function(){
		this.timerHandler = clearInterval(this.timerHandler);
		this.count = 0;
	};
	
	module.exports = TimerLabel;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var videoViewer = __webpack_require__(204);
	var MiniVideoWin = __webpack_require__(205);
	var Dict = __webpack_require__(179);
	
	var wrapperDom;
	var multiVideoContainer;
	var singleVideoContainer;
	
	var videoWindowList;
	var dispatcher;
	var userNum = 0;
	
	module.exports = {
		init: init,
		show: show,
		hide: hide,
		addOrUpdateStream: addOrUpdateStream,
		removeStream: removeStream,
	};
	
	function init(option){
		var opt = option || {};
		wrapperDom = opt.wrapperDom;
		dispatcher = opt.dispatcher;
		multiVideoContainer = wrapperDom.querySelector(".multi-video-container");
		singleVideoContainer = wrapperDom.querySelector(".single-video-container");
		videoViewer.init({
			wrapperDom: singleVideoContainer,
			service: opt.service,
			dispatcher: dispatcher,
			parentContainer: wrapperDom
		});
	
		dispatcher.addEventListener("switchToMiniVideoWindow", function(info){
			utils.addClass(multiVideoContainer, "hide");
			videoViewer.show(info);
		});
	
		dispatcher.addEventListener("returnToMultiVideoWindow", function(){
			utils.removeClass(multiVideoContainer, "hide");
			videoViewer.hide();
		});
	
		_reset();
	}
	
	function show(){
		utils.removeClass(wrapperDom, "hide");
	}
	
	function hide(){
		utils.addClass(wrapperDom, "hide");
		_reset();
	}
	
	function _reset(){
		videoWindowList = new Dict();
		videoViewer.hide();
		multiVideoContainer.innerHTML = "";
		utils.removeClass(multiVideoContainer, "hide");
	}
	
	function addOrUpdateStream(stream){
		var streamOwnerName = utils.getDataByPath(stream, "owner.name");
		var targetMiniVideoWindow = videoWindowList.get(streamOwnerName);
	
		if(targetMiniVideoWindow){
			targetMiniVideoWindow.updateStream(stream);
		}
		else{
			videoWindowList.set(streamOwnerName, new MiniVideoWin({
				parentContainer: multiVideoContainer,
				stream: stream,
				dispatcher: dispatcher,
				id: userNum++
			}));
		}
	
		dispatcher.trigger("addOrUpdateStream", stream);
	}
	
	function removeStream(stream){
		var streamOwnerName = utils.getDataByPath(stream, "owner.name");
		var targetMiniVideoWindow = videoWindowList.get(streamOwnerName);
	
		if(!targetMiniVideoWindow) throw new Error("no such object.");
	
		targetMiniVideoWindow.removeStream(stream);
		if(targetMiniVideoWindow.isEmpty()){
			targetMiniVideoWindow.destroy();
			videoWindowList.remove(streamOwnerName);
		}
	
		dispatcher.trigger("removeStream", stream);
	}


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	
	// adapter.js 会劫持这个 api，为了达到预期效果，事先保存
	// var nativeCreateObjectURL = URL && URL.createObjectURL;
	
	var wrapperDom;
	var videoDom;
	var noAudioVideoDom;
	var nicknameDom;
	var returnButtonDom;
	var toggleMicroPhoneButtonDom;
	var toggleCameraButtonDom;
	
	var dispatcher;
	var service;
	var currentStream;
	var currentNoAudioStream;
	var currentOwnerName;
	
	module.exports = {
		init: init,
		show: show,
		hide: hide,
	};
	
	function init(option){
		var opt = option || {};
		if(wrapperDom){
			throw new Error("video viewer has been already initialized.");
		}
	
		wrapperDom = opt.wrapperDom;
		service = opt.service;
		dispatcher = opt.dispatcher;
		parentContainer = opt.parentContainer;
	
		videoDom = wrapperDom.querySelector(".main-video");
		noAudioVideoDom = wrapperDom.querySelector(".no-audio-video");
		nicknameDom = wrapperDom.querySelector(".nickname");
		returnButtonDom = wrapperDom.querySelector(".return-to-multi-video");
		toggleMicroPhoneButtonDom = wrapperDom.querySelector(".toggle-microphone-btn");
		toggleCameraButtonDom = wrapperDom.querySelector(".toggle-carema-btn");
		toggleFullScreenButtonDom = wrapperDom.querySelector(".toggle-full-screen-btn");
	
		dispatcher.addEventListener("addOrUpdateStream", _addOrUpdateStream);
		dispatcher.addEventListener("removeStream", _removeStream);
	
		// 大小
		utils.on(returnButtonDom, "click", _returnToMultivideo);
		// 声音
		utils.on(toggleMicroPhoneButtonDom, "click", _toggleMicroPhone);
		// 是否可见
		utils.on(toggleCameraButtonDom, "click", _toggleCarema);
		// 全屏
		utils.on(toggleFullScreenButtonDom, "click", _toggleFullScreen);
	
	
		if(utils.isMobile){
			utils.removeClass(toggleFullScreenButtonDom, "hide");
		}
	}
	
	function _returnToMultivideo(){
		dispatcher.trigger("returnToMultiVideoWindow");
	
		$(".video-chat-wrapper").css("height","auto");
		parentContainer.style.height = "auto";
		wrapperDom.style.height = "270px";
		utils.addClass(toggleFullScreenButtonDom, "icon-fullscreen");
		utils.removeClass(toggleFullScreenButtonDom, "icon-hrefscreen");
	}
	
	function _toggleMicroPhone(){
		service.aoff(currentStream, !currentStream.aoff);
		_updateButtonStatus();
	}
	
	function _toggleCarema(){
		service.voff(currentStream, !currentStream.voff);
		_updateButtonStatus();
	}
	
	function _toggleFullScreen(){
		utils.toggleClass(wrapperDom, "big");
		if(utils.hasClass(wrapperDom, "big")){
			$(".video-chat-wrapper").css("height","100%");
			parentContainer.style.height = "100%";
			wrapperDom.style.height = "calc(100% - 88px)";
			utils.removeClass(toggleFullScreenButtonDom, "icon-fullscreen");
			utils.addClass(toggleFullScreenButtonDom, "icon-hrefscreen");
		}
		else{
			$(".video-chat-wrapper").css("height","auto");
			parentContainer.style.height = "auto";
			wrapperDom.style.height = "270px";
			utils.addClass(toggleFullScreenButtonDom, "icon-fullscreen");
			utils.removeClass(toggleFullScreenButtonDom, "icon-hrefscreen");
		}
	}
	
	function _updateButtonStatus(){
		var isLocal = currentStream && currentStream.located();
		var isMicroPhoneDisabled;
		var isCameraDisabled;
	
		utils.toggleClass(toggleMicroPhoneButtonDom, "hide", !isLocal);
		utils.toggleClass(toggleCameraButtonDom, "hide", !isLocal);
	
		if(isLocal){
			isMicroPhoneDisabled = !!currentStream.aoff;
			isCameraDisabled = !!currentStream.voff;
	
			utils.toggleClass(toggleMicroPhoneButtonDom, "icon-microphone", !isMicroPhoneDisabled);
			utils.toggleClass(toggleMicroPhoneButtonDom, "icon-disable-microphone", isMicroPhoneDisabled);
	
			utils.toggleClass(toggleCameraButtonDom, "icon-camera", !isCameraDisabled);
			utils.toggleClass(toggleCameraButtonDom, "icon-disable-camera", isCameraDisabled);
		}
	}
	
	function show(info){
		// reset video dom
		currentStream = null;
		videoDom.src = "";
		nicknameDom.innerText = "";
		currentNoAudioStream = null;
		noAudioVideoDom.src = "";
		utils.removeClass(videoDom, "hide");
		utils.addClass(noAudioVideoDom, "hide");
	
		currentOwnerName = info.ownerName;
		_.each(info.streams, _addOrUpdateStream);
		utils.removeClass(wrapperDom, "hide");
	}
	
	function hide(){
		currentOwnerName = null;
		_updateButtonStatus();
		utils.addClass(wrapperDom, "hide");
	}
	
	function _addOrUpdateStream(stream){
	
		var ownerName = utils.getDataByPath(stream, "owner.name");
		var isLocalStream = stream.located();
		var mediaStream;
	
		if(ownerName !== currentOwnerName) return;
	
		mediaStream = stream.getMediaStream();
	
		switch(stream.type){
		case _const.STREAM_TYPE.NORMAL:
			currentStream = stream;
			videoDom.src = mediaStream ? URL.createObjectURL(mediaStream) : "";
			// 本地视频需要 muted
			videoDom.muted = isLocalStream;
			nicknameDom.innerText = isLocalStream
				? "Me"
				: utils.getDataByPath(stream, "owner.ext.nickname");
			break;
		case _const.STREAM_TYPE.NO_AUDIO:
			currentNoAudioStream = stream;
			noAudioVideoDom.src = mediaStream ? URL.createObjectURL(mediaStream) : "";
			utils.addClass(videoDom, "hide");
			utils.removeClass(noAudioVideoDom, "hide");
			break;
		default:
			throw new Error("unexpected stream type.");
		}
		_updateButtonStatus();
	}
	
	function _removeStream(stream){
		switch(stream.type){
		case _const.STREAM_TYPE.NORMAL:
			currentStream = null;
			videoDom.src = "";
			nicknameDom.innerText = "";
			break;
		case _const.STREAM_TYPE.NO_AUDIO:
			currentNoAudioStream = null;
			noAudioVideoDom.src = "";
			utils.removeClass(videoDom, "hide");
			utils.addClass(noAudioVideoDom, "hide");
			break;
		default:
			throw new Error("unexpected stream type.");
		}
	
		_updateButtonStatus();
	
		// exit single viewer mode when all streams removed
		if(!currentStream && !currentNoAudioStream){
			dispatcher.trigger("returnToMultiVideoWindow");
		}
	}


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	
	var template = _.template([
		"<div class=\"mini-video-window\">",
		"<p class=\"nickname\"></p>",
		"<video <%= muted %> autoplay playsinline webkit-playsinline class=\"main-video\"></video>",
		"<video muted autoplay playsinline webkit-playsinline class=\"no-audio-video hide\"></video>",
		"<span class=\"play-button hide\"><i class=\"button-icon icon-star\"></i></span>",
		"</div>",
	].join(""));
	
	var MiniVideoWin;
	
	module.exports = MiniVideoWin = function(option){ 
		var opt = option || {};
		var stream = opt.stream;
		var me = this;
		var isLocalStream = stream.located();
	
		this.parentContainer = opt.parentContainer;
		this.dispatcher = opt.dispatcher;
		this.eventHandler = function(){
			me.dispatcher.trigger("switchToMiniVideoWindow", {
				ownerName: me.ownerName,
				streams: _.compact([me.stream, me.noAudioStream]),
			});
		};
		this.eventHandler2 = function(e){
			me.videoDom && me.videoDom.play();
			me.noAudioVideoDom && me.noAudioVideoDom.play();
			utils.addClass(me.playButtonDom, "hide");
			utils.stopPropagation();
		};
	
		// 本地视频需要 muted
		this.dom = utils.createElementFromHTML(template({
			muted: isLocalStream ? "muted" : ""
		}));
		this.nicknameDom = this.dom.querySelector(".nickname");
		this.videoDom = this.dom.querySelector(".main-video");
		this.playButtonDom = this.dom.querySelector(".play-button");
		this.noAudioVideoDom = this.dom.querySelector(".no-audio-video");
		this.parentContainer.appendChild(this.dom);
	
		this.stream = null;
		this.noAudioStream = null;
		this.ownerName = "";
		this.updateStream(stream);
	
		utils.on(this.dom, "click", this.eventHandler);
		utils.on(this.playButtonDom, "click", this.eventHandler2);
	};
	
	MiniVideoWin.prototype.destroy = function(){
		utils.off(this.dom, "click", this.eventHandler);
		utils.off(this.playButtonDom, "click", this.eventHandler2);
		this.dom.remove();
	};
	
	MiniVideoWin.prototype.getStream = function(){
		return this.stream;
	};
	
	MiniVideoWin.prototype.isEmpty = function(){
		return !this.stream;
	};
	
	MiniVideoWin.prototype.removeStream = function(stream){
		switch(stream.type){
		case _const.STREAM_TYPE.NORMAL:
			this.stream = null;
			this.videoDom.src = "";
			this.nicknameDom.innerText = "";
			break;
		case _const.STREAM_TYPE.NO_AUDIO:
			this.noAudioStream = null;
			this.noAudioVideoDom.src = "";
			utils.removeClass(this.videoDom, "hide");
			utils.addClass(this.noAudioVideoDom, "hide");
			break;
		default:
			throw new Error("unexpected stream type.");
		}
	};
	
	MiniVideoWin.prototype.updateStream = function(stream){
		var mediaStream = stream.getMediaStream();
		var isLocalStream = stream.located();
	
		this.ownerName = utils.getDataByPath(stream, "owner.name");
	
		switch(stream.type){
		case _const.STREAM_TYPE.NORMAL:
			this.stream = stream;
			this.videoDom.src = mediaStream ? URL.createObjectURL(mediaStream) : "";
			this.nicknameDom.innerText = isLocalStream
				? "Me"
				: utils.getDataByPath(stream, "owner.ext.nickname");
	
			isLocalStream && utils.addClass(this.videoDom, "me-video"); 
			if(utils.isMobile){
				!isLocalStream && utils.addClass(this.dom, "current-video");
			}
			 
			
			break;
		case _const.STREAM_TYPE.NO_AUDIO:
			this.noAudioStream = stream;
			this.noAudioVideoDom.src = mediaStream ? URL.createObjectURL(mediaStream) : "";
			utils.addClass(this.videoDom, "hide");
			utils.removeClass(this.noAudioVideoDom, "hide");
			break;
		default:
			throw new Error("unexpected stream type.");
		}
	
		// Safari 浏览器不会自动播放视频，要显示播放按钮
		if(utils.isSafari && (
			// 自己的视频、正在播放的视频不显示播放按钮
			(this.stream && !this.stream.located() && this.stream.paused)
			// 别人的共享桌面也要显示按钮
			|| (this.noAudioStream && this.noAudioStream.paused)
		)){
			utils.removeClass(this.playButtonDom, "hide");
		}
	};
	


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	module.exports = "<div class=video-chat-wrapper> <div class=\"status-bar hide\"> <div> <span class=status-text></span> <span class=time-escape></span> </div> <div class=control-panel> <i class=\"accept-button icon-answer hide\"></i> <i class=\"end-button icon-decline\"></i> </div> <i class=\"collapse-toggle-button icon-arrow-right\"></i> </div> <div class=\"video-panel hide\"> <div class=multi-video-container></div> <div class=\"single-video-container hide\"> <video autoplay playsinline class=main-video></video> <video autoplay playsinline class=\"no-audio-video hide\"></video> <p class=nickname></p> <div class=control-panel> <i class=\"return-to-multi-video icon-return-to-multi-video\"></i> <i class=\"toggle-full-screen-btn hide icon-fullscreen\"></i> <i class=\"toggle-microphone-btn icon-microphone\"></i> <i class=\"toggle-carema-btn icon-camera\"></i> </div> </div> </div> <div id=main-video-argo> <div class=\"mini-video-argo hide\"> <div id=mini-video-agent0 class=mini-video-agent> <span class=nickname></span> </div> <div id=mini-video-visitor></div> <div id=mini-video-agent1 class=mini-video-agent></div> </div> <div class=\"big-video-argo hide\"> <div id=big-video-argo> <i class=\"return-to-multi-video icon-return-to-multi-video\"></i> <i class=\"toggle-full-screen-btn hide icon-fullscreen\"></i> <i class=\"toggle-microphone-btn icon-microphone hide\"></i> <i class=\"desktop-share icon-desktop hide\"></i> <i class=\"toggle-carema-btn icon-camera hide\"></i> <span class=nickname></span> </div> </div> </div> </div> ";

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	@params
	clientConfig 创建客户端的配置
	onRemoteUserChange 远端⽤户对象change变化回调
	onJoinstateChange 加⼊房间状体变化事件
	onErrorNotify 错误回调
	onUserJoined ⽤户加⼊回调 *（加⼊后不能⽴即播放 user上还没有 audioTrack videoTrack 需要在handleUserPublished 回调触发之后才可以）
	onUserLeft ⽤户离开回调
	*/
	
	function log() {
	  var _console;
	
	  for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
	    params[_key] = arguments[_key];
	  }
	
	  (_console = console).log.apply(_console, params.concat(['myself']));
	}
	
	var func = function func() {
	  return void 0;
	};
	
	var HxVideo = function () {
	  function HxVideo() {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, HxVideo);
	
	    var _config$clientConfig = config.clientConfig;
	    var clientConfig = _config$clientConfig === undefined ? { codec: 'h264', mode: 'live', role: 'host' } : _config$clientConfig;
	    var _config$onRemoteUserC = config.onRemoteUserChange;
	    var onRemoteUserChange = _config$onRemoteUserC === undefined ? func : _config$onRemoteUserC;
	    var _config$onErrorNotify = config.onErrorNotify;
	    var onErrorNotify = _config$onErrorNotify === undefined ? func : _config$onErrorNotify;
	    var _config$onUserJoined = config.onUserJoined;
	    var onUserJoined = _config$onUserJoined === undefined ? func : _config$onUserJoined;
	    var _config$onUserLeft = config.onUserLeft;
	    var onUserLeft = _config$onUserLeft === undefined ? func : _config$onUserLeft;
	
	
	    this.config = config;
	    this.client = AgoraRTC.createClient(clientConfig); //创建客户端
	    this.joinState = false; //是否加入了频道
	    this.remoteUsers = []; //远端客户对象
	    this.localAudioTrack = null; //本地音频轨道
	    this.localVideoTrack = null; //本地视频轨道
	    this.localScreenTrack = null; //本地p屏幕轨道
	    this.localScreenVideoTrack = null; //本地屏幕视频轨道
	    this.localScreenAudioTrack = null; //本地屏幕音频轨道
	
	
	    this.onRemoteUserChange = onRemoteUserChange.bind(this); //远端用户change回调
	    this.onErrorNotify = onErrorNotify.bind(this); // 错误回调
	    this.onUserJoined = onUserJoined.bind(this); // 当前用户加入回调
	    this.onUserLeft = onUserLeft.bind(this); // 当前用户离开回调
	
	    this.handleUserPublished = this.handleUserPublished.bind(this);
	    this.handleUserUnpublished = this.handleUserUnpublished.bind(this);
	    this.handleUserJoined = this.handleUserJoined.bind(this);
	    this.handleUserLeft = this.handleUserLeft.bind(this);
	
	    this.bindClientListener();
	  }
	
	  /* 创建本地音视频轨道 */
	
	
	  _createClass(HxVideo, [{
	    key: 'createLocalTracks',
	    value: function createLocalTracks(audioConfig, videoConfig) {
	      var _this = this;
	
	      return new Promise(function (resolve, reject) {
	        if (_this.localAudioTrack && _this.localVideoTrack) {
	          return resolve([_this.localAudioTrack, _this.localVideoTrack]);
	        }
	        AgoraRTC.getCameras().then(function(cameras) {
	          // alert(JSON.stringify(cameras));
	          if(!cameras.length){
	            return
	          }
	          var defaultDevice = 
	          AgoraRTC.createMicrophoneAndCameraTracks(audioConfig, Object.assign({cameraId: cameras[0].deviceId}, videoConfig)).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2);
	  
	            var microphoneTrack = _ref2[0];
	            var cameraTrack = _ref2[1];
	  
	            _this.localAudioTrack = microphoneTrack;
	            _this.localVideoTrack = cameraTrack;
	            _this.deviceId = cameras[0].deviceId;
	            resolve([microphoneTrack, cameraTrack]);
	          }).catch(function (error) {
	            _this.onErrorNotify(error.code);
	          });
	        })
	      });
	    }
	
	    /* 创建用于屏幕共享的视频轨道 */
	  }, {
	    key: 'createScreenVideoTrack',
	    value: function createScreenVideoTrack(config) {
	      var _this2 = this;
	
	      return AgoraRTC.createScreenVideoTrack(config&&config.TrackInitConfig,config&&config.withAudio).then(function (localScreenTrack) {
	        if(localScreenTrack instanceof Array){
	          _this2.localScreenVideoTrack = localScreenTrack[0];
	          _this2.localScreenAudioTrack = localScreenTrack[1];
	        }
	        else{
	          _this2.localScreenVideoTrack = localScreenTrack;
	        }
	        return localScreenTrack;
	      }).catch(function (error) {
	        _this2.onErrorNotify(error.code);
	      });
	    }
	  }, {
	    key: 'publish',
	    value: function publish() {
	      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
	        params[_key] = arguments[_key];
	      }
	
	      this.client.publish(params);
	    }
	    /* audioConfig, videoConfig 创建本地音视频轨道的参数 */
	
	  }, {
	    key: 'join',
	    value: function join(_ref3) {
	      var _this3 = this;
	
	      var appid = _ref3.appid;
	      var channel = _ref3.channel;
	      var token = _ref3.token;
	      var uid = _ref3.uid;
	      var audioConfig = _ref3.audioConfig;
	      var videoConfig = _ref3.videoConfig;
	
	      if (!this.client) return;
	
	      return this.createLocalTracks(audioConfig, videoConfig).then(function (_ref4) {
	        var _ref5 = _slicedToArray(_ref4, 2);
	
	        var microphoneTrack = _ref5[0];
	        var cameraTrack = _ref5[1];
	
	        return _this3.client.join(appid, channel, token || null, uid || undefined);
	      }).then(function () {
	        return _this3.publish(_this3.localAudioTrack, _this3.localVideoTrack);
	      }).then(function () {
	        _this3.setJoinState(true);
	      }).catch(function (error) {
	        _this3.onErrorNotify(error.code);
	      });
	    }
	  }, {
	    key: 'closeLocalTrack',
		// 关闭本地⾳视频轨道
	    value: function closeLocalTrack(type) {
	      switch (type) {
	        case 'audio':
	          return void this.closeLocalAudioTrack();
	        case 'video':
	          return void this.closeLocalVideoTrack();
	        case 'screen':
	          return void this.closeLocalScreenTrack();
	
	        default:
	          this.closeLocalAudioTrack();
	          this.closeLocalVideoTrack();
	          this.closeLocalScreenTrack();
	          return void 0;
	      }
	    }
	    // 关闭本地音频轨道
	  }, {
	    key: 'closeLocalAudioTrack',
	    value: function closeLocalAudioTrack() {
	      var _this4 = this;
	      if (this.localAudioTrack) {
	        this.client.unpublish(this.localAudioTrack).then(function () {
	          _this4.localAudioTrack.stop();
	          _this4.localAudioTrack.close();
	          _this4.localAudioTrack = void 0;
	        });
	      } else {
	        return Promise.resolve();
	      }
	    }
	    // 关闭本地视频轨道
	  }, {
	    key: 'closeLocalVideoTrack',
	    value: function closeLocalVideoTrack() {
	      var _this5 = this;
	      if (this.localVideoTrack) {
	        return this.client.unpublish(this.localVideoTrack).then(function () {
	          _this5.localVideoTrack.stop();
	          _this5.localVideoTrack.close();
	          _this5.localVideoTrack = void 0;
	        });
	      } else {
	        return Promise.resolve();
	      }
	    }
	  }, {
	    key: 'closeLocalScreenTrack',
	    value: function closeLocalScreenTrack() {
	      var _this6 = this;
	
	      if (this.localScreenTrack) {
	        return this.client.unpublish(this.localScreenTrack).then(function () {
	          _this6.localScreenTrack.stop();
	          _this6.localScreenTrack.close();
	          _this6.localScreenTrack = void 0;
	        });
	      } else {
	        return Promise.resolve();
	      }
	    }
	
	    /* 离开 */
	
	  }, {
	    key: 'leave',
	    value: function leave() {
	      this.closeLocalTrack();
	      this.setRemoteUsers([]);
	      this.setJoinState(false);
	      return this.client.leave();
	    }
	  }, {
	    key: 'setJoinState',
	    value: function setJoinState(value) {
	      this.joinState = value;
	    }
	
	    
	
	  }, {
	    key: 'setRemoteUsers',
		/* 设置remoteUser 远端客户 */
	    value: function setRemoteUsers(users) {
	      this.remoteUsers = users || Array.from(this.client.remoteUsers);
	      this.onRemoteUserChange(this.remoteUsers);
	    }
	
	    /* 销毁函数 */
	
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.unBindClientListener();
	      this.client = null;
	      this.localAudioTrack = null;
	      this.localVideoTrack = null;
	      this.localScreenTrack = null;
	    }
	
	    
	
	  }, {
	    key: 'handleUserPublished',
		/* ⽤户发布出发回调 */
	    value: function handleUserPublished(user, mediaType) {
	      var _this7 = this;
	
	      this.client.subscribe(user, mediaType).then(function () {
	        _this7.setRemoteUsers();
	      }).catch(function (error) {
	        _this7.onErrorNotify(error.code);
	      });
	    }
	
	    /* 用户取消发布触发回调 */
	
	  }, {
	    key: 'handleUserUnpublished',
	    value: function handleUserUnpublished() {
	      this.setRemoteUsers();
	    }
	
	    /* 用户加入回调 */
	
	  }, {
	    key: 'handleUserJoined',
	    value: function handleUserJoined(user) {
	      this.onUserJoined();
	      this.setRemoteUsers();
	    }
	
	    /* 用户离开回调 */
	
	  }, {
	    key: 'handleUserLeft',
	    value: function handleUserLeft() {
	      this.onUserLeft();
	      this.setRemoteUsers();
	    }
	
	    /* 取消监听 */
	
	  }, {
	    key: 'unBindClientListener',
	    value: function unBindClientListener() {
	      this.client.off('user-published', this.handleUserPublished);
	      this.client.off('user-unpublished', this.handleUserUnpublished);
	      this.client.off('user-joined', this.handleUserJoined);
	      this.client.off('user-left', this.handleUserLeft);
	    }
	
	    /* 添加监听 */
	
	  }, {
	    key: 'bindClientListener',
	    value: function bindClientListener() {
	      if (!this.client) return;
	      this.client.on('user-published', this.handleUserPublished);
	      this.client.on('user-unpublished', this.handleUserUnpublished);
	      this.client.on('user-joined', this.handleUserJoined);
	      this.client.on('user-left', this.handleUserLeft);
	    }
	  }]);
	
	  return HxVideo;
	}();
	module.exports = HxVideo;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		视频流程
		1.加载声网sdk
		2.
			a. 访客发起邀请
			b. 坐席发起邀请
		3. 访客收到ticket
		4初始化sdk，回调
		5. 访客加入会议
	*/
	
	var _const = __webpack_require__(176);
	var uikit = __webpack_require__(180);
	var channel = __webpack_require__(186);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var utils = __webpack_require__(16);
	var tools = __webpack_require__(188);
	var Dispatcher = __webpack_require__(200);
	var commonConfig = __webpack_require__(177);
	
	var statusBar = __webpack_require__(201);
	var videoPanel = __webpack_require__(203);
	// var videoChatTemplate = require("../../../../template/videoChat.html");
	var videoAgoraTemplate = __webpack_require__(209);
	var apiHelper = __webpack_require__(181);
	var TimerLabel = __webpack_require__(202);
	var videoChatAgora = __webpack_require__(207);
	var videoConnecting = false; // 是否正在视频通话
	var videoInviteButton = false;
	var thirdAgentName = null;
	var shaDesktopSuccFlag = false;
	var _initOnce = _.once(_init);
	var parentContainer;
	var videoWidget;
	var dispatcher;
	var enlargeEl = {};
	var enlargeBefore = {};
	var config;
	var dialog, agentInviteDialog, visitorDialog;
	var timerBarDom, timerLabel;
	var service;
	var serviceAgora;
	var cfgAgora;
	var callId;
	var inviteByVisitor = false; //访客邀请的
	var whiteBoardConnect = false; //白板是否处于连接中
	var userVideo0,userVideo1;
	var dragMove = __webpack_require__(210)
	var cams = []
	
	var STATIC_PATH =  false ? "static" : "../static";
	
	module.exports = {
		init: init,
	};
	
	function _init(){
		if(videoWidget) return;
		// init dom
		videoWidget = utils.createElementFromHTML(_.template(videoAgoraTemplate)());
		if (!utils.isMobile) {
			$(videoWidget.querySelector('.toggle-carematurn-btn-agora')).addClass('hide');
		}
		AgoraRTC.getCameras().then(function(camsArr) {
			cams = camsArr;
			cams.length < 2 && $(videoWidget.querySelector('.toggle-carematurn-btn-agora')).addClass('gray');
		}, function(err) {
			console.error(err);
		});
	
		parentContainer.appendChild(videoWidget);
		// parentContainer.appendChild(utils.createElementFromHTML(_.template(videoAgoraTemplate)()));
	
		config = commonConfig.getConfig();
	
		if(config.videoH5Status == ""){
			// 允许访客二次确认接口
			apiHelper.getVideoH5Status().then(function(res){
				if(res.entity){
					config.videoH5Status = res.entity
				}
			})
		}
	
		dispatcher = new Dispatcher();
	
		dialog = uikit.createDialog({
			contentDom: [
				"<p class=\"prompt\">",
				"Invite the agent to a video call? Send the invite and wait for the agent to join the video call.",
				"</p>"
			].join(""),
			className: "rtc-video-confirm",
		}).addButton({ confirm: _onConfirm });
	
		var $agentNickname = document.querySelector(".em-widget-header-nickname").innerText;
		var $agentFace = document.querySelector(".em-agent-face").src;
		agentInviteDialog = uikit.createDialog({
			contentDom: [
				"<div>",
				"<p class=\"title\">"+ "Video call" +"</p>",
				"<p class=\"time\"><p>",
				"<p> <img src=\""+ $agentFace +"\" class=\"\"/> </p>",
				"<p class=\"nickname\">"+ $agentNickname +"</p>",
				"<p class=\"title\">"+ "The agent invite you to enter the video call"+"</p>",
				"<div class=\"foot\"> <div class=\"button answer\"><i class=\"icon-answer\"></i> <span>"+ "Answer" +"</span></div> <div class=\"button huang\"><i class=\"icon-huang\"></i> <span>"+ "Refuse"+"</span></div> </div>",
				"</div>"
			].join(""),
			className: "agent-invite-video-confirm",
		})
	
		utils.live(".agent-invite-video-confirm .icon-answer","click",_onAgentInviteConfirm);
		utils.live(".agent-invite-video-confirm .icon-huang","click",_onAgentInviteCancel);
	
	
		timerBarDom = agentInviteDialog.el.querySelector(".time");
		timerLabel = new TimerLabel(timerBarDom);
	
		statusBar.init({
			wrapperDom: videoWidget.querySelector(".status-bar"),
			acceptCallback: function(){
				serviceAgora.join(cfgAgora).then(function(){
					videoConnecting = true;
					statusBar.hideAcceptButton();
					$(".video-agora-wrapper").removeClass("hide");
					$('.end-button').addClass("hide");
					var visitorMicrophoneState = $("#visitor-video >.toggle-microphone-state");
					// $(".mini-video-argo").removeClass("hide");
					// $("#mini-video-agent0>.nickname").html(profile.newNickName);
					$("#visitor-video >.small-name").html("Me");
					if(serviceAgora._audio_muted_){
						// 静音
						visitorMicrophoneState.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
					}
					else{
						visitorMicrophoneState.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
					}
					statusBar.setStatusText("connecting");
					serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video", {fit: "contain"});
					serviceAgora.localAudioTrack && serviceAgora.localAudioTrack.setMuted(false);
					// 静音
					$(".foot>.toggle-microphone-btn-agora").unbind('click').bind('click',function (e){
					// utils.on($(".foot>.toggle-microphone-btn-agora"), "click", function(e){
						if($(e.target).hasClass("icon-microphone-agora")){
							serviceAgora.localAudioTrack && serviceAgora.localAudioTrack.setMuted(true);
							$(e.target).addClass("icon-disable-microphone-agora");
							$(e.target).removeClass("icon-microphone-agora");
							if(!$("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								visitorMicrophoneState.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
							}
							else if($("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								$(".nickNameWraper >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
							}
							else if(!$("#visitor-video").hasClass("visitor-big")  && $("#agent-video").hasClass("agent-big")){
								visitorMicrophoneState.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
							}
						}
						else{
							$(e.target).removeClass("icon-disable-microphone-agora");
							$(e.target).addClass("icon-microphone-agora");
							serviceAgora.localAudioTrack && serviceAgora.localAudioTrack.setMuted(false);
							if(!$("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								visitorMicrophoneState.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
							}
							else if($("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								$(".nickNameWraper >.toggle-microphone-state").addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
							}
							else if(!$("#visitor-video").hasClass("visitor-big")  && $("#agent-video").hasClass("agent-big")){
								visitorMicrophoneState.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
							}
						}
					});
					// 关闭摄像头
					$(".foot>.toggle-carema-btn-agora").unbind('click').bind('click',function (e){
						if($(e.target).hasClass("icon-camera-agora")){
							serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.setMuted(true);
							$(e.target).addClass("icon-disable-camera-agora");
							$(e.target).removeClass("icon-camera-agora");
							$('.foot > .toggle-carematurn-btn-agora').addClass('gray');
						}
						else{
							$(e.target).removeClass("icon-disable-camera-agora");
							$(e.target).addClass("icon-camera-agora");
							serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.setMuted(false);
							$('.foot > .toggle-carematurn-btn-agora').removeClass('gray');
						}
					});
					// 切换摄像头
					$('.foot > .toggle-carematurn-btn-agora').unbind('click').bind('click', function(e) {
						// 关闭摄像头的时候，关闭切换
						if ($('.foot > .icon-disable-camera-agora').length || cams.length < 2) {
							return false;
						}
	
						AgoraRTC.getCameras().then(function(cams) {
							var newCam = cams.find(function(item) {
								return item.deviceId != serviceAgora.deviceId
							})
							var deviceId = newCam ? newCam.deviceId : '';
							// 切换摄像头
							serviceAgora.localVideoTrack.setDevice(deviceId).then(function() {
								// alert("set device success>>" + deviceId + "||| before deviceId>>" + serviceAgora.deviceId);
	              serviceAgora.deviceId = deviceId;
							}).catch(function(e) {
								console.log("set device error", e);
							});
						}, function(err) {
							console.error(err);
						});
					});
					// 获取视频弹窗的宽高
	
					enlargeEl.width = $("#em-kefu-webim-chat").width();
					enlargeEl.height = $("#em-kefu-webim-chat").height();
					// 拖拽缩放
					_dragVideo();
				})
			},
			endCallback: function(){
				serviceAgora.client.unpublish(serviceAgora.localScreenVideoTrack);
				serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.close();
				serviceAgora.localScreenAudioTrack && serviceAgora.localScreenAudioTrack.close();
				returnToMuti();
				serviceAgora.leave();
				videoConnecting = false;
				videoInviteButton = false;
				inviteByVisitor = false;
				statusBar.showClosing();
				// 挂断通知
				channel.sendCmdExitVideo(callId,{
					ext: {
						type: "agorartcmedia/video",
						msgtype: {
							visitorRejectInvitation:{
								callId:callId
							}
						},
					},
				})
				shaDesktopSuccFlag = false;
				// setTimeout(function(){
				// 	$(".video-agora-wrapper").addClass("hide")
				// }, 3000);
				$(".video-agora-wrapper").addClass("hide")
	
			},
		});
	
		// // 展开折叠
		// utils.on($(".collapse-toggle-button"), "click", function(){
		// 	if($(".video-agora-wrapper>.status-bar").hasClass("collapsed")){
		// 		$("#main-video-argo").addClass("hide");
		// 	}
		// 	else{
		// 		$("#main-video-argo").removeClass("hide");
		// 	}
		// });
	
		utils.on($(".desktop-share-agora"), "click", function(){
			onDesktopControl();
		});
		// 挂电话
		utils.on($(".toggle-huang-agora"), "click", function(){
			_closeVideo();
		});
		// 共享桌面灰度，集成端 手机端共享桌面按钮先隐藏
		if(!profile.grayList.shareDesktop || $("body").hasClass("window-demo") || utils.isMobile){
			$('.foot>.desktop-share-agora').addClass("hide");
		}
		// 白板灰度
		if(!profile.grayList.whiteBoard){
			$('.foot>.toggle-white-board-agora').addClass("hide");
		}
		utils.on($(".toggle-enlarge"), "click", function(e){
			if($(e.currentTarget).hasClass("icon-enlarge") ){
				$(".toggle-enlarge").addClass("icon-reduction");
				$(".toggle-enlarge").removeClass("icon-enlarge");
				enlargeBefore.top = $(".video-agora-wrapper").offset().top;
				enlargeBefore.left = $(".video-agora-wrapper").offset().left;
				enlargeBefore.width = $(".video-agora-wrapper").width();
				enlargeBefore.height = $(".video-agora-wrapper").height();
				$(".video-agora-wrapper").css({ 'width': enlargeEl.width + 'px', 'height': enlargeEl.height + 'px','top':'0','left':'0','margin-left': '0px', 'margin-top': '0px','position': 'absolute' });
			}
			else{
				$(".toggle-enlarge").addClass("icon-enlarge");
				$(".toggle-enlarge").removeClass("icon-reduction");
				$(".video-agora-wrapper").css({ 'width': enlargeBefore.width + 'px', 'height': enlargeBefore.height + 'px','top': enlargeBefore.top + 'px','left':enlargeBefore.left + 'px','position': 'fixed' });
			}
		});
		// 缩小
		utils.on($(".icon-narrow"), "click", function(){
			$(".video-agora-wrapper").addClass("hide");
			$(".small-video").removeClass("hide");
			$(".small-video-box").removeClass("hide");
			_dragIconVideo();
		});
		utils.on($(".small-video-box"), "mousedown", function(e){
			var oldTim = new Date().getTime();
			utils.on($(".small-video-box"), "mouseup", function(e){
				if((new Date().getTime() - oldTim) > 300 ){
					return false;
				}
				$(".video-agora-wrapper").removeClass("hide");
				$(".small-video").addClass("hide");
				$(".small-video-box").addClass("hide");
			});
		});
		// 关闭白板
		utils.on($("#close-white"), "click", function(){
			console.log("关闭白板")
			var whiteVideo = $("#white-video");
			if(whiteVideo.hasClass("visitor-white")){
				serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video", {fit: "contain"});
				whiteVideo.removeClass("visitor-white");
				$("#white-board").addClass("hide")
				$("#big-video").removeClass("hide")
			}
			else if(whiteVideo.hasClass("agent0-white")){
				userVideo0._videoTrack && userVideo0._videoTrack.play("big-video", {fit: "contain"});
				whiteVideo.removeClass("agent0-white");
				$("#white-board").addClass("hide")
				$("#big-video").removeClass("hide")
			}
			else if(whiteVideo.hasClass("agent1-white")){
				userVideo1._videoTrack && userVideo1._videoTrack.play("big-video", {fit: "contain"});
				whiteVideo.removeClass("agent1-white");
				$("#white-board").addClass("hide")
				$("#big-video").removeClass("hide")
			}
			creatWhiteboard.destoryWhiteboard(document.getElementById("white-board"));
			whiteVideo.addClass("hide");
			// $("#white-board").empty();
			whiteBoardConnect = false;
			$(".desktop-share-agora").css({"pointer-events":"auto"});
			$(".desktop-share-agora").removeClass("icon-desktop-selected");
			$(".toggle-white-board-agora").css({"pointer-events":"auto"});
			$(".toggle-white-board-agora").removeClass("icon-white-board-connect");
			$(".nickNameWraper").removeClass("hide");
			_dragVideo();
			_dragIconVideo();
		});
		$('.end-button').addClass("hide");
		_dragIconVideo();
		// 白板
		utils.on($(".toggle-white-board-agora"), "click", function(){
			if(whiteBoardConnect){
				return;
			}
			if($(".toggle-enlarge").hasClass("icon-enlarge") ){
				$(".toggle-enlarge").click();
			}
			$("#white-video").removeClass("hide");
			$("#white-video>img").addClass("hide");
			// whiteBoardInitDom();
			_inviteWhiteBoard();
		});
	}
	function returnToMuti(){
		$(".toggle-microphone-btn-agora").removeClass("icon-disable-microphone-agora").addClass("icon-microphone-agora");
		$(".toggle-carema-btn-agora").removeClass("icon-disable-camera-agora").addClass("icon-camera-agora");
		$('.toggle-carematurn-btn-agora').removeClass('gray');
		$(".small-video").addClass("hide");
		$(".small-video-box").addClass("hide");
		$("#visitor-video").removeClass("visitor-big");
		$("#agent-video").removeClass("agent-big");
		if($("body").hasClass("window-demo")){
			$(".video-agora-wrapper").css({ 'width':'360px', 'height':'416px','top':'50%','left':'50%','margin-left': '-180px', 'margin-top': '-208px','position': 'absolute'  });
		}
		else{
			$(".video-agora-wrapper").css({ 'width':'400px', 'height':'616px','top':'50%','left':'50%','margin-left': '-180px', 'margin-top': '-308px','position': 'absolute'  });
		}
		$("#white-video").removeClass("visitor agent0 agent1 visitor-white agent0-white agent1-white").addClass("hide");
		$("#white-board").addClass("hide");
		$("#big-video").removeClass("hide");
		// 恢复共享 白板按钮状态
		$(".desktop-share-agora").css({"pointer-events":"auto"});
		$(".desktop-share-agora").removeClass("icon-desktop-selected");
		$(".toggle-white-board-agora").css({"pointer-events":"auto"});
		$(".toggle-white-board-agora").removeClass("icon-white-board-connect");
	}
	
	function startTimer(){
		timerLabel.start();
	}
	
	function init(option){
		var opt;
		var triggerButton;
		var adapterPath;
		var eMediaSdkPath;
	
		if(
			window.location.protocol !== "https:"
			|| !Modernizr.peerconnection // UC 和 夸克 该方法返回false，不支持webRtc
			|| !profile.grayList.agoraVideo
		) return;
	
		opt = option || {};
		triggerButton = opt.triggerButton;
		parentContainer = opt.parentContainer;
	  var videoSwitch = opt.videoSwitch;
	
		adapterPath = STATIC_PATH + "/js/lib/adapter.min.js?v=unknown-000";
		eMediaSdkPath = STATIC_PATH + "/js/lib/EMedia_sdk.min.js?v=1.1.2";
	
		var eMediaSdkPathSW = STATIC_PATH + "/js/lib/AgoraRTC_N-4.8.0.js";
		var whiteBoardPath = STATIC_PATH + "/js/lib/white_board.js";
		tools.loadScript(adapterPath)
		.then(function(){
			return tools.loadScript(eMediaSdkPathSW);
		})
		.then(function(){
			eventListener.add(_const.SYSTEM_EVENT.VIDEO_TICKET_RECEIVED, _reveiveTicket);
			eventListener.add(_const.SYSTEM_EVENT.VIDEO_ARGO_END, _closeVideo);
			eventListener.add(_const.SYSTEM_EVENT.WHITE_BOARD_RECEIVED, _receiveWhiteBoard);
	    // 当关闭视频按钮开关时，不触发视频邀请按钮逻辑
	    if(!videoSwitch) return
			// 显示视频邀请按钮，并绑定事件
			utils.removeClass(triggerButton, "hide");
			utils.on(triggerButton, "click", function(){
				if(videoInviteButton) return;
				if (videoWidget) {
					cams.length < 2 && $(videoWidget.querySelector('.toggle-carematurn-btn-agora')).addClass('gray');
				}
				_initOnce();
				 serviceAgora = new videoChatAgora({});
				_onConfirm();
				videoInviteButton = true;
				//  serviceAgora.createLocalTracks();
			});
		});
		// 加载白板JS
		if(profile.grayList.whiteBoard){
			tools.loadScript(whiteBoardPath).then(function(){
				window.lodash = _.noConflict();
			})
		}
		
	}
	
	// 收到ticket通知
	function _reveiveTicket(ticketInfo, ticketExtend){
		if(ticketInfo.isThirdAgent && ticketInfo.agentTicket){
			thirdAgentName = ticketInfo.agentTicket.niceName;
		}
		if(videoConnecting) return;
		if (videoWidget) {
			cams.length < 2 && $(videoWidget.querySelector('.toggle-carematurn-btn-agora')).addClass('gray');
		}
		$(".video-agora-wrapper").removeClass("hide");
		// 有可能收到客服的主动邀请，此时需要初始化
		_initOnce();
		// 加入会议
		
		cfgAgora= {
			appid:ticketInfo.appId,
			channel:ticketInfo.channel,
			token:ticketInfo.token,
			uid:ticketInfo.uid
		}
		// callId 拒绝视频邀请要用
		callId = ticketInfo.callId;
		// 初始化声网SDK
	 	serviceAgora = new videoChatAgora({onRemoteUserChange:function(remoteUSer){
				// returnToMuti();
				// statusBar.setStatusText("connecting");
				var microphoneState = $(".nickNameWraper >.toggle-microphone-state");
				var visitorMicrophoneState = $("#visitor-video >.toggle-microphone-state");
				var whiteVideo = $("#white-video");
				remoteUSer.forEach(function (item,index){
					if(index === 1){
						userVideo1 = item;
						$("#agent-video").removeClass("hide");
						userVideo1._videoTrack && userVideo1._videoTrack.play("agent-video", {fit: "contain"});
						userVideo1.audioTrack && userVideo1.audioTrack.play();
						if(userVideo1._audio_muted_){
							// 静音
							if(!$("#visitor-video").hasClass("visitor-big")  && $("#agent-video").hasClass("agent-big")){
								// 三方坐席大图
								userVideo1._videoTrack && userVideo1._videoTrack.play("big-video", {fit: "contain"});
								userVideo0._videoTrack && userVideo0._videoTrack.play("agent-video", {fit: "contain"});
								$(".nickNameWraper >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
								$(".video-agora-wrapper .nickNameWraper >.nickName").html("Agent " + thirdAgentName);
							}
							else if(!$("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								// 坐席大图，三方坐席小图
								userVideo1._videoTrack && userVideo1._videoTrack.play("agent-video", {fit: "contain"});
								if(serviceAgora.localScreenVideoTrack && !serviceAgora.localScreenVideoTrack._isClosed){
									serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("big-video", {fit: "contain"});
								}
								else{
									// serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video");
									userVideo0._videoTrack && userVideo0._videoTrack.play("big-video", {fit: "contain"});
								}
								$("#agent-video  >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
								$("#agent-video >.small-name").html("Agent " + thirdAgentName);
							}
							else if($("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								userVideo1._videoTrack && userVideo1._videoTrack.play("agent-video", {fit: "contain"});
								userVideo0._videoTrack && userVideo0._videoTrack.play("visitor-video", {fit: "contain"});
								$("#agent-video  >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
								$("#agent-video >.small-name").html("Agent " + thirdAgentName);
							}
							// $("#agent-video >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							if(!$("#visitor-video").hasClass("visitor-big")  && $("#agent-video").hasClass("agent-big")){
								// 三方坐席大图
								if(whiteBoardConnect){
									userVideo1._videoTrack && userVideo1._videoTrack.play("agent-video", {fit: "contain"});
								}
								else{
									userVideo1._videoTrack && userVideo1._videoTrack.play("big-video", {fit: "contain"});
									userVideo0._videoTrack && userVideo0._videoTrack.play("agent-video", {fit: "contain"});
								}
								microphoneState.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
								$(".video-agora-wrapper .nickNameWraper >.nickName").html("客服" + thirdAgentName);
							}
							else if(!$("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								// 坐席大图，三方坐席小图
								if(whiteBoardConnect){
									userVideo1._videoTrack && userVideo1._videoTrack.play("agent-video", {fit: "contain"});
								}
								else{
									userVideo1._videoTrack && userVideo1._videoTrack.play("agent-video", {fit: "contain"});
									userVideo0._videoTrack && userVideo0._videoTrack.play("big-video", {fit: "contain"});
								}
								$("#agent-video >.toggle-microphone-state").addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
								$("#agent-video >.small-name").html("Agent " + thirdAgentName);
							}
							else if($("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								if(whiteBoardConnect){
									userVideo1._videoTrack && userVideo1._videoTrack.play("agent-video", {fit: "contain"});
								}
								else{
									userVideo1._videoTrack && userVideo1._videoTrack.play("agent-video", {fit: "contain"});
									userVideo0._videoTrack && userVideo0._videoTrack.play("visitor-video", {fit: "contain"});
								}
								$("#agent-video >.toggle-microphone-state").addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
								$("#agent-video >.small-name").html("Agent " + thirdAgentName);
							}
						}
					}
					else{
						if(whiteBoardConnect){
							return
						}
						userVideo0 = item;
						$("#agent-video").addClass("hide");
						if(userVideo0._audio_muted_){
							// 静音
							if($("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								// 访客大图
								// serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video");
								if(serviceAgora.localScreenVideoTrack && !serviceAgora.localScreenVideoTrack._isClosed){
									serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("big-video", {fit: "contain"});
								}
								else{
									serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video", {fit: "contain"});
								}
								userVideo0._videoTrack && userVideo0._videoTrack.play("visitor-video", {fit: "contain"});
								$("#visitor-video >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
								$("#visitor-video >.small-name").html("Agent " + profile.newNickName);
							}
							else if(!$("#visitor-video").hasClass("visitor-big")  && $("#agent-video").hasClass("agent-big")){
								// 三方坐席大图
								// serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video");
								if(serviceAgora.localScreenVideoTrack && !serviceAgora.localScreenVideoTrack._isClosed){
									serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("visitor-video", {fit: "contain"});
								}
								else{
									serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video", {fit: "contain"});
								}
								userVideo0._videoTrack && userVideo0._videoTrack.play("agent-video", {fit: "contain"});
								$("#agent-video >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
								$("#agent-video .nickNameWraper >.nickName").html("Agent " + profile.newNickName);
							}
							else if(!$("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								// 访客小图
								// serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video");
								if(serviceAgora.localScreenVideoTrack && !serviceAgora.localScreenVideoTrack._isClosed){
									serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("visitor-video", {fit: "contain"});
								}
								else{
									serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video", {fit: "contain"});
								}
								userVideo0._videoTrack && userVideo0._videoTrack.play("big-video", {fit: "contain"});
								userVideo0.audioTrack && userVideo0.audioTrack.play();
								$(".nickNameWraper >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
								$(".video-agora-wrapper .nickNameWraper >.nickName").html("Agent " + profile.newNickName);
							}
							// microphoneState.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							if($("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								// 访客大图
								// serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video");
								if(serviceAgora.localScreenVideoTrack && !serviceAgora.localScreenVideoTrack._isClosed){
									serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("big-video", {fit: "contain"});
								}
								else{
									serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video", {fit: "contain"});
								}
								userVideo0._videoTrack && userVideo0._videoTrack.play("visitor-video", {fit: "contain"});
								userVideo0.audioTrack && userVideo0.audioTrack.play();
								$("#visitor-video >.toggle-microphone-state").addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
								$("#visitor-video >.small-name").html("Agent " + profile.newNickName);
							}
							else if(!$("#visitor-video").hasClass("visitor-big")  && $("#agent-video").hasClass("agent-big")){
								// 三方坐席大图
								if(serviceAgora.localScreenVideoTrack && !serviceAgora.localScreenVideoTrack._isClosed){
									serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("visitor-video", {fit: "contain"});
								}
								else{
									serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video", {fit: "contain"});
								}
								userVideo0._videoTrack && userVideo0._videoTrack.play("agent-video", {fit: "contain"});
								userVideo1._videoTrack && userVideo1._videoTrack.play("big-video", {fit: "contain"});
								$("#agent-video  >.toggle-microphone-state").addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
								$("#agent-video .nickNameWraper >.nickName").html("Agent " + profile.newNickName);
							}
							else if(!$("#visitor-video").hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big")){
								// 访客小图
								if(serviceAgora.localScreenVideoTrack && !serviceAgora.localScreenVideoTrack._isClosed){
									serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("visitor-video", {fit: "contain"});
								}
								else{
									serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video", {fit: "contain"});
								}
								userVideo0._videoTrack && userVideo0._videoTrack.play("big-video", {fit: "contain"});
								userVideo0.audioTrack && userVideo0.audioTrack.play();
								$(".nickNameWraper  >.toggle-microphone-state").addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
								$(".video-agora-wrapper .nickNameWraper >.nickName").html("Agent " + profile.newNickName);
							}
						}
					}
					videoConnecting = true;
				});
				if(remoteUSer.length === 1){
					if(bigVideoEl() === "1"){
						$("#agent-video >.small-name").html("");
						$("#agent-video >.toggle-microphone-state").addClass("hide");
						userVideo0._videoTrack && userVideo0._videoTrack.play("big-video", {fit: "contain"});
						$(".video-agora-wrapper .nickNameWraper >.nickName").html("Agent " + profile.newNickName);
					}
					else{
						$("#agent-video >.small-name").html("");
						$("#agent-video >.toggle-microphone-state").addClass("hide");
					}
					$("#agent-video").addClass("hide");
				}
				// 第三方客服
				$('#agent-video').unbind('click').bind('click',function (e){
					if(whiteBoardConnect){
						$("#white-board").addClass("hide")
						$("#big-video").removeClass("hide")
						$("#white-video>img").removeClass("hide");
						$("#white-video >.small-name").addClass("hide")
						$("#white-video  >.toggle-microphone-state").addClass("hide");
						whiteVideo.removeClass("visitor agent0 agent1 visitor-white agent0-white agent1-white");
					}
					if($(e.currentTarget).hasClass("agent-big") && !$("#visitor-video").hasClass("visitor-big")){
						userVideo0._videoTrack && userVideo0._videoTrack.play("big-video", {fit: "contain"});
						userVideo1._videoTrack && userVideo1._videoTrack.play("agent-video", {fit: "contain"});
						whiteVideo.addClass("agent0");
						$(e.currentTarget).removeClass("agent-big")
						$(".video-agora-wrapper .nickNameWraper >.nickName").html("Agent " + profile.newNickName);
						$("#agent-video >.small-name").html("Agent " + thirdAgentName);
						if(userVideo1._audio_muted_){
							// 静音
							// microphoneState.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
							$("#agent-video >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							$("#agent-video >.toggle-microphone-state").addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
						}
						if(userVideo0._audio_muted_){
							// 静音
							microphoneState.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							microphoneState.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
						}
					}
					else if(!$(e.currentTarget).hasClass("agent-big") && !$("#visitor-video").hasClass("visitor-big")){
						userVideo0._videoTrack && userVideo0._videoTrack.play("agent-video", {fit: "contain"});
						userVideo1._videoTrack && userVideo1._videoTrack.play("big-video", {fit: "contain"});
						whiteVideo.addClass("agent1");
						$(e.currentTarget).addClass("agent-big")
						$(".video-agora-wrapper .nickNameWraper >.nickName").html("Agent " + thirdAgentName);
						$("#agent-video >.small-name").html("Agent " +  profile.newNickName);
						if(userVideo1._audio_muted_){
							// 静音
							$(".nickNameWraper >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							$(".nickNameWraper >.toggle-microphone-state").addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
						}
						if(userVideo0._audio_muted_){
							// 静音
							$("#agent-video >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							$("#agent-video >.toggle-microphone-state").addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
						}
					}
					else if(!$(e.currentTarget).hasClass("agent-big") && $("#visitor-video").hasClass("visitor-big")){
						userVideo1._videoTrack && userVideo1._videoTrack.play("big-video", {fit: "contain"});
						userVideo0._videoTrack && userVideo0._videoTrack.play("agent-video", {fit: "contain"});
						whiteVideo.addClass("agent1");
						// serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video");
						if(serviceAgora.localScreenVideoTrack && !serviceAgora.localScreenVideoTrack._isClosed){
							serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("visitor-video", {fit: "contain"});
						}
						else{
							serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video", {fit: "contain"});
						}
						$(e.currentTarget).addClass("agent-big");
						$("#visitor-video").removeClass("visitor-big")
						$(".video-agora-wrapper .nickNameWraper >.nickName").html("Agent " + thirdAgentName);
						$("#agent-video >.small-name").html("Agent " +  profile.newNickName);
						$("#visitor-video >.small-name").html("Me");
						if(userVideo1._audio_muted_){
							// 静音
							$("#agent-video >.toggle-microphone-state").removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							$("#agent-video >.toggle-microphone-state").addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
						}
						if(userVideo0._audio_muted_){
							// 静音
							microphoneState.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							microphoneState.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
						}
					}
				});
	
				// 访客的视频
				$('#visitor-video').unbind('click').bind('click',function (e){
					$(".nickNameWraper").removeClass("hide");
					if(whiteBoardConnect){
						// creatWhiteboard.default(document.getElementById("white-video"),{uuid:"0c7c3e80bd5d11ec97cdebb70556e411",userId:"0c7c3e80bd5d11ec97cdebb70556e411",identity:"joiner",region:"cn-hz"})
						$("#white-board").addClass("hide")
						$("#big-video").removeClass("hide")
						$("#white-video >.small-name").addClass("hide")
						$("#white-video  >.toggle-microphone-state").addClass("hide");
						$("#white-video>img").removeClass("hide");
						whiteVideo.removeClass("visitor agent0 agent1 visitor-white agent0-white agent1-white");
					}
					if($(e.currentTarget).hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big") ){
						userVideo0._videoTrack && userVideo0._videoTrack.play("big-video", {fit: "contain"});
						whiteVideo.addClass("agent0");
						if(serviceAgora.localScreenVideoTrack && !serviceAgora.localScreenVideoTrack._isClosed){
							serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("visitor-video", {fit: "contain"});
						}
						else{
							serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video", {fit: "contain"});
						}
						$(e.currentTarget).removeClass("visitor-big");
						$(".video-agora-wrapper .nickNameWraper >.nickName").html("Agent " + profile.newNickName);
						$("#visitor-video >.small-name").html("Me");
						if(userVideo0._audio_muted_){
							// 静音
							microphoneState.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							microphoneState.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
						}
						if(serviceAgora.localAudioTrack._muted){
							// 静音
							visitorMicrophoneState.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							visitorMicrophoneState.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
						}
					}
					else if(!$(e.currentTarget).hasClass("visitor-big")  && !$("#agent-video").hasClass("agent-big") ){
						userVideo0._videoTrack && userVideo0._videoTrack.play("visitor-video", {fit: "contain"});
						whiteVideo.addClass("visitor");
						if(serviceAgora.localScreenVideoTrack && !serviceAgora.localScreenVideoTrack._isClosed){
							serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("big-video", {fit: "contain"});
						}
						else{
							serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video", {fit: "contain"});
						}
						$(e.currentTarget).addClass("visitor-big");
						$(".video-agora-wrapper .nickNameWraper >.nickName").html("Me");
						$("#visitor-video >.small-name").html("Agent " + profile.newNickName);
						if(serviceAgora.localAudioTrack._muted){
							// 静音
							microphoneState.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							microphoneState.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
						}
						if(userVideo0._audio_muted_){
							// 静音
							visitorMicrophoneState.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
						}
						else{
							visitorMicrophoneState.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled").removeClass("hide");
						}
					}
					else if(!$(e.currentTarget).hasClass("visitor-big")  && $("#agent-video").hasClass("agent-big") ){
						// serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video");
						if(serviceAgora.localScreenVideoTrack && !serviceAgora.localScreenVideoTrack._isClosed){
							serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("big-video", {fit: "contain"});
						}
						else{
							serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video", {fit: "contain"});
						}
						userVideo0._videoTrack && userVideo0._videoTrack.play("visitor-video", {fit: "contain"});
						userVideo1._videoTrack && userVideo1._videoTrack.play("agent-video", {fit: "contain"});
						whiteVideo.addClass("visitor");
						$(e.currentTarget).addClass("visitor-big");
						$("#agent-video").removeClass("agent-big");
						$(".video-agora-wrapper .nickNameWraper >.nickName").html("Me");
						$("#visitor-video >.small-name").html("Agent " + profile.newNickName);
						$("#agent-video >.small-name").html("Agent " +  thirdAgentName);
					}
	
				});
				// 白板
				whiteVideo.unbind('click').bind('click',function (e){
					var whitSmallName = $("#white-video >.small-name");
					var white_board =  $("#white-board");
					var big_video = $("#big-video");
					if(whiteVideo.hasClass("visitor")){
						serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("white-video", {fit: "contain"});
						whiteVideo.removeClass("visitor hide");
						white_board.removeClass("hide")
						big_video.addClass("hide")
						whitSmallName.removeClass("hide");
						whitSmallName.html("Me");
						whiteState();
					}
					else if(whiteVideo.hasClass("agent0")){
						userVideo0._videoTrack && userVideo0._videoTrack.play("white-video", {fit: "contain"});
						whiteVideo.removeClass("agent0 hide");
						white_board.removeClass("hide")
						big_video.addClass("hide")
						whitSmallName.removeClass("hide");
						whitSmallName.html("Agent " + profile.newNickName);
						whiteState();
					}
					else if(whiteVideo.hasClass("agent1")){
						userVideo1._videoTrack && userVideo1._videoTrack.play("white-video", {fit: "contain"});
						whiteVideo.removeClass("agent1 hide");
						white_board.removeClass("hide")
						big_video.addClass("hide")
						whitSmallName.removeClass("hide");
						whitSmallName.html("Agent " + thirdAgentName);
						whiteState();
					}
					else if(whiteVideo.hasClass("visitor-white")){
						serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video", {fit: "contain"});
						$("#white-video>img").removeClass("hide");
						whiteVideo.removeClass("visitor-white");
						white_board.addClass("hide")
						big_video.removeClass("hide")
						whitSmallName.addClass("hide");
						$(".nickNameWraper").removeClass("hide");
						$("#white-video  >.toggle-microphone-state").addClass("hide");
					}
					else if(whiteVideo.hasClass("agent0-white")){
						userVideo0._videoTrack && userVideo0._videoTrack.play("big-video", {fit: "contain"});
						$("#white-video>img").removeClass("hide");
						whiteVideo.removeClass("agent0-white");
						white_board.addClass("hide")
						big_video.removeClass("hide")
						whitSmallName.addClass("hide");
						$(".nickNameWraper").removeClass("hide");
						$("#white-video  >.toggle-microphone-state").addClass("hide");
					}
					else if(whiteVideo.hasClass("agent1-white")){
						userVideo1._videoTrack && userVideo1._videoTrack.play("big-video", {fit: "contain"});
						$("#white-video>img").removeClass("hide");
						whiteVideo.removeClass("agent1-white");
						white_board.addClass("hide")
						big_video.removeClass("hide")
						whitSmallName.addClass("hide");
						$(".nickNameWraper").removeClass("hide");
						$("#white-video  >.toggle-microphone-state").addClass("hide");
					}
					else{
						whiteState();
						white_board.removeClass("hide")
						big_video.addClass("hide")
					}
				});
			},
			onUserLeft:function(){
				if(serviceAgora.remoteUsers.length != 1){
					return;
				}
				returnToMuti();
				serviceAgora.leave();
				videoConnecting = false;
				videoInviteButton = false;
				statusBar.showClosing();
				inviteByVisitor = false;
				shaDesktopSuccFlag = false;
				// 挂断通知
				channel.sendCmdExitVideo(callId,{
					ext: {
						type: "agorartcmedia/video",
						msgtype: {
							visitorRejectInvitation:{
								callId:callId
							}
						},
					},
				})
				// setTimeout(function(){
				// 	$(".video-agora-wrapper").addClass("hide")
				// }, 3000);
				$(".video-agora-wrapper").addClass("hide")
	
			}
		});
		// 访客邀请的，不显示，直接打开视频, 
		// 开启“视频通话允许访客二次确认”，需要确认
		var wrapperDom = videoWidget.querySelector(".status-bar");
		var acceptButtonDom = wrapperDom.querySelector(".accept-button");
		if(inviteByVisitor && config.videoH5Status == false){
			acceptButtonDom.click();
			utils.addClass(acceptButtonDom, "hide");
			inviteByVisitor = false;
			statusBar.show();
		}
		else{
			utils.removeClass(acceptButtonDom, "hide");
			// 访客二次确认
			if(inviteByVisitor && config.videoH5Status){
				// statusBar.show();
				// $('.end-button').removeClass("hide");
				// $(".visitor-invite-video-confirm").addClass("hide")
				// 弹 “客服邀请” 窗
				agentInviteDialog.show();
				startTimer();
				// videoInviteButton = true;
				$(".video-agora-wrapper").addClass("hide");
			}
			else{
				// 弹 “客服邀请” 窗
				agentInviteDialog.show();
				startTimer();
				videoInviteButton = true;
				$(".video-agora-wrapper").addClass("hide");
			}
		}
		$(".visitor-invite-video-confirm").addClass("hide")
	}
	
	function _onConfirm(){
		inviteByVisitor = true;
		eventListener.trigger("video.conform");
		channel.sendText("Invite the agent to a video call", {
			ext: {
				// type: "rtcmedia/video",
				type: "agorartcmedia/video",
				msgtype: {
					liveStreamInvitation: {
						msg: "Invite the agent to a video call",
						orgName: config.orgName,
						appName: config.appName,
						userName: config.user.username,
						imServiceNumber: config.toUser,
						restServer: config.restServer,
						xmppServer: config.xmppServer,
						resource: "webim",
						isNewInvitation: true,
						userAgent: navigator.userAgent,
					},
				},
			},
		});
		var $agentNickname = document.querySelector(".em-widget-header-nickname").innerText;
		var $agentFace = document.querySelector(".em-agent-face").src;
		visitorDialog = uikit.createDialog({
			contentDom: [
				"<div>",
				"<p class=\"title\">"+ "Video call" +"</p>",
				"<p class=\"time\"><p>",
				"<p> <img src=\""+ $agentFace +"\" class=\"\"/> </p>",
				"<p class=\"nickname\">"+ $agentNickname +"</p>",
				"<p class=\"title\">"+ "You are inviting customer service for a video call"+"</p>",
				// "<div class=\"foot\"> <svg class=\"icon svg-icon\" aria-hidden=\"true\"><use xlink:href=\"#newim-a-anwser1x\"></use> </svg></div>",
				"<div class=\"foot\">  <div class=\"button\"><i class=\"icon-huang\"></i> <span>"+ "Hang up"+"</span></div> </div>",
				"</div>"
			].join(""),
			className: "visitor-invite-video-confirm",
		})
		visitorDialog.show();
		$(".visitor-invite-video-confirm .icon-huang").on("click",_onConfirmExitvideo);
	}
	
	function _onAgentInviteConfirm(){
		$(".video-agora-wrapper").removeClass("hide");
		timerLabel.stop();
		statusBar.show();
		statusBar.accept();
		agentInviteDialog.hide();
		statusBar.hideAcceptButton();
	}
	
	function _onAgentInviteCancel(){
		// 拒绝的消息先注释跟原来保持一致
		// channel.sendText("invite reject video", {
		// 	ext: {
		// 		type: "rtcmedia/video",
		// 		msgtype: {
		// 			visitorCancelInvitation: {
		// 				msg: "invite reject video",
		// 				callId:callId,
		// 			},
		// 		},
		// 	},
		// });
		channel.sendCmdExitVideo(callId,{
			ext: {
				type: "agorartcmedia/video",
				msgtype: {
					visitorRejectInvitation:{
						callId:callId
					}
				},
			},
		})
		agentInviteDialog.hide();
		timerLabel.stop();
		statusBar.end();
		agentInviteDialog.hide();
		videoInviteButton = false;
		inviteByVisitor = false;
	}
	
	function _onConfirmExitvideo(){
		channel.sendText("The visitor abandoned the video call", {
			ext: {
				type: "rtcmedia/video",
				msgtype: {
					visitorCancelInvitation: {
						msg: "The visitor abandoned the video call",
						callId:callId,
					},
				},
			},
		});
		channel.sendCmdExitVideo(null,{
			ext: {
				type: "agorartcmedia/video",
				msgtype: {
					visitorCancelInvitation:{
						callId:null
					}
				},
			},
		})
		visitorDialog.hide();
		videoInviteButton = false;
		inviteByVisitor = false;
	}
	function _closeVideo(){
		serviceAgora.client && serviceAgora.client.unpublish(serviceAgora.localScreenVideoTrack);
		serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.close();
		serviceAgora.localScreenAudioTrack && serviceAgora.localScreenAudioTrack.close();
		returnToMuti();
		serviceAgora && serviceAgora.leave();
		videoConnecting = false;
		videoInviteButton = false;
		inviteByVisitor = false;
		statusBar.showClosing();
		whiteBoardConnect = false;
		$(".toggle-enlarge").removeClass("icon-reduction").addClass("icon-enlarge")
		$(".video-agora-wrapper").addClass("hide")
		agentInviteDialog && agentInviteDialog.hide();
		shaDesktopSuccFlag = false;
		creatWhiteboard && creatWhiteboard.destoryWhiteboard(document.getElementById("white-board"));
	}
	
	// 共享桌面的打开关闭
	function onDesktopControl(e){
		if(shaDesktopSuccFlag) {
	  		shaDesktopSuccFlag = false;
	
	  		serviceAgora.client.unpublish(serviceAgora.localScreenVideoTrack);
			serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.close();
			serviceAgora.localScreenAudioTrack && serviceAgora.localScreenAudioTrack.close();
	
			if(bigVideoEl() == "0"){
				serviceAgora.publish(serviceAgora.localVideoTrack);
				serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video", {fit: "contain"});
			}
			else if(bigVideoEl() == "1"){
				serviceAgora.publish(serviceAgora.localVideoTrack);
				serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video", {fit: "contain"});
			}
			else{
				serviceAgora.publish(serviceAgora.localVideoTrack);
				serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video", {fit: "contain"});
				// userVideo0._videoTrack && userVideo0._videoTrack.play("big-video");
			}
	  		$(".desktop-share-agora").removeClass("icon-desktop-selected");
	  		$(".desktop-share-agora").addClass("icon-desktop");
	  		return;
		}
	  
		serviceAgora.createScreenVideoTrack({TrackInitConfig:{},withAudio:"auto"})
	    	.then(function(localScreenTrack){
				if(!localScreenTrack){
					$(".desktop-share-agora").removeClass("icon-desktop-selected");
					$(".desktop-share-agora").addClass("icon-desktop");
					return;
				};
	
				if(serviceAgora.localScreenAudioTrack == null){
					serviceAgora.client.publish([serviceAgora.localScreenVideoTrack]);
				}
				else{
					serviceAgora.client.publish([serviceAgora.localScreenVideoTrack, serviceAgora.localScreenAudioTrack]);
				}
				serviceAgora.client.unpublish(serviceAgora.localVideoTrack);
				serviceAgora.localVideoTrack.stop();
				if(bigVideoEl() == "0"){
					// serviceAgora.client.unpublish(serviceAgora.localVideoTrack);
					// serviceAgora.localVideoTrack.stop();
					serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("big-video", {fit: "contain"});
					serviceAgora.localScreenAudioTrack && serviceAgora.localScreenAudioTrack.play();
				}
				else if(bigVideoEl() == "1"){
					// userVideo1._videoTrack && userVideo1._videoTrack.stop();
					console.log("屏幕共享1111" )
					serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("visitor-video", {fit: "contain"});
					serviceAgora.localScreenAudioTrack && serviceAgora.localScreenAudioTrack.play();
				}
				else{
					console.log("屏幕共享2222222222" )
					// userVideo0._videoTrack && userVideo0._videoTrack.stop();
					serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.play("visitor-video", {fit: "contain"});
					serviceAgora.localScreenAudioTrack && serviceAgora.localScreenAudioTrack.play();
				}
	
				shaDesktopSuccFlag = true;
				// 浏览器停止共享按钮事件监听
				serviceAgora.localScreenVideoTrack.on("track-ended", function(){
					// 关闭共享
					shaDesktopSuccFlag = false;
					serviceAgora.client.unpublish(serviceAgora.localScreenVideoTrack);
					serviceAgora.localScreenVideoTrack && serviceAgora.localScreenVideoTrack.close();
					serviceAgora.localScreenAudioTrack && serviceAgora.localScreenAudioTrack.close();
					// localScreenVideoTrack
					// 打开本地摄像头
					if(bigVideoEl() == "0"){
						serviceAgora.publish(serviceAgora.localVideoTrack);
						serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("big-video", {fit: "contain"});
					}
					else if(bigVideoEl() == "1"){
						serviceAgora.publish(serviceAgora.localVideoTrack);
						serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video", {fit: "contain"});
					}
					else{
						serviceAgora.publish(serviceAgora.localVideoTrack);
						serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("visitor-video", {fit: "contain"});
						// userVideo0._videoTrack && userVideo0._videoTrack.play("big-video");
					}
	
					$(".desktop-share-agora").removeClass("icon-desktop-selected");
					$(".desktop-share-agora").addClass("icon-desktop");
				});
				$(".desktop-share-agora").addClass("icon-desktop-selected");
				$(".desktop-share-agora").removeClass("icon-desktop");
	  		})
	}
	
	function bigVideoEl(){
		// 0 访客在大图展示  1 三方坐席在大图展示   2坐席在大图展示
		if($("#visitor-video").hasClass("visitor-big")){
			return "0";
		}
		else if($("#agent-video").hasClass("agent-big")){
			return "1";
		}
		else{
			return "2";
		}
	}
	function _dragVideo(){
		dragMove.drag({
			parentdraf : '.video-agora-wrapper' , // 拖拽元素父级
			draftin : '.video-agora-wrapper' , // 拖拽元素
			// sizeLeft : '.video-agora-wrapper  .barl', // 改变大小左边
			sizeRight : '.video-agora-wrapper  .barr', // 改变大小右边
			// sizeTop : '.video-agora-wrapper  .bart', // 改变大小上边
			sizeBottom : '.video-agora-wrapper  .barb',  // 改变大小下边
			sizeSkew : '.video-agora-wrapper .bar'
		},utils.isMobile);
	}
	function _dragIconVideo(){
		dragMove.drag({
			parentdraf : '.small-video-box' , // 拖拽元素父级
			draftin : '.small-video-box' , // 拖拽元素
		},utils.isMobile);
	}
	function _receiveWhiteBoard(roomInfo){
		if(roomInfo && !whiteBoardConnect){
			if($(".toggle-enlarge").hasClass("icon-enlarge") ){
				$(".toggle-enlarge").click();
			}
			dragMove.offDarg('.video-agora-wrapper');  // 禁止拖拽
			dragMove.drag({
				parentdraf : '.video-agora-wrapper' , // 拖拽元素父级
				draftin : '.video-agora-wrapper .foot' , // 拖拽元素
			},utils.isMobile);
			dragMove.drag({
				parentdraf : '.video-agora-wrapper' , // 拖拽元素父级
				draftin : '.video-agora-wrapper .top' , // 拖拽元素
			},utils.isMobile);
			$(".desktop-share-agora").css({"pointer-events":"none"});
			$(".desktop-share-agora").addClass("icon-desktop-selected");
			$(".toggle-white-board-agora").css({"pointer-events":"none"});
			$(".toggle-white-board-agora").addClass("icon-white-board-connect");
			whiteBoardInitDom(roomInfo.roomUUID,callId,"creator","cn-hz",roomInfo.roomToken,roomInfo.appIdentifier,config.tenantId,callId);
		}
	}
	function _inviteWhiteBoard(){
		channel.sendCmdExitVideo(callId,{
			ext: {
				type: "agorartcmedia/video",
				msgtype: {
					whiteboardInvitaion:{
						callId:callId
					}
				},
			},
		});
	}
	function whiteBoardInitDom(uuid,callId,identity,region,roomToken,appIdentifier,tenantId,callId){
		var whiteMicrophone = $("#white-video  >.toggle-microphone-state");
		if(bigVideoEl() === "0"){
			serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("white-video", {fit: "contain"});
			$("#white-video").addClass("visitor-white");
			whiteMicrophone.removeClass("icon-microphone-enable").addClass("icon-microphone-disabled");
			$("#white-video >.small-name").html("Me");
			if(serviceAgora.localAudioTrack._muted){
				// 静音
				whiteMicrophone.removeClass("icon-microphone-enable hide").addClass("icon-microphone-disabled");
			}
			else{
				whiteMicrophone.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled hide");
			}
		}
		else if(bigVideoEl() === "1"){
			userVideo1._videoTrack && userVideo1._videoTrack.play("white-video", {fit: "contain"});
			$("#white-video").addClass("agent1-white");
			$("#white-video >.small-name").html("Agent " + thirdAgentName);
			if(userVideo1._audio_muted_){
				// 静音
				whiteMicrophone.removeClass("icon-microphone-enable hide").addClass("icon-microphone-disabled");
			}
			else{
				whiteMicrophone.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled hide");
			}
		}
		else{
			userVideo0._videoTrack && userVideo0._videoTrack.play("white-video", {fit: "contain"});
			$("#white-video").addClass("agent0-white");
			$("#white-video >.small-name").html("Agent " + profile.newNickName);
			if(userVideo0._audio_muted_){
				// 静音
				whiteMicrophone.removeClass("icon-microphone-enable hide").addClass("icon-microphone-disabled");
			}
			else{
				whiteMicrophone.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled hide");
			}
		}
		if($("#white-board").hasClass("hide")){
			$("#white-board").removeClass("hide")
			$("#white-video").removeClass("hide");
			$("#big-video").addClass("hide");
			$(".nickNameWraper").addClass("hide");
	        // const {uuid, userId, identity,region,roomToken,appIdentifier,tenantId,callId} = this.props;
	
			creatWhiteboard.creatWhiteboard(document.getElementById("white-board"),{uuid:uuid,userId:callId,identity:identity,region:region,roomToken:roomToken,appIdentifier:appIdentifier,tenantId:tenantId,callId:callId,language:"en-US",floatBar:!utils.isMobile})
			whiteBoardConnect = true;
		}
	}
	function whiteState(){
		var whiteVideo = $("#white-video");
		var whiteMicrophone = $("#white-video  >.toggle-microphone-state");
		$("#white-video>img").addClass("hide");
		whiteVideo.removeClass("visitor agent0 agent1");
		$(".nickNameWraper").addClass("hide");
		$("#white-video >.small-name").removeClass("hide");
		if(bigVideoEl() === "0"){
			serviceAgora.localVideoTrack && serviceAgora.localVideoTrack.play("white-video", {fit: "contain"});
			whiteVideo.addClass("visitor-white");
			$("#white-video >.small-name").html("Me");
			if(serviceAgora.localAudioTrack._muted){
				// 静音
				whiteMicrophone.removeClass("icon-microphone-enable hide").addClass("icon-microphone-disabled");
			}
			else{
				whiteMicrophone.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled hide");
			}
		}
		else if(bigVideoEl() === "1"){
			userVideo1._videoTrack && userVideo1._videoTrack.play("white-video", {fit: "contain"});
			whiteVideo.addClass("agent1-white");
			$("#white-video >.small-name").html("Agent "+ thirdAgentName);
			if(userVideo1._audio_muted_){
				// 静音
				whiteMicrophone.removeClass("icon-microphone-enable hide").addClass("icon-microphone-disabled");
			}
			else{
				whiteMicrophone.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled hide");
			}
		}
		else{
			userVideo0._videoTrack && userVideo0._videoTrack.play("white-video", {fit: "contain"});
			whiteVideo.addClass("agent0-white");
			$("#white-video >.small-name").html("Agent " + profile.newNickName);
			if(userVideo0._audio_muted_){
				// 静音
				whiteMicrophone.removeClass("icon-microphone-enable hide").addClass("icon-microphone-disabled");
			}
			else{
				whiteMicrophone.addClass("icon-microphone-enable").removeClass("icon-microphone-disabled hide");
			}
		}
	}


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"video-agora-wrapper hide\"> <span class=bart></span> <span class=barb></span> <span class=barr></span> <span class=barl></span> <span class=bar></span> <div class=top> <div class=\"status-bar hide\"> <div> <span class=status-text></span> <span class=time-escape></span> </div> <div class=control-panel> <i class=\"accept-button icon-answer hide\"></i> <i class=\"end-button icon-decline\"></i> </div> <i class=icon-narrow></i> <i class=\"icon-enlarge toggle-enlarge\"></i> </div> </div> <div class=video-contener> <div class=mini-wraper> <div id=visitor-video class=\"mini-video visitor-video\"> <span class=small-name></span> <i class=\"toggle-microphone-state icon-microphone-enable hide\"></i> </div> <div id=agent-video class=\"mini-video agent-video hide\"> <span class=small-name></span> <i class=\"toggle-microphone-state icon-microphone-enable hide\"></i> </div> <div id=white-video class=\"mini-video white-video hide\"> <span class=small-name></span> <i class=\"toggle-microphone-state icon-microphone-enable hide\"></i> <img src=/webim/static/img/whiteBoard.jpg alt=\"\"> </div> </div> <div id=big-video class=big-video></div> <div id=white-board class=\"white-board hide\"></div> <div id=close-white class=hide></div> </div> <div class=nickNameWraper> <i class=\"toggle-microphone-state icon-microphone-enable hide\"></i> <div class=nickName></div> </div> <div class=foot> <i class=\"toggle-microphone-btn-agora icon-microphone-agora\"></i> <i class=\"toggle-carema-btn-agora icon-camera-agora\"></i> <i class=\"toggle-carematurn-btn-agora icon-cameraturn-agora\"></i> <i class=\"desktop-share-agora icon-desktop-agora\"></i> <i class=\"toggle-white-board-agora icon-white-board\"></i> <i class=\"toggle-huang-agora icon-huang-agora\"></i> </div> </div> ";

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports = {
		drag: myPlugin,
		offDarg:offDarg
	};
	function myPlugin(options,isMobil) {
		var $doc = $(document);
		var defaults = {
			parentdraf: '.J-xloginPanel', // 拖拽元素父级
			draftin: '.J-xloginPanel h3', // 拖拽元素
			sizeLeft: '.J-xloginPanel .barl', // 改变大小左边
			sizeRight: '.J-xloginPanel .barr', // 改变大小右边
			sizeTop: '.J-xloginPanel .bart', // 改变大小上边
			sizeBottom: '.J-xloginPanel .barb',  // 改变大小下边
			sizeSkew: '.J-xloginPanel .bar'
		};
		var settings = $.extend({}, defaults, options);
	
		/* 拖拽 */
		$(settings.draftin).on('mousedown', dragmove);
		// 移动端
		if(isMobil){
			$(settings.draftin).on('touchstart', dragmoveMobil);
		}
		function dragmove(event) {
			event = event || window.event;
			var disX = event.pageX - $(settings.parentdraf).offset().left;
			var disY = event.pageY - $(settings.parentdraf).offset().top;
			$doc.on('mousemove', move);
			function move(event) {
				event.stopPropagation();
				event = event || window.event;
				var mouseX = event.pageX - disX;
				var mouseY = event.pageY - disY;
				var maxX = document.documentElement.clientWidth - $(settings.parentdraf).outerWidth(),
					maxY = document.documentElement.clientHeight - $(settings.parentdraf).outerHeight();
				if (mouseX < 0) {
					mouseX = 0;
				} else if (mouseX > maxX) {
					mouseX = maxX;
				}
				if (mouseY < 0) {
					mouseY = 0;
				} else if (mouseY > maxY) {
					mouseY = maxY;
				}
				$(settings.parentdraf).css({ 'left': mouseX + 'px', 'top': mouseY + 'px', 'margin-left': '0px', 'margin-top': '0px', 'position': 'fixed' });
			};
		};
		function dragmoveMobil(event) {
			event = event || window.event;
			event = event.originalEvent.targetTouches && event.originalEvent.targetTouches[0];
			var disX = (event && event.pageX) - $(settings.parentdraf).offset().left;
			var disY = (event && event.pageY) - $(settings.parentdraf).offset().top;
			$doc.on('touchmove', move);
			function move(event) {
				event.stopPropagation();
				event = event || window.event;
				event = event.originalEvent && event.originalEvent.targetTouches[0];
				var mouseX = event.pageX - disX;
				var mouseY = event.pageY - disY;
				var maxX = document.documentElement.clientWidth - $(settings.parentdraf).outerWidth(),
					maxY = document.documentElement.clientHeight - $(settings.parentdraf).outerHeight();
				if (mouseX < 0) {
					mouseX = 0;
				} else if (mouseX > maxX) {
					mouseX = maxX;
				}
				if (mouseY < 0) {
					mouseY = 0;
				} else if (mouseY > maxY) {
					mouseY = maxY;
				}
				$(settings.parentdraf).css({ 'left': mouseX + 'px', 'top': mouseY + 'px', 'margin-left': '0px', 'margin-top': '0px', 'position': 'fixed' });
			};
		};
	
		/* 左边 */
		$(settings.sizeLeft).on('mousedown', function (event) {
			event = event || window.event;
			var $this = $(this);
			var disX = $(settings.parentdraf).offset().left,
				drafw = $(settings.parentdraf).width();
			$doc.on('mousemove', function (event) {
				event = event || window.event;
				var mouseX = event.pageX;
				if (mouseX < 0) mouseX = 0;
				$(settings.parentdraf).css({ 'left': mouseX + 'px', 'width': (disX - mouseX - 4) + drafw + 'px','mamargin-left': '0px', })
			});
		});
	
		/* 右边 */
		$(settings.sizeRight).on('mousedown', function (event) {
			event = event || window.event;
			var $this = $(this);
			var disX = $(settings.parentdraf).offset().left;
			var disW = $(settings.parentdraf).width();
			$doc.on('mousemove', function (event) {
				event = event || window.event;
				var mouseX = event.pageX - disX,
					maxX = document.documentElement.clientWidth - disX - 2;
				if (mouseX > maxX) mouseX = maxX;
				if (mouseX < disW) mouseX = disW;
				$(settings.parentdraf).css({ 'width': mouseX + 'px' })
			});
		});
	
		/* 上边 */
		$(settings.sizeTop).on('mousedown', function (event) {
			event = event || window.event;
			var $this = $(this);
			var disY = $(settings.parentdraf).offset().top,
				drafH = $(settings.parentdraf).height();
			$doc.on('mousemove', function (event) {
				event = event || window.event;
				var mouseY = event.pageY,
					range = disY - mouseY - 4;
				if (mouseY + 4 > 0) {
					$(settings.parentdraf).css({ 'top': mouseY + 'px', 'height': range + drafH + 'px','margin-top': '0px' });
				};
			});
		});
	
		/* 下边 */
		$(settings.sizeBottom).on('mousedown', function (event) {
			event = event || window.event;
			var $this = $(this);
			var disY = $(settings.parentdraf).offset().top;
			var disH = $(settings.parentdraf).height();
			$doc.on('mousemove', function (event) {
				event = event || window.event;
				var mouseY = event.pageY - disY,
					maxY = document.documentElement.clientHeight - disY - 2;
				if (mouseY > maxY) mouseY = maxY;
				if (mouseY < disH) mouseY = disH;
				$(settings.parentdraf).css({ 'height': mouseY + 'px' });
			});
		});
	
	
		/* 下斜 */
		$(settings.sizeSkew).on('mousedown', function (event) {
			event = event || window.event;
			var $this = $(this),
				disX = $(settings.parentdraf).offset().left,
				disY = $(settings.parentdraf).offset().top;
			var disH = $(settings.parentdraf).height();
			var disW = $(settings.parentdraf).width();
			$doc.on('mousemove', function (event) {
				event = event || window.event;
				var mouseX = event.pageX - disX + 14,
					mouseY = event.pageY - disY + 14,
					maxX = document.documentElement.clientWidth - disX - 2,
					maxY = document.documentElement.clientHeight - disY - 2;
				if (mouseX > maxX) mouseX = maxX;
				if (mouseY > maxY) mouseY = maxY;
				if (mouseX < disW) mouseX = disW;
				if (mouseY < disH) mouseY = disH;
				$(settings.parentdraf).css({ 'width': mouseX + 'px', 'height': mouseY + 'px' });
			});
		});
	
		/* 松开鼠标 */
		$doc.mouseup(function () {
			$doc.off('mousedown')
			$doc.off('mousemove')
			$doc.off('touchstart')
			$doc.off('touchmove')
		});
	};
	function offDarg(el){
		if(el){
			$(el).off('mousedown')
			$(el).off('mousemove')
			$(el).off('touchstart')
			$(el).off('touchmove')
		}
	}
	


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var apiHelper = __webpack_require__(181);
	var channel = __webpack_require__(186);
	var guess_template = __webpack_require__(212);
	
	var oldValue = "";
	var newValue = "";
	var timer;
	
	function loadHtml(){
		var htmlStr = _.template(guess_template)();
		var dom = utils.createElementFromHTML(htmlStr);
	
		var editorView = document.querySelector(".em-widget-send-wrapper");
	
		var doms = {
			guessTips: editorView.querySelector(".guess-tips"),
			guessArea: editorView.querySelector(".guess-area"),
			closeBtn: editorView.querySelector(".close-btn"),
			guessBtn: editorView.querySelectorAll(".guess-area li"),
			guessList: editorView.querySelector(".guess-list"),
			loading: editorView.querySelector(".loading"),
	
			textInput: editorView.querySelector(".em-widget-textarea"),
			chatWrapper: document.querySelector(".chat-wrapper"),
	
			editorView: editorView,
		};
		return {
			dom: dom,
			doms: doms
		};
	}
	
	function _addEvents(){
		var doms = loadHtml().doms;
	
	    // 点击猜你想说按钮上屏
		utils.live("li", "click", function(e){
			var curText = this.innerText;
			channel.sendText(curText);
			doms.textInput.value = "";
	    oldValue = "";
			utils.trigger(doms.textInput, "change");
			// 恢复默认样式
			doms.guessArea.style.display = "none";
			doms.chatWrapper.style.bottom = 140 + "px";
		    doms.guessList.innerHTML = "";
		}, doms.guessList);
	
	
	    // 点击猜你想说关闭按钮 恢复样式
		utils.on(doms.closeBtn, "click", function(){
			doms.guessArea.style.display = "none";
			doms.chatWrapper.style.bottom = 140 + "px";
			doms.guessTips.innerText = "请点击您想咨询的问题！";
			doms.loading.style.display = "block";
			doms.guessList.innerHTML = "";
		});
	
	
		// 文本框检索猜你想说内容
		// keyup在ios手机原生的输入法是不支持的，但是在ios端第三方的输入法搜狗输入法是支持的，为了兼容性，不能使用keyup事件
		utils.on(doms.textInput, "input propertychange", function(){
			// doms.guessArea.style.display = "block";
			var value = this.value.length ? this.value.trim() : "";
			newValue = value;
	
	    clearTimeout(timer);
	
			// 根据当前文本框输入内容是否发生变化 发起请求
			if(value && oldValue !== newValue){
				// 访客输入第一句话时，会话尚未建立，尚未获知agentId, 暂不进行输入联想请求
				if(profile.currentOfficialAccount.agentId &&  profile.currentOfficialAccount.agentType == 6){
					timer = setTimeout(function(){
	          apiHelper.getGuessList(value).then(function(res){
	            if(res && res.data && res.data.entities && res.data.entities.length && newValue.length){ // 如果搜索结果出来的时候 用户清空了输入框 则不再展示结果
	              doms.guessArea.style.display = "block";
	              doms.guessTips.innerText = "请点击您想咨询的问题！";
	              doms.loading.style.display = "none";
	                // 创建模板
	              createTemplate(res.data.entities);
	                // 设置聊天框内容样式
	              // doms.chatWrapper.style.bottom = 300 + "px";
	              doms.chatWrapper.style.bottom = 140 + "px";
	            }
	            else{
	                  // 检索不到值时恢复 默认样式
	              doms.guessArea.style.display = "none";
	              doms.guessList.innerHTML = "";
	              doms.chatWrapper.style.bottom = 140 + "px";
	            }
	          });
	        }, 300)
				}
				else{
					doms.guessArea.style.display = "none";
				}
				oldValue = newValue;
			}
			// 当值不变时 不触发搜索状态
			else if(oldValue == newValue){
				// doms.guessArea.style.display = "none";
				// doms.chatWrapper.style.bottom = 140 + "px";
			}
			else if(!value){
				// 文本框内容清空时 重置样式
				doms.guessArea.style.display = "none";
				doms.chatWrapper.style.bottom = 140 + "px";
				oldValue = "";
			}
		});
	
	}
	
	// 根据`猜你想问`接口返回拼接模板
	function createTemplate(data){
		var doms = loadHtml().doms;
		var html = "";
		for(var i = 0; i < data.length; i++){
	    var item = data[i].replace(/&amp;lt;/g, "<").replace(/&amp;gt;/g, ">")
			html += "<li>" + item + "</li>";
			doms.guessList.innerHTML = html;
		}
	}
	
	// 重置样式
	function resetStyle(){
		var doms = loadHtml().doms;
		doms.guessArea.style.display = "none";
		doms.chatWrapper.style.bottom = 140 + "px";
		doms.guessList.innerHTML = "";
		doms.guessTips.innerText = "请点击您想咨询的问题！";
		doms.loading.style.display = "block";
	}
	
	function clearCacheInput(){
	  oldValue = ""
	  newValue = ""
	  clearTimeout(timer)
	}
	
	module.exports = {
		loadHtml: loadHtml,
		addEvents: _addEvents,
		resetStyle: resetStyle,
	  clearCacheInput: clearCacheInput
	};


/***/ }),
/* 212 */
/***/ (function(module, exports) {

	module.exports = "<div class=guess-area> <div class=loading-wrap style=display:none> <span class=guess-tips>请点击您想咨询的问题！</span> <div class=\"loader-inner ball-beat loading\"> <div></div> <div></div> <div></div> </div> </div> <span style=display:none class=close-btn>&#10005;</span> <ul class=guess-list id=guessList> </ul> </div>";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Swiper 4.2.0
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * http://www.idangero.us/swiper/
	 *
	 * Copyright 2014-2018 Vladimir Kharlampidi
	 *
	 * Released under the MIT License
	 *
	 * Released on: March 16, 2018
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Swiper = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * SSR Window 1.0.0
	 * Better handling for window object in SSR environment
	 * https://github.com/nolimits4web/ssr-window
	 *
	 * Copyright 2018, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: February 10, 2018
	 */
	var d;
	if (typeof document === 'undefined') {
	  d = {
	    body: {},
	    addEventListener: function addEventListener() {},
	    removeEventListener: function removeEventListener() {},
	    activeElement: {
	      blur: function blur() {},
	      nodeName: '',
	    },
	    querySelector: function querySelector() {
	      return null;
	    },
	    querySelectorAll: function querySelectorAll() {
	      return [];
	    },
	    getElementById: function getElementById() {
	      return null;
	    },
	    createEvent: function createEvent() {
	      return {
	        initEvent: function initEvent() {},
	      };
	    },
	    createElement: function createElement() {
	      return {
	        children: [],
	        childNodes: [],
	        style: {},
	        setAttribute: function setAttribute() {},
	        getElementsByTagName: function getElementsByTagName() {
	          return [];
	        },
	      };
	    },
	    location: { hash: '' },
	  };
	} else {
	  // eslint-disable-next-line
	  d = document;
	}
	
	var doc = d;
	
	var w;
	if (typeof window === 'undefined') {
	  w = {
	    document: doc,
	    navigator: {
	      userAgent: '',
	    },
	    location: {},
	    history: {},
	    CustomEvent: function CustomEvent() {
	      return this;
	    },
	    addEventListener: function addEventListener() {},
	    removeEventListener: function removeEventListener() {},
	    getComputedStyle: function getComputedStyle() {
	      return {
	        getPropertyValue: function getPropertyValue() {
	          return '';
	        },
	      };
	    },
	    Image: function Image() {},
	    Date: function Date() {},
	    screen: {},
	    setTimeout: function setTimeout() {},
	    clearTimeout: function clearTimeout() {},
	  };
	} else {
	  // eslint-disable-next-line
	  w = window;
	}
	
	var win = w;
	
	/**
	 * Dom7 2.0.3
	 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	 * http://framework7.io/docs/dom.html
	 *
	 * Copyright 2018, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 *
	 * Licensed under MIT
	 *
	 * Released on: February 21, 2018
	 */
	
	var Dom7 = function Dom7(arr) {
	  var self = this;
	  // Create array-like object
	  for (var i = 0; i < arr.length; i += 1) {
	    self[i] = arr[i];
	  }
	  self.length = arr.length;
	  // Return collection with methods
	  return this;
	};
	
	function $(selector, context) {
	  var arr = [];
	  var i = 0;
	  if (selector && !context) {
	    if (selector instanceof Dom7) {
	      return selector;
	    }
	  }
	  if (selector) {
	      // String
	    if (typeof selector === 'string') {
	      var els;
	      var tempParent;
	      var html = selector.trim();
	      if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	        var toCreate = 'div';
	        if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
	        if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
	        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
	        if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
	        if (html.indexOf('<option') === 0) { toCreate = 'select'; }
	        tempParent = doc.createElement(toCreate);
	        tempParent.innerHTML = html;
	        for (i = 0; i < tempParent.childNodes.length; i += 1) {
	          arr.push(tempParent.childNodes[i]);
	        }
	      } else {
	        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
	          // Pure ID selector
	          els = [doc.getElementById(selector.trim().split('#')[1])];
	        } else {
	          // Other selectors
	          els = (context || doc).querySelectorAll(selector.trim());
	        }
	        for (i = 0; i < els.length; i += 1) {
	          if (els[i]) { arr.push(els[i]); }
	        }
	      }
	    } else if (selector.nodeType || selector === win || selector === doc) {
	      // Node/element
	      arr.push(selector);
	    } else if (selector.length > 0 && selector[0].nodeType) {
	      // Array of elements or instance of Dom
	      for (i = 0; i < selector.length; i += 1) {
	        arr.push(selector[i]);
	      }
	    }
	  }
	  return new Dom7(arr);
	}
	
	$.fn = Dom7.prototype;
	$.Class = Dom7;
	$.Dom7 = Dom7;
	
	function unique(arr) {
	  var uniqueArray = [];
	  for (var i = 0; i < arr.length; i += 1) {
	    if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
	  }
	  return uniqueArray;
	}
	
	// Classes and attributes
	function addClass(className) {
	  var this$1 = this;
	
	  if (typeof className === 'undefined') {
	    return this;
	  }
	  var classes = className.split(' ');
	  for (var i = 0; i < classes.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.add(classes[i]); }
	    }
	  }
	  return this;
	}
	function removeClass(className) {
	  var this$1 = this;
	
	  var classes = className.split(' ');
	  for (var i = 0; i < classes.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.remove(classes[i]); }
	    }
	  }
	  return this;
	}
	function hasClass(className) {
	  if (!this[0]) { return false; }
	  return this[0].classList.contains(className);
	}
	function toggleClass(className) {
	  var this$1 = this;
	
	  var classes = className.split(' ');
	  for (var i = 0; i < classes.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.toggle(classes[i]); }
	    }
	  }
	  return this;
	}
	function attr(attrs, value) {
	  var arguments$1 = arguments;
	  var this$1 = this;
	
	  if (arguments.length === 1 && typeof attrs === 'string') {
	    // Get attr
	    if (this[0]) { return this[0].getAttribute(attrs); }
	    return undefined;
	  }
	
	  // Set attrs
	  for (var i = 0; i < this.length; i += 1) {
	    if (arguments$1.length === 2) {
	      // String
	      this$1[i].setAttribute(attrs, value);
	    } else {
	      // Object
	      // eslint-disable-next-line
	      for (var attrName in attrs) {
	        this$1[i][attrName] = attrs[attrName];
	        this$1[i].setAttribute(attrName, attrs[attrName]);
	      }
	    }
	  }
	  return this;
	}
	// eslint-disable-next-line
	function removeAttr(attr) {
	  var this$1 = this;
	
	  for (var i = 0; i < this.length; i += 1) {
	    this$1[i].removeAttribute(attr);
	  }
	  return this;
	}
	function data(key, value) {
	  var this$1 = this;
	
	  var el;
	  if (typeof value === 'undefined') {
	    el = this[0];
	    // Get value
	    if (el) {
	      if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
	        return el.dom7ElementDataStorage[key];
	      }
	
	      var dataKey = el.getAttribute(("data-" + key));
	      if (dataKey) {
	        return dataKey;
	      }
	      return undefined;
	    }
	    return undefined;
	  }
	
	  // Set value
	  for (var i = 0; i < this.length; i += 1) {
	    el = this$1[i];
	    if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
	    el.dom7ElementDataStorage[key] = value;
	  }
	  return this;
	}
	// Transforms
	// eslint-disable-next-line
	function transform(transform) {
	  var this$1 = this;
	
	  for (var i = 0; i < this.length; i += 1) {
	    var elStyle = this$1[i].style;
	    elStyle.webkitTransform = transform;
	    elStyle.transform = transform;
	  }
	  return this;
	}
	function transition(duration) {
	  var this$1 = this;
	
	  if (typeof duration !== 'string') {
	    duration = duration + "ms"; // eslint-disable-line
	  }
	  for (var i = 0; i < this.length; i += 1) {
	    var elStyle = this$1[i].style;
	    elStyle.webkitTransitionDuration = duration;
	    elStyle.transitionDuration = duration;
	  }
	  return this;
	}
	// Events
	function on() {
	  var this$1 = this;
	  var assign;
	
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];
	  var eventType = args[0];
	  var targetSelector = args[1];
	  var listener = args[2];
	  var capture = args[3];
	  if (typeof args[1] === 'function') {
	    (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	    targetSelector = undefined;
	  }
	  if (!capture) { capture = false; }
	
	  function handleLiveEvent(e) {
	    var target = e.target;
	    if (!target) { return; }
	    var eventData = e.target.dom7EventData || [];
	    eventData.unshift(e);
	    if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
	    else {
	      var parents = $(target).parents(); // eslint-disable-line
	      for (var k = 0; k < parents.length; k += 1) {
	        if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
	      }
	    }
	  }
	  function handleEvent(e) {
	    var eventData = e && e.target ? e.target.dom7EventData || [] : [];
	    eventData.unshift(e);
	    listener.apply(this, eventData);
	  }
	  var events = eventType.split(' ');
	  var j;
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this$1[i];
	    if (!targetSelector) {
	      for (j = 0; j < events.length; j += 1) {
	        if (!el.dom7Listeners) { el.dom7Listeners = []; }
	        el.dom7Listeners.push({
	          type: eventType,
	          listener: listener,
	          proxyListener: handleEvent,
	        });
	        el.addEventListener(events[j], handleEvent, capture);
	      }
	    } else {
	      // Live events
	      for (j = 0; j < events.length; j += 1) {
	        if (!el.dom7LiveListeners) { el.dom7LiveListeners = []; }
	        el.dom7LiveListeners.push({
	          type: eventType,
	          listener: listener,
	          proxyListener: handleLiveEvent,
	        });
	        el.addEventListener(events[j], handleLiveEvent, capture);
	      }
	    }
	  }
	  return this;
	}
	function off() {
	  var this$1 = this;
	  var assign;
	
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];
	  var eventType = args[0];
	  var targetSelector = args[1];
	  var listener = args[2];
	  var capture = args[3];
	  if (typeof args[1] === 'function') {
	    (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	    targetSelector = undefined;
	  }
	  if (!capture) { capture = false; }
	
	  var events = eventType.split(' ');
	  for (var i = 0; i < events.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      var el = this$1[j];
	      if (!targetSelector) {
	        if (el.dom7Listeners) {
	          for (var k = 0; k < el.dom7Listeners.length; k += 1) {
	            if (listener) {
	              if (el.dom7Listeners[k].listener === listener) {
	                el.removeEventListener(events[i], el.dom7Listeners[k].proxyListener, capture);
	              }
	            } else if (el.dom7Listeners[k].type === events[i]) {
	              el.removeEventListener(events[i], el.dom7Listeners[k].proxyListener, capture);
	            }
	          }
	        }
	      } else if (el.dom7LiveListeners) {
	        for (var k$1 = 0; k$1 < el.dom7LiveListeners.length; k$1 += 1) {
	          if (listener) {
	            if (el.dom7LiveListeners[k$1].listener === listener) {
	              el.removeEventListener(events[i], el.dom7LiveListeners[k$1].proxyListener, capture);
	            }
	          } else if (el.dom7LiveListeners[k$1].type === events[i]) {
	            el.removeEventListener(events[i], el.dom7LiveListeners[k$1].proxyListener, capture);
	          }
	        }
	      }
	    }
	  }
	  return this;
	}
	function trigger() {
	  var this$1 = this;
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];
	
	  var events = args[0].split(' ');
	  var eventData = args[1];
	  for (var i = 0; i < events.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      var evt = (void 0);
	      try {
	        evt = new win.CustomEvent(events[i], {
	          detail: eventData,
	          bubbles: true,
	          cancelable: true,
	        });
	      } catch (e) {
	        evt = doc.createEvent('Event');
	        evt.initEvent(events[i], true, true);
	        evt.detail = eventData;
	      }
	      // eslint-disable-next-line
	      this$1[j].dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
	      this$1[j].dispatchEvent(evt);
	      this$1[j].dom7EventData = [];
	      delete this$1[j].dom7EventData;
	    }
	  }
	  return this;
	}
	function transitionEnd(callback) {
	  var events = ['webkitTransitionEnd', 'transitionend'];
	  var dom = this;
	  var i;
	  function fireCallBack(e) {
	    /* jshint validthis:true */
	    if (e.target !== this) { return; }
	    callback.call(this, e);
	    for (i = 0; i < events.length; i += 1) {
	      dom.off(events[i], fireCallBack);
	    }
	  }
	  if (callback) {
	    for (i = 0; i < events.length; i += 1) {
	      dom.on(events[i], fireCallBack);
	    }
	  }
	  return this;
	}
	function outerWidth(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      // eslint-disable-next-line
	      var styles = this.styles();
	      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
	    }
	    return this[0].offsetWidth;
	  }
	  return null;
	}
	function outerHeight(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      // eslint-disable-next-line
	      var styles = this.styles();
	      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
	    }
	    return this[0].offsetHeight;
	  }
	  return null;
	}
	function offset() {
	  if (this.length > 0) {
	    var el = this[0];
	    var box = el.getBoundingClientRect();
	    var body = doc.body;
	    var clientTop = el.clientTop || body.clientTop || 0;
	    var clientLeft = el.clientLeft || body.clientLeft || 0;
	    var scrollTop = el === win ? win.scrollY : el.scrollTop;
	    var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
	    return {
	      top: (box.top + scrollTop) - clientTop,
	      left: (box.left + scrollLeft) - clientLeft,
	    };
	  }
	
	  return null;
	}
	function styles() {
	  if (this[0]) { return win.getComputedStyle(this[0], null); }
	  return {};
	}
	function css(props, value) {
	  var this$1 = this;
	
	  var i;
	  if (arguments.length === 1) {
	    if (typeof props === 'string') {
	      if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
	    } else {
	      for (i = 0; i < this.length; i += 1) {
	        // eslint-disable-next-line
	        for (var prop in props) {
	          this$1[i].style[prop] = props[prop];
	        }
	      }
	      return this;
	    }
	  }
	  if (arguments.length === 2 && typeof props === 'string') {
	    for (i = 0; i < this.length; i += 1) {
	      this$1[i].style[props] = value;
	    }
	    return this;
	  }
	  return this;
	}
	// Iterate over the collection passing elements to `callback`
	function each(callback) {
	  var this$1 = this;
	
	  // Don't bother continuing without a callback
	  if (!callback) { return this; }
	  // Iterate over the current collection
	  for (var i = 0; i < this.length; i += 1) {
	    // If the callback returns false
	    if (callback.call(this$1[i], i, this$1[i]) === false) {
	      // End the loop early
	      return this$1;
	    }
	  }
	  // Return `this` to allow chained DOM operations
	  return this;
	}
	// eslint-disable-next-line
	function html(html) {
	  var this$1 = this;
	
	  if (typeof html === 'undefined') {
	    return this[0] ? this[0].innerHTML : undefined;
	  }
	
	  for (var i = 0; i < this.length; i += 1) {
	    this$1[i].innerHTML = html;
	  }
	  return this;
	}
	// eslint-disable-next-line
	function text(text) {
	  var this$1 = this;
	
	  if (typeof text === 'undefined') {
	    if (this[0]) {
	      return this[0].textContent.trim();
	    }
	    return null;
	  }
	
	  for (var i = 0; i < this.length; i += 1) {
	    this$1[i].textContent = text;
	  }
	  return this;
	}
	function is(selector) {
	  var el = this[0];
	  var compareWith;
	  var i;
	  if (!el || typeof selector === 'undefined') { return false; }
	  if (typeof selector === 'string') {
	    if (el.matches) { return el.matches(selector); }
	    else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
	    else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }
	
	    compareWith = $(selector);
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) { return true; }
	    }
	    return false;
	  } else if (selector === doc) { return el === doc; }
	  else if (selector === win) { return el === win; }
	
	  if (selector.nodeType || selector instanceof Dom7) {
	    compareWith = selector.nodeType ? [selector] : selector;
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) { return true; }
	    }
	    return false;
	  }
	  return false;
	}
	function index() {
	  var child = this[0];
	  var i;
	  if (child) {
	    i = 0;
	    // eslint-disable-next-line
	    while ((child = child.previousSibling) !== null) {
	      if (child.nodeType === 1) { i += 1; }
	    }
	    return i;
	  }
	  return undefined;
	}
	// eslint-disable-next-line
	function eq(index) {
	  if (typeof index === 'undefined') { return this; }
	  var length = this.length;
	  var returnIndex;
	  if (index > length - 1) {
	    return new Dom7([]);
	  }
	  if (index < 0) {
	    returnIndex = length + index;
	    if (returnIndex < 0) { return new Dom7([]); }
	    return new Dom7([this[returnIndex]]);
	  }
	  return new Dom7([this[index]]);
	}
	function append() {
	  var this$1 = this;
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];
	
	  var newChild;
	
	  for (var k = 0; k < args.length; k += 1) {
	    newChild = args[k];
	    for (var i = 0; i < this.length; i += 1) {
	      if (typeof newChild === 'string') {
	        var tempDiv = doc.createElement('div');
	        tempDiv.innerHTML = newChild;
	        while (tempDiv.firstChild) {
	          this$1[i].appendChild(tempDiv.firstChild);
	        }
	      } else if (newChild instanceof Dom7) {
	        for (var j = 0; j < newChild.length; j += 1) {
	          this$1[i].appendChild(newChild[j]);
	        }
	      } else {
	        this$1[i].appendChild(newChild);
	      }
	    }
	  }
	
	  return this;
	}
	function prepend(newChild) {
	  var this$1 = this;
	
	  var i;
	  var j;
	  for (i = 0; i < this.length; i += 1) {
	    if (typeof newChild === 'string') {
	      var tempDiv = doc.createElement('div');
	      tempDiv.innerHTML = newChild;
	      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	        this$1[i].insertBefore(tempDiv.childNodes[j], this$1[i].childNodes[0]);
	      }
	    } else if (newChild instanceof Dom7) {
	      for (j = 0; j < newChild.length; j += 1) {
	        this$1[i].insertBefore(newChild[j], this$1[i].childNodes[0]);
	      }
	    } else {
	      this$1[i].insertBefore(newChild, this$1[i].childNodes[0]);
	    }
	  }
	  return this;
	}
	function next(selector) {
	  if (this.length > 0) {
	    if (selector) {
	      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
	        return new Dom7([this[0].nextElementSibling]);
	      }
	      return new Dom7([]);
	    }
	
	    if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
	    return new Dom7([]);
	  }
	  return new Dom7([]);
	}
	function nextAll(selector) {
	  var nextEls = [];
	  var el = this[0];
	  if (!el) { return new Dom7([]); }
	  while (el.nextElementSibling) {
	    var next = el.nextElementSibling; // eslint-disable-line
	    if (selector) {
	      if ($(next).is(selector)) { nextEls.push(next); }
	    } else { nextEls.push(next); }
	    el = next;
	  }
	  return new Dom7(nextEls);
	}
	function prev(selector) {
	  if (this.length > 0) {
	    var el = this[0];
	    if (selector) {
	      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
	        return new Dom7([el.previousElementSibling]);
	      }
	      return new Dom7([]);
	    }
	
	    if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
	    return new Dom7([]);
	  }
	  return new Dom7([]);
	}
	function prevAll(selector) {
	  var prevEls = [];
	  var el = this[0];
	  if (!el) { return new Dom7([]); }
	  while (el.previousElementSibling) {
	    var prev = el.previousElementSibling; // eslint-disable-line
	    if (selector) {
	      if ($(prev).is(selector)) { prevEls.push(prev); }
	    } else { prevEls.push(prev); }
	    el = prev;
	  }
	  return new Dom7(prevEls);
	}
	function parent(selector) {
	  var this$1 = this;
	
	  var parents = []; // eslint-disable-line
	  for (var i = 0; i < this.length; i += 1) {
	    if (this$1[i].parentNode !== null) {
	      if (selector) {
	        if ($(this$1[i].parentNode).is(selector)) { parents.push(this$1[i].parentNode); }
	      } else {
	        parents.push(this$1[i].parentNode);
	      }
	    }
	  }
	  return $(unique(parents));
	}
	function parents(selector) {
	  var this$1 = this;
	
	  var parents = []; // eslint-disable-line
	  for (var i = 0; i < this.length; i += 1) {
	    var parent = this$1[i].parentNode; // eslint-disable-line
	    while (parent) {
	      if (selector) {
	        if ($(parent).is(selector)) { parents.push(parent); }
	      } else {
	        parents.push(parent);
	      }
	      parent = parent.parentNode;
	    }
	  }
	  return $(unique(parents));
	}
	function closest(selector) {
	  var closest = this; // eslint-disable-line
	  if (typeof selector === 'undefined') {
	    return new Dom7([]);
	  }
	  if (!closest.is(selector)) {
	    closest = closest.parents(selector).eq(0);
	  }
	  return closest;
	}
	function find(selector) {
	  var this$1 = this;
	
	  var foundElements = [];
	  for (var i = 0; i < this.length; i += 1) {
	    var found = this$1[i].querySelectorAll(selector);
	    for (var j = 0; j < found.length; j += 1) {
	      foundElements.push(found[j]);
	    }
	  }
	  return new Dom7(foundElements);
	}
	function children(selector) {
	  var this$1 = this;
	
	  var children = []; // eslint-disable-line
	  for (var i = 0; i < this.length; i += 1) {
	    var childNodes = this$1[i].childNodes;
	
	    for (var j = 0; j < childNodes.length; j += 1) {
	      if (!selector) {
	        if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
	      } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
	        children.push(childNodes[j]);
	      }
	    }
	  }
	  return new Dom7(unique(children));
	}
	function remove() {
	  var this$1 = this;
	
	  for (var i = 0; i < this.length; i += 1) {
	    if (this$1[i].parentNode) { this$1[i].parentNode.removeChild(this$1[i]); }
	  }
	  return this;
	}
	function add() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];
	
	  var dom = this;
	  var i;
	  var j;
	  for (i = 0; i < args.length; i += 1) {
	    var toAdd = $(args[i]);
	    for (j = 0; j < toAdd.length; j += 1) {
	      dom[dom.length] = toAdd[j];
	      dom.length += 1;
	    }
	  }
	  return dom;
	}
	
	var Methods = {
	  addClass: addClass,
	  removeClass: removeClass,
	  hasClass: hasClass,
	  toggleClass: toggleClass,
	  attr: attr,
	  removeAttr: removeAttr,
	  data: data,
	  transform: transform,
	  transition: transition,
	  on: on,
	  off: off,
	  trigger: trigger,
	  transitionEnd: transitionEnd,
	  outerWidth: outerWidth,
	  outerHeight: outerHeight,
	  offset: offset,
	  css: css,
	  each: each,
	  html: html,
	  text: text,
	  is: is,
	  index: index,
	  eq: eq,
	  append: append,
	  prepend: prepend,
	  next: next,
	  nextAll: nextAll,
	  prev: prev,
	  prevAll: prevAll,
	  parent: parent,
	  parents: parents,
	  closest: closest,
	  find: find,
	  children: children,
	  remove: remove,
	  add: add,
	  styles: styles,
	};
	
	Object.keys(Methods).forEach(function (methodName) {
	  $.fn[methodName] = Methods[methodName];
	});
	
	var Utils = {
	  deleteProps: function deleteProps(obj) {
	    var object = obj;
	    Object.keys(object).forEach(function (key) {
	      try {
	        object[key] = null;
	      } catch (e) {
	        // no getter for object
	      }
	      try {
	        delete object[key];
	      } catch (e) {
	        // something got wrong
	      }
	    });
	  },
	  nextTick: function nextTick(callback, delay) {
	    if ( delay === void 0 ) delay = 0;
	
	    return setTimeout(callback, delay);
	  },
	  now: function now() {
	    return Date.now();
	  },
	  getTranslate: function getTranslate(el, axis) {
	    if ( axis === void 0 ) axis = 'x';
	
	    var matrix;
	    var curTransform;
	    var transformMatrix;
	
	    var curStyle = win.getComputedStyle(el, null);
	
	    if (win.WebKitCSSMatrix) {
	      curTransform = curStyle.transform || curStyle.webkitTransform;
	      if (curTransform.split(',').length > 6) {
	        curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
	      }
	      // Some old versions of Webkit choke when 'none' is passed; pass
	      // empty string instead in this case
	      transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	    } else {
	      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	      matrix = transformMatrix.toString().split(',');
	    }
	
	    if (axis === 'x') {
	      // Latest Chrome and webkits Fix
	      if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
	      // Crazy IE10 Matrix
	      else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
	      // Normal Browsers
	      else { curTransform = parseFloat(matrix[4]); }
	    }
	    if (axis === 'y') {
	      // Latest Chrome and webkits Fix
	      if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
	      // Crazy IE10 Matrix
	      else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
	      // Normal Browsers
	      else { curTransform = parseFloat(matrix[5]); }
	    }
	    return curTransform || 0;
	  },
	  parseUrlQuery: function parseUrlQuery(url) {
	    var query = {};
	    var urlToParse = url || win.location.href;
	    var i;
	    var params;
	    var param;
	    var length;
	    if (typeof urlToParse === 'string' && urlToParse.length) {
	      urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
	      params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
	      length = params.length;
	
	      for (i = 0; i < length; i += 1) {
	        param = params[i].replace(/#\S+/g, '').split('=');
	        query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
	      }
	    }
	    return query;
	  },
	  isObject: function isObject(o) {
	    return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
	  },
	  extend: function extend() {
	    var args = [], len$1 = arguments.length;
	    while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];
	
	    var to = Object(args[0]);
	    for (var i = 1; i < args.length; i += 1) {
	      var nextSource = args[i];
	      if (nextSource !== undefined && nextSource !== null) {
	        var keysArray = Object.keys(Object(nextSource));
	        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	          var nextKey = keysArray[nextIndex];
	          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	          if (desc !== undefined && desc.enumerable) {
	            if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	              Utils.extend(to[nextKey], nextSource[nextKey]);
	            } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	              to[nextKey] = {};
	              Utils.extend(to[nextKey], nextSource[nextKey]);
	            } else {
	              to[nextKey] = nextSource[nextKey];
	            }
	          }
	        }
	      }
	    }
	    return to;
	  },
	};
	
	var Support = (function Support() {
	  var testDiv = doc.createElement('div');
	  return {
	    touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
	      return !!(('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
	    }()),
	
	    pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent),
	    prefixedPointerEvents: !!win.navigator.msPointerEnabled,
	
	    transition: (function checkTransition() {
	      var style = testDiv.style;
	      return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
	    }()),
	    transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
	      var style = testDiv.style;
	      return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
	    }()),
	
	    flexbox: (function checkFlexbox() {
	      var style = testDiv.style;
	      var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
	      for (var i = 0; i < styles.length; i += 1) {
	        if (styles[i] in style) { return true; }
	      }
	      return false;
	    }()),
	
	    observer: (function checkObserver() {
	      return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
	    }()),
	
	    passiveListener: (function checkPassiveListener() {
	      var supportsPassive = false;
	      try {
	        var opts = Object.defineProperty({}, 'passive', {
	          // eslint-disable-next-line
	          get: function get() {
	            supportsPassive = true;
	          },
	        });
	        win.addEventListener('testPassiveListener', null, opts);
	      } catch (e) {
	        // No support
	      }
	      return supportsPassive;
	    }()),
	
	    gestures: (function checkGestures() {
	      return 'ongesturestart' in win;
	    }()),
	  };
	}());
	
	var SwiperClass = function SwiperClass(params) {
	  if ( params === void 0 ) params = {};
	
	  var self = this;
	  self.params = params;
	
	  // Events
	  self.eventsListeners = {};
	
	  if (self.params && self.params.on) {
	    Object.keys(self.params.on).forEach(function (eventName) {
	      self.on(eventName, self.params.on[eventName]);
	    });
	  }
	};
	
	var staticAccessors = { components: { configurable: true } };
	SwiperClass.prototype.on = function on (events, handler, priority) {
	  var self = this;
	  if (typeof handler !== 'function') { return self; }
	  var method = priority ? 'unshift' : 'push';
	  events.split(' ').forEach(function (event) {
	    if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
	    self.eventsListeners[event][method](handler);
	  });
	  return self;
	};
	SwiperClass.prototype.once = function once (events, handler, priority) {
	  var self = this;
	  if (typeof handler !== 'function') { return self; }
	  function onceHandler() {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	    handler.apply(self, args);
	    self.off(events, onceHandler);
	  }
	  return self.on(events, onceHandler, priority);
	};
	SwiperClass.prototype.off = function off (events, handler) {
	  var self = this;
	  events.split(' ').forEach(function (event) {
	    if (typeof handler === 'undefined') {
	      self.eventsListeners[event] = [];
	    } else {
	      self.eventsListeners[event].forEach(function (eventHandler, index) {
	        if (eventHandler === handler) {
	          self.eventsListeners[event].splice(index, 1);
	        }
	      });
	    }
	  });
	  return self;
	};
	SwiperClass.prototype.emit = function emit () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	  var self = this;
	  if (!self.eventsListeners) { return self; }
	  var events;
	  var data;
	  var context;
	  if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	    events = args[0];
	    data = args.slice(1, args.length);
	    context = self;
	  } else {
	    events = args[0].events;
	    data = args[0].data;
	    context = args[0].context || self;
	  }
	  var eventsArray = Array.isArray(events) ? events : events.split(' ');
	  eventsArray.forEach(function (event) {
	    if (self.eventsListeners[event]) {
	      var handlers = [];
	      self.eventsListeners[event].forEach(function (eventHandler) {
	        handlers.push(eventHandler);
	      });
	      handlers.forEach(function (eventHandler) {
	        eventHandler.apply(context, data);
	      });
	    }
	  });
	  return self;
	};
	SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
	  var instance = this;
	  if (!instance.modules) { return; }
	  Object.keys(instance.modules).forEach(function (moduleName) {
	    var module = instance.modules[moduleName];
	    // Extend params
	    if (module.params) {
	      Utils.extend(instanceParams, module.params);
	    }
	  });
	};
	SwiperClass.prototype.useModules = function useModules (modulesParams) {
	    if ( modulesParams === void 0 ) modulesParams = {};
	
	  var instance = this;
	  if (!instance.modules) { return; }
	  Object.keys(instance.modules).forEach(function (moduleName) {
	    var module = instance.modules[moduleName];
	    var moduleParams = modulesParams[moduleName] || {};
	    // Extend instance methods and props
	    if (module.instance) {
	      Object.keys(module.instance).forEach(function (modulePropName) {
	        var moduleProp = module.instance[modulePropName];
	        if (typeof moduleProp === 'function') {
	          instance[modulePropName] = moduleProp.bind(instance);
	        } else {
	          instance[modulePropName] = moduleProp;
	        }
	      });
	    }
	    // Add event listeners
	    if (module.on && instance.on) {
	      Object.keys(module.on).forEach(function (moduleEventName) {
	        instance.on(moduleEventName, module.on[moduleEventName]);
	      });
	    }
	
	    // Module create callback
	    if (module.create) {
	      module.create.bind(instance)(moduleParams);
	    }
	  });
	};
	staticAccessors.components.set = function (components) {
	  var Class = this;
	  if (!Class.use) { return; }
	  Class.use(components);
	};
	SwiperClass.installModule = function installModule (module) {
	    var params = [], len = arguments.length - 1;
	    while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];
	
	  var Class = this;
	  if (!Class.prototype.modules) { Class.prototype.modules = {}; }
	  var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
	  Class.prototype.modules[name] = module;
	  // Prototype
	  if (module.proto) {
	    Object.keys(module.proto).forEach(function (key) {
	      Class.prototype[key] = module.proto[key];
	    });
	  }
	  // Class
	  if (module.static) {
	    Object.keys(module.static).forEach(function (key) {
	      Class[key] = module.static[key];
	    });
	  }
	  // Callback
	  if (module.install) {
	    module.install.apply(Class, params);
	  }
	  return Class;
	};
	SwiperClass.use = function use (module) {
	    var params = [], len = arguments.length - 1;
	    while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];
	
	  var Class = this;
	  if (Array.isArray(module)) {
	    module.forEach(function (m) { return Class.installModule(m); });
	    return Class;
	  }
	  return Class.installModule.apply(Class, [ module ].concat( params ));
	};
	
	Object.defineProperties( SwiperClass, staticAccessors );
	
	function updateSize () {
	  var swiper = this;
	  var width;
	  var height;
	  var $el = swiper.$el;
	  if (typeof swiper.params.width !== 'undefined') {
	    width = swiper.params.width;
	  } else {
	    width = $el[0].clientWidth;
	  }
	  if (typeof swiper.params.height !== 'undefined') {
	    height = swiper.params.height;
	  } else {
	    height = $el[0].clientHeight;
	  }
	  if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
	    return;
	  }
	
	  // Subtract paddings
	  width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
	  height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);
	
	  Utils.extend(swiper, {
	    width: width,
	    height: height,
	    size: swiper.isHorizontal() ? width : height,
	  });
	}
	
	function updateSlides () {
	  var swiper = this;
	  var params = swiper.params;
	
	  var $wrapperEl = swiper.$wrapperEl;
	  var swiperSize = swiper.size;
	  var rtl = swiper.rtlTranslate;
	  var wrongRTL = swiper.wrongRTL;
	  var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	  var snapGrid = [];
	  var slidesGrid = [];
	  var slidesSizesGrid = [];
	
	  var offsetBefore = params.slidesOffsetBefore;
	  if (typeof offsetBefore === 'function') {
	    offsetBefore = params.slidesOffsetBefore.call(swiper);
	  }
	
	  var offsetAfter = params.slidesOffsetAfter;
	  if (typeof offsetAfter === 'function') {
	    offsetAfter = params.slidesOffsetAfter.call(swiper);
	  }
	
	  var previousSlidesLength = slidesLength;
	  var previousSnapGridLength = swiper.snapGrid.length;
	  var previousSlidesGridLength = swiper.snapGrid.length;
	
	  var spaceBetween = params.spaceBetween;
	  var slidePosition = -offsetBefore;
	  var prevSlideSize = 0;
	  var index = 0;
	  if (typeof swiperSize === 'undefined') {
	    return;
	  }
	  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	    spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
	  }
	
	  swiper.virtualSize = -spaceBetween;
	
	  // reset margins
	  if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
	  else { slides.css({ marginRight: '', marginBottom: '' }); }
	
	  var slidesNumberEvenToRows;
	  if (params.slidesPerColumn > 1) {
	    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
	      slidesNumberEvenToRows = slidesLength;
	    } else {
	      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
	    }
	    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
	      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
	    }
	  }
	
	  // Calc slides
	  var slideSize;
	  var slidesPerColumn = params.slidesPerColumn;
	  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	  var numFullColumns = slidesPerRow - ((params.slidesPerColumn * slidesPerRow) - slidesLength);
	  for (var i = 0; i < slidesLength; i += 1) {
	    slideSize = 0;
	    var slide = slides.eq(i);
	    if (params.slidesPerColumn > 1) {
	      // Set slides order
	      var newSlideOrderIndex = (void 0);
	      var column = (void 0);
	      var row = (void 0);
	      if (params.slidesPerColumnFill === 'column') {
	        column = Math.floor(i / slidesPerColumn);
	        row = i - (column * slidesPerColumn);
	        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
	          row += 1;
	          if (row >= slidesPerColumn) {
	            row = 0;
	            column += 1;
	          }
	        }
	        newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
	        slide
	          .css({
	            '-webkit-box-ordinal-group': newSlideOrderIndex,
	            '-moz-box-ordinal-group': newSlideOrderIndex,
	            '-ms-flex-order': newSlideOrderIndex,
	            '-webkit-order': newSlideOrderIndex,
	            order: newSlideOrderIndex,
	          });
	      } else {
	        row = Math.floor(i / slidesPerRow);
	        column = i - (row * slidesPerRow);
	      }
	      slide
	        .css(
	          ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
	          (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
	        )
	        .attr('data-swiper-column', column)
	        .attr('data-swiper-row', row);
	    }
	    if (slide.css('display') === 'none') { continue; } // eslint-disable-line
	
	    if (params.slidesPerView === 'auto') {
	      var slideStyles = win.getComputedStyle(slide[0], null);
	      if (swiper.isHorizontal()) {
	        slideSize = slide[0].getBoundingClientRect().width +
	          parseFloat(slideStyles.getPropertyValue('margin-left')) +
	          parseFloat(slideStyles.getPropertyValue('margin-right'));
	      } else {
	        slideSize = slide[0].getBoundingClientRect().height +
	          parseFloat(slideStyles.getPropertyValue('margin-top')) +
	          parseFloat(slideStyles.getPropertyValue('margin-bottom'));
	      }
	      if (params.roundLengths) { slideSize = Math.floor(slideSize); }
	    } else {
	      slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
	      if (params.roundLengths) { slideSize = Math.floor(slideSize); }
	
	      if (slides[i]) {
	        if (swiper.isHorizontal()) {
	          slides[i].style.width = slideSize + "px";
	        } else {
	          slides[i].style.height = slideSize + "px";
	        }
	      }
	    }
	    if (slides[i]) {
	      slides[i].swiperSlideSize = slideSize;
	    }
	    slidesSizesGrid.push(slideSize);
	
	
	    if (params.centeredSlides) {
	      slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
	      if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	      if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	      if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
	      if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	      slidesGrid.push(slidePosition);
	    } else {
	      if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	      slidesGrid.push(slidePosition);
	      slidePosition = slidePosition + slideSize + spaceBetween;
	    }
	
	    swiper.virtualSize += slideSize + spaceBetween;
	
	    prevSlideSize = slideSize;
	
	    index += 1;
	  }
	  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	  var newSlidesGrid;
	
	  if (
	    rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	    $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
	  }
	  if (!Support.flexbox || params.setWrapperSize) {
	    if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	    else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	  }
	
	  if (params.slidesPerColumn > 1) {
	    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
	    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
	    if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	    else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	    if (params.centeredSlides) {
	      newSlidesGrid = [];
	      for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
	        if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(snapGrid[i$1]); }
	      }
	      snapGrid = newSlidesGrid;
	    }
	  }
	
	  // Remove last grid elements depending on width
	  if (!params.centeredSlides) {
	    newSlidesGrid = [];
	    for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
	      if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
	        newSlidesGrid.push(snapGrid[i$2]);
	      }
	    }
	    snapGrid = newSlidesGrid;
	    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	      snapGrid.push(swiper.virtualSize - swiperSize);
	    }
	  }
	  if (snapGrid.length === 0) { snapGrid = [0]; }
	
	  if (params.spaceBetween !== 0) {
	    if (swiper.isHorizontal()) {
	      if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
	      else { slides.css({ marginRight: (spaceBetween + "px") }); }
	    } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
	  }
	
	  Utils.extend(swiper, {
	    slides: slides,
	    snapGrid: snapGrid,
	    slidesGrid: slidesGrid,
	    slidesSizesGrid: slidesSizesGrid,
	  });
	
	  if (slidesLength !== previousSlidesLength) {
	    swiper.emit('slidesLengthChange');
	  }
	  if (snapGrid.length !== previousSnapGridLength) {
	    if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
	    swiper.emit('snapGridLengthChange');
	  }
	  if (slidesGrid.length !== previousSlidesGridLength) {
	    swiper.emit('slidesGridLengthChange');
	  }
	
	  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateSlidesOffset();
	  }
	}
	
	function updateAutoHeight (speed) {
	  var swiper = this;
	  var activeSlides = [];
	  var newHeight = 0;
	  var i;
	  if (typeof speed === 'number') {
	    swiper.setTransition(speed);
	  } else if (speed === true) {
	    swiper.setTransition(swiper.params.speed);
	  }
	  // Find slides currently in view
	  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	    for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	      var index = swiper.activeIndex + i;
	      if (index > swiper.slides.length) { break; }
	      activeSlides.push(swiper.slides.eq(index)[0]);
	    }
	  } else {
	    activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
	  }
	
	  // Find new height from highest slide in view
	  for (i = 0; i < activeSlides.length; i += 1) {
	    if (typeof activeSlides[i] !== 'undefined') {
	      var height = activeSlides[i].offsetHeight;
	      newHeight = height > newHeight ? height : newHeight;
	    }
	  }
	
	  // Update Height
	  if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
	}
	
	function updateSlidesOffset () {
	  var swiper = this;
	  var slides = swiper.slides;
	  for (var i = 0; i < slides.length; i += 1) {
	    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	  }
	}
	
	function updateSlidesProgress (translate) {
	  if ( translate === void 0 ) translate = this.translate || 0;
	
	  var swiper = this;
	  var params = swiper.params;
	
	  var slides = swiper.slides;
	  var rtl = swiper.rtlTranslate;
	
	  if (slides.length === 0) { return; }
	  if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }
	
	  var offsetCenter = -translate;
	  if (rtl) { offsetCenter = translate; }
	
	  // Visible Slides
	  slides.removeClass(params.slideVisibleClass);
	
	  for (var i = 0; i < slides.length; i += 1) {
	    var slide = slides[i];
	    var slideProgress =
	      (
	        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
	      ) / (slide.swiperSlideSize + params.spaceBetween);
	    if (params.watchSlidesVisibility) {
	      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	      var isVisible =
	                (slideBefore >= 0 && slideBefore < swiper.size) ||
	                (slideAfter > 0 && slideAfter <= swiper.size) ||
	                (slideBefore <= 0 && slideAfter >= swiper.size);
	      if (isVisible) {
	        slides.eq(i).addClass(params.slideVisibleClass);
	      }
	    }
	    slide.progress = rtl ? -slideProgress : slideProgress;
	  }
	}
	
	function updateProgress (translate) {
	  if ( translate === void 0 ) translate = this.translate || 0;
	
	  var swiper = this;
	  var params = swiper.params;
	
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  var progress = swiper.progress;
	  var isBeginning = swiper.isBeginning;
	  var isEnd = swiper.isEnd;
	  var wasBeginning = isBeginning;
	  var wasEnd = isEnd;
	  if (translatesDiff === 0) {
	    progress = 0;
	    isBeginning = true;
	    isEnd = true;
	  } else {
	    progress = (translate - swiper.minTranslate()) / (translatesDiff);
	    isBeginning = progress <= 0;
	    isEnd = progress >= 1;
	  }
	  Utils.extend(swiper, {
	    progress: progress,
	    isBeginning: isBeginning,
	    isEnd: isEnd,
	  });
	
	  if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }
	
	  if (isBeginning && !wasBeginning) {
	    swiper.emit('reachBeginning toEdge');
	  }
	  if (isEnd && !wasEnd) {
	    swiper.emit('reachEnd toEdge');
	  }
	  if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
	    swiper.emit('fromEdge');
	  }
	
	  swiper.emit('progress', progress);
	}
	
	function updateSlidesClasses () {
	  var swiper = this;
	
	  var slides = swiper.slides;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var activeIndex = swiper.activeIndex;
	  var realIndex = swiper.realIndex;
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	
	  slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));
	
	  var activeSlide;
	  if (isVirtual) {
	    activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
	  } else {
	    activeSlide = slides.eq(activeIndex);
	  }
	
	  // Active classes
	  activeSlide.addClass(params.slideActiveClass);
	
	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (activeSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl
	        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
	        .addClass(params.slideDuplicateActiveClass);
	    } else {
	      $wrapperEl
	        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
	        .addClass(params.slideDuplicateActiveClass);
	    }
	  }
	  // Next Slide
	  var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
	  if (params.loop && nextSlide.length === 0) {
	    nextSlide = slides.eq(0);
	    nextSlide.addClass(params.slideNextClass);
	  }
	  // Prev Slide
	  var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
	  if (params.loop && prevSlide.length === 0) {
	    prevSlide = slides.eq(-1);
	    prevSlide.addClass(params.slidePrevClass);
	  }
	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (nextSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl
	        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicateNextClass);
	    } else {
	      $wrapperEl
	        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicateNextClass);
	    }
	    if (prevSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl
	        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicatePrevClass);
	    } else {
	      $wrapperEl
	        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicatePrevClass);
	    }
	  }
	}
	
	function updateActiveIndex (newActiveIndex) {
	  var swiper = this;
	  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  var slidesGrid = swiper.slidesGrid;
	  var snapGrid = swiper.snapGrid;
	  var params = swiper.params;
	  var previousIndex = swiper.activeIndex;
	  var previousRealIndex = swiper.realIndex;
	  var previousSnapIndex = swiper.snapIndex;
	  var activeIndex = newActiveIndex;
	  var snapIndex;
	  if (typeof activeIndex === 'undefined') {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
	          activeIndex = i;
	        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	          activeIndex = i + 1;
	        }
	      } else if (translate >= slidesGrid[i]) {
	        activeIndex = i;
	      }
	    }
	    // Normalize slideIndex
	    if (params.normalizeSlideIndex) {
	      if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
	    }
	  }
	  if (snapGrid.indexOf(translate) >= 0) {
	    snapIndex = snapGrid.indexOf(translate);
	  } else {
	    snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
	  }
	  if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
	  if (activeIndex === previousIndex) {
	    if (snapIndex !== previousSnapIndex) {
	      swiper.snapIndex = snapIndex;
	      swiper.emit('snapIndexChange');
	    }
	    return;
	  }
	
	  // Get real index
	  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
	
	  Utils.extend(swiper, {
	    snapIndex: snapIndex,
	    realIndex: realIndex,
	    previousIndex: previousIndex,
	    activeIndex: activeIndex,
	  });
	  swiper.emit('activeIndexChange');
	  swiper.emit('snapIndexChange');
	  if (previousRealIndex !== realIndex) {
	    swiper.emit('realIndexChange');
	  }
	  swiper.emit('slideChange');
	}
	
	function updateClickedSlide (e) {
	  var swiper = this;
	  var params = swiper.params;
	  var slide = $(e.target).closest(("." + (params.slideClass)))[0];
	  var slideFound = false;
	  if (slide) {
	    for (var i = 0; i < swiper.slides.length; i += 1) {
	      if (swiper.slides[i] === slide) { slideFound = true; }
	    }
	  }
	
	  if (slide && slideFound) {
	    swiper.clickedSlide = slide;
	    if (swiper.virtual && swiper.params.virtual.enabled) {
	      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
	    } else {
	      swiper.clickedIndex = $(slide).index();
	    }
	  } else {
	    swiper.clickedSlide = undefined;
	    swiper.clickedIndex = undefined;
	    return;
	  }
	  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	    swiper.slideToClickedSlide();
	  }
	}
	
	var update = {
	  updateSize: updateSize,
	  updateSlides: updateSlides,
	  updateAutoHeight: updateAutoHeight,
	  updateSlidesOffset: updateSlidesOffset,
	  updateSlidesProgress: updateSlidesProgress,
	  updateProgress: updateProgress,
	  updateSlidesClasses: updateSlidesClasses,
	  updateActiveIndex: updateActiveIndex,
	  updateClickedSlide: updateClickedSlide,
	};
	
	function getTranslate (axis) {
	  if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';
	
	  var swiper = this;
	
	  var params = swiper.params;
	  var rtl = swiper.rtlTranslate;
	  var translate = swiper.translate;
	  var $wrapperEl = swiper.$wrapperEl;
	
	  if (params.virtualTranslate) {
	    return rtl ? -translate : translate;
	  }
	
	  var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
	  if (rtl) { currentTranslate = -currentTranslate; }
	
	  return currentTranslate || 0;
	}
	
	function setTranslate (translate, byController) {
	  var swiper = this;
	  var rtl = swiper.rtlTranslate;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var progress = swiper.progress;
	  var x = 0;
	  var y = 0;
	  var z = 0;
	
	  if (swiper.isHorizontal()) {
	    x = rtl ? -translate : translate;
	  } else {
	    y = translate;
	  }
	
	  if (params.roundLengths) {
	    x = Math.floor(x);
	    y = Math.floor(y);
	  }
	
	  if (!params.virtualTranslate) {
	    if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
	    else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
	  }
	
	  swiper.translate = swiper.isHorizontal() ? x : y;
	
	  // Check if we need to update progress
	  var newProgress;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
	  }
	  if (newProgress !== progress) {
	    swiper.updateProgress(translate);
	  }
	
	  swiper.emit('setTranslate', swiper.translate, byController);
	}
	
	function minTranslate () {
	  return (-this.snapGrid[0]);
	}
	
	function maxTranslate () {
	  return (-this.snapGrid[this.snapGrid.length - 1]);
	}
	
	var translate = {
	  getTranslate: getTranslate,
	  setTranslate: setTranslate,
	  minTranslate: minTranslate,
	  maxTranslate: maxTranslate,
	};
	
	function setTransition (duration, byController) {
	  var swiper = this;
	
	  swiper.$wrapperEl.transition(duration);
	
	  swiper.emit('setTransition', duration, byController);
	}
	
	function transitionStart (runCallbacks, direction) {
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var activeIndex = swiper.activeIndex;
	  var params = swiper.params;
	  var previousIndex = swiper.previousIndex;
	  if (params.autoHeight) {
	    swiper.updateAutoHeight();
	  }
	
	  var dir = direction;
	  if (!dir) {
	    if (activeIndex > previousIndex) { dir = 'next'; }
	    else if (activeIndex < previousIndex) { dir = 'prev'; }
	    else { dir = 'reset'; }
	  }
	
	  swiper.emit('transitionStart');
	
	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit('slideResetTransitionStart');
	      return;
	    }
	    swiper.emit('slideChangeTransitionStart');
	    if (dir === 'next') {
	      swiper.emit('slideNextTransitionStart');
	    } else {
	      swiper.emit('slidePrevTransitionStart');
	    }
	  }
	}
	
	function transitionEnd$1 (runCallbacks, direction) {
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var activeIndex = swiper.activeIndex;
	  var previousIndex = swiper.previousIndex;
	  swiper.animating = false;
	  swiper.setTransition(0);
	
	  var dir = direction;
	  if (!dir) {
	    if (activeIndex > previousIndex) { dir = 'next'; }
	    else if (activeIndex < previousIndex) { dir = 'prev'; }
	    else { dir = 'reset'; }
	  }
	
	  swiper.emit('transitionEnd');
	
	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit('slideResetTransitionEnd');
	      return;
	    }
	    swiper.emit('slideChangeTransitionEnd');
	    if (dir === 'next') {
	      swiper.emit('slideNextTransitionEnd');
	    } else {
	      swiper.emit('slidePrevTransitionEnd');
	    }
	  }
	}
	
	var transition$1 = {
	  setTransition: setTransition,
	  transitionStart: transitionStart,
	  transitionEnd: transitionEnd$1,
	};
	
	function slideTo (index, speed, runCallbacks, internal) {
	  if ( index === void 0 ) index = 0;
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var slideIndex = index;
	  if (slideIndex < 0) { slideIndex = 0; }
	
	  var params = swiper.params;
	  var snapGrid = swiper.snapGrid;
	  var slidesGrid = swiper.slidesGrid;
	  var previousIndex = swiper.previousIndex;
	  var activeIndex = swiper.activeIndex;
	  var rtl = swiper.rtlTranslate;
	  var $wrapperEl = swiper.$wrapperEl;
	  if (swiper.animating && params.preventIntercationOnTransition) {
	    return false;
	  }
	
	  var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
	  if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
	
	  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
	    swiper.emit('beforeSlideChangeStart');
	  }
	
	  var translate = -snapGrid[snapIndex];
	
	  // Update progress
	  swiper.updateProgress(translate);
	
	  // Normalize slideIndex
	  if (params.normalizeSlideIndex) {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
	        slideIndex = i;
	      }
	    }
	  }
	  // Directions locks
	  if (swiper.initialized && slideIndex !== activeIndex) {
	    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
	      return false;
	    }
	    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	      if ((activeIndex || 0) !== slideIndex) { return false; }
	    }
	  }
	
	  var direction;
	  if (slideIndex > activeIndex) { direction = 'next'; }
	  else if (slideIndex < activeIndex) { direction = 'prev'; }
	  else { direction = 'reset'; }
	
	
	  // Update Index
	  if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
	    swiper.updateActiveIndex(slideIndex);
	    // Update Height
	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	    swiper.updateSlidesClasses();
	    if (params.effect !== 'slide') {
	      swiper.setTranslate(translate);
	    }
	    if (direction !== 'reset') {
	      swiper.transitionStart(runCallbacks, direction);
	      swiper.transitionEnd(runCallbacks, direction);
	    }
	    return false;
	  }
	
	  if (speed === 0 || !Support.transition) {
	    swiper.setTransition(0);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks, direction);
	    swiper.transitionEnd(runCallbacks, direction);
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks, direction);
	    if (!swiper.animating) {
	      swiper.animating = true;
	      $wrapperEl.transitionEnd(function () {
	        if (!swiper || swiper.destroyed) { return; }
	        swiper.transitionEnd(runCallbacks, direction);
	      });
	    }
	  }
	
	  return true;
	}
	
	function slideToLoop (index, speed, runCallbacks, internal) {
	  if ( index === void 0 ) index = 0;
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var newIndex = index;
	  if (swiper.params.loop) {
	    newIndex += swiper.loopedSlides;
	  }
	
	  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
	}
	
	/* eslint no-unused-vars: "off" */
	function slideNext (speed, runCallbacks, internal) {
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var params = swiper.params;
	  var animating = swiper.animating;
	  if (params.loop) {
	    if (animating) { return false; }
	    swiper.loopFix();
	    // eslint-disable-next-line
	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
	  }
	  return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
	}
	
	/* eslint no-unused-vars: "off" */
	function slidePrev (speed, runCallbacks, internal) {
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var params = swiper.params;
	  var animating = swiper.animating;
	
	  if (params.loop) {
	    if (animating) { return false; }
	    swiper.loopFix();
	    // eslint-disable-next-line
	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	    return swiper.slideTo(swiper.activeIndex - 1, speed, runCallbacks, internal);
	  }
	  return swiper.slideTo(swiper.activeIndex - 1, speed, runCallbacks, internal);
	}
	
	/* eslint no-unused-vars: "off" */
	function slideReset (speed, runCallbacks, internal) {
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	}
	
	/* eslint no-unused-vars: "off" */
	function slideToClosest (speed, runCallbacks, internal) {
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var index = swiper.activeIndex;
	  var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);
	
	  if (snapIndex < swiper.snapGrid.length - 1) {
	    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	
	    var currentSnap = swiper.snapGrid[snapIndex];
	    var nextSnap = swiper.snapGrid[snapIndex + 1];
	
	    if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
	      index = swiper.params.slidesPerGroup;
	    }
	  }
	
	  return swiper.slideTo(index, speed, runCallbacks, internal);
	}
	
	function slideToClickedSlide () {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	
	  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	  var slideToIndex = swiper.clickedIndex;
	  var realIndex;
	  if (params.loop) {
	    if (swiper.animating) { return; }
	    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	    if (params.centeredSlides) {
	      if (
	        (slideToIndex < swiper.loopedSlides - (slidesPerView / 2)) ||
	        (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
	      ) {
	        swiper.loopFix();
	        slideToIndex = $wrapperEl
	          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	          .eq(0)
	          .index();
	
	        Utils.nextTick(function () {
	          swiper.slideTo(slideToIndex);
	        });
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	      swiper.loopFix();
	      slideToIndex = $wrapperEl
	        .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	        .eq(0)
	        .index();
	
	      Utils.nextTick(function () {
	        swiper.slideTo(slideToIndex);
	      });
	    } else {
	      swiper.slideTo(slideToIndex);
	    }
	  } else {
	    swiper.slideTo(slideToIndex);
	  }
	}
	
	var slide = {
	  slideTo: slideTo,
	  slideToLoop: slideToLoop,
	  slideNext: slideNext,
	  slidePrev: slidePrev,
	  slideReset: slideReset,
	  slideToClosest: slideToClosest,
	  slideToClickedSlide: slideToClickedSlide,
	};
	
	function loopCreate () {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  // Remove duplicated slides
	  $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();
	
	  var slides = $wrapperEl.children(("." + (params.slideClass)));
	
	  if (params.loopFillGroupWithBlank) {
	    var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
	    if (blankSlidesNum !== params.slidesPerGroup) {
	      for (var i = 0; i < blankSlidesNum; i += 1) {
	        var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
	        $wrapperEl.append(blankNode);
	      }
	      slides = $wrapperEl.children(("." + (params.slideClass)));
	    }
	  }
	
	  if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }
	
	  swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
	  swiper.loopedSlides += params.loopAdditionalSlides;
	  if (swiper.loopedSlides > slides.length) {
	    swiper.loopedSlides = slides.length;
	  }
	
	  var prependSlides = [];
	  var appendSlides = [];
	  slides.each(function (index, el) {
	    var slide = $(el);
	    if (index < swiper.loopedSlides) { appendSlides.push(el); }
	    if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
	    slide.attr('data-swiper-slide-index', index);
	  });
	  for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
	    $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	  for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
	    $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	}
	
	function loopFix () {
	  var swiper = this;
	  var params = swiper.params;
	  var activeIndex = swiper.activeIndex;
	  var slides = swiper.slides;
	  var loopedSlides = swiper.loopedSlides;
	  var allowSlidePrev = swiper.allowSlidePrev;
	  var allowSlideNext = swiper.allowSlideNext;
	  var snapGrid = swiper.snapGrid;
	  var rtl = swiper.rtlTranslate;
	  var newIndex;
	  swiper.allowSlidePrev = true;
	  swiper.allowSlideNext = true;
	
	  var snapTranslate = -snapGrid[activeIndex];
	  var diff = snapTranslate - swiper.getTranslate();
	
	
	  // Fix For Negative Oversliding
	  if (activeIndex < loopedSlides) {
	    newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
	    newIndex += loopedSlides;
	    var slideChanged = swiper.slideTo(newIndex, 0, false, true);
	    if (slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex > slides.length - (params.slidesPerView * 2))) {
	    // Fix For Positive Oversliding
	    newIndex = -slides.length + activeIndex + loopedSlides;
	    newIndex += loopedSlides;
	    var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
	    if (slideChanged$1 && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  }
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	}
	
	function loopDestroy () {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl;
	  var params = swiper.params;
	  var slides = swiper.slides;
	  $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();
	  slides.removeAttr('data-swiper-slide-index');
	}
	
	var loop = {
	  loopCreate: loopCreate,
	  loopFix: loopFix,
	  loopDestroy: loopDestroy,
	};
	
	function setGrabCursor (moving) {
	  var swiper = this;
	  if (Support.touch || !swiper.params.simulateTouch) { return; }
	  var el = swiper.el;
	  el.style.cursor = 'move';
	  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	  el.style.cursor = moving ? 'grabbing' : 'grab';
	}
	
	function unsetGrabCursor () {
	  var swiper = this;
	  if (Support.touch) { return; }
	  swiper.el.style.cursor = '';
	}
	
	var grabCursor = {
	  setGrabCursor: setGrabCursor,
	  unsetGrabCursor: unsetGrabCursor,
	};
	
	function appendSlide (slides) {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl;
	  var params = swiper.params;
	  if (params.loop) {
	    swiper.loopDestroy();
	  }
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) { $wrapperEl.append(slides[i]); }
	    }
	  } else {
	    $wrapperEl.append(slides);
	  }
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	  if (!(params.observer && Support.observer)) {
	    swiper.update();
	  }
	}
	
	function prependSlide (slides) {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var activeIndex = swiper.activeIndex;
	
	  if (params.loop) {
	    swiper.loopDestroy();
	  }
	  var newActiveIndex = activeIndex + 1;
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) { $wrapperEl.prepend(slides[i]); }
	    }
	    newActiveIndex = activeIndex + slides.length;
	  } else {
	    $wrapperEl.prepend(slides);
	  }
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	  if (!(params.observer && Support.observer)) {
	    swiper.update();
	  }
	  swiper.slideTo(newActiveIndex, 0, false);
	}
	
	function removeSlide (slidesIndexes) {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var activeIndex = swiper.activeIndex;
	
	  if (params.loop) {
	    swiper.loopDestroy();
	    swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
	  }
	  var newActiveIndex = activeIndex;
	  var indexToRemove;
	
	  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
	    for (var i = 0; i < slidesIndexes.length; i += 1) {
	      indexToRemove = slidesIndexes[i];
	      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	    }
	    newActiveIndex = Math.max(newActiveIndex, 0);
	  } else {
	    indexToRemove = slidesIndexes;
	    if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	    if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	    newActiveIndex = Math.max(newActiveIndex, 0);
	  }
	
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	
	  if (!(params.observer && Support.observer)) {
	    swiper.update();
	  }
	  if (params.loop) {
	    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	}
	
	function removeAllSlides () {
	  var swiper = this;
	
	  var slidesIndexes = [];
	  for (var i = 0; i < swiper.slides.length; i += 1) {
	    slidesIndexes.push(i);
	  }
	  swiper.removeSlide(slidesIndexes);
	}
	
	var manipulation = {
	  appendSlide: appendSlide,
	  prependSlide: prependSlide,
	  removeSlide: removeSlide,
	  removeAllSlides: removeAllSlides,
	};
	
	var Device = (function Device() {
	  var ua = win.navigator.userAgent;
	
	  var device = {
	    ios: false,
	    android: false,
	    androidChrome: false,
	    desktop: false,
	    windows: false,
	    iphone: false,
	    ipod: false,
	    ipad: false,
	    cordova: win.cordova || win.phonegap,
	    phonegap: win.cordova || win.phonegap,
	  };
	
	  var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	
	
	  // Windows
	  if (windows) {
	    device.os = 'windows';
	    device.osVersion = windows[2];
	    device.windows = true;
	  }
	  // Android
	  if (android && !windows) {
	    device.os = 'android';
	    device.osVersion = android[2];
	    device.android = true;
	    device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
	  }
	  if (ipad || iphone || ipod) {
	    device.os = 'ios';
	    device.ios = true;
	  }
	  // iOS
	  if (iphone && !ipod) {
	    device.osVersion = iphone[2].replace(/_/g, '.');
	    device.iphone = true;
	  }
	  if (ipad) {
	    device.osVersion = ipad[2].replace(/_/g, '.');
	    device.ipad = true;
	  }
	  if (ipod) {
	    device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	    device.iphone = true;
	  }
	  // iOS 8+ changed UA
	  if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
	    if (device.osVersion.split('.')[0] === '10') {
	      device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
	    }
	  }
	
	  // Desktop
	  device.desktop = !(device.os || device.android || device.webView);
	
	  // Webview
	  device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);
	
	  // Minimal UI
	  if (device.os && device.os === 'ios') {
	    var osVersionArr = device.osVersion.split('.');
	    var metaViewport = doc.querySelector('meta[name="viewport"]');
	    device.minimalUi =
	      !device.webView &&
	      (ipod || iphone) &&
	      (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
	      metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
	  }
	
	  // Pixel Ratio
	  device.pixelRatio = win.devicePixelRatio || 1;
	
	  // Export object
	  return device;
	}());
	
	function onTouchStart (event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params;
	  var touches = swiper.touches;
	  if (swiper.animating && params.preventIntercationOnTransition) {
	    return;
	  }
	  var e = event;
	  if (e.originalEvent) { e = e.originalEvent; }
	  data.isTouchEvent = e.type === 'touchstart';
	  if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
	  if (data.isTouched && data.isMoved) { return; }
	  if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
	    swiper.allowClick = true;
	    return;
	  }
	  if (params.swipeHandler) {
	    if (!$(e).closest(params.swipeHandler)[0]) { return; }
	  }
	
	  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  var startX = touches.currentX;
	  var startY = touches.currentY;
	
	  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
	
	  if (
	    Device.ios &&
	    !Device.cordova &&
	    params.iOSEdgeSwipeDetection &&
	    (startX <= params.iOSEdgeSwipeThreshold) &&
	    (startX >= win.screen.width - params.iOSEdgeSwipeThreshold)
	  ) {
	    return;
	  }
	
	  Utils.extend(data, {
	    isTouched: true,
	    isMoved: false,
	    allowTouchCallbacks: true,
	    isScrolling: undefined,
	    startMoving: undefined,
	  });
	
	  touches.startX = startX;
	  touches.startY = startY;
	  data.touchStartTime = Utils.now();
	  swiper.allowClick = true;
	  swiper.updateSize();
	  swiper.swipeDirection = undefined;
	  if (params.threshold > 0) { data.allowThresholdMove = false; }
	  if (e.type !== 'touchstart') {
	    var preventDefault = true;
	    if ($(e.target).is(data.formElements)) { preventDefault = false; }
	    if (
	      doc.activeElement &&
	      $(doc.activeElement).is(data.formElements) &&
	      doc.activeElement !== e.target
	    ) {
	      doc.activeElement.blur();
	    }
	    if (preventDefault && swiper.allowTouchMove) {
	      e.preventDefault();
	    }
	  }
	  swiper.emit('touchStart', e);
	}
	
	function onTouchMove (event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params;
	  var touches = swiper.touches;
	  var rtl = swiper.rtlTranslate;
	  var e = event;
	  if (e.originalEvent) { e = e.originalEvent; }
	  if (!data.isTouched) {
	    if (data.startMoving && data.isScrolling) {
	      swiper.emit('touchMoveOpposite', e);
	    }
	    return;
	  }
	  if (data.isTouchEvent && e.type === 'mousemove') { return; }
	  var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	  var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	  if (e.preventedByNestedSwiper) {
	    touches.startX = pageX;
	    touches.startY = pageY;
	    return;
	  }
	  if (!swiper.allowTouchMove) {
	    // isMoved = true;
	    swiper.allowClick = false;
	    if (data.isTouched) {
	      Utils.extend(touches, {
	        startX: pageX,
	        startY: pageY,
	        currentX: pageX,
	        currentY: pageY,
	      });
	      data.touchStartTime = Utils.now();
	    }
	    return;
	  }
	  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
	    if (swiper.isVertical()) {
	      // Vertical
	      if (
	        (pageY < touches.startY && swiper.translate <= swiper.maxTranslate()) ||
	        (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
	      ) {
	        data.isTouched = false;
	        data.isMoved = false;
	        return;
	      }
	    } else if (
	      (pageX < touches.startX && swiper.translate <= swiper.maxTranslate()) ||
	      (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
	    ) {
	      return;
	    }
	  }
	  if (data.isTouchEvent && doc.activeElement) {
	    if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
	      data.isMoved = true;
	      swiper.allowClick = false;
	      return;
	    }
	  }
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchMove', e);
	  }
	  if (e.targetTouches && e.targetTouches.length > 1) { return; }
	
	  touches.currentX = pageX;
	  touches.currentY = pageY;
	
	  var diffX = touches.currentX - touches.startX;
	  var diffY = touches.currentY - touches.startY;
	
	  if (typeof data.isScrolling === 'undefined') {
	    var touchAngle;
	    if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
	      data.isScrolling = false;
	    } else {
	      // eslint-disable-next-line
	      if ((diffX * diffX) + (diffY * diffY) >= 25) {
	        touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
	        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
	      }
	    }
	  }
	  if (data.isScrolling) {
	    swiper.emit('touchMoveOpposite', e);
	  }
	  if (typeof startMoving === 'undefined') {
	    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	      data.startMoving = true;
	    }
	  }
	  if (data.isScrolling) {
	    data.isTouched = false;
	    return;
	  }
	  if (!data.startMoving) {
	    return;
	  }
	  swiper.allowClick = false;
	  e.preventDefault();
	  if (params.touchMoveStopPropagation && !params.nested) {
	    e.stopPropagation();
	  }
	
	  if (!data.isMoved) {
	    if (params.loop) {
	      swiper.loopFix();
	    }
	    data.startTranslate = swiper.getTranslate();
	    swiper.setTransition(0);
	    if (swiper.animating) {
	      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
	    }
	    data.allowMomentumBounce = false;
	    // Grab Cursor
	    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	      swiper.setGrabCursor(true);
	    }
	    swiper.emit('sliderFirstMove', e);
	  }
	  swiper.emit('sliderMove', e);
	  data.isMoved = true;
	
	  var diff = swiper.isHorizontal() ? diffX : diffY;
	  touches.diff = diff;
	
	  diff *= params.touchRatio;
	  if (rtl) { diff = -diff; }
	
	  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	  data.currentTranslate = diff + data.startTranslate;
	
	  var disableParentSwiper = true;
	  var resistanceRatio = params.resistanceRatio;
	  if (params.touchReleaseOnEdges) {
	    resistanceRatio = 0;
	  }
	  if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
	    disableParentSwiper = false;
	    if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
	  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
	  }
	
	  if (disableParentSwiper) {
	    e.preventedByNestedSwiper = true;
	  }
	
	  // Directions locks
	  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	
	
	  // Threshold
	  if (params.threshold > 0) {
	    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	      if (!data.allowThresholdMove) {
	        data.allowThresholdMove = true;
	        touches.startX = touches.currentX;
	        touches.startY = touches.currentY;
	        data.currentTranslate = data.startTranslate;
	        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	        return;
	      }
	    } else {
	      data.currentTranslate = data.startTranslate;
	      return;
	    }
	  }
	
	  if (!params.followFinger) { return; }
	
	  // Update active index in free mode
	  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  }
	  if (params.freeMode) {
	    // Velocity
	    if (data.velocities.length === 0) {
	      data.velocities.push({
	        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
	        time: data.touchStartTime,
	      });
	    }
	    data.velocities.push({
	      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
	      time: Utils.now(),
	    });
	  }
	  // Update progress
	  swiper.updateProgress(data.currentTranslate);
	  // Update translate
	  swiper.setTranslate(data.currentTranslate);
	}
	
	function onTouchEnd (event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	
	  var params = swiper.params;
	  var touches = swiper.touches;
	  var rtl = swiper.rtlTranslate;
	  var $wrapperEl = swiper.$wrapperEl;
	  var slidesGrid = swiper.slidesGrid;
	  var snapGrid = swiper.snapGrid;
	  var e = event;
	  if (e.originalEvent) { e = e.originalEvent; }
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchEnd', e);
	  }
	  data.allowTouchCallbacks = false;
	  if (!data.isTouched) {
	    if (data.isMoved && params.grabCursor) {
	      swiper.setGrabCursor(false);
	    }
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  }
	  // Return Grab Cursor
	  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	    swiper.setGrabCursor(false);
	  }
	
	  // Time diff
	  var touchEndTime = Utils.now();
	  var timeDiff = touchEndTime - data.touchStartTime;
	
	  // Tap, doubleTap, Click
	  if (swiper.allowClick) {
	    swiper.updateClickedSlide(e);
	    swiper.emit('tap', e);
	    if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
	      if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
	      data.clickTimeout = Utils.nextTick(function () {
	        if (!swiper || swiper.destroyed) { return; }
	        swiper.emit('click', e);
	      }, 300);
	    }
	    if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
	      if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
	      swiper.emit('doubleTap', e);
	    }
	  }
	
	  data.lastClickTime = Utils.now();
	  Utils.nextTick(function () {
	    if (!swiper.destroyed) { swiper.allowClick = true; }
	  });
	
	  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
	    data.isTouched = false;
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  }
	  data.isTouched = false;
	  data.isMoved = false;
	  data.startMoving = false;
	
	  var currentPos;
	  if (params.followFinger) {
	    currentPos = rtl ? swiper.translate : -swiper.translate;
	  } else {
	    currentPos = -data.currentTranslate;
	  }
	
	  if (params.freeMode) {
	    if (currentPos < -swiper.minTranslate()) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    } else if (currentPos > -swiper.maxTranslate()) {
	      if (swiper.slides.length < snapGrid.length) {
	        swiper.slideTo(snapGrid.length - 1);
	      } else {
	        swiper.slideTo(swiper.slides.length - 1);
	      }
	      return;
	    }
	
	    if (params.freeModeMomentum) {
	      if (data.velocities.length > 1) {
	        var lastMoveEvent = data.velocities.pop();
	        var velocityEvent = data.velocities.pop();
	
	        var distance = lastMoveEvent.position - velocityEvent.position;
	        var time = lastMoveEvent.time - velocityEvent.time;
	        swiper.velocity = distance / time;
	        swiper.velocity /= 2;
	        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
	          swiper.velocity = 0;
	        }
	        // this implies that the user stopped moving a finger then released.
	        // There would be no events with distance zero, so the last event is stale.
	        if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
	          swiper.velocity = 0;
	        }
	      } else {
	        swiper.velocity = 0;
	      }
	      swiper.velocity *= params.freeModeMomentumVelocityRatio;
	
	      data.velocities.length = 0;
	      var momentumDuration = 1000 * params.freeModeMomentumRatio;
	      var momentumDistance = swiper.velocity * momentumDuration;
	
	      var newPosition = swiper.translate + momentumDistance;
	      if (rtl) { newPosition = -newPosition; }
	
	      var doBounce = false;
	      var afterBouncePosition;
	      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
	      if (newPosition < swiper.maxTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
	            newPosition = swiper.maxTranslate() - bounceAmount;
	          }
	          afterBouncePosition = swiper.maxTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.maxTranslate();
	        }
	      } else if (newPosition > swiper.minTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition - swiper.minTranslate() > bounceAmount) {
	            newPosition = swiper.minTranslate() + bounceAmount;
	          }
	          afterBouncePosition = swiper.minTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.minTranslate();
	        }
	      } else if (params.freeModeSticky) {
	        var nextSlide;
	        for (var j = 0; j < snapGrid.length; j += 1) {
	          if (snapGrid[j] > -newPosition) {
	            nextSlide = j;
	            break;
	          }
	        }
	
	        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
	          newPosition = snapGrid[nextSlide];
	        } else {
	          newPosition = snapGrid[nextSlide - 1];
	        }
	        newPosition = -newPosition;
	      }
	      // Fix duration
	      if (swiper.velocity !== 0) {
	        if (rtl) {
	          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
	        } else {
	          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
	        }
	      } else if (params.freeModeSticky) {
	        swiper.slideToClosest();
	        return;
	      }
	
	      if (params.freeModeMomentumBounce && doBounce) {
	        swiper.updateProgress(afterBouncePosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);
	        swiper.animating = true;
	        $wrapperEl.transitionEnd(function () {
	          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
	          swiper.emit('momentumBounce');
	
	          swiper.setTransition(params.speed);
	          swiper.setTranslate(afterBouncePosition);
	          $wrapperEl.transitionEnd(function () {
	            if (!swiper || swiper.destroyed) { return; }
	            swiper.transitionEnd();
	          });
	        });
	      } else if (swiper.velocity) {
	        swiper.updateProgress(newPosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);
	        if (!swiper.animating) {
	          swiper.animating = true;
	          $wrapperEl.transitionEnd(function () {
	            if (!swiper || swiper.destroyed) { return; }
	            swiper.transitionEnd();
	          });
	        }
	      } else {
	        swiper.updateProgress(newPosition);
	      }
	
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    } else if (params.freeModeSticky) {
	      swiper.slideToClosest();
	      return;
	    }
	
	    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
	      swiper.updateProgress();
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	    return;
	  }
	
	  // Find current slide
	  var stopIndex = 0;
	  var groupSize = swiper.slidesSizesGrid[0];
	  for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
	    if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
	      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
	        stopIndex = i;
	        groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
	      }
	    } else if (currentPos >= slidesGrid[i]) {
	      stopIndex = i;
	      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	    }
	  }
	
	  // Find current slide size
	  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	
	  if (timeDiff > params.longSwipesMs) {
	    // Long touches
	    if (!params.longSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	    if (swiper.swipeDirection === 'next') {
	      if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
	      else { swiper.slideTo(stopIndex); }
	    }
	    if (swiper.swipeDirection === 'prev') {
	      if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
	      else { swiper.slideTo(stopIndex); }
	    }
	  } else {
	    // Short swipes
	    if (!params.shortSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	    if (swiper.swipeDirection === 'next') {
	      swiper.slideTo(stopIndex + params.slidesPerGroup);
	    }
	    if (swiper.swipeDirection === 'prev') {
	      swiper.slideTo(stopIndex);
	    }
	  }
	}
	
	function onResize () {
	  var swiper = this;
	
	  var params = swiper.params;
	  var el = swiper.el;
	
	  if (el && el.offsetWidth === 0) { return; }
	
	  // Breakpoints
	  if (params.breakpoints) {
	    swiper.setBreakpoint();
	  }
	
	  // Save locks
	  var allowSlideNext = swiper.allowSlideNext;
	  var allowSlidePrev = swiper.allowSlidePrev;
	
	  // Disable locks on resize
	  swiper.allowSlideNext = true;
	  swiper.allowSlidePrev = true;
	
	  swiper.updateSize();
	  swiper.updateSlides();
	
	  if (params.freeMode) {
	    var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
	    swiper.setTranslate(newTranslate);
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	
	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	  } else {
	    swiper.updateSlidesClasses();
	    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	    } else {
	      swiper.slideTo(swiper.activeIndex, 0, false, true);
	    }
	  }
	  // Return locks after resize
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	}
	
	function onClick (e) {
	  var swiper = this;
	  if (!swiper.allowClick) {
	    if (swiper.params.preventClicks) { e.preventDefault(); }
	    if (swiper.params.preventClicksPropagation && swiper.animating) {
	      e.stopPropagation();
	      e.stopImmediatePropagation();
	    }
	  }
	}
	
	function attachEvents() {
	  var swiper = this;
	  var params = swiper.params;
	  var touchEvents = swiper.touchEvents;
	  var el = swiper.el;
	  var wrapperEl = swiper.wrapperEl;
	
	  {
	    swiper.onTouchStart = onTouchStart.bind(swiper);
	    swiper.onTouchMove = onTouchMove.bind(swiper);
	    swiper.onTouchEnd = onTouchEnd.bind(swiper);
	  }
	
	  swiper.onClick = onClick.bind(swiper);
	
	  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
	  var capture = !!params.nested;
	
	  // Touch Events
	  {
	    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	      target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
	      doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
	      doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
	    } else {
	      if (Support.touch) {
	        var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	        target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	        target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
	        target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	      }
	      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	        target.addEventListener('mousedown', swiper.onTouchStart, false);
	        doc.addEventListener('mousemove', swiper.onTouchMove, capture);
	        doc.addEventListener('mouseup', swiper.onTouchEnd, false);
	      }
	    }
	    // Prevent Links Clicks
	    if (params.preventClicks || params.preventClicksPropagation) {
	      target.addEventListener('click', swiper.onClick, true);
	    }
	  }
	
	  // Resize handler
	  swiper.on('resize observerUpdate', onResize, true);
	}
	
	function detachEvents() {
	  var swiper = this;
	
	  var params = swiper.params;
	  var touchEvents = swiper.touchEvents;
	  var el = swiper.el;
	  var wrapperEl = swiper.wrapperEl;
	
	  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
	  var capture = !!params.nested;
	
	  // Touch Events
	  {
	    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	      target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
	      doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	      doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
	    } else {
	      if (Support.touch) {
	        var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	        target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	        target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	        target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	      }
	      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	        target.removeEventListener('mousedown', swiper.onTouchStart, false);
	        doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
	        doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
	      }
	    }
	    // Prevent Links Clicks
	    if (params.preventClicks || params.preventClicksPropagation) {
	      target.removeEventListener('click', swiper.onClick, true);
	    }
	  }
	
	  // Resize handler
	  swiper.off('resize observerUpdate', onResize);
	}
	
	var events = {
	  attachEvents: attachEvents,
	  detachEvents: detachEvents,
	};
	
	function setBreakpoint () {
	  var swiper = this;
	  var activeIndex = swiper.activeIndex;
	  var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
	  var params = swiper.params;
	  var breakpoints = params.breakpoints;
	  if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }
	  // Set breakpoint for window width and update parameters
	  var breakpoint = swiper.getBreakpoint(breakpoints);
	  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
	    var breakPointsParams = breakpoint in breakpoints ? breakpoints[breakpoint] : swiper.originalParams;
	    var needsReLoop = params.loop && (breakPointsParams.slidesPerView !== params.slidesPerView);
	
	    Utils.extend(swiper.params, breakPointsParams);
	
	    Utils.extend(swiper, {
	      allowTouchMove: swiper.params.allowTouchMove,
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,
	    });
	
	    swiper.currentBreakpoint = breakpoint;
	
	    if (needsReLoop) {
	      swiper.loopDestroy();
	      swiper.loopCreate();
	      swiper.updateSlides();
	      swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
	    }
	    swiper.emit('breakpoint', breakPointsParams);
	  }
	}
	
	function getBreakpoint (breakpoints) {
	  // Get breakpoint for window width
	  if (!breakpoints) { return undefined; }
	  var breakpoint = false;
	  var points = [];
	  Object.keys(breakpoints).forEach(function (point) {
	    points.push(point);
	  });
	  points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
	  for (var i = 0; i < points.length; i += 1) {
	    var point = points[i];
	    if (point >= win.innerWidth && !breakpoint) {
	      breakpoint = point;
	    }
	  }
	  return breakpoint || 'max';
	}
	
	var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };
	
	var Browser = (function Browser() {
	  function isSafari() {
	    var ua = win.navigator.userAgent.toLowerCase();
	    return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
	  }
	  return {
	    isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
	    isSafari: isSafari(),
	    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
	  };
	}());
	
	function addClasses () {
	  var swiper = this;
	  var classNames = swiper.classNames;
	  var params = swiper.params;
	  var rtl = swiper.rtl;
	  var $el = swiper.$el;
	  var suffixes = [];
	
	  suffixes.push(params.direction);
	
	  if (params.freeMode) {
	    suffixes.push('free-mode');
	  }
	  if (!Support.flexbox) {
	    suffixes.push('no-flexbox');
	  }
	  if (params.autoHeight) {
	    suffixes.push('autoheight');
	  }
	  if (rtl) {
	    suffixes.push('rtl');
	  }
	  if (params.slidesPerColumn > 1) {
	    suffixes.push('multirow');
	  }
	  if (Device.android) {
	    suffixes.push('android');
	  }
	  if (Device.ios) {
	    suffixes.push('ios');
	  }
	  // WP8 Touch Events Fix
	  if (Browser.isIE && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	    suffixes.push(("wp8-" + (params.direction)));
	  }
	
	  suffixes.forEach(function (suffix) {
	    classNames.push(params.containerModifierClass + suffix);
	  });
	
	  $el.addClass(classNames.join(' '));
	}
	
	function removeClasses () {
	  var swiper = this;
	  var $el = swiper.$el;
	  var classNames = swiper.classNames;
	
	  $el.removeClass(classNames.join(' '));
	}
	
	var classes = { addClasses: addClasses, removeClasses: removeClasses };
	
	function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
	  var image;
	  function onReady() {
	    if (callback) { callback(); }
	  }
	  if (!imageEl.complete || !checkForComplete) {
	    if (src) {
	      image = new win.Image();
	      image.onload = onReady;
	      image.onerror = onReady;
	      if (sizes) {
	        image.sizes = sizes;
	      }
	      if (srcset) {
	        image.srcset = srcset;
	      }
	      if (src) {
	        image.src = src;
	      }
	    } else {
	      onReady();
	    }
	  } else {
	    // image already loaded...
	    onReady();
	  }
	}
	
	function preloadImages () {
	  var swiper = this;
	  swiper.imagesToLoad = swiper.$el.find('img');
	  function onReady() {
	    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
	    if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
	    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
	      if (swiper.params.updateOnImagesReady) { swiper.update(); }
	      swiper.emit('imagesReady');
	    }
	  }
	  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
	    var imageEl = swiper.imagesToLoad[i];
	    swiper.loadImage(
	      imageEl,
	      imageEl.currentSrc || imageEl.getAttribute('src'),
	      imageEl.srcset || imageEl.getAttribute('srcset'),
	      imageEl.sizes || imageEl.getAttribute('sizes'),
	      true,
	      onReady
	    );
	  }
	}
	
	var images = {
	  loadImage: loadImage,
	  preloadImages: preloadImages,
	};
	
	function checkOverflow() {
	  var swiper = this;
	  var wasLocked = swiper.isLocked;
	
	  swiper.isLocked = swiper.snapGrid.length === 1;
	  swiper.allowTouchMove = !swiper.isLocked;
	
	  if (wasLocked && wasLocked !== swiper.isLocked) {
	    swiper.isEnd = false;
	    swiper.navigation.update();
	  }
	}
	
	var checkOverflow$1 = { checkOverflow: checkOverflow };
	
	var defaults = {
	  init: true,
	  direction: 'horizontal',
	  touchEventsTarget: 'container',
	  initialSlide: 0,
	  speed: 300,
	  //
	  preventIntercationOnTransition: false,
	
	  // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
	  iOSEdgeSwipeDetection: false,
	  iOSEdgeSwipeThreshold: 20,
	
	  // Free mode
	  freeMode: false,
	  freeModeMomentum: true,
	  freeModeMomentumRatio: 1,
	  freeModeMomentumBounce: true,
	  freeModeMomentumBounceRatio: 1,
	  freeModeMomentumVelocityRatio: 1,
	  freeModeSticky: false,
	  freeModeMinimumVelocity: 0.02,
	
	  // Autoheight
	  autoHeight: false,
	
	  // Set wrapper width
	  setWrapperSize: false,
	
	  // Virtual Translate
	  virtualTranslate: false,
	
	  // Effects
	  effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	
	  // Breakpoints
	  breakpoints: undefined,
	
	  // Slides grid
	  spaceBetween: 0,
	  slidesPerView: 1,
	  slidesPerColumn: 1,
	  slidesPerColumnFill: 'column',
	  slidesPerGroup: 1,
	  centeredSlides: false,
	  slidesOffsetBefore: 0, // in px
	  slidesOffsetAfter: 0, // in px
	  normalizeSlideIndex: true,
	
	  // Disable swiper and hide navigation when container not overflow
	  watchOverflow: false,
	
	  // Round length
	  roundLengths: false,
	
	  // Touches
	  touchRatio: 1,
	  touchAngle: 45,
	  simulateTouch: true,
	  shortSwipes: true,
	  longSwipes: true,
	  longSwipesRatio: 0.5,
	  longSwipesMs: 300,
	  followFinger: true,
	  allowTouchMove: true,
	  threshold: 0,
	  touchMoveStopPropagation: true,
	  touchReleaseOnEdges: false,
	
	  // Unique Navigation Elements
	  uniqueNavElements: true,
	
	  // Resistance
	  resistance: true,
	  resistanceRatio: 0.85,
	
	  // Progress
	  watchSlidesProgress: false,
	  watchSlidesVisibility: false,
	
	  // Cursor
	  grabCursor: false,
	
	  // Clicks
	  preventClicks: true,
	  preventClicksPropagation: true,
	  slideToClickedSlide: false,
	
	  // Images
	  preloadImages: true,
	  updateOnImagesReady: true,
	
	  // loop
	  loop: false,
	  loopAdditionalSlides: 0,
	  loopedSlides: null,
	  loopFillGroupWithBlank: false,
	
	  // Swiping/no swiping
	  allowSlidePrev: true,
	  allowSlideNext: true,
	  swipeHandler: null, // '.swipe-handler',
	  noSwiping: true,
	  noSwipingClass: 'swiper-no-swiping',
	  noSwipingSelector: null,
	
	  // Passive Listeners
	  passiveListeners: true,
	
	  // NS
	  containerModifierClass: 'swiper-container-', // NEW
	  slideClass: 'swiper-slide',
	  slideBlankClass: 'swiper-slide-invisible-blank',
	  slideActiveClass: 'swiper-slide-active',
	  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	  slideVisibleClass: 'swiper-slide-visible',
	  slideDuplicateClass: 'swiper-slide-duplicate',
	  slideNextClass: 'swiper-slide-next',
	  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	  slidePrevClass: 'swiper-slide-prev',
	  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	  wrapperClass: 'swiper-wrapper',
	
	  // Callbacks
	  runCallbacksOnInit: true,
	};
	
	var prototypes = {
	  update: update,
	  translate: translate,
	  transition: transition$1,
	  slide: slide,
	  loop: loop,
	  grabCursor: grabCursor,
	  manipulation: manipulation,
	  events: events,
	  breakpoints: breakpoints,
	  checkOverflow: checkOverflow$1,
	  classes: classes,
	  images: images,
	};
	
	var extendedDefaults = {};
	
	var Swiper = (function (SwiperClass$$1) {
	  function Swiper() {
	    var assign;
	
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	    var el;
	    var params;
	    if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
	      params = args[0];
	    } else {
	      (assign = args, el = assign[0], params = assign[1]);
	    }
	    if (!params) { params = {}; }
	
	    params = Utils.extend({}, params);
	    if (el && !params.el) { params.el = el; }
	
	    SwiperClass$$1.call(this, params);
	
	    Object.keys(prototypes).forEach(function (prototypeGroup) {
	      Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
	        if (!Swiper.prototype[protoMethod]) {
	          Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	        }
	      });
	    });
	
	    // Swiper Instance
	    var swiper = this;
	    if (typeof swiper.modules === 'undefined') {
	      swiper.modules = {};
	    }
	    Object.keys(swiper.modules).forEach(function (moduleName) {
	      var module = swiper.modules[moduleName];
	      if (module.params) {
	        var moduleParamName = Object.keys(module.params)[0];
	        var moduleParams = module.params[moduleParamName];
	        if (typeof moduleParams !== 'object') { return; }
	        if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
	        if (params[moduleParamName] === true) {
	          params[moduleParamName] = { enabled: true };
	        }
	        if (
	          typeof params[moduleParamName] === 'object' &&
	          !('enabled' in params[moduleParamName])
	        ) {
	          params[moduleParamName].enabled = true;
	        }
	        if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
	      }
	    });
	
	    // Extend defaults with modules params
	    var swiperParams = Utils.extend({}, defaults);
	    swiper.useModulesParams(swiperParams);
	
	    // Extend defaults with passed params
	    swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
	    swiper.originalParams = Utils.extend({}, swiper.params);
	    swiper.passedParams = Utils.extend({}, params);
	
	    // Save Dom lib
	    swiper.$ = $;
	
	    // Find el
	    var $el = $(swiper.params.el);
	    el = $el[0];
	
	    if (!el) {
	      return undefined;
	    }
	
	    if ($el.length > 1) {
	      var swipers = [];
	      $el.each(function (index, containerEl) {
	        var newParams = Utils.extend({}, params, { el: containerEl });
	        swipers.push(new Swiper(newParams));
	      });
	      return swipers;
	    }
	
	    el.swiper = swiper;
	    $el.data('swiper', swiper);
	
	    // Find Wrapper
	    var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));
	
	    // Extend Swiper
	    Utils.extend(swiper, {
	      $el: $el,
	      el: el,
	      $wrapperEl: $wrapperEl,
	      wrapperEl: $wrapperEl[0],
	
	      // Classes
	      classNames: [],
	
	      // Slides
	      slides: $(),
	      slidesGrid: [],
	      snapGrid: [],
	      slidesSizesGrid: [],
	
	      // isDirection
	      isHorizontal: function isHorizontal() {
	        return swiper.params.direction === 'horizontal';
	      },
	      isVertical: function isVertical() {
	        return swiper.params.direction === 'vertical';
	      },
	      // RTL
	      rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	      wrongRTL: $wrapperEl.css('display') === '-webkit-box',
	
	      // Indexes
	      activeIndex: 0,
	      realIndex: 0,
	
	      //
	      isBeginning: true,
	      isEnd: false,
	
	      // Props
	      translate: 0,
	      progress: 0,
	      velocity: 0,
	      animating: false,
	
	      // Locks
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,
	
	      // Touch Events
	      touchEvents: (function touchEvents() {
	        var touch = ['touchstart', 'touchmove', 'touchend'];
	        var desktop = ['mousedown', 'mousemove', 'mouseup'];
	        if (Support.pointerEvents) {
	          desktop = ['pointerdown', 'pointermove', 'pointerup'];
	        } else if (Support.prefixedPointerEvents) {
	          desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
	        }
	        swiper.touchEventsTouch = {
	          start: touch[0],
	          move: touch[1],
	          end: touch[2],
	        };
	        swiper.touchEventsDesktop = {
	          start: desktop[0],
	          move: desktop[1],
	          end: desktop[2],
	        };
	        return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
	      }()),
	      touchEventsData: {
	        isTouched: undefined,
	        isMoved: undefined,
	        allowTouchCallbacks: undefined,
	        touchStartTime: undefined,
	        isScrolling: undefined,
	        currentTranslate: undefined,
	        startTranslate: undefined,
	        allowThresholdMove: undefined,
	        // Form elements to match
	        formElements: 'input, select, option, textarea, button, video',
	        // Last click time
	        lastClickTime: Utils.now(),
	        clickTimeout: undefined,
	        // Velocities
	        velocities: [],
	        allowMomentumBounce: undefined,
	        isTouchEvent: undefined,
	        startMoving: undefined,
	      },
	
	      // Clicks
	      allowClick: true,
	
	      // Touches
	      allowTouchMove: swiper.params.allowTouchMove,
	
	      touches: {
	        startX: 0,
	        startY: 0,
	        currentX: 0,
	        currentY: 0,
	        diff: 0,
	      },
	
	      // Images
	      imagesToLoad: [],
	      imagesLoaded: 0,
	
	    });
	
	    // Install Modules
	    swiper.useModules();
	
	    // Init
	    if (swiper.params.init) {
	      swiper.init();
	    }
	
	    // Return app instance
	    return swiper;
	  }
	
	  if ( SwiperClass$$1 ) Swiper.__proto__ = SwiperClass$$1;
	  Swiper.prototype = Object.create( SwiperClass$$1 && SwiperClass$$1.prototype );
	  Swiper.prototype.constructor = Swiper;
	
	  var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };
	  Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
	    var swiper = this;
	    var params = swiper.params;
	    var slides = swiper.slides;
	    var slidesGrid = swiper.slidesGrid;
	    var swiperSize = swiper.size;
	    var activeIndex = swiper.activeIndex;
	    var spv = 1;
	    if (params.centeredSlides) {
	      var slideSize = slides[activeIndex].swiperSlideSize;
	      var breakLoop;
	      for (var i = activeIndex + 1; i < slides.length; i += 1) {
	        if (slides[i] && !breakLoop) {
	          slideSize += slides[i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) { breakLoop = true; }
	        }
	      }
	      for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
	        if (slides[i$1] && !breakLoop) {
	          slideSize += slides[i$1].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) { breakLoop = true; }
	        }
	      }
	    } else {
	      for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
	        if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
	          spv += 1;
	        }
	      }
	    }
	    return spv;
	  };
	  Swiper.prototype.update = function update$$1 () {
	    var swiper = this;
	    if (!swiper || swiper.destroyed) { return; }
	    swiper.updateSize();
	    swiper.updateSlides();
	    swiper.updateProgress();
	    swiper.updateSlidesClasses();
	
	    function setTranslate() {
	      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
	      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	      swiper.setTranslate(newTranslate);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	    var translated;
	    if (swiper.params.freeMode) {
	      setTranslate();
	      if (swiper.params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	    } else {
	      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	      } else {
	        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	      }
	      if (!translated) {
	        setTranslate();
	      }
	    }
	    swiper.emit('update');
	  };
	  Swiper.prototype.init = function init () {
	    var swiper = this;
	    if (swiper.initialized) { return; }
	
	    swiper.emit('beforeInit');
	
	    // Set breakpoint
	    if (swiper.params.breakpoints) {
	      swiper.setBreakpoint();
	    }
	
	    // Add Classes
	    swiper.addClasses();
	
	    // Create loop
	    if (swiper.params.loop) {
	      swiper.loopCreate();
	    }
	
	    // Update size
	    swiper.updateSize();
	
	    // Update slides
	    swiper.updateSlides();
	
	    if (swiper.params.watchOverflow) {
	      swiper.checkOverflow();
	    }
	
	    // Set Grab Cursor
	    if (swiper.params.grabCursor) {
	      swiper.setGrabCursor();
	    }
	
	    if (swiper.params.preloadImages) {
	      swiper.preloadImages();
	    }
	
	    // Slide To Initial Slide
	    if (swiper.params.loop) {
	      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
	    } else {
	      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
	    }
	
	    // Attach events
	    swiper.attachEvents();
	
	    // Init Flag
	    swiper.initialized = true;
	
	    // Emit
	    swiper.emit('init');
	  };
	  Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
	    if ( deleteInstance === void 0 ) deleteInstance = true;
	    if ( cleanStyles === void 0 ) cleanStyles = true;
	
	    var swiper = this;
	    var params = swiper.params;
	    var $el = swiper.$el;
	    var $wrapperEl = swiper.$wrapperEl;
	    var slides = swiper.slides;
	    swiper.emit('beforeDestroy');
	
	    // Init Flag
	    swiper.initialized = false;
	
	    // Detach events
	    swiper.detachEvents();
	
	    // Destroy loop
	    if (params.loop) {
	      swiper.loopDestroy();
	    }
	
	    // Cleanup styles
	    if (cleanStyles) {
	      swiper.removeClasses();
	      $el.removeAttr('style');
	      $wrapperEl.removeAttr('style');
	      if (slides && slides.length) {
	        slides
	          .removeClass([
	            params.slideVisibleClass,
	            params.slideActiveClass,
	            params.slideNextClass,
	            params.slidePrevClass ].join(' '))
	          .removeAttr('style')
	          .removeAttr('data-swiper-slide-index')
	          .removeAttr('data-swiper-column')
	          .removeAttr('data-swiper-row');
	      }
	    }
	
	    swiper.emit('destroy');
	
	    // Detach emitter events
	    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
	      swiper.off(eventName);
	    });
	
	    if (deleteInstance !== false) {
	      swiper.$el[0].swiper = null;
	      swiper.$el.data('swiper', null);
	      Utils.deleteProps(swiper);
	    }
	    swiper.destroyed = true;
	  };
	  Swiper.extendDefaults = function extendDefaults (newDefaults) {
	    Utils.extend(extendedDefaults, newDefaults);
	  };
	  staticAccessors.extendedDefaults.get = function () {
	    return extendedDefaults;
	  };
	  staticAccessors.defaults.get = function () {
	    return defaults;
	  };
	  staticAccessors.Class.get = function () {
	    return SwiperClass$$1;
	  };
	  staticAccessors.$.get = function () {
	    return $;
	  };
	
	  Object.defineProperties( Swiper, staticAccessors );
	
	  return Swiper;
	}(SwiperClass));
	
	var Device$1 = {
	  name: 'device',
	  proto: {
	    device: Device,
	  },
	  static: {
	    device: Device,
	  },
	};
	
	var Support$1 = {
	  name: 'support',
	  proto: {
	    support: Support,
	  },
	  static: {
	    support: Support,
	  },
	};
	
	var Browser$1 = {
	  name: 'browser',
	  proto: {
	    browser: Browser,
	  },
	  static: {
	    browser: Browser,
	  },
	};
	
	var Resize = {
	  name: 'resize',
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      resize: {
	        resizeHandler: function resizeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	          swiper.emit('beforeResize');
	          swiper.emit('resize');
	        },
	        orientationChangeHandler: function orientationChangeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	          swiper.emit('orientationchange');
	        },
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      // Emit resize
	      win.addEventListener('resize', swiper.resize.resizeHandler);
	
	      // Emit orientationchange
	      win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      win.removeEventListener('resize', swiper.resize.resizeHandler);
	      win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    },
	  },
	};
	
	var Observer = {
	  func: win.MutationObserver || win.WebkitMutationObserver,
	  attach: function attach(target, options) {
	    if ( options === void 0 ) options = {};
	
	    var swiper = this;
	
	    var ObserverFunc = Observer.func;
	    var observer = new ObserverFunc(function (mutations) {
	      mutations.forEach(function (mutation) {
	        swiper.emit('observerUpdate', mutation);
	      });
	    });
	
	    observer.observe(target, {
	      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	      childList: typeof options.childList === 'undefined' ? true : options.childList,
	      characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
	    });
	
	    swiper.observer.observers.push(observer);
	  },
	  init: function init() {
	    var swiper = this;
	    if (!Support.observer || !swiper.params.observer) { return; }
	    if (swiper.params.observeParents) {
	      var containerParents = swiper.$el.parents();
	      for (var i = 0; i < containerParents.length; i += 1) {
	        swiper.observer.attach(containerParents[i]);
	      }
	    }
	    // Observe container
	    swiper.observer.attach(swiper.$el[0], { childList: false });
	
	    // Observe wrapper
	    swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    swiper.observer.observers.forEach(function (observer) {
	      observer.disconnect();
	    });
	    swiper.observer.observers = [];
	  },
	};
	
	var Observer$1 = {
	  name: 'observer',
	  params: {
	    observer: false,
	    observeParents: false,
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      observer: {
	        init: Observer.init.bind(swiper),
	        attach: Observer.attach.bind(swiper),
	        destroy: Observer.destroy.bind(swiper),
	        observers: [],
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.observer.init();
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.observer.destroy();
	    },
	  },
	};
	
	var Virtual = {
	  update: function update(force) {
	    var swiper = this;
	    var ref = swiper.params;
	    var slidesPerView = ref.slidesPerView;
	    var slidesPerGroup = ref.slidesPerGroup;
	    var centeredSlides = ref.centeredSlides;
	    var ref$1 = swiper.virtual;
	    var previousFrom = ref$1.from;
	    var previousTo = ref$1.to;
	    var slides = ref$1.slides;
	    var previousSlidesGrid = ref$1.slidesGrid;
	    var renderSlide = ref$1.renderSlide;
	    var previousOffset = ref$1.offset;
	    swiper.updateActiveIndex();
	    var activeIndex = swiper.activeIndex || 0;
	
	    var offsetProp;
	    if (swiper.rtlTranslate) { offsetProp = 'right'; }
	    else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }
	
	    var slidesAfter;
	    var slidesBefore;
	    if (centeredSlides) {
	      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup;
	      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup;
	    } else {
	      slidesAfter = slidesPerView + (slidesPerGroup - 1);
	      slidesBefore = slidesPerGroup;
	    }
	    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
	    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
	    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
	
	    Utils.extend(swiper.virtual, {
	      from: from,
	      to: to,
	      offset: offset,
	      slidesGrid: swiper.slidesGrid,
	    });
	
	    function onRendered() {
	      swiper.updateSlides();
	      swiper.updateProgress();
	      swiper.updateSlidesClasses();
	      if (swiper.lazy && swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    }
	
	    if (previousFrom === from && previousTo === to && !force) {
	      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
	        swiper.slides.css(offsetProp, (offset + "px"));
	      }
	      swiper.updateProgress();
	      return;
	    }
	    if (swiper.params.virtual.renderExternal) {
	      swiper.params.virtual.renderExternal.call(swiper, {
	        offset: offset,
	        from: from,
	        to: to,
	        slides: (function getSlides() {
	          var slidesToRender = [];
	          for (var i = from; i <= to; i += 1) {
	            slidesToRender.push(slides[i]);
	          }
	          return slidesToRender;
	        }()),
	      });
	      onRendered();
	      return;
	    }
	    var prependIndexes = [];
	    var appendIndexes = [];
	    if (force) {
	      swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
	    } else {
	      for (var i = previousFrom; i <= previousTo; i += 1) {
	        if (i < from || i > to) {
	          swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
	        }
	      }
	    }
	    for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
	      if (i$1 >= from && i$1 <= to) {
	        if (typeof previousTo === 'undefined' || force) {
	          appendIndexes.push(i$1);
	        } else {
	          if (i$1 > previousTo) { appendIndexes.push(i$1); }
	          if (i$1 < previousFrom) { prependIndexes.push(i$1); }
	        }
	      }
	    }
	    appendIndexes.forEach(function (index) {
	      swiper.$wrapperEl.append(renderSlide(slides[index], index));
	    });
	    prependIndexes.sort(function (a, b) { return a < b; }).forEach(function (index) {
	      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
	    });
	    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
	    onRendered();
	  },
	  renderSlide: function renderSlide(slide, index) {
	    var swiper = this;
	    var params = swiper.params.virtual;
	    if (params.cache && swiper.virtual.cache[index]) {
	      return swiper.virtual.cache[index];
	    }
	    var $slideEl = params.renderSlide
	      ? $(params.renderSlide.call(swiper, slide, index))
	      : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
	    if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
	    if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
	    return $slideEl;
	  },
	  appendSlide: function appendSlide(slide) {
	    var swiper = this;
	    swiper.virtual.slides.push(slide);
	    swiper.virtual.update(true);
	  },
	  prependSlide: function prependSlide(slide) {
	    var swiper = this;
	    swiper.virtual.slides.unshift(slide);
	    if (swiper.params.virtual.cache) {
	      var cache = swiper.virtual.cache;
	      var newCache = {};
	      Object.keys(cache).forEach(function (cachedIndex) {
	        newCache[cachedIndex + 1] = cache[cachedIndex];
	      });
	      swiper.virtual.cache = newCache;
	    }
	    swiper.virtual.update(true);
	    swiper.slideNext(0);
	  },
	};
	
	var Virtual$1 = {
	  name: 'virtual',
	  params: {
	    virtual: {
	      enabled: false,
	      slides: [],
	      cache: true,
	      renderSlide: null,
	      renderExternal: null,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      virtual: {
	        update: Virtual.update.bind(swiper),
	        appendSlide: Virtual.appendSlide.bind(swiper),
	        prependSlide: Virtual.prependSlide.bind(swiper),
	        renderSlide: Virtual.renderSlide.bind(swiper),
	        slides: swiper.params.virtual.slides,
	        cache: {},
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (!swiper.params.virtual.enabled) { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
	      var overwriteParams = {
	        watchSlidesProgress: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);
	
	      swiper.virtual.update();
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (!swiper.params.virtual.enabled) { return; }
	      swiper.virtual.update();
	    },
	  },
	};
	
	var Keyboard = {
	  handle: function handle(event) {
	    var swiper = this;
	    var rtl = swiper.rtlTranslate;
	    var e = event;
	    if (e.originalEvent) { e = e.originalEvent; } // jquery fix
	    var kc = e.keyCode || e.charCode;
	    // Directions locks
	    if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40))) {
	      return false;
	    }
	    if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38))) {
	      return false;
	    }
	    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
	      return undefined;
	    }
	    if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
	      return undefined;
	    }
	    if (swiper.params.keyboard.onlyInViewport && (kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
	      var inView = false;
	      // Check that swiper should be inside of visible area of window
	      if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
	        return undefined;
	      }
	      var windowWidth = win.innerWidth;
	      var windowHeight = win.innerHeight;
	      var swiperOffset = swiper.$el.offset();
	      if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
	      var swiperCoord = [
	        [swiperOffset.left, swiperOffset.top],
	        [swiperOffset.left + swiper.width, swiperOffset.top],
	        [swiperOffset.left, swiperOffset.top + swiper.height],
	        [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
	      for (var i = 0; i < swiperCoord.length; i += 1) {
	        var point = swiperCoord[i];
	        if (
	          point[0] >= 0 && point[0] <= windowWidth &&
	          point[1] >= 0 && point[1] <= windowHeight
	        ) {
	          inView = true;
	        }
	      }
	      if (!inView) { return undefined; }
	    }
	    if (swiper.isHorizontal()) {
	      if (kc === 37 || kc === 39) {
	        if (e.preventDefault) { e.preventDefault(); }
	        else { e.returnValue = false; }
	      }
	      if ((kc === 39 && !rtl) || (kc === 37 && rtl)) { swiper.slideNext(); }
	      if ((kc === 37 && !rtl) || (kc === 39 && rtl)) { swiper.slidePrev(); }
	    } else {
	      if (kc === 38 || kc === 40) {
	        if (e.preventDefault) { e.preventDefault(); }
	        else { e.returnValue = false; }
	      }
	      if (kc === 40) { swiper.slideNext(); }
	      if (kc === 38) { swiper.slidePrev(); }
	    }
	    swiper.emit('keyPress', kc);
	    return undefined;
	  },
	  enable: function enable() {
	    var swiper = this;
	    if (swiper.keyboard.enabled) { return; }
	    $(doc).on('keydown', swiper.keyboard.handle);
	    swiper.keyboard.enabled = true;
	  },
	  disable: function disable() {
	    var swiper = this;
	    if (!swiper.keyboard.enabled) { return; }
	    $(doc).off('keydown', swiper.keyboard.handle);
	    swiper.keyboard.enabled = false;
	  },
	};
	
	var Keyboard$1 = {
	  name: 'keyboard',
	  params: {
	    keyboard: {
	      enabled: false,
	      onlyInViewport: true,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      keyboard: {
	        enabled: false,
	        enable: Keyboard.enable.bind(swiper),
	        disable: Keyboard.disable.bind(swiper),
	        handle: Keyboard.handle.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.keyboard.enabled) {
	        swiper.keyboard.enable();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.keyboard.enabled) {
	        swiper.keyboard.disable();
	      }
	    },
	  },
	};
	
	function isEventSupported() {
	  var eventName = 'onwheel';
	  var isSupported = eventName in doc;
	
	  if (!isSupported) {
	    var element = doc.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported &&
	    doc.implementation &&
	    doc.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    doc.implementation.hasFeature('', '') !== true
	  ) {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	var Mousewheel = {
	  lastScrollTime: Utils.now(),
	  event: (function getEvent() {
	    if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
	    return isEventSupported() ? 'wheel' : 'mousewheel';
	  }()),
	  normalize: function normalize(e) {
	    // Reasonable defaults
	    var PIXEL_STEP = 10;
	    var LINE_HEIGHT = 40;
	    var PAGE_HEIGHT = 800;
	
	    var sX = 0;
	    var sY = 0; // spinX, spinY
	    var pX = 0;
	    var pY = 0; // pixelX, pixelY
	
	    // Legacy
	    if ('detail' in e) {
	      sY = e.detail;
	    }
	    if ('wheelDelta' in e) {
	      sY = -e.wheelDelta / 120;
	    }
	    if ('wheelDeltaY' in e) {
	      sY = -e.wheelDeltaY / 120;
	    }
	    if ('wheelDeltaX' in e) {
	      sX = -e.wheelDeltaX / 120;
	    }
	
	    // side scrolling on FF with DOMMouseScroll
	    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
	      sX = sY;
	      sY = 0;
	    }
	
	    pX = sX * PIXEL_STEP;
	    pY = sY * PIXEL_STEP;
	
	    if ('deltaY' in e) {
	      pY = e.deltaY;
	    }
	    if ('deltaX' in e) {
	      pX = e.deltaX;
	    }
	
	    if ((pX || pY) && e.deltaMode) {
	      if (e.deltaMode === 1) { // delta in LINE units
	        pX *= LINE_HEIGHT;
	        pY *= LINE_HEIGHT;
	      } else { // delta in PAGE units
	        pX *= PAGE_HEIGHT;
	        pY *= PAGE_HEIGHT;
	      }
	    }
	
	    // Fall-back if spin cannot be determined
	    if (pX && !sX) {
	      sX = (pX < 1) ? -1 : 1;
	    }
	    if (pY && !sY) {
	      sY = (pY < 1) ? -1 : 1;
	    }
	
	    return {
	      spinX: sX,
	      spinY: sY,
	      pixelX: pX,
	      pixelY: pY,
	    };
	  },
	  handleMouseEnter: function handleMouseEnter() {
	    var swiper = this;
	    swiper.mouseEntered = true;
	  },
	  handleMouseLeave: function handleMouseLeave() {
	    var swiper = this;
	    swiper.mouseEntered = false;
	  },
	  handle: function handle(event) {
	    var e = event;
	    var swiper = this;
	    var params = swiper.params.mousewheel;
	
	    if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }
	
	    if (e.originalEvent) { e = e.originalEvent; } // jquery fix
	    var delta = 0;
	    var rtlFactor = swiper.rtlTranslate ? -1 : 1;
	
	    var data = Mousewheel.normalize(e);
	
	    if (params.forceToAxis) {
	      if (swiper.isHorizontal()) {
	        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
	        else { return true; }
	      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
	      else { return true; }
	    } else {
	      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
	    }
	
	    if (delta === 0) { return true; }
	
	    if (params.invert) { delta = -delta; }
	
	    if (!swiper.params.freeMode) {
	      if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
	        if (delta < 0) {
	          if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
	            swiper.slideNext();
	            swiper.emit('scroll', e);
	          } else if (params.releaseOnEdges) { return true; }
	        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
	          swiper.slidePrev();
	          swiper.emit('scroll', e);
	        } else if (params.releaseOnEdges) { return true; }
	      }
	      swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
	    } else {
	      // Freemode or scrollContainer:
	      var position = swiper.getTranslate() + (delta * params.sensitivity);
	      var wasBeginning = swiper.isBeginning;
	      var wasEnd = swiper.isEnd;
	
	      if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
	      if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }
	
	      swiper.setTransition(0);
	      swiper.setTranslate(position);
	      swiper.updateProgress();
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	
	      if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
	        swiper.updateSlidesClasses();
	      }
	
	      if (swiper.params.freeModeSticky) {
	        clearTimeout(swiper.mousewheel.timeout);
	        swiper.mousewheel.timeout = Utils.nextTick(function () {
	          swiper.slideToClosest();
	        }, 300);
	      }
	      // Emit event
	      swiper.emit('scroll', e);
	
	      // Stop autoplay
	      if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.stopAutoplay(); }
	      // Return page scroll on edge positions
	      if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
	    }
	
	    if (e.preventDefault) { e.preventDefault(); }
	    else { e.returnValue = false; }
	    return false;
	  },
	  enable: function enable() {
	    var swiper = this;
	    if (!Mousewheel.event) { return false; }
	    if (swiper.mousewheel.enabled) { return false; }
	    var target = swiper.$el;
	    if (swiper.params.mousewheel.eventsTarged !== 'container') {
	      target = $(swiper.params.mousewheel.eventsTarged);
	    }
	    target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
	    target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
	    target.on(Mousewheel.event, swiper.mousewheel.handle);
	    swiper.mousewheel.enabled = true;
	    return true;
	  },
	  disable: function disable() {
	    var swiper = this;
	    if (!Mousewheel.event) { return false; }
	    if (!swiper.mousewheel.enabled) { return false; }
	    var target = swiper.$el;
	    if (swiper.params.mousewheel.eventsTarged !== 'container') {
	      target = $(swiper.params.mousewheel.eventsTarged);
	    }
	    target.off(Mousewheel.event, swiper.mousewheel.handle);
	    swiper.mousewheel.enabled = false;
	    return true;
	  },
	};
	
	var Mousewheel$1 = {
	  name: 'mousewheel',
	  params: {
	    mousewheel: {
	      enabled: false,
	      releaseOnEdges: false,
	      invert: false,
	      forceToAxis: false,
	      sensitivity: 1,
	      eventsTarged: 'container',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      mousewheel: {
	        enabled: false,
	        enable: Mousewheel.enable.bind(swiper),
	        disable: Mousewheel.disable.bind(swiper),
	        handle: Mousewheel.handle.bind(swiper),
	        handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
	        handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
	        lastScrollTime: Utils.now(),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
	    },
	  },
	};
	
	var Navigation = {
	  update: function update() {
	    // Update Navigation Buttons
	    var swiper = this;
	    var params = swiper.params.navigation;
	
	    if (swiper.params.loop) { return; }
	    var ref = swiper.navigation;
	    var $nextEl = ref.$nextEl;
	    var $prevEl = ref.$prevEl;
	
	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        $prevEl.addClass(params.disabledClass);
	      } else {
	        $prevEl.removeClass(params.disabledClass);
	      }
	      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        $nextEl.addClass(params.disabledClass);
	      } else {
	        $nextEl.removeClass(params.disabledClass);
	      }
	      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.navigation;
	    if (!(params.nextEl || params.prevEl)) { return; }
	
	    var $nextEl;
	    var $prevEl;
	    if (params.nextEl) {
	      $nextEl = $(params.nextEl);
	      if (
	        swiper.params.uniqueNavElements &&
	        typeof params.nextEl === 'string' &&
	        $nextEl.length > 1 &&
	        swiper.$el.find(params.nextEl).length === 1
	      ) {
	        $nextEl = swiper.$el.find(params.nextEl);
	      }
	    }
	    if (params.prevEl) {
	      $prevEl = $(params.prevEl);
	      if (
	        swiper.params.uniqueNavElements &&
	        typeof params.prevEl === 'string' &&
	        $prevEl.length > 1 &&
	        swiper.$el.find(params.prevEl).length === 1
	      ) {
	        $prevEl = swiper.$el.find(params.prevEl);
	      }
	    }
	
	    if ($nextEl && $nextEl.length > 0) {
	      $nextEl.on('click', function (e) {
	        e.preventDefault();
	        if (swiper.isEnd && !swiper.params.loop) { return; }
	        swiper.slideNext();
	      });
	    }
	    if ($prevEl && $prevEl.length > 0) {
	      $prevEl.on('click', function (e) {
	        e.preventDefault();
	        if (swiper.isBeginning && !swiper.params.loop) { return; }
	        swiper.slidePrev();
	      });
	    }
	
	    Utils.extend(swiper.navigation, {
	      $nextEl: $nextEl,
	      nextEl: $nextEl && $nextEl[0],
	      $prevEl: $prevEl,
	      prevEl: $prevEl && $prevEl[0],
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var ref = swiper.navigation;
	    var $nextEl = ref.$nextEl;
	    var $prevEl = ref.$prevEl;
	    if ($nextEl && $nextEl.length) {
	      $nextEl.off('click');
	      $nextEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	    if ($prevEl && $prevEl.length) {
	      $prevEl.off('click');
	      $prevEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	  },
	};
	
	var Navigation$1 = {
	  name: 'navigation',
	  params: {
	    navigation: {
	      nextEl: null,
	      prevEl: null,
	
	      hideOnClick: false,
	      disabledClass: 'swiper-button-disabled',
	      hiddenClass: 'swiper-button-hidden',
	      lockClass: 'swiper-button-lock',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      navigation: {
	        init: Navigation.init.bind(swiper),
	        update: Navigation.update.bind(swiper),
	        destroy: Navigation.destroy.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.navigation.init();
	      swiper.navigation.update();
	    },
	    toEdge: function toEdge() {
	      var swiper = this;
	      swiper.navigation.update();
	    },
	    fromEdge: function fromEdge() {
	      var swiper = this;
	      swiper.navigation.update();
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.navigation.destroy();
	    },
	    click: function click(e) {
	      var swiper = this;
	      var ref = swiper.navigation;
	      var $nextEl = ref.$nextEl;
	      var $prevEl = ref.$prevEl;
	      if (
	        swiper.params.navigation.hideOnClick &&
	        !$(e.target).is($prevEl) &&
	        !$(e.target).is($nextEl)
	      ) {
	        if ($nextEl) { $nextEl.toggleClass(swiper.params.navigation.hiddenClass); }
	        if ($prevEl) { $prevEl.toggleClass(swiper.params.navigation.hiddenClass); }
	      }
	    },
	  },
	};
	
	var Pagination = {
	  update: function update() {
	    // Render || Update Pagination bullets/items
	    var swiper = this;
	    var rtl = swiper.rtl;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    var $el = swiper.pagination.$el;
	    // Current/Total
	    var current;
	    var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	    if (swiper.params.loop) {
	      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
	      if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
	        current -= (slidesLength - (swiper.loopedSlides * 2));
	      }
	      if (current > total - 1) { current -= total; }
	      if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
	    } else if (typeof swiper.snapIndex !== 'undefined') {
	      current = swiper.snapIndex;
	    } else {
	      current = swiper.activeIndex || 0;
	    }
	    // Types
	    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	      var bullets = swiper.pagination.bullets;
	      var firstIndex;
	      var lastIndex;
	      var midIndex;
	      if (params.dynamicBullets) {
	        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
	        $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
	        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
	          swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
	          if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
	            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
	          } else if (swiper.pagination.dynamicBulletIndex < 0) {
	            swiper.pagination.dynamicBulletIndex = 0;
	          }
	        }
	        firstIndex = current - swiper.pagination.dynamicBulletIndex;
	        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
	        midIndex = (lastIndex + firstIndex) / 2;
	      }
	      bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
	      if ($el.length > 1) {
	        bullets.each(function (index, bullet) {
	          var $bullet = $(bullet);
	          var bulletIndex = $bullet.index();
	          if (bulletIndex === current) {
	            $bullet.addClass(params.bulletActiveClass);
	          }
	          if (params.dynamicBullets) {
	            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
	              $bullet.addClass(((params.bulletActiveClass) + "-main"));
	            }
	            if (bulletIndex === firstIndex) {
	              $bullet
	                .prev()
	                .addClass(((params.bulletActiveClass) + "-prev"))
	                .prev()
	                .addClass(((params.bulletActiveClass) + "-prev-prev"));
	            }
	            if (bulletIndex === lastIndex) {
	              $bullet
	                .next()
	                .addClass(((params.bulletActiveClass) + "-next"))
	                .next()
	                .addClass(((params.bulletActiveClass) + "-next-next"));
	            }
	          }
	        });
	      } else {
	        var $bullet = bullets.eq(current);
	        $bullet.addClass(params.bulletActiveClass);
	        if (params.dynamicBullets) {
	          var $firstDisplayedBullet = bullets.eq(firstIndex);
	          var $lastDisplayedBullet = bullets.eq(lastIndex);
	          for (var i = firstIndex; i <= lastIndex; i += 1) {
	            bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
	          }
	          $firstDisplayedBullet
	            .prev()
	            .addClass(((params.bulletActiveClass) + "-prev"))
	            .prev()
	            .addClass(((params.bulletActiveClass) + "-prev-prev"));
	          $lastDisplayedBullet
	            .next()
	            .addClass(((params.bulletActiveClass) + "-next"))
	            .next()
	            .addClass(((params.bulletActiveClass) + "-next-next"));
	        }
	      }
	      if (params.dynamicBullets) {
	        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
	        var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
	        var offsetProp = rtl ? 'right' : 'left';
	        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
	      }
	    }
	    if (params.type === 'fraction') {
	      $el.find(("." + (params.currentClass))).text(current + 1);
	      $el.find(("." + (params.totalClass))).text(total);
	    }
	    if (params.type === 'progressbar') {
	      var scale = (current + 1) / total;
	      var scaleX = scale;
	      var scaleY = 1;
	      if (!swiper.isHorizontal()) {
	        scaleY = scale;
	        scaleX = 1;
	      }
	      $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
	    }
	    if (params.type === 'custom' && params.renderCustom) {
	      $el.html(params.renderCustom(swiper, current + 1, total));
	      swiper.emit('paginationRender', swiper, $el[0]);
	    } else {
	      swiper.emit('paginationUpdate', swiper, $el[0]);
	    }
	    $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	  },
	  render: function render() {
	    // Render Container
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	
	    var $el = swiper.pagination.$el;
	    var paginationHTML = '';
	    if (params.type === 'bullets') {
	      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	      for (var i = 0; i < numberOfBullets; i += 1) {
	        if (params.renderBullet) {
	          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	        } else {
	          paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
	        }
	      }
	      $el.html(paginationHTML);
	      swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
	    }
	    if (params.type === 'fraction') {
	      if (params.renderFraction) {
	        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	      } else {
	        paginationHTML =
	        "<span class=\"" + (params.currentClass) + "\"></span>" +
	        ' / ' +
	        "<span class=\"" + (params.totalClass) + "\"></span>";
	      }
	      $el.html(paginationHTML);
	    }
	    if (params.type === 'progressbar') {
	      if (params.renderProgressbar) {
	        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	      } else {
	        paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
	      }
	      $el.html(paginationHTML);
	    }
	    if (params.type !== 'custom') {
	      swiper.emit('paginationRender', swiper.pagination.$el[0]);
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el) { return; }
	
	    var $el = $(params.el);
	    if ($el.length === 0) { return; }
	
	    if (
	      swiper.params.uniqueNavElements &&
	      typeof params.el === 'string' &&
	      $el.length > 1 &&
	      swiper.$el.find(params.el).length === 1
	    ) {
	      $el = swiper.$el.find(params.el);
	    }
	
	    if (params.type === 'bullets' && params.clickable) {
	      $el.addClass(params.clickableClass);
	    }
	
	    $el.addClass(params.modifierClass + params.type);
	
	    if (params.type === 'bullets' && params.dynamicBullets) {
	      $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
	      swiper.pagination.dynamicBulletIndex = 0;
	      if (params.dynamicMainBullets < 1) {
	        params.dynamicMainBullets = 1;
	      }
	    }
	
	    if (params.clickable) {
	      $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
	        e.preventDefault();
	        var index = $(this).index() * swiper.params.slidesPerGroup;
	        if (swiper.params.loop) { index += swiper.loopedSlides; }
	        swiper.slideTo(index);
	      });
	    }
	
	    Utils.extend(swiper.pagination, {
	      $el: $el,
	      el: $el[0],
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	    var $el = swiper.pagination.$el;
	
	    $el.removeClass(params.hiddenClass);
	    $el.removeClass(params.modifierClass + params.type);
	    if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
	    if (params.clickable) {
	      $el.off('click', ("." + (params.bulletClass)));
	    }
	  },
	};
	
	var Pagination$1 = {
	  name: 'pagination',
	  params: {
	    pagination: {
	      el: null,
	      bulletElement: 'span',
	      clickable: false,
	      hideOnClick: false,
	      renderBullet: null,
	      renderProgressbar: null,
	      renderFraction: null,
	      renderCustom: null,
	      type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	      dynamicBullets: false,
	      dynamicMainBullets: 1,
	      bulletClass: 'swiper-pagination-bullet',
	      bulletActiveClass: 'swiper-pagination-bullet-active',
	      modifierClass: 'swiper-pagination-', // NEW
	      currentClass: 'swiper-pagination-current',
	      totalClass: 'swiper-pagination-total',
	      hiddenClass: 'swiper-pagination-hidden',
	      progressbarFillClass: 'swiper-pagination-progressbar-fill',
	      clickableClass: 'swiper-pagination-clickable', // NEW
	      lockClass: 'swiper-pagination-lock',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      pagination: {
	        init: Pagination.init.bind(swiper),
	        render: Pagination.render.bind(swiper),
	        update: Pagination.update.bind(swiper),
	        destroy: Pagination.destroy.bind(swiper),
	        dynamicBulletIndex: 0,
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.pagination.init();
	      swiper.pagination.render();
	      swiper.pagination.update();
	    },
	    activeIndexChange: function activeIndexChange() {
	      var swiper = this;
	      if (swiper.params.loop) {
	        swiper.pagination.update();
	      } else if (typeof swiper.snapIndex === 'undefined') {
	        swiper.pagination.update();
	      }
	    },
	    snapIndexChange: function snapIndexChange() {
	      var swiper = this;
	      if (!swiper.params.loop) {
	        swiper.pagination.update();
	      }
	    },
	    slidesLengthChange: function slidesLengthChange() {
	      var swiper = this;
	      if (swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    snapGridLengthChange: function snapGridLengthChange() {
	      var swiper = this;
	      if (!swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.pagination.destroy();
	    },
	    click: function click(e) {
	      var swiper = this;
	      if (
	        swiper.params.pagination.el &&
	        swiper.params.pagination.hideOnClick &&
	        swiper.pagination.$el.length > 0 &&
	        !$(e.target).hasClass(swiper.params.pagination.bulletClass)
	      ) {
	        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
	      }
	    },
	  },
	};
	
	var Scrollbar = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var rtl = swiper.rtlTranslate;
	    var progress = swiper.progress;
	    var dragSize = scrollbar.dragSize;
	    var trackSize = scrollbar.trackSize;
	    var $dragEl = scrollbar.$dragEl;
	    var $el = scrollbar.$el;
	    var params = swiper.params.scrollbar;
	
	    var newSize = dragSize;
	    var newPos = (trackSize - dragSize) * progress;
	    if (rtl) {
	      newPos = -newPos;
	      if (newPos > 0) {
	        newSize = dragSize - newPos;
	        newPos = 0;
	      } else if (-newPos + dragSize > trackSize) {
	        newSize = trackSize + newPos;
	      }
	    } else if (newPos < 0) {
	      newSize = dragSize + newPos;
	      newPos = 0;
	    } else if (newPos + dragSize > trackSize) {
	      newSize = trackSize - newPos;
	    }
	    if (swiper.isHorizontal()) {
	      if (Support.transforms3d) {
	        $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
	      } else {
	        $dragEl.transform(("translateX(" + newPos + "px)"));
	      }
	      $dragEl[0].style.width = newSize + "px";
	    } else {
	      if (Support.transforms3d) {
	        $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
	      } else {
	        $dragEl.transform(("translateY(" + newPos + "px)"));
	      }
	      $dragEl[0].style.height = newSize + "px";
	    }
	    if (params.hide) {
	      clearTimeout(swiper.scrollbar.timeout);
	      $el[0].style.opacity = 1;
	      swiper.scrollbar.timeout = setTimeout(function () {
	        $el[0].style.opacity = 0;
	        $el.transition(400);
	      }, 1000);
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	    swiper.scrollbar.$dragEl.transition(duration);
	  },
	  updateSize: function updateSize() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	
	    var scrollbar = swiper.scrollbar;
	    var $dragEl = scrollbar.$dragEl;
	    var $el = scrollbar.$el;
	
	    $dragEl[0].style.width = '';
	    $dragEl[0].style.height = '';
	    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
	
	    var divider = swiper.size / swiper.virtualSize;
	    var moveDivider = divider * (trackSize / swiper.size);
	    var dragSize;
	    if (swiper.params.scrollbar.dragSize === 'auto') {
	      dragSize = trackSize * divider;
	    } else {
	      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
	    }
	
	    if (swiper.isHorizontal()) {
	      $dragEl[0].style.width = dragSize + "px";
	    } else {
	      $dragEl[0].style.height = dragSize + "px";
	    }
	
	    if (divider >= 1) {
	      $el[0].style.display = 'none';
	    } else {
	      $el[0].style.display = '';
	    }
	    if (swiper.params.scrollbarHide) {
	      $el[0].style.opacity = 0;
	    }
	    Utils.extend(scrollbar, {
	      trackSize: trackSize,
	      divider: divider,
	      moveDivider: moveDivider,
	      dragSize: dragSize,
	    });
	    scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
	  },
	  setDragPosition: function setDragPosition(e) {
	    var swiper = this;
	    var scrollbar = swiper.scrollbar;
	    var rtl = swiper.rtlTranslate;
	    var $el = scrollbar.$el;
	    var dragSize = scrollbar.dragSize;
	    var trackSize = scrollbar.trackSize;
	
	    var pointerPosition;
	    if (swiper.isHorizontal()) {
	      pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
	    } else {
	      pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
	    }
	    var positionRatio;
	    positionRatio = ((pointerPosition) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragSize / 2)) / (trackSize - dragSize);
	    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
	    if (rtl) {
	      positionRatio = 1 - positionRatio;
	    }
	
	    var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);
	
	    swiper.updateProgress(position);
	    swiper.setTranslate(position);
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  },
	  onDragStart: function onDragStart(e) {
	    var swiper = this;
	    var params = swiper.params.scrollbar;
	    var scrollbar = swiper.scrollbar;
	    var $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el;
	    var $dragEl = scrollbar.$dragEl;
	    swiper.scrollbar.isTouched = true;
	    e.preventDefault();
	    e.stopPropagation();
	
	    $wrapperEl.transition(100);
	    $dragEl.transition(100);
	    scrollbar.setDragPosition(e);
	
	    clearTimeout(swiper.scrollbar.dragTimeout);
	
	    $el.transition(0);
	    if (params.hide) {
	      $el.css('opacity', 1);
	    }
	    swiper.emit('scrollbarDragStart', e);
	  },
	  onDragMove: function onDragMove(e) {
	    var swiper = this;
	    var scrollbar = swiper.scrollbar;
	    var $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el;
	    var $dragEl = scrollbar.$dragEl;
	
	    if (!swiper.scrollbar.isTouched) { return; }
	    if (e.preventDefault) { e.preventDefault(); }
	    else { e.returnValue = false; }
	    scrollbar.setDragPosition(e);
	    $wrapperEl.transition(0);
	    $el.transition(0);
	    $dragEl.transition(0);
	    swiper.emit('scrollbarDragMove', e);
	  },
	  onDragEnd: function onDragEnd(e) {
	    var swiper = this;
	
	    var params = swiper.params.scrollbar;
	    var scrollbar = swiper.scrollbar;
	    var $el = scrollbar.$el;
	
	    if (!swiper.scrollbar.isTouched) { return; }
	    swiper.scrollbar.isTouched = false;
	    if (params.hide) {
	      clearTimeout(swiper.scrollbar.dragTimeout);
	      swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
	        $el.css('opacity', 0);
	        $el.transition(400);
	      }, 1000);
	    }
	    swiper.emit('scrollbarDragEnd', e);
	    if (params.snapOnRelease) {
	      swiper.slideToClosest();
	    }
	  },
	  enableDraggable: function enableDraggable() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var touchEvents = swiper.touchEvents;
	    var touchEventsDesktop = swiper.touchEventsDesktop;
	    var params = swiper.params;
	    var $el = scrollbar.$el;
	    var target = $el[0];
	    var activeListener = Support.passiveListener && params.passiveListener ? { passive: false, capture: false } : false;
	    var passiveListener = Support.passiveListener && params.passiveListener ? { passive: true, capture: false } : false;
	    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	      doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	      doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	    } else {
	      if (Support.touch) {
	        target.addEventListener(touchEvents.start, swiper.scrollbar.onDragStart, activeListener);
	        target.addEventListener(touchEvents.move, swiper.scrollbar.onDragMove, activeListener);
	        target.addEventListener(touchEvents.end, swiper.scrollbar.onDragEnd, passiveListener);
	      }
	      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	        target.addEventListener('mousedown', swiper.scrollbar.onDragStart, activeListener);
	        doc.addEventListener('mousemove', swiper.scrollbar.onDragMove, activeListener);
	        doc.addEventListener('mouseup', swiper.scrollbar.onDragEnd, passiveListener);
	      }
	    }
	  },
	  disableDraggable: function disableDraggable() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var touchEvents = swiper.touchEvents;
	    var touchEventsDesktop = swiper.touchEventsDesktop;
	    var params = swiper.params;
	    var $el = scrollbar.$el;
	    var target = $el[0];
	    var activeListener = Support.passiveListener && params.passiveListener ? { passive: false, capture: false } : false;
	    var passiveListener = Support.passiveListener && params.passiveListener ? { passive: true, capture: false } : false;
	    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	      doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	      doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	    } else {
	      if (Support.touch) {
	        target.removeEventListener(touchEvents.start, swiper.scrollbar.onDragStart, activeListener);
	        target.removeEventListener(touchEvents.move, swiper.scrollbar.onDragMove, activeListener);
	        target.removeEventListener(touchEvents.end, swiper.scrollbar.onDragEnd, passiveListener);
	      }
	      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	        target.removeEventListener('mousedown', swiper.scrollbar.onDragStart, activeListener);
	        doc.removeEventListener('mousemove', swiper.scrollbar.onDragMove, activeListener);
	        doc.removeEventListener('mouseup', swiper.scrollbar.onDragEnd, passiveListener);
	      }
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var $swiperEl = swiper.$el;
	    var params = swiper.params.scrollbar;
	
	    var $el = $(params.el);
	    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
	      $el = $swiperEl.find(params.el);
	    }
	
	    var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
	    if ($dragEl.length === 0) {
	      $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
	      $el.append($dragEl);
	    }
	
	    Utils.extend(scrollbar, {
	      $el: $el,
	      el: $el[0],
	      $dragEl: $dragEl,
	      dragEl: $dragEl[0],
	    });
	
	    if (params.draggable) {
	      scrollbar.enableDraggable();
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    swiper.scrollbar.disableDraggable();
	  },
	};
	
	var Scrollbar$1 = {
	  name: 'scrollbar',
	  params: {
	    scrollbar: {
	      el: null,
	      dragSize: 'auto',
	      hide: false,
	      draggable: false,
	      snapOnRelease: true,
	      lockClass: 'swiper-scrollbar-lock',
	      dragClass: 'swiper-scrollbar-drag',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      scrollbar: {
	        init: Scrollbar.init.bind(swiper),
	        destroy: Scrollbar.destroy.bind(swiper),
	        updateSize: Scrollbar.updateSize.bind(swiper),
	        setTranslate: Scrollbar.setTranslate.bind(swiper),
	        setTransition: Scrollbar.setTransition.bind(swiper),
	        enableDraggable: Scrollbar.enableDraggable.bind(swiper),
	        disableDraggable: Scrollbar.disableDraggable.bind(swiper),
	        setDragPosition: Scrollbar.setDragPosition.bind(swiper),
	        onDragStart: Scrollbar.onDragStart.bind(swiper),
	        onDragMove: Scrollbar.onDragMove.bind(swiper),
	        onDragEnd: Scrollbar.onDragEnd.bind(swiper),
	        isTouched: false,
	        timeout: null,
	        dragTimeout: null,
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.scrollbar.init();
	      swiper.scrollbar.updateSize();
	      swiper.scrollbar.setTranslate();
	    },
	    update: function update() {
	      var swiper = this;
	      swiper.scrollbar.updateSize();
	    },
	    resize: function resize() {
	      var swiper = this;
	      swiper.scrollbar.updateSize();
	    },
	    observerUpdate: function observerUpdate() {
	      var swiper = this;
	      swiper.scrollbar.updateSize();
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      swiper.scrollbar.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      swiper.scrollbar.setTransition(duration);
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.scrollbar.destroy();
	    },
	  },
	};
	
	var Parallax = {
	  setTransform: function setTransform(el, progress) {
	    var swiper = this;
	    var rtl = swiper.rtl;
	
	    var $el = $(el);
	    var rtlFactor = rtl ? -1 : 1;
	
	    var p = $el.attr('data-swiper-parallax') || '0';
	    var x = $el.attr('data-swiper-parallax-x');
	    var y = $el.attr('data-swiper-parallax-y');
	    var scale = $el.attr('data-swiper-parallax-scale');
	    var opacity = $el.attr('data-swiper-parallax-opacity');
	
	    if (x || y) {
	      x = x || '0';
	      y = y || '0';
	    } else if (swiper.isHorizontal()) {
	      x = p;
	      y = '0';
	    } else {
	      y = p;
	      x = '0';
	    }
	
	    if ((x).indexOf('%') >= 0) {
	      x = (parseInt(x, 10) * progress * rtlFactor) + "%";
	    } else {
	      x = (x * progress * rtlFactor) + "px";
	    }
	    if ((y).indexOf('%') >= 0) {
	      y = (parseInt(y, 10) * progress) + "%";
	    } else {
	      y = (y * progress) + "px";
	    }
	
	    if (typeof opacity !== 'undefined' && opacity !== null) {
	      var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
	      $el[0].style.opacity = currentOpacity;
	    }
	    if (typeof scale === 'undefined' || scale === null) {
	      $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
	    } else {
	      var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
	      $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
	    }
	  },
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var $el = swiper.$el;
	    var slides = swiper.slides;
	    var progress = swiper.progress;
	    var snapGrid = swiper.snapGrid;
	    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	      .each(function (index, el) {
	        swiper.parallax.setTransform(el, progress);
	      });
	    slides.each(function (slideIndex, slideEl) {
	      var slideProgress = slideEl.progress;
	      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
	        slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
	      }
	      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
	      $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	        .each(function (index, el) {
	          swiper.parallax.setTransform(el, slideProgress);
	        });
	    });
	  },
	  setTransition: function setTransition(duration) {
	    if ( duration === void 0 ) duration = this.params.speed;
	
	    var swiper = this;
	    var $el = swiper.$el;
	    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	      .each(function (index, parallaxEl) {
	        var $parallaxEl = $(parallaxEl);
	        var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
	        if (duration === 0) { parallaxDuration = 0; }
	        $parallaxEl.transition(parallaxDuration);
	      });
	  },
	};
	
	var Parallax$1 = {
	  name: 'parallax',
	  params: {
	    parallax: {
	      enabled: false,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      parallax: {
	        setTransform: Parallax.setTransform.bind(swiper),
	        setTranslate: Parallax.setTranslate.bind(swiper),
	        setTransition: Parallax.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (!swiper.params.parallax.enabled) { return; }
	      swiper.params.watchSlidesProgress = true;
	    },
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.parallax) { return; }
	      swiper.parallax.setTranslate();
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (!swiper.params.parallax) { return; }
	      swiper.parallax.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (!swiper.params.parallax) { return; }
	      swiper.parallax.setTransition(duration);
	    },
	  },
	};
	
	var Zoom = {
	  // Calc Scale From Multi-touches
	  getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
	    if (e.targetTouches.length < 2) { return 1; }
	    var x1 = e.targetTouches[0].pageX;
	    var y1 = e.targetTouches[0].pageY;
	    var x2 = e.targetTouches[1].pageX;
	    var y2 = e.targetTouches[1].pageY;
	    var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
	    return distance;
	  },
	  // Events
	  onGestureStart: function onGestureStart(e) {
	    var swiper = this;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    zoom.fakeGestureTouched = false;
	    zoom.fakeGestureMoved = false;
	    if (!Support.gestures) {
	      if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
	        return;
	      }
	      zoom.fakeGestureTouched = true;
	      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
	    }
	    if (!gesture.$slideEl || !gesture.$slideEl.length) {
	      gesture.$slideEl = $(e.target).closest('.swiper-slide');
	      if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	      if (gesture.$imageWrapEl.length === 0) {
	        gesture.$imageEl = undefined;
	        return;
	      }
	    }
	    gesture.$imageEl.transition(0);
	    swiper.zoom.isScaling = true;
	  },
	  onGestureChange: function onGestureChange(e) {
	    var swiper = this;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    if (!Support.gestures) {
	      if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
	        return;
	      }
	      zoom.fakeGestureMoved = true;
	      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    if (Support.gestures) {
	      swiper.zoom.scale = e.scale * zoom.currentScale;
	    } else {
	      zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
	    }
	    if (zoom.scale > gesture.maxRatio) {
	      zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
	    }
	    if (zoom.scale < params.minRatio) {
	      zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
	    }
	    gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	  },
	  onGestureEnd: function onGestureEnd(e) {
	    var swiper = this;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    if (!Support.gestures) {
	      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
	        return;
	      }
	      if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
	        return;
	      }
	      zoom.fakeGestureTouched = false;
	      zoom.fakeGestureMoved = false;
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
	    gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	    zoom.currentScale = zoom.scale;
	    zoom.isScaling = false;
	    if (zoom.scale === 1) { gesture.$slideEl = undefined; }
	  },
	  onTouchStart: function onTouchStart(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    if (image.isTouched) { return; }
	    if (Device.android) { e.preventDefault(); }
	    image.isTouched = true;
	    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  },
	  onTouchMove: function onTouchMove(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;
	    var velocity = zoom.velocity;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    swiper.allowClick = false;
	    if (!image.isTouched || !gesture.$slideEl) { return; }
	
	    if (!image.isMoved) {
	      image.width = gesture.$imageEl[0].offsetWidth;
	      image.height = gesture.$imageEl[0].offsetHeight;
	      image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
	      image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
	      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
	      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
	      gesture.$imageWrapEl.transition(0);
	      if (swiper.rtl) {
	        image.startX = -image.startX;
	        image.startY = -image.startY;
	      }
	    }
	    // Define if we need image drag
	    var scaledWidth = image.width * zoom.scale;
	    var scaledHeight = image.height * zoom.scale;
	
	    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }
	
	    image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	    image.maxX = -image.minX;
	    image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	    image.maxY = -image.minY;
	
	    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	
	    if (!image.isMoved && !zoom.isScaling) {
	      if (
	        swiper.isHorizontal() &&
	        (
	          (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x) ||
	          (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
	        )
	      ) {
	        image.isTouched = false;
	        return;
	      } else if (
	        !swiper.isHorizontal() &&
	        (
	          (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y) ||
	          (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
	        )
	      ) {
	        image.isTouched = false;
	        return;
	      }
	    }
	    e.preventDefault();
	    e.stopPropagation();
	
	    image.isMoved = true;
	    image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
	    image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;
	
	    if (image.currentX < image.minX) {
	      image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
	    }
	    if (image.currentX > image.maxX) {
	      image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
	    }
	
	    if (image.currentY < image.minY) {
	      image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
	    }
	    if (image.currentY > image.maxY) {
	      image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
	    }
	
	    // Velocity
	    if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
	    if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
	    if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
	    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
	    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
	    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
	    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
	    velocity.prevPositionX = image.touchesCurrent.x;
	    velocity.prevPositionY = image.touchesCurrent.y;
	    velocity.prevTime = Date.now();
	
	    gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	  },
	  onTouchEnd: function onTouchEnd() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;
	    var velocity = zoom.velocity;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    if (!image.isTouched || !image.isMoved) {
	      image.isTouched = false;
	      image.isMoved = false;
	      return;
	    }
	    image.isTouched = false;
	    image.isMoved = false;
	    var momentumDurationX = 300;
	    var momentumDurationY = 300;
	    var momentumDistanceX = velocity.x * momentumDurationX;
	    var newPositionX = image.currentX + momentumDistanceX;
	    var momentumDistanceY = velocity.y * momentumDurationY;
	    var newPositionY = image.currentY + momentumDistanceY;
	
	    // Fix duration
	    if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
	    if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
	    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
	
	    image.currentX = newPositionX;
	    image.currentY = newPositionY;
	
	    // Define if we need image drag
	    var scaledWidth = image.width * zoom.scale;
	    var scaledHeight = image.height * zoom.scale;
	    image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	    image.maxX = -image.minX;
	    image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	    image.maxY = -image.minY;
	    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
	    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
	
	    gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	  },
	  onTransitionEnd: function onTransitionEnd() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
	      gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
	      gesture.$imageWrapEl.transform('translate3d(0,0,0)');
	      gesture.$slideEl = undefined;
	      gesture.$imageEl = undefined;
	      gesture.$imageWrapEl = undefined;
	
	      zoom.scale = 1;
	      zoom.currentScale = 1;
	    }
	  },
	  // Toggle Zoom
	  toggle: function toggle(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	
	    if (zoom.scale && zoom.scale !== 1) {
	      // Zoom Out
	      zoom.out();
	    } else {
	      // Zoom In
	      zoom.in(e);
	    }
	  },
	  in: function in$1(e) {
	    var swiper = this;
	
	    var zoom = swiper.zoom;
	    var params = swiper.params.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;
	
	    if (!gesture.$slideEl) {
	      gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	
	    gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));
	
	    var touchX;
	    var touchY;
	    var offsetX;
	    var offsetY;
	    var diffX;
	    var diffY;
	    var translateX;
	    var translateY;
	    var imageWidth;
	    var imageHeight;
	    var scaledWidth;
	    var scaledHeight;
	    var translateMinX;
	    var translateMinY;
	    var translateMaxX;
	    var translateMaxY;
	    var slideWidth;
	    var slideHeight;
	
	    if (typeof image.touchesStart.x === 'undefined' && e) {
	      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	    } else {
	      touchX = image.touchesStart.x;
	      touchY = image.touchesStart.y;
	    }
	
	    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	    if (e) {
	      slideWidth = gesture.$slideEl[0].offsetWidth;
	      slideHeight = gesture.$slideEl[0].offsetHeight;
	      offsetX = gesture.$slideEl.offset().left;
	      offsetY = gesture.$slideEl.offset().top;
	      diffX = (offsetX + (slideWidth / 2)) - touchX;
	      diffY = (offsetY + (slideHeight / 2)) - touchY;
	
	      imageWidth = gesture.$imageEl[0].offsetWidth;
	      imageHeight = gesture.$imageEl[0].offsetHeight;
	      scaledWidth = imageWidth * zoom.scale;
	      scaledHeight = imageHeight * zoom.scale;
	
	      translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
	      translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
	      translateMaxX = -translateMinX;
	      translateMaxY = -translateMinY;
	
	      translateX = diffX * zoom.scale;
	      translateY = diffY * zoom.scale;
	
	      if (translateX < translateMinX) {
	        translateX = translateMinX;
	      }
	      if (translateX > translateMaxX) {
	        translateX = translateMaxX;
	      }
	
	      if (translateY < translateMinY) {
	        translateY = translateMinY;
	      }
	      if (translateY > translateMaxY) {
	        translateY = translateMaxY;
	      }
	    } else {
	      translateX = 0;
	      translateY = 0;
	    }
	    gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
	    gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	  },
	  out: function out() {
	    var swiper = this;
	
	    var zoom = swiper.zoom;
	    var params = swiper.params.zoom;
	    var gesture = zoom.gesture;
	
	    if (!gesture.$slideEl) {
	      gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	
	    zoom.scale = 1;
	    zoom.currentScale = 1;
	    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
	    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
	    gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
	    gesture.$slideEl = undefined;
	  },
	  // Attach/Detach Events
	  enable: function enable() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    if (zoom.enabled) { return; }
	    zoom.enabled = true;
	
	    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
	
	    // Scale image
	    if (Support.gestures) {
	      swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
	      swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
	    } else if (swiper.touchEvents.start === 'touchstart') {
	      swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
	      swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
	    }
	
	    // Move image
	    swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
	  },
	  disable: function disable() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    if (!zoom.enabled) { return; }
	
	    swiper.zoom.enabled = false;
	
	    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
	
	    // Scale image
	    if (Support.gestures) {
	      swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
	      swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
	    } else if (swiper.touchEvents.start === 'touchstart') {
	      swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
	      swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
	    }
	
	    // Move image
	    swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
	  },
	};
	
	var Zoom$1 = {
	  name: 'zoom',
	  params: {
	    zoom: {
	      enabled: false,
	      maxRatio: 3,
	      minRatio: 1,
	      toggle: true,
	      containerClass: 'swiper-zoom-container',
	      zoomedSlideClass: 'swiper-slide-zoomed',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    var zoom = {
	      enabled: false,
	      scale: 1,
	      currentScale: 1,
	      isScaling: false,
	      gesture: {
	        $slideEl: undefined,
	        slideWidth: undefined,
	        slideHeight: undefined,
	        $imageEl: undefined,
	        $imageWrapEl: undefined,
	        maxRatio: 3,
	      },
	      image: {
	        isTouched: undefined,
	        isMoved: undefined,
	        currentX: undefined,
	        currentY: undefined,
	        minX: undefined,
	        minY: undefined,
	        maxX: undefined,
	        maxY: undefined,
	        width: undefined,
	        height: undefined,
	        startX: undefined,
	        startY: undefined,
	        touchesStart: {},
	        touchesCurrent: {},
	      },
	      velocity: {
	        x: undefined,
	        y: undefined,
	        prevPositionX: undefined,
	        prevPositionY: undefined,
	        prevTime: undefined,
	      },
	    };
	    ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
	      zoom[methodName] = Zoom[methodName].bind(swiper);
	    });
	    Utils.extend(swiper, {
	      zoom: zoom,
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.zoom.enabled) {
	        swiper.zoom.enable();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.zoom.disable();
	    },
	    touchStart: function touchStart(e) {
	      var swiper = this;
	      if (!swiper.zoom.enabled) { return; }
	      swiper.zoom.onTouchStart(e);
	    },
	    touchEnd: function touchEnd(e) {
	      var swiper = this;
	      if (!swiper.zoom.enabled) { return; }
	      swiper.zoom.onTouchEnd(e);
	    },
	    doubleTap: function doubleTap(e) {
	      var swiper = this;
	      if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
	        swiper.zoom.toggle(e);
	      }
	    },
	    transitionEnd: function transitionEnd() {
	      var swiper = this;
	      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
	        swiper.zoom.onTransitionEnd();
	      }
	    },
	  },
	};
	
	var Lazy = {
	  loadInSlide: function loadInSlide(index, loadInDuplicate) {
	    if ( loadInDuplicate === void 0 ) loadInDuplicate = true;
	
	    var swiper = this;
	    var params = swiper.params.lazy;
	    if (typeof index === 'undefined') { return; }
	    if (swiper.slides.length === 0) { return; }
	    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	
	    var $slideEl = isVirtual
	      ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
	      : swiper.slides.eq(index);
	
	    var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
	    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
	      $images = $images.add($slideEl[0]);
	    }
	    if ($images.length === 0) { return; }
	
	    $images.each(function (imageIndex, imageEl) {
	      var $imageEl = $(imageEl);
	      $imageEl.addClass(params.loadingClass);
	
	      var background = $imageEl.attr('data-background');
	      var src = $imageEl.attr('data-src');
	      var srcset = $imageEl.attr('data-srcset');
	      var sizes = $imageEl.attr('data-sizes');
	
	      swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
	        if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
	        if (background) {
	          $imageEl.css('background-image', ("url(\"" + background + "\")"));
	          $imageEl.removeAttr('data-background');
	        } else {
	          if (srcset) {
	            $imageEl.attr('srcset', srcset);
	            $imageEl.removeAttr('data-srcset');
	          }
	          if (sizes) {
	            $imageEl.attr('sizes', sizes);
	            $imageEl.removeAttr('data-sizes');
	          }
	          if (src) {
	            $imageEl.attr('src', src);
	            $imageEl.removeAttr('data-src');
	          }
	        }
	
	        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
	        $slideEl.find(("." + (params.preloaderClass))).remove();
	        if (swiper.params.loop && loadInDuplicate) {
	          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
	          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
	            var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
	            swiper.lazy.loadInSlide(originalSlide.index(), false);
	          } else {
	            var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
	            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
	          }
	        }
	        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
	      });
	
	      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
	    });
	  },
	  load: function load() {
	    var swiper = this;
	    var $wrapperEl = swiper.$wrapperEl;
	    var swiperParams = swiper.params;
	    var slides = swiper.slides;
	    var activeIndex = swiper.activeIndex;
	    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
	    var params = swiperParams.lazy;
	
	    var slidesPerView = swiperParams.slidesPerView;
	    if (slidesPerView === 'auto') {
	      slidesPerView = 0;
	    }
	
	    function slideExist(index) {
	      if (isVirtual) {
	        if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
	          return true;
	        }
	      } else if (slides[index]) { return true; }
	      return false;
	    }
	    function slideIndex(slideEl) {
	      if (isVirtual) {
	        return $(slideEl).attr('data-swiper-slide-index');
	      }
	      return $(slideEl).index();
	    }
	
	    if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
	    if (swiper.params.watchSlidesVisibility) {
	      $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
	        var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
	        swiper.lazy.loadInSlide(index);
	      });
	    } else if (slidesPerView > 1) {
	      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
	        if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
	      }
	    } else {
	      swiper.lazy.loadInSlide(activeIndex);
	    }
	    if (params.loadPrevNext) {
	      if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
	        var amount = params.loadPrevNextAmount;
	        var spv = slidesPerView;
	        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
	        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
	        // Next Slides
	        for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
	          if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
	        }
	        // Prev Slides
	        for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
	          if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
	        }
	      } else {
	        var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
	        if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }
	
	        var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
	        if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
	      }
	    }
	  },
	};
	
	var Lazy$1 = {
	  name: 'lazy',
	  params: {
	    lazy: {
	      enabled: false,
	      loadPrevNext: false,
	      loadPrevNextAmount: 1,
	      loadOnTransitionStart: false,
	
	      elementClass: 'swiper-lazy',
	      loadingClass: 'swiper-lazy-loading',
	      loadedClass: 'swiper-lazy-loaded',
	      preloaderClass: 'swiper-lazy-preloader',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      lazy: {
	        initialImageLoaded: false,
	        load: Lazy.load.bind(swiper),
	        loadInSlide: Lazy.loadInSlide.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
	        swiper.params.preloadImages = false;
	      }
	    },
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
	        swiper.lazy.load();
	      }
	    },
	    scroll: function scroll() {
	      var swiper = this;
	      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
	        swiper.lazy.load();
	      }
	    },
	    resize: function resize() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    },
	    scrollbarDragMove: function scrollbarDragMove() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    },
	    transitionStart: function transitionStart() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled) {
	        if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
	          swiper.lazy.load();
	        }
	      }
	    },
	    transitionEnd: function transitionEnd() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
	        swiper.lazy.load();
	      }
	    },
	  },
	};
	
	/* eslint no-bitwise: ["error", { "allow": [">>"] }] */
	
	var Controller = {
	  LinearSpline: function LinearSpline(x, y) {
	    var binarySearch = (function search() {
	      var maxIndex;
	      var minIndex;
	      var guess;
	      return function (array, val) {
	        minIndex = -1;
	        maxIndex = array.length;
	        while (maxIndex - minIndex > 1) {
	          guess = maxIndex + minIndex >> 1;
	          if (array[guess] <= val) {
	            minIndex = guess;
	          } else {
	            maxIndex = guess;
	          }
	        }
	        return maxIndex;
	      };
	    }());
	    this.x = x;
	    this.y = y;
	    this.lastIndex = x.length - 1;
	    // Given an x value (x2), return the expected y2 value:
	    // (x1,y1) is the known point before given value,
	    // (x3,y3) is the known point after given value.
	    var i1;
	    var i3;
	
	    this.interpolate = function interpolate(x2) {
	      if (!x2) { return 0; }
	
	      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	      i3 = binarySearch(this.x, x2);
	      i1 = i3 - 1;
	
	      // We have our indexes i1 & i3, so we can calculate already:
	      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	      return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
	    };
	    return this;
	  },
	  // xxx: for now i will just save one spline function to to
	  getInterpolateFunction: function getInterpolateFunction(c) {
	    var swiper = this;
	    if (!swiper.controller.spline) {
	      swiper.controller.spline = swiper.params.loop ?
	        new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) :
	        new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
	    }
	  },
	  setTranslate: function setTranslate(setTranslate$1, byController) {
	    var swiper = this;
	    var controlled = swiper.controller.control;
	    var multiplier;
	    var controlledTranslate;
	    function setControlledTranslate(c) {
	      // this will create an Interpolate function based on the snapGrids
	      // x is the Grid of the scrolled scroller and y will be the controlled scroller
	      // it makes sense to create this only once and recall it for the interpolation
	      // the function does a lot of value caching for performance
	      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
	      if (swiper.params.controller.by === 'slide') {
	        swiper.controller.getInterpolateFunction(c);
	        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	        // but it did not work out
	        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
	      }
	
	      if (!controlledTranslate || swiper.params.controller.by === 'container') {
	        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
	        controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
	      }
	
	      if (swiper.params.controller.inverse) {
	        controlledTranslate = c.maxTranslate() - controlledTranslate;
	      }
	      c.updateProgress(controlledTranslate);
	      c.setTranslate(controlledTranslate, swiper);
	      c.updateActiveIndex();
	      c.updateSlidesClasses();
	    }
	    if (Array.isArray(controlled)) {
	      for (var i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTranslate(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTranslate(controlled);
	    }
	  },
	  setTransition: function setTransition(duration, byController) {
	    var swiper = this;
	    var controlled = swiper.controller.control;
	    var i;
	    function setControlledTransition(c) {
	      c.setTransition(duration, swiper);
	      if (duration !== 0) {
	        c.transitionStart();
	        c.$wrapperEl.transitionEnd(function () {
	          if (!controlled) { return; }
	          if (c.params.loop && swiper.params.controller.by === 'slide') {
	            c.loopFix();
	          }
	          c.transitionEnd();
	        });
	      }
	    }
	    if (Array.isArray(controlled)) {
	      for (i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTransition(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTransition(controlled);
	    }
	  },
	};
	var Controller$1 = {
	  name: 'controller',
	  params: {
	    controller: {
	      control: undefined,
	      inverse: false,
	      by: 'slide', // or 'container'
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      controller: {
	        control: swiper.params.controller.control,
	        getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
	        setTranslate: Controller.setTranslate.bind(swiper),
	        setTransition: Controller.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    update: function update() {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    resize: function resize() {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    observerUpdate: function observerUpdate() {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    setTranslate: function setTranslate(translate, byController) {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      swiper.controller.setTranslate(translate, byController);
	    },
	    setTransition: function setTransition(duration, byController) {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      swiper.controller.setTransition(duration, byController);
	    },
	  },
	};
	
	var a11y = {
	  makeElFocusable: function makeElFocusable($el) {
	    $el.attr('tabIndex', '0');
	    return $el;
	  },
	  addElRole: function addElRole($el, role) {
	    $el.attr('role', role);
	    return $el;
	  },
	  addElLabel: function addElLabel($el, label) {
	    $el.attr('aria-label', label);
	    return $el;
	  },
	  disableEl: function disableEl($el) {
	    $el.attr('aria-disabled', true);
	    return $el;
	  },
	  enableEl: function enableEl($el) {
	    $el.attr('aria-disabled', false);
	    return $el;
	  },
	  onEnterKey: function onEnterKey(e) {
	    var swiper = this;
	    var params = swiper.params.a11y;
	    if (e.keyCode !== 13) { return; }
	    var $targetEl = $(e.target);
	    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
	      if (!(swiper.isEnd && !swiper.params.loop)) {
	        swiper.slideNext();
	      }
	      if (swiper.isEnd) {
	        swiper.a11y.notify(params.lastSlideMessage);
	      } else {
	        swiper.a11y.notify(params.nextSlideMessage);
	      }
	    }
	    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
	      if (!(swiper.isBeginning && !swiper.params.loop)) {
	        swiper.slidePrev();
	      }
	      if (swiper.isBeginning) {
	        swiper.a11y.notify(params.firstSlideMessage);
	      } else {
	        swiper.a11y.notify(params.prevSlideMessage);
	      }
	    }
	    if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
	      $targetEl[0].click();
	    }
	  },
	  notify: function notify(message) {
	    var swiper = this;
	    var notification = swiper.a11y.liveRegion;
	    if (notification.length === 0) { return; }
	    notification.html('');
	    notification.html(message);
	  },
	  updateNavigation: function updateNavigation() {
	    var swiper = this;
	
	    if (swiper.params.loop) { return; }
	    var ref = swiper.navigation;
	    var $nextEl = ref.$nextEl;
	    var $prevEl = ref.$prevEl;
	
	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        swiper.a11y.disableEl($prevEl);
	      } else {
	        swiper.a11y.enableEl($prevEl);
	      }
	    }
	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        swiper.a11y.disableEl($nextEl);
	      } else {
	        swiper.a11y.enableEl($nextEl);
	      }
	    }
	  },
	  updatePagination: function updatePagination() {
	    var swiper = this;
	    var params = swiper.params.a11y;
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
	        var $bulletEl = $(bulletEl);
	        swiper.a11y.makeElFocusable($bulletEl);
	        swiper.a11y.addElRole($bulletEl, 'button');
	        swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
	      });
	    }
	  },
	  init: function init() {
	    var swiper = this;
	
	    swiper.$el.append(swiper.a11y.liveRegion);
	
	    // Navigation
	    var params = swiper.params.a11y;
	    var $nextEl;
	    var $prevEl;
	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }
	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }
	    if ($nextEl) {
	      swiper.a11y.makeElFocusable($nextEl);
	      swiper.a11y.addElRole($nextEl, 'button');
	      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
	      $nextEl.on('keydown', swiper.a11y.onEnterKey);
	    }
	    if ($prevEl) {
	      swiper.a11y.makeElFocusable($prevEl);
	      swiper.a11y.addElRole($prevEl, 'button');
	      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
	      $prevEl.on('keydown', swiper.a11y.onEnterKey);
	    }
	
	    // Pagination
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }
	
	    var $nextEl;
	    var $prevEl;
	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }
	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }
	    if ($nextEl) {
	      $nextEl.off('keydown', swiper.a11y.onEnterKey);
	    }
	    if ($prevEl) {
	      $prevEl.off('keydown', swiper.a11y.onEnterKey);
	    }
	
	    // Pagination
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	    }
	  },
	};
	var A11y = {
	  name: 'a11y',
	  params: {
	    a11y: {
	      enabled: true,
	      notificationClass: 'swiper-notification',
	      prevSlideMessage: 'Previous slide',
	      nextSlideMessage: 'Next slide',
	      firstSlideMessage: 'This is the first slide',
	      lastSlideMessage: 'This is the last slide',
	      paginationBulletMessage: 'Go to slide {{index}}',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      a11y: {
	        liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
	      },
	    });
	    Object.keys(a11y).forEach(function (methodName) {
	      swiper.a11y[methodName] = a11y[methodName].bind(swiper);
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.init();
	      swiper.a11y.updateNavigation();
	    },
	    toEdge: function toEdge() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.updateNavigation();
	    },
	    fromEdge: function fromEdge() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.updateNavigation();
	    },
	    paginationUpdate: function paginationUpdate() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.updatePagination();
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.destroy();
	    },
	  },
	};
	
	var History = {
	  init: function init() {
	    var swiper = this;
	    if (!swiper.params.history) { return; }
	    if (!win.history || !win.history.pushState) {
	      swiper.params.history.enabled = false;
	      swiper.params.hashNavigation.enabled = true;
	      return;
	    }
	    var history = swiper.history;
	    history.initialized = true;
	    history.paths = History.getPathValues();
	    if (!history.paths.key && !history.paths.value) { return; }
	    history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
	    if (!swiper.params.history.replaceState) {
	      win.addEventListener('popstate', swiper.history.setHistoryPopState);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    if (!swiper.params.history.replaceState) {
	      win.removeEventListener('popstate', swiper.history.setHistoryPopState);
	    }
	  },
	  setHistoryPopState: function setHistoryPopState() {
	    var swiper = this;
	    swiper.history.paths = History.getPathValues();
	    swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
	  },
	  getPathValues: function getPathValues() {
	    var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
	    var total = pathArray.length;
	    var key = pathArray[total - 2];
	    var value = pathArray[total - 1];
	    return { key: key, value: value };
	  },
	  setHistory: function setHistory(key, index) {
	    var swiper = this;
	    if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
	    var slide = swiper.slides.eq(index);
	    var value = History.slugify(slide.attr('data-history'));
	    if (!win.location.pathname.includes(key)) {
	      value = key + "/" + value;
	    }
	    var currentState = win.history.state;
	    if (currentState && currentState.value === value) {
	      return;
	    }
	    if (swiper.params.history.replaceState) {
	      win.history.replaceState({ value: value }, null, value);
	    } else {
	      win.history.pushState({ value: value }, null, value);
	    }
	  },
	  slugify: function slugify(text) {
	    return text.toString().toLowerCase()
	      .replace(/\s+/g, '-')
	      .replace(/[^\w-]+/g, '')
	      .replace(/--+/g, '-')
	      .replace(/^-+/, '')
	      .replace(/-+$/, '');
	  },
	  scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
	    var swiper = this;
	    if (value) {
	      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	        var slide = swiper.slides.eq(i);
	        var slideHistory = History.slugify(slide.attr('data-history'));
	        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	          var index = slide.index();
	          swiper.slideTo(index, speed, runCallbacks);
	        }
	      }
	    } else {
	      swiper.slideTo(0, speed, runCallbacks);
	    }
	  },
	};
	
	var History$1 = {
	  name: 'history',
	  params: {
	    history: {
	      enabled: false,
	      replaceState: false,
	      key: 'slides',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      history: {
	        init: History.init.bind(swiper),
	        setHistory: History.setHistory.bind(swiper),
	        setHistoryPopState: History.setHistoryPopState.bind(swiper),
	        scrollToSlide: History.scrollToSlide.bind(swiper),
	        destroy: History.destroy.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.history.enabled) {
	        swiper.history.init();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.params.history.enabled) {
	        swiper.history.destroy();
	      }
	    },
	    transitionEnd: function transitionEnd() {
	      var swiper = this;
	      if (swiper.history.initialized) {
	        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
	      }
	    },
	  },
	};
	
	var HashNavigation = {
	  onHashCange: function onHashCange() {
	    var swiper = this;
	    var newHash = doc.location.hash.replace('#', '');
	    var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
	    if (newHash !== activeSlideHash) {
	      swiper.slideTo(swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index());
	    }
	  },
	  setHash: function setHash() {
	    var swiper = this;
	    if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
	    if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
	      win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
	    } else {
	      var slide = swiper.slides.eq(swiper.activeIndex);
	      var hash = slide.attr('data-hash') || slide.attr('data-history');
	      doc.location.hash = hash || '';
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
	    swiper.hashNavigation.initialized = true;
	    var hash = doc.location.hash.replace('#', '');
	    if (hash) {
	      var speed = 0;
	      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	        var slide = swiper.slides.eq(i);
	        var slideHash = slide.attr('data-hash') || slide.attr('data-history');
	        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	          var index = slide.index();
	          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
	        }
	      }
	    }
	    if (swiper.params.hashNavigation.watchState) {
	      $(win).on('hashchange', swiper.hashNavigation.onHashCange);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    if (swiper.params.hashNavigation.watchState) {
	      $(win).off('hashchange', swiper.hashNavigation.onHashCange);
	    }
	  },
	};
	var HashNavigation$1 = {
	  name: 'hash-navigation',
	  params: {
	    hashNavigation: {
	      enabled: false,
	      replaceState: false,
	      watchState: false,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      hashNavigation: {
	        initialized: false,
	        init: HashNavigation.init.bind(swiper),
	        destroy: HashNavigation.destroy.bind(swiper),
	        setHash: HashNavigation.setHash.bind(swiper),
	        onHashCange: HashNavigation.onHashCange.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.hashNavigation.enabled) {
	        swiper.hashNavigation.init();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.params.hashNavigation.enabled) {
	        swiper.hashNavigation.destroy();
	      }
	    },
	    transitionEnd: function transitionEnd() {
	      var swiper = this;
	      if (swiper.hashNavigation.initialized) {
	        swiper.hashNavigation.setHash();
	      }
	    },
	  },
	};
	
	var Autoplay = {
	  run: function run() {
	    var swiper = this;
	    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
	    var delay = swiper.params.autoplay.delay;
	    if ($activeSlideEl.attr('data-swiper-autoplay')) {
	      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
	    }
	    swiper.autoplay.timeout = Utils.nextTick(function () {
	      if (swiper.params.autoplay.reverseDirection) {
	        if (swiper.params.loop) {
	          swiper.loopFix();
	          swiper.slidePrev(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.isBeginning) {
	          swiper.slidePrev(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.params.autoplay.stopOnLastSlide) {
	          swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else {
	          swiper.autoplay.stop();
	        }
	      } else if (swiper.params.loop) {
	        swiper.loopFix();
	        swiper.slideNext(swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else if (!swiper.isEnd) {
	        swiper.slideNext(swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else if (!swiper.params.autoplay.stopOnLastSlide) {
	        swiper.slideTo(0, swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else {
	        swiper.autoplay.stop();
	      }
	    }, delay);
	  },
	  start: function start() {
	    var swiper = this;
	    if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
	    if (swiper.autoplay.running) { return false; }
	    swiper.autoplay.running = true;
	    swiper.emit('autoplayStart');
	    swiper.autoplay.run();
	    return true;
	  },
	  stop: function stop() {
	    var swiper = this;
	    if (!swiper.autoplay.running) { return false; }
	    if (typeof swiper.autoplay.timeout === 'undefined') { return false; }
	
	    if (swiper.autoplay.timeout) {
	      clearTimeout(swiper.autoplay.timeout);
	      swiper.autoplay.timeout = undefined;
	    }
	    swiper.autoplay.running = false;
	    swiper.emit('autoplayStop');
	    return true;
	  },
	  pause: function pause(speed) {
	    var swiper = this;
	    if (!swiper.autoplay.running) { return; }
	    if (swiper.autoplay.paused) { return; }
	    if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
	    swiper.autoplay.paused = true;
	    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
	      swiper.autoplay.paused = false;
	      swiper.autoplay.run();
	    } else {
	      swiper.$wrapperEl.transitionEnd(function () {
	        if (!swiper || swiper.destroyed) { return; }
	        swiper.autoplay.paused = false;
	        if (!swiper.autoplay.running) {
	          swiper.autoplay.stop();
	        } else {
	          swiper.autoplay.run();
	        }
	      });
	    }
	  },
	};
	
	var Autoplay$1 = {
	  name: 'autoplay',
	  params: {
	    autoplay: {
	      enabled: false,
	      delay: 3000,
	      waitForTransition: true,
	      disableOnInteraction: true,
	      stopOnLastSlide: false,
	      reverseDirection: false,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      autoplay: {
	        running: false,
	        paused: false,
	        run: Autoplay.run.bind(swiper),
	        start: Autoplay.start.bind(swiper),
	        stop: Autoplay.stop.bind(swiper),
	        pause: Autoplay.pause.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.autoplay.enabled) {
	        swiper.autoplay.start();
	      }
	    },
	    beforeTransitionStart: function beforeTransitionStart(speed, internal) {
	      var swiper = this;
	      if (swiper.autoplay.running) {
	        if (internal || !swiper.params.autoplay.disableOnInteraction) {
	          swiper.autoplay.pause(speed);
	        } else {
	          swiper.autoplay.stop();
	        }
	      }
	    },
	    sliderFirstMove: function sliderFirstMove() {
	      var swiper = this;
	      if (swiper.autoplay.running) {
	        if (swiper.params.autoplay.disableOnInteraction) {
	          swiper.autoplay.stop();
	        } else {
	          swiper.autoplay.pause();
	        }
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.autoplay.running) {
	        swiper.autoplay.stop();
	      }
	    },
	  },
	};
	
	var Fade = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var slides = swiper.slides;
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = swiper.slides.eq(i);
	      var offset = $slideEl[0].swiperSlideOffset;
	      var tx = -offset;
	      if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
	      var ty = 0;
	      if (!swiper.isHorizontal()) {
	        ty = tx;
	        tx = 0;
	      }
	      var slideOpacity = swiper.params.fadeEffect.crossFade ?
	        Math.max(1 - Math.abs($slideEl[0].progress), 0) :
	        1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
	      $slideEl
	        .css({
	          opacity: slideOpacity,
	        })
	        .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var slides = swiper.slides;
	    var $wrapperEl = swiper.$wrapperEl;
	    slides.transition(duration);
	    if (swiper.params.virtualTranslate && duration !== 0) {
	      var eventTriggered = false;
	      slides.transitionEnd(function () {
	        if (eventTriggered) { return; }
	        if (!swiper || swiper.destroyed) { return; }
	        eventTriggered = true;
	        swiper.animating = false;
	        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	        for (var i = 0; i < triggerEvents.length; i += 1) {
	          $wrapperEl.trigger(triggerEvents[i]);
	        }
	      });
	    }
	  },
	};
	
	var EffectFade = {
	  name: 'effect-fade',
	  params: {
	    fadeEffect: {
	      crossFade: false,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      fadeEffect: {
	        setTranslate: Fade.setTranslate.bind(swiper),
	        setTransition: Fade.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'fade') { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        spaceBetween: 0,
	        virtualTranslate: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'fade') { return; }
	      swiper.fadeEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'fade') { return; }
	      swiper.fadeEffect.setTransition(duration);
	    },
	  },
	};
	
	var Cube = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var $el = swiper.$el;
	    var $wrapperEl = swiper.$wrapperEl;
	    var slides = swiper.slides;
	    var swiperWidth = swiper.width;
	    var swiperHeight = swiper.height;
	    var rtl = swiper.rtlTranslate;
	    var swiperSize = swiper.size;
	    var params = swiper.params.cubeEffect;
	    var isHorizontal = swiper.isHorizontal();
	    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	    var wrapperRotate = 0;
	    var $cubeShadowEl;
	    if (params.shadow) {
	      if (isHorizontal) {
	        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
	        if ($cubeShadowEl.length === 0) {
	          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
	          $wrapperEl.append($cubeShadowEl);
	        }
	        $cubeShadowEl.css({ height: (swiperWidth + "px") });
	      } else {
	        $cubeShadowEl = $el.find('.swiper-cube-shadow');
	        if ($cubeShadowEl.length === 0) {
	          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
	          $el.append($cubeShadowEl);
	        }
	      }
	    }
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var slideIndex = i;
	      if (isVirtual) {
	        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
	      }
	      var slideAngle = slideIndex * 90;
	      var round = Math.floor(slideAngle / 360);
	      if (rtl) {
	        slideAngle = -slideAngle;
	        round = Math.floor(-slideAngle / 360);
	      }
	      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	      var tx = 0;
	      var ty = 0;
	      var tz = 0;
	      if (slideIndex % 4 === 0) {
	        tx = -round * 4 * swiperSize;
	        tz = 0;
	      } else if ((slideIndex - 1) % 4 === 0) {
	        tx = 0;
	        tz = -round * 4 * swiperSize;
	      } else if ((slideIndex - 2) % 4 === 0) {
	        tx = swiperSize + (round * 4 * swiperSize);
	        tz = swiperSize;
	      } else if ((slideIndex - 3) % 4 === 0) {
	        tx = -swiperSize;
	        tz = (3 * swiperSize) + (swiperSize * 4 * round);
	      }
	      if (rtl) {
	        tx = -tx;
	      }
	
	      if (!isHorizontal) {
	        ty = tx;
	        tx = 0;
	      }
	
	      var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
	      if (progress <= 1 && progress > -1) {
	        wrapperRotate = (slideIndex * 90) + (progress * 90);
	        if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
	      }
	      $slideEl.transform(transform);
	      if (params.slideShadows) {
	        // Set shadows
	        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	        if (shadowBefore.length === 0) {
	          shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	          $slideEl.append(shadowBefore);
	        }
	        if (shadowAfter.length === 0) {
	          shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	          $slideEl.append(shadowAfter);
	        }
	        if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	        if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	      }
	    }
	    $wrapperEl.css({
	      '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	      '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	      '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	      'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	    });
	
	    if (params.shadow) {
	      if (isHorizontal) {
	        $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
	      } else {
	        var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
	        var multiplier = 1.5 - (
	          (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2) +
	          (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
	        );
	        var scale1 = params.shadowScale;
	        var scale2 = params.shadowScale / multiplier;
	        var offset = params.shadowOffset;
	        $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
	      }
	    }
	    var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
	    $wrapperEl
	      .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var $el = swiper.$el;
	    var slides = swiper.slides;
	    slides
	      .transition(duration)
	      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	      .transition(duration);
	    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
	      $el.find('.swiper-cube-shadow').transition(duration);
	    }
	  },
	};
	
	var EffectCube = {
	  name: 'effect-cube',
	  params: {
	    cubeEffect: {
	      slideShadows: true,
	      shadow: true,
	      shadowOffset: 20,
	      shadowScale: 0.94,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      cubeEffect: {
	        setTranslate: Cube.setTranslate.bind(swiper),
	        setTransition: Cube.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'cube') { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        resistanceRatio: 0,
	        spaceBetween: 0,
	        centeredSlides: false,
	        virtualTranslate: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'cube') { return; }
	      swiper.cubeEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'cube') { return; }
	      swiper.cubeEffect.setTransition(duration);
	    },
	  },
	};
	
	var Flip = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var slides = swiper.slides;
	    var rtl = swiper.rtlTranslate;
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var progress = $slideEl[0].progress;
	      if (swiper.params.flipEffect.limitRotation) {
	        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	      }
	      var offset = $slideEl[0].swiperSlideOffset;
	      var rotate = -180 * progress;
	      var rotateY = rotate;
	      var rotateX = 0;
	      var tx = -offset;
	      var ty = 0;
	      if (!swiper.isHorizontal()) {
	        ty = tx;
	        tx = 0;
	        rotateX = -rotateY;
	        rotateY = 0;
	      } else if (rtl) {
	        rotateY = -rotateY;
	      }
	
	      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
	
	      if (swiper.params.flipEffect.slideShadows) {
	        // Set shadows
	        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	        if (shadowBefore.length === 0) {
	          shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
	          $slideEl.append(shadowBefore);
	        }
	        if (shadowAfter.length === 0) {
	          shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
	          $slideEl.append(shadowAfter);
	        }
	        if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	        if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	      }
	      $slideEl
	        .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var slides = swiper.slides;
	    var activeIndex = swiper.activeIndex;
	    var $wrapperEl = swiper.$wrapperEl;
	    slides
	      .transition(duration)
	      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	      .transition(duration);
	    if (swiper.params.virtualTranslate && duration !== 0) {
	      var eventTriggered = false;
	      // eslint-disable-next-line
	      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
	        if (eventTriggered) { return; }
	        if (!swiper || swiper.destroyed) { return; }
	        // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
	        eventTriggered = true;
	        swiper.animating = false;
	        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	        for (var i = 0; i < triggerEvents.length; i += 1) {
	          $wrapperEl.trigger(triggerEvents[i]);
	        }
	      });
	    }
	  },
	};
	
	var EffectFlip = {
	  name: 'effect-flip',
	  params: {
	    flipEffect: {
	      slideShadows: true,
	      limitRotation: true,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      flipEffect: {
	        setTranslate: Flip.setTranslate.bind(swiper),
	        setTransition: Flip.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'flip') { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        spaceBetween: 0,
	        virtualTranslate: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'flip') { return; }
	      swiper.flipEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'flip') { return; }
	      swiper.flipEffect.setTransition(duration);
	    },
	  },
	};
	
	var Coverflow = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var swiperWidth = swiper.width;
	    var swiperHeight = swiper.height;
	    var slides = swiper.slides;
	    var $wrapperEl = swiper.$wrapperEl;
	    var slidesSizesGrid = swiper.slidesSizesGrid;
	    var params = swiper.params.coverflowEffect;
	    var isHorizontal = swiper.isHorizontal();
	    var transform = swiper.translate;
	    var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
	    var rotate = isHorizontal ? params.rotate : -params.rotate;
	    var translate = params.depth;
	    // Each slide offset from center
	    for (var i = 0, length = slides.length; i < length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var slideSize = slidesSizesGrid[i];
	      var slideOffset = $slideEl[0].swiperSlideOffset;
	      var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;
	
	      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
	      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
	      // var rotateZ = 0
	      var translateZ = -translate * Math.abs(offsetMultiplier);
	
	      var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
	      var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;
	
	      // Fix for ultra small values
	      if (Math.abs(translateX) < 0.001) { translateX = 0; }
	      if (Math.abs(translateY) < 0.001) { translateY = 0; }
	      if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
	      if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
	      if (Math.abs(rotateX) < 0.001) { rotateX = 0; }
	
	      var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";
	
	      $slideEl.transform(slideTransform);
	      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	      if (params.slideShadows) {
	        // Set shadows
	        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	        if ($shadowBeforeEl.length === 0) {
	          $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	          $slideEl.append($shadowBeforeEl);
	        }
	        if ($shadowAfterEl.length === 0) {
	          $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	          $slideEl.append($shadowAfterEl);
	        }
	        if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
	        if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
	      }
	    }
	
	    // Set correct perspective for IE10
	    if (Support.pointerEvents || Support.prefixedPointerEvents) {
	      var ws = $wrapperEl[0].style;
	      ws.perspectiveOrigin = center + "px 50%";
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    swiper.slides
	      .transition(duration)
	      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	      .transition(duration);
	  },
	};
	
	var EffectCoverflow = {
	  name: 'effect-coverflow',
	  params: {
	    coverflowEffect: {
	      rotate: 50,
	      stretch: 0,
	      depth: 100,
	      modifier: 1,
	      slideShadows: true,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      coverflowEffect: {
	        setTranslate: Coverflow.setTranslate.bind(swiper),
	        setTransition: Coverflow.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'coverflow') { return; }
	
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	
	      swiper.params.watchSlidesProgress = true;
	      swiper.originalParams.watchSlidesProgress = true;
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'coverflow') { return; }
	      swiper.coverflowEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'coverflow') { return; }
	      swiper.coverflowEffect.setTransition(duration);
	    },
	  },
	};
	
	// Swiper Class
	
	var components = [
	  Device$1,
	  Support$1,
	  Browser$1,
	  Resize,
	  Observer$1,
	  Virtual$1,
	  Keyboard$1,
	  Mousewheel$1,
	  Navigation$1,
	  Pagination$1,
	  Scrollbar$1,
	  Parallax$1,
	  Zoom$1,
	  Lazy$1,
	  Controller$1,
	  A11y,
	  History$1,
	  HashNavigation$1,
	  Autoplay$1,
	  EffectFade,
	  EffectCube,
	  EffectFlip,
	  EffectCoverflow
	];
	
	if (typeof Swiper.use === 'undefined') {
	  Swiper.use = Swiper.Class.use;
	  Swiper.installModule = Swiper.Class.installModule;
	}
	
	Swiper.use(components);
	
	return Swiper;
	
	})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var domUtils =		__webpack_require__(215);
	var classUtils =	__webpack_require__(216);
	var Dialog =		__webpack_require__(217);
	var tips =			__webpack_require__(219);
	var uikit = __webpack_require__(180);
	var utils = __webpack_require__(16);
	
	// var profile =		require("@/app/tools/profile");
	var apiHelper =		__webpack_require__(181);
	var tpl =			__webpack_require__(221);
	
	var TagSelector = classUtils.createView({
	
		dialog: null,
		msgId: "",
		hasTags: false,
		events: {
			"click li": "onTagClick"
		},
	
		init: function(){
			var me = this;
	
	
			// 拿到 taglist
			// apiHelper.getSatisfactionCommentTags(robotAgentId)
			// .then(function(dat){
			// 	me.hasTags = dat && dat.length;
			// 	me.$el.innerHTML = _.template(tpl)({ tags: dat });
			// 	me.createDialog();
			// });
		},
	
		createDialog: function(){
			this.dialog = new Dialog({
				contentDom: this.$el,
				className: "tag-selector"	// 把 dialog 做小
			})
			.addButton({
				confirmText: "提交",
				confirm: _.bind(this.onConfirm, this)
			});
		},
	
		onTagClick: function(e){
			var targetDom = e.target;
			domUtils.toggleClass(targetDom, "selected");
			utils.stopPropagation();
		},
	
		show: function(dat, robotAgentId, satisfactionCommentKey){
			this.$el.innerHTML = _.template(tpl)({ tags: dat });
			this.createDialog();
	
			this.hasTags = dat && dat.length;
			this.robotAgentId = robotAgentId;
			this.satisfactionCommentKey = satisfactionCommentKey;
			// this.msgId = msgId;
			// this.multiTurnDialogueId = multiTurnDialogueId;
			if(this.hasTags){
				this.dialog.show();
			}
			else{
				tips.tip("需要管理员先设置问题标签");
			}
		},
	
		hide: function(){
			this.dialog.hide();
		},
	
		onConfirm: function(){
			var me = this;
			var selected = [];
			_.each(this.$el.querySelectorAll("li"), function(tagDom){
				if(domUtils.hasClass(tagDom, "selected")){
					selected.push(tagDom.innerText);
				}
			});
			// if(selected.length){
			// profile.getProp("sessionId").then(function(ssid){
			apiHelper.confirmSatisfaction(me.robotAgentId, me.satisfactionCommentKey, selected.join(","))
			.then(function(){
				uikit.tip("谢谢");
			}, function(err){
				if(err.errorCode === "KEFU_ROBOT_INTEGRATION_0207"){
					uikit.tip("已评价");
				}
			});
	
			me.hide();
			// });
			// 	return true;
			// }
			// tips.tip("未解决您的问题的原因是？");
			return false;
		},
	
	});
	
	module.exports = TagSelector;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var utils =	__webpack_require__(16);
	
	
	module.exports = {
	
		click: utils.isMobile && ("ontouchstart" in window) ? "touchstart" : "click",
	
		eachElement: function(elementOrNodeList, fn /* *arguments */){
			var nodeList;
			var extraArgs = [];
			var i, l, tmpElem;
			if(typeof fn !== "function") return;
			nodeList = _isNodeList(elementOrNodeList) ? elementOrNodeList : [elementOrNodeList];
			// parse extra arguments
			for(i = 2, l = arguments.length; i < l; ++i){
				extraArgs.push(arguments[i]);
			}
			for(i = 0, l = nodeList.length; i < l; ++i){
				(tmpElem = nodeList[i]) && fn.apply(null, [tmpElem].concat(extraArgs));
			}
		},
		// 触发事件，对于 ie8 只支持原生事件，不支持自定义事件
		trigger: function(element, eventName){
			var ev;
			if(document.createEvent){
				ev = document.createEvent("HTMLEvents");
				ev.initEvent(eventName, true, false);
				element.dispatchEvent(ev);
			}
			else{
				element.fireEvent("on" + eventName);
			}
		},
	
		addClass: function(elementOrNodeList, className){
			this.eachElement(elementOrNodeList, _addClass, className);
			return elementOrNodeList;
		},
		removeClass: function(elementOrNodeList, className){
			this.eachElement(elementOrNodeList, _removeClass, className);
			return elementOrNodeList;
		},
		hasClass: function(elem, className){
			if(!elem) return false;
			return _hasClass(elem, className);
		},
		toggleClass: function(element, className, stateValue){
			var ifNeedAddClass;
			if(!element || !className) return;
	
			ifNeedAddClass = typeof stateValue === "undefined"
				? !_hasClass(element, className)
				: stateValue;
	
			if(ifNeedAddClass){
				_addClass(element, className);
			}
			else{
				_removeClass(element, className);
			}
		},
		appendHTMLTo: function(element, html){
			if(!element) return;
	
			var tmpDiv = document.createElement("div");
			var documentFragment = document.createDocumentFragment();
			var children;
			var el;
	
			tmpDiv.innerHTML = html;
			children = tmpDiv.childNodes;
			el = children[0];
	
			while(children.length > 0){
				documentFragment.appendChild(children[0]);
			}
	
			element.appendChild(documentFragment);
			return el;
		},
		appendHTMLToBody: function(html){
			return this.appendHTMLTo(document.body, html);
		},
		createElementFromHTML: function(html){
			var tmpDiv = document.createElement("div");
			tmpDiv.innerHTML = html;
			return tmpDiv.childNodes[0];
		},
		removeDom: function(elem){
			if(!elem) return;
			if(elem.remove){
				elem.remove();
			}
			else if(elem.parentNode){
				elem.parentNode.removeChild(elem);
			}
			else{}
		},
	};
	
	function _isNodeList(nodes){
		var stringRepr = Object.prototype.toString.call(nodes);
		return typeof nodes === "object"
			&& /^\[object (HTMLCollection|NodeList|Object)\]$/.test(stringRepr)
			&& typeof nodes.length === "number"
			&& (nodes.length === 0 || (typeof nodes[0] === "object" && nodes[0].nodeType > 0));
	}
	
	function _addClass(elem, className){
		if(!_hasClass(elem, className)){
			elem.className += " " + className;
		}
	}
	
	function _removeClass(elem, className){
		if(_hasClass(elem, className)){
			elem.className = (
				(" " + elem.className + " ")
				.replace(new RegExp(" " + className + " ", "g"), " ")
			).trim();
		}
	}
	
	function _hasClass(elem, className){
		return !!~(" " + elem.className + " ").indexOf(" " + className + " ");
	}


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var domUtils =	__webpack_require__(215);
	
	var _eventSplitter = /\s+/;
	var _delegateEventSplitter = /^(\S+)\s*(.*)$/;
	var _cid = 0;
	var _slice = [].slice;
	
	var _Events = {
		// Bind an event to a `callback` function.
		// Passing `"all"` will bind the callback to all events fired.
		on: function(name, callback, context){
			var events;
			// name 将递归分解到单位长度
			if(
				!_eventsApi(this, "on", name, [callback, context])
				|| !callback
			){
				return this;
			}
			// name 单位长度时，记录
			this._events || (this._events = {});
			events = this._events[name] || (this._events[name] = []);
			events.push({
				callback: callback,
				context: context,
				ctx: context || this
			});
			return this;
		},
		// Bind an event to only be triggered a single time. After the first time
		// the callback is invoked, it will be removed.
		once: function(name, callback, context){
			var me = this;
			var once;
			if(
				!_eventsApi(this, "once", name, [callback, context])
				|| !callback
			){
				return this;
			}
			once = _.once(function(){
				me.off(name, once);
				// 这个 this 不是外面的 this
				callback.apply(this, arguments);
			});
			once._callback = callback;
			return this.on(name, once, context);
		},
		// Remove one or many callbacks.
		// If `context` is null, removes all callbacks with that function.
		// If `callback` is null, removes all callbacks for the event.
		// If `name` is null, removes all bound callbacks for all events.
		off: function(name, callback, context){
			var retain,	//
				ev,
				events,
				names,
				i,
				l,
				j,
				k;
			// name 将递归分解到单位长度
			if(
				!this._events
				|| !_eventsApi(this, "off", name, [callback, context])
			){
				return this;
			}
			// name 单位长度时，off events
			if(!name && !callback && !context){
				this._events = void 0;
				return this;
			}
			names = name ? [name] : _.keys(this._events);
			for(i = 0, l = names.length; i < l; i++){
				name = names[i];
				events = this._events[name];
				if(events){
					this._events[name] = retain = [];
					if(callback || context){
						for(j = 0, k = events.length; j < k; j++){
							ev = events[j];
							if(
								(
									callback && callback !== ev.callback
									&& callback !== ev.callback._callback
								)
								||
								(
									context && context !== ev.context
								)
							){
								retain.push(ev);
							}
						}
					}
					// 逐个剔除
					if(!retain.length){
						delete this._events[name];
					}
				}
			}
			return this;
		},
		// Trigger one or many events, firing all bound callbacks.
		// Callbacks are passed the same arguments as `trigger` is, apart from the event name
		// (unless you're listening on `"all"`, which will cause your callback to receive the true name of the event as the first argument).
		trigger: function(name){
			var args;
			var events;
			var allEvents;
			if(!this._events){
				return this;
			}
			args = _slice.call(arguments, 1);
			// name 将递归分解到单位长度
			if(!_eventsApi(this, "trigger", name, args)){
				return this;
			}
			// name 单位长度时，trigger events
			events = this._events[name];
			// 如果 on 过 all，拿出 all 下的所有 cbObj 逐一执行，不管 name 匹配
			allEvents = this._events.all;
			if(events){
				_triggerEvents(events, args);
			}
			if(allEvents){
				_triggerEvents(allEvents, arguments);
			}
			return this;
		},
		listen: function(obj, name, callback, once){
			// 此时 this 是 view 实例
			var listeningTo = this._listeningTo || (this._listeningTo = {});
			var id = obj._listenId || (obj._listenId = _.uniqueId("l"));
			// 信使被记录，随机的 id 作为 key
			listeningTo[id] = obj;
			// 本句忽略，不常用
			if(!callback && typeof name === "object"){
				callback = this;
			}
			// this 是这里绑定的
			once
				? obj.once(name, callback, this)
				: obj.on(name, callback, this);
			return this;
		},
		listenTo: function(obj, name, callback){
			return this.listen(obj, name, callback, false);
		},
		listenToOnce: function(obj, name, callback){
			return this.listen(obj, name, callback, true);
		},
		// Tell this object to stop listening to either specific events ... or
		// to every object it's currently listening to.
		stopListening: function(obj, name, callback){
			var listeningTo = this._listeningTo;
			var id;
			var remove;
			if(!listeningTo){
				return this;
			}
			remove = !name && !callback;
			if(!callback && typeof name === "object"){
				callback = this;
			}
			if(obj){
				(listeningTo = {})[obj._listenId] = obj;
			}
			for(id in listeningTo){
				obj = listeningTo[id];
				obj.off(name, callback, this);
				if(remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
			}
			return this;
		}
	};
	
	var clzUtils = {
		//
		createClass: function(protoProps, staticProps, clz){
			// var clzname = constructor.toString().match(/^function (.*)\(/)[1];
			// if(clzname) throw new Error("Class must provide a name.");
			// 代理类构造器
			clz = clz || function(){
				this.cid = ++_cid;
				this.init.apply(this, arguments);
			};
			clz.prototype.init = function(){};
			staticProps && _.extend(clz, staticProps);
			// 所有类 100% 具备 trigger 能力
			protoProps && _.extend(clz.prototype, _Events, protoProps);
			return clz;
		},
	
		// 具备 dom events 处理能力
		createView: function(protoProps, staticProps, name){
			var _liveEvents;
			var viewProto;
			var clz = name ? congrets : clzz;
			function clzz(){
				this.cid = ++_cid;
				this.init.apply(this, arguments);
				this.delegateEvents();
			}
			function congrets(){
				this.cid = ++_cid;
				this.init.apply(this, arguments);
				this.delegateEvents();
			}
			// 折中一下，放到类定义闭包里
			_liveEvents = {
				findWrapped: function(dom, event, oriHandler, cid){
					var targetEvtInfo;
					// _.filter return []
					var targetIndex = _.findIndex(
						this[event][cid],
						function(efo){
							return efo.elem == dom && efo.handler == oriHandler;
						}
					);
					if(~targetIndex){
						targetEvtInfo = this[event][cid][targetIndex];
						return {
							// 被 dom、eventType、oriHandler 唯一锁定的 wrapped
							wrapped: targetEvtInfo.wrapped,
							idx: targetIndex
						};
					}
				},
				isWatching: function(){
					return this.findWrapped.apply(this, arguments);
				},
				createPackage: function(cid, event){
					this[event] = this[event] || {};
					this[event][cid] = this[event][cid] || [];
				}
			};
			// 能作为索引的，尽量剥离一层，使得循环更少，对比简单
			// _liveEvents: {
			// 	event: {
			//		// 加一层 cid 是为了支持 unwatch 整个 dom
			// 		cid: [
			// 			// handler & elem 不能作为索引，就得借助一个索引
			//			{
			// 				elem: dom,
			// 				handler: handler,
			// 				wrapped: wrapped,
			// 			}
			//		]
			// 	}
			// }
			viewProto = {
				cid: -1,
				$el: document.createElement("div"),
				// 不冒泡的、延迟监听的、非子节点的、View 的，不能走 events
				events: {},
				// 修改 this 指向的 on，并缓存，否则 off 不了了就
				watchDom: function(elementsOrSelector, event, oriHandler, once){
					var selector;
					var elements;
					var wrappedHandler;
					var me = this;
					_liveEvents.createPackage(this.cid, event);
					(typeof elementsOrSelector === "string")
						? interWatch()
						: directWatch();
					function interWatch(){
						selector = elementsOrSelector;
						if(_liveEvents.isWatching(me.$el, event, oriHandler, me.cid)){
							throw new Error("重复监听");
						}
						// wrappedHandler 要处理 srcElement
						wrappedHandler = _live(
							selector,
							event,
							_.bind(oriHandler, me),
							me.$el
						);
						_liveEvents[event][me.cid].push({
							elem: me.$el,
							event: event,
							handler: oriHandler,
							wrapped: wrappedHandler,
							selector: selector,
						});
					}
					function directWatch(){
						elements = elementsOrSelector;
						if(_liveEvents.isWatching(elements, event, oriHandler, me.cid)){
							throw new Error("重复监听");
						}
						// wrappedHandler 要处理 srcElement
						wrappedHandler = _.bind(function(e){
							e.target = e.target || e.srcElement;
							oriHandler.apply(this, arguments);
						}, me);
						once
							? _one(elements, event, wrappedHandler)
							: _on(elements, event, wrappedHandler);
						_liveEvents[event][me.cid].push({
							elem: elements,
							event: event,
							handler: oriHandler,
							wrapped: wrappedHandler,
							selector: "",
						});
					}
				},
				watchDomOnce: function(elementsOrSelector, event, oriHandler){
					this.watchDom(elementsOrSelector, event, oriHandler, true);
				},
				unWatchDom: function(elements, event, oriHandler){
					var wrappedInfo;
					var wrappedInfos;
					_liveEvents.createPackage(this.cid, event);
					wrappedInfos = _liveEvents[event][this.cid];
					if(oriHandler && event && elements){
						wrappedInfo = _liveEvents.findWrapped(elements, event, oriHandler, this.cid);
						if(wrappedInfo){
							_off(elements, event, wrappedInfo.wrapped);
							wrappedInfos.splice(wrappedInfo.idx, 1);
						}
					}
					// 否则就消除改 dom 全部事件
					else if(elements){
						_.each(_liveEvents, function(typeInfo, event){
							_.each(typeInfo, function(instanceListenTo, cid){
								_.each(instanceListenTo, function(evtInfo, idx){
									_off(elements, event, evtInfo.wrapped);
									instanceListenTo.splice(idx, 1);
								});
							});
						});
					}
				},
				delegateEvents: function(events){
					return _domEventAction.apply(this, [events, true]);
				},
				undelegateEvents: function(events){
					return _domEventAction.apply(this, [events, false]);
				},
				remove: function(){
					this.removing();
					this.undelegateEvents();
					domUtils.removeDom(this.$el);
					this.stopListening();
					return this;
				},
				removing: function(){},
			};
			_.extend(viewProto, protoProps);
			return this.createClass(viewProto, staticProps, clz);
		},
	
		extendClass: function(parent, protoProps, staticProps){
			// 链式回溯所有上级构造器
			var child = function(){ return parent.apply(this, arguments); };
			function surrogate(){ this.constructor = child; }
			surrogate.prototype = parent.prototype;
			child.prototype = new surrogate();
			//
			staticProps && _.extend(child, parent, staticProps);
			protoProps && _.extend(child.prototype, protoProps);
			return child;
		},
	
		getEventsProto: function(){
			return _.clone(_Events);
		},
	
	};
	
	// VIEW 事件
	function _eventsApi(obj, action, name, rest){
		var names;
		var i, l;
		if(!name){
			return true;
		}
		// 是否是多个 name
		if(_eventSplitter.test(name)){
			names = name.split(_eventSplitter);
			for(i = 0, l = names.length; i < l; i++){
				// on/off 执行
				obj[action].apply(obj, [names[i]].concat(rest));
			}
			return false;
		}
		return true;
	}
	
	function _triggerEvents(events, args){
		var ev,
			i = -1,
			l = events.length,
			a1 = args[0],
			a2 = args[1],
			a3 = args[2];
		switch(args.length){
		case 0:
			while(++i < l) (ev = events[i]).callback.call(ev.ctx); return;
		case 1:
			while(++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
		case 2:
			while(++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
		case 3:
			while(++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
		default:
			while(++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
		}
	}
	
	// VIEW dom event
	// 需要绑定 this
	function _domEventAction(events, isDelegate){
		var key;
		var method;
		var match;
		var eventName;
		var selector;
		if(!(events || (events = _.result(this, "events")))){
			return this;
		}
		isDelegate && this.undelegateEvents();
		for(key in events){
			method = events[key];
			if(!_.isFunction(method)){
				method = this[events[key]];
			}
			if(!method){
				// continue;
				throw new Error(key + " " + events[key] + ": handler is not a function");
			}
			match = key.match(_delegateEventSplitter);
			eventName = match[1];
			selector = match[2];
			// method = _.bind(method, this);
			// eventName += ".delegateEvents" + this.cid;
			if(isDelegate){
				this.watchDom(
					selector === "" ? this.$el : selector,
					eventName,
					method
				);
			}
			else{
				// 这里都是遍历 events 的，所以 off 一定是 $el
				this.unWatchDom(
					this.$el,
					eventName,
					method
				);
			}
		}
		return this;
	}
	
	function _bind(elem, evt, handler, isCapture){
		if(elem.addEventListener){
			elem.addEventListener(evt, handler, isCapture);
		}
		else if(elem.attachEvent){
			elem.attachEvent("on" + evt, handler);
		}
	}
	function _unbind(elem, evt, handler){
		if(elem.removeEventListener && handler){
			elem.removeEventListener(evt, handler);
		}
		else if(elem.detachEvent){
			elem.detachEvent("on" + evt, handler);
		}
	}
	function _on(elements, event, handler, isCapture){
		domUtils.eachElement(elements, _bind, event, handler, isCapture);
	}
	function _off(elements, event, handler){
		domUtils.eachElement(elements, _unbind, event, handler);
	}
	function _one(element, ev, handler, isCapture){
		if(!element || !ev){
			return;
		}
		_bind(element, ev, tempFn, isCapture);
		function tempFn(){
			handler.apply(this, arguments);
			_unbind(element, ev, tempFn);
		}
	}
	function _live(selector, ev, handler, wrapper){
		var container = wrapper || document;
		_on(container, ev, wrappedHandler);
		function wrappedHandler(e){
			var evt = e || window.event;
			var target = evt.target = evt.target || evt.srcElement;
			var parentOfTarget = target.parentNode;
			var targetList;
			var i;
			var l;
			var currentElement;
			// 兼容多种 selector 类型
			if(typeof selector === "string"){
				targetList = container.querySelectorAll(selector);
			}
			else{
				targetList = selector.length ? selector : [selector];
			}
			for(i = 0, l = targetList.length; i < l; ++i){
				currentElement = targetList[i];
				if(currentElement === target){
					handler.call(target, evt);
				}
				else if(currentElement === parentOfTarget){
					handler.call(parentOfTarget, evt);
				}
			}
		}
		return wrappedHandler;
	}
	
	
	module.exports = clzUtils;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var utils =			__webpack_require__(16);
	var domUtils =		__webpack_require__(215);
	var classUtils =	__webpack_require__(216);
	var tpl =			__webpack_require__(218);
	
	module.exports = classUtils.createView({
	
		events: {
			"click .cancel-btn": "hide",
			"click .confirm-btn": "confirm",
		},
	
		init: function(opt){
			var contentDom;
			var className;
	
			opt = opt || {};
			className = opt.className;
			contentDom = opt.contentDom || "";
	
			this.$el = domUtils.createElementFromHTML(tpl);
			this.footer = this.$el.querySelector(".footer");
			this.cancelBtn = this.footer.querySelector(".cancel-btn");
			this.confirmBtn = this.footer.querySelector(".confirm-btn");
	
			className && domUtils.addClass(this.$el, className);
			if(typeof contentDom === "string"){
				contentDom = domUtils.createElementFromHTML(contentDom);
			}
			contentDom && this.$el.insertBefore(contentDom, this.footer);
			document.body.appendChild(this.$el);
		},
	
		show: function(){
			domUtils.removeClass(this.$el, "hide");
			return this;
		},
	
		hide: function(){
			domUtils.addClass(this.$el, "hide");
			return this;
		},
	
		confirm: function(){
			this.hide();
			return this;
		},
	
		toggle: function(){
			utils.toggle(this.$el, "hide");
			return this;
		},
	
		addButton: function(opt){
			opt = opt || {};
			domUtils.removeClass(this.footer, "hide");
			this.confirmBtn.innerText = opt.confirmText || "确定";
			opt.hideCancel && domUtils.addClass(this.cancelBtn, "hide");
	
			var _hide = this.hide;
			var _confirm = this.confirm;
	
			// 重新监听前（原函数被覆盖前）前要先注销，否则覆盖完就对应不上，不能去除监听。
			this.undelegateEvents();
	
			this.hide = function(){
				(opt.cancel || utils.noop)();
				return _hide.apply(this);
			};
			this.confirm = function(){
				var result = (opt.confirm || utils.noop)();
				(result !== false) && _confirm.apply(this);
				return this;
			};
	
			// 覆盖 events 的回调后，重新监听。
			this.delegateEvents();
			return this;
		},
	
	});


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"em-dialog hide\"> <div class=\"footer hide\"> <button class=cancel-btn>取消</button> <button class=\"confirm-btn bg-color\"></button> </div> </div> ";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var domUtils =		__webpack_require__(215);
	var classUtils =	__webpack_require__(216);
	var tpl =			__webpack_require__(220);
	
	// prompt 不会消失
	// tip 2 秒后自动消失
	var Tips = classUtils.createView({
	
		hideTimer: 0,
	
		init: function(){
			this.hideTimer = 0;
			this.$el = domUtils.createElementFromHTML(tpl);
			this.promptTextSpanDom = this.$el.querySelector("span");
		},
	
		prompt: function(msg){
			this.promptTextSpanDom.innerText = msg;
			domUtils.removeClass(this.$el, "hide");
		},
	
		hidePrompt: function(){
			domUtils.addClass(this.$el, "hide");
		},
	
		tip: function(msg){
			this.prompt(msg);
			clearTimeout(this.hideTimer);
			this.hideTimer = setTimeout(_.bind(this.hidePrompt, this), 2000);
		},
	});
	
	var tips = new Tips();
	var widgetWrapper = document.querySelector(".em-widget-wrapper");
	widgetWrapper && widgetWrapper.appendChild(tips.$el);
	module.exports = tips;


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"em-widget-error-prompt hide\"> <span></span> </div> ";

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	module.exports = "<p>未解决原因：</p> <ul class=em-taglist> <% _.each(tags, function(tag){ %> <li class=em-tag tagid=\"<%= tag.id %>\"><%= tag.name %></li> <% }) %> </ul> ";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var apiHelper = __webpack_require__(181);
	
	var preventTimestamp = 0;
	var inputState;
	var agentInputStateTimer = null;
	
	module.exports = function(){
		var topBar;
	
		if(!profile.grayList.agentInputStateEnable) return;
	
		topBar = document.querySelector(".em-widget-header");
		inputState = topBar.querySelector(".em-agent-input-state");
	
		// start timer
		agentInputStateTimer = setInterval(function(){
			var officialAccount = profile.currentOfficialAccount;
			_update(officialAccount);
		}, _const.AGENT_INPUT_STATE_INTERVAL);
	
		eventListener.add(_const.SYSTEM_EVENT.SESSION_OPENED, _update);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_CLOSED, _update);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERED, _update);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_RESTORED, _update);
		eventListener.add(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_SWITCHED, _update);
		eventListener.add(_const.SYSTEM_EVENT.CLEAR_AGENTINPUTSTATE, _clearTimer);
	};
	
	function _update(officialAccount){
		var state;
		var sessionId;
		var agentType;
	
		if(
			officialAccount !== profile.currentOfficialAccount
			|| !officialAccount
			|| !profile.isChatWindowOpen
			|| utils.isBrowserMinimized()
		) return;
	
		state = officialAccount.sessionState;
		sessionId = officialAccount.sessionId;
		agentType = officialAccount.agentType;
	
		if(
			sessionId
			&& state === _const.SESSION_STATE.PROCESSING
			&& agentType !== _const.AGENT_ROLE.ROBOT
		){
			apiHelper.getAgentInputState(sessionId).then(function(entity){
				var currentTimestamp = entity.timestamp;
				var ifDisplayTypingState = entity.input_state_tips;
	
				// 为了先发送的请求后回来的异步问题，仅处理时间戳比当前大的response
				if(currentTimestamp > preventTimestamp){
					preventTimestamp = currentTimestamp;
					utils.toggleClass(inputState, "hide", !ifDisplayTypingState);
				}
			});
		}
		else{
			utils.addClass(inputState, "hide");
		}
	}
	function _clearTimer(){
		clearInterval(agentInputStateTimer);
	}


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var apiHelper = __webpack_require__(181);
	
	var $agentStatusText;
	var agentStateTimer = null;
	
	module.exports = function(){
		var topBar = document.querySelector(".em-widget-header");
		$agentStatusText = topBar.querySelector(".em-header-status-text");
	
		// 开始轮询坐席状态
		agentStateTimer = setInterval(function(){
			var officialAccount = profile.currentOfficialAccount;
			_setAgentStatus(officialAccount);
		}, 5000);
	
		eventListener.add(_const.SYSTEM_EVENT.SESSION_OPENED, _setAgentStatus);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERED, _setAgentStatus);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_CLOSED, _setAgentStatus);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERING, _setAgentStatus);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_RESTORED, _setAgentStatus);
		eventListener.add(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_SWITCHED, function(officialAccount){
			_update(officialAccount.status);
		});
		eventListener.add(_const.SYSTEM_EVENT.CLEAR_AGENTSTATE, _clearTimer);
	};
	
	function _setAgentStatus(officialAccount){
		if(
			officialAccount !== profile.currentOfficialAccount
			|| !officialAccount
			|| !profile.isChatWindowOpen
			|| utils.isBrowserMinimized()
		) return;
	
		var agentId = officialAccount.agentId;
		var agentType = officialAccount.agentType;
		var isSessionOpen = officialAccount.isSessionOpen;
	
		if(
			!profile.isAgentNicknameEnable
			|| !agentId
			|| !isSessionOpen
		){
			_update(null);
		}
		else if(agentType === _const.AGENT_ROLE.ROBOT){
			// 机器人不去轮询，显示为在线
			_update("Online");
		}
		else{
			apiHelper.getAgentStatus(agentId).then(function(status){
				officialAccount.agentState = status;
				_update(status);
			});
		}
	}
	
	function _update(status){
	    var agentStatusText = _const.agentStatusText[status || "Other"];
	    if (profile.isHideCustomerStatus) {
	        $agentStatusText.innerText = '';
	    } else {
	        $agentStatusText.innerText = agentStatusText;
	    }
	}
	
	function _clearTimer(){
		clearInterval(agentStateTimer);
	}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var apiHelper = __webpack_require__(181);
	
	var visitorLeaveTimer = null;
	module.exports = function(){
	
		_init();
	
		eventListener.add(_const.SYSTEM_EVENT.SESSION_RESTORED, function(){
			// console.log("_const.SYSTEM_EVENT.SESSION_RESTORED");
		});
		eventListener.add(_const.SYSTEM_EVENT.SESSION_OPENED, _init);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_CLOSED, _clearTimer);
		eventListener.add(_const.SYSTEM_EVENT.CHAT_CLOSED, _clearTimer);
		eventListener.add(_const.SYSTEM_EVENT.CHAT_WINDOW_OPENED, _init);
	};
	function _init(){
	
		_clearTimer();
	
		// 开始轮询访客状态
		visitorLeaveTimer = setInterval(function(){
			var officialAccount = profile.currentOfficialAccount;
			_setVisitorStatus(officialAccount);
		}, 3000);
	}
	function _setVisitorStatus(officialAccount){
		var agentType = officialAccount.agentType;
		var isSessionOpen = officialAccount.isSessionOpen;
		var sessionId = officialAccount.sessionId;
	
		if(
			profile.grayList.visitorLeave &&
			isSessionOpen &&
			agentType === _const.AGENT_ROLE.AGENT &&
			sessionId){
			apiHelper.startKeep({ serviceSessionId: sessionId });
		}
		else{
			_clearTimer();
		}
	}
	
	function _clearTimer(){
		clearInterval(visitorLeaveTimer);
	}


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var apiHelper = __webpack_require__(181);
	var commonConfig = __webpack_require__(177);
	
	var preventTimestamp = 0;
	var $queuingNumberStatus;
	var $queuingNumberLabel;
	var abandonQueueBtn;
	
	module.exports = function () {
		eventListener.add(_const.SYSTEM_EVENT.SESSION_OPENED, _getExitState);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_CLOSED, _getExitState);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERED, _getExitState);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_CREATED, _getExitState);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_RESTORED, _getExitState);
		eventListener.add(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_SWITCHED, _getExitState);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERING, _getExitState);
		if (!profile.grayList.waitListNumberEnable) return;
		var editorView = document.querySelector(".em-widget-send-wrapper");
		$queuingNumberStatus = editorView.querySelector(".queuing-number-status");
		$queuingNumberLabel = $queuingNumberStatus.querySelector("label");
	
		abandonQueueBtn = editorView.querySelector(".em-widget-abandon-queue");
	
		// 海外集群10秒轮询一次，海外集群的tenantid是1000000开始的
		var config = commonConfig.getConfig();
		var t = 1000;
		if (config.tenantId >= 1000000) {
			t = 10000;
		}
		else {
			t = 1000;
		}
		// 开始轮询排队人数
		setInterval(function () {
			var officialAccount = profile.currentOfficialAccount;
			_getQueuingNumber(officialAccount);
		}, t);
	
		eventListener.add(_const.SYSTEM_EVENT.SESSION_OPENED, _getQueuingNumber);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_CLOSED, _getQueuingNumber);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERED, _getQueuingNumber);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_CREATED, _getQueuingNumber);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_RESTORED, _getQueuingNumber);
		eventListener.add(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_SWITCHED, _getQueuingNumber);
	};
	
	function _getQueuingNumber(officialAccount) {
		if (
			officialAccount !== profile.currentOfficialAccount
			|| !officialAccount
			|| !profile.isChatWindowOpen
			|| utils.isBrowserMinimized()
		) return;
	
		var state = officialAccount.sessionState;
		var queueId = officialAccount.skillGroupId;
		var sessionId = officialAccount.sessionId;
		var officialAccountId = officialAccount.official_account_id;
	
		if (state === _const.SESSION_STATE.WAIT && sessionId) {
			if (queueId) {
				apiHelper.getWaitListNumber(sessionId, queueId).then(function (entity) {
					var waitingNumber = entity.visitorUserWaitingNumber;
					var currentTimestamp = entity.visitorUserWaitingTimestamp;
	
					if (currentTimestamp > preventTimestamp) {
						preventTimestamp = currentTimestamp;
						_update(waitingNumber);
					}
				});
			}
			else {
				apiHelper.getLastSession(officialAccountId).then(function (entity) {
					officialAccount.skillGroupId = entity.skill_group_id;
					profile.latestNiceName = entity.agent_nice_name;
				});
			}
		}
		else {
			_update(null);
		}
	}
	function _getExitState(officialAccount) {
		var exit = document.querySelector(".em-widget-out-of-line"); //访客退队按钮
		var state = officialAccount.sessionState;
		var sessionId = officialAccount.sessionId;
		if (state === _const.SESSION_STATE.WAIT && sessionId) {
			$(exit).removeClass("hide");
			eventListener.trigger("swiper.update");
		}
		else {
			$(exit).addClass("hide");
			eventListener.trigger("swiper.update");
		}
	}
	
	function _update(waitingNumber) {
		var config = commonConfig.getConfig();
		var logo = document.querySelector(".easemob-copyright");
		// 没有人排队会返回 no
		if (!waitingNumber || waitingNumber === "no") {
			utils.addClass($queuingNumberStatus, "hide");
			$(logo).css("marginTop", "30px")
			// 改变button的top todo
			eventListener.trigger("swiper.update");
			// $(".em-widget-send-wrapper-top").css("top","0px");
			// 放弃排队
			if (config.options.visitorAbandonQueue == "true") {
				utils.addClass(abandonQueueBtn, "hide");
			}
		}
		else {
			utils.removeClass($queuingNumberStatus, "hide");
			$queuingNumberLabel.innerHTML = waitingNumber;
			// document.querySelector(".em-widget-out-of-line")
			$(logo).css("marginTop", "5px")
			eventListener.trigger("swiper.update");
			$(".em-widget-send-wrapper-top").css("top", "-40px");
	
			// 放弃排队
			if (config.options.visitorAbandonQueue == "true") {
				utils.removeClass(abandonQueueBtn, "hide");
			}
		}
	}


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var apiHelper = __webpack_require__(181);
	var channel = __webpack_require__(186);
	var commonConfig = __webpack_require__(177);
	
	var toKefuBtn;
	var toTicketBtn;
	var sendMsgNumber = 1;
	var msgOptionNumber;
	
	module.exports = function(){
		if(!commonConfig.getConfig().toolbar.transferToKefu) return;
	
		var editorView = document.querySelector(".em-widget-send-wrapper");
		toKefuBtn = editorView.querySelector(".em-widget-to-kefu");
		toTicketBtn = editorView.querySelector(".em-widget-to-ticket");
		// toKefuBtn = document.querySelector(".em-widget-to-kefu-input-button");
		textareaBtn = editorView.querySelector(".em-widget-textarea");
	
		// 人工客服接起会话
	
		utils.on(toKefuBtn, "click", _.throttle(function(){
			channel.sendTransferToKf();
		}, 8000, { trailing: false }));
	
		// 获取发送几次消息显示转人工按钮配置
		apiHelper.getMsgNumberOption().then(function(data){
			msgOptionNumber = data[0] ? Number(data[0].optionValue) : 0;
			sendMsgNumber = msgOptionNumber;
		});
	
		// 把注册事件和方法提取到新增的输入框上方按钮文件
		eventListener.add(_const.SYSTEM_EVENT.SESSION_OPENED, _displayOrHideTransferToKefuBtn);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERING, _displayOrHideTransferToKefuBtn);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERED, _displayOrHideTransferToKefuBtn);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_RESTORED, _displayOrHideTransferToKefuBtn);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_NOT_CREATED, _displayOrHideTransferToKefuBtn);
		eventListener.add(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_SWITCHED, _displayOrHideTransferToKefuBtn);
	
		eventListener.add(_const.SYSTEM_EVENT.SEND_MESSAGE, _reduceMsgNumber);
		// 结束会话，计数重新计算
		eventListener.add(_const.SYSTEM_EVENT.SESSION_CLOSED, function(){
			sendMsgNumber = msgOptionNumber;
		});
	};
	
	function _reduceMsgNumber(officialAccount){
		if(sendMsgNumber && sendMsgNumber > 0){
			sendMsgNumber--;
		}
	
		if(sendMsgNumber == 0){
			_displayOrHideTransferToKefuBtn(officialAccount);
		}
	}
	
	function _displayOrHideTransferToKefuBtn(officialAccount){
		// 忽略非当前服务号的事件
		if(profile.currentOfficialAccount !== officialAccount) return;
	
		var state = officialAccount.sessionState;
		var agentType = officialAccount.agentType;
		var type = officialAccount.type;
		var isRobotAgent = agentType === _const.AGENT_ROLE.ROBOT;
	
		if(type === "CUSTOM"){
			// 营销号一律不显示转人工按钮
			utils.addClass(toKefuBtn, "hide");
		}
		// Processing
		else if(state === _const.SESSION_STATE.PROCESSING){
			if(sendMsgNumber <= 0){
				if(utils.hasClass(toTicketBtn, "hide")){
					utils.toggleClass(toKefuBtn, "hide", !isRobotAgent);
				}
			}
		}
		// Wait
		else if(state === _const.SESSION_STATE.WAIT){
			// 待接入状态 隐藏按钮
			utils.addClass(toKefuBtn, "hide");
		}
		else{
			if(!officialAccount.isSessionOpen) return;
			apiHelper.getRobertIsOpen().then(function(isRobotEnable){
				utils.toggleClass(toKefuBtn, "hide", !isRobotEnable);
			});
		}
	
		if(utils.isMobile){
			if(utils.hasClass(toKefuBtn, "hide")){
				textareaBtn.style.maxWidth = "calc(100% - 45px)";
			}
			else{
				textareaBtn.style.maxWidth = "calc(100% - 90px)";
			}
		}
		
		
	}


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var apiHelper = __webpack_require__(181);
	var createSessionList = __webpack_require__(228);
	var createMessageView = __webpack_require__(229);
	var createCtaDialog = __webpack_require__(233);
	
	var sessionListBtn;
	var redDotDom;
	var sessionListView;
	var statusBar;
	var ctaDialog;
	var parentContainer;
	
	module.exports = function(){
		var topBar = document.querySelector(".em-widget-header");
		sessionListBtn = topBar.querySelector(".session-list-btn");
		redDotDom = sessionListBtn.querySelector(".notice");
		statusBar = topBar.querySelector(".status-bar");
		parentContainer = document.querySelector(".chat-wrapper");
	
		eventListener.add(_const.SYSTEM_EVENT.MESSAGE_SENT, function(){
			var officialAccount = profile.currentOfficialAccount;
			if(!officialAccount) return;
			_reportReplied(officialAccount);
		});
		eventListener.add(_const.SYSTEM_EVENT.MARKETING_MESSAGE_RECEIVED, _onMarketingMessageReceived);
		eventListener.add(_const.SYSTEM_EVENT.NEW_OFFICIAL_ACCOUNT_FOUND, _newOfficialAccountFound);
	
		eventListener.add(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_SWITCHED, function(officialAccount){
			officialAccount.messageView.scrollToBottom();
			utils.removeClass(statusBar, "hide");
			_attemptToGetMarketingTaskInfo(officialAccount);
			_reportOpened(officialAccount);
			_clearUnreadCount(officialAccount);
		});
	
		eventListener.add(_const.SYSTEM_EVENT.CHAT_WINDOW_OPENED, function(){
			var officialAccount = profile.currentOfficialAccount;
			if(_.isEmpty(officialAccount)) return;
			officialAccount.messageView.scrollToBottom();
			_reportOpened(officialAccount);
			_clearUnreadCount(officialAccount);
		});
	
		eventListener.add(_const.SYSTEM_EVENT.SYSTEM_OFFICIAL_ACCOUNT_UPDATED, function(){
			sessionListView.updateItem(profile.systemOfficialAccount, "default");
		});
	
		eventListener.add(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_LIST_GOT, function(){
			if(profile.ctaEnable){
				utils.trigger(sessionListBtn, "click");
			}
		});
	
		eventListener.add(_const.SYSTEM_EVENT.MESSAGE_APPENDED, function(officialAccount, msg){
			if(officialAccount === profile.currentOfficialAccount) return;
	
			var msgBrief = msg.brief;
			var formattedTimestamp = utils.formatDate(_.now());
			var officialAccountId = officialAccount.official_account_id;
	
			officialAccount.unreadMessageIdList.add(msg.id);
			sessionListView.updateLatestMessage(officialAccountId, msgBrief, formattedTimestamp);
			sessionListView.updateUnreadCount(officialAccountId, officialAccount.unreadMessageIdList.getLength());
			_updateSessionListRedDotStatus();
		});
	};
	
	function _updateSessionListRedDotStatus(){
		var sumOfUnreadMessageCount = _.chain(profile.officialAccountList)
			// 取得每个服务号的未读消息数
		.map(function(officialAccount){
			return officialAccount.unreadMessageIdList.getLength();
		})
			// 求和
		.reduce(function(a, b){
			return a + b;
		})
			// 退出链式调用，并返回结果
		.value();
	
		var ifDisplayRedDot = !!sumOfUnreadMessageCount;
	
		utils.toggleClass(redDotDom, "hide", !ifDisplayRedDot);
	}
	
	function _clearUnreadCount(officialAccount){
		var officialAccountId = officialAccount.official_account_id;
		officialAccount.unreadMessageIdList.removeAll();
		sessionListView.updateUnreadCount(officialAccountId, null);
		_updateSessionListRedDotStatus();
	}
	
	function _attemptToGetMarketingTaskInfo(officialAccount){
		if(officialAccount.type === "SYSTEM" || officialAccount.hasGotMarketingInfo) return;
	
		var officialAccountId = officialAccount.official_account_id;
		officialAccount.hasGotMarketingInfo = true;
		apiHelper.getLatestMarketingTask(officialAccountId).then(function(entity){
			officialAccount.bindSkillGroupName = utils.getDataByPath(entity, "schedule_info.skillgroup_name");
			officialAccount.bindAgentUsername = utils.getDataByPath(entity, "schedule_info.agent_username");
		});
	}
	
	function _reportReplied(officialAccount){
		_.each(officialAccount.unrepliedMarketingTaskIdList.getAll(), function(marketingTaskId){
			officialAccount.unrepliedMarketingTaskIdList.remove(marketingTaskId);
			apiHelper.reportMarketingTaskReplied(marketingTaskId);
		});
	}
	
	function _reportOpened(officialAccount){
		_.each(officialAccount.unopenedMarketingTaskIdList.getAll(), function(marketingTaskId){
			officialAccount.unopenedMarketingTaskIdList.remove(marketingTaskId);
			apiHelper.reportMarketingTaskOpened(marketingTaskId);
		});
	}
	
	function _onMarketingMessageReceived(officialAccount, marketingTaskId, msg){
		var avatar = officialAccount.img;
		var officialAccountId = officialAccount.official_account_id;
		var content = msg.brief;
		var title = utils.getDataByPath(msg, "ext.weichat.marketing.name");
		var scheduleInfo = utils.getDataByPath(msg, "ext.weichat.marketing.schedule_info") || {};
		officialAccount.bindSkillGroupName = scheduleInfo.skillgroup_name;
		officialAccount.bindAgentUsername = scheduleInfo.agent_username;
		officialAccount.hasGotMarketingInfo = true;
	
		officialAccount !== profile.currentOfficialAccount
			&& profile.currentOfficialAccount
			&& (ctaDialog = createCtaDialog({
				title: title,
				replyCallback: _switchToOfficialAccount,
				content: content,
				avatar: avatar,
				className: "cta-prompt",
				callbackMessage: officialAccountId
			}));
	
		if(
			profile.isChatWindowOpen
			&& officialAccount === profile.currentOfficialAccount
		){
			apiHelper.reportMarketingTaskOpened(marketingTaskId);
		}
		else{
			officialAccount.unopenedMarketingTaskIdList.add(marketingTaskId);
		}
	
		officialAccount.unrepliedMarketingTaskIdList.add(marketingTaskId);
		apiHelper.reportMarketingTaskDelivered(marketingTaskId);
	}
	
	function _switchToOfficialAccount(id){
		var targerOfficialAccountProfile = _.findWhere(profile.officialAccountList, { official_account_id: id });
	
		_.each(profile.officialAccountList, function(item){
			item.messageView.hide();
		});
	
		targerOfficialAccountProfile.messageView.show();
		profile.currentOfficialAccount = targerOfficialAccountProfile;
	
		eventListener.excuteCallbacks(
			_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_SWITCHED,
			[targerOfficialAccountProfile]
		);
	}
	
	function _newOfficialAccountFound(officialAccount){
		var type = officialAccount.type;
	
		officialAccount.messageView = createMessageView({
			officialAccount: officialAccount,
			parentContainer: parentContainer,
		});
	
		if(!sessionListView){
			sessionListView = createSessionList({
				itemOnClickCallback: _switchToOfficialAccount
			});
			utils.on(sessionListBtn, "click", function(){
				sessionListView.show();
				// 如果有ctaPromptDialog则关闭
				ctaDialog && ctaDialog.hide();
				profile.currentOfficialAccount = null;
				utils.addClass(statusBar, "hide");
			});
		}
		sessionListView.appendItem(officialAccount);
	
		// 有服务号消息时显示sessionList
		if(type === "CUSTOM"){
			utils.removeClass(sessionListBtn, "hide");
		}
	}


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var Dict = __webpack_require__(179);
	var uikit = __webpack_require__(180);
	
	var EMPTY_FUNCTION = function(){};
	var dialog;
	var listDom;
	var itemHashTable = new Dict();
	var itemOnClickCallback;
	
	module.exports = function(options){
		var opt = options || {};
		itemOnClickCallback = opt.itemOnClickCallback || EMPTY_FUNCTION;
	
		dialog = uikit.createDialog({
			className: "session-list",
			contentDom:  "<ul></ul>"
		});
		listDom = dialog.el.querySelector("ul");
	
		utils.live("li.session-item", "click", function(){
			var id = this.getAttribute("data-id");
			itemOnClickCallback(id);
			dialog.hide();
		}, listDom);
	
		return {
			appendItem: _appendItem,
			updateItem: _updateItem,
			updateLatestMessage: _updateLatestMessage,
			updateUnreadCount: _updateUnreadCount,
			show: dialog.show
		};
	};
	
	function _updateLatestMessage(itemId, textMessage, timestamp){
		var itemDom = itemHashTable.get(itemId);
		var latestMessageDom = itemDom.querySelector(".latest-message");
		var latestTimestamp = itemDom.querySelector(".latest-timestamp");
	
		latestTimestamp.innerText = timestamp;
		latestMessageDom.innerText = textMessage;
	
		listDom.insertBefore(itemDom, listDom.firstChild);
	}
	
	function _updateUnreadCount(itemId, unreadCount){
		var itemDom = itemHashTable.get(itemId);
		var unreadCountDom = itemDom.querySelector(".unread-count");
	
		if(!unreadCount || typeof unreadCount !== "number"){
			utils.addClass(unreadCountDom, "hide");
		}
		else if(unreadCount > 99){
			unreadCountDom.innerText = "...";
			utils.removeClass(unreadCountDom, "hide");
		}
		else{
			unreadCountDom.innerText = unreadCount;
			utils.removeClass(unreadCountDom, "hide");
		}
	}
	
	function _updateItem(item, oldId){
		var newId = item.official_account_id;
		var newItemDom = _renderItem(item);
		var oldItemDom = itemHashTable.get(oldId);
	
		listDom.replaceChild(newItemDom, oldItemDom);
		itemHashTable.set(newId, newItemDom);
		itemHashTable.remove(oldId);
	}
	
	function _appendItem(item){
		var id = item.official_account_id;
		var itemDom = _renderItem(item);
		listDom.appendChild(itemDom);
		itemHashTable.set(id, itemDom);
	}
	
	function _renderItem(item){
		var name = item.name;
		var id = item.official_account_id;
		var avatar = item.img || profile.defaultAvatar;
		return utils.createElementFromHTML([
			"<li class=\"session-item\" data-id=\"" + id + "\">",
			"<img class=\"avatar\" src=\"" + avatar + "\">",
			"<span class=\"name\">" + name + "</span>",
			"<span class=\"latest-message\"></span>",
			"<span class=\"latest-timestamp\"></span>",
			"<span class=\"unread-count hide\"></span>",
			"</li>"
		].join(""));
	}


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	var profile = __webpack_require__(178);
	var genDomFromMsg = __webpack_require__(230);
	var eventListener = __webpack_require__(185);
	var apiHelper = __webpack_require__(181);
	var channel = __webpack_require__(186);
	var commonConfig = __webpack_require__(177);
	var moment = __webpack_require__(17);
	var getToHost = __webpack_require__(190);
	
	var tpl = __webpack_require__(232);
	var closDate = [];
	
	module.exports = function(opt){
		// 当下全部都是 profile.systemOfficialAccount
		var officialAccount = opt.officialAccount;
		var parentContainer = opt.parentContainer;
		var el = utils.createElementFromHTML(_.template(tpl)({
			msg_in_loading: "loading...",
			no_more_msg: "no more messages",
		}));
		var loadingMore = el.querySelector(".loading-tip");
		var noMoreMsg = el.querySelector(".no-more-msg");
		var currHistoryMsgSeqId = 0;
		var noMoreHistoryMessage;
	
		var msgTimeSpanBegin = new Date(2099, 0).getTime();
		var msgTimeSpanEnd = new Date(1970, 0).getTime();
		var url;
		// if(profile.grayList.poweredByEasemob){
		// 	utils.addClass(el, "paddingTo48");
		// 	utils.addClass(noMoreMsg, "top34");
		// 	url = "http://www.easemob.com/product/cs?utm_source=csw&tenantid=" + commonConfig.getConfig().tenantId;
		// 	utils.appendHTMLTo(el, "<div class=\"easemob-copyright\"><a target=\"_blank\" href=" + url + "><span>即时聊天基于<i class=\"icon-easemob\"></i><span>环信</span></span></a></div>");
		// }
	
		parentContainer.appendChild(el);
		eventListener.add(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_LIST_GOT, function(reinit){
			if(reinit === "reinit"){
				currHistoryMsgSeqId = 0;
			}
			var id = officialAccount.official_account_id;
			// 获取当前 session 信息
			apiHelper.getLastSession(id).then(function(entity){
				officialAccount.agentId = entity.agent_id;
				officialAccount.sessionId = entity.session_id;
				officialAccount.sessionState = entity.state;
				officialAccount.agentType = entity.agent_type;
				officialAccount.skillGroupId = entity.skill_group_id;
				profile.latestNiceName = entity.agent_nice_name;
				officialAccount.isSessionOpen = (
					entity.state === _const.SESSION_STATE.PROCESSING
					|| entity.state === _const.SESSION_STATE.WAIT
				);
				// 拉取历史消息
				_getHistory(_scrollToBottom);
				// 初始化滚动拉取历史消息
				_initHistoryPuller();
				// 客服会话接起时不再显示欢迎语追问
				if(officialAccount.agentType == 6){
					eventListener.excuteCallbacks(_const.SYSTEM_EVENT.SESSION_ALREADY_CREATED, [officialAccount]);
				}
				else{
					// eventListener.excuteCallbacks(_const.SYSTEM_EVENT.STOP_TIMEOUT, [officialAccount]);
				}
				eventListener.excuteCallbacks(_const.SYSTEM_EVENT.SESSION_RESTORED, [officialAccount]);
			}, function(err){
				if(err === _const.ERROR_MSG.SESSION_DOES_NOT_EXIST){
					eventListener.excuteCallbacks(_const.SYSTEM_EVENT.SESSION_NOT_CREATED, [officialAccount]);
				}
				else{
					throw err;
				}
			});
		});
	
		return {
			show: _show,
			hide: _hide,
			scrollToBottom: _scrollToBottom,
			appendMsg: _appendMsg,
			appendEventMsg: _appendEventMsg,
			el: el
		};
	
		function _appendEventMsg(msg){
			_appendDate();
			// todo: xss defence
			utils.appendHTMLTo(el, [
				"<div class=\"em-widget-event\">",
				"<span>" + msg + "</span>",
				"</div>"
			].join(""));
			_scrollToBottom();
		}
	
	    // 页面每次进入进这个函数
		function _appendMsg(msg, options){
			var opt = options || {};
			var isReceived = opt.isReceived;
			var isHistory = opt.isHistory;
			var date = opt.timestamp || new Date().getTime();
			var dom = genDomFromMsg(msg, isReceived, isHistory, opt);
			var img = dom.querySelector(".em-widget-imgview");
	
			// 不是历史消息，不是接收到的消息，开始计数。几次后，显示转人工按钮。
			if(!isHistory && !isReceived){
				eventListener.excuteCallbacks(_const.SYSTEM_EVENT.SEND_MESSAGE, [officialAccount]);
			}
	
			if(isHistory){
				el.insertBefore(dom, el.firstChild);
				// 历史消息是向前插入，所以时间戳应在消息之后上屏
				_appendDate(date, isHistory);
			}
			else{
				// 时间戳上屏
				_appendDate(date, isHistory);
	
				if(img){
					// 如果包含图片，则需要等待图片加载后再滚动消息
					el.appendChild(dom);
					_scrollToBottom();
					utils.one(img, "load", function(){
						_scrollToBottom();
					});
				}
				else{
					// 非图片消息直接滚到底
					el.appendChild(dom);
					_scrollToBottom();
	
					// var listEle =  $(".em-widget-left");
					// var scroBox = $(".chat-wrapper")[0];
					// var top = scroBox.scrollTop;
					// var divEl = $(listEle[listEle.length -1]).find(".em-widget-msg-wrapper");
					// if($(divEl).hasClass("msgtype-skillgroupMenu")){
					// 	$(scroBox).scrollTop(top + 270)
					// }
					// else{
					// 	_scrollToBottom();
					// }
				}
			}
			var color = "";
			var themeClassName;
			var config = commonConfig.getConfig();
			var themeName = config.ui.themeName;
			if(themeName && themeName.indexOf("theme_custom") > -1){
				var arr = themeName.split("theme_custom");
				color = arr[1];
				themeClassName = "theme_custom";
			}
			else{
				themeClassName = _const.themeMap[config.themeName];
			}
			var button = dom.querySelector(".msgtype-satisfactionEvaluation .em-btn-list>button");
			if(color && button){
				if($(button).hasClass("fg-color")){
					$(button).css("cssText", "color: " + color + " !important");
				}
			}
	
	    dhRichTextHandler();
	    fullMenuListHander();
		}
	
		function _appendDate(timestamp, isHistory){
			var showTime;
			if(_timestampToTime(timestamp) == _timestampToTime(new Date().getTime())){
				showTime = utils.formatHHmm(timestamp);
			}
			else{
				showTime = utils.formatDate(timestamp);
			}
			var dom = utils.createElementFromHTML([
				"<div class=\"em-widget-date\">",
				"<span>" + showTime + "</span>",
				"</div>"
			].join(""));
			var date = timestamp || _.now();
	
			if(isHistory){
				msgTimeSpanBegin - date > _const.MESSAGE_TIME_SPAN_INTERVAL
					&& el.insertBefore(dom, el.firstChild);
			}
			else{
				date - msgTimeSpanEnd > _const.MESSAGE_TIME_SPAN_INTERVAL
					&& el.appendChild(dom);
			}
	
			// 更新时间范围
			date < msgTimeSpanBegin && (msgTimeSpanBegin = date);
			date > msgTimeSpanEnd && (msgTimeSpanEnd = date);
		}
	
		function _getHistory(callback){
			if(noMoreHistoryMessage) return;
			utils.removeClass(loadingMore, "hide");
			apiHelper.getOfficalAccountMessage(
				officialAccount.official_account_id,
				currHistoryMsgSeqId
			).then(function(msgList){
				var length = msgList.length;
				var earliestMsg = msgList[length - 1] || {};
				var nextMsgSeq = earliestMsg.id;
				utils.addClass(loadingMore, "hide");
				currHistoryMsgSeqId = nextMsgSeq;
				noMoreHistoryMessage = length < _const.GET_HISTORY_MESSAGE_COUNT_EACH_TIME || nextMsgSeq <= 0;
				noMoreHistoryMessage && utils.removeClass(noMoreMsg, "hide");
				// var closDate = []
				// 存储满意度评价时效的结束时间
				_.each(msgList, function(itm){
					if(itm.body.ext.weichat.event){
						if(itm.body.ext.weichat.event.eventName === "ServiceSessionClosedEvent" ||
						itm.body.ext.weichat.event.eventName === "ServiceSessionAbortedEvent"){
							var obj = {
								id: itm.body.ext.weichat.service_session.serviceSessionId,
								timp: itm.body.timestamp
							};
							closDate.push(obj);
						}
					}
				});
				utils.setStore("closDate", JSON.stringify(closDate));
				_.each(msgList, channel.handleHistoryMsg);
				typeof callback === "function" && callback();
			});
		}
	
		function _initHistoryPuller(){
			var st;
			var _startY;
			var _y;
	
			if(utils.isMobile){
				// wap
				utils.on(el, "touchstart", function(ev){
					_startY = utils.getDataByPath(ev, "changedTouches.0.pageY");
				});
				utils.on(el, "touchend", function(ev){
					_y = utils.getDataByPath(ev, "changedTouches.0.pageY");
					if(_y - _startY > 8 && this.getBoundingClientRect().top >= 0){
						clearTimeout(st);
						st = setTimeout(function(){
							_getHistory();
						}, 100);
					}
				});
			}
			else{
				// pc端
				utils.on(el, "mousewheel DOMMouseScroll", function(ev){
					if(officialAccount !== profile.currentOfficialAccount) return;
					var that = this;
	
					if(ev.wheelDelta / 120 > 0 || ev.detail < 0){
						clearTimeout(st);
						st = setTimeout(function(){
							if(that.getBoundingClientRect().top >= 0){
								_getHistory();
							}
						}, 400);
					}
				});
			}
			// 初始化拉取历史消息清空存储的结束时间
			utils.clearStore("closDate");
		}
	
		function _scrollToBottom(){
			parentContainer.scrollTop = parentContainer.scrollHeight - parentContainer.offsetHeight + 9999;
	
			var listEle =  $(".em-widget-left");
			var scroBox = $(".chat-wrapper")[0];
			var top = scroBox.scrollTop;
			var divEl = $(listEle[listEle.length - 1]).find(".em-widget-msg-wrapper");
			var color;
			var config = commonConfig.getConfig();
			var themeName = config.ui.themeName;
			if(themeName && themeName.indexOf("theme_custom") > -1){
				var arr = themeName.split("theme_custom");
				color = arr[1];
				themeClassName = "theme_custom";
			}
			else{
				themeClassName = _const.themeMap[config.themeName];
			}
			var hoverColor = $("body." + themeClassName + " .border-color").css("borderColor");
			if(!color){
				color = hoverColor;
			}
			var aEl = $(".em-widget-left a");
			for(var i = 0; i < aEl.length; i++){
				aEl[i].style.color = color;
			}
			if($("body").hasClass("window-demo")){
				var elHeight = $(divEl).outerHeight() - 150;
			}
			else{
				var elHeight = $(divEl).outerHeight() - 150;
			}
			if($(divEl).hasClass("msgtype-skillgroupMenu") || $(divEl).hasClass("msgtype-robotList")){
				$(scroBox).scrollTop(top - elHeight);
			}
		}
	
		function _hide(){
			utils.addClass(el, "hide");
		}
	
		function _show(){
			utils.removeClass(el, "hide");
		}
		function _timestampToTime(timestamp){
			var date = new Date(timestamp);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
			var Y = date.getFullYear() + "-";
			var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
			var D = date.getDate() + " ";
			return Y + M + D;
		}
	
	  // 敦煌富文本 a 点击时，需要单独上屏
	  function dhRichTextHandler() {
	    document.querySelectorAll('.dh_rich_text li a').forEach(function (item) {
	      // 点击内部的 li 时，发送消息
	      item.onclick = function (e) {
	        var value = e.target.name;
	        channel.sendText(value)
	
	        // 包子科技单独callback返回定制
	        if(item.getAttribute("baozicallback")) {
	          getToHost.send({ event: _const.EVENTS.ONBAOZICALLBACK, data: item.getAttribute("baozicallback")});
	        }
	      }
	      
	    })
	  }
	
	  function fullMenuListHander() {
	    if(!document.querySelector('.full-menu-list')) return;
	
	    document.querySelectorAll('.full-menu-list .menu-item').forEach(function (item) {
	      item.onclick = function (e) {
	        // 切换菜单
			document.querySelectorAll('.menu-item').forEach(function (item) {
				item.classList.remove('active');
				item.classList.remove('fg-color');
			  });
	        e.target.classList.add('active');
	        e.target.classList.add('fg-color');
	        // 切换内容
	        var index = e.target.dataset.index;
	        var content = document.querySelectorAll('.content-item');
			content.forEach(function (item) {
				return item.classList.remove('active');
			});
	        content[index].classList.add('active');
	      }
	    })
	
	    document.querySelectorAll('.full-menu-list .content-item .text').forEach(function (item) {
	      item.onclick = function () {
	        channel.sendText(item.innerHTML)
	      }
	    })
	
	    if(document.querySelector('.full-menu-list .left-arrow')) {
	      document.querySelector('.full-menu-list .left-arrow').onclick = function () {
	        var menu = document.querySelector('.full-menu-list .menu-list');
	        menu.scrollLeft -= 100;
	      }
	
	      document.querySelector('.full-menu-list .right-arrow').onclick = function () {
	        var menu = document.querySelector('.full-menu-list .menu-list');
	        menu.scrollLeft += 100;
	      }
	    }
	  }
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	var commonConfig = __webpack_require__(177);
	var eventListener = __webpack_require__(185);
	var profile = __webpack_require__(178);
	var textParser = __webpack_require__(189);
	var moment = __webpack_require__(17);
	var apiHelper = __webpack_require__(181);
	var channel = __webpack_require__(186);
	var generateFullMenuList = __webpack_require__(231);
	
	var LOADING = Modernizr.inlinesvg ? _const.loadingSvg : "<img src=\"//kefu.easemob.com/webim/static/img/loading.gif\" width=\"20\" style=\"margin-top:10px;\"/>";
	
	// channel.js 放着消息列表的构建，是不对的
	function genMsgContent(msg, opt){
		var notFromSystem = false;
		// 历史消息里的
		if(msg.fromUser && msg.type !== "customMagicEmoji"){
			var fromType = utils.getDataByPath(msg, "fromUser.user_type");
			if(fromType !== "Scheduler" && fromType !== "Robot"){
				notFromSystem = true;
			}
		}
		// 实时消息里的
		if(opt.notFromSystem && msg.type !== "customMagicEmoji"){
			var fromType = utils.getDataByPath(msg, "ext.weichat.agent.userType");
			if(msg.ext.weichat.agent && fromType == "Agent"){
				notFromSystem = true;
			}
			else if(msg.ext.weichat.agent && fromType == "Robot"){
				notFromSystem = false;
			}
			else if(msg.ext.weichat.agent && !fromType){
				notFromSystem = false;
			}
			else{
				notFromSystem = opt.notFromSystem;
			}
		}
	
		// console.log(msg)
		var type = msg.type;
		var value = msg.data;
		// 来自智能辅助的客服消息也会转译两次（和历史会话一样），这里转译处理。
		value = textParser.unescape(textParser.unescape(value));
		var laiye = msg.laiye;
		var rulai = msg.rulai;
		var relatedRules;
		var html = "";
		var msgContent;
		var ruleId;
		var answerId;
		var relatedRuleIds;
		
	
		switch(type){
		case "txt":
			if(profile.grayList.rulaiRobotRichText && rulai){
				html = "<span class=\"text\">";
				html += value;
				html += "</span>";
	
				break;
			}
			else if(laiye){
				var tmpDiv = document.createElement("div");
				tmpDiv.innerHTML = value;
				utils.addClass(tmpDiv.getElementsByTagName("img"), "em-widget-imgview");
				value = tmpDiv.innerHTML;
				html = "<span class=\"text\">" + value + "</span>";
				break;
			}
			else if(isJsonString(value)){
				value = JSON.parse(value);
				if(value.type == "richtext"){
					var txtDom = apiHelper.getlaiyeHtml(value.content);
					value = txtDom.response;
				}
				else{
					value = JSON.stringify(value);
				}
			}
			// 留言
			else if(utils.getDataByPath(msg, "ext.weichat.ctrlType") === "TransferToTickets"){
				html = "<div>" + (value != "NoTransferToTicketsTitle" ? value : "") + "</div><a href=\"javascript:;\" class='msgTicketButton'>" + "ticket" + "</a>";
				eventListener.excuteCallbacks(_const.eventMessageText.TICKET, []);
				break;
			}
			else{
				value =  notFromSystem ? textParser.parse(value, { "default": true }, opt.isReceived) : textParser.parse(value);
				
				// 历史消息以及收到的实时消息
				if(utils.isMobile && value[0].type == "ENCODED_TEXT"){
					html = "<span class=\"text\">";
					html += _.map(value, function(fragment){
						// 识别号码
						return validatePhoneInTxt(fragment.value);
					}).join("");
					html += "</span>";
									// 历史消息以及收到的实时消息
									// html = "<span class=\"text\">" + _.map(value, function(fragment){
									// 	return fragment.value;
									// }).join("") + "</span>";
				}
				else{
					// 历史消息以及收到的实时消息
					html = "<span class=\"text\">" + _.map(value, function(fragment){
						return fragment.value;
					}).join("") + "</span>";
				}
				break;
			}
	  case "commonRichText":
	    html = textParser.unescape(msg.data)
	    html = textParser.replaceEmojis(html);
	    break;
		case "txtLink":
			html = value;
			break;
		case "img":
			// todo: remove a
			html = "<a href=\"javascript:;\"><img class=\"em-widget-imgview\" src=\""
				+ msg.url + "\"/></a>";
			break;
		case "customMagicEmoji":
			// 给图片消息或附件消息的url拼上hostname
			if(msg.url && !/^http?/.test(msg.url)){
				// commonConfig.getConfig().domain 有时有http?有时没有？
				if(/^http?/.test(commonConfig.getConfig().domain)){
					msg.url = commonConfig.getConfig().domain + msg.url;
				}
				else{
					msg.url = location.protocol + commonConfig.getConfig().domain + msg.url;
				}
			}
			// todo: remove a
			html = "<a href=\"javascript:;\"><img class=\"em-widget-imgview\" src=\""
				+ msg.url + "\"/></a>";
			break;
		// 这个消息类型包含了很多子类型
		case "list":
			if(profile.grayList.rulaiRobotRichText && rulai){
				var newValue;
				if(value.indexOf("<img") > -1){
					var reg = new RegExp("<img", "g");
					newValue = value.replace(reg, "<img class='em-widget-imgview' ");
				}
				else{
					newValue = value;
				}
	      if(newValue) {
	        html = "<span class=\"text\">";
	        html += newValue;
	        html += "</span>";
	      }
	      // 非空才添加
	      if(!isEmptyMsgList(msg.list)) {
	        html += msg.list;
	      }
				break;
			}
			else if(laiye){
				html = "<div class='list-title'>" + value + "</div>" + msg.list;
				break;
			}
			else{
				value = textParser.parse(value);
				value = _.map(value, function(fragment){ return fragment.value; }).join("");
				html = "<div class='list-title'>" + value + "</div>" + msg.list;
				break;
			}
	  case "tianrunRobotWelcomeListMessageType":
	    html = generateFullMenuList(msg.ext.msgtype.options)
	    break;
		case "file":
			// 历史会话中 filesize = 0
			// 访客端发文件消息 filesize = undefined
			// 需要过滤这两种情况，暂时只显示坐席发过来的文件大小
			var newUrl;
			if(msg.url.indexOf("blob:") == 0){
				newUrl = msg.url;
			}
			else{
				newUrl = msg.url.replace("http:", "https:");
			}
			html = "<i class=\"icon-attachment container-icon-attachment hide\"></i>"
				+ "<span class=\"file-info\">"
				+ "<p class=\"filename\">" + msg.filename + "</p>"
				+ "</span>"
				+ "<a target=\"_blank\" href=\"" + newUrl
				+ "\" class=\" container-icon-download\" title=\""
				+ msg.filename + "\" download=\"" + msg.filename + "\">"
				+ "<img src=\"/webim/static/img/downloadfiles.png\"  class=\"img-download\"/>"
				+ "</a>"
				+ "<p class=\"filesize\">" + utils.filesizeFormat(msg.fileLength) + "</p>";
			break;
			// 小视频类型
		case "video":
			// html = "<video class=\"video-btn\"  controls src=\"" + msg.url + " \">"
			// 		+ "<source  src=\"" + msg.url + " \" type=\"video/mp4\"></source>"
			// 		+ "<source  src=\"" + msg.url + " \" type=\"video/webm\"></source>"
			// 		+ "<source  src=\"" + msg.url + " \" type=\"video/ogg\"></source>"
			// 	   + "</video>";
			// break;
			//
			if(utils.isMobile){
				// 取第一帧，安卓黑屏
				var newUrl = msg.url + "#t=1";
	
				html = "<video preload='metadata'  poster=\"" + msg.thumb + "\" data-url=\"" + msg.url + " \" class=\"video-btn video-btn-android\" x5-video-player-type='h5' src=\"" + newUrl + " \">"
				+ "<source  src=\"" + msg.url + " \" type=\"video/mp4\"></source>"
				+ "<source  src=\"" + msg.url + " \" type=\"video/webm\"></source>"
				+ "<source  src=\"" + msg.url + " \" type=\"video/ogg\"></source>"
				+ "</video>"
				+ "<div class='icon-play-box'><i class='icon-play'></i></div>";
			}
			else{
				html = "<video controls height='300'  class=\"video-btn\" src=\"" + msg.url + " \">"
				+ "<source  src=\"" + msg.url + " \" type=\"video/mp4\"></source>"
				+ "<source  src=\"" + msg.url + " \" type=\"video/webm\"></source>"
				+ "<source  src=\"" + msg.url + " \" type=\"video/ogg\"></source>"
				+ "</video>";
			}
			
			
			break;
		case "html-form":
			msgContent = msg.ext.msgtype.html;
			html = "<a class=\"form-url\" target=\"_blank\" href=" + msgContent.url + "></a>"
				+ "<div class=\"form-content\">"
				+ "<span class=\"title\">" + msgContent.topic + "</span>"
				+ "<span class=\"desc\">" + msgContent.desc + "</span>"
				+ "</div>"
				+ "<div class=\"form-aside\">"
				+ "<i class=\"icon-form\"></i>"
				+ "</div>";
			break;
		case "track":
		case "order":
			msgContent = msg.ext.msgtype.track || msg.ext.msgtype.order;
			html = [
				msgContent.title ? "<h1>" + msgContent.title + "</h1>" : "",
				msgContent.order_title ? "<h2>" + msgContent.order_title + "</h2>" : "",
				msgContent.img_url ? "<div><img src='" + msgContent.img_url + "'/></div>" : "",
				msgContent.desc ? "<p>" + msgContent.desc + "</p>" : "",
				msgContent.price ? "<span>" + msgContent.price + "</span>" : "",
				msgContent.item_url ? "<a target='_blank' href='" + msgContent.item_url + "'></a>" : "",
			].join("");
			break;
		case "article":
			var msgArticles = utils.getDataByPath(msg, "ext.msgtype.articles");
			var articleNode = "";
			var showDirectly = utils.getDataByPath(msg, "ext.msgtype.showDirectly");
			var cardViewOption = utils.getDataByPath(msg, "ext.msgtype.cardViewOption");
			if(showDirectly){
				if(cardViewOption == "SLIDE"){
					html = "<div class=\"article-msg-outer more-articles specialArticle directly-article-drawer\" style=\"margin-bottom:6px;\">"
					+ _.map(msgArticles, function(item, index){
						var str = "";
						articleDom = apiHelper.getArticleHtml(msgArticles[index].url);
						// var uuid = utils.uuid();
						articleTextDom = utils.createElementArticleFromHTML(articleDom.responseText);
						// msgArticles[index].url = msgArticles[index].url.replace("http:", "https:");
						// str =  "<div><iframe id=" + uuid + " src=" + msgArticles[index].url + " height=\"500px%\" width=\"100%\" frameborder=\"0\"></iframe></div>";
						utils.addClass(articleTextDom.getElementsByTagName("img"), "em-widget-imgview");
						str =  "<div>" + articleTextDom.getElementsByTagName("div")[0].innerHTML + "</div>";
						
						return str;
					}).join("") || ""
					+ "<div></div></div>";
				}
				else{
					html = _.map(msgArticles, function(item, index){
						var str = "";
						articleDom = apiHelper.getArticleHtml(msgArticles[index].url);
						articleTextDom = utils.createElementArticleFromHTML(articleDom.responseText);
						utils.addClass(articleTextDom.getElementsByTagName("img"), "em-widget-imgview");
							// var uuid = utils.uuid();
							// item.url = item.url.replace("http:", "https:");
						str =  "<div class=\"article-msg-outer more-articles specialArticle\">" + articleTextDom.getElementsByTagName("div")[0].innerHTML;
						return str;
					}).join("") || ""
					+ "</div>";
				}
				
			}
			else if(cardViewOption == "SLIDE"){
	
				html = "<div class=\"article-msg-outer more-articles  article-drawer\" style=\"margin-bottom:10px;\">"
									+ _.map(msgArticles, function(item, index){
										var date = msgArticles[index].createdTime ? moment(msgArticles[index].createdTime).format("MMM D")
										: moment(msgArticles[index].date).format("MMM D");
										var str = "";
										str = "" +
											"<div class=\"article-msg-outer article-item only-one-article\">" +
												"<div class=\"body\">" +
													"<h3 class=\"title\">" + msgArticles[index].title + "</h3>" +
													"<p class=\"create-time\">" + date + "</p>" +
													"<img class=\"cover\" src=\"" + msgArticles[index].picurl + "\"/>" +
													"<div class=\"desc\"><p>" + msgArticles[index].description + "</p></div>" +
												"</div>" +
												"<div class=\"footer\"><span class=\"look-article\">" + "Read all" + "</span><i class=\"icon-arrow-right\"></i></div>" +
												// "<a class=\"article-link\" target=\"_blank\" href=\"" + msgArticles[0].url + "\"></a>" +
												"<div class=\"article-link\" data-status=\"" + msgArticles[index].sendCustomer + "\"><span>" + msgArticles[index].url + "</span></div>" +
											"</div>";
										return str;
	
									}).join("") || ""
									+ "</div>";
			}
			else if(msgArticles.length === 1){
				var date = msgArticles[0].createdTime ? moment(msgArticles[0].createdTime).format("MMM D")
									: moment(msgArticles[0].date).format("MMM D");
				html = "" +
									"<div class=\"article-msg-outer article-item only-one-article\">" +
										"<div class=\"body\">" +
											"<h3 class=\"title\">" + msgArticles[0].title + "</h3>" +
											"<p class=\"create-time\">" + date + "</p>" +
											"<img class=\"cover\" src=\"" + msgArticles[0].picurl + "\"/>" +
											"<div class=\"desc\"><p>" + msgArticles[0].description + "</p></div>" +
										"</div>" +
										"<div class=\"footer\"><span class=\"look-article\">" + "Read all" + "</span><i class=\"icon-arrow-right\"></i></div>" +
										// "<a class=\"article-link\" target=\"_blank\" href=\"" + msgArticles[0].url + "\"></a>" +
										"<div class=\"article-link\" data-status=\"" + msgArticles[0].sendCustomer + "\"><span>" + msgArticles[0].url + "</span></div>" +
									"</div>";
			}
			else{
				html = "<div class=\"article-msg-outer more-articles\">"
									+ _.map(msgArticles, function(item, index){
										var str = "";
										if(index === 0){
											str = "<div class=\"article-item first-item\">" +
											"<h3 class=\"title\">" + item.title + "</h3>";
										}
										else{
											str = "<div class=\"article-item rest-item\">" +
											"<div class=\"title-wrapper\"><p class=\"title\">" + item.title + "</p></div>";
										}
										str += "<img class=\"cover-img\" src=\"" + item.picurl + "\"/>" +
											// "<a class=\"article-link\" target=\"_blank\" href=\"" + item.url + "\"></a>" +
											"<div class=\"article-link\"><span>" + item.url + "</span></div>" +
											"</div>";
										return str;
									}).join("") || ""
									+ "</div>";
			}
			
			// dom.className = "article-message-wrapper";
	
			// 单独的转人工按钮（txt、）
			if(!utils.getDataByPath(msg, "ext.msgtype.choice") && utils.getDataByPath(msg, "ext.weichat.ctrlType") === "TransferToKfHint"){
				var articleTransferNode;
				var ctrlArgs = msg.ext.weichat.ctrlArgs;
				var transferToHumanButtonInfo = msg.ext.weichat.transferToHumanButtonInfo;
				var disabledClass = profile.shouldMsgActivated(ctrlArgs.serviceSessionId) ? "" : "disabled";
	
				if(transferToHumanButtonInfo && transferToHumanButtonInfo.suggestionTransferToHumanLabel != null){
					html += "<div class=\"em-btn-list\" style=\"max-width: 360px;margin: 0 auto;\">"
					+ "<button "
						+ "class=\"white bg-color border-color bg-hover-color-dark js_robotTransferBtn " + disabledClass + "\" "
						+ "data-sessionid=\"" + ctrlArgs.serviceSessionId + "\" "
						+ "data-id=\"" + ctrlArgs.id + "\" "
						+ "data-transferToHumanId=\"" + transferToHumanButtonInfo.transferToHumanId + "\" "
					+ ">" + transferToHumanButtonInfo.suggestionTransferToHumanLabel + "</button>"
				+ "</div>";
				}
				// 英文状态开关可能会有问题，这里用语言状态来判断
				else{
					ctrlArgs.label =  false ? ctrlArgs.label : "Chat with agent";
					html += "<div class=\"em-btn-list\" style=\"max-width: 360px;margin: 0 auto;\">"
						+ "<button "
							+ "class=\"white bg-color border-color bg-hover-color-dark js_robotTransferBtn " + disabledClass + "\" "
							+ "data-sessionid=\"" + ctrlArgs.serviceSessionId + "\" "
							+ "data-id=\"" + ctrlArgs.id + "\" "
						+ ">" + ctrlArgs.label + "</button>"
					+ "</div>";
				}
			}
	
			// dom.innerHTML = articleNode;
			
			// return dom;
			break;
		default:
			throw new Error("unexpected value type.");
		}
	
		if(msg.ext &&  msg.ext.relatedRules && msg.ext.relatedRules.questions.length > 0){
			relatedRules = msg.ext.relatedRules;
			ruleId = relatedRules.ruleId;
			answerId = relatedRules.answerId;
			relatedRuleIds = relatedRules.relatedRuleIds;
			html += "<div style='border-top: 1px solid #e5e5e5;margin: 10px -10px 4px;' ></div><div class=\"em-btn-list\">"  + _.map(msg.ext.relatedRules.questions, function(question, index){ return "<li><button class=\"js_robotRelateListbtn fg-color\" data-ruleId=" + ruleId + " data-answerId=" + answerId + " data-relatedRuleId=" + relatedRuleIds[index] + ">" + question + "</button><i class='icon-arrow-right'></i></li>";}).join("") || "";
		}
	
		return html;
	}
	
	function _getAvatar(msg){
		var officialAccountType = utils.getDataByPath(msg, "ext.weichat.official_account.type");
		var avatarFromOfficialAccountExt = utils.getDataByPath(msg, "ext.weichat.official_account.img");
		var avatarFromMessageExt = utils.getDataByPath(msg, "fromUser.img");
		var avatarFromCurrentAgent = profile.systemAgentAvatar;
		var avatar;
	
		if(officialAccountType === "CUSTOM"){
			avatar = avatarFromOfficialAccountExt;
		}
		else if(profile.isAgentNicknameEnable){
			avatar = avatarFromMessageExt || avatarFromCurrentAgent;
		}
		else{
			avatar = profile.tenantAvatar || profile.defaultAvatar;
		}
	
		return avatar || profile.tenantAvatar || profile.defaultAvatar;
	}
	// "For <strong><em>account </em></strong>related issues, choose one of these topics, or briefly describe what you need."
	function _getRulaiHtml(content){
	
	}
	
	function isEmptyMsgList(str) {
	  return str === '<div class="em-btn-list"></div>';
	} 
	
	function genDomFromMsg(msg, isReceived, isHistory, opt){
		opt = opt || {};
		// console.log(msg)
		var id = msg.id;
		var type = msg.type;
		var html = "";
		var dom = document.createElement("div");
		var direction = isReceived ? "left" : "right";
		var articleDom;
		var articleTextDom;
		var satisfactionCommentInfo;
		var agentId;
		var satisfactionCommentInvitation;
		opt.isReceived = isReceived;
		
		// 设置消息气泡显示在左侧还是右侧
		// .em-widget-right, .em-widget-left used here
		dom.className = "em-widget-" + direction;
	
		// 给消息追加id，用于失败重发消息或撤回消息
		if(id){
			dom.id = id;
		}
	
		// 坐席消息头像
		if(direction === "left"){
			if(utils.isMobile){
				// html += "<img class=\"avatar\" src=\"" + _getAvatar(msg) + "\">";
			}
			else if(msg.ext && msg.ext.weichat){
				var name = msg.ext.weichat.agent.userNickname || msg.ext.weichat.official_account.name;
				html += "<span class=\"userNickname\">" + name + "</span>";
			}
		}
	
		// wrapper 开始
		if(direction === "left"){
			if(type === "customMagicEmoji" || type === "video"){
				html += "<div class=\"em-widget-msg-wrapper no-bg msgtype-" + (msg.subtype || type) + "\">";
			}
			else{
				html += "<div class=\"em-widget-msg-wrapper msgtype-" + (msg.subtype || type) + "\">";
			}
			
			// html += "<i class=\"icon-corner-" + direction + "\"></i>";
		}
		else{
			var myconfig = commonConfig.getConfig();
			var themeName = myconfig.ui.themeName;
			if(themeName && themeName.indexOf("theme_custom") > -1){
				var arr = themeName.split("theme_custom");
				var color = arr[1];
			}
			// 无背景
			if(type === "customMagicEmoji" || type === "img" || type === "video"){
				html += "<div class=\"em-widget-msg-wrapper no-bg msgtype-" + (msg.subtype || type) + "\">";
			}
			// 原背景
			else if(type === "file" || type === "order" || type === "track"  || type === "article"){
				html += "<div class=\"em-widget-msg-wrapper msgtype-" + (msg.subtype || type) + "\">";
			}
			else if(color){
				html += "<div class=\"em-widget-msg-wrapper msgtype-" + (msg.subtype || type) + "\" style=\"color:#fff; background: " + color + " \">";
			}
			else{
				html += "<div class=\"em-widget-msg-wrapper bg-color msgtype-" + (msg.subtype || type) + "\">";
			}
			// html += "<i class=\"fg-color icon-corner-" + direction + "\"></i>";
		}
	
		// 设置消息气泡的突起位置
		// .icon-corner-right, .icon-corner-left used here
		
		
	
		// 发出的消息增加状态显示
		if(!isReceived && !isHistory && id){
			// todo: 只拼一遍 id
			// todo: 去掉 type
			if(type == "img"){
				html += "<div id=\"" + id
				+ "_failed\" data-type=\"" + type + "\" class=\"em-widget-msg-status hide\">"
				+ "<span>" + "Failed to send" + "</span><i class=\"icon-circle\"><i class=\"icon-exclamation\"></i></i></div>"
				+ "<div id=\"" + id
				+ "_loading\" class=\"em-widget-msg-loading\">" + LOADING + "</div>";
			}
			else{
				html += "<div id=\"" + id
				+ "_failed\" data-type=\"" + type + "\" class=\"em-widget-msg-status hide\">"
				+ "<span>" + "Failed to send" + "</span><i class=\"icon-circle\"><i class=\"icon-exclamation\"></i></i></div>";
			}
				
		}
	
		// todo: simplify the class name em-widget-msg
		// container 开始
		// .em-widget-msg-* used here
		html += "<div class=\"em-widget-msg-container em-widget-msg-" + type + "\">";
		// 消息内容
	
	
		var data = msg.data;
		var laiye = msg.laiye;
		var laiyeType;
		// 如来机器人，支持富文本展示
		if(profile.grayList.rulaiRobotRichText && isJsonString(data)){
			var parseredData = JSON.parse(data);
	    if(Array.isArray(parseredData)) {
	      parseredData.forEach(function(item){
	        if(item.type == "richText"){
	          var newContent = "";
	  
	          if(item.content.indexOf("<img") > -1){
	            var reg = new RegExp("<img", "g");
	            newContent = item.content.replace(reg, "<img class='em-widget-imgview' ");
	          }
	          else{
	            newContent = item.content;
	          }
	  
	          // 针对文本中带有 [:$] 表情字符的，转化为表情
	          newContent = newContent.replace(/\[:\$\]/g, '<img class="emoji" src="static/img/faces/ee_9.png" alt="[:$]">');
	          newContent = newContent.replace(/\[\(\|\)\]/g, '<img class="emoji" src="static/img/faces/ee_24.png" alt="[:$]">');
	  
	          // 针对敦煌富文本消息，将其中的 id 改为 class ，方便做事件绑定
	          if(item.content.indexOf("dh_rich_text") > -1) {
	            var updatedText = newContent.replace(/id=('[^']*'|"[^"]*")/g, 'class=$1');
	            newContent = updatedText;
	          } 
	  
	          msg.data = newContent;
	          msg.rulai = true;
	          html += genMsgContent(msg, opt);
	        }
	      });
	    } else {
	      msg.data = data;
	      html += genMsgContent(msg, opt);
	    }
		}
		else if(laiye && isJsonString(data) && (msg.type == "txt" || msg.type == "list")){
			data = JSON.parse(data);
			laiyeType = msg.type;
			data.forEach(function(item){
				msg.data = item.content;
				if(item.type == "text"){
					msg.type = "txt";
				}
				else if(item.type == "image"){
					msg.type = "img";
					msg.url = item.content;
				}
				else if(item.type == "richtext"){
					var articleDom = apiHelper.getlaiyeHtml(item.content);
					msg.data = articleDom.response;
					msg.type = "txt";
				}
				else{
					msg.type = item.type;
				}
				msg.laiye = laiye;
				html += genMsgContent(msg, opt);
	
			});
			if(laiyeType == "list" || (msg.multipleMsgOneByOne && msg.list)){
				html += msg.list;
			}
		}
		else{
			html += genMsgContent(msg, opt);
			if(msg.multipleMsgOneByOne && msg.list){
				html += msg.list;
			}
		}
	
		// container 结束
		html += "</div>";
	
		// 单独的转人工按钮（txt、）
		if(!utils.getDataByPath(msg, "ext.msgtype.choice") && utils.getDataByPath(msg, "ext.weichat.ctrlType") === "TransferToKfHint"){
			var ctrlArgs = msg.ext.weichat.ctrlArgs;
			var transferToHumanButtonInfo = msg.ext.weichat.transferToHumanButtonInfo;
			var disabledClass = profile.shouldMsgActivated(ctrlArgs.serviceSessionId) ? "" : "disabled";
			// // 判断英文状态开关是否打开状态，打开改变label的字段
			// var resRoobot;
			// try{
			// 	resRoobot = JSON.parse(apiHelper.getRobotNotReachableENEnable().response);
			// }
			// catch(e){
			// 	console.log(e)
			// }
			// if(resRoobot.status == "OK" ){
			// 	if(resRoobot.entities.length != 0 && resRoobot.entities[0].optionValue){
			// 		ctrlArgs.label = "Chat with agent"
			// 	}else{
			// 		ctrlArgs.label
			// 	}
			// }else{
			// 	console.log("unexpected response value.");
			// }
	
			if(transferToHumanButtonInfo && transferToHumanButtonInfo.suggestionTransferToHumanLabel != null){
				html += "<div class=\"em-btn-list\" style=\"padding:0\">"
				+ "<button "
					+ "class=\"white fg-color border-color  js_robotTransferBtn " + disabledClass + "\" "
					+ "data-sessionid=\"" + ctrlArgs.serviceSessionId + "\" "
					+ "data-id=\"" + ctrlArgs.id + "\" "
					+ "data-transferToHumanId=\"" + transferToHumanButtonInfo.transferToHumanId + "\" "
				+ ">" + transferToHumanButtonInfo.suggestionTransferToHumanLabel + "</button>"
			+ "</div>";
			}
			// 英文状态开关可能会有问题，这里用语言状态来判断
			else{
				ctrlArgs.label =  false ? ctrlArgs.label : "Chat with agent";
				html += "<div class=\"em-btn-list\" style=\"padding:0\">"
					+ "<button "
						+ "class=\"white fg-color border-color  js_robotTransferBtn  TransferBtnColor" + disabledClass + "\" "
						+ "data-sessionid=\"" + ctrlArgs.serviceSessionId + "\" "
						+ "data-id=\"" + ctrlArgs.id + "\" "
					+ ">" + ctrlArgs.label + "</button>"
				+ "</div>";
			}
		}
	
		satisfactionCommentInfo = utils.getDataByPath(msg, "ext.weichat.extRobot.satisfactionCommentInfo");
		satisfactionCommentInvitation = utils.getDataByPath(msg, "ext.weichat.extRobot.satisfactionCommentInvitation");
		agentId = utils.getDataByPath(msg, "ext.weichat.agent.userId");
	
		if(msg.ext &&  satisfactionCommentInvitation){
			html +=  "<div class='statisfy'><span class='statisfyYes' data-satisfactionCommentInfo='" + satisfactionCommentInfo + "' data-agentId='" + agentId + "'><i class=\"icon-resolved\"></i><span>" + "Resolved" + "</span></span><span class='statisfyNo' data-satisfactionCommentInfo='" + satisfactionCommentInfo + "' data-agentId='" + agentId + "'><i class=\"icon-unresolved\"></i><span>" + "Unsolved" + "</span></span></div>";
		}
	
		// wrapper 结尾
		html += "</div>";
		dom.innerHTML = html;
	
		return dom;
	}
	
	function isJsonString(str){
		try{
			if(typeof JSON.parse(str) == "object"){
				return true;
			}
		}
		catch(e){
		}
		return false;
	}
	
	function validatePhoneInTxt(val){
		var txt = val;
		var phoneList = [];
		// 判断是否有链接，如果有则直接返回链接
		var reg = /(((https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/ig;
		if(reg.test(val)){
			return val;
		}
		var arr = val.split(/[^0-9/?-]/);
		_.map(arr, function(item){
			if(isPhone(item)){
				phoneList.push(item);
			}
		});
		if(phoneList.length){
			_.map(phoneList, function(item){
				var reg = new RegExp(item, "g");
				var newStr = txt.replace(reg, "<a href='tel:" + item + "'>" + item + "</a>");
				txt = newStr;
			});
		}
		return txt;
	}
	
	function isPhone(num){
		var varisPhone = /^((0\d{2,3})-)?(\d{5,8})(-(\d{3,}))?$/.test(num);
		var varisMobile = /^1[3456789]\d{9}$/.test(num);
		return (varisPhone || varisMobile);
	}
	
	module.exports = genDomFromMsg;


/***/ }),
/* 231 */
/***/ (function(module, exports) {

	function generateFullMenuList(data) {
	  var appContainer = document.createElement('div');
	  appContainer.classList.add('full-menu-list');
	
	  var titleDiv = document.createElement('div');
	  titleDiv.classList.add('main-title');
	  titleDiv.textContent = '猜你想问:';
	  appContainer.appendChild(titleDiv);
	
	  var menuContainer = document.createElement('div');
	  menuContainer.classList.add('menu');
	  var menuListContainer = document.createElement('div');
	  menuListContainer.classList.add('menu-list');
	  if(data.length >= 1) {
	    appContainer.appendChild(menuContainer);
	    menuContainer.appendChild(menuListContainer);
	  }
	
	  var contentContainer = document.createElement('div');
	  contentContainer.classList.add('content');
	  appContainer.appendChild(contentContainer);
	
	  var wrapperDOM = document.createElement('div');
	  wrapperDOM.appendChild(appContainer);
	
	
	  // 创建菜单项
	  data.forEach(function (categoryData, index) {
	    var menuItem = document.createElement('div');
	    menuItem.classList.add('menu-item');
	    if (index === 0) {
	      menuItem.classList.add('active');
	      menuItem.classList.add('fg-color');
	    }
	    menuItem.textContent = categoryData.category;
	    menuItem.dataset.index = index;
	    if (categoryData.category !== "default") {
	      menuListContainer.appendChild(menuItem);
	    }
	  
	    // 创建对应的内容区域
	    var contentItem = document.createElement('div');
	    contentItem.classList.add('content-item');
	    if (index === 0) contentItem.classList.add('active');
	    contentItem.dataset.index = index;
	  
	    categoryData.info.forEach(function (info) {
	      var content = document.createElement('div');
	      content.classList.add('fg-color');
	  
	      var textDiv = document.createElement('div');
	      textDiv.classList.add('text');
	      textDiv.textContent = info.content;
	      content.appendChild(textDiv);
	  
	      var iArrow = document.createElement('i');
	      iArrow.classList.add('icon-arrow-right');
	      content.appendChild(iArrow);
	  
	      contentItem.appendChild(content);
	    });
	  
	    contentContainer.appendChild(contentItem);
	  });
	
	  if(data.length >= 2) {
	    var leftArrow = document.createElement('div');
	    leftArrow.classList.add('left-arrow');
	    leftArrow.classList.add("icon-arrow-right")
	    menuContainer.prepend(leftArrow);
	    var rightArrow = document.createElement('div');
	    rightArrow.classList.add('right-arrow');
	    rightArrow.classList.add("icon-arrow-right")
	    menuContainer.appendChild(rightArrow);
	  }
	
	  return wrapperDOM.innerHTML;
	}
	
	module.exports  = generateFullMenuList;

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"chat-container hide\"> <div class=\"loading-tip hide\"> <span class=\"icon-spin loading-btn\"></span> <span> <%=msg_in_loading%></span> </div> <div class=\"no-more-msg hide\"> <span><%=no_more_msg%></span> </div> </div> ";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	
	var EMPTY_FUNCTION = function(){};
	var promptDom;
	var closeBtn;
	var replyBtn;
	var relpyCallback;
	var closeCallback;
	var callbackMessage;
	
	module.exports = function(options){
		var opt = options || {};
		var newPromptDom = _render(opt);
		relpyCallback = opt.replyCallback || EMPTY_FUNCTION;
		closeCallback = opt.closeCallback || EMPTY_FUNCTION;
		callbackMessage = opt.callbackMessage || null;
	
		if(promptDom){
			_unbindEvents();
			document.body.replaceChild(newPromptDom, promptDom);
		}
		else{
			document.body.appendChild(newPromptDom);
		}
	
		promptDom = newPromptDom;
		_bindEvents();
	
		return {
			hide: _hide
		};
	};
	
	function _unbindEvents(){
		utils.off(closeBtn, "click", _closeCallback);
		utils.off(replyBtn, "click", _replyCallback);
	}
	
	function _bindEvents(){
		closeBtn = promptDom.querySelector(".btn-close");
		replyBtn = promptDom.querySelector(".btn-reply");
		utils.on(closeBtn, "click", _closeCallback);
		utils.on(replyBtn, "click", _replyCallback);
	}
	
	function _hide(){
		utils.addClass(promptDom, "hide");
	}
	
	function _replyCallback(){
		_hide();
		relpyCallback(callbackMessage);
	}
	
	function _closeCallback(){
		_hide();
		closeCallback(callbackMessage);
	}
	
	function _render(options){
		var opt = options || {};
		var avatar = opt.avatar || "";
		var title = opt.title || "";
		var content = opt.content || "";
		var className = opt.className || "";
	
		return utils.createElementFromHTML([
			"<div class=\"em-dialog " + className + "\">",
			"<span class=\"indicator bg-border-bottom-color\"></span>",
			"<div class=\"bg-color header\">",
			"<img class=\"avatar\" src=\"" + avatar + "\">",
			"<span class=\"title\">" + title + "</span>",
			"<span class=\"btn-close icon-close\"></span>",
			"</div>",
			"<div class=\"body\">",
			"<p class=\"content\">" + content + "</p>",
			"</div>",
			"<div class=\"footer\">",
			"<button class=\"btn-reply bg-color icon-message\">" + "Reply" + "</button>",
			"</div>",
			"</div>"
		].join(""));
	}


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var apiHelper = __webpack_require__(181);
	var channel = __webpack_require__(186);
	var commonConfig = __webpack_require__(177);
	var answersGroupTimeout;
	var answerIndex = 0;
	var answerLoop = 1;
	var greetingData;
	var waitTimeout;
	var AnswersGroupShowFlag = true;
	var greetingRotate = false;
	module.exports = function(){
		eventListener.add(_const.SYSTEM_EVENT.SESSION_RESTORED, _getGreetings);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_NOT_CREATED, _getGreetings);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_ALREADY_CREATED, _getGreetingsData);
		eventListener.add(_const.SYSTEM_EVENT.CLEAR_TIMEOUT, clearAnswersGroupTimeout);
		eventListener.add(_const.SYSTEM_EVENT.STOP_TIMEOUT, stopAnswerTimeout);
	};
	function htmlDecodeByRegExp(str){
		var temp = "";
		if(str.length == 0) return "";
		temp = str.replace(/&amp;/g, "&");
		temp = temp.replace(/&lt;/g, "<");
		temp = temp.replace(/&gt;/g, ">");
		temp = temp.replace(/&nbsp;/g, " ");
		temp = temp.replace(/&#39;/g, "'");
		temp = temp.replace(/&quot;/g, "\"");
		temp = translate(translate(translate(temp)));  //处理后端多次转义
		return temp;
	}
	function htmlDecodeByRegExp2(str){
		var temp = "";
		if(!str) return "";
		temp = str.replace(/&amp;amp;amp;/g, "&");
		temp = temp.replace(/&amp;amp;lt;/g, "<");
		temp = temp.replace(/&amp;amp;gt;/g, ">");
		temp = temp.replace(/&amp;amp;amp;#39;|&amp;amp;#39;|＆amp;#39;/g, "'");
		temp = temp.replace(/&amp;amp;quot;|&amp;quot;/g, "\"");
	
		temp = translate(translate(translate(temp))); //处理后端多次转义
		return temp;
	}
	function translate(val) {
		return $("<div>"+ val +"</div>").text()
	}
	function _getGreetings(officialAccount){
		console.log('_getGreetings(officialAccount)')
		if(officialAccount !== profile.systemOfficialAccount) return;
		if(officialAccount.isSessionOpen) return;
		Promise.all([
			apiHelper.getSystemGreeting(),
			apiHelper.getRobertGreeting(),
			apiHelper.getSkillgroupMenu(),
		]).then(function(result){
			var systemGreetingText = result[0];
			var robotGreetingObj = result[1];
			var groupMenus = result[2];
	
			var greetingTextType = robotGreetingObj.greetingTextType;
			var greetingText = robotGreetingObj.greetingText;
			var laiye = robotGreetingObj.laiye;
			greetingRotate = robotGreetingObj.rotate;
			var greetingObj = {};
	
			// 系统欢迎语
			systemGreetingText && channel.handleMessage({
				data: systemGreetingText,
			}, {
				type: "commonRichText",
				noPrompt: true
			});
	
	    // 天润机器人欢迎语
	    var greetingObject = robotGreetingObj.greetingObject;
	    if(greetingObject && greetingTextType === 2) {
	      renderTianRunGreeting(greetingObject.data.replies)
	    }
	
			// 机器人欢迎语
	    if(greetingText) {
	      switch(greetingTextType){
	        case 0:
	          // 文本消息
	          greetingText = htmlDecodeByRegExp2(greetingText);
	          channel.handleMessage({
	            data: greetingText,
	          }, {
	            type: "txt",
	            noPrompt: true,
	            laiye: laiye
	          });
	          break;
	        case 1:
	          // 菜单消息
	          // 适配后端有转义两次／三次的情况
	          greetingText = htmlDecodeByRegExp2(greetingText);
	          greetingObj = JSON.parse(greetingText.replace(/&amp;amp;quot;|&amp;quot;/g, "\""));
	          
	          greetingObj.ext && channel.handleMessage({
	            ext: greetingObj.ext,
	          }, {
	            type: "txt",
	            noPrompt: true,
	            answerSource: "WELCOME",
	            laiye: laiye
	          });
	          break;
	        case 2:
	          // 图片消息
	          // 适配后端有转义两次／三次的情况
	          greetingObj = JSON.parse(greetingText.replace(/&amp;amp;quot;|&amp;quot;/g, "\""));
	          greetingObj.url = commonConfig.getConfig().domain + greetingObj.urlPath;
	          channel.handleMessage(greetingObj, { type: "img", noPrompt: true, laiye: laiye });
	          break;
	        case 4:
	            // 图文消息
	          greetingObj = JSON.parse(greetingText.replace(/&amp;amp;quot;|&amp;quot;/g, "\""));
	          greetingObj.url = commonConfig.getConfig().domain + greetingObj.urlPath;
	          greetingObj.ext = {};
	          greetingObj.ext.msgtype = greetingObj.news;
	          channel.handleMessage(greetingObj, { type: "article", noPrompt: true, laiye: laiye });
	          break;
	        case 5:
	          // 答案组
	          greetingText = JSON.parse(htmlDecodeByRegExp2(greetingText));
	          greetingData = greetingText;
	          answersGroupHandleMessage();
	          break;
	        case undefined:
	          // 未设置机器人欢迎语
	          break;
	        default:
	          console.error("unknown robot greeting type.");
	          break;
	      }
	    }
	
			// 技能组列表（机器人菜单）
			if(groupMenus){
				groupMenus.menuName = htmlDecodeByRegExp(groupMenus.menuName);
				if(groupMenus.children && groupMenus.children.length){
					var childs = groupMenus.children;
					_.map(childs, function(item){
						item.menuName = htmlDecodeByRegExp(item.menuName);
						return childs;
					});
				}
				channel.handleMessage({
					data: groupMenus,
				}, {
					type: "skillgroupMenu",
					noPrompt: true
				});
			}
	
			// 询前引导
			if(!greetingTextType && !greetingText && profile.grayList.transfermanualmenuguide && profile.isManualMenuGuide){
				apiHelper.getTransferManualMenu().then(function(result){
					channel.handleMessage({
						data: result,
					}, {
						type: "transferManualMenu",
						noPrompt: true
					});
				});
			}
	
		});
	}
	
	function _getGreetingsData(){
		console.log('_getGreetingsData()')
		//  只调一次，机器人欢迎语，这个整体都不要了
	/* 	Promise.all([
			apiHelper.getSystemGreeting(),
			apiHelper.getRobertGreeting(),
			apiHelper.getSkillgroupMenu(),
		]).then(function(result){
			var robotGreetingObj = result[1];
	    var greetingTextType = robotGreetingObj.greetingTextType;
			var greetingText = robotGreetingObj.greetingText;
			
			greetingRotate = robotGreetingObj.rotate;
	
			if(greetingTextType && greetingText){
				// 答案组
				greetingText = JSON.parse(htmlDecodeByRegExp2(greetingText));
				greetingData = greetingText;
				clearAnswersGroupTimeout();
			}
		}); */
	}
	
	function renderTianRunGreeting(greetings) {
	  console.log('greetings', greetings)
	  greetings.forEach(function(greeting) {
	    var answerType = greeting.answerType;
	    var text = greeting.answerText;
	      if(greeting.answerSource === "Other") {
	        var optionType = greeting.options.optionType;
	        // 菜单类型
	        if(optionType === "HotQuestion") {
	          channel.handleMessage({
	            answerSource: "WELCOME",
	            ext: {
	              msgtype: {
	                options: greeting.options.option,
	                from: "tianrunWelcomeList"
	              }
	            }
	          }, {
	            type: "tianrunRobotWelcomeList",
	            noPrompt: true
	          })
	        }
	
	        // 富文本类型
	        else if(answerType === "RTF") {
	          // var data = text.replace(/&amp;/g, '&')
	          channel.handleMessage({
	            data: text,
	          }, { type: "commonRichText", noPrompt: true });
	        }
	
	        // 文本类型
	        else if(answerType === "Text"){
	          channel.handleMessage({
	            data: text,
	          }, {
	            type: "txt",
	            noPrompt: true
	          })
	        }
	      }
	  })
	}
	
	function answersGroupHandleMessage(){
		var answersLength = greetingData.length;
		var randomTime;
		var greetingTextType;
		var laiye;
		var greetingText;
		var greetingObj = {};
		if(answerIndex < answersLength){
			if(answerIndex == 0){
				randomTime = 0;
			}
			else{
				// randomTime = 1000;
				randomTime = Math.floor((parseInt(Math.random() * 10) + 25) * 1000);
			}
	
			greetingTextType = greetingData[answerIndex].greetingTextType;
			laiye = greetingData[answerIndex].laiye;
			greetingText = greetingData[answerIndex].greetingText;
	
			answersGroupTimeout = setTimeout(function(){
				switch(greetingTextType){
				case 0:
						// 文本消息
					greetingText = htmlDecodeByRegExp2(greetingText);
					channel.handleMessage({
						data: greetingText,
					}, {
						type: "txt",
						noPrompt: true,
						laiye: laiye
					});
					break;
				case 1:
						// 菜单消息
						// 适配后端有转义两次／三次的情况
					greetingText = htmlDecodeByRegExp2(greetingText);
					greetingObj = JSON.parse(greetingText.replace(/&amp;amp;quot;|&amp;quot;/g, "\""));
						
					greetingObj.ext && channel.handleMessage({
						ext: greetingObj.ext,
					}, {
						type: "txt",
						noPrompt: true,
						answerSource: "WELCOME",
						laiye: laiye
					});
					break;
				case 2:
						// 图片消息
						// 适配后端有转义两次／三次的情况
					greetingObj = JSON.parse(greetingText.replace(/&amp;amp;quot;|&amp;quot;/g, "\""));
					greetingObj.url = commonConfig.getConfig().domain + greetingObj.urlPath;
					channel.handleMessage(greetingObj, { type: "img", noPrompt: true, laiye: laiye });
					break;
				case 4:
						// 图文消息
					greetingObj = JSON.parse(greetingText.replace(/&amp;amp;quot;|&amp;quot;/g, "\""));
					greetingObj.url = commonConfig.getConfig().domain + greetingObj.urlPath;
					greetingObj.ext = {};
					greetingObj.ext.msgtype = greetingObj.news;
					channel.handleMessage(greetingObj, { type: "article", noPrompt: true, laiye: laiye });
					break;
				case undefined:
						// 未设置机器人欢迎语
					break;
				default:
					console.error("unknown robot greeting type.");
					break;
				}
				answerIndex++;
				answersGroupHandleMessage();
			}, randomTime);
		}
		else{
			answerLoop++;
			answerIndex = 0;
			clearAnswersGroupTimeout();
		}
	}
	
	function clearAnswersGroupTimeout(){
		var time;
		clearTimeout(waitTimeout);
		if(AnswersGroupShowFlag && greetingRotate){
			if(answerLoop <= 5){
				time = 60 * 1000 * answerLoop;
				clearTimeout(answersGroupTimeout);
				waitTimeout = setTimeout(function(){
					answersGroupHandleMessage();
				}, time);
			}
		}
	}
	
	function stopAnswerTimeout(){
		AnswersGroupShowFlag = false;
		clearTimeout(answersGroupTimeout);
		clearTimeout(waitTimeout);
	}


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var commonConfig = __webpack_require__(177);
	
	var $agentNickname, $agentFace;
	
	module.exports = function(){
		var topBar = document.querySelector(".em-widget-header");
		$agentFace = topBar.querySelector(".em-agent-face");
		$agentNickname = topBar.querySelector(".em-widget-header-nickname");
	
		eventListener.add(_const.SYSTEM_EVENT.SESSION_OPENED, _updateAgentNickname);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERED, _updateAgentNickname);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERING, _updateAgentNickname);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_CLOSED, _updateAgentNickname);
	
		eventListener.add(_const.SYSTEM_EVENT.AGENT_INFO_UPDATE, _updateAgentNickname);
	
		eventListener.add(_const.SYSTEM_EVENT.SESSION_RESTORED, _updateAgentNickname);
		eventListener.add(_const.SYSTEM_EVENT.SESSION_NOT_CREATED, _updateAgentNickname);
	
		eventListener.add(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_SWITCHED, _updateAgentNickname);
	};
	
	function _updateAgentNickname(officialAccount){
		$(".em-service-title").addClass("hide");
		if(officialAccount !== profile.currentOfficialAccount) return;
	
		var agentNickname = officialAccount.agentNickname;
		var agentAvatar = officialAccount.agentAvatar;
		var isSessionOpen = officialAccount.isSessionOpen;
		var officialAccountType = officialAccount.type;
		var defaultAvatar = commonConfig.getConfig().staticPath + "/img/default_avatar.png";
		var faceImg;
		if(agentNickname && agentAvatar){
			faceImg = agentAvatar;
		}
		else if(officialAccount.img){
			faceImg = officialAccount.img
		}
		else{
			faceImg = $agentFace.src;
		}
		$agentFace.src = faceImg;
		// utils.removeClass($agentFace, "hide");
	
		// fake: update system agent avatar
		if(officialAccountType === "SYSTEM"){
			profile.systemAgentAvatar = isSessionOpen
				? utils.getAvatarsFullPath(agentAvatar, commonConfig.getConfig().domain)
				: null;
		}
	
		if(officialAccountType === "CUSTOM"){
			// 昵称显示为服务号名称
			$agentNickname.innerText = officialAccount.name;
		}
		else if(
			profile.isAgentNicknameEnable
			&& agentNickname
			&& isSessionOpen
			&& agentNickname !== "Scheduler"
		){
			$agentNickname.innerText = agentNickname;
		}
		else if(profile.latestNiceName && isSessionOpen){
			$agentNickname.innerText = profile.latestNiceName;
		}
		else{
			$agentNickname.innerText = profile.defaultAgentName;
		}
		profile.newNickName = $agentNickname.innerText;
	}


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var apiHelper = __webpack_require__(181);
	var channel = __webpack_require__(186);
	var commonConfig = __webpack_require__(177);
	var Swiper = __webpack_require__(213);
	var popup = __webpack_require__(237);
	
	var apiHelperQA = __webpack_require__(238);
	
	var toKefuBtn;
	
	module.exports = function(data, isOpen){
		var prevPc = document.querySelector(".swiper-button-prev");
		var nextPc = document.querySelector(".swiper-button-next");
		if(!isOpen){
			data = [];
			$(prevPc).addClass("hide");
			$(nextPc).addClass("hide");
			$(".swiper-container").css("width", "96%");
		}
		if(data.length == 0){
			$(prevPc).addClass("hide");
			$(nextPc).addClass("hide");
			$(".swiper-container").css("width", "96%");
		}
		$(".em-widget-send-wrapper-top").removeClass("hide");
		// 自定义主题色
		var color = "";
		var themeClassName;
		var config = commonConfig.getConfig();
		var themeName = config.ui.themeName;
		if(themeName && themeName.indexOf("theme_custom") > -1){
			var arr = themeName.split("theme_custom");
			color = arr[1];
			themeClassName = "theme_custom";
		}
		else{
			themeClassName = _const.themeMap[config.themeName];
		}
	
		// toKefuBtn = document.querySelector(".em-widget-to-kefu-input-button");
	
		toKefuBtn = document.querySelector(".em-widget-to-kefu");
		var topButtonBox = document.querySelector(".em-widget-send-wrapper-top>.swiper-container>.swiper-wrapper");
		for(var i = 0; i < data.length; i++){
			var el = utils.createElementFromHTML("<div class=\"swiper-slide\"  content=\"" + data[i].content + "\" type=\"" + data[i].operateType + "\" title=\"" + data[i].name + "\" id=\"" + data[i].id + "\" class=\"input-top-btn  " + themeClassName + "\">" + data[i].name + " </div>");
			// mySwiper.appendSlide(el);
			topButtonBox.append(el);
		}
	
	
	
		$(".em-widget-send-wrapper-top>.swiper-container>.swiper-wrapper .swiper-slide").hover(function(){
			var hoverColor = $("body." + themeClassName + " .border-color").css("borderColor");
			hoverColor = hoverColor ? hoverColor : "#42b8f4";
			if($(this).hasClass("em-widget-exit-video")){
				return false;
			}
			if(color){
				$(this).css("color", color);
				$(this).css("borderColor", color);
			}
			else{
				$(this).css("color", hoverColor);
				$(this).css("borderColor", hoverColor);
			}
	
		}, function(){
			if($(this).hasClass("em-widget-exit-video")){
				return false;
			}
			$(this).css("color", "#566477");
			$(this).css("borderColor", "#E6E6E6");
		});
	
		// eventListener.add(_const.SYSTEM_EVENT.SESSION_OPENED, _displayOrHideTransferToKefuBtn);
		// eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERING, _displayOrHideTransferToKefuBtn);
		// eventListener.add(_const.SYSTEM_EVENT.SESSION_TRANSFERED, _displayOrHideTransferToKefuBtn);
		// eventListener.add(_const.SYSTEM_EVENT.SESSION_RESTORED, _displayOrHideTransferToKefuBtn);
		// eventListener.add(_const.SYSTEM_EVENT.SESSION_NOT_CREATED, _displayOrHideTransferToKefuBtn);
		// eventListener.add(_const.SYSTEM_EVENT.OFFICIAL_ACCOUNT_SWITCHED, _displayOrHideTransferToKefuBtn);
	
		// eventListener.add("video.conform", _conformVideo);
		// eventListener.add("video.cancel", _cancelVideo);
		eventListener.add("swiper.update", updateSwiper);
	
	
		if(utils.isMobile){
			// 移动端 ，也要有箭头按钮的
	/* 		var next = document.querySelector(".swiper-button-next");
			var prev = document.querySelector(".swiper-button-prev");
			$(next).addClass("hide");
			$(prev).addClass("hide"); */
			var mySwiper = new Swiper(".em-widget-send-wrapper-top>.swiper-container", {
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				slidesPerView: "auto",
				spaceBetween: 10,
				freeMode: true,
			});
		}
		else{
			var mySwiper = new Swiper(".em-widget-send-wrapper-top>.swiper-container", {
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				slidesPerView: "auto",
				spaceBetween: 10,
				freeMode: true,
				mousewheel: true,
			});
			var prevPc = document.querySelector(".swiper-button-prev");
			var nextPc = document.querySelector(".swiper-button-next");
			if($(nextPc).hasClass("swiper-button-disabled")){
				$(prevPc).addClass("hide");
				$(nextPc).addClass("hide");
				$(".swiper-container").css("width", "96%");
			}
		}
		// 输入框上方的按钮
		// utils.on(document.getElementsByClassName("input-top-btn"), "click", function(e){
		utils.on(document.getElementsByClassName("swiper-slide"), "click", function(e){
			var content = $(e.target).attr("content");
			var type = $(e.target).attr("type");
			var sendBtn = document.querySelector(".em-widget-send-wrapper .em-widget-send");
			var textInput = document.querySelector(".em-widget-send-wrapper .em-widget-textarea");
	// 埋点 ST
			var id =  $(e.target).attr("id");
			apiHelperQA.recordFaqClick(id,"shortcut");
	// 埋点 END
	
			if(utils.isMobile){
				var satisfaction = document.querySelector(".em-widget-send-wrapper .toolbar-mobile .em-widget-satisfaction");
			}
			else{
				var satisfaction = document.querySelector(".em-widget-send-wrapper .toolbar-pc .em-widget-satisfaction");
			}
			switch(type){
			case "link":
				window.open(content);
				break;
			case "message":
				textInput.value = content;
				$(sendBtn).removeClass("disabled");
				utils.trigger(sendBtn, "click");
				break;
			case "transfer":
				channel.sendTransferToKf();
				break;
			case "evaluate":
				utils.trigger(satisfaction, "click");
				break;
	    case "popup":
	      popup.show();
			default:
				break;
			}
	
		});
		// // 确定视频通话
		// function _conformVideo(){
		// 	var videoBtn =  document.querySelector(".swiper-wrapper>.em-widget-exit-video");
		// 	$(videoBtn).removeClass("hide");
		// 	mySwiper.update();
		// }
		// // 取消视频通话
		// function _cancelVideo(){
		// 	var videoBtn =  document.querySelector(".swiper-wrapper>.em-widget-exit-video");
		// 	$(videoBtn).addClass("hide");
		// 	mySwiper.update();
		// }
		function updateSwiper(){
			setTimeout(function(){
				mySwiper.update();
				if($(nextPc).hasClass("swiper-button-disabled") && $(prevPc).hasClass("swiper-button-disabled")){
					$(prevPc).addClass("hide");
					$(nextPc).addClass("hide");
					$(".swiper-container").css("width", "96%");
				}
				else{
					$(prevPc).removeClass("hide");
					$(nextPc).removeClass("hide");
				}
				// 移动端 ，也要有箭头按钮的
	/* 			if(utils.isMobile){
					$(prevPc).addClass("hide");
					$(nextPc).addClass("hide");
				} */
			}, 1100);
		}
	
		function _displayOrHideTransferToKefuBtn(officialAccount){
			// 如果转人工开关没有打开不走此逻辑
			if(!commonConfig.getConfig().toolbar.transferToKefu) return;
			// 忽略非当前服务号的事件
			if(profile.currentOfficialAccount !== officialAccount) return;
	
			var state = officialAccount.sessionState;
			var agentType = officialAccount.agentType;
			var type = officialAccount.type;
			var isRobotAgent = agentType === _const.AGENT_ROLE.ROBOT;
	
			if(type === "CUSTOM"){
				// 营销号一律不显示转人工按钮
				utils.addClass(toKefuBtn, "hide");
				mySwiper.update();
			}
			else if(state === _const.SESSION_STATE.PROCESSING){
				utils.toggleClass(toKefuBtn, "hide", !isRobotAgent);
				mySwiper.update();
			}
			else if(state === _const.SESSION_STATE.WAIT){
				// 待接入状态 隐藏按钮
				utils.addClass(toKefuBtn, "hide");
				mySwiper.update();
			}
			else{
				if(!officialAccount.isSessionOpen) return;
				apiHelper.getRobertIsOpen().then(function(isRobotEnable){
					utils.toggleClass(toKefuBtn, "hide", !isRobotEnable);
				});
				mySwiper.update();
			}
			if(utils.isMobile){
				if(utils.hasClass(toKefuBtn, "hide")){
					textareaBtn.style.maxWidth = "calc(100% - 45px)";
				}
				else{
					textareaBtn.style.maxWidth = "calc(100% - 90px)";
				}
				mySwiper.update();
			}
		}
		utils.on(document.querySelector(".swiper-slide.em-widget-out-of-line"), "click", function(e){
			var officialAccount = profile.currentOfficialAccount;
			if(!officialAccount){
				return;
			}
			var videoBtn = document.querySelector(".swiper-wrapper>.em-widget-exit-video");
			$(videoBtn).addClass("hide");
			mySwiper.update();
			var isSessionOpen = officialAccount.isSessionOpen;
			var sessionId = officialAccount.sessionId;
			isSessionOpen && apiHelper.closeServiceSession(sessionId);
		});
	
	  popupInit(data)
	};
	
	function popupInit(data) {
	  var popupItem = data.filter(function(item) {
	    return item.operateType === 'popup';
	  })[0]
	
	  if(popupItem) {
	    var autoOpen
	    var popupConfig = commonConfig.getConfig().popup || {}
	    if(popupConfig.autoOpen !== undefined) {
	      autoOpen = popupConfig.autoOpen
	    } else {
	      autoOpen = popupItem.operateExtend === "1"
	    }
	
	    popupConfig.url = popupItem.content
	    popupConfig.autoOpen = autoOpen
	
	    commonConfig.setConfig({
	      popupConfig: popupConfig
	    })
	    
	    popup.handler(popupConfig)
	  }
	}
	


/***/ }),
/* 237 */
/***/ (function(module, exports) {

	var modal, dialog;
	var isIframeMode;
	var isMobile = isMobileDevice();
	var autoOpen;
	
	function handler(popupConfig) {
	  var url = popupConfig.url || "http://localhost:8008/webim/demos/dunhuang/order-popup.html";
	  autoOpen = popupConfig.autoOpen;
	  isIframeMode = window.top !== window.self;
	  modal = createModal();
	
	  // 将 popupConfig 中的配置信息传递给 iframe url
	  var urlInfoConfig = popupConfig
	  delete urlInfoConfig.url
	
	  var params = "";
	  for (var key in urlInfoConfig) {
	    if (urlInfoConfig.hasOwnProperty(key)) {
	      if (params !== "") {
	        params += "&";
	      }
	      params += encodeURIComponent(key) + "=" + encodeURIComponent(urlInfoConfig[key].toString());
	    }
	  }
	
	  if(params.length) {
	    url += "?" + params;
	  }
	  
	  dialog = renderDialog(url);
	
	  var container = document.querySelector(".em-widget-box");
	
	  // 点击 dialog 以外的区域关闭 dialog
	  container.addEventListener("click", function (event) {
	    var isClickInsidePopup = dialog.contains(event.target); // 检查点击的元素是否在 dialog 内部
	    var isClickInsideModal = modal.contains(event.target); // 检查点击的元素是否在 dialog 内部
	
	    if (!isClickInsidePopup && isClickInsideModal) {
	      hide();
	    }
	  });
	
	  iframeListenHandler();
	  modal.appendChild(dialog);
	  container.appendChild(modal);
	
	  if (autoOpen) {
	    show();
	  } else {
	    hide();
	  }
	}
	
	function renderDialog(url) {
	  dialog = document.createElement("div");
	  dialog.className = "popup-dialog";
	  dialog.style.width = "100%";
	  if (isMobile) {
	    dialog.style.height = "75%";
	  } else {
	    dialog.style.height = "417px";
	  }
	  dialog.style.padding = "0";
	  dialog.style.margin = "0";
	  dialog.style.border = "none";
	  dialog.style.position = "absolute";
	  dialog.style.backgroundColor = "#fff";
	  dialog.style.bottom = "0";
	  dialog.style.left = "0";
	  dialog.style.zIndex = "10";
	  dialog.style.borderRadius = "12px 12px 0 0";
	
	  dialog.innerHTML =
	    '<iframe src="' + url + '" style="width:100%;height:100%;border:none;"></iframe>';
	  return dialog;
	}
	
	function createModal() {
	  // 新建一个 Modal
	  var modal = document.createElement("div");
	  modal.className = "popup-modal";
	  modal.style.width = "100%";
	  modal.style.height = "100%";
	  modal.style.position = "absolute";
	  modal.style.top = "0";
	  modal.style.left = "0";
	  modal.style.zIndex = "10";
	  modal.style.backgroundColor = "rgba(0,0,0,0.5)";
	  return modal;
	}
	
	function iframeListenHandler() {
	  window.addEventListener("message", function (event) {
	    var data;
	    try {
	      data = JSON.parse(event.data);
	    } catch (err) {
	      return;
	    }
	
	    var type = data.type;
	    var value = data.value;
	
	    if (type === "POPUP_CLOSE") {
	      hide();
	    } else if (type == "POPUP_ORDER") {
	      hide();
	      window.sendText(value);
	    }
	  });
	}
	
	function isMobileDevice() {
	  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	}
	
	function ifShouldOpenPopup(config) {
	  if (config.popup && config.popup.switch) {
	    handler(config.popup.url);
	  }
	}
	
	function show() {
	  dialog.style.display = "block";
	  modal.style.display = "block";
	}
	
	function hide() {
	  dialog.style.display = "none";
	  modal.style.display = "none";
	}
	
	module.exports = {
	  ifShouldOpenPopup: ifShouldOpenPopup,
	  handler: handler,
	  show:show,
	  hide:hide,
	};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var apiHelper = __webpack_require__(182);
	var commonConfig = __webpack_require__(177);
	
	// 以下调用会缓存参数
	// getVisitorId
	// getProjectId
	// getToken
	var config;
	
	var api = apiHelper.api;
	
	function getFaqList(){
		var config = commonConfig.getConfig()
		return new Promise(function(resolve, reject){
			api("getFaqList", {
				tenantId: config.tenantId,
				configId: config.configId
			}, function(msg){
				var status = utils.getDataByPath(msg, "data.status");
				var entities = utils.getDataByPath(msg, "data.entities");
				if(status === "OK"){
					resolve(entities);
				}
				else{
					reject(msg.data);
				}
			}, function(error){
				reject(error);
			});
		});
	}
	function recordFaqClick(issueId,recordType){
		return new Promise(function(resolve, reject){
			api("recordFaqClick", {
				tenantId: config.tenantId,
				configId: config.configId,
				issueId: issueId,
				recordType:recordType,
			}, function(msg){
				if(status === "OK"){
					resolve();
				}
				else{
					reject(msg.data);
				}
			}, function(error){
				reject(error);
			});
		});
	}
	function getSelfServiceList(){
		var config = commonConfig.getConfig()
		return new Promise(function(resolve, reject){
			api("getSelfServiceList", {
				tenantId: config.tenantId,
				configId: config.configId
			}, function(msg){
				var status = utils.getDataByPath(msg, "data.status");
				var entities = utils.getDataByPath(msg, "data.entities");
				if(status === "OK"){
					resolve(entities);
				}
				else{
					reject(msg.data);
				}
			}, function(error){
				reject(error);
			});
		});
	}
	
	function getSelfServiceAndFaq(){
		var config = commonConfig.getConfig()
		if(config.configId){
			return new Promise(function(resolve, reject){
				Promise.all([
					getSelfServiceList(),
					getFaqList()
				]).then(function(result){
					resolve(result);
				});
			});
		}
		else{
			return new Promise(function(resolve, reject){
				resolve([[],[]]);
			});
		}
	}
	
	
	
	module.exports = {
		getFaqList: getFaqList,
		getSelfServiceList: getSelfServiceList,
		recordFaqClick: recordFaqClick,
		getSelfServiceAndFaq:getSelfServiceAndFaq,
		update: function(cfg){
			config = cfg;
		}
	};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var apiHelper = __webpack_require__(181);
	var channel = __webpack_require__(186);
	var commonConfig = __webpack_require__(177);
	var uikit = __webpack_require__(180);
	var Swiper = __webpack_require__(213);  
	
	
	var toKefuBtn;
	
	module.exports = function(data,isShowSatis){
		// $(".em-widget-send-wrapper-top").addClass("hide")
		// 获取按钮数量渲染按钮
		var H5ButtonBox = document.querySelector(".toolbar-mobile>.swiper-wrapper");
		// 获取原来容器中button的数量
		var oldBtnEl = document.querySelector(".toolbar-mobile>.swiper-wrapper>.swiper-slide");
		var oldBtnNum = $(oldBtnEl).children(".hide").length;//隐藏的按钮
		if(isShowSatis){
			oldBtnNum -= 1;
		}
	
	
		// 默认有6个按钮，计算出默认有几个按钮显示然后补全。一页要显示8个按钮。 
		
		var oldBtn =  data.slice(0,oldBtnNum+2);
		var newBtn = data.slice(oldBtnNum+2,data.length);
	
	
		var newData = [];
		for(var i = 0;i<newBtn.length;i+=8){
	        newData.push(newBtn.slice(i,i+8))
		}
		for(var j=0;j<oldBtn.length;j++){
			// var url = oldBtn[j].icon.split("Tenant")[1]
			var url = oldBtn[j].icon;
			// url = "//" + window.location.host + "/Tenant" + url
			// url = window.location.host + "/Tenant" + url
			var el = utils.createElementFromHTML("<div class=\"\"><div class=\"btn-container\"> <img content=\""+ oldBtn[j].content+"\" type=\""+ oldBtn[j].operateType+"\" src=\""+ url +"\" /> </div><span>"+ oldBtn[j].name +"</span></div>");
			oldBtnEl.append(el)
		}
		var slideBox,slidContent;
		newData.forEach(function(item, index){
			slideBox = utils.createElementFromHTML("<div class=\"swiper-slide\"></div>");
			for(var i=0;i<item.length;i++){
			
				slidContent = utils.createElementFromHTML("<div class=\"\"><div class=\"btn-container\"> <img content=\""+ item[i].content+"\" type=\""+ item[i].operateType+"\" src=\""+ item[i].icon +"\" /> </div><span>"+ item[i].name +"</span></div>");
				slideBox.append(slidContent)
			}
			H5ButtonBox.append(slideBox)
		})
	
		// 获取主题色
		var color = "";
		var themeClassName;
		var config = commonConfig.getConfig();
		var themeName = config.ui.themeName;
		if(themeName && themeName.indexOf("theme_custom") > -1){
			var arr = themeName.split("theme_custom");
			color = arr[1];
			themeClassName = "theme_custom";
		}
		else{
			themeClassName = _const.themeMap[config.themeName];
		}
		var hoverColor = $("body."+ themeClassName +" .border-color").css("borderColor")
		var mySwiperH5 = new Swiper('.toolbar-mobile',{
			pagination:{
				el:'.swiper-pagination',
				clickable:true,
			},//这样写小圆点就有了
			resistanceRatio : 0,
			observer: true,//修改swiper自己或子元素时，自动初始化swiper
			observeParents: true,//修改swiper的父元素时，自动初始化swiper
			on: {
				slideChange: function(swiper){
					var el = document.querySelector(".swiper-pagination-bullet-active")
					if(color){
						$(el).css("backgroundColor",color)
					}
					else{
						$(el).css("backgroundColor",hoverColor)
					}
				},
			}
		})
		var slidNum = H5ButtonBox.getElementsByClassName("swiper-slide").length;
		if(slidNum<2){
			$(document.querySelector(".swiper-pagination")).addClass("hide")
		}
		// swiper-slide
	
		// H5按钮
		// 输入框上方的按钮
		utils.on($(".toolbar-mobile .swiper-slide>div"), "click", function(e){
			var content = $(e.target).attr("content")
			var type = $(e.target).attr("type");
			// var	sendBtn = document.querySelector(".em-widget-send-wrapper .em-widget-send");
			// var textInput = document.querySelector(".em-widget-send-wrapper .em-widget-textarea");
			var satisfaction = document.querySelector(".em-widget-send-wrapper .toolbar-mobile .em-widget-satisfaction");
	
			var sendImgBtn = document.querySelector(".em-widget-send-wrapper .toolbar-mobile .em-widget-img");
			var sendVideoBtn = document.querySelector(".em-widget-send-wrapper .toolbar-mobile .em-widget-video");
			var popWindow = document.querySelector(".chat-pop-em-model");
			var iframe = document.getElementById("chat-pop")
		
			switch(type){
			case "linkH5":
				window.open(content)
				break;
			case "popWindow":
				$(popWindow).removeClass("hide");
				$(iframe).attr("src",content)
				break;
			case "photo":
				utils.trigger(sendImgBtn, "click");
				break;
			case "video":
				utils.trigger(sendVideoBtn, "click");
				break;
			case "evaluateH5":
				utils.trigger(satisfaction, "click");
				break;
			default:
				break;
			}
		});
		utils.on(document.querySelector(".chat-pop .icon-close"), "click", function(e){
			var popWindow = document.querySelector(".chat-pop-em-model");
			$(popWindow).addClass("hide");
		})
	
	};
	
	


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var template = __webpack_require__(241);
	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	var apiHelper = __webpack_require__(181);
	var profile = __webpack_require__(178);
	var channel = __webpack_require__(186);
	var List = __webpack_require__(187);
	var commonConfig = __webpack_require__(177);
	
	var HEIGHT_OF_TOP_NAVIGATOR = 43;
	var MAGIC_EMOJI_COUNT_PER_LINE = 6;
	var EMOJI_COUNT_PER_LINE = 10;
	
	var dom;
	var emojiPageContainer;
	var systemEmojiContainer;
	var emojiContainerList;
	var loadedEmojiPageIndexList = new List();
	var customEmojiPackageHtmlList;
	var config;
	
	module.exports = {
		init: init,
		move: move,
	};
	
	function init(option){
		var isEmojiLoaded = false;
		var params = option || {};
		var container = params.container;
		var toggleButton = params.toggleButton;
		var textInput = params.textInput;
		config = commonConfig.getConfig();
	
		if(dom) throw new Error("emoji panel has already initialized.");
	
		dom = utils.createElementFromHTML(template);
		systemEmojiContainer = dom.querySelector(".emoji-container.system");
	
		container.appendChild(dom);
	
		utils.on(toggleButton, utils.click, function(){
			if(utils.isMobile){
				if($(document.querySelector(".toolbar-mobile")).hasClass("hide")){
					utils.trigger(document.querySelector(".em-widget-add"), "click");
				}
				else{
					if(!$(dom).hasClass("hide")){
						utils.trigger(document.querySelector(".em-widget-add"), "click");
					}
				}
			}
			textInput.blur();
			utils.toggleClass(dom, "hide");
			if(profile.grayList.poweredByEasemob){
				if(!utils.isMobile){
					utils.addClass(document.querySelector(".emoji-panel"), "emoji-bottom160");
				}
			}
	
			// 懒加载，打开表情面板时才初始化图标
			if(!isEmojiLoaded){
				isEmojiLoaded = true;
				_loadSystemEmojiPackage();
				_initCustomMagicEmoji();
			}
		});
	
		// 表情的选中
		utils.live("img.emoji", utils.click, function(ev){
			var event = window.event || ev;
			var target = event.srcElement || event.target;
			var type = target.getAttribute("data-type");
			var imageUrl;
	
			if(type === "custom"){
				imageUrl = target.getAttribute("data-origin-url");
				channel.sendText("", {
					ext: {
						msgtype: {
							customMagicEmoji: {
								url: imageUrl,
							},
						},
					},
				});
			}
			else{
				!utils.isMobile && textInput.focus();
				textInput.value += target.getAttribute("data-value");
				utils.trigger(textInput, "change");
			}
		}, dom);
	
		// todo: kill .e-face to make it more elegant
		// ie8 does not support stopPropagation -_-||
		// 点击别处时隐藏表情面板
		utils.on(document, utils.click, function(ev){
			var e = window.event || ev;
			var target = e.srcElement || e.target;
	
			if(!utils.hasClass(target, "e-face")){
				utils.addClass(dom, "hide");
			}
		});
	}
	
	// 输入框位置发生变化时表情面板要随之移动
	function move(inputBoxPosition, offset){
		var offsetHeight = offset || 0;
	
		switch(inputBoxPosition){
		case "up":
			if(offsetHeight > 200){
				dom.style.top = "60px";
			}else{
				dom.style.top = offsetHeight + "px";
			}
			dom.style.bottom = "auto";
			break;
		case "down":
			dom.style.top = "auto";
			if(offsetHeight > 200){
				dom.style.bottom = 3 + "px";
			}else{
				dom.style.bottom = offsetHeight + "px";
			}
			
			break;
		default:
			throw new Error("unexpect direction.");
		}
	}
	
	function _initCustomMagicEmoji(){
		if(!profile.grayList.customMagicEmoji) return;
		if(emojiPageContainer) throw new Error("custom magic emoji has already initialized.");
	
		emojiPageContainer = dom.querySelector(".page-container");
	
		Promise.all([
			apiHelper.getCustomEmojiPackages(),
			apiHelper.getCustomEmojiFiles(),
		]).then(function(result){
			var packageList = result[0];
			var fileList = result[1];
	
			if(_.isEmpty(packageList)) return;
	
			customEmojiPackageHtmlList = _genEmojiPackageHtmlList(packageList, fileList);
	
			// 自定义表情仅创建空的 container，懒加载
			_.each(customEmojiPackageHtmlList, function(){
				var tmpHtml = "<div class=\"emoji-container magic hide\"></div>";
				var tmpDom = utils.createElementFromHTML(tmpHtml);
	
				emojiPageContainer.appendChild(tmpDom);
			});
	
			emojiContainerList = _.toArray(emojiPageContainer.querySelectorAll(".emoji-container"));
	
			_initNavigator(packageList);
		});
	}
	
	function _genEmojiPackageHtmlList(packageList, fileList){
		return _.chain(packageList)
		.pluck("id")
		.map(function(packageId){
			var filesInCurrentPackage = _.where(fileList, { packageId: packageId });
			var currentPageHtml =  _.chain(filesInCurrentPackage)
			// 生成图标html
			.map(function(item){
				var thumbnailUrl = utils.formatProtocol(config.domain) + item.thumbnailUrl;
				var originUrl = item.originUrl;
	
				return "<div class=\"emoji-bg e-face\">"
						+ "<img class=\"e-face emoji\" src=\""
						+ thumbnailUrl
						+ "\" data-origin-url=" + originUrl + " data-type=\"custom\"/>"
						+ "</div>";
			})
			// 按照下标分组
			.groupBy(function(elem, index){
				return Math.floor(index / MAGIC_EMOJI_COUNT_PER_LINE);
			})
			// 增加wrapper
			.map(function(elem){
				var currentLineHtml = elem.join("");
	
				return "<li class=\"line-container e-face\">" + currentLineHtml + "</li>";
			})
			// 结束链式调用
			.value()
			// 把数组拼接成字符串
			.join("");
	
			return currentPageHtml;
		})
		.value();
	}
	
	function _initNavigator(packageList){
		var packageNameList = _.pluck(packageList, "packageName");
		var navigatorWrapper = dom.querySelector(".navigator-wrapper");
		var navigatorContainer = navigatorWrapper.querySelector(".navigator-container");
		var navigatorItemList;
	
		// 增加系统默认图标导航
		packageNameList.unshift("default");
	
		navigatorContainer.innerHTML = _.map(packageNameList, function(name, index){
			// todo: xss defence
			return "<li class=\"navigator-item e-face\" data-page-index=\"" + index + "\">" + name + "</li>";
		}).join("");
	
		navigatorItemList = _.toArray(navigatorContainer.querySelectorAll(".navigator-item"));
	
		utils.live(".navigator-item", utils.click, function(ev){
			var event = window.event || ev;
			var target = event.srcElement || event.target;
			var targetIndex = +target.getAttribute("data-page-index");
	
			utils.addClass(target, "selected");
			_.each(emojiContainerList, function(elem, index){
				var emojiContainer = elem;
				var navigatorItem = navigatorItemList[index];
				var isTargetElement = targetIndex === index;
	
				utils.toggleClass(emojiContainer, "hide", !isTargetElement);
				utils.toggleClass(navigatorItem, "selected", isTargetElement);
	
				// 自定义表情面板懒加载
				if(
					isTargetElement
					&& index !== 0
					&& !loadedEmojiPageIndexList.has(index)
				){
					emojiContainerList[index].innerHTML = customEmojiPackageHtmlList[index - 1];
					loadedEmojiPageIndexList.add(index);
				}
			});
		}, navigatorContainer);
	
		// init scroll
		setTimeout(function(){
			_initScroll({
				navigatorWrapper: navigatorWrapper,
				navigatorContainer: navigatorContainer,
				navigatorItemList: navigatorItemList,
			});
		}, 0);
	
		// 选取第一个item
		utils.addClass(navigatorContainer.querySelector(".navigator-item"), "selected");
	
		// 显示导航栏
		utils.removeClass(navigatorWrapper, "hide");
	}
	
	function _initScroll(domList){
		var SCROLL_BUTTON_WIDTH = 30;
		var navigatorWrapper = domList.navigatorWrapper;
		var navigatorContainer = domList.navigatorContainer;
		var navigatorItemList = domList.navigatorItemList;
		var scrollLeftButton = navigatorWrapper.querySelector(".scroll-left");
		var scrollRightButton = navigatorWrapper.querySelector(".scroll-right");
		var containerWidth = _getElementWidth(navigatorContainer) - (SCROLL_BUTTON_WIDTH * 2);
		var sumOfAllContentWidth = _.chain(navigatorItemList)
		.map(function(elem){
			return _getElementWidth(elem);
		})
		.reduce(function(a, b){
			return a + b;
		}, 0)
		.value();
	
		if(sumOfAllContentWidth > containerWidth){
			_updateScrollButtonStatus();
	
			utils.on(scrollLeftButton, utils.click, _handleScrollButton);
			utils.on(scrollRightButton, utils.click, _handleScrollButton);
		}
	
		function _handleScrollButton(ev){
			var event = window.event || ev;
			var target = event.srcElement || event.target;
			var isDisabled = utils.hasClass(target, "disabled");
			var isLeftButton = utils.hasClass(target, "scroll-left");
			var isRightButton = utils.hasClass(target, "scroll-right");
	
			if(isDisabled) return;
	
			if(isLeftButton){
				_setContentOffset(+containerWidth);
			}
			else if(isRightButton){
				_setContentOffset(-containerWidth);
			}
			else{
				throw new Error("unexpected button triggered");
			}
	
			_updateScrollButtonStatus();
		}
		function _setContentOffset(offset){
			var currentLeftOffset = navigatorContainer.getBoundingClientRect().left
				- navigatorWrapper.getBoundingClientRect().left;
			var targetOffset = currentLeftOffset + offset;
			var maxOffset = 0;
			var minOffset = -(sumOfAllContentWidth - containerWidth);
	
			if(targetOffset > maxOffset){
				targetOffset = maxOffset;
	
			}
			else if(targetOffset < minOffset){
				targetOffset = minOffset;
			}
			if(targetOffset !== currentLeftOffset){
				navigatorContainer.style.left = targetOffset + "px";
			}
		}
		function _updateScrollButtonStatus(){
			var currentLeftOffset = navigatorContainer.getBoundingClientRect().left
				- navigatorWrapper.getBoundingClientRect().left;
	
			utils.toggleClass(scrollLeftButton, "disabled", currentLeftOffset === 0);
			utils.toggleClass(scrollRightButton, "disabled", (-currentLeftOffset + containerWidth) >= sumOfAllContentWidth);
		}
		function _getElementWidth(elem){
			var domRect = elem.getBoundingClientRect();
	
			// IE8 doesn't support width / height property
			return domRect.width || (domRect.right - domRect.left);
		}
	}
	
	function _loadSystemEmojiPackage(){
		var path = _const.EMOJI_PATH;
	
		systemEmojiContainer.innerHTML = _.chain(_const.EMOJI_MAP)
		// 生成图标html
		.map(function(value, key){
			return "<div class=\"emoji-bg e-face\">"
					+ "<img class=\"e-face emoji\" src=\""
					+ path + value
					+ "\" data-value=" + key + " />"
					+ "</div>";
		})
		// 按照下标分组
		.groupBy(function(elem, index){
			return Math.floor(index / EMOJI_COUNT_PER_LINE);
		})
		// 增加wrapper
		.map(function(elem){
			// todo: discard line-container
			return "<li class=\"line-container e-face\">" + elem.join("") + "</li>";
		})
		// 结束链式调用
		.value()
		// 把数组拼接成字符串
		.join("");
	}


/***/ }),
/* 241 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"emoji-panel e-face hide\"> <div class=page-container> <ul class=\"system emoji-container\"></ul> </div> <div class=\"navigator-wrapper e-face hide\"> <div class=\"navigator-container e-face\"></div> <li class=\"scroll-left icon-corner-left e-face disabled\"></li> <li class=\"scroll-right icon-corner-right e-face disabled\"></li> </div> </div> ";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var _const = __webpack_require__(176);
	var utils = __webpack_require__(16);
	var profile = __webpack_require__(178);
	var eventListener = __webpack_require__(185);
	var channel = __webpack_require__(186);
	
	var messageChannelReadyPromise;
	var sessionOpenPromise;
	var initOnce = _.once(_init);
	
	module.exports = {
		init: initOnce,
		push: push,
	};
	
	/*
		暂时没有考虑会话打开后又关闭的情形
		所以会话打开后 crm 消息就会无阻碍发送
		即使后来会话又被关闭
	*/
	
	function push(extendMessage){
		var isCrmExtendMessage = !!utils.getDataByPath(extendMessage, "cmd.updateVisitorInfoSrc");
		initOnce();
		if(isCrmExtendMessage){
			// crm 对接消息必须等会话打开后才能发
			// todo: discard ext
			sessionOpenPromise.then(function(){ channel.sendText("", { ext: extendMessage }); });
		}
		else{
			// 其他消息只要 channelReady 就可以发
			messageChannelReadyPromise.then(function(){ channel.sendText("", { ext: extendMessage }); });
		}
	}
	
	function _init(){
		sessionOpenPromise = new Promise(function(resolve){
			eventListener.add([
				_const.SYSTEM_EVENT.SESSION_OPENED,
				_const.SYSTEM_EVENT.SESSION_RESTORED,
			], function(){
				profile.systemOfficialAccount.isSessionOpen && resolve();
			});
		});
	
		messageChannelReadyPromise = new Promise(function(resolve){
			eventListener.add(_const.SYSTEM_EVENT.MESSAGE_CHANNEL_READY, resolve);
		});
	}


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var apiHelper = __webpack_require__(181);
	var PopupList = __webpack_require__(244);
	var utils = __webpack_require__(16);
	var channel = __webpack_require__(186);
	var tpl = __webpack_require__(246);
	var profile = __webpack_require__(178);
	
	module.exports = function(){
		// 二级菜单实例
		var menuInsArr = [];
		var menuArr = [];
		var container = document.querySelector(".em-widget-tip");
		container.innerHTML = "";
		utils.addClass(container, "new");
		if(!profile.grayList.poweredByEasemob && !utils.isMobile){
			if(!$("#em-kefu-webim-self").hasClass("hide")){
				$(".em-widget-send-wrapper").css("height", "140px !important");
				document.querySelector(".chat-wrapper").style.cssText='top:45px;bottom", "140px !important;left:10px;background: #fff;padding-right:10px;';
			}
			else{
				document.querySelector(".chat-wrapper").style.cssText='top:42px;background: #fff;';
			}
		}
		else{
			if(!utils.isMobile && !$("#em-kefu-webim-self").hasClass("hide")){
				document.querySelector(".chat-wrapper").style.cssText='top:40px;left:10px;background: #fff;padding-right:10px;bottom:170px';
			}
			else if(!utils.isMobile && $("#em-kefu-webim-self").hasClass("hide")){
				document.querySelector(".chat-wrapper").style.cssText='top:42px;background: #fff;bottom:170px'
			}
			else if(utils.isMobile){
				document.querySelector(".chat-wrapper").style.cssText='top:32px;'
			}
		}
	
		apiHelper.getNotice()
		.then(function(notice){
			if(!notice.enabled) return;
			menuArr = notice.content;
			container.innerHTML = _.template(tpl)({
				menu: menuArr
			});
			createMenu();
			utils.live(".tip-btn", "click", onMenuClick, container);
		});
	
		// 菜单点击
		function onMenuClick(e){
			var menuId;
			var menuDat;
			var target = e.srcElement || e.target;
			var targetBounding;
			if(utils.hasClass(target.parentNode, "tip-btn")){
				target = target.parentNode;
			}
			menuId = target.getAttribute("menuId");
			menuDat = menuArr[menuId];
	
			targetBounding = target.getBoundingClientRect();
			handleMenuClick(menuDat, menuId, {
				top: targetBounding.top + 48,
				left: targetBounding.left + (target.clientWidth * 0.1),
				width: target.clientWidth * 0.8,
			});
			// ie8
			// 使得 popupList 可以自动关闭
			utils.stopPropagation();
			return false;
		}
	
		function handleMenuClick(menuDat, menuId, pos){
			// 有子菜单
			if(menuDat.sub_button){
				popupList(menuId, pos || {
					left: 0,
					top: 0,
					width: 0,
				});
			}
			// 无子菜单
			else{
				hideAllSubMenu();
				fireMsg(menuDat);
			}
		}
	
		function fireMsg(dat){
			switch(dat.type){
			// 发送 article
			case "media_id":
				fireArticle(dat);
				break;
			// 发送 url
			case "view":
				fireUrl(dat);
				break;
			// 发送 text
			case "txt":
				fireText(dat);
				break;
			default:
				break;
			}
		}
	
		function fireArticle(menuDat){
			apiHelper.getArticleJson({
				media_id: menuDat.media_id
			}).then(function(articles){
				//yu 点名字，所调接口返回为空 ，就直接阻断流程
				if(!articles){
					return
				}
				articles = _.map(articles, function(article){
					return {
						title: article.title,
						digest: article.digest,
						description: article.digest,
						url:article.url,
						// url: "/v1/webimplugin/tenants/" + article.tenantId + "/robot/article/html/" + article.articleId,
						// url: "/v1/Tenants/" + article.tenantId + "/robot/article/html/" + article.articleId,
						thumbUrl: "/v1/Tenant/" + article.tenantId + "/MediaFiles/" + article.thumb_media_id,
						picurl: "/v1/Tenant/" + article.tenantId + "/MediaFiles/" + article.thumb_media_id,
						prop: article.prop,
						sendCustomer: menuDat.send_by_customer
					};
				});
				// 根据send_by_customer值判断是否在客服上上屏
				// send_by_customer 为true 客服模式下的会话 不上屏，只在当前demo中上屏
				if(menuDat.send_by_customer){
					channel.handleMessage(
						{
							ext: {
								msgtype: {
									articles: articles,
								}
							},
						},
						{
							type: "article",
							noPrompt: true
						}
					);
				}
				else{
					channel.sendText("", {
						ext: {
							msgtype: {
								articles: articles,
							}
						},
					});
				}
			});
		}
	
		function fireText(menuDat){
	
		}
	
		function fireUrl(menuDat){
	
		}
	
		// 每个 btn 创建一个菜单
		function createMenu(){
			_.each(menuArr, function(menuDat, menuId){
				menuInsArr[menuId] = new PopupList({
					items: menuDat.sub_button,
					reportClick: handleMenuClick,
				});
			});
		}
	
		// 弹出菜单
		function popupList(menuId, pos){
			hideAllSubMenu();
			menuInsArr[menuId].show(pos);
		}
	
		function hideAllSubMenu(){
			_.each(menuInsArr, function(menuIns){
				menuIns.hide();
			});
		}
	
		return {
			show: function(){
				container.style.display = "block";
			},
			hide: function(){
				container.style.display = "none";
			}
		};
	};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var tpl = __webpack_require__(245);
	
	module.exports = function(opt){
		var items = opt.items;
		var reportClick = opt.reportClick || utils.noop;
	
		var dom = utils.createElementFromHTML(_.template(tpl)({
			items: items
		}));
		document.body.appendChild(dom);
		utils.on(window, "resize", function(){
			hide();
		});
		utils.on(document, "click", function(e){
			var target = e.srcElement || e.target;
			if(!dom.contains(target)){
				hide();
			}
		});
	
		// 菜单点击
		utils.live("li", "click", function(e){
			var menuId;
			var target = e.srcElement || e.target;
			if(utils.hasClass(target.parentNode, "popup-item")){
				target = target.parentNode;
			}
			menuId = target.getAttribute("menuId");
			// 上报点击项
			reportClick(items[menuId], menuId);
			hide();
		}, dom);
	
		function show(pos){
			utils.removeClass(dom, "hide");
			dom.style.left = pos.left + "px";
			dom.style.top = pos.top + "px";
			pos.width && (dom.style.width = pos.width + "px");
		}
	
		function hide(){
			utils.addClass(dom, "hide");
		}
	
		return {
			show: show,
			hide: hide,
		};
	};


/***/ }),
/* 245 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"em-info-popup-tip hide\"> <% _.each(items, function(itm, menuId){ %> <li class=popup-item menuid=\"<%= menuId %>\"> <a><%= itm.name %></a> </li> <% }) %> </ul> ";

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	module.exports = "<% _.each(menu, function(itm, menuId){ %> <div class=tip-btn menuid=\"<%= menuId %>\"> <i class=\"<%= 'icon-' + itm.icon %>\"></i> <span><%= itm.name %></span> </div> <% }) %> ";

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	module.exports = "<div id=em-article-container> <div class=\"em-article-body ios-scroll\"> <div id=em-article-close> <span class=\"icon-back back-chat\">返回会话窗</span> <span class=\"icon-back new-message hide\">未读消息<span class=news></span></span> </div> </div> </div> <div id=em-widgetPopBar class=hide> <a class=\"em-widget-pop-bar bg-color icon-easemob\" href=javascript:;><%=contact_agent%></a> </div> <div class=\"em-widget-box hide\"> <div class=\"em-model chat-pop-em-model hide\"> <div class=chat-pop> <i class=\"icon-close tip-close\"></i> <iframe id=chat-pop src=\"\" frameborder=0></iframe> </div> </div> <div class=\"mobile-model hide\"> <div class=model-container> <p class=mobile-model-content></p> <span allow><%=allow%></span> <span refuse><%=refuse%></span> </div> </div> <div class=\"em-widget-header bg-color border-color\"> <p class=\"em-service-title hide\"><%=self_service%></p> <p class=drag-bar unselectable=on onselectstart=return!1 style=-moz-user-select:none></p> <div class=status-bar> <span class=\"session-list-btn icon-list hide\"> <span class=\"icon-circle notice hide\"></span> </span> <img src=/webim/static/img/default_avatar.png alt=\"\" class=\"em-agent-face hide\"> <span class=em-widget-header-nickname></span> <span class=em-header-status-text></span> <span class=\"em-agent-input-state hide\"><%=agent_is_typing%></span> </div> <i title=\"<%=close%>\" class=\"icon-mobile-close btn-close border-color hide\"></i> <i title=\"<%=min_window%>\" class=\"icon-min btn-min border-color hide\"></i> <i title=\"<%=close_sound%>\" class=\"icon-bell btn-audio hide\"></i> <i class=\"btn-keyboard icon-keyboard-up hide\"></i> </div> <div class=em-widget-content-box> <div id=em-kefu-webim-chat class=\"em-widget-wrapper hide\"> <span class=\"expand hide\"> <img src=/webim/static/img/rightOpen.png alt=\"\"> </span> <div class=em-widget-risk-warning> <div> <div class=contentDom> <i class=icon-radio></i> <span class=content><%=risk_alert%> </span> <i class=\"icon-close btn-audio\"></i> </div> </div> </div> <div class=em-widget-tip> <div class=\"\"> <div class=contentDom> <i class=icon-radio></i> <span class=content></span> <i class=\"icon-close-new tip-close\"></i> </div> </div> </div> <div class=chat-wrapper> <div class=\"em-widget-tenant-logo hide\"> <div class=\"swiper-container mySwiper\"> <div class=swiper-wrapper> </div> <div class=swiper-pagination></div> </div> </div> </div> <div class=em-widget-send-wrapper> <div class=\"em-widget-send-wrapper-top hide\"> <div class=\"swiper-button-prev height-btn swiper-button-black\"></div> <div class=swiper-container> <div class=swiper-wrapper> <div class=\"swiper-slide em-widget-out-of-line hide\"><%=out_of_line%> </div> <div class=\"swiper-slide em-widget-exit-video hide\"><%=exit_video%></div> </div> </div> <div class=\"swiper-button-next height-btn swiper-button-black\"></div> </div> <div class=\"queuing-number-status hide\"><%=current_queue_number%><label></label></div> <div class=\"toolbar toolbar-pc\"> <i class=\"em-bar-emoji icon-face e-face fg-hover-color\" title=\"<%=emoji%>\"></i> <i class=\"em-widget-img icon-picture fg-hover-color hide\" title=\"<%=picture%>\"></i> <i class=\"em-widget-file icon-attachment fg-hover-color hide\" title=\"<%=attachment%>\"></i> <i class=\"em-widget-video icon-sendvideo fg-hover-color hide\" title=\"<%=send_video%>\"></i> <i class=\"em-widget-note icon-note fg-hover-color hide\" title=\"<%=ticket%>\"></i> <i class=\"icon-video fg-hover-color em-video-invite hide\" title=\"<%=video_invite%>\"></i> <i class=\"icon-flower fg-hover-color em-widget-satisfaction hide\" title=\"<%=evaluate_agent%>\"></i> <i class=\"fg-hover-color em-widget-satisfaction screenshot icon-screenshot\" title=\"<%=screenShot%>\"></i> </div> <input type=file class=upload-file-container> <input type=file class=upload-img-container accept=image/jpg,image/gif,image/jpeg,image/png> <input type=file class=upload-video-container accept=video/*> <div class=input-box> <span class=\"fg-color em-widget-to-kefu hide\"> <i class=icon-transform></i> <span><%=transfer_to_kefu%></span> </span> <span class=\"fg-color em-widget-to-ticket hide\"> <span><%=transfer_to_ticket%></span> </span> <span class=\"fg-color em-widget-abandon-queue hide\"> <span><%=abandon_queue%></span> </span> <textarea class=em-widget-textarea spellcheck=false placeholder=\"<%=input_placeholder%>\"></textarea> <span class=\"em-widget-send disabled\"><%=connecting%></span> <i class=\"em-bar-emoji icon-face-new e-face fg-hover-color hide\" title=\"<%=emoji%>\"></i> <span class=\"em-widget-add hide\"><i class=icon-add></i></span> </div> <div class=\"toolbar toolbar-mobile hide\"> <div class=swiper-wrapper> <div class=swiper-slide> <div class=\"em-widget-img hide\"> <div class=btn-container><i class=icon-picture-new title=\"<%=picture%>\"></i></div> <span><%=picture%></span> </div> <div class=\"em-widget-file hide\"> <div class=btn-container><i class=icon-attachment-new title=\"<%=attachment%>\"></i></div> <span><%=attachment%></span> </div> <div class=\"em-widget-video hide\"> <div class=btn-container><i class=icon-sendvideo-new title=\"<%=send_video%>\"></i></div> <span><%=send_video%></span> </div> <div class=\"em-widget-note hide\"> <div class=btn-container><i class=icon-note-new title=\"<%=ticket%>\"></i></div> <span><%=ticket%></span> </div> <div class=\"em-video-invite hide\"> <div class=btn-container><i class=icon-video-new title=\"<%=video_invite%>\"></i></div> <span><%=video_invite%></span> </div> <div class=\"em-widget-satisfaction hide\"> <div class=btn-container><i class=icon-flower-new title=\"<%=evaluate_agent%>\"></i></div> <span><%=evaluate_agent%></span> </div> </div> </div> <div class=swiper-pagination slot=pagination></div> </div> </div> <div class=\"em-widget-error-prompt hide\"> <span></span> </div> <div class=\"img-view hide\"> <img> <span class=\"ios-load hide\"><span><%=press_save_img%></span></span> <a class=\"android-load hide icon-download\" download></a> </div> <div class=\"em-kefu-webim-note hide\"> <div class=note-top> <i class=icon-close></i> </div> </div> <div class=\"small-video-box hide\"> <i class=\"small-video icon-camera-small hide\"></i> <span><%=video_connecting%></span> </div> </div> <div id=em-kefu-webim-self class=\"em-self-wrapper hide\"> </div> </div> </div> <div class=\"em-kefu-webim-note-mobile hide\"> <div class=note-top> <i class=icon-close></i> </div> </div> <div class=\"auth-box-PC hide\"> <div> <img src=/webim/static/img/u1447.png alt=\"\"> <span></span> </div> </div> <div class=\"auth-box-H5 hide\"> <div> <img src=/webim/static/img/u1447.png alt=\"\"> <div> <span class=is-auth></span> <span><%=unavailable%></span> </div> </div> </div> <div class=\"em-video-container hide\"> <span class=video-container-close><i class=icon-close></i></span> <div class=full-video-box></div> </div> ";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(5).polyfill();
	__webpack_require__(8);
	__webpack_require__(9);
	__webpack_require__(11);
	__webpack_require__(13);
	window._ = __webpack_require__(13);
	
	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	
	var uikit = __webpack_require__(180);
	var apiHelper = __webpack_require__(181);
	var eventCollector = __webpack_require__(249);
	var chat = __webpack_require__(135);
	var channel = __webpack_require__(186);
	var profile = __webpack_require__(178);
	var commonConfig = __webpack_require__(177);
	var getToHost = __webpack_require__(190);
	var hasChatEntryInitialized;
	var extendMessageSender = __webpack_require__(242);
	
	var setConfig;
	
	module.exports = {
		init: init,
		initChat: initChat,
		chat_window_mode_init: chat_window_mode_init,
		initRelevanceError: initRelevanceError,
		show: show,
		close: close,
	};
	
	function show(){
		utils.removeClass(document.querySelector(".em-widget-wrapper"), "hide");
	}
	
	function close(){
		utils.addClass(document.querySelector(".em-widget-wrapper"), "hide");
	}
	
	function init(obj){
		setConfig = obj;
		utils.on(window, "message", function(e){
			updateCustomerInfo(e);
		});
	}
	
	function updateCustomerInfo(e){
		var trackMsg;
		var temp;
		var data = e.data;
		if(typeof data === "string" && data != "undefined"){
			try{
				data = JSON.parse(data);
			}
			catch(err){
				
			}
		}
		temp = utils.getDataByPath(data, "easemob.kefu.cta");
		if(temp){
			trackMsg = {
				ext: {
					msgtype: {
						track: {
							// 消息标题
							title: "从\"" + temp.title + "\"提交的手机号码：",
							// 商品描述
							desc: temp.phone,
							// 商品图片链接
							// img_url: "/images/robot/article_image.png",
							// 商品页面链接
							item_url: temp.item_url
						}
					}
				}
			};
			apiHelper.updateCustomerInfo({
				phone: temp.phone
			});
			channel.sendText("转人工客服", trackMsg);
		}
	}
	
	function initChat(){
		handleMsgData();
		utils.removeClass(document.querySelector(".em-widget-wrapper"), "hide");
		apiHelper.getGrayList(commonConfig.getConfig().tenantId).then(function(grayList){
			// 灰度列表
			profile.grayList = grayList;
	
			// 访客回呼功能
			// CLOUD-15395 在config中配置eventCollector:true, 在手机端浏览器会自动打开聊天窗口
			// !utils.isMobile && commonConfig.getConfig().eventCollector && !eventCollector.isStarted()
			if(commonConfig.getConfig().eventCollector && !eventCollector.isStarted()){
				eventCollector.startToReport(function(targetUserInfo){
					initChatEntry(targetUserInfo);
				});
			}
			else{
				// 获取关联，创建访客，调用聊天窗口
				initChatEntry();
			}
		});
	}
	
	function handleMsgData(){
		if(_.isArray(commonConfig.getConfig().extMsg)){
			_.each(commonConfig.getConfig().extMsg, function(elem){
				extendMessageSender.push(elem);
			});
		}
		else if(_.isObject(commonConfig.getConfig().extMsg)){
			extendMessageSender.push(commonConfig.getConfig().extMsg);
		}
	}
	
	function chat_window_mode_init(){
		var $contactAgentBtn = document.getElementById("em-widgetPopBar");
		getToHost.listen(function(msg){
			var event = msg.event;
			var data = msg.data;
			var extendMessage;
	
			switch(event){
			case _const.EVENTS.SHOW:
				// 在访客点击联系客服后停止上报访客
				if(eventCollector.isStarted()){
					eventCollector.stopReporting();
					initChatEntry();
				}
	
				// 访客端有进行中会话，停止了轮询，此时需要走一遍之前被跳过的初始化流程
				if(eventCollector.hasProcessingSession()){
					initChatEntry();
				}
	
				if(eventCollector.hasCtaInvite()){
					initChatEntry();
					eventCollector.hideCtaPrompt();
				}
	
				// 显示聊天窗口
				chat.show();
				break;
			case _const.EVENTS.CLOSE:
				chat.close();
				break;
			case _const.EVENTS.EXT:
				extendMessage = data.ext;
				extendMessageSender.push(extendMessage.ext);
				break;
			case _const.EVENTS.TEXTMSG:
				channel.sendText(data);
				break;
			case _const.EVENTS.UPDATE_URL:
				profile.currentBrowsingURL = data;
				break;
			case _const.EVENTS.HIDE_DEFAULT_BTN:
				utils.addClass($contactAgentBtn, "hide");
				profile.isHideBtn = true;
				break;
			default:
				break;
			}
		}, ["down2Im"]);
	
		utils.removeClass($contactAgentBtn, "hide");
		utils.on($contactAgentBtn, "click", function(){
			getToHost.send({ event: _const.EVENTS.SHOW });
		});
	}
	
	function initRelevanceError(err){
		if(err.statusCode === 503){
			uikit.createDialog({
				contentDom: utils.createElementFromHTML([
					"<div class=\"wrapper\">",
					"<span class=\"icon-waiting\"></span>",
					"<p class=\"tip-word\">" +  "All agents are busy now. Please try again later…" + "</p>",
					"</div>"
				].join("")),
				className: "session-over-limit"
			}).show();
		}
		else{
		// chat.show()针对移动端，在pc端不是必要的逻辑
			chat.show();
			uikit.prompt(err);
			throw err;
		}
	}
	
	function initChatEntry(targetUserInfo){
		if(hasChatEntryInitialized){
			return;
		}
		hasChatEntryInitialized = true;
		setConfig(targetUserInfo)
		.then(function(type){
			// config ready
			apiHelper.update(commonConfig.getConfig());
			switch(type){
			case "user":
				userEntry(targetUserInfo);
				break;
	
			case "userWithToken":
				userTokenEntry(targetUserInfo);
				break;
	
			case "userWithPassword":
				userWithPasswordEntry(targetUserInfo);
				break;
	
			case "userWithNameAndToken":
				userNameAndTokenEntry();
				break;
	
			case "userWidthNameAndPassword":
				_initLanguage(commonConfig.getConfig().user);
				profile.imPassword = commonConfig.getConfig().user.password;
				chat.init();
				break;
	
			case "wechatAuth":
			case "widthPassword":
				_initLanguage(commonConfig.getConfig().user);
				chat.init();
				break;
	
			case "autoCreateAppointedVisitor":
			case "noWechatAuth":
			case "noAutoCreateAppointedVisitor":
			default:
				_createVisitor();
				break;
			}
		});
	
	}
	
	function userEntry(targetUserInfo){
		chat.init();
		chat.show();
		getToHost.send({
			event: _const.EVENTS.SHOW
		});
		getToHost.send({
			event: _const.EVENTS.CACHEUSER,
			data: {
				username: targetUserInfo.userName,
				// todo: check if need emgroup
				group: commonConfig.getConfig().user.emgroup
			}
		});
		// 发送指定坐席的ext消息，延迟发送
		extendMessageSender.push({
			weichat: {
				agentUsername: targetUserInfo.agentUserName
			}
		});
	}
	
	function userTokenEntry(targetUserInfo){
		// 发送空的ext消息，延迟发送
		profile.commandMessageToBeSendList.push({
			ext: {
				weichat: {
					agentUsername: targetUserInfo.agentUserName
				}
			}
		});
		chat.init();
		chat.show();
		getToHost.send({
			event: _const.EVENTS.SHOW
		});
		// 发送指定坐席的ext消息，延迟发送
		extendMessageSender.push({
			weichat: {
				agentUsername: targetUserInfo.agentUserName
			}
		});
	}
	
	function userWithPasswordEntry(targetUserInfo){
		chat.init();
		chat.show();
		getToHost.send({
			event: _const.EVENTS.SHOW
		});
		// 发送指定坐席的ext消息，延迟发送
		extendMessageSender.push({
			weichat: {
				agentUsername: targetUserInfo.agentUserName
			}
		});
	}
	
	function userNameAndTokenEntry(){
		// todo: move imToken to an independent key
		profile.imToken = commonConfig.getConfig().user.token;
		_initLanguage(commonConfig.getConfig().user);
		chat.init();
	}
	
	
	
	
	function _createVisitor(){
		_initLanguage(commonConfig.getConfig().user);
		var cacheKeyName = (commonConfig.getConfig().configId || (commonConfig.getConfig().to + commonConfig.getConfig().tenantId + commonConfig.getConfig().emgroup));
	
		if(commonConfig.getConfig().user.password === ""){
			profile.imRestDown = true;
		}
		if(utils.isTop){
			utils.set("root" + (commonConfig.getConfig().configId || (commonConfig.getConfig().tenantId + commonConfig.getConfig().emgroup)), commonConfig.getConfig().user.username);
			// utils.set(commonConfig.getConfig().user.username, commonConfig.getConfig().user.userNickname);
		}
		else{
			getToHost.send({
				event: _const.EVENTS.CACHEUSER,
				data: {
					key: cacheKeyName,
					value: commonConfig.getConfig().user.username,
				}
			});
		}
		chat.init();
	}
	function _initLanguage(user){
		apiHelper.initLanguage(commonConfig.getConfig().initLanguage,user.username);
	}


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var _const = __webpack_require__(176);
	var api = __webpack_require__(181);
	var apiHelper = __webpack_require__(182);
	var profile = __webpack_require__(178);
	var Poller = __webpack_require__(250);
	var createCtaDialog = __webpack_require__(233);
	var commonConfig = __webpack_require__(177);
	var getToHost = __webpack_require__(190);
	
	var POLLING_INTERVAL = 5000;
	
	var _polling;
	var _callback;
	var _config;
	var _gid;
	var _hasProcessingSession;
	var _hasCtaInvite;
	var _ctaPrompt;
	
	function _reportData(userType, userId){
		var url = profile.currentBrowsingURL;
	
		getToHost.send({ event: _const.EVENTS.REQUIRE_URL });
	
		url && apiHelper.reportEvent(url, userType, userId).then(function(resp){
			var type = resp.type;
			var username = resp.userName;
			var orgName = resp.orgName;
			var appName = resp.appName;
			// cta invite extended field
			var message = resp.message;
			var agentNickname = resp.agentNickname;
			var agentAvatar = resp.agentAvatar || profile.defaultAvatar;
	
			_hasCtaInvite = !!message;
	
			switch(type){
				// 没有坐席呼叫，什么都不做
			case "OK":
				break;
				// 有坐席呼叫
			case "INIT_CALL":
				if(_isStarted()){
					// 回呼游客，游客身份变为访客
					if(username){
						_gid = orgName + "#" + appName + "_" + username;
						_polling.stop();
						_polling = new Poller(function(){
							_reportData("VISITOR", _gid);
						}, POLLING_INTERVAL);
					}
					_stopReporting();
	
					if(_hasCtaInvite){
						getToHost.send({ event: _const.EVENTS.ADD_PROMPT });
						_ctaPrompt = createCtaDialog({
							title: agentNickname,
							content: message,
							avatar: agentAvatar,
							className: "cta-prompt bottom",
							replyCallback: function(){
								_callback(resp);
								getToHost.send({ event: _const.EVENTS.REMOVE_PROMPT });
							},
							closeCallback: function(){
								getToHost.send({ event: _const.EVENTS.REMOVE_PROMPT });
							}
						});
					}
					else{
						// 旧的访客回呼还是直接弹出
						_callback(resp);
					}
				}
				// 已停止轮询 （被呼叫的访客/游客 已经创建会话），不回呼
				else{}
				break;
			default:
				throw "unexpected event type.";
			}
		});
	}
	
	function _startToReoprt(callback){
		_callback || (_callback = callback);
		_config || (_config = commonConfig.getConfig());
	
		// h5 方式屏蔽访客回呼功能
		if(utils.isTop) return;
	
		// 要求外部页面更新URL
		getToHost.send({ event: _const.EVENTS.REQUIRE_URL });
	
		// 用户点击联系客服弹出的窗口，结束会话后调用的startToReport没有传入参数
		if(!_config){
			console.error("not config yet.");
		}
		else if(_polling){
			_polling.start();
		}
		else if(_config.user.username){
			_reportVisitor(_config.user.username);
		}
		else{
			_reportGuest();
		}
	}
	
	function _reportGuest(){
		var guestId = _config.guestId || utils.uuid();
	
		// 缓存guestId
		getToHost.send({
			event: _const.EVENTS.SET_ITEM,
			data: {
				key: "guestId",
				value: guestId
			}
		});
	
		_polling = new Poller(function(){
			_reportData("GUEST", guestId);
		}, POLLING_INTERVAL);
	
		_polling.start();
	}
	
	function _reportVisitor(username){
		// 获取关联信息
		apiHelper.getRelevanceList().then(function(relevanceList){
			var targetItem = relevanceList[0];
			var splited = _config.appKey.split("#");
	
			_config.orgName = splited[0] || targetItem.orgName;
			_config.appName = splited[1] || targetItem.appName;
			_config.toUser = _config.to || targetItem.imServiceNumber;
			_config.restServer = _config.restServer || targetItem.restDomain;
	
			// todo: use xmpp server from relevanceList
			var cluster = _config.restServer ? _config.restServer.match(/vip\d/) : "";
			cluster = cluster && cluster.length ? "-" + cluster[0] : "";
			_config.xmppServer = _config.xmppServer || "im-api" + cluster + ".easemob.com";
	
			_gid = _config.orgName + "#" + _config.appName + "_" + username;
	
			_polling = new Poller(function(){
				_reportData("VISITOR", _gid);
			}, POLLING_INTERVAL);
	
			// 获取当前会话信息
			apiHelper.getCurrentServiceSession().then(function(response){
				_hasProcessingSession = !!response;
				// 没有会话数据，则开始轮询
				!_hasProcessingSession && _polling.start();
			});
		}, function(err){
			throw err;
		});
	}
	
	function _stopReporting(){
		_polling && _polling.stop();
		_gid && api.deleteEvent(_gid);
	}
	
	function _isStarted(){
		return _polling && _polling.isStarted;
	}
	
	module.exports = {
		startToReport: _startToReoprt,
		stopReporting: _stopReporting,
		hasProcessingSession: function(){
			return _hasProcessingSession;
		},
		hasCtaInvite: function(){
			return _hasCtaInvite;
		},
		hideCtaPrompt: function _hideCtaPrompt(){
			_ctaPrompt && _ctaPrompt.hide();
			getToHost.send({ event: _const.EVENTS.REMOVE_PROMPT });
		},
		isStarted: _isStarted
	};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

	var Poller = function(fn, interval){
		this.fn = fn;
		this.isStarted = false;
		this.timerHandler = null;
		this.interval = interval;
	};
	
	Poller.prototype.start = function(){
		if(!this.isStarted){
			this.isStarted = true;
			setTimeout(this.fn, 0);
			this.timerHandler = setInterval(this.fn, this.interval);
		}
	};
	
	Poller.prototype.stop = function(){
		if(this.isStarted){
			this.isStarted = false;
			clearInterval(this.timerHandler);
		}
	};
	
	Poller.prototype.isStarted = function(){
		return this.isStarted;
	};
	
	module.exports = Poller;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var SelfService = __webpack_require__(252);
	var Faq = __webpack_require__(255);
	var FaqIframe = __webpack_require__(258);
	var ContactBtn = __webpack_require__(259);
	
	var utils = __webpack_require__(16);
	var apis = __webpack_require__(238);
	var commonConfig = __webpack_require__(177);
	
	function init(obj){
		var faq;
		var selfService;
		var iframe;
	
		var resultStatus = obj.resultStatus;
	  var options = commonConfig.getConfig().options
		apis.update(commonConfig.getConfig());
	
		// 外部已经处理了是否显示
		if(resultStatus[0]){
			faq = new Faq(options["item-click-action"]);
		}
		if(resultStatus[1]){
			selfService = new SelfService();
		}
		// enable
		if(resultStatus[2]){
			// settings
			iframe = new FaqIframe(resultStatus[3][0]);
			var iframeList = [];
				for(var i=0;i<resultStatus[3].length;i++){
					iframeList.push(new FaqIframe(resultStatus[3][i]))
				}
		}
		show();
	
		return {
			faq: faq,
			ss: selfService,
			iframe: iframe,
			contact: new ContactBtn(),
			iframeList:iframeList
		};
	}
	
	function show(){
		var domSelfWrapper = document.querySelector(".em-self-wrapper");
		utils.removeClass(domSelfWrapper, "hide");
		// document.querySelector(".em-kefu-webim-chat").style.cssText='left:10px;';
		if(!utils.isMobile){
			document.querySelector(".chat-wrapper").style.cssText='top:10px;left:10px;background: #fff;padding-right:10px;';
			document.querySelector(".em-self-wrapper").style.cssText='top:10px;right:10px;background: #F0F0F0;padding-bottom:10px;';
			document.querySelector(".em-widget-content-box").style.cssText='padding-bottom: 10px;';
			document.querySelector(".em-widget-send-wrapper").style.cssText='left:10px;padding-right:10px;';
			document.querySelector(".em-widget-tip").style.cssText='left:10px;top:10px;width:calc(100% - 10px)';
		}
	}
	
	module.exports = {
		init: init,
		show: show,
	};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var apis = __webpack_require__(238);
	var _const = __webpack_require__(176);
	var container_tpl = __webpack_require__(253);
	var item_tpl = __webpack_require__(254);
	var SELFSERVICE_PATH = _const.SELFSERVICE_PATH;
	
	module.exports = function(){
		var container = $(_.template(container_tpl)());
	
		apis.getSelfServiceList()
		.then(function(data){
			_.each(data, function(item){
				if(item.iconType == "system"){
					item.icon = SELFSERVICE_PATH + item.icon;
				}
			});
			container.removeClass("hide");
	
			console.log(data)
			container.append(_.template(item_tpl)({
				selfService: data
			}));
			$(".right_service_href_cls").on("click", function(e){
				console.log($(this).attr("id"))
				var id = $(this).attr("id");
				apis.recordFaqClick(id,"self-service");
			})
		});
	
		// APIs
		this.$el = container;
		this.show = function(){
			
		};
	};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"self-service-list hide\"> </div> ";

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = "<% _.each(selfService, function(itm, idx){ %> <a href=\"<%= itm.link %>\" target=_blank class=right_service_href_cls id=\"<%= itm.id %>\"> <img src=\"<%= itm.icon %>\"/> <span><%= itm.name %></span> </a> <%if(idx == 3){%> <br/> <%}%> <% }) %> ";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var apis = __webpack_require__(238);
	var utils = __webpack_require__(16);
	var container_tpl = __webpack_require__(256);
	var item_tpl = __webpack_require__(257);
	var channel = __webpack_require__(186);
	var _const = __webpack_require__(176);
	var eventListener = __webpack_require__(185);
	var enableFaqClickToSend = false;
	
	module.exports = function(clickAction){
		var container = $(_.template(container_tpl)({
			faq: "FAQs",
		}));
	
	  enableFaqClickToSend = clickAction === "1";
	
		apis.getFaqList()
		.then(function(data){
			_.each(data, function(itm){
				itm.content = utils.encode(itm.content);
				itm.content = utils.parseUrl(itm.content);
			});
	
			container.removeClass("hide");
			container.find(".faq-list-content").append(_.template(item_tpl)({
				faq: data,
			}));
			container.delegate(".question", "click", onMenuClick);
			container.delegate(".question>i", "click", function(e){
				e.target.parentNode.click();
			});
	
	    if(enableFaqClickToSend){ // 设置为单击发送则修改列表项的展开箭头为书本图标，并添加悬浮背景颜色
	      container.addClass("click-list-icon");
	      container.find(".question").addClass("fg-hover-color");
	    }
		});
	
		// 菜单点击
		function onMenuClick(e){
			var issueId = e.target.getAttribute("data-id");
			issueId && apis.recordFaqClick(issueId,"issues");	// 统计
	    if(enableFaqClickToSend){ // 点击直接发送
	      var title = e.target.innerText.trim();
	      if(title){
	        if(utils.isMobile){
	          eventListener.trigger(_const.SYSTEM_EVENT.CONSULT_AGENT);
	          window._sendFaqMessage = function() {
	            channel.sendText(title);
	          }
	        }else{
	          channel.sendText(title);
	        }
	      }
	    }
	    else{
	      utils.toggleClass(e.target.parentNode, "hide-answer");
	    }
			utils.stopPropagation();
			return false;
		}
	
		// APIs
		this.$el = container;
		this.show = function(){
		};
	};


/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"faq-list hide\"> <p> <%= faq %> </p> <div class=faq-list-content></div> </div> ";

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	module.exports = "<% _.each(faq, function(itm, idx){ %> <div class=\"faq-item hide-answer\"> <p class=question data-id=\"<%= itm.id %>\"> <i class=icon-arrow-right></i> <%= itm.title %> </p> <p class=answer><%= itm.content %></p> </div> <% }) %> ";

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	module.exports = function(iframeSettings){
		var container = $("<div class=\"faq-iframe hide\"><iframe style=\"border:0;width:100%;height:100%;\"/></div>");
		container.removeClass("hide");
		var iframe = container.find("iframe");
		
		// APIs
		this.$el = container;
		this.show = function(){
			if(!iframe[0].src){
				iframe[0].src = iframeSettings.url;
			}
		};
	};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var btn_tpl = __webpack_require__(260);
	var _const = __webpack_require__(176);
	var eventListener = __webpack_require__(185);
	
	module.exports = function(){
		var container = $(_.template(btn_tpl)({
			consult_agent: "Consult agent"
		}));
		container.removeClass("hide");
		container.on("click", function(e){
			eventListener.trigger(_const.SYSTEM_EVENT.CONSULT_AGENT);
			e.stopPropagation();
			return false;
		});
	
		// APIs
		this.$el = container;
		this.show = function(){
		};
	};


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"contact-customer-service bg-color hide\"> <%= consult_agent %> </div> ";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	
	// 微信授权登录步骤
	// 1. get Wechat Component Id (code does not exist)
	// 2. redirectTo open.weixin.qq.com
	// 3. callback with code
	// 4. get Wechat Profile by code
	// 5. cache Wechat nickname
	// 6. create Wechat im user
	// 7. exec success callback
	
	var utils = __webpack_require__(16);
	var apiHelper = __webpack_require__(182);
	var commonConfig = __webpack_require__(177);
	
	var isWechatBrowser = /MicroMessenger/.test(navigator.userAgent);
	var appid = utils.query("appid");
	var code = utils.query("code");
	
	module.exports = function(success, fail){
		var config = commonConfig.getConfig();
		var tenantId = config.tenantId;
		if(!isWechatBrowser || !tenantId || !appid){
			fail();
			return;
		}
	
		if(!code){
			apiHelper.getWechatComponentId().then(function(id){
				location.href =  "https://open.weixin.qq.com/connect/oauth2/authorize?"
					+ "appid=" + appid
					+ "&redirect_uri=" + encodeURIComponent(location.href)
					+ "&response_type=code"
					+ "&scope=snsapi_userinfo"
					+ "&state=STATE"
					+ "&component_appid=" + id
					+ "#wechat_redirect"
				;
			}, function(err){
				console.warn(err);
				fail();
			});
		}
		else{
			apiHelper.getWechatProfile(tenantId, appid, code).then(function(info){
				// cache wechat nickname
				commonConfig.setConfig({
					visitor: _.extend({}, config.visitor, { userNickname: info.nickname })
				});
	
				apiHelper.createWechatImUser(info.openid).then(function(entity){
					success(entity);
				}, function(err){
					console.warn(err);
					fail();
				});
			}, function(err){
				var url;
	
				if(err.message === "unexpected response value."){
					fail();
				}
				else{
					// 此处重试次数不能限制，否则会导致手动刷新后失败
					url = location.href.replace(/&code=[^&]+/, "");
	
					if(url.indexOf("appid") !== url.lastIndexOf("appid")){
						url = url.replace(/&appid=wx[^&]+/, "");
					}
					location.href = url;
				}
			});
		}
	};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(16);
	var tpl = __webpack_require__(263);
	var eventListener = __webpack_require__(185);
	var commonConfig = __webpack_require__(177);
	var _const = __webpack_require__(176);
	
	function Tab(opt){
		opt = opt || {};
		this.inst = {};
		this.bodies = {};
		this.tabs = [];
		this.$el = $(_.template(tpl)());
		opt.className && this.$el.addClass(opt.className);
		this.$head = this.$el.find(".head");
	}
	Tab.prototype.addTab = function(tabInfo){
		if(!_.reduce(tabInfo.ins, function(result, cur){ return result && cur; }, true)){
			throw new Error("不允许空实例");
		};
		var liWidth;
		var $headItemTmp = $("<li title=\"" + tabInfo.text + "\"  sign=\"" + tabInfo.sign + "\"><span>" + tabInfo.text + "</span></li>");
		var $bodyItemTmp = $("<div class='hide' sign=" + tabInfo.sign + ">");
		// frame append
		this.$head.append($headItemTmp);
		this.$el.append($bodyItemTmp);
		// update
		this.tabs.push(tabInfo);
		this.bodies[tabInfo.sign] = $bodyItemTmp;
		this.inst[tabInfo.sign] = tabInfo.ins;		// arr
		this.$allContent = this.$el.find("> div");
		this.$allTab = this.$el.find("> ul > li");
		// 超过一个 tab 才显示头
		if(this.tabs.length >= 2){
			this.$el.removeClass("headless");
		}
		// 平均分配 li 的宽度
		// liWidth = (100 / (this.tabs.length)) + "%";
		// _.each(this.$allTab, function(tab){
		// 	tab.style = "width:" + liWidth;
		// });
		// [API] this.$el
		_.each(tabInfo.ins, function(ins){
			$bodyItemTmp.append(ins.$el);
		});
		// evt
		var me = this;
		utils.on($headItemTmp, "click", function(e){
			me.onTabClick(e);
		});
	};
	Tab.prototype.onTabClick = function(e){
		var $tab = $(e.currentTarget);
		if(!$tab.hasClass("selected")){
			this.selectTab($tab);
		}
	};
	Tab.prototype.clearSelected = function(){
		this.$allTab.removeClass("selected");
		this.$allTab.find("span").removeClass("border-color fg-color");
		if($(".theme_custom").length){
			this.$allTab.find("span").css("cssText","border-color:none; color:none");
		}
		this.$allContent.addClass("hide");
	};
	Tab.prototype.selectFirstTab = function(silent){
		var firstTab = this.tabs[0];
		if(firstTab){
			this.setSelect(firstTab.sign, silent);
			return true;
		}
		return false;
	};
	Tab.prototype.selectTab = function($tab, silent){
		var sign = $tab.attr("sign");
		if($(".theme_custom").length){
			var fgColor = $(".theme_custom .selected .border-color").css("color");
			this.fgColor = fgColor;
		}
		this.clearSelected();
		$tab.addClass("selected");
		$(".ui-cmp-tab>ul>li").removeClass("fg-color");
		$tab.addClass("fg-color");
		// $tab.find("li")["context"].addClass("border-color");
		var elActive = $tab.find("li")["context"];
		if(elActive){
			$(elActive).addClass("border-color");
		}
		$(".ui-cmp-tab>ul>li").css("cssText","color:#000 !important;" );
		if(this.fgColor){
			$tab.find("li").css("cssText","border-top-color: " + this.fgColor + " !important ; color: " + this.fgColor + " !important");
		}
		else{
			// 自定义主题色
			var color = "";
			var themeClassName;
			var config = commonConfig.getConfig();
			var themeName = config.ui.themeName;
			if(themeName && themeName.indexOf("theme_custom") > -1){
				var arr = themeName.split("theme_custom");
				color = arr[1];
				themeClassName = "theme_custom";
			}
			else{
				themeClassName = _const.themeMap[config.themeName];
			}
			$tab.css("cssText","border-top-color: " + color + " !important; fg-color: " + color + " !important; color:" + color+ " !important;" );
		}
		
		this.bodies[sign].removeClass("hide");
		// [API] this.show()
		_.each(this.inst[sign], function(ins){
			ins.show();
		});
		if(!silent){
			eventListener.trigger("ui.tab.click", sign);
		}
	};
	Tab.prototype.setSelect = function(sign, silent){
		var me = this;
		$.each(this.$allTab, function(k, v){
			var $v = $(v);
			if($v.attr("sign") == sign){
				me.selectTab($v, silent);
			}
		});
	};
	
	module.exports = Tab;


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"ui-cmp-tab headless\"> <ul class=head> </ul> <span class=\"ul-left hover icon-corner-left\"></span> <span class=\"ul-right hover icon-corner-right\"></span> </div> ";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "../css/im.css";

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	module.exports = "module.exports = __webpack_public_path__ + \"../../im.html\";";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js